webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(736),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BackendApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_axios_interceptors__ = __webpack_require__(379);



var BackendApi = {
  getClient: function getClient() {
    if (!localStorage.getItem('api_token')) {
      throw new Error('api_token not set in local storage');
    }

    var instance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
      baseURL: "https://api.inovadata-br.ufv.br/",
      headers: { 'Authorization': 'Bearer ' + localStorage.getItem('api_token') }
    });

    __WEBPACK_IMPORTED_MODULE_1__services_axios_interceptors__["a" /* default */].addGlobalRequestInterceptors(instance);
    __WEBPACK_IMPORTED_MODULE_1__services_axios_interceptors__["a" /* default */].addGlobalResponseInterceptors(instance);
    __WEBPACK_IMPORTED_MODULE_1__services_axios_interceptors__["a" /* default */].addUnauthorizedResponseInterceptor(instance);

    return instance;
  },
  getAnonymousClient: function getAnonymousClient() {
    var instance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
      baseURL: "https://api.inovadata-br.ufv.br/"
    });

    __WEBPACK_IMPORTED_MODULE_1__services_axios_interceptors__["a" /* default */].addGlobalRequestInterceptors(instance);
    __WEBPACK_IMPORTED_MODULE_1__services_axios_interceptors__["a" /* default */].addGlobalResponseInterceptors(instance);
    return instance;
  },
  get: function get(client, uri) {
    return client.get(uri).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  }
};

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(741),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(709),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_resource_client_user__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_resource_client_park__ = __webpack_require__(29);





var STORAGE_KEY_API_TOKEN = 'api_token';
var STORAGE_KEY_USER_ROLE = 'user_role';
var STORAGE_KEY_USER_ID = 'user_id';
var STORAGE_KEY_PARK_ID = 'park_id';
var STORAGE_KEY_PARK_CURRENT_STAGE = 'current_stage';
var USER_ROLE_RESEARCHER = 'ROLE_RESEARCHER';
var USER_ROLE_ADMIN = 'ROLE_ADMIN';
var USER_ROLE_PARK = 'ROLE_PARK';
var USER_ROLE_PARTNER = 'ROLE_PARTNER';

/* harmony default export */ __webpack_exports__["a"] = ({
  login: function login(email, password) {
    var _this = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      _this.getApiToken(email, password).then(function () {
        _this.getCurrentUser().then(function (currentUser) {
          if (_this.userHasParkRole()) {
            _this.logout();
            reject(new Error('ROLE_PARK'));
            return;
          }
          resolve(currentUser);
        }).catch(reject);
      }).catch(reject);
    });
  },
  getApiToken: function getApiToken(email, password) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api.inovadata-br.ufv.br/" + 'login_check', '_email=' + email + '&_password=' + password).then(function (r) {
      localStorage.setItem(STORAGE_KEY_API_TOKEN, r.data.token);
      return r;
    }).catch(function (e) {
      throw e;
    });
  },
  getCurrentUser: function getCurrentUser() {
    return __WEBPACK_IMPORTED_MODULE_2__services_resource_client_user__["a" /* default */].getCurrentUser().then(function (r) {
      localStorage.setItem(STORAGE_KEY_USER_ROLE, r.data.roles[0]);
      localStorage.setItem(STORAGE_KEY_USER_ID, r.data.id);
      return r;
    }).catch(function (e) {
      throw e;
    });
  },
  logout: function logout() {
    this.clearStorage();
  },
  clearStorage: function clearStorage() {
    localStorage.removeItem(STORAGE_KEY_API_TOKEN);
    localStorage.removeItem(STORAGE_KEY_USER_ROLE);
    localStorage.removeItem(STORAGE_KEY_USER_ID);
    localStorage.removeItem(STORAGE_KEY_PARK_ID);
    localStorage.removeItem(STORAGE_KEY_PARK_CURRENT_STAGE);
  },
  isAuthenticated: function isAuthenticated() {
    return typeof localStorage.getItem(STORAGE_KEY_API_TOKEN) !== 'undefined' && localStorage.getItem(STORAGE_KEY_API_TOKEN) !== null;
  },
  getUserRole: function getUserRole() {
    return localStorage.getItem(STORAGE_KEY_USER_ROLE);
  },
  userHasResearcherRole: function userHasResearcherRole() {
    return this.getUserRole() === USER_ROLE_RESEARCHER;
  },
  userHasAdminRole: function userHasAdminRole() {
    return this.getUserRole() === USER_ROLE_ADMIN;
  },
  userHasParkRole: function userHasParkRole() {
    return this.getUserRole() === USER_ROLE_PARK;
  },
  userHasPartnerRole: function userHasPartnerRole() {
    return this.getUserRole() === USER_ROLE_PARTNER;
  },
  getUserId: function getUserId() {
    return localStorage.getItem(STORAGE_KEY_USER_ID);
  },
  getParkData: function getParkData() {
    return __WEBPACK_IMPORTED_MODULE_3__services_resource_client_park__["a" /* default */].getParkByUserId(this.getUserId()).then(function (r) {
      localStorage.setItem(STORAGE_KEY_PARK_ID, r.data[0].id);
      localStorage.setItem(STORAGE_KEY_PARK_CURRENT_STAGE, r.data[0].currentStage);
      return r;
    }).catch(function (e) {
      throw e;
    });
  },
  getParkId: function getParkId() {
    return localStorage.getItem(STORAGE_KEY_PARK_ID);
  },
  getParkCurrentStage: function getParkCurrentStage() {
    return localStorage.getItem(STORAGE_KEY_PARK_CURRENT_STAGE);
  }
});

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({
  ACCELERATION: {
    questionUuid: '3003938c-5e9e-3b8a-933c-4c1378a31b60',
    itemRowUuid: 'f4a42f0f-f46c-32d4-b7d4-e80544347a46',
    fieldUuid: '44118a89-b996-3241-8acc-c4d76128b8e7'
  },
  ASSOCIATION: {
    questionUuid: '3003938c-5e9e-3b8a-933c-4c1378a31b60',
    itemRowUuid: '1f9f3f73-fa47-3e09-8d7a-da88911be704',
    fieldUuid: '07f4bab6-ec47-3586-9a84-7ada8186fe52'
  },
  COWORKING: {
    questionUuid: '3003938c-5e9e-3b8a-933c-4c1378a31b60',
    itemRowUuid: '7ad80f89-f83e-3fed-a1e5-a71e916068c4',
    fieldUuid: 'cd50a5cb-67cd-386c-936d-97d7b0f5591b'
  },
  INCUBATION: {
    questionUuid: '3003938c-5e9e-3b8a-933c-4c1378a31b60',
    itemRowUuid: '2ff7a790-6759-39ac-af63-fe486656dad0',
    fieldUuid: 'b99a8e52-edc4-327c-8259-d77c62c8e820'
  },
  PRE_INCUBATION: {
    questionUuid: '3003938c-5e9e-3b8a-933c-4c1378a31b60',
    itemRowUuid: '1a22abe6-13f8-3682-af80-560fd482403d',
    fieldUuid: '64806d0b-6411-38d3-a1a4-7a07a220f4ea'
  },
  RESIDENCY: {
    questionUuid: '3003938c-5e9e-3b8a-933c-4c1378a31b60',
    itemRowUuid: '0d5ce468-b51d-32e5-ad51-b6b5d6972a0e',
    fieldUuid: 'dee67a3a-ddcb-39d9-84bd-8af513e85ce7'
  },
  has: function has(program, quizAnswers) {
    var programsAnswer = quizAnswers.find(function (a) {
      return a.questionUuid === program.questionUuid;
    });
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(programsAnswer) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(programsAnswer.value)) {
      return false;
    }

    var programItemRowAnswer = programsAnswer.value.find(function (i) {
      return i.itemRowUuid === program.itemRowUuid;
    });
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(programItemRowAnswer) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(programItemRowAnswer.fieldsAnswers)) {
      return false;
    }

    var programFieldAnswer = programItemRowAnswer.fieldsAnswers.find(function (fa) {
      return fa.fieldUuid === program.fieldUuid;
    });
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(programFieldAnswer) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(programFieldAnswer.value)) {
      return false;
    }

    return programFieldAnswer.value.includes('Sim');
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_backend_api__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getAnonymousClient().get('parks/' + id).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  cget: function cget() {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getAnonymousClient().get('parks/').then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  post: function post(park) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().post('parks/', park).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  put: function put(park) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().put('parks/' + park.id, park).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  getParkByUserId: function getParkByUserId(userId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getAnonymousClient().get('parks/?userId=' + userId).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  withApprovedParkQuizPerYear: function withApprovedParkQuizPerYear() {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().get('parks/with-approved-park-quiz-per-year').then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  }
});

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(775),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  formatIsoDate: function formatIsoDate(date) {
    var dateTime = new Date(date);
    var dateString = dateTime.getDate() + '/';
    dateString += dateTime.getMonth() + 1 + '/';
    dateString += dateTime.getFullYear();

    return dateString;
  },
  formatAPIDate: function formatAPIDate(date) {
    var dateString = date.getFullYear() + '-';
    dateString += ('0' + (date.getMonth() + 1)).slice(-2) + '-';
    dateString += ('0' + date.getDate()).slice(-2);

    return dateString;
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite__);




function normalizeChartPayload(data) {
  if (data && Array.isArray(data.datasets)) {
    return {
      chartData: data.datasets,
      labels: data.labels || null,
      metadata: data.metadata || null
    };
  }
  return {
    chartData: data,
    labels: null,
    metadata: null
  };
}

function normalizeTextualPayload(data) {
  if (data && data.metadata && (data.columns || data.rows)) {
    return {
      report: {
        columns: data.columns,
        rows: data.rows
      },
      metadata: data.metadata
    };
  }
  return {
    report: data,
    metadata: data && data.metadata ? data.metadata : null
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  textual: function textual(data, title) {
    var normalized = normalizeTextualPayload(data);
    return {
      report: normalized.report,
      metadata: normalized.metadata,
      title: title
    };
  },
  chart: function chart(data, title) {
    var normalized = normalizeChartPayload(data);
    var labels = (normalized.labels || createChartLabels(normalized.chartData)).map(String);
    var formatted = {
      report: {
        labels: labels,
        datasets: createChartDatasets(normalized.chartData, labels)
      },
      metadata: normalized.metadata,
      options: buildChartOptions(title, normalized.metadata)
    };
    return formatted;
  },
  horizontalBarChart: function horizontalBarChart(data, title) {
    var chart = this.chart(data, title);

    chart.options.scales.yAxes = [{
      ticks: {
        autoSkip: false,
        callback: function callback(yLabel) {
          return truncate(yLabel, 40);
        }
      }
    }];

    chart.options.scales.xAxes = [{
      ticks: {
        callback: function callback(value) {
          var num = Number(value);
          if (!__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite___default()(num)) {
            return '';
          }
          return num.toLocaleString('pt-BR');
        }
      }
    }];

    chart.options.tooltips.callbacks.label = function (tooltipItems) {
      var num = Number(tooltipItems.xLabel);
      if (!__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite___default()(num)) {
        return 'Sem dado';
      }
      return num.toLocaleString('pt-BR');
    };

    return chart;
  },
  percentageHorizontalBarChart: function percentageHorizontalBarChart(data, title) {
    var chart = this.horizontalBarChart(data, title);

    chart.options.scales.xAxes[0].ticks.max = 100;
    chart.options.scales.xAxes[0].ticks.callback = function (value) {
      var num = Number(value);
      if (!__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite___default()(num)) {
        return '';
      }
      return num.toFixed(0) + '%';
    };

    chart.options.tooltips.callbacks.label = function (tooltipItems) {
      var num = Number(tooltipItems.xLabel);
      if (!__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite___default()(num)) {
        return 'Sem dado';
      }
      return num.toFixed(1).replace('.', ',') + '%';
    };

    chart.options.legend = { display: false };

    return chart;
  },
  doughnutChart: function doughnutChart(data, title) {
    var normalized = normalizeChartPayload(data);
    var labels = createChartLabels(normalized.chartData);
    var reportDatasets = createChartDatasets(normalized.chartData, labels);
    reportDatasets[0].borderColor = colors;
    reportDatasets[0].backgroundColor = colors;

    var chart = this.chart(data, title);
    chart.report.labels = labels;
    chart.report.datasets = reportDatasets;
    chart.options.scales = false;
    chart.options.maintainAspectRatio = true;
    chart.options.tooltips.callbacks.label = function (tooltipItems, data) {
      var idx = tooltipItems.index;
      var value = data.datasets[0].data[idx];
      var num = Number(value);
      if (!__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite___default()(num)) {
        return 'Sem dado';
      }
      return num.toLocaleString('pt-BR');
    };

    return chart;
  },
  percentageDoughnutChart: function percentageDoughnutChart(data, title) {
    var chart = this.doughnutChart(data, title);
    var categoryCount = createChartLabels(normalizeChartPayload(data).chartData).length;

    chart.options.tooltips.callbacks.label = function (tooltipItems, data) {
      var idx = tooltipItems.index;
      var value = data.datasets[0].data[idx];
      var num = Number(value);
      if (!__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite___default()(num)) {
        return 'Sem dado';
      }
      return data.labels[idx] + ': ' + num.toFixed(1).replace('.', ',') + '%';
    };

    chart.options.legend = {
      display: true,
      position: categoryCount > 5 ? 'right' : 'bottom',
      labels: {
        boxWidth: 14,
        fontSize: 11,
        padding: 10
      }
    };

    return chart;
  },
  stackedBarChart: function stackedBarChart(data, title) {
    var chart = this.chart(data, title);
    chart.options.scales.xAxes = [{
      stacked: true
    }];
    chart.options.scales.yAxes = [{
      stacked: true
    }];
    chart.options.tooltips.callbacks.title = function (tooltipItems, data) {
      var idx = tooltipItems[0].datasetIndex;
      return data.datasets[idx].label + ' - ' + tooltipItems[0].label;
    };
    return chart;
  }
});

function buildChartOptions(title, metadata) {
  var options = {
    responsive: true,
    maintainAspectRatio: false,
    title: {
      display: true,
      text: title
    },
    scales: {
      yAxes: [{
        ticks: {
          callback: function callback(value, index, values) {
            var num = Number(value);
            if (!__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite___default()(num)) {
              return '';
            }
            return num.toLocaleString('pt-BR');
          }
        }
      }],
      xAxes: [{
        ticks: {
          autoSkip: false,
          maxRotation: 60,
          minRotation: 0,
          callback: function callback(xLabel) {
            return truncate(xLabel, 25);
          }
        }
      }]
    },
    tooltips: {
      enabled: true,
      callbacks: {
        title: function title(tooltipItems, data) {
          var idx = tooltipItems[0].index;
          return data.labels[idx];
        },
        label: function label(tooltipItems, data) {
          var num = Number(tooltipItems.yLabel);
          if (!__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite___default()(num)) {
            return 'Sem dado';
          }
          return num.toLocaleString('pt-BR');
        }
      }
    }
  };

  if (metadata && metadata.filterScopeLabel) {
    options.title.text = title + '\n' + metadata.filterScopeLabel;
  }

  return options;
}

var createChartLabels = function createChartLabels(chartData) {
  var nonEmptyDataset = chartData.find(function (dataset) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(dataset.result).length;
  });
  if (!nonEmptyDataset) {
    return [];
  }
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(nonEmptyDataset.result).map(stripTags);
};

var stripTags = function stripTags(str) {
  return String(str).replace(/<(?:.|\n)*?>/gm, '');
};

var truncate = function truncate(str) {
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;

  var value = String(str);
  if (value.length <= maxLength) {
    return value;
  }
  return value.substr(0, maxLength).trim() + '...';
};

var colors = ['#3c8dbc', '#00c0ef', '#f56954', '#3c4dbc', '#3cbcab', '#bc3c4d', '#bd3ca1', '#f3d512', '#1f1f1f', '#214034', '#351224', '#b99f52', '#424240', '#66787b', '#643c24'];

var normalizeChartValue = function normalizeChartValue(value) {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value)) === 'object' && value !== null && value.value !== undefined) {
    return normalizeChartValue(value.value);
  }

  var num = Number(value);
  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite___default()(num) ? num : null;
};

var createChartDatasets = function createChartDatasets(chartData, labels) {
  var datasets = [];
  chartData.forEach(function (item, index) {
    var result = item.result || {};
    var data = labels && labels.length ? labels.map(function (label) {
      if (result[label] !== undefined) {
        return normalizeChartValue(result[label]);
      }
      var key = String(label);
      if (result[key] !== undefined) {
        return normalizeChartValue(result[key]);
      }
      return null;
    }) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(result).map(normalizeChartValue);

    var dataset = {
      label: truncate(String(item.label), 45),
      borderColor: colors[index % colors.length],
      backgroundColor: colors[index % colors.length],
      fill: false,
      data: data,
      spanGaps: false
    };
    datasets.push(dataset);
  });

  return datasets;
};

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(694),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(759),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(779),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(740),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(689),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(699),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(734),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['data'],
  data: function data() {
    return {
      isRenderingChart: false
    };
  },
  mounted: function mounted() {
    this.renderFromData();
  },
  beforeDestroy: function beforeDestroy() {
    this.isRenderingChart = false;
    if (this.$data._chart) {
      this.$data._chart.destroy();
      this.$data._chart = null;
    }
  },

  watch: {
    // Reference-only: Chart.js mutates options/datasets in place. A deep watcher
    // re-enters renderFromData and freezes the tab (especially on financialView changes).
    data: function data() {
      this.renderFromData();
    }
  },
  methods: {
    renderFromData: function renderFromData() {
      var _this = this;

      if (!this.data || !this.data.report || this.isRenderingChart) {
        return;
      }

      this.isRenderingChart = true;

      try {
        if (this.$data._chart) {
          this.$data._chart.destroy();
          this.$data._chart = null;
        }

        this.renderChart(this.data.report, this.data.options);

        this.$nextTick(function () {
          if (_this.$data._chart) {
            _this.$data._chart.resize();
          }
          _this.isRenderingChart = false;
        });
      } catch (error) {
        this.isRenderingChart = false;
        throw error;
      }
    }
  }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FIRST_AVAILABLE_YEAR; });
/* unused harmony export COMPANY_ENTRY_YEAR_START */
/* harmony export (immutable) */ __webpack_exports__["c"] = buildYearRange;
/* harmony export (immutable) */ __webpack_exports__["b"] = yearsInRange;
var FIRST_AVAILABLE_YEAR = 1985;

var COMPANY_ENTRY_YEAR_START = 1985;

function buildYearRange() {
  var endYear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date().getFullYear();
  var startYear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FIRST_AVAILABLE_YEAR;

  var years = [];
  for (var year = endYear; year >= startYear; year--) {
    years.push(year);
  }
  return years;
}

function yearsInRange(startYear, endYear) {
  var years = [];
  for (var year = startYear; year <= endYear; year++) {
    years.push(year);
  }
  return years;
}

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PARK_QUIZ_TEMPLATE_UUID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PARK_QUIZ_STATUS_UNANSWERED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PARK_QUIZ_STATUS_ANSWERED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PARK_QUIZ_STATUS_WAITING_APPROVAL; });
/* unused harmony export PARK_QUIZ_STATUS_DISAPPROVED */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_backend_api__ = __webpack_require__(3);


var PARK_QUIZ_TEMPLATE_UUID = 'cec1cd60-db16-35ca-aa9f-ca2056b7b9bc';
var PARK_QUIZ_STATUS_UNANSWERED = 'unanswered';
var PARK_QUIZ_STATUS_ANSWERED = 'answered';
var PARK_QUIZ_STATUS_WAITING_APPROVAL = 'waiting_approval';
var PARK_QUIZ_STATUS_DISAPPROVED = 'disapproved';

/* harmony default export */ __webpack_exports__["a"] = ({
  post: function post(parkId, year) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().post('park-quizzes/', { parkId: parkId, year: year, quizTemplateUuid: PARK_QUIZ_TEMPLATE_UUID }).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  put: function put(uuid, status, answers) {
    var axisToValidate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().put('park-quizzes/' + uuid, { status: status, answers: answers, axisToValidate: axisToValidate }).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  getByYear: function getByYear(parkId, year) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().get('park-quizzes/?park=' + parkId + '&year=' + year).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  waittingApproval: function waittingApproval() {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().get('/waitting-approval-park-quizzes').then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  }
});

/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(719),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(593)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(763),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a3fefefe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(602)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(780),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f4ed9428",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(586)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(720),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-45b879f8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(731),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(723),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(750),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_backend_api__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getAnonymousClient().get('companies/' + id).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  cget: function cget() {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getAnonymousClient().get('companies/').then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  cgetByPark: function cgetByPark(parkId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getAnonymousClient().get('parks/' + parkId + '/companies/').then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  post: function post(parkId, company) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().post('parks/' + parkId + '/companies/', company).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  put: function put(company) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().put('/companies/' + company.id, company).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  unlink: function unlink(companyId, date) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().post('companies/' + companyId + '/unlink', { date: date }).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  relink: function relink(companyId, date) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().post('companies/' + companyId + '/relink', { date: date }).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_backend_api__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getAnonymousClient().get('news/' + id).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  cget: function cget() {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getAnonymousClient().get('news/').then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  post: function post(news) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().post('news/', news).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  put: function put(news) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().put('news/' + news.id, news).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_backend_api__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().get('partners/' + id).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  cget: function cget() {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().get('partners/').then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  post: function post(partner) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().post('partners/', partner).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  put: function put(partner) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().put('partners/' + partner.id, partner).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().delete('partners/' + id).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  recoverPassword: function recoverPassword(id) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().put('users/partner-password-recovery/' + id).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_backend_api__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(uuid, parkId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().get('quiz-templates/' + uuid + '/' + parkId).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_backend_api__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  getInPeriod: function getInPeriod(endpoint, startYear, endYear) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().get(endpoint + '?startYear=' + startYear + '&endYear=' + endYear).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  getInYear: function getInYear(endpoint, year) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().get(endpoint + '?year=' + year).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  getInDateRange: function getInDateRange(endpoint, startDate, endDate) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().get(endpoint + '?startDate=' + startDate + '&endDate=' + endDate).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  getInYearForRespondents: function getInYearForRespondents(endpoint, year, respondents) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().get(endpoint + '?year=' + year + '&respondents=' + respondents).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  }
});

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(599)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(771),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ce3515d0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(395),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(733),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(743),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(711),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(772),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(703),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(466),
  /* template */
  __webpack_require__(727),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_portal__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_security__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_researcher__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_admin__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router_parks__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_partners__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router_companies__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router_cms__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_news__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router_quiz_period__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__router_reports__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__router_mailing__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__router_export__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__router_maintenance__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__router_errors__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__services_authentication__ = __webpack_require__(23);




















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var routes = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__router_security__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5__router_researcher__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_6__router_admin__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3__router_portal__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_7__router_parks__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_8__router_partners__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_9__router_companies__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_10__router_cms__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_11__router_news__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_17__router_errors__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_12__router_quiz_period__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_13__router_reports__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_14__router_mailing__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_15__router_export__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_16__router_maintenance__["a" /* default */]));

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: routes,
  history: true,
  mode: 'history',
  saveScrollPosition: true,
  linkActiveClass: 'active'
});

router.beforeEach(function (to, from, next) {
  router.app.$Progress.start();

  if (!routeExists(to)) {
    redirectToNotFoundPage();
    return;
  }

  if (!routeRequiresAuthentication(to)) {
    if (to.meta.preLoad) {
      to.meta.preLoad(to, __WEBPACK_IMPORTED_MODULE_18__services_authentication__["a" /* default */], router).then(next());
      return;
    }

    next();
    return;
  }

  if (!__WEBPACK_IMPORTED_MODULE_18__services_authentication__["a" /* default */].isAuthenticated()) {
    redirectToLoginPage(to, next);
    return;
  }

  if (routeRequiresResearcherOnly(to) && !__WEBPACK_IMPORTED_MODULE_18__services_authentication__["a" /* default */].userHasResearcherRole()) {
    redirectToUnauthorizedPage();
    return;
  }

  if (!__WEBPACK_IMPORTED_MODULE_18__services_authentication__["a" /* default */].userHasAdminRole() && !__WEBPACK_IMPORTED_MODULE_18__services_authentication__["a" /* default */].userHasResearcherRole() && !userHasRequiredRole(to)) {
    redirectToUnauthorizedPage();
  }

  if (to.meta.preLoad) {
    to.meta.preLoad(to, __WEBPACK_IMPORTED_MODULE_18__services_authentication__["a" /* default */], router).then(next());
    return;
  }

  next();
  return;
});

var routeExists = function routeExists(to) {
  return to.matched.length > 0;
};

var redirectToNotFoundPage = function redirectToNotFoundPage() {
  router.push({ name: 'NotFoundError' });
};

var routeRequiresAuthentication = function routeRequiresAuthentication(to) {
  return to.matched.some(function (record) {
    return record.meta.requiresAuthentication;
  });
};

var redirectToLoginPage = function redirectToLoginPage(to, next) {
  next({
    path: '/login',
    query: { redirect: to.fullPath }
  });
};

var routeRequiresResearcherOnly = function routeRequiresResearcherOnly(to) {
  return to.matched.some(function (record) {
    return record.meta.researcherOnly === true;
  });
};

var userHasRequiredRole = function userHasRequiredRole(to) {
  return to.matched.some(function (record) {
    return typeof record.meta.roleRequired === 'undefined' || record.meta.roleRequired === null || record.meta.roleRequired.includes(__WEBPACK_IMPORTED_MODULE_18__services_authentication__["a" /* default */].getUserRole());
  });
};

var redirectToUnauthorizedPage = function redirectToUnauthorizedPage() {
  router.push({ name: 'UnauthorizedError' });
};

router.afterEach(function (to, from) {
  router.app.$Progress.finish();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_backend_api__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(pageName) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getAnonymousClient().get('page-contents/' + pageName).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  put: function put(pageContent) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().put('page-contents/' + pageContent.pageName, pageContent).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  }
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_backend_api__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get() {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getAnonymousClient().get('indicators').then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_backend_api__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  byParkQuizUuid: function byParkQuizUuid(parkQuizUuid) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().get('/quiz-evaluations/?parkQuiz=' + parkQuizUuid).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  post: function post(parkQuizUuid) {
    var approvedAxis = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var disapprovedAxis = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().post('/quiz-evaluations/', { parkQuizUuid: parkQuizUuid, approvedAxis: approvedAxis, disapprovedAxis: disapprovedAxis }).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  put: function put(id, parkQuizUuid) {
    var approvedAxis = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var disapprovedAxis = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var isParkQuizApproved = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().put('/quiz-evaluations/' + id, { parkQuizUuid: parkQuizUuid, approvedAxis: approvedAxis, disapprovedAxis: disapprovedAxis, isParkQuizApproved: isParkQuizApproved }).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  }
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_backend_api__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  getByYear: function getByYear(year) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().get('quiz-periods/?search=' + year).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  post: function post(quizPeriod) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().post('quiz-periods/', quizPeriod).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  put: function put(quizPeriod) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().put('quiz-periods/' + quizPeriod.id, quizPeriod).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  }
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = responseContainsCpfCnpjValidationError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


/**
 * Detects CPF/CNPJ validation messages returned by the API (nested JSON).
 */
function responseContainsCpfCnpjValidationError(data) {
  if (data == null) {
    return false;
  }
  if (typeof data === 'string') {
    var s = data.toLowerCase();
    return s.includes('valid cpf') || s.includes('valid cnpj') || s.includes('cpf inválido') || s.includes('cnpj inválido');
  }
  if (Array.isArray(data)) {
    return data.some(function (item) {
      return responseContainsCpfCnpjValidationError(item);
    });
  }
  if ((typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(data)) === 'object') {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).some(function (k) {
      return responseContainsCpfCnpjValidationError(data[k]);
    });
  }
  return false;
}

/***/ }),
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(595)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(765),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a8b9bb86",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(577)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(688),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-13f5e213",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(396),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(397),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(398),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(588)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(724),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(735),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(580)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(696),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(692),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(698),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */
/***/ (function(module, exports) {

module.exports = {"AC":{"name":"Acre","cities":["Acrelândia","Assis Brasil","Brasiléia","Bujari","Capixaba","Cruzeiro do Sul","Epitaciolândia","Feijó","Jordão","Mâncio Lima","Manoel Urbano","Marechal Thaumaturgo","Plácido de Castro","Porto Acre","Porto Walter","Rio Branco","Rodrigues Alves","Santa Rosa do Purus","Sena Madureira","Senador Guiomard","Tarauacá","Xapuri"]},"AL":{"name":"Alagoas","cities":["Água Branca","Anadia","Arapiraca","Atalaia","Barra de Santo Antônio","Barra de São Miguel","Batalha","Belém","Belo Monte","Boca da Mata","Branquinha","Cacimbinhas","Cajueiro","Campestre","Campo Alegre","Campo Grande","Canapi","Capela","Carneiros","Chã Preta","Coité do Nóia","Colônia Leopoldina","Coqueiro Seco","Coruripe","Craíbas","Delmiro Gouveia","Dois Riachos","Estrela de Alagoas","Feira Grande","Feliz Deserto","Flexeiras","Girau do Ponciano","Ibateguara","Igaci","Igreja Nova","Inhapi","Jacaré dos Homens","Jacuípe","Japaratinga","Jaramataia","Jequiá da Praia","Joaquim Gomes","Jundiá","Junqueiro","Lagoa da Canoa","Limoeiro de Anadia","Maceió","Major Isidoro","Mar Vermelho","Maragogi","Maravilha","Marechal Deodoro","Maribondo","Mata Grande","Matriz de Camaragibe","Messias","Minador do Negrão","Monteirópolis","Murici","Novo Lino","Olho d'Água das Flores","Olho d'Água do Casado","Olho d'Água Grande","Olivença","Ouro Branco","Palestina","Palmeira dos Índios","Pão de Açúcar","Pariconha","Paripueira","Passo de Camaragibe","Paulo Jacinto","Penedo","Piaçabuçu","Pilar","Pindoba","Piranhas","Poço das Trincheiras","Porto Calvo","Porto de Pedras","Porto Real do Colégio","Quebrangulo","Rio Largo","Roteiro","Santa Luzia do Norte","Santana do Ipanema","Santana do Mundaú","São Brás","São José da Laje","São José da Tapera","São Luís do Quitunde","São Miguel dos Campos","São Miguel dos Milagres","São Sebastião","Satuba","Senador Rui Palmeira","Tanque d'Arca","Taquarana","Teotônio Vilela","Traipu","União dos Palmares","Viçosa"]},"AM":{"name":"Amazonas","cities":["Alvarães","Amaturá","Anamã","Anori","Apuí","Atalaia do Norte","Autazes","Barcelos","Barreirinha","Benjamin Constant","Beruri","Boa Vista do Ramos","Boca do Acre","Borba","Caapiranga","Canutama","Carauari","Careiro","Careiro da Várzea","Coari","Codajás","Eirunepé","Envira","Fonte Boa","Guajará","Humaitá","Ipixuna","Iranduba","Itacoatiara","Itamarati","Itapiranga","Japurá","Juruá","Jutaí","Lábrea","Manacapuru","Manaquiri","Manaus","Manicoré","Maraã","Maués","Nhamundá","Nova Olinda do Norte","Novo Airão","Novo Aripuanã","Parintins","Pauini","Presidente Figueiredo","Rio Preto da Eva","Santa Isabel do Rio Negro","Santo Antônio do Içá","São Gabriel da Cachoeira","São Paulo de Olivença","São Sebastião do Uatumã","Silves","Tabatinga","Tapauá","Tefé","Tonantins","Uarini","Urucará","Urucurituba"]},"AP":{"name":"Amapá","cities":["Amapá","Calçoene","Cutias","Ferreira Gomes","Itaubal","Laranjal do Jari","Macapá","Mazagão","Oiapoque","Pedra Branca do Amapari","Porto Grande","Pracuúba","Santana","Serra do Navio","Tartarugalzinho","Vitória do Jari"]},"BA":{"name":"Bahia","cities":["Abaíra","Abaré","Acajutiba","Adustina","Água Fria","Aiquara","Alagoinhas","Alcobaça","Almadina","Amargosa","Amélia Rodrigues","América Dourada","Anagé","Andaraí","Andorinha","Angical","Anguera","Antas","Antônio Cardoso","Antônio Gonçalves","Aporá","Apuarema","Araças","Aracatu","Araci","Aramari","Arataca","Aratuípe","Aurelino Leal","Baianópolis","Baixa Grande","Banzaê","Barra","Barra da Estiva","Barra do Choça","Barra do Mendes","Barra do Rocha","Barreiras","Barro Alto","Barrocas","Barro Preto","Belmonte","Belo Campo","Biritinga","Boa Nova","Boa Vista do Tupim","Bom Jesus da Lapa","Bom Jesus da Serra","Boninal","Bonito","Boquira","Botuporã","Brejões","Brejolândia","Brotas de Macaúbas","Brumado","Buerarema","Buritirama","Caatiba","Cabaceiras do Paraguaçu","Cachoeira","Caculé","Caém","Caetanos","Caetité","Cafarnaum","Cairu","Caldeirão Grande","Camacan","Camaçari","Camamu","Campo Alegre de Lourdes","Campo Formoso","Canápolis","Canarana","Canavieiras","Candeal","Candeias","Candiba","Cândido Sales","Cansanção","Canudos","Capela do Alto Alegre","Capim Grosso","Caraíbas","Caravelas","Cardeal da Silva","Carinhanha","Casa Nova","Castro Alves","Catolândia","Catu","Caturama","Central","Chorrochó","Cícero Dantas","Cipó","Coaraci","Cocos","Conceição da Feira","Conceição do Almeida","Conceição do Coité","Conceição do Jacuípe","Conde","Condeúba","Contendas do Sincorá","Coração de Maria","Cordeiros","Coribe","Coronel João Sá","Correntina","Cotegipe","Cravolândia","Crisópolis","Cristópolis","Cruz das Almas","Curaçá","Dário Meira","Dias d'Ávila","Dom Basílio","Dom Macedo Costa","Elísio Medrado","Encruzilhada","Entre Rios","Érico Cardoso","Esplanada","Euclides da Cunha","Eunápolis","Fátima","Feira da Mata","Feira de Santana","Filadélfia","Firmino Alves","Floresta Azul","Formosa do Rio Preto","Gandu","Gavião","Gentio do Ouro","Glória","Gongogi","Governador Mangabeira","Guajeru","Guanambi","Guaratinga","Heliópolis","Iaçu","Ibiassucê","Ibicaraí","Ibicoara","Ibicuí","Ibipeba","Ibipitanga","Ibiquera","Ibirapitanga","Ibirapuã","Ibirataia","Ibitiara","Ibititá","Ibotirama","Ichu","Igaporã","Igrapiúna","Iguaí","Ilhéus","Inhambupe","Ipecaetá","Ipiaú","Ipirá","Ipupiara","Irajuba","Iramaia","Iraquara","Irará","Irecê","Itabela","Itaberaba","Itabuna","Itacaré","Itaeté","Itagi","Itagibá","Itagimirim","Itaguaçu da Bahia","Itaju do Colônia","Itajuípe","Itamaraju","Itamari","Itambé","Itanagra","Itanhém","Itaparica","Itapé","Itapebi","Itapetinga","Itapicuru","Itapitanga","Itaquara","Itarantim","Itatim","Itiruçu","Itiúba","Itororó","Ituaçu","Ituberá","Iuiú","Jaborandi","Jacaraci","Jacobina","Jaguaquara","Jaguarari","Jaguaripe","Jandaíra","Jequié","Jeremoabo","Jiquiriçá","Jitaúna","João Dourado","Juazeiro","Jucuruçu","Jussara","Jussari","Jussiape","Lafaiete Coutinho","Lagoa Real","Laje","Lajedão","Lajedinho","Lajedo do Tabocal","Lamarão","Lapão","Lauro de Freitas","Lençóis","Licínio de Almeida","Livramento de Nossa Senhora","Luís Eduardo Magalhães","Macajuba","Macarani","Macaúbas","Macururé","Madre de Deus","Maetinga","Maiquinique","Mairi","Malhada","Malhada de Pedras","Manoel Vitorino","Mansidão","Maracás","Maragogipe","Maraú","Marcionílio Souza","Mascote","Mata de São João","Matina","Medeiros Neto","Miguel Calmon","Milagres","Mirangaba","Mirante","Monte Santo","Morpará","Morro do Chapéu","Mortugaba","Mucugê","Mucuri","Mulungu do Morro","Mundo Novo","Muniz Ferreira","Muquém de São Francisco","Muritiba","Mutuípe","Nazaré","Nilo Peçanha","Nordestina","Nova Canaã","Nova Fátima","Nova Ibiá","Nova Itarana","Nova Redenção","Nova Soure","Nova Viçosa","Novo Horizonte","Novo Triunfo","Olindina","Oliveira dos Brejinhos","Ouriçangas","Ourolândia","Palmas de Monte Alto","Palmeiras","Paramirim","Paratinga","Paripiranga","Pau Brasil","Paulo Afonso","Pé de Serra","Pedrão","Pedro Alexandre","Piatã","Pilão Arcado","Pindaí","Pindobaçu","Pintadas","Piraí do Norte","Piripá","Piritiba","Planaltino","Planalto","Poções","Pojuca","Ponto Novo","Porto Seguro","Potiraguá","Prado","Presidente Dutra","Presidente Jânio Quadros","Presidente Tancredo Neves","Queimadas","Quijingue","Quixabeira","Rafael Jambeiro","Remanso","Retirolândia","Riachão das Neves","Riachão do Jacuípe","Riacho de Santana","Ribeira do Amparo","Ribeira do Pombal","Ribeirão do Largo","Rio de Contas","Rio do Antônio","Rio do Pires","Rio Real","Rodelas","Ruy Barbosa","Salinas da Margarida","Salvador","Santa Bárbara","Santa Brígida","Santa Cruz Cabrália","Santa Cruz da Vitória","Santa Inês","Santa Luzia","Santa Maria da Vitória","Santa Rita de Cássia","Santa Teresinha","Santaluz","Santana","Santanópolis","Santo Amaro","Santo Antônio de Jesus","Santo Estêvão","São Desidério","São Domingos","São Felipe","São Félix","São Félix do Coribe","São Francisco do Conde","São Gabriel","São Gonçalo dos Campos","São José da Vitória","São José do Jacuípe","São Miguel das Matas","São Sebastião do Passé","Sapeaçu","Sátiro Dias","Saubara","Saúde","Seabra","Sebastião Laranjeiras","Senhor do Bonfim","Sento Sé","Serra do Ramalho","Serra Dourada","Serra Preta","Serrinha","Serrolândia","Simões Filho","Sítio do Mato","Sítio do Quinto","Sobradinho","Souto Soares","Tabocas do Brejo Velho","Tanhaçu","Tanque Novo","Tanquinho","Taperoá","Tapiramutá","Teixeira de Freitas","Teodoro Sampaio","Teofilândia","Teolândia","Terra Nova","Tremedal","Tucano","Uauá","Ubaíra","Ubaitaba","Ubatã","Uibaí","Umburanas","Una","Urandi","Uruçuca","Utinga","Valença","Valente","Várzea da Roça","Várzea do Poço","Várzea Nova","Varzedo","Vera Cruz","Vereda","Vitória da Conquista","Wagner","Wanderley","Wenceslau Guimarães","Xique-Xique"]},"CE":{"name":"Ceará","cities":["Abaiara","Acarapé","Acaraú","Acopiara","Aiuaba","Alcântaras","Altaneira","Alto Santo","Amontada","Antonina do Norte","Apuiarés","Aquiraz","Aracati","Aracoiaba","Ararendá","Araripe","Aratuba","Arneiroz","Assaré","Aurora","Baixio","Banabuiú","Barbalha","Barreira","Barro","Barroquinha","Baturité","Beberibe","Bela Cruz","Boa Viagem","Brejo Santo","Camocim","Campos Sales","Canindé","Capistrano","Caridade","Cariré","Caririaçu","Cariús","Carnaubal","Cascavel","Catarina","Catunda","Caucaia","Cedro","Chaval","Choró","Chorozinho","Coreaú","Crateús","Crato","Croatá","Cruz","Deputado Irapuan Pinheiro","Ererê","Eusébio","Farias Brito","Forquilha","Fortaleza","Fortim","Frecheirinha","General Sampaio","Graça","Granja","Granjeiro","Groaíras","Guaiúba","Guaraciaba do Norte","Guaramiranga","Hidrolândia","Horizonte","Ibaretama","Ibiapina","Ibicuitinga","Icapuí","Icó","Iguatu","Independência","Ipaporanga","Ipaumirim","Ipu","Ipueiras","Iracema","Irauçuba","Itaiçaba","Itaitinga","Itapagé","Itapipoca","Itapiúna","Itarema","Itatira","Jaguaretama","Jaguaribara","Jaguaribe","Jaguaruana","Jardim","Jati","Jijoca de Jericoaroara","Juazeiro do Norte","Jucás","Lavras da Mangabeira","Limoeiro do Norte","Madalena","Maracanaú","Maranguape","Marco","Martinópole","Massapê","Mauriti","Meruoca","Milagres","Milhã","Miraíma","Missão Velha","Mombaça","Monsenhor Tabosa","Morada Nova","Moraújo","Morrinhos","Mucambo","Mulungu","Nova Olinda","Nova Russas","Novo Oriente","Ocara","Orós","Pacajus","Pacatuba","Pacoti","Pacujá","Palhano","Palmácia","Paracuru","Paraipaba","Parambu","Paramoti","Pedra Branca","Penaforte","Pentecoste","Pereiro","Pindoretama","Piquet Carneiro","Pires Ferreira","Poranga","Porteiras","Potengi","Potiretama","Quiterianópolis","Quixadá","Quixelô","Quixeramobim","Quixeré","Redenção","Reriutaba","Russas","Saboeiro","Salitre","Santa Quitéria","Santana do Acaraú","Santana do Cariri","São Benedito","São Gonçalo do Amarante","São João do Jaguaribe","São Luís do Curu","Senador Pompeu","Senador Sá","Sobral","Solonópole","Tabuleiro do Norte","Tamboril","Tarrafas","Tauá","Tejuçuoca","Tianguá","Trairi","Tururu","Ubajara","Umari","Umirim","Uruburetama","Uruoca","Varjota","Várzea Alegre","Viçosa do Ceará"]},"DF":{"name":"Distrito Federal","cities":["Brasília"]},"ES":{"name":"Espírito Santo","cities":["Afonso Cláudio","Água Doce do Norte","Águia Branca","Alegre","Alfredo Chaves","Alto Rio Novo","Anchieta","Apiacá","Aracruz","Atilio Vivacqua","Baixo Guandu","Barra de São Francisco","Boa Esperança","Bom Jesus do Norte","Brejetuba","Cachoeiro de Itapemirim","Cariacica","Castelo","Colatina","Conceição da Barra","Conceição do Castelo","Divino de São Lourenço","Domingos Martins","Dores do Rio Preto","Ecoporanga","Fundão","Governador Lindenberg","Guaçuí","Guarapari","Ibatiba","Ibiraçu","Ibitirama","Iconha","Irupi","Itaguaçu","Itapemirim","Itarana","Iúna","Jaguaré","Jerônimo Monteiro","João Neiva","Laranja da Terra","Linhares","Mantenópolis","Marataizes","Marechal Floriano","Marilândia","Mimoso do Sul","Montanha","Mucurici","Muniz Freire","Muqui","Nova Venécia","Pancas","Pedro Canário","Pinheiros","Piúma","Ponto Belo","Presidente Kennedy","Rio Bananal","Rio Novo do Sul","Santa Leopoldina","Santa Maria de Jetibá","Santa Teresa","São Domingos do Norte","São Gabriel da Palha","São José do Calçado","São Mateus","São Roque do Canaã","Serra","Sooretama","Vargem Alta","Venda Nova do Imigrante","Viana","Vila Pavão","Vila Valério","Vila Velha","Vitória"]},"GO":{"name":"Goiás","cities":["Abadia de Goiás","Abadiânia","Acreúna","Adelândia","Água Fria de Goiás","Água Limpa","Águas Lindas de Goiás","Alexânia","Aloândia","Alto Horizonte","Alto Paraíso de Goiás","Alvorada do Norte","Amaralina","Americano do Brasil","Amorinópolis","Anápolis","Anhanguera","Anicuns","Aparecida de Goiânia","Aparecida do Rio Doce","Aporé","Araçu","Aragarças","Aragoiânia","Araguapaz","Arenópolis","Aruanã","Aurilândia","Avelinópolis","Baliza","Barro Alto","Bela Vista de Goiás","Bom Jardim de Goiás","Bom Jesus de Goiás","Bonfinópolis","Bonópolis","Brazabrantes","Britânia","Buriti Alegre","Buriti de Goiás","Buritinópolis","Cabeceiras","Cachoeira Alta","Cachoeira de Goiás","Cachoeira Dourada","Caçu","Caiapônia","Caldas Novas","Caldazinha","Campestre de Goiás","Campinaçu","Campinorte","Campo Alegre de Goiás","Campos Limpo de Goiás","Campos Belos","Campos Verdes","Carmo do Rio Verde","Castelândia","Catalão","Caturaí","Cavalcante","Ceres","Cezarina","Chapadão do Céu","Cidade Ocidental","Cocalzinho de Goiás","Colinas do Sul","Córrego do Ouro","Corumbá de Goiás","Corumbaíba","Cristalina","Cristianópolis","Crixás","Cromínia","Cumari","Damianópolis","Damolândia","Davinópolis","Diorama","Divinópolis de Goiás","Doverlândia","Edealina","Edéia","Estrela do Norte","Faina","Fazenda Nova","Firminópolis","Flores de Goiás","Formosa","Formoso","Gameleira de Goiás","Goianápolis","Goiandira","Goianésia","Goiânia","Goianira","Goiás","Goiatuba","Gouvelândia","Guapó","Guaraíta","Guarani de Goiás","Guarinos","Heitoraí","Hidrolândia","Hidrolina","Iaciara","Inaciolândia","Indiara","Inhumas","Ipameri","Ipiranga de Goiás","Iporá","Israelândia","Itaberaí","Itaguari","Itaguaru","Itajá","Itapaci","Itapirapuã","Itapuranga","Itarumã","Itauçu","Itumbiara","Ivolândia","Jandaia","Jaraguá","Jataí","Jaupaci","Jesúpolis","Joviânia","Jussara","Lagoa Santa","Leopoldo de Bulhões","Luziânia","Mairipotaba","Mambaí","Mara Rosa","Marzagão","Matrinchã","Maurilândia","Mimoso de Goiás","Minaçu","Mineiros","Moiporá","Monte Alegre de Goiás","Montes Claros de Goiás","Montividiu","Montividiu do Norte","Morrinhos","Morro Agudo de Goiás","Mossâmedes","Mozarlândia","Mundo Novo","Mutunópolis","Nazário","Nerópolis","Niquelândia","Nova América","Nova Aurora","Nova Crixás","Nova Glória","Nova Iguaçu de Goiás","Nova Roma","Nova Veneza","Novo Brasil","Novo Gama","Novo Planalto","Orizona","Ouro Verde de Goiás","Ouvidor","Padre Bernardo","Palestina de Goiás","Palmeiras de Goiás","Palmelo","Palminópolis","Panamá","Paranaiguara","Paraúna","Perolândia","Petrolina de Goiás","Pilar de Goiás","Piracanjuba","Piranhas","Pirenópolis","Pires do Rio","Planaltina","Pontalina","Porangatu","Porteirão","Portelândia","Posse","Professor Jamil","Quirinópolis","Rialma","Rianápolis","Rio Quente","Rio Verde","Rubiataba","Sanclerlândia","Santa Bárbara de Goiás","Santa Cruz de Goiás","Santa Fé de Goiás","Santa Helena de Goiás","Santa Isabel","Santa Rita do Araguaia","Santa Rita do Novo Destino","Santa Rosa de Goiás","Santa Tereza de Goiás","Santa Terezinha de Goiás","Santo Antônio da Barra","Santo Antônio de Goiás","Santo Antônio do Descoberto","São Domingos","São Francisco de Goiás","São João d'Aliança","São João da Paraúna","São Luís de Montes Belos","São Luíz do Norte","São Miguel do Araguaia","São Miguel do Passa Quatro","São Patrício","São Simão","Senador Canedo","Serranópolis","Silvânia","Simolândia","Sítio d'Abadia","Taquaral de Goiás","Teresina de Goiás","Terezópolis de Goiás","Três Ranchos","Trindade","Trombas","Turvânia","Turvelândia","Uirapuru","Uruaçu","Uruana","Urutaí","Valparaíso de Goiás","Varjão","Vianópolis","Vicentinópolis","Vila Boa","Vila Propício"]},"MA":{"name":"Maranhão","cities":["Açailândia","Afonso Cunha","Água Doce do Maranhão","Alcântara","Aldeias Altas","Altamira do Maranhão","Alto Alegre do Maranhão","Alto Alegre do Pindaré","Alto Parnaíba","Amapá do Maranhão","Amarante do Maranhão","Anajatuba","Anapurus","Apicum-Açu","Araguanã","Araioses","Arame","Arari","Axixá","Bacabal","Bacabeira","Bacuri","Bacurituba","Balsas","Barão de Grajaú","Barra do Corda","Barreirinhas","Bela Vista do Maranhão","Belágua","Benedito Leite","Bequimão","Bernardo do Mearim","Boa Vista do Gurupi","Bom Jardim","Bom Jesus das Selvas","Bom Lugar","Brejo","Brejo de Areia","Buriti","Buriti Bravo","Buriticupu","Buritirana","Cachoeira Grande","Cajapió","Cajari","Campestre do Maranhão","Cândido Mendes","Cantanhede","Capinzal do Norte","Carolina","Carutapera","Caxias","Cedral","Central do Maranhão","Centro do Guilherme","Centro Novo do Maranhão","Chapadinha","Cidelândia","Codó","Coelho Neto","Colinas","Conceição do Lago-Açu","Coroatá","Cururupu","Davinópolis","Dom Pedro","Duque Bacelar","Esperantinópolis","Estreito","Feira Nova do Maranhão","Fernando Falcão","Formosa da Serra Negra","Fortaleza dos Nogueiras","Fortuna","Godofredo Viana","Gonçalves Dias","Governador Archer","Governador Edison Lobão","Governador Eugênio Barros","Governador Luiz Rocha","Governador Newton Bello","Governador Nunes Freire","Graça Aranha","Grajaú","Guimarães","Humberto de Campos","Icatu","Igarapé do Meio","Igarapé Grande","Imperatriz","Itaipava do Grajaú","Itapecuru Mirim","Itinga do Maranhão","Jatobá","Jenipapo dos Vieiras","João Lisboa","Joselândia","Junco do Maranhão","Lago da Pedra","Lago do Junco","Lago dos Rodrigues","Lago Verde","Lagoa do Mato","Lagoa Grande do Maranhão","Lajeado Novo","Lima Campos","Loreto","Luís Domingues","Magalhães de Almeida","Maracaçumé","Marajá do Sena","Maranhãozinho","Mata Roma","Matinha","Matões","Matões do Norte","Milagres do Maranhão","Mirador","Miranda do Norte","Mirinzal","Monção","Montes Altos","Morros","Nina Rodrigues","Nova Colinas","Nova Iorque","Nova Olinda do Maranhão","Olho d'Água das Cunhãs","Olinda Nova do Maranhão","Paço do Lumiar","Palmeirândia","Paraibano","Parnarama","Passagem Franca","Pastos Bons","Paulino Neves","Paulo Ramos","Pedreiras","Pedro do Rosário","Penalva","Peri Mirim","Peritoró","Pindaré Mirim","Pinheiro","Pio XII","Pirapemas","Poção de Pedras","Porto Franco","Porto Rico do Maranhão","Presidente Dutra","Presidente Juscelino","Presidente Médici","Presidente Sarney","Presidente Vargas","Primeira Cruz","Raposa","Riachão","Ribamar Fiquene","Rosário","Sambaíba","Santa Filomena do Maranhão","Santa Helena","Santa Inês","Santa Luzia","Santa Luzia do Paruá","Santa Quitéria do Maranhão","Santa Rita","Santana do Maranhão","Santo Amaro do Maranhão","Santo Antônio dos Lopes","São Benedito do Rio Preto","São Bento","São Bernardo","São Domingos do Azeitão","São Domingos do Maranhão","São Félix de Balsas","São Francisco do Brejão","São Francisco do Maranhão","São João Batista","São João do Carú","São João do Paraíso","São João do Soter","São João dos Patos","São José de Ribamar","São José dos Basílios","São Luís","São Luís Gonzaga do Maranhão","São Mateus do Maranhão","São Pedro da Água Branca","São Pedro dos Crentes","São Raimundo das Mangabeiras","São Raimundo do Doca Bezerra","São Roberto","São Vicente Ferrer","Satubinha","Senador Alexandre Costa","Senador La Rocque","Serrano do Maranhão","Sítio Novo","Sucupira do Norte","Sucupira do Riachão","Tasso Fragoso","Timbiras","Timon","Trizidela do Vale","Tufilândia","Tuntum","Turiaçu","Turilândia","Tutóia","Urbano Santos","Vargem Grande","Viana","Vila Nova dos Martírios","Vitória do Mearim","Vitorino Freire","Zé Doca"]},"MG":{"name":"Minas Gerais","cities":["Abadia dos Dourados","Abaeté","Abre Campo","Acaiaca","Açucena","Água Boa","Água Comprida","Aguanil","Águas Formosas","Águas Vermelhas","Aimorés","Aiuruoca","Alagoa","Albertina","Além Paraíba","Alfenas","Alfredo Vasconcelos","Almenara","Alpercata","Alpinópolis","Alterosa","Alto Caparaó","Alto Jequitibá","Alto Rio Doce","Alvarenga","Alvinópolis","Alvorada de Minas","Amparo do Serra","Andradas","Andrelândia","Angelândia","Antônio Carlos","Antônio Dias","Antônio Prado de Minas","Araçaí","Aracitaba","Araçuaí","Araguari","Arantina","Araponga","Araporã","Arapuá","Araújos","Araxá","Arceburgo","Arcos","Areado","Argirita","Aricanduva","Arinos","Astolfo Dutra","Ataléia","Augusto de Lima","Baependi","Baldim","Bambuí","Bandeira","Bandeira do Sul","Barão de Cocais","Barão de Monte Alto","Barbacena","Barra Longa","Barroso","Bela Vista de Minas","Belmiro Braga","Belo Horizonte","Belo Oriente","Belo Vale","Berilo","Berizal","Bertópolis","Betim","Bias Fortes","Bicas","Biquinhas","Boa Esperança","Bocaina de Minas","Bocaiúva","Bom Despacho","Bom Jardim de Minas","Bom Jesus da Penha","Bom Jesus do Amparo","Bom Jesus do Galho","Bom Repouso","Bom Sucesso","Bonfim","Bonfinópolis de Minas","Bonito de Minas","Borda da Mata","Botelhos","Botumirim","Brás Pires","Brasilândia de Minas","Brasília de Minas","Brasópolis","Braúnas","Brumadinho","Bueno Brandão","Buenópolis","Bugre","Buritis","Buritizeiro","Cabeceira Grande","Cabo Verde","Cachoeira da Prata","Cachoeira de Minas","Cachoeira de Pajeú","Cachoeira Dourada","Caetanópolis","Caeté","Caiana","Cajuri","Caldas","Camacho","Camanducaia","Cambuí","Cambuquira","Campanário","Campanha","Campestre","Campina Verde","Campo Azul","Campo Belo","Campo do Meio","Campo Florido","Campos Altos","Campos Gerais","Cana Verde","Canaã","Canápolis","Candeias","Cantagalo","Caparaó","Capela Nova","Capelinha","Capetinga","Capim Branco","Capinópolis","Capitão Andrade","Capitão Enéas","Capitólio","Caputira","Caraí","Caranaíba","Carandaí","Carangola","Caratinga","Carbonita","Careaçu","Carlos Chagas","Carmésia","Carmo da Cachoeira","Carmo da Mata","Carmo de Minas","Carmo do Cajuru","Carmo do Paranaíba","Carmo do Rio Claro","Carmópolis de Minas","Carneirinho","Carrancas","Carvalhópolis","Carvalhos","Casa Grande","Cascalho Rico","Cássia","Cataguases","Catas Altas","Catas Altas da Noruega","Catuji","Catuti","Caxambu","Cedro do Abaeté","Central de Minas","Centralina","Chácara","Chalé","Chapada do Norte","Chapada Gaúcha","Chiador","Cipotânea","Claraval","Claro dos Poções","Cláudio","Coimbra","Coluna","Comendador Gomes","Comercinho","Conceição da Aparecida","Conceição da Barra de Minas","Conceição das Alagoas","Conceição das Pedras","Conceição de Ipanema","Conceição do Mato Dentro","Conceição do Pará","Conceição do Rio Verde","Conceição dos Ouros","Cônego Marinho","Confins","Congonhal","Congonhas","Congonhas do Norte","Conquista","Conselheiro Lafaiete","Conselheiro Pena","Consolação","Contagem","Coqueiral","Coração de Jesus","Cordisburgo","Cordislândia","Corinto","Coroaci","Coromandel","Coronel Fabriciano","Coronel Murta","Coronel Pacheco","Coronel Xavier Chaves","Córrego Danta","Córrego do Bom Jesus","Córrego Fundo","Córrego Novo","Couto de Magalhães de Minas","Crisólita","Cristais","Cristália","Cristiano Otoni","Cristina","Crucilândia","Cruzeiro da Fortaleza","Cruzília","Cuparaque","Curral de Dentro","Curvelo","Datas","Delfim Moreira","Delfinópolis","Delta","Descoberto","Desterro de Entre Rios","Desterro do Melo","Diamantina","Diogo de Vasconcelos","Dionísio","Divinésia","Divino","Divino das Laranjeiras","Divinolândia de Minas","Divinópolis","Divisa Alegre","Divisa Nova","Divisópolis","Dom Bosco","Dom Cavati","Dom Joaquim","Dom Silvério","Dom Viçoso","Dona Euzébia","Dores de Campos","Dores de Guanhães","Dores do Indaiá","Dores do Turvo","Doresópolis","Douradoquara","Durandé","Elói Mendes","Engenheiro Caldas","Engenheiro Navarro","Entre Folhas","Entre Rios de Minas","Ervália","Esmeraldas","Espera Feliz","Espinosa","Espírito Santo do Dourado","Estiva","Estrela Dalva","Estrela do Indaiá","Estrela do Sul","Eugenópolis","Ewbank da Câmara","Extrema","Fama","Faria Lemos","Felício dos Santos","Felisburgo","Felixlândia","Fernandes Tourinho","Ferros","Fervedouro","Florestal","Formiga","Formoso","Fortaleza de Minas","Fortuna de Minas","Francisco Badaró","Francisco Dumont","Francisco Sá","Franciscópolis","Frei Gaspar","Frei Inocêncio","Frei Lagonegro","Fronteira","Fronteira dos Vales","Fruta de Leite","Frutal","Funilândia","Galiléia","Gameleiras","Glaucilândia","Goiabeira","Goianá","Gonçalves","Gonzaga","Gouveia","Governador Valadares","Grão Mogol","Grupiara","Guanhães","Guapé","Guaraciaba","Guaraciama","Guaranésia","Guarani","Guarará","Guarda-Mor","Guaxupé","Guidoval","Guimarânia","Guiricema","Gurinhatã","Heliodora","Iapu","Ibertioga","Ibiá","Ibiaí","Ibiracatu","Ibiraci","Ibirité","Ibitiúra de Minas","Ibituruna","Icaraí de Minas","Igarapé","Igaratinga","Iguatama","Ijaci","Ilicínea","Imbé de Minas","Inconfidentes","Indaiabira","Indianópolis","Ingaí","Inhapim","Inhaúma","Inimutaba","Ipaba","Ipanema","Ipatinga","Ipiaçu","Ipuiúna","Iraí de Minas","Itabira","Itabirinha de Mantena","Itabirito","Itacambira","Itacarambi","Itaguara","Itaipé","Itajubá","Itamarandiba","Itamarati de Minas","Itambacuri","Itambé do Mato Dentro","Itamogi","Itamonte","Itanhandu","Itanhomi","Itaobim","Itapagipe","Itapecerica","Itapeva","Itatiaiuçu","Itaú de Minas","Itaúna","Itaverava","Itinga","Itueta","Ituiutaba","Itumirim","Iturama","Itutinga","Jaboticatubas","Jacinto","Jacuí","Jacutinga","Jaguaraçu","Jaíba","Jampruca","Janaúba","Januária","Japaraíba","Japonvar","Jeceaba","Jenipapo de Minas","Jequeri","Jequitaí","Jequitibá","Jequitinhonha","Jesuânia","Joaíma","Joanésia","João Monlevade","João Pinheiro","Joaquim Felício","Jordânia","José Gonçalves de Minas","José Raydan","Josenópolis","Juatuba","Juiz de Fora","Juramento","Juruaia","Juvenília","Ladainha","Lagamar","Lagoa da Prata","Lagoa dos Patos","Lagoa Dourada","Lagoa Formosa","Lagoa Grande","Lagoa Santa","Lajinha","Lambari","Lamim","Laranjal","Lassance","Lavras","Leandro Ferreira","Leme do Prado","Leopoldina","Liberdade","Lima Duarte","Limeira do Oeste","Lontra","Luisburgo","Luislândia","Luminárias","Luz","Machacalis","Machado","Madre de Deus de Minas","Malacacheta","Mamonas","Manga","Manhuaçu","Manhumirim","Mantena","Mar de Espanha","Maravilhas","Maria da Fé","Mariana","Marilac","Mário Campos","Maripá de Minas","Marliéria","Marmelópolis","Martinho Campos","Martins Soares","Mata Verde","Materlândia","Mateus Leme","Mathias Lobato","Matias Barbosa","Matias Cardoso","Matipó","Mato Verde","Matozinhos","Matutina","Medeiros","Medina","Mendes Pimentel","Mercês","Mesquita","Minas Novas","Minduri","Mirabela","Miradouro","Miraí","Miravânia","Moeda","Moema","Monjolos","Monsenhor Paulo","Montalvânia","Monte Alegre de Minas","Monte Azul","Monte Belo","Monte Carmelo","Monte Formoso","Monte Santo de Minas","Monte Sião","Montes Claros","Montezuma","Morada Nova de Minas","Morro da Garça","Morro do Pilar","Munhoz","Muriaé","Mutum","Muzambinho","Nacip Raydan","Nanuque","Naque","Natalândia","Natércia","Nazareno","Nepomuceno","Ninheira","Nova Belém","Nova Era","Nova Lima","Nova Módica","Nova Ponte","Nova Porteirinha","Nova Resende","Nova Serrana","Nova União","Novo Cruzeiro","Novo Oriente de Minas","Novorizonte","Olaria","Olhos-d'Água","Olímpio Noronha","Oliveira","Oliveira Fortes","Onça de Pitangui","Oratórios","Orizânia","Ouro Branco","Ouro Fino","Ouro Preto","Ouro Verde de Minas","Padre Carvalho","Padre Paraíso","Pai Pedro","Paineiras","Pains","Paiva","Palma","Palmópolis","Papagaios","Pará de Minas","Paracatu","Paraguaçu","Paraisópolis","Paraopeba","Passa Quatro","Passa Tempo","Passa-Vinte","Passabém","Passos","Patis","Patos de Minas","Patrocínio","Patrocínio do Muriaé","Paula Cândido","Paulistas","Pavão","Peçanha","Pedra Azul","Pedra Bonita","Pedra do Anta","Pedra do Indaiá","Pedra Dourada","Pedralva","Pedras de Maria da Cruz","Pedrinópolis","Pedro Leopoldo","Pedro Teixeira","Pequeri","Pequi","Perdigão","Perdizes","Perdões","Periquito","Pescador","Piau","Piedade de Caratinga","Piedade de Ponte Nova","Piedade do Rio Grande","Piedade dos Gerais","Pimenta","Pingo-d'Água","Pintópolis","Piracema","Pirajuba","Piranga","Piranguçu","Piranguinho","Pirapetinga","Pirapora","Piraúba","Pitangui","Piumhi","Planura","Poço Fundo","Poços de Caldas","Pocrane","Pompéu","Ponte Nova","Ponto Chique","Ponto dos Volantes","Porteirinha","Porto Firme","Poté","Pouso Alegre","Pouso Alto","Prados","Prata","Pratápolis","Pratinha","Presidente Bernardes","Presidente Juscelino","Presidente Kubitschek","Presidente Olegário","Prudente de Morais","Quartel Geral","Queluzito","Raposos","Raul Soares","Recreio","Reduto","Resende Costa","Resplendor","Ressaquinha","Riachinho","Riacho dos Machados","Ribeirão das Neves","Ribeirão Vermelho","Rio Acima","Rio Casca","Rio do Prado","Rio Doce","Rio Espera","Rio Manso","Rio Novo","Rio Paranaíba","Rio Pardo de Minas","Rio Piracicaba","Rio Pomba","Rio Preto","Rio Vermelho","Ritápolis","Rochedo de Minas","Rodeiro","Romaria","Rosário da Limeira","Rubelita","Rubim","Sabará","Sabinópolis","Sacramento","Salinas","Salto da Divisa","Santa Bárbara","Santa Bárbara do Leste","Santa Bárbara do Monte Verde","Santa Bárbara do Tugúrio","Santa Cruz de Minas","Santa Cruz de Salinas","Santa Cruz do Escalvado","Santa Efigênia de Minas","Santa Fé de Minas","Santa Helena de Minas","Santa Juliana","Santa Luzia","Santa Margarida","Santa Maria de Itabira","Santa Maria do Salto","Santa Maria do Suaçuí","Santa Rita de Caldas","Santa Rita de Ibitipoca","Santa Rita de Jacutinga","Santa Rita de Minas","Santa Rita do Itueto","Santa Rita do Sapucaí","Santa Rosa da Serra","Santa Vitória","Santana da Vargem","Santana de Cataguases","Santana de Pirapama","Santana do Deserto","Santana do Garambéu","Santana do Jacaré","Santana do Manhuaçu","Santana do Paraíso","Santana do Riacho","Santana dos Montes","Santo Antônio do Amparo","Santo Antônio do Aventureiro","Santo Antônio do Grama","Santo Antônio do Itambé","Santo Antônio do Jacinto","Santo Antônio do Monte","Santo Antônio do Retiro","Santo Antônio do Rio Abaixo","Santo Hipólito","Santos Dumont","São Bento Abade","São Brás do Suaçuí","São Domingos das Dores","São Domingos do Prata","São Félix de Minas","São Francisco","São Francisco de Paula","São Francisco de Sales","São Francisco do Glória","São Geraldo","São Geraldo da Piedade","São Geraldo do Baixio","São Gonçalo do Abaeté","São Gonçalo do Pará","São Gonçalo do Rio Abaixo","São Gonçalo do Rio Preto","São Gonçalo do Sapucaí","São Gotardo","São João Batista do Glória","São João da Lagoa","São João da Mata","São João da Ponte","São João das Missões","São João del Rei","São João do Manhuaçu","São João do Manteninha","São João do Oriente","São João do Pacuí","São João do Paraíso","São João Evangelista","São João Nepomuceno","São Joaquim de Bicas","São José da Barra","São José da Lapa","São José da Safira","São José da Varginha","São José do Alegre","São José do Divino","São José do Goiabal","São José do Jacuri","São José do Mantimento","São Lourenço","São Miguel do Anta","São Pedro da União","São Pedro do Suaçuí","São Pedro dos Ferros","São Romão","São Roque de Minas","São Sebastião da Bela Vista","São Sebastião da Vargem Alegre","São Sebastião do Anta","São Sebastião do Maranhão","São Sebastião do Oeste","São Sebastião do Paraíso","São Sebastião do Rio Preto","São Sebastião do Rio Verde","São Thomé das Letras","São Tiago","São Tomás de Aquino","São Vicente de Minas","Sapucaí-Mirim","Sardoá","Sarzedo","Sem-Peixe","Senador Amaral","Senador Cortes","Senador Firmino","Senador José Bento","Senador Modestino Gonçalves","Senhora de Oliveira","Senhora do Porto","Senhora dos Remédios","Sericita","Seritinga","Serra Azul de Minas","Serra da Saudade","Serra do Salitre","Serra dos Aimorés","Serrania","Serranópolis de Minas","Serranos","Serro","Sete Lagoas","Setubinha","Silveirânia","Silvianópolis","Simão Pereira","Simonésia","Sobrália","Soledade de Minas","Tabuleiro","Taiobeiras","Taparuba","Tapira","Tapiraí","Taquaraçu de Minas","Tarumirim","Teixeiras","Teófilo Otoni","Timóteo","Tiradentes","Tiros","Tocantins","Tocos do Moji","Toledo","Tombos","Três Corações","Três Marias","Três Pontas","Tumiritinga","Tupaciguara","Turmalina","Turvolândia","Ubá","Ubaí","Ubaporanga","Uberaba","Uberlândia","Umburatiba","Unaí","União de Minas","Uruana de Minas","Urucânia","Urucuia","Vargem Alegre","Vargem Bonita","Vargem Grande do Rio Pardo","Varginha","Varjão de Minas","Várzea da Palma","Varzelândia","Vazante","Verdelândia","Veredinha","Veríssimo","Vermelho Novo","Vespasiano","Viçosa","Vieiras","Virgem da Lapa","Virgínia","Virginópolis","Virgolândia","Visconde do Rio Branco","Volta Grande","Wenceslau Braz"]},"MS":{"name":"Mato Grosso do Sul","cities":["Água Clara","Alcinópolis","Amambaí","Anastácio","Anaurilândia","Angélica","Antônio João","Aparecida do Taboado","Aquidauana","Aral Moreira","Bandeirantes","Bataguassu","Bataiporã","Bela Vista","Bodoquena","Bonito","Brasilândia","Caarapó","Camapuã","Campo Grande","Caracol","Cassilândia","Chapadão do Sul","Corguinho","Coronel Sapucaia","Corumbá","Costa Rica","Coxim","Deodápolis","Dois Irmãos do Buriti","Douradina","Dourados","Eldorado","Fátima do Sul","Glória de Dourados","Guia Lopes da Laguna","Iguatemi","Inocência","Itaporã","Itaquiraí","Ivinhema","Japorã","Jaraguari","Jardim","Jateí","Juti","Ladário","Laguna Carapã","Maracaju","Miranda","Mundo Novo","Naviraí","Nioaque","Nova Alvorada do Sul","Nova Andradina","Novo Horizonte do Sul","Paranaíba","Paranhos","Pedro Gomes","Ponta Porã","Porto Murtinho","Ribas do Rio Pardo","Rio Brilhante","Rio Negro","Rio Verde de Mato Grosso","Rochedo","Santa Rita do Pardo","São Gabriel do Oeste","Selvíria","Sete Quedas","Sidrolândia","Sonora","Tacuru","Taquarussu","Terenos","Três Lagoas","Vicentina"]},"MT":{"name":"Mato Grosso","cities":["Acorizal","Água Boa","Alta Floresta","Alto Araguaia","Alto Boa Vista","Alto Garças","Alto Paraguai","Alto Taquari","Apiacás","Araguaiana","Araguainha","Araputanga","Arenápolis","Aripuanã","Barão de Melgaço","Barra do Bugres","Barra do Garças","Bom Jesus do Araguaia","Brasnorte","Cáceres","Campinápolis","Campo Novo do Parecis","Campo Verde","Campos de Júlio","Canabrava do Norte","Canarana","Carlinda","Castanheira","Chapada dos Guimarães","Cláudia","Cocalinho","Colíder","Colniza","Comodoro","Confresa","Conquista d'Oeste","Cotriguaçu","Curvelândia","Cuiabá","Denise","Diamantino","Dom Aquino","Feliz Natal","Figueirópolis d'Oeste","Gaúcha do Norte","General Carneiro","Glória d'Oeste","Guarantã do Norte","Guiratinga","Indiavaí","Itaúba","Itiquira","Jaciara","Jangada","Jauru","Juara","Juína","Juruena","Juscimeira","Lambari d'Oeste","Lucas do Rio Verde","Luciára","Marcelândia","Matupá","Mirassol d'Oeste","Nobres","Nortelândia","Nossa Senhora do Livramento","Nova Bandeirantes","Nova Brasilândia","Nova Canãa do Norte","Nova Guarita","Nova Lacerda","Nova Marilândia","Nova Maringá","Nova Monte Verde","Nova Mutum","Nova Nazaré","Nova Olímpia","Nova Santa Helena","Nova Ubiratã","Nova Xavantina","Novo Horizonte do Norte","Novo Mundo","Novo Santo Antônio","Novo São Joaquim","Paranaíta","Paranatinga","Pedra Preta","Peixoto de Azevedo","Planalto da Serra","Poconé","Pontal do Araguaia","Ponte Branca","Pontes e Lacerda","Porto Alegre do Norte","Porto dos Gaúchos","Porto Esperidião","Porto Estrela","Poxoréo","Primavera do Leste","Querência","Reserva do Cabaçal","Ribeirão Cascalheira","Ribeirãozinho","Rio Branco","Rondolândia","Rondonópolis","Rosário Oeste","Salto do Céu","Santa Carmem","Santa Cruz do Xingu","Santa Rita do Trivelato","Santa Terezinha","Santo Afonso","Santo Antônio do Leste","Santo Antônio do Leverger","São Félix do Araguaia","São José do Povo","São José do Rio Claro","São José do Xingu","São José dos Quatro Marcos","São Pedro da Cipa","Sapezal","Serra Nova Dourada","Sinop","Sorriso","Tabaporã","Tangará da Serra","Tapurah","Terra Nova do Norte","Tesouro","Torixoréu","União do Sul","Vale de São Domingos","Várzea Grande","Vera","Vila Bela da Santíssima Trindade","Vila Rica"]},"PA":{"name":"Pará","cities":["Abaetetuba","Abel Figueiredo","Acará","Afuá","Água Azul do Norte","Alenquer","Almeirim","Altamira","Anajás","Ananindeua","Anapu","Augusto Corrêa","Aurora do Pará","Aveiro","Bagre","Baião","Bannach","Barcarena","Belém","Belterra","Benevides","Bom Jesus do Tocantins","Bonito","Bragança","Brasil Novo","Brejo Grande do Araguaia","Breu Branco","Breves","Bujaru","Cachoeira do Arari","Cachoeira do Piriá","Cametá","Canaã dos Carajás","Capanema","Capitão Poço","Castanhal","Chaves","Colares","Conceição do Araguaia","Concórdia do Pará","Cumaru do Norte","Curionópolis","Curralinho","Curuá","Curuçá","Dom Eliseu","Eldorado dos Carajás","Faro","Floresta do Araguaia","Garrafão do Norte","Goianésia do Pará","Gurupá","Igarapé-Açu","Igarapé-Miri","Inhangapi","Ipixuna do Pará","Irituia","Itaituba","Itupiranga","Jacareacanga","Jacundá","Juruti","Limoeiro do Ajuru","Mãe do Rio","Magalhães Barata","Marabá","Maracanã","Marapanim","Marituba","Medicilândia","Melgaço","Mocajuba","Moju","Monte Alegre","Muaná","Nova Esperança do Piriá","Nova Ipixuna","Nova Timboteua","Novo Progresso","Novo Repartimento","Óbidos","Oeiras do Pará","Oriximiná","Ourém","Ourilândia do Norte","Pacajá","Palestina do Pará","Paragominas","Parauapebas","Pau d'Arco","Peixe-Boi","Piçarra","Placas","Ponta de Pedras","Portel","Porto de Moz","Prainha","Primavera","Quatipuru","Redenção","Rio Maria","Rondon do Pará","Rurópolis","Salinópolis","Salvaterra","Santa Bárbara do Pará","Santa Cruz do Arari","Santa Isabel do Pará","Santa Luzia do Pará","Santa Maria das Barreiras","Santa Maria do Pará","Santana do Araguaia","Santarém","Santarém Novo","Santo Antônio do Tauá","São Caetano de Odivela","São Domingos do Araguaia","São Domingos do Capim","São Félix do Xingu","São Francisco do Pará","São Geraldo do Araguaia","São João da Ponta","São João de Pirabas","São João do Araguaia","São Miguel do Guamá","São Sebastião da Boa Vista","Sapucaia","Senador José Porfírio","Soure","Tailândia","Terra Alta","Terra Santa","Tomé-Açu","Tracuateua","Trairão","Tucumã","Tucuruí","Ulianópolis","Uruará","Vigia","Viseu","Vitória do Xingu","Xinguara"]},"PB":{"name":"Paraíba","cities":["Água Branca","Aguiar","Alagoa Grande","Alagoa Nova","Alagoinha","Alcantil","Algodão de Jandaíra","Alhandra","Amparo","Aparecida","Araçagi","Arara","Araruna","Areia","Areia de Baraúnas","Areial","Aroeiras","Assunção","Baía da Traição","Bananeiras","Baraúna","Barra de Santa Rosa","Barra de Santana","Barra de São Miguel","Bayeux","Belém","Belém do Brejo do Cruz","Bernardino Batista","Boa Ventura","Boa Vista","Bom Jesus","Bom Sucesso","Bonito de Santa Fé","Boqueirão","Borborema","Brejo do Cruz","Brejo dos Santos","Caaporã","Cabaceiras","Cabedelo","Cachoeira dos Índios","Cacimba de Areia","Cacimba de Dentro","Cacimbas","Caiçara","Cajazeiras","Cajazeirinhas","Caldas Brandão","Camalaú","Campina Grande","Campo de Santana","Capim","Caraúbas","Carrapateira","Casserengue","Catingueira","Catolé do Rocha","Caturité","Conceição","Condado","Conde","Congo","Coremas","Coxixola","Cruz do Espírito Santo","Cubati","Cuité","Cuité de Mamanguape","Cuitegi","Curral de Cima","Curral Velho","Damião","Desterro","Diamante","Dona Inês","Duas Estradas","Emas","Esperança","Fagundes","Frei Martinho","Gado Bravo","Guarabira","Gurinhém","Gurjão","Ibiara","Igaracy","Imaculada","Ingá","Itabaiana","Itaporanga","Itapororoca","Itatuba","Jacaraú","Jericó","João Pessoa","Juarez Távora","Juazeirinho","Junco do Seridó","Juripiranga","Juru","Lagoa","Lagoa de Dentro","Lagoa Seca","Lastro","Livramento","Logradouro","Lucena","Mãe d'Água","Malta","Mamanguape","Manaíra","Marcação","Mari","Marizópolis","Massaranduba","Mataraca","Matinhas","Mato Grosso","Maturéia","Mogeiro","Montadas","Monte Horebe","Monteiro","Mulungu","Natuba","Nazarezinho","Nova Floresta","Nova Olinda","Nova Palmeira","Olho d'Água","Olivedos","Ouro Velho","Parari","Passagem","Patos","Paulista","Pedra Branca","Pedra Lavrada","Pedras de Fogo","Pedro Régis","Piancó","Picuí","Pilar","Pilões","Pilõezinhos","Pirpirituba","Pitimbu","Pocinhos","Poço Dantas","Poço de José de Moura","Pombal","Prata","Princesa Isabel","Puxinanã","Queimadas","Quixabá","Remígio","Riachão","Riachão do Bacamarte","Riachão do Poço","Riacho de Santo Antônio","Riacho dos Cavalos","Rio Tinto","Salgadinho","Salgado de São Félix","Santa Cecília","Santa Cruz","Santa Helena","Santa Inês","Santa Luzia","Santa Rita","Santa Teresinha","Santana de Mangueira","Santana dos Garrotes","Santarém","Santo André","São Bentinho","São Bento","São Domingos de Pombal","São Domingos do Cariri","São Francisco","São João do Cariri","São João do Rio do Peixe","São João do Tigre","São José da Lagoa Tapada","São José de Caiana","São José de Espinharas","São José de Piranhas","São José de Princesa","São José do Bonfim","São José do Brejo do Cruz","São José do Sabugi","São José dos Cordeiros","São José dos Ramos","São Mamede","São Miguel de Taipu","São Sebastião de Lagoa de Roça","São Sebastião do Umbuzeiro","Sapé","Seridó","Serra Branca","Serra da Raiz","Serra Grande","Serra Redonda","Serraria","Sertãozinho","Sobrado","Solânea","Soledade","Sossêgo","Sousa","Sumé","Taperoá","Tavares","Teixeira","Tenório","Triunfo","Uiraúna","Umbuzeiro","Várzea","Vieirópolis","Vista Serrana","Zabelê"]},"PE":{"name":"Pernambuco","cities":["Abreu e Lima","Afogados da Ingazeira","Afrânio","Agrestina","Água Preta","Águas Belas","Alagoinha","Aliança","Altinho","Amaraji","Angelim","Araçoiaba","Araripina","Arcoverde","Barra de Guabiraba","Barreiros","Belém de Maria","Belém de São Francisco","Belo Jardim","Betânia","Bezerros","Bodocó","Bom Conselho","Bom Jardim","Bonito","Brejão","Brejinho","Brejo da Madre de Deus","Buenos Aires","Buíque","Cabo de Santo Agostinho","Cabrobó","Cachoeirinha","Caetés","Calçado","Calumbi","Camaragibe","Camocim de São Félix","Camutanga","Canhotinho","Capoeiras","Carnaíba","Carnaubeira da Penha","Carpina","Caruaru","Casinhas","Catende","Cedro","Chã de Alegria","Chã Grande","Condado","Correntes","Cortês","Cumaru","Cupira","Custódia","Dormentes","Escada","Exu","Feira Nova","Fernando de Noronha","Ferreiros","Flores","Floresta","Frei Miguelinho","Gameleira","Garanhuns","Glória do Goitá","Goiana","Granito","Gravatá","Iati","Ibimirim","Ibirajuba","Igarassu","Iguaraci","Inajá","Ingazeira","Ipojuca","Ipubi","Itacuruba","Itaíba","Itamaracá","Itambé","Itapetim","Itapissuma","Itaquitinga","Jaboatão dos Guararapes","Jaqueira","Jataúba","Jatobá","João Alfredo","Joaquim Nabuco","Jucati","Jupi","Jurema","Lagoa do Carro","Lagoa do Itaenga","Lagoa do Ouro","Lagoa dos Gatos","Lagoa Grande","Lajedo","Limoeiro","Macaparana","Machados","Manari","Maraial","Mirandiba","Moreilândia","Moreno","Nazaré da Mata","Olinda","Orobó","Orocó","Ouricuri","Palmares","Palmeirina","Panelas","Paranatama","Parnamirim","Passira","Paudalho","Paulista","Pedra","Pesqueira","Petrolândia","Petrolina","Poção","Pombos","Primavera","Quipapá","Quixaba","Recife","Riacho das Almas","Ribeirão","Rio Formoso","Sairé","Salgadinho","Salgueiro","Saloá","Sanharó","Santa Cruz","Santa Cruz da Baixa Verde","Santa Cruz do Capibaribe","Santa Filomena","Santa Maria da Boa Vista","Santa Maria do Cambucá","Santa Terezinha","São Benedito do Sul","São Bento do Una","São Caitano","São João","São Joaquim do Monte","São José da Coroa Grande","São José do Belmonte","São José do Egito","São Lourenço da Mata","São Vicente Ferrer","Serra Talhada","Serrita","Sertânia","Sirinhaém","Solidão","Surubim","Tabira","Tacaimbó","Tacaratu","Tamandaré","Taquaritinga do Norte","Terezinha","Terra Nova","Timbaúba","Toritama","Tracunhaém","Trindade","Triunfo","Tupanatinga","Tuparetama","Venturosa","Verdejante","Vertente do Lério","Vertentes","Vicência","Vitória de Santo Antão","Xexéu"]},"PI":{"name":"Piauí","cities":["Acauã","Agricolândia","Água Branca","Alagoinha do Piauí","Alegrete do Piauí","Alto Longá","Altos","Alvorada do Gurguéia","Amarante","Angical do Piauí","Anísio de Abreu","Antônio Almeida","Aroazes","Arraial","Assunção do Piauí","Avelino Lopes","Baixa Grande do Ribeiro","Barra d'Alcântara","Barras","Barreiras do Piauí","Barro Duro","Batalha","Bela Vista do Piauí","Belém do Piauí","Beneditinos","Bertolínia","Betânia do Piauí","Boa Hora","Bocaina","Bom Jesus","Bom Princípio do Piauí","Bonfim do Piauí","Boqueirão do Piauí","Brasileira","Brejo do Piauí","Buriti dos Lopes","Buriti dos Montes","Cabeceiras do Piauí","Cajazeiras do Piauí","Cajueiro da Praia","Caldeirão Grande do Piauí","Campinas do Piauí","Campo Alegre do Fidalgo","Campo Grande do Piauí","Campo Largo do Piauí","Campo Maior","Canavieira","Canto do Buriti","Capitão de Campos","Capitão Gervásio Oliveira","Caracol","Caraúbas do Piauí","Caridade do Piauí","Castelo do Piauí","Caxingó","Cocal","Cocal de Telha","Cocal dos Alves","Coivaras","Colônia do Gurguéia","Colônia do Piauí","Conceição do Canindé","Coronel José Dias","Corrente","Cristalândia do Piauí","Cristino Castro","Curimatá","Currais","Curral Novo do Piauí","Curralinhos","Demerval Lobão","Dirceu Arcoverde","Dom Expedito Lopes","Dom Inocêncio","Domingos Mourão","Elesbão Veloso","Eliseu Martins","Esperantina","Fartura do Piauí","Flores do Piauí","Floresta do Piauí","Floriano","Francinópolis","Francisco Ayres","Francisco Macedo","Francisco Santos","Fronteiras","Geminiano","Gilbués","Guadalupe","Guaribas","Hugo Napoleão","Ilha Grande","Inhuma","Ipiranga do Piauí","Isaías Coelho","Itainópolis","Itaueira","Jacobina do Piauí","Jaicós","Jardim do Mulato","Jatobá do Piauí","Jerumenha","João Costa","Joaquim Pires","Joca Marques","José de Freitas","Juazeiro do Piauí","Júlio Borges","Jurema","Lagoa Alegre","Lagoa de São Francisco","Lagoa do Barro do Piauí","Lagoa do Piauí","Lagoa do Sítio","Lagoinha do Piauí","Landri Sales","Luís Correia","Luzilândia","Madeiro","Manoel Emídio","Marcolândia","Marcos Parente","Massapê do Piauí","Matias Olímpio","Miguel Alves","Miguel Leão","Milton Brandão","Monsenhor Gil","Monsenhor Hipólito","Monte Alegre do Piauí","Morro Cabeça no Tempo","Morro do Chapéu do Piauí","Murici dos Portelas","Nazaré do Piauí","Nossa Senhora de Nazaré","Nossa Senhora dos Remédios","Nova Santa Rita","Novo Oriente do Piauí","Novo Santo Antônio","Oeiras","Olho d'Água do Piauí","Padre Marcos","Paes Landim","Pajeú do Piauí","Palmeira do Piauí","Palmeirais","Paquetá","Parnaguá","Parnaíba","Passagem Franca do Piauí","Patos do Piauí","Pau d'Arco do Piauí","Paulistana","Pavussu","Pedro II","Pedro Laurentino","Picos","Pimenteiras","Pio IX","Piracuruca","Piripiri","Porto","Porto Alegre do Piauí","Prata do Piauí","Queimada Nova","Redenção do Gurguéia","Regeneração","Riacho Frio","Ribeira do Piauí","Ribeiro Gonçalves","Rio Grande do Piauí","Santa Cruz do Piauí","Santa Cruz dos Milagres","Santa Filomena","Santa Luz","Santa Rosa do Piauí","Santana do Piauí","Santo Antônio de Lisboa","Santo Antônio dos Milagres","Santo Inácio do Piauí","São Braz do Piauí","São Félix do Piauí","São Francisco de Assis do Piauí","São Francisco do Piauí","São Gonçalo do Gurguéia","São Gonçalo do Piauí","São João da Canabrava","São João da Fronteira","São João da Serra","São João da Varjota","São João do Arraial","São João do Piauí","São José do Divino","São José do Peixe","São José do Piauí","São Julião","São Lourenço do Piauí","São Luis do Piauí","São Miguel da Baixa Grande","São Miguel do Fidalgo","São Miguel do Tapuio","São Pedro do Piauí","São Raimundo Nonato","Sebastião Barros","Sebastião Leal","Sigefredo Pacheco","Simões","Simplício Mendes","Socorro do Piauí","Sussuapara","Tamboril do Piauí","Tanque do Piauí","Teresina","União","Uruçuí","Valença do Piauí","Várzea Branca","Várzea Grande","Vera Mendes","Vila Nova do Piauí","Wall Ferraz"]},"PR":{"name":"Paraná","cities":["Abatiá","Adrianópolis","Agudos do Sul","Almirante Tamandaré","Altamira do Paraná","Alto Paraná","Alto Piquiri","Altônia","Alvorada do Sul","Amaporã","Ampére","Anahy","Andirá","Ângulo","Antonina","Antônio Olinto","Apucarana","Arapongas","Arapoti","Arapuã","Araruna","Araucária","Ariranha do Ivaí","Assaí","Assis Chateaubriand","Astorga","Atalaia","Balsa Nova","Bandeirantes","Barbosa Ferraz","Barra do Jacaré","Barracão","Bela Vista da Caroba","Bela Vista do Paraíso","Bituruna","Boa Esperança","Boa Esperança do Iguaçu","Boa Ventura de São Roque","Boa Vista da Aparecida","Bocaiúva do Sul","Bom Jesus do Sul","Bom Sucesso","Bom Sucesso do Sul","Borrazópolis","Braganey","Brasilândia do Sul","Cafeara","Cafelândia","Cafezal do Sul","Califórnia","Cambará","Cambé","Cambira","Campina da Lagoa","Campina do Simão","Campina Grande do Sul","Campo Bonito","Campo do Tenente","Campo Largo","Campo Magro","Campo Mourão","Cândido de Abreu","Candói","Cantagalo","Capanema","Capitão Leônidas Marques","Carambeí","Carlópolis","Cascavel","Castro","Catanduvas","Centenário do Sul","Cerro Azul","Céu Azul","Chopinzinho","Cianorte","Cidade Gaúcha","Clevelândia","Colombo","Colorado","Congonhinhas","Conselheiro Mairinck","Contenda","Corbélia","Cornélio Procópio","Coronel Domingos Soares","Coronel Vivida","Corumbataí do Sul","Cruz Machado","Cruzeiro do Iguaçu","Cruzeiro do Oeste","Cruzeiro do Sul","Cruzmaltina","Curitiba","Curiúva","Diamante d'Oeste","Diamante do Norte","Diamante do Sul","Dois Vizinhos","Douradina","Doutor Camargo","Doutor Ulysses","Enéas Marques","Engenheiro Beltrão","Entre Rios do Oeste","Esperança Nova","Espigão Alto do Iguaçu","Farol","Faxinal","Fazenda Rio Grande","Fênix","Fernandes Pinheiro","Figueira","Flor da Serra do Sul","Floraí","Floresta","Florestópolis","Flórida","Formosa do Oeste","Foz do Iguaçu","Foz do Jordão","Francisco Alves","Francisco Beltrão","General Carneiro","Godoy Moreira","Goioerê","Goioxim","Grandes Rios","Guaíra","Guairaçá","Guamiranga","Guapirama","Guaporema","Guaraci","Guaraniaçu","Guarapuava","Guaraqueçaba","Guaratuba","Honório Serpa","Ibaiti","Ibema","Ibiporã","Icaraíma","Iguaraçu","Iguatu","Imbaú","Imbituva","Inácio Martins","Inajá","Indianópolis","Ipiranga","Iporã","Iracema do Oeste","Irati","Iretama","Itaguajé","Itaipulândia","Itambaracá","Itambé","Itapejara d'Oeste","Itaperuçu","Itaúna do Sul","Ivaí","Ivaiporã","Ivaté","Ivatuba","Jaboti","Jacarezinho","Jaguapitã","Jaguariaíva","Jandaia do Sul","Janiópolis","Japira","Japurá","Jardim Alegre","Jardim Olinda","Jataizinho","Jesuítas","Joaquim Távora","Jundiaí do Sul","Juranda","Jussara","Kaloré","Lapa","Laranjal","Laranjeiras do Sul","Leópolis","Lidianópolis","Lindoeste","Loanda","Lobato","Londrina","Luiziana","Lunardelli","Lupionópolis","Mallet","Mamborê","Mandaguaçu","Mandaguari","Mandirituba","Manfrinópolis","Mangueirinha","Manoel Ribas","Marechal Cândido Rondon","Maria Helena","Marialva","Marilândia do Sul","Marilena","Mariluz","Maringá","Mariópolis","Maripá","Marmeleiro","Marquinho","Marumbi","Matelândia","Matinhos","Mato Rico","Mauá da Serra","Medianeira","Mercedes","Mirador","Miraselva","Missal","Moreira Sales","Morretes","Munhoz de Melo","Nossa Senhora das Graças","Nova Aliança do Ivaí","Nova América da Colina","Nova Aurora","Nova Cantu","Nova Esperança","Nova Esperança do Sudoeste","Nova Fátima","Nova Laranjeiras","Nova Londrina","Nova Olímpia","Nova Prata do Iguaçu","Nova Santa Bárbara","Nova Santa Rosa","Nova Tebas","Novo Itacolomi","Ortigueira","Ourizona","Ouro Verde do Oeste","Paiçandu","Palmas","Palmeira","Palmital","Palotina","Paraíso do Norte","Paranacity","Paranaguá","Paranapoema","Paranavaí","Pato Bragado","Pato Branco","Paula Freitas","Paulo Frontin","Peabiru","Perobal","Pérola","Pérola d'Oeste","Piên","Pinhais","Pinhal de São Bento","Pinhalão","Pinhão","Piraí do Sul","Piraquara","Pitanga","Pitangueiras","Planaltina do Paraná","Planalto","Ponta Grossa","Pontal do Paraná","Porecatu","Porto Amazonas","Porto Barreiro","Porto Rico","Porto Vitória","Prado Ferreira","Pranchita","Presidente Castelo Branco","Primeiro de Maio","Prudentópolis","Quarto Centenário","Quatiguá","Quatro Barras","Quatro Pontes","Quedas do Iguaçu","Querência do Norte","Quinta do Sol","Quitandinha","Ramilândia","Rancho Alegre","Rancho Alegre d'Oeste","Realeza","Rebouças","Renascença","Reserva","Reserva do Iguaçu","Ribeirão Claro","Ribeirão do Pinhal","Rio Azul","Rio Bom","Rio Bonito do Iguaçu","Rio Branco do Ivaí","Rio Branco do Sul","Rio Negro","Rolândia","Roncador","Rondon","Rosário do Ivaí","Sabáudia","Salgado Filho","Salto do Itararé","Salto do Lontra","Santa Amélia","Santa Cecília do Pavão","Santa Cruz Monte Castelo","Santa Fé","Santa Helena","Santa Inês","Santa Isabel do Ivaí","Santa Izabel do Oeste","Santa Lúcia","Santa Maria do Oeste","Santa Mariana","Santa Mônica","Santa Tereza do Oeste","Santa Terezinha de Itaipu","Santana do Itararé","Santo Antônio da Platina","Santo Antônio do Caiuá","Santo Antônio do Paraíso","Santo Antônio do Sudoeste","Santo Inácio","São Carlos do Ivaí","São Jerônimo da Serra","São João","São João do Caiuá","São João do Ivaí","São João do Triunfo","São Jorge d'Oeste","São Jorge do Ivaí","São Jorge do Patrocínio","São José da Boa Vista","São José das Palmeiras","São José dos Pinhais","São Manoel do Paraná","São Mateus do Sul","São Miguel do Iguaçu","São Pedro do Iguaçu","São Pedro do Ivaí","São Pedro do Paraná","São Sebastião da Amoreira","São Tomé","Sapopema","Sarandi","Saudade do Iguaçu","Sengés","Serranópolis do Iguaçu","Sertaneja","Sertanópolis","Siqueira Campos","Sulina","Tamarana","Tamboara","Tapejara","Tapira","Teixeira Soares","Telêmaco Borba","Terra Boa","Terra Rica","Terra Roxa","Tibagi","Tijucas do Sul","Toledo","Tomazina","Três Barras do Paraná","Tunas do Paraná","Tuneiras do Oeste","Tupãssi","Turvo","Ubiratã","Umuarama","União da Vitória","Uniflor","Uraí","Ventania","Vera Cruz do Oeste","Verê","Vila Alta","Virmond","Vitorino","Wenceslau Braz","Xambrê"]},"RJ":{"name":"Rio de Janeiro","cities":["Angra dos Reis","Aperibé","Araruama","Areal","Armação de Búzios","Arraial do Cabo","Barra do Piraí","Barra Mansa","Belford Roxo","Bom Jardim","Bom Jesus do Itabapoana","Cabo Frio","Cachoeiras de Macacu","Cambuci","Campos dos Goytacazes","Cantagalo","Carapebus","Cardoso Moreira","Carmo","Casimiro de Abreu","Comendador Levy Gasparian","Conceição de Macabu","Cordeiro","Duas Barras","Duque de Caxias","Engenheiro Paulo de Frontin","Guapimirim","Iguaba Grande","Itaboraí","Itaguaí","Italva","Itaocara","Itaperuna","Itatiaia","Japeri","Laje do Muriaé","Macaé","Macuco","Magé","Mangaratiba","Maricá","Mendes","Mesquita","Miguel Pereira","Miracema","Natividade","Nilópolis","Niterói","Nova Friburgo","Nova Iguaçu","Paracambi","Paraíba do Sul","Parati","Paty do Alferes","Petrópolis","Pinheiral","Piraí","Porciúncula","Porto Real","Quatis","Queimados","Quissamã","Resende","Rio Bonito","Rio Claro","Rio das Flores","Rio das Ostras","Rio de Janeiro","Santa Maria Madalena","Santo Antônio de Pádua","São Fidélis","São Francisco de Itabapoana","São Gonçalo","São João da Barra","São João de Meriti","São José de Ubá","São José do Vale do Rio Preto","São Pedro da Aldeia","São Sebastião do Alto","Sapucaia","Saquarema","Seropédica","Silva Jardim","Sumidouro","Tanguá","Teresópolis","Trajano de Morais","Três Rios","Valença","Varre-Sai","Vassouras","Volta Redonda"]},"RN":{"name":"Rio Grande do Norte","cities":["Acari","Açu","Afonso Bezerra","Água Nova","Alexandria","Almino Afonso","Alto do Rodrigues","Angicos","Antônio Martins","Apodi","Areia Branca","Arês","Augusto Severo","Baía Formosa","Baraúna","Barcelona","Bento Fernandes","Bodó","Bom Jesus","Brejinho","Caiçara do Norte","Caiçara do Rio do Vento","Caicó","Campo Redondo","Canguaretama","Caraúbas","Carnaúba dos Dantas","Carnaubais","Ceará-Mirim","Cerro Corá","Coronel Ezequiel","Coronel João Pessoa","Cruzeta","Currais Novos","Doutor Severiano","Encanto","Equador","Espírito Santo","Extremoz","Felipe Guerra","Fernando Pedroza","Florânia","Francisco Dantas","Frutuoso Gomes","Galinhos","Goianinha","Governador Dix-Sept Rosado","Grossos","Guamaré","Ielmo Marinho","Ipanguaçu","Ipueira","Itajá","Itaú","Jaçanã","Jandaíra","Janduís","Januário Cicco","Japi","Jardim de Angicos","Jardim de Piranhas","Jardim do Seridó","João Câmara","João Dias","José da Penha","Jucurutu","Jundiá","Lagoa d'Anta","Lagoa de Pedras","Lagoa de Velhos","Lagoa Nova","Lagoa Salgada","Lajes","Lajes Pintadas","Lucrécia","Luís Gomes","Macaíba","Macau","Major Sales","Marcelino Vieira","Martins","Maxaranguape","Messias Targino","Montanhas","Monte Alegre","Monte das Gameleiras","Mossoró","Natal","Nísia Floresta","Nova Cruz","Olho-d'Água do Borges","Ouro Branco","Paraná","Paraú","Parazinho","Parelhas","Parnamirim","Passa e Fica","Passagem","Patu","Pau dos Ferros","Pedra Grande","Pedra Preta","Pedro Avelino","Pedro Velho","Pendências","Pilões","Poço Branco","Portalegre","Porto do Mangue","Presidente Juscelino","Pureza","Rafael Fernandes","Rafael Godeiro","Riacho da Cruz","Riacho de Santana","Riachuelo","Rio do Fogo","Rodolfo Fernandes","Ruy Barbosa","Santa Cruz","Santa Maria","Santana do Matos","Santana do Seridó","Santo Antônio","São Bento do Norte","São Bento do Trairí","São Fernando","São Francisco do Oeste","São Gonçalo do Amarante","São João do Sabugi","São José de Mipibu","São José do Campestre","São José do Seridó","São Miguel","São Miguel de Touros","São Paulo do Potengi","São Pedro","São Rafael","São Tomé","São Vicente","Senador Elói de Souza","Senador Georgino Avelino","Serra de São Bento","Serra do Mel","Serra Negra do Norte","Serrinha","Serrinha dos Pintos","Severiano Melo","Sítio Novo","Taboleiro Grande","Taipu","Tangará","Tenente Ananias","Tenente Laurentino Cruz","Tibau","Tibau do Sul","Timbaúba dos Batistas","Touros","Triunfo Potiguar","Umarizal","Upanema","Várzea","Venha-Ver","Vera Cruz","Viçosa","Vila Flor"]},"RO":{"name":"Rondônia","cities":["Alta Floresta d'Oeste","Alto Alegre do Parecis","Alto Paraíso","Alvorada d'Oeste","Ariquemes","Buritis","Cabixi","Cacaulândia","Cacoal","Campo Novo de Rondônia","Candeias do Jamari","Castanheiras","Cerejeiras","Chupinguaia","Colorado do Oeste","Corumbiara","Costa Marques","Cujubim","Espigão d'Oeste","Governador Jorge Teixeira","Guajará-Mirim","Itapuã do Oeste","Jaru","Ji-Paraná","Machadinho d'Oeste","Ministro Andreazza","Mirante da Serra","Monte Negro","Nova Brasilândia d'Oeste","Nova Mamoré","Nova União","Novo Horizonte do Oeste","Ouro Preto do Oeste","Parecis","Pimenta Bueno","Pimenteiras do Oeste","Porto Velho","Presidente Médici","Primavera de Rondônia","Rio Crespo","Rolim de Moura","Santa Luzia d'Oeste","São Felipe d'Oeste","São Francisco do Guaporé","São Miguel do Guaporé","Seringueiras","Teixeirópolis","Theobroma","Urupá","Vale do Anari","Vale do Paraíso","Vilhena"]},"RR":{"name":"Roraima","cities":["Alto Alegre","Amajari","Boa Vista","Bonfim","Cantá","Caracaraí","Caroebe","Iracema","Mucajaí","Normandia","Pacaraima","Rorainópolis","São João da Baliza","São Luiz","Uiramutã"]},"RS":{"name":"Rio Grande do Sul","cities":["Aceguá","Água Santa","Agudo","Ajuricaba","Alecrim","Alegrete","Alegria","Almirante Tamandaré do Sul","Alpestre","Alto Alegre","Alto Feliz","Alvorada","Amaral Ferrador","Ametista do Sul","André da Rocha","Anta Gorda","Antônio Prado","Arambaré","Araricá","Aratiba","Arroio do Meio","Arroio do Padre","Arroio do Sal","Arroio do Tigre","Arroio dos Ratos","Arroio Grande","Arvorezinha","Augusto Pestana","Áurea","Bagé","Balneário Pinhal","Barão","Barão de Cotegipe","Barão do Triunfo","Barra do Guarita","Barra do Quaraí","Barra do Ribeiro","Barra do Rio Azul","Barra Funda","Barracão","Barros Cassal","Benjamin Constan do Sul","Bento Gonçalves","Boa Vista das Missões","Boa Vista do Buricá","Boa Vista do Cadeado","Boa Vista do Incra","Boa Vista do Sul","Bom Jesus","Bom Princípio","Bom Progresso","Bom Retiro do Sul","Boqueirão do Leão","Bossoroca","Bozano","Braga","Brochier","Butiá","Caçapava do Sul","Cacequi","Cachoeira do Sul","Cachoeirinha","Cacique Doble","Caibaté","Caiçara","Camaquã","Camargo","Cambará do Sul","Campestre da Serra","Campina das Missões","Campinas do Sul","Campo Bom","Campo Novo","Campos Borges","Candelária","Cândido Godói","Candiota","Canela","Canguçu","Canoas","Canudos do Vale","Capão Bonito do Sul","Capão da Canoa","Capão do Cipó","Capão do Leão","Capela de Santana","Capitão","Capivari do Sul","Caraá","Carazinho","Carlos Barbosa","Carlos Gomes","Casca","Caseiros","Catuípe","Caxias do Sul","Centenário","Cerrito","Cerro Branco","Cerro Grande","Cerro Grande do Sul","Cerro Largo","Chapada","Charqueadas","Charrua","Chiapeta","Chuí","Chuvisca","Cidreira","Ciríaco","Colinas","Colorado","Condor","Constantina","Coqueiro Baixo","Coqueiros do Sul","Coronel Barros","Coronel Bicaco","Coronel Pilar","Cotiporã","Coxilha","Crissiumal","Cristal","Cristal do Sul","Cruz Alta","Cruzaltense","Cruzeiro do Sul","David Canabarro","Derrubadas","Dezesseis de Novembro","Dilermando de Aguiar","Dois Irmãos","Dois Irmãos das Missões","Dois Lajeados","Dom Feliciano","Dom Pedrito","Dom Pedro de Alcântara","Dona Francisca","Doutor Maurício Cardoso","Doutor Ricardo","Eldorado do Sul","Encantado","Encruzilhada do Sul","Engenho Velho","Entre Rios do Sul","Entre-Ijuís","Erebango","Erechim","Ernestina","Erval Grande","Erval Seco","Esmeralda","Esperança do Sul","Espumoso","Estação","Estância Velha","Esteio","Estrela","Estrela Velha","Eugênio de Castro","Fagundes Varela","Farroupilha","Faxinal do Soturno","Faxinalzinho","Fazenda Vilanova","Feliz","Flores da Cunha","Floriano Peixoto","Fontoura Xavier","Formigueiro","Forquetinha","Fortaleza dos Valos","Frederico Westphalen","Garibaldi","Garruchos","Gaurama","General Câmara","Gentil","Getúlio Vargas","Giruá","Glorinha","Gramado","Gramado dos Loureiros","Gramado Xavier","Gravataí","Guabiju","Guaíba","Guaporé","Guarani das Missões","Harmonia","Herval","Herveiras","Horizontina","Hulha Negra","Humaitá","Ibarama","Ibiaçá","Ibiraiaras","Ibirapuitã","Ibirubá","Igrejinha","Ijuí","Ilópolis","Imbé","Imigrante","Independência","Inhacorá","Ipê","Ipiranga do Sul","Iraí","Itaara","Itacurubi","Itapuca","Itaqui","Itati","Itatiba do Sul","Ivorá","Ivoti","Jaboticaba","Jacuizinho","Jacutinga","Jaguarão","Jaguari","Jaquirana","Jari","Jóia","Júlio de Castilhos","Lagoa Bonita do Sul","Lagoa dos Três Cantos","Lagoa Vermelha","Lagoão","Lajeado","Lajeado do Bugre","Lavras do Sul","Liberato Salzano","Lindolfo Collor","Linha Nova","Maçambara","Machadinho","Mampituba","Manoel Viana","Maquiné","Maratá","Marau","Marcelino Ramos","Mariana Pimentel","Mariano Moro","Marques de Souza","Mata","Mato Castelhano","Mato Leitão","Mato Queimado","Maximiliano de Almeida","Minas do Leão","Miraguaí","Montauri","Monte Alegre dos Campos","Monte Belo do Sul","Montenegro","Mormaço","Morrinhos do Sul","Morro Redondo","Morro Reuter","Mostardas","Muçum","Muitos Capões","Muliterno","Não-Me-Toque","Nicolau Vergueiro","Nonoai","Nova Alvorada","Nova Araçá","Nova Bassano","Nova Boa Vista","Nova Bréscia","Nova Candelária","Nova Esperança do Sul","Nova Hartz","Nova Pádua","Nova Palma","Nova Petrópolis","Nova Prata","Nova Ramada","Nova Roma do Sul","Nova Santa Rita","Novo Barreiro","Novo Cabrais","Novo Hamburgo","Novo Machado","Novo Tiradentes","Novo Xingu","Osório","Paim Filho","Palmares do Sul","Palmeira das Missões","Palmitinho","Panambi","Pântano Grande","Paraí","Paraíso do Sul","Pareci Novo","Parobé","Passa Sete","Passo do Sobrado","Passo Fundo","Paulo Bento","Paverama","Pedras Altas","Pedro Osório","Pejuçara","Pelotas","Picada Café","Pinhal","Pinhal da Serra","Pinhal Grande","Pinheirinho do Vale","Pinheiro Machado","Pirapó","Piratini","Planalto","Poço das Antas","Pontão","Ponte Preta","Portão","Porto Alegre","Porto Lucena","Porto Mauá","Porto Vera Cruz","Porto Xavier","Pouso Novo","Presidente Lucena","Progresso","Protásio Alves","Putinga","Quaraí","Quatro Irmãos","Quevedos","Quinze de Novembro","Redentora","Relvado","Restinga Seca","Rio dos Índios","Rio Grande","Rio Pardo","Riozinho","Roca Sales","Rodeio Bonito","Rolador","Rolante","Ronda Alta","Rondinha","Roque Gonzales","Rosário do Sul","Sagrada Família","Saldanha Marinho","Salto do Jacuí","Salvador das Missões","Salvador do Sul","Sananduva","Santa Bárbara do Sul","Santa Cecília do Sul","Santa Clara do Sul","Santa Cruz do Sul","Santa Margarida do Sul","Santa Maria","Santa Maria do Herval","Santa Rosa","Santa Tereza","Santa Vitória do Palmar","Santana da Boa Vista","Santana do Livramento","Santiago","Santo Ângelo","Santo Antônio da Patrulha","Santo Antônio das Missões","Santo Antônio do Palma","Santo Antônio do Planalto","Santo Augusto","Santo Cristo","Santo Expedito do Sul","São Borja","São Domingos do Sul","São Francisco de Assis","São Francisco de Paula","São Gabriel","São Jerônimo","São João da Urtiga","São João do Polêsine","São Jorge","São José das Missões","São José do Herval","São José do Hortêncio","São José do Inhacorá","São José do Norte","São José do Ouro","São José do Sul","São José dos Ausentes","São Leopoldo","São Lourenço do Sul","São Luiz Gonzaga","São Marcos","São Martinho","São Martinho da Serra","São Miguel das Missões","São Nicolau","São Paulo das Missões","São Pedro da Serra","São Pedro das Missões","São Pedro do Butiá","São Pedro do Sul","São Sebastião do Caí","São Sepé","São Valentim","São Valentim do Sul","São Valério do Sul","São Vendelino","São Vicente do Sul","Sapiranga","Sapucaia do Sul","Sarandi","Seberi","Sede Nova","Segredo","Selbach","Senador Salgado Filho","Sentinela do Sul","Serafina Corrêa","Sério","Sertão","Sertão Santana","Sete de Setembro","Severiano de Almeida","Silveira Martins","Sinimbu","Sobradinho","Soledade","Tabaí","Tapejara","Tapera","Tapes","Taquara","Taquari","Taquaruçu do Sul","Tavares","Tenente Portela","Terra de Areia","Teutônia","Tio Hugo","Tiradentes do Sul","Toropi","Torres","Tramandaí","Travesseiro","Três Arroios","Três Cachoeiras","Três Coroas","Três de Maio","Três Forquilhas","Três Palmeiras","Três Passos","Trindade do Sul","Triunfo","Tucunduva","Tunas","Tupanci do Sul","Tupanciretã","Tupandi","Tuparendi","Turuçu","Ubiretama","União da Serra","Unistalda","Uruguaiana","Vacaria","Vale do Sol","Vale Real","Vale Verde","Vanini","Venâncio Aires","Vera Cruz","Veranópolis","Vespasiano Correa","Viadutos","Viamão","Vicente Dutra","Victor Graeff","Vila Flores","Vila Lângaro","Vila Maria","Vila Nova do Sul","Vista Alegre","Vista Alegre do Prata","Vista Gaúcha","Vitória das Missões","Westfália","Xangri-lá"]},"SC":{"name":"Santa Catarina","cities":["Abdon Batista","Abelardo Luz","Agrolândia","Agronômica","Água Doce","Águas de Chapecó","Águas Frias","Águas Mornas","Alfredo Wagner","Alto Bela Vista","Anchieta","Angelina","Anita Garibaldi","Anitápolis","Antônio Carlos","Apiúna","Arabutã","Araquari","Araranguá","Armazém","Arroio Trinta","Arvoredo","Ascurra","Atalanta","Aurora","Balneário Arroio do Silva","Balneário Barra do Sul","Balneário Camboriú","Balneário Gaivota","Bandeirante","Barra Bonita","Barra Velha","Bela Vista do Toldo","Belmonte","Benedito Novo","Biguaçu","Blumenau","Bocaina do Sul","Bom Jardim da Serra","Bom Jesus","Bom Jesus do Oeste","Bom Retiro","Bombinhas","Botuverá","Braço do Norte","Braço do Trombudo","Brunópolis","Brusque","Caçador","Caibi","Calmon","Camboriú","Campo Alegre","Campo Belo do Sul","Campo Erê","Campos Novos","Canelinha","Canoinhas","Capão Alto","Capinzal","Capivari de Baixo","Catanduvas","Caxambu do Sul","Celso Ramos","Cerro Negro","Chapadão do Lageado","Chapecó","Cocal do Sul","Concórdia","Cordilheira Alta","Coronel Freitas","Coronel Martins","Correia Pinto","Corupá","Criciúma","Cunha Porã","Cunhataí","Curitibanos","Descanso","Dionísio Cerqueira","Dona Emma","Doutor Pedrinho","Entre Rios","Ermo","Erval Velho","Faxinal dos Guedes","Flor do Sertão","Florianópolis","Formosa do Sul","Forquilhinha","Fraiburgo","Frei Rogério","Galvão","Garopaba","Garuva","Gaspar","Governador Celso Ramos","Grão Pará","Gravatal","Guabiruba","Guaraciaba","Guaramirim","Guarujá do Sul","Guatambú","Herval d'Oeste","Ibiam","Ibicaré","Ibirama","Içara","Ilhota","Imaruí","Imbituba","Imbuia","Indaial","Iomerê","Ipira","Iporã do Oeste","Ipuaçu","Ipumirim","Iraceminha","Irani","Irati","Irineópolis","Itá","Itaiópolis","Itajaí","Itapema","Itapiranga","Itapoá","Ituporanga","Jaborá","Jacinto Machado","Jaguaruna","Jaraguá do Sul","Jardinópolis","Joaçaba","Joinville","José Boiteux","Jupiá","Lacerdópolis","Lages","Laguna","Lajeado Grande","Laurentino","Lauro Muller","Lebon Régis","Leoberto Leal","Lindóia do Sul","Lontras","Luiz Alves","Luzerna","Macieira","Mafra","Major Gercino","Major Vieira","Maracajá","Maravilha","Marema","Massaranduba","Matos Costa","Meleiro","Mirim Doce","Modelo","Mondaí","Monte Carlo","Monte Castelo","Morro da Fumaça","Morro Grande","Navegantes","Nova Erechim","Nova Itaberaba","Nova Trento","Nova Veneza","Novo Horizonte","Orleans","Otacílio Costa","Ouro","Ouro Verde","Paial","Painel","Palhoça","Palma Sola","Palmeira","Palmitos","Papanduva","Paraíso","Passo de Torres","Passos Maia","Paulo Lopes","Pedras Grandes","Penha","Peritiba","Petrolândia","Piçarras","Pinhalzinho","Pinheiro Preto","Piratuba","Planalto Alegre","Pomerode","Ponte Alta","Ponte Alta do Norte","Ponte Serrada","Porto Belo","Porto União","Pouso Redondo","Praia Grande","Presidente Castelo Branco","Presidente Getúlio","Presidente Nereu","Princesa","Quilombo","Rancho Queimado","Rio das Antas","Rio do Campo","Rio do Oeste","Rio do Sul","Rio dos Cedros","Rio Fortuna","Rio Negrinho","Rio Rufino","Riqueza","Rodeio","Romelândia","Salete","Saltinho","Salto Veloso","Sangão","Santa Cecília","Santa Helena","Santa Rosa de Lima","Santa Rosa do Sul","Santa Terezinha","Santa Terezinha do Progresso","Santiago do Sul","Santo Amaro da Imperatriz","São Bento do Sul","São Bernardino","São Bonifácio","São Carlos","São Cristovão do Sul","São Domingos","São Francisco do Sul","São João Batista","São João do Itaperiú","São João do Oeste","São João do Sul","São Joaquim","São José","São José do Cedro","São José do Cerrito","São Lourenço do Oeste","São Ludgero","São Martinho","São Miguel da Boa Vista","São Miguel do Oeste","São Pedro de Alcântara","Saudades","Schroeder","Seara","Serra Alta","Siderópolis","Sombrio","Sul Brasil","Taió","Tangará","Tigrinhos","Tijucas","Timbé do Sul","Timbó","Timbó Grande","Três Barras","Treviso","Treze de Maio","Treze Tílias","Trombudo Central","Tubarão","Tunápolis","Turvo","União do Oeste","Urubici","Urupema","Urussanga","Vargeão","Vargem","Vargem Bonita","Vidal Ramos","Videira","Vitor Meireles","Witmarsum","Xanxerê","Xavantina","Xaxim","Zortéa"]},"SE":{"name":"Sergipe","cities":["Amparo de São Francisco","Aquidabã","Aracaju","Arauá","Areia Branca","Barra dos Coqueiros","Boquim","Brejo Grande","Campo do Brito","Canhoba","Canindé de São Francisco","Capela","Carira","Carmópolis","Cedro de São João","Cristinápolis","Cumbe","Divina Pastora","Estância","Feira Nova","Frei Paulo","Gararu","General Maynard","Gracho Cardoso","Ilha das Flores","Indiaroba","Itabaiana","Itabaianinha","Itabi","Itaporanga d'Ajuda","Japaratuba","Japoatã","Lagarto","Laranjeiras","Macambira","Malhada dos Bois","Malhador","Maruim","Moita Bonita","Monte Alegre de Sergipe","Muribeca","Neópolis","Nossa Senhora Aparecida","Nossa Senhora da Glória","Nossa Senhora das Dores","Nossa Senhora de Lourdes","Nossa Senhora do Socorro","Pacatuba","Pedra Mole","Pedrinhas","Pinhão","Pirambu","Poço Redondo","Poço Verde","Porto da Folha","Propriá","Riachão do Dantas","Riachuelo","Ribeirópolis","Rosário do Catete","Salgado","Santa Luzia do Itanhy","Santa Rosa de Lima","Santana do São Francisco","Santo Amaro das Brotas","São Cristóvão","São Domingos","São Francisco","São Miguel do Aleixo","Simão Dias","Siriri","Telha","Tobias Barreto","Tomar do Geru","Umbaúba"]},"SP":{"name":"São Paulo","cities":["Adamantina","Adolfo","Aguaí","Águas da Prata","Águas de Lindóia","Águas de Santa Bárbara","Águas de São Pedro","Agudos","Alambari","Alfredo Marcondes","Altair","Altinópolis","Alto Alegre","Alumínio","Álvares Florence","Álvares Machado","Álvaro de Carvalho","Alvinlândia","Americana","Américo Brasiliense","Américo de Campos","Amparo","Analândia","Andradina","Angatuba","Anhembi","Anhumas","Aparecida","Aparecida d'Oeste","Apiaí","Araçariguama","Araçatuba","Araçoiaba da Serra","Aramina","Arandu","Arapeí","Araraquara","Araras","Arco-Íris","Arealva","Areias","Areiópolis","Ariranha","Artur Nogueira","Arujá","Aspásia","Assis","Atibaia","Auriflama","Avaí","Avanhandava","Avaré","Bady Bassitt","Balbinos","Bálsamo","Bananal","Barão de Antonina","Barbosa","Bariri","Barra Bonita","Barra do Chapéu","Barra do Turvo","Barretos","Barrinha","Barueri","Bastos","Batatais","Bauru","Bebedouro","Bento de Abreu","Bernardino de Campos","Bertioga","Bilac","Birigui","Biritiba-Mirim","Boa Esperança do Sul","Bocaina","Bofete","Boituva","Bom Jesus dos Perdões","Bom Sucesso de Itararé","Borá","Boracéia","Borborema","Borebi","Botucatu","Bragança Paulista","Braúna","Brejo Alegre","Brodowski","Brotas","Buri","Buritama","Buritizal","Cabrália Paulista","Cabreúva","Caçapava","Cachoeira Paulista","Caconde","Cafelândia","Caiabu","Caieiras","Caiuá","Cajamar","Cajati","Cajobi","Cajuru","Campina do Monte Alegre","Campinas","Campo Limpo Paulista","Campos do Jordão","Campos Novos Paulista","Cananéia","Canas","Cândido Mota","Cândido Rodrigues","Canitar","Capão Bonito","Capela do Alto","Capivari","Caraguatatuba","Carapicuíba","Cardoso","Casa Branca","Cássia dos Coqueiros","Castilho","Catanduva","Catiguá","Cedral","Cerqueira César","Cerquilho","Cesário Lange","Charqueada","Chavantes","Clementina","Colina","Colômbia","Conchal","Conchas","Cordeirópolis","Coroados","Coronel Macedo","Corumbataí","Cosmópolis","Cosmorama","Cotia","Cravinhos","Cristais Paulista","Cruzália","Cruzeiro","Cubatão","Cunha","Descalvado","Diadema","Dirce Reis","Divinolândia","Dobrada","Dois Córregos","Dolcinópolis","Dourado","Dracena","Duartina","Dumont","Echaporã","Eldorado","Elias Fausto","Elisiário","Embaúba","Embu","Embu-Guaçu","Emilianópolis","Engenheiro Coelho","Espírito Santo do Pinhal","Espírito Santo do Turvo","Estiva Gerbi","Estrela d'Oeste","Estrela do Norte","Euclides da Cunha Paulista","Fartura","Fernando Prestes","Fernandópolis","Fernão","Ferraz de Vasconcelos","Flora Rica","Floreal","Florínia","Flórida Paulista","Franca","Francisco Morato","Franco da Rocha","Gabriel Monteiro","Gália","Garça","Gastão Vidigal","Gavião Peixoto","General Salgado","Getulina","Glicério","Guaiçara","Guaimbê","Guaíra","Guapiaçu","Guapiara","Guará","Guaraçaí","Guaraci","Guarani d'Oeste","Guarantã","Guararapes","Guararema","Guaratinguetá","Guareí","Guariba","Guarujá","Guarulhos","Guatapará","Guzolândia","Herculândia","Holambra","Hortolândia","Iacanga","Iacri","Iaras","Ibaté","Ibirá","Ibirarema","Ibitinga","Ibiúna","Icém","Iepê","Igaraçu do Tietê","Igarapava","Igaratá","Iguape","Ilha Comprida","Ilha Solteira","Ilhabela","Indaiatuba","Indiana","Indiaporã","Inúbia Paulista","Ipauçu","Iperó","Ipeúna","Ipiguá","Iporanga","Ipuã","Iracemápolis","Irapuã","Irapuru","Itaberá","Itaí","Itajobi","Itaju","Itanhaém","Itaóca","Itapecerica da Serra","Itapetininga","Itapeva","Itapevi","Itapira","Itapirapuã Paulista","Itápolis","Itaporanga","Itapuí","Itapura","Itaquaquecetuba","Itararé","Itariri","Itatiba","Itatinga","Itirapina","Itirapuã","Itobi","Itu","Itupeva","Ituverava","Jaborandi","Jaboticabal","Jacareí","Jaci","Jacupiranga","Jaguariúna","Jales","Jambeiro","Jandira","Jardinópolis","Jarinu","Jaú","Jeriquara","Joanópolis","João Ramalho","José Bonifácio","Júlio Mesquita","Jumirim","Jundiaí","Junqueirópolis","Juquiá","Juquitiba","Lagoinha","Laranjal Paulista","Lavínia","Lavrinhas","Leme","Lençóis Paulista","Limeira","Lindóia","Lins","Lorena","Lourdes","Louveira","Lucélia","Lucianópolis","Luís Antônio","Luiziânia","Lupércio","Lutécia","Macatuba","Macaubal","Macedônia","Magda","Mairinque","Mairiporã","Manduri","Marabá Paulista","Maracaí","Marapoama","Mariápolis","Marília","Marinópolis","Martinópolis","Matão","Mauá","Mendonça","Meridiano","Mesópolis","Miguelópolis","Mineiros do Tietê","Mira Estrela","Miracatu","Mirandópolis","Mirante do Paranapanema","Mirassol","Mirassolândia","Mococa","Mogi das Cruzes","Mogi-Guaçu","Mogi-Mirim","Mombuca","Monções","Mongaguá","Monte Alegre do Sul","Monte Alto","Monte Aprazível","Monte Azul Paulista","Monte Castelo","Monte Mor","Monteiro Lobato","Morro Agudo","Morungaba","Motuca","Murutinga do Sul","Nantes","Narandiba","Natividade da Serra","Nazaré Paulista","Neves Paulista","Nhandeara","Nipoã","Nova Aliança","Nova Campina","Nova Canaã Paulista","Nova Castilho","Nova Europa","Nova Granada","Nova Guataporanga","Nova Independência","Nova Luzitânia","Nova Odessa","Novais","Novo Horizonte","Nuporanga","Ocauçu","Óleo","Olímpia","Onda Verde","Oriente","Orindiúva","Orlândia","Osasco","Oscar Bressane","Osvaldo Cruz","Ourinhos","Ouro Verde","Ouroeste","Pacaembu","Palestina","Palmares Paulista","Palmeira d'Oeste","Palmital","Panorama","Paraguaçu Paulista","Paraibuna","Paraíso","Paranapanema","Paranapuã","Parapuã","Pardinho","Pariquera-Açu","Parisi","Patrocínio Paulista","Paulicéia","Paulínia","Paulistânia","Paulo de Faria","Pederneiras","Pedra Bela","Pedranópolis","Pedregulho","Pedreira","Pedrinhas Paulista","Pedro de Toledo","Penápolis","Pereira Barreto","Pereiras","Peruíbe","Piacatu","Piedade","Pilar do Sul","Pindamonhangaba","Pindorama","Pinhalzinho","Piquerobi","Piquete","Piracaia","Piracicaba","Piraju","Pirajuí","Pirangi","Pirapora do Bom Jesus","Pirapozinho","Pirassununga","Piratininga","Pitangueiras","Planalto","Platina","Poá","Poloni","Pompéia","Pongaí","Pontal","Pontalinda","Pontes Gestal","Populina","Porangaba","Porto Feliz","Porto Ferreira","Potim","Potirendaba","Pracinha","Pradópolis","Praia Grande","Pratânia","Presidente Alves","Presidente Bernardes","Presidente Epitácio","Presidente Prudente","Presidente Venceslau","Promissão","Quadra","Quatá","Queiroz","Queluz","Quintana","Rafard","Rancharia","Redenção da Serra","Regente Feijó","Reginópolis","Registro","Restinga","Ribeira","Ribeirão Bonito","Ribeirão Branco","Ribeirão Corrente","Ribeirão do Sul","Ribeirão dos Índios","Ribeirão Grande","Ribeirão Pires","Ribeirão Preto","Rifaina","Rincão","Rinópolis","Rio Claro","Rio das Pedras","Rio Grande da Serra","Riolândia","Riversul","Rosana","Roseira","Rubiácea","Rubinéia","Sabino","Sagres","Sales","Sales Oliveira","Salesópolis","Salmourão","Saltinho","Salto","Salto de Pirapora","Salto Grande","Sandovalina","Santa Adélia","Santa Albertina","Santa Bárbara d'Oeste","Santa Branca","Santa Clara d'Oeste","Santa Cruz da Conceição","Santa Cruz da Esperança","Santa Cruz das Palmeiras","Santa Cruz do Rio Pardo","Santa Ernestina","Santa Fé do Sul","Santa Gertrudes","Santa Isabel","Santa Lúcia","Santa Maria da Serra","Santa Mercedes","Santa Rita d'Oeste","Santa Rita do Passa Quatro","Santa Rosa de Viterbo","Santa Salete","Santana da Ponte Pensa","Santana de Parnaíba","Santo Anastácio","Santo André","Santo Antônio da Alegria","Santo Antônio de Posse","Santo Antônio do Aracanguá","Santo Antônio do Jardim","Santo Antônio do Pinhal","Santo Expedito","Santópolis do Aguapeí","Santos","São Bento do Sapucaí","São Bernardo do Campo","São Caetano do Sul","São Carlos","São Francisco","São João da Boa Vista","São João das Duas Pontes","São João de Iracema","São João do Pau d'Alho","São Joaquim da Barra","São José da Bela Vista","São José do Barreiro","São José do Rio Pardo","São José do Rio Preto","São José dos Campos","São Lourenço da Serra","São Luís do Paraitinga","São Manuel","São Miguel Arcanjo","São Paulo","São Pedro","São Pedro do Turvo","São Roque","São Sebastião","São Sebastião da Grama","São Simão","São Vicente","Sarapuí","Sarutaiá","Sebastianópolis do Sul","Serra Azul","Serra Negra","Serrana","Sertãozinho","Sete Barras","Severínia","Silveiras","Socorro","Sorocaba","Sud Mennucci","Sumaré","Suzanápolis","Suzano","Tabapuã","Tabatinga","Taboão da Serra","Taciba","Taguaí","Taiaçu","Taiúva","Tambaú","Tanabi","Tapiraí","Tapiratiba","Taquaral","Taquaritinga","Taquarituba","Taquarivaí","Tarabai","Tarumã","Tatuí","Taubaté","Tejupá","Teodoro Sampaio","Terra Roxa","Tietê","Timburi","Torre de Pedra","Torrinha","Trabiju","Tremembé","Três Fronteiras","Tuiuti","Tupã","Tupi Paulista","Turiúba","Turmalina","Ubarana","Ubatuba","Ubirajara","Uchoa","União Paulista","Urânia","Uru","Urupês","Valentim Gentil","Valinhos","Valparaíso","Vargem","Vargem Grande do Sul","Vargem Grande Paulista","Várzea Paulista","Vera Cruz","Vinhedo","Viradouro","Vista Alegre do Alto","Vitória Brasil","Votorantim","Votuporanga","Zacarias"]},"TO":{"name":"Tocantins","cities":["Abreulândia","Aguiarnópolis","Aliança do Tocantins","Almas","Alvorada","Ananás","Angico","Aparecida do Rio Negro","Aragominas","Araguacema","Araguaçu","Araguaína","Araguanã","Araguatins","Arapoema","Arraias","Augustinópolis","Aurora do Tocantins","Axixá do Tocantins","Babaçulândia","Bandeirantes do Tocantins","Barra do Ouro","Barrolândia","Bernardo Sayão","Bom Jesus do Tocantins","Brasilândia do Tocantins","Brejinho de Nazaré","Buriti do Tocantins","Cachoeirinha","Campos Lindos","Cariri do Tocantins","Carmolândia","Carrasco Bonito","Caseara","Centenário","Chapada da Natividade","Chapada de Areia","Colinas do Tocantins","Colméia","Combinado","Conceição do Tocantins","Couto de Magalhães","Cristalândia","Crixás do Tocantins","Darcinópolis","Dianópolis","Divinópolis do Tocantins","Dois Irmãos do Tocantins","Dueré","Esperantina","Fátima","Figueirópolis","Filadélfia","Formoso do Araguaia","Fortaleza do Tabocão","Goianorte","Goiatins","Guaraí","Gurupi","Ipueiras","Itacajá","Itaguatins","Itapiratins","Itaporã do Tocantins","Jaú do Tocantins","Juarina","Lagoa da Confusão","Lagoa do Tocantins","Lajeado","Lavandeira","Lizarda","Luzinópolis","Marianópolis do Tocantins","Mateiros","Maurilândia do Tocantins","Miracema do Tocantins","Miranorte","Monte do Carmo","Monte Santo do Tocantins","Muricilândia","Natividade","Nazaré","Nova Olinda","Nova Rosalândia","Novo Acordo","Novo Alegre","Novo Jardim","Oliveira de Fátima","Palmas","Palmeirante","Palmeiras do Tocantins","Palmeirópolis","Paraíso do Tocantins","Paranã","Pau d'Arco","Pedro Afonso","Peixe","Pequizeiro","Pindorama do Tocantins","Piraquê","Pium","Ponte Alta do Bom Jesus","Ponte Alta do Tocantins","Porto Alegre do Tocantins","Porto Nacional","Praia Norte","Presidente Kennedy","Pugmil","Recursolândia","Riachinho","Rio da Conceição","Rio dos Bois","Rio Sono","Sampaio","Sandolândia","Santa Fé do Araguaia","Santa Maria do Tocantins","Santa Rita do Tocantins","Santa Rosa do Tocantins","Santa Tereza do Tocantins","Santa Terezinha Tocantins","São Bento do Tocantins","São Félix do Tocantins","São Miguel do Tocantins","São Salvador do Tocantins","São Sebastião do Tocantins","São Valério da Natividade","Silvanópolis","Sítio Novo do Tocantins","Sucupira","Taguatinga","Taipas do Tocantins","Talismã","Tocantínia","Tocantinópolis","Tupirama","Tupiratins","Wanderlândia","Xambioá"]}}

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__dirname) {var path = __webpack_require__(839);

var IMG_DIR = path.resolve(__dirname, 'static/img');

module.exports = {
  creatorName: 'UFV',
  projectName: 'MCTIC-InovaData BR',
  logo: IMG_DIR + '/logo.png',
  imgDir: '' + IMG_DIR,
  adminlte: {
    skin: 'skin-blue'
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var messages = {
  pt: {
    navbar: {
      home: 'Início',
      parks: 'Parques Tecnológicos',
      companies: 'Empresas',
      about: 'Institucional',
      contact: 'Contato',
      login: 'Entrar'
    },
    content: {
      news: 'Notícias',
      map: 'Mapa',
      tecnoparks: 'Parques Tecnológicos',
      parksInPlanningStage: 'Parques em Planejamento',
      parksInImplantationStage: 'Parques em Implantação',
      parksInOperationStage: 'Parques em Operação',
      byState: 'Por estado',
      selectState: 'Selecione um estado',
      selectStage: 'Selecione um estágio',
      byFocus: 'Por foco de atuação',
      selectFocus: 'Selecione um foco de atuação',
      notFound: 'Não Encontrado!',
      noParksFound: 'Nenhum parque encontrado.',
      search: 'Busca',
      mapLegendParks: 'Parques em operação por estado',
      mapLegendCompanies: 'Empresas vinculadas por estado',
      mapLegendBoth: 'Parques e empresas por estado',
      mapLegendEmpty: 'Marque parques e/ou empresas para ver a distribuição',
      mapTooltipParks: 'parques',
      mapTooltipCompanies: 'empresas'
    },
    commons: {
      park: 'Parque Tecnológico',
      name: 'Nome',
      email: 'Email',
      city: 'Cidade',
      state: 'Estado',
      companies: 'Empresas',
      about: 'Institucional',
      initials: 'Sigla',
      phoneNumber: 'Telefone',
      website: 'Website',
      legalResponsible: 'Responsável legal',
      stage: 'Estágio',
      planning: 'Planejamento',
      implantation: 'Implantação',
      operation: 'Operação'
    },
    portal: {
      revenues: 'Faturamento estimado',
      taxes: 'Impostos estimados',
      jobs: 'Empregos estimados',
      forTheYear: 'Referente a',
      contributors: 'Realização',
      project: 'Projeto',
      development: 'Desenvolvimento'
    },
    contact: {
      contact_us: 'Para mais informações, fale conosco!',
      our_email: 'E-mail',
      our_phones: 'Telefones',
      our_address: 'Endereço',
      form: {
        name: 'Seu nome completo',
        email: 'Seu endereço de e-mail',
        subject: 'Assunto',
        message: 'Mensagem',
        submit: 'Enviar',
        validation: {
          requiredField: 'Este campo é de preenchimento obrigatório.',
          invalidEmailAddress: 'Este campo deve ser preenchido com um endereço de e-mail válido.'
        },
        alerts: {
          success: 'Sua mensagem foi enviada!',
          error: 'Ocorreu um erro ao enviar a sua mensagem, por favor tente novamente mais tarde.'
        }
      }
    }
  },
  en: {
    navbar: {
      home: 'Home',
      parks: 'Science Parks',
      companies: 'Companies',
      about: 'About',
      contact: 'Contact',
      login: 'Login'
    },
    content: {
      news: 'News',
      map: 'Map',
      tecnoparks: 'Parks',
      parksInPlanningStage: 'Parks in Planning Stage',
      parksInImplantationStage: 'Parks in Implantation Stage',
      parksInOperationStage: 'Parks in Operation Stage',
      byState: 'By state',
      selectState: 'Select a state',
      selectStage: 'Select a stage',
      notFound: 'Not Found!',
      noParksFound: 'No parks have been found.',
      search: 'Search',
      mapLegendParks: 'Parks in operation by state',
      mapLegendCompanies: 'Linked companies by state',
      mapLegendBoth: 'Parks and companies by state',
      mapLegendEmpty: 'Check parks and/or companies to see distribution',
      mapTooltipParks: 'parks',
      mapTooltipCompanies: 'companies'
    },
    commons: {
      park: 'Park',
      name: 'Name',
      email: 'Email',
      city: 'City',
      state: 'State',
      companies: 'Companies',
      about: 'About',
      initials: 'Initials',
      phoneNumber: 'Phone Number',
      website: 'Website',
      legalResponsible: 'Legal Responsible',
      stage: 'Stage',
      planning: 'Planning',
      implantation: 'implantation',
      operation: 'Operation'
    },
    portal: {
      revenues: 'Estimated revenues',
      taxes: 'Estimated taxes',
      jobs: 'Estimated jobs',
      forTheYear: 'For the year',
      contributors: 'Contributors',
      project: 'Project',
      development: 'Development'
    },
    contact: {
      contact_us: 'Contact us for more informations!',
      our_email: 'Email',
      our_phones: 'Phones',
      our_address: 'Address',
      form: {
        name: 'Your name',
        email: 'Your email address',
        subject: 'Subject',
        message: 'Message',
        submit: 'Submit',
        validation: {
          requiredField: 'This field is required.',
          invalidEmailAddress: 'This field must have a valid e-mail address.'
        },
        alerts: {
          success: 'Your message was sent!',
          error: 'An error occurred, please try again alter.'
        }
      }
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 335 */,
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/*! DataTables 1.13.5
 * ©2008-2023 SpryMedia Ltd - datatables.net/license
 */



// DataTables code uses $ internally, but we want to be able to
// reassign $ with the `use` method, so it is a regular var.
var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;


var DataTable = function ( selector, options )
{
	// Check if called with a window or jQuery object for DOM less applications
	// This is for backwards compatibility
	if (DataTable.factory(selector, options)) {
		return DataTable;
	}

	// When creating with `new`, create a new DataTable, returning the API instance
	if (this instanceof DataTable) {
		return $(selector).DataTable(options);
	}
	else {
		// Argument switching
		options = selector;
	}

	/**
	 * Perform a jQuery selector action on the table's TR elements (from the tbody) and
	 * return the resulting jQuery object.
	 *  @param {string|node|jQuery} sSelector jQuery selector or node collection to act on
	 *  @param {object} [oOpts] Optional parameters for modifying the rows to be included
	 *  @param {string} [oOpts.filter=none] Select TR elements that meet the current filter
	 *    criterion ("applied") or all TR elements (i.e. no filter).
	 *  @param {string} [oOpts.order=current] Order of the TR elements in the processed array.
	 *    Can be either 'current', whereby the current sorting of the table is used, or
	 *    'original' whereby the original order the data was read into the table is used.
	 *  @param {string} [oOpts.page=all] Limit the selection to the currently displayed page
	 *    ("current") or not ("all"). If 'current' is given, then order is assumed to be
	 *    'current' and filter is 'applied', regardless of what they might be given as.
	 *  @returns {object} jQuery object, filtered by the given selector.
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *
	 *      // Highlight every second row
	 *      oTable.$('tr:odd').css('backgroundColor', 'blue');
	 *    } );
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *
	 *      // Filter to rows with 'Webkit' in them, add a background colour and then
	 *      // remove the filter, thus highlighting the 'Webkit' rows only.
	 *      oTable.fnFilter('Webkit');
	 *      oTable.$('tr', {"search": "applied"}).css('backgroundColor', 'blue');
	 *      oTable.fnFilter('');
	 *    } );
	 */
	this.$ = function ( sSelector, oOpts )
	{
		return this.api(true).$( sSelector, oOpts );
	};
	
	
	/**
	 * Almost identical to $ in operation, but in this case returns the data for the matched
	 * rows - as such, the jQuery selector used should match TR row nodes or TD/TH cell nodes
	 * rather than any descendants, so the data can be obtained for the row/cell. If matching
	 * rows are found, the data returned is the original data array/object that was used to
	 * create the row (or a generated array if from a DOM source).
	 *
	 * This method is often useful in-combination with $ where both functions are given the
	 * same parameters and the array indexes will match identically.
	 *  @param {string|node|jQuery} sSelector jQuery selector or node collection to act on
	 *  @param {object} [oOpts] Optional parameters for modifying the rows to be included
	 *  @param {string} [oOpts.filter=none] Select elements that meet the current filter
	 *    criterion ("applied") or all elements (i.e. no filter).
	 *  @param {string} [oOpts.order=current] Order of the data in the processed array.
	 *    Can be either 'current', whereby the current sorting of the table is used, or
	 *    'original' whereby the original order the data was read into the table is used.
	 *  @param {string} [oOpts.page=all] Limit the selection to the currently displayed page
	 *    ("current") or not ("all"). If 'current' is given, then order is assumed to be
	 *    'current' and filter is 'applied', regardless of what they might be given as.
	 *  @returns {array} Data for the matched elements. If any elements, as a result of the
	 *    selector, were not TR, TD or TH elements in the DataTable, they will have a null
	 *    entry in the array.
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *
	 *      // Get the data from the first row in the table
	 *      var data = oTable._('tr:first');
	 *
	 *      // Do something useful with the data
	 *      alert( "First cell is: "+data[0] );
	 *    } );
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *
	 *      // Filter to 'Webkit' and get all data for
	 *      oTable.fnFilter('Webkit');
	 *      var data = oTable._('tr', {"search": "applied"});
	 *
	 *      // Do something with the data
	 *      alert( data.length+" rows matched the search" );
	 *    } );
	 */
	this._ = function ( sSelector, oOpts )
	{
		return this.api(true).rows( sSelector, oOpts ).data();
	};
	
	
	/**
	 * Create a DataTables Api instance, with the currently selected tables for
	 * the Api's context.
	 * @param {boolean} [traditional=false] Set the API instance's context to be
	 *   only the table referred to by the `DataTable.ext.iApiIndex` option, as was
	 *   used in the API presented by DataTables 1.9- (i.e. the traditional mode),
	 *   or if all tables captured in the jQuery object should be used.
	 * @return {DataTables.Api}
	 */
	this.api = function ( traditional )
	{
		return traditional ?
			new _Api(
				_fnSettingsFromNode( this[ _ext.iApiIndex ] )
			) :
			new _Api( this );
	};
	
	
	/**
	 * Add a single new row or multiple rows of data to the table. Please note
	 * that this is suitable for client-side processing only - if you are using
	 * server-side processing (i.e. "bServerSide": true), then to add data, you
	 * must add it to the data source, i.e. the server-side, through an Ajax call.
	 *  @param {array|object} data The data to be added to the table. This can be:
	 *    <ul>
	 *      <li>1D array of data - add a single row with the data provided</li>
	 *      <li>2D array of arrays - add multiple rows in a single call</li>
	 *      <li>object - data object when using <i>mData</i></li>
	 *      <li>array of objects - multiple data objects when using <i>mData</i></li>
	 *    </ul>
	 *  @param {bool} [redraw=true] redraw the table or not
	 *  @returns {array} An array of integers, representing the list of indexes in
	 *    <i>aoData</i> ({@link DataTable.models.oSettings}) that have been added to
	 *    the table.
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    // Global var for counter
	 *    var giCount = 2;
	 *
	 *    $(document).ready(function() {
	 *      $('#example').dataTable();
	 *    } );
	 *
	 *    function fnClickAddRow() {
	 *      $('#example').dataTable().fnAddData( [
	 *        giCount+".1",
	 *        giCount+".2",
	 *        giCount+".3",
	 *        giCount+".4" ]
	 *      );
	 *
	 *      giCount++;
	 *    }
	 */
	this.fnAddData = function( data, redraw )
	{
		var api = this.api( true );
	
		/* Check if we want to add multiple rows or not */
		var rows = Array.isArray(data) && ( Array.isArray(data[0]) || $.isPlainObject(data[0]) ) ?
			api.rows.add( data ) :
			api.row.add( data );
	
		if ( redraw === undefined || redraw ) {
			api.draw();
		}
	
		return rows.flatten().toArray();
	};
	
	
	/**
	 * This function will make DataTables recalculate the column sizes, based on the data
	 * contained in the table and the sizes applied to the columns (in the DOM, CSS or
	 * through the sWidth parameter). This can be useful when the width of the table's
	 * parent element changes (for example a window resize).
	 *  @param {boolean} [bRedraw=true] Redraw the table or not, you will typically want to
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable( {
	 *        "sScrollY": "200px",
	 *        "bPaginate": false
	 *      } );
	 *
	 *      $(window).on('resize', function () {
	 *        oTable.fnAdjustColumnSizing();
	 *      } );
	 *    } );
	 */
	this.fnAdjustColumnSizing = function ( bRedraw )
	{
		var api = this.api( true ).columns.adjust();
		var settings = api.settings()[0];
		var scroll = settings.oScroll;
	
		if ( bRedraw === undefined || bRedraw ) {
			api.draw( false );
		}
		else if ( scroll.sX !== "" || scroll.sY !== "" ) {
			/* If not redrawing, but scrolling, we want to apply the new column sizes anyway */
			_fnScrollDraw( settings );
		}
	};
	
	
	/**
	 * Quickly and simply clear a table
	 *  @param {bool} [bRedraw=true] redraw the table or not
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *
	 *      // Immediately 'nuke' the current rows (perhaps waiting for an Ajax callback...)
	 *      oTable.fnClearTable();
	 *    } );
	 */
	this.fnClearTable = function( bRedraw )
	{
		var api = this.api( true ).clear();
	
		if ( bRedraw === undefined || bRedraw ) {
			api.draw();
		}
	};
	
	
	/**
	 * The exact opposite of 'opening' a row, this function will close any rows which
	 * are currently 'open'.
	 *  @param {node} nTr the table row to 'close'
	 *  @returns {int} 0 on success, or 1 if failed (can't find the row)
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable;
	 *
	 *      // 'open' an information row when a row is clicked on
	 *      $('#example tbody tr').click( function () {
	 *        if ( oTable.fnIsOpen(this) ) {
	 *          oTable.fnClose( this );
	 *        } else {
	 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
	 *        }
	 *      } );
	 *
	 *      oTable = $('#example').dataTable();
	 *    } );
	 */
	this.fnClose = function( nTr )
	{
		this.api( true ).row( nTr ).child.hide();
	};
	
	
	/**
	 * Remove a row for the table
	 *  @param {mixed} target The index of the row from aoData to be deleted, or
	 *    the TR element you want to delete
	 *  @param {function|null} [callBack] Callback function
	 *  @param {bool} [redraw=true] Redraw the table or not
	 *  @returns {array} The row that was deleted
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *
	 *      // Immediately remove the first row
	 *      oTable.fnDeleteRow( 0 );
	 *    } );
	 */
	this.fnDeleteRow = function( target, callback, redraw )
	{
		var api = this.api( true );
		var rows = api.rows( target );
		var settings = rows.settings()[0];
		var data = settings.aoData[ rows[0][0] ];
	
		rows.remove();
	
		if ( callback ) {
			callback.call( this, settings, data );
		}
	
		if ( redraw === undefined || redraw ) {
			api.draw();
		}
	
		return data;
	};
	
	
	/**
	 * Restore the table to it's original state in the DOM by removing all of DataTables
	 * enhancements, alterations to the DOM structure of the table and event listeners.
	 *  @param {boolean} [remove=false] Completely remove the table from the DOM
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      // This example is fairly pointless in reality, but shows how fnDestroy can be used
	 *      var oTable = $('#example').dataTable();
	 *      oTable.fnDestroy();
	 *    } );
	 */
	this.fnDestroy = function ( remove )
	{
		this.api( true ).destroy( remove );
	};
	
	
	/**
	 * Redraw the table
	 *  @param {bool} [complete=true] Re-filter and resort (if enabled) the table before the draw.
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *
	 *      // Re-draw the table - you wouldn't want to do it here, but it's an example :-)
	 *      oTable.fnDraw();
	 *    } );
	 */
	this.fnDraw = function( complete )
	{
		// Note that this isn't an exact match to the old call to _fnDraw - it takes
		// into account the new data, but can hold position.
		this.api( true ).draw( complete );
	};
	
	
	/**
	 * Filter the input based on data
	 *  @param {string} sInput String to filter the table on
	 *  @param {int|null} [iColumn] Column to limit filtering to
	 *  @param {bool} [bRegex=false] Treat as regular expression or not
	 *  @param {bool} [bSmart=true] Perform smart filtering or not
	 *  @param {bool} [bShowGlobal=true] Show the input global filter in it's input box(es)
	 *  @param {bool} [bCaseInsensitive=true] Do case-insensitive matching (true) or not (false)
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *
	 *      // Sometime later - filter...
	 *      oTable.fnFilter( 'test string' );
	 *    } );
	 */
	this.fnFilter = function( sInput, iColumn, bRegex, bSmart, bShowGlobal, bCaseInsensitive )
	{
		var api = this.api( true );
	
		if ( iColumn === null || iColumn === undefined ) {
			api.search( sInput, bRegex, bSmart, bCaseInsensitive );
		}
		else {
			api.column( iColumn ).search( sInput, bRegex, bSmart, bCaseInsensitive );
		}
	
		api.draw();
	};
	
	
	/**
	 * Get the data for the whole table, an individual row or an individual cell based on the
	 * provided parameters.
	 *  @param {int|node} [src] A TR row node, TD/TH cell node or an integer. If given as
	 *    a TR node then the data source for the whole row will be returned. If given as a
	 *    TD/TH cell node then iCol will be automatically calculated and the data for the
	 *    cell returned. If given as an integer, then this is treated as the aoData internal
	 *    data index for the row (see fnGetPosition) and the data for that row used.
	 *  @param {int} [col] Optional column index that you want the data of.
	 *  @returns {array|object|string} If mRow is undefined, then the data for all rows is
	 *    returned. If mRow is defined, just data for that row, and is iCol is
	 *    defined, only data for the designated cell is returned.
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    // Row data
	 *    $(document).ready(function() {
	 *      oTable = $('#example').dataTable();
	 *
	 *      oTable.$('tr').click( function () {
	 *        var data = oTable.fnGetData( this );
	 *        // ... do something with the array / object of data for the row
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Individual cell data
	 *    $(document).ready(function() {
	 *      oTable = $('#example').dataTable();
	 *
	 *      oTable.$('td').click( function () {
	 *        var sData = oTable.fnGetData( this );
	 *        alert( 'The cell clicked on had the value of '+sData );
	 *      } );
	 *    } );
	 */
	this.fnGetData = function( src, col )
	{
		var api = this.api( true );
	
		if ( src !== undefined ) {
			var type = src.nodeName ? src.nodeName.toLowerCase() : '';
	
			return col !== undefined || type == 'td' || type == 'th' ?
				api.cell( src, col ).data() :
				api.row( src ).data() || null;
		}
	
		return api.data().toArray();
	};
	
	
	/**
	 * Get an array of the TR nodes that are used in the table's body. Note that you will
	 * typically want to use the '$' API method in preference to this as it is more
	 * flexible.
	 *  @param {int} [iRow] Optional row index for the TR element you want
	 *  @returns {array|node} If iRow is undefined, returns an array of all TR elements
	 *    in the table's body, or iRow is defined, just the TR element requested.
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *
	 *      // Get the nodes from the table
	 *      var nNodes = oTable.fnGetNodes( );
	 *    } );
	 */
	this.fnGetNodes = function( iRow )
	{
		var api = this.api( true );
	
		return iRow !== undefined ?
			api.row( iRow ).node() :
			api.rows().nodes().flatten().toArray();
	};
	
	
	/**
	 * Get the array indexes of a particular cell from it's DOM element
	 * and column index including hidden columns
	 *  @param {node} node this can either be a TR, TD or TH in the table's body
	 *  @returns {int} If nNode is given as a TR, then a single index is returned, or
	 *    if given as a cell, an array of [row index, column index (visible),
	 *    column index (all)] is given.
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      $('#example tbody td').click( function () {
	 *        // Get the position of the current data from the node
	 *        var aPos = oTable.fnGetPosition( this );
	 *
	 *        // Get the data array for this row
	 *        var aData = oTable.fnGetData( aPos[0] );
	 *
	 *        // Update the data array and return the value
	 *        aData[ aPos[1] ] = 'clicked';
	 *        this.innerHTML = 'clicked';
	 *      } );
	 *
	 *      // Init DataTables
	 *      oTable = $('#example').dataTable();
	 *    } );
	 */
	this.fnGetPosition = function( node )
	{
		var api = this.api( true );
		var nodeName = node.nodeName.toUpperCase();
	
		if ( nodeName == 'TR' ) {
			return api.row( node ).index();
		}
		else if ( nodeName == 'TD' || nodeName == 'TH' ) {
			var cell = api.cell( node ).index();
	
			return [
				cell.row,
				cell.columnVisible,
				cell.column
			];
		}
		return null;
	};
	
	
	/**
	 * Check to see if a row is 'open' or not.
	 *  @param {node} nTr the table row to check
	 *  @returns {boolean} true if the row is currently open, false otherwise
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable;
	 *
	 *      // 'open' an information row when a row is clicked on
	 *      $('#example tbody tr').click( function () {
	 *        if ( oTable.fnIsOpen(this) ) {
	 *          oTable.fnClose( this );
	 *        } else {
	 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
	 *        }
	 *      } );
	 *
	 *      oTable = $('#example').dataTable();
	 *    } );
	 */
	this.fnIsOpen = function( nTr )
	{
		return this.api( true ).row( nTr ).child.isShown();
	};
	
	
	/**
	 * This function will place a new row directly after a row which is currently
	 * on display on the page, with the HTML contents that is passed into the
	 * function. This can be used, for example, to ask for confirmation that a
	 * particular record should be deleted.
	 *  @param {node} nTr The table row to 'open'
	 *  @param {string|node|jQuery} mHtml The HTML to put into the row
	 *  @param {string} sClass Class to give the new TD cell
	 *  @returns {node} The row opened. Note that if the table row passed in as the
	 *    first parameter, is not found in the table, this method will silently
	 *    return.
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable;
	 *
	 *      // 'open' an information row when a row is clicked on
	 *      $('#example tbody tr').click( function () {
	 *        if ( oTable.fnIsOpen(this) ) {
	 *          oTable.fnClose( this );
	 *        } else {
	 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
	 *        }
	 *      } );
	 *
	 *      oTable = $('#example').dataTable();
	 *    } );
	 */
	this.fnOpen = function( nTr, mHtml, sClass )
	{
		return this.api( true )
			.row( nTr )
			.child( mHtml, sClass )
			.show()
			.child()[0];
	};
	
	
	/**
	 * Change the pagination - provides the internal logic for pagination in a simple API
	 * function. With this function you can have a DataTables table go to the next,
	 * previous, first or last pages.
	 *  @param {string|int} mAction Paging action to take: "first", "previous", "next" or "last"
	 *    or page number to jump to (integer), note that page 0 is the first page.
	 *  @param {bool} [bRedraw=true] Redraw the table or not
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *      oTable.fnPageChange( 'next' );
	 *    } );
	 */
	this.fnPageChange = function ( mAction, bRedraw )
	{
		var api = this.api( true ).page( mAction );
	
		if ( bRedraw === undefined || bRedraw ) {
			api.draw(false);
		}
	};
	
	
	/**
	 * Show a particular column
	 *  @param {int} iCol The column whose display should be changed
	 *  @param {bool} bShow Show (true) or hide (false) the column
	 *  @param {bool} [bRedraw=true] Redraw the table or not
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *
	 *      // Hide the second column after initialisation
	 *      oTable.fnSetColumnVis( 1, false );
	 *    } );
	 */
	this.fnSetColumnVis = function ( iCol, bShow, bRedraw )
	{
		var api = this.api( true ).column( iCol ).visible( bShow );
	
		if ( bRedraw === undefined || bRedraw ) {
			api.columns.adjust().draw();
		}
	};
	
	
	/**
	 * Get the settings for a particular table for external manipulation
	 *  @returns {object} DataTables settings object. See
	 *    {@link DataTable.models.oSettings}
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *      var oSettings = oTable.fnSettings();
	 *
	 *      // Show an example parameter from the settings
	 *      alert( oSettings._iDisplayStart );
	 *    } );
	 */
	this.fnSettings = function()
	{
		return _fnSettingsFromNode( this[_ext.iApiIndex] );
	};
	
	
	/**
	 * Sort the table by a particular column
	 *  @param {int} iCol the data index to sort on. Note that this will not match the
	 *    'display index' if you have hidden data entries
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *
	 *      // Sort immediately with columns 0 and 1
	 *      oTable.fnSort( [ [0,'asc'], [1,'asc'] ] );
	 *    } );
	 */
	this.fnSort = function( aaSort )
	{
		this.api( true ).order( aaSort ).draw();
	};
	
	
	/**
	 * Attach a sort listener to an element for a given column
	 *  @param {node} nNode the element to attach the sort listener to
	 *  @param {int} iColumn the column that a click on this node will sort on
	 *  @param {function} [fnCallback] callback function when sort is run
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *
	 *      // Sort on column 1, when 'sorter' is clicked on
	 *      oTable.fnSortListener( document.getElementById('sorter'), 1 );
	 *    } );
	 */
	this.fnSortListener = function( nNode, iColumn, fnCallback )
	{
		this.api( true ).order.listener( nNode, iColumn, fnCallback );
	};
	
	
	/**
	 * Update a table cell or row - this method will accept either a single value to
	 * update the cell with, an array of values with one element for each column or
	 * an object in the same format as the original data source. The function is
	 * self-referencing in order to make the multi column updates easier.
	 *  @param {object|array|string} mData Data to update the cell/row with
	 *  @param {node|int} mRow TR element you want to update or the aoData index
	 *  @param {int} [iColumn] The column to update, give as null or undefined to
	 *    update a whole row.
	 *  @param {bool} [bRedraw=true] Redraw the table or not
	 *  @param {bool} [bAction=true] Perform pre-draw actions or not
	 *  @returns {int} 0 on success, 1 on error
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *      oTable.fnUpdate( 'Example update', 0, 0 ); // Single cell
	 *      oTable.fnUpdate( ['a', 'b', 'c', 'd', 'e'], $('tbody tr')[0] ); // Row
	 *    } );
	 */
	this.fnUpdate = function( mData, mRow, iColumn, bRedraw, bAction )
	{
		var api = this.api( true );
	
		if ( iColumn === undefined || iColumn === null ) {
			api.row( mRow ).data( mData );
		}
		else {
			api.cell( mRow, iColumn ).data( mData );
		}
	
		if ( bAction === undefined || bAction ) {
			api.columns.adjust();
		}
	
		if ( bRedraw === undefined || bRedraw ) {
			api.draw();
		}
		return 0;
	};
	
	
	/**
	 * Provide a common method for plug-ins to check the version of DataTables being used, in order
	 * to ensure compatibility.
	 *  @param {string} sVersion Version string to check for, in the format "X.Y.Z". Note that the
	 *    formats "X" and "X.Y" are also acceptable.
	 *  @returns {boolean} true if this version of DataTables is greater or equal to the required
	 *    version, or false if this version of DataTales is not suitable
	 *  @method
	 *  @dtopt API
	 *  @deprecated Since v1.10
	 *
	 *  @example
	 *    $(document).ready(function() {
	 *      var oTable = $('#example').dataTable();
	 *      alert( oTable.fnVersionCheck( '1.9.0' ) );
	 *    } );
	 */
	this.fnVersionCheck = _ext.fnVersionCheck;
	

	var _that = this;
	var emptyInit = options === undefined;
	var len = this.length;

	if ( emptyInit ) {
		options = {};
	}

	this.oApi = this.internal = _ext.internal;

	// Extend with old style plug-in API methods
	for ( var fn in DataTable.ext.internal ) {
		if ( fn ) {
			this[fn] = _fnExternApiFunc(fn);
		}
	}

	this.each(function() {
		// For each initialisation we want to give it a clean initialisation
		// object that can be bashed around
		var o = {};
		var oInit = len > 1 ? // optimisation for single table case
			_fnExtend( o, options, true ) :
			options;

		/*global oInit,_that,emptyInit*/
		var i=0, iLen, j, jLen, k, kLen;
		var sId = this.getAttribute( 'id' );
		var bInitHandedOff = false;
		var defaults = DataTable.defaults;
		var $this = $(this);
		
		
		/* Sanity check */
		if ( this.nodeName.toLowerCase() != 'table' )
		{
			_fnLog( null, 0, 'Non-table node initialisation ('+this.nodeName+')', 2 );
			return;
		}
		
		/* Backwards compatibility for the defaults */
		_fnCompatOpts( defaults );
		_fnCompatCols( defaults.column );
		
		/* Convert the camel-case defaults to Hungarian */
		_fnCamelToHungarian( defaults, defaults, true );
		_fnCamelToHungarian( defaults.column, defaults.column, true );
		
		/* Setting up the initialisation object */
		_fnCamelToHungarian( defaults, $.extend( oInit, $this.data() ), true );
		
		
		
		/* Check to see if we are re-initialising a table */
		var allSettings = DataTable.settings;
		for ( i=0, iLen=allSettings.length ; i<iLen ; i++ )
		{
			var s = allSettings[i];
		
			/* Base check on table node */
			if (
				s.nTable == this ||
				(s.nTHead && s.nTHead.parentNode == this) ||
				(s.nTFoot && s.nTFoot.parentNode == this)
			) {
				var bRetrieve = oInit.bRetrieve !== undefined ? oInit.bRetrieve : defaults.bRetrieve;
				var bDestroy = oInit.bDestroy !== undefined ? oInit.bDestroy : defaults.bDestroy;
		
				if ( emptyInit || bRetrieve )
				{
					return s.oInstance;
				}
				else if ( bDestroy )
				{
					s.oInstance.fnDestroy();
					break;
				}
				else
				{
					_fnLog( s, 0, 'Cannot reinitialise DataTable', 3 );
					return;
				}
			}
		
			/* If the element we are initialising has the same ID as a table which was previously
			 * initialised, but the table nodes don't match (from before) then we destroy the old
			 * instance by simply deleting it. This is under the assumption that the table has been
			 * destroyed by other methods. Anyone using non-id selectors will need to do this manually
			 */
			if ( s.sTableId == this.id )
			{
				allSettings.splice( i, 1 );
				break;
			}
		}
		
		/* Ensure the table has an ID - required for accessibility */
		if ( sId === null || sId === "" )
		{
			sId = "DataTables_Table_"+(DataTable.ext._unique++);
			this.id = sId;
		}
		
		/* Create the settings object for this table and set some of the default parameters */
		var oSettings = $.extend( true, {}, DataTable.models.oSettings, {
			"sDestroyWidth": $this[0].style.width,
			"sInstance":     sId,
			"sTableId":      sId
		} );
		oSettings.nTable = this;
		oSettings.oApi   = _that.internal;
		oSettings.oInit  = oInit;
		
		allSettings.push( oSettings );
		
		// Need to add the instance after the instance after the settings object has been added
		// to the settings array, so we can self reference the table instance if more than one
		oSettings.oInstance = (_that.length===1) ? _that : $this.dataTable();
		
		// Backwards compatibility, before we apply all the defaults
		_fnCompatOpts( oInit );
		_fnLanguageCompat( oInit.oLanguage );
		
		// If the length menu is given, but the init display length is not, use the length menu
		if ( oInit.aLengthMenu && ! oInit.iDisplayLength )
		{
			oInit.iDisplayLength = Array.isArray( oInit.aLengthMenu[0] ) ?
				oInit.aLengthMenu[0][0] : oInit.aLengthMenu[0];
		}
		
		// Apply the defaults and init options to make a single init object will all
		// options defined from defaults and instance options.
		oInit = _fnExtend( $.extend( true, {}, defaults ), oInit );
		
		
		// Map the initialisation options onto the settings object
		_fnMap( oSettings.oFeatures, oInit, [
			"bPaginate",
			"bLengthChange",
			"bFilter",
			"bSort",
			"bSortMulti",
			"bInfo",
			"bProcessing",
			"bAutoWidth",
			"bSortClasses",
			"bServerSide",
			"bDeferRender"
		] );
		_fnMap( oSettings, oInit, [
			"asStripeClasses",
			"ajax",
			"fnServerData",
			"fnFormatNumber",
			"sServerMethod",
			"aaSorting",
			"aaSortingFixed",
			"aLengthMenu",
			"sPaginationType",
			"sAjaxSource",
			"sAjaxDataProp",
			"iStateDuration",
			"sDom",
			"bSortCellsTop",
			"iTabIndex",
			"fnStateLoadCallback",
			"fnStateSaveCallback",
			"renderer",
			"searchDelay",
			"rowId",
			[ "iCookieDuration", "iStateDuration" ], // backwards compat
			[ "oSearch", "oPreviousSearch" ],
			[ "aoSearchCols", "aoPreSearchCols" ],
			[ "iDisplayLength", "_iDisplayLength" ]
		] );
		_fnMap( oSettings.oScroll, oInit, [
			[ "sScrollX", "sX" ],
			[ "sScrollXInner", "sXInner" ],
			[ "sScrollY", "sY" ],
			[ "bScrollCollapse", "bCollapse" ]
		] );
		_fnMap( oSettings.oLanguage, oInit, "fnInfoCallback" );
		
		/* Callback functions which are array driven */
		_fnCallbackReg( oSettings, 'aoDrawCallback',       oInit.fnDrawCallback,      'user' );
		_fnCallbackReg( oSettings, 'aoServerParams',       oInit.fnServerParams,      'user' );
		_fnCallbackReg( oSettings, 'aoStateSaveParams',    oInit.fnStateSaveParams,   'user' );
		_fnCallbackReg( oSettings, 'aoStateLoadParams',    oInit.fnStateLoadParams,   'user' );
		_fnCallbackReg( oSettings, 'aoStateLoaded',        oInit.fnStateLoaded,       'user' );
		_fnCallbackReg( oSettings, 'aoRowCallback',        oInit.fnRowCallback,       'user' );
		_fnCallbackReg( oSettings, 'aoRowCreatedCallback', oInit.fnCreatedRow,        'user' );
		_fnCallbackReg( oSettings, 'aoHeaderCallback',     oInit.fnHeaderCallback,    'user' );
		_fnCallbackReg( oSettings, 'aoFooterCallback',     oInit.fnFooterCallback,    'user' );
		_fnCallbackReg( oSettings, 'aoInitComplete',       oInit.fnInitComplete,      'user' );
		_fnCallbackReg( oSettings, 'aoPreDrawCallback',    oInit.fnPreDrawCallback,   'user' );
		
		oSettings.rowIdFn = _fnGetObjectDataFn( oInit.rowId );
		
		/* Browser support detection */
		_fnBrowserDetect( oSettings );
		
		var oClasses = oSettings.oClasses;
		
		$.extend( oClasses, DataTable.ext.classes, oInit.oClasses );
		$this.addClass( oClasses.sTable );
		
		
		if ( oSettings.iInitDisplayStart === undefined )
		{
			/* Display start point, taking into account the save saving */
			oSettings.iInitDisplayStart = oInit.iDisplayStart;
			oSettings._iDisplayStart = oInit.iDisplayStart;
		}
		
		if ( oInit.iDeferLoading !== null )
		{
			oSettings.bDeferLoading = true;
			var tmp = Array.isArray( oInit.iDeferLoading );
			oSettings._iRecordsDisplay = tmp ? oInit.iDeferLoading[0] : oInit.iDeferLoading;
			oSettings._iRecordsTotal = tmp ? oInit.iDeferLoading[1] : oInit.iDeferLoading;
		}
		
		/* Language definitions */
		var oLanguage = oSettings.oLanguage;
		$.extend( true, oLanguage, oInit.oLanguage );
		
		if ( oLanguage.sUrl )
		{
			/* Get the language definitions from a file - because this Ajax call makes the language
			 * get async to the remainder of this function we use bInitHandedOff to indicate that
			 * _fnInitialise will be fired by the returned Ajax handler, rather than the constructor
			 */
			$.ajax( {
				dataType: 'json',
				url: oLanguage.sUrl,
				success: function ( json ) {
					_fnCamelToHungarian( defaults.oLanguage, json );
					_fnLanguageCompat( json );
					$.extend( true, oLanguage, json, oSettings.oInit.oLanguage );
		
					_fnCallbackFire( oSettings, null, 'i18n', [oSettings]);
					_fnInitialise( oSettings );
				},
				error: function () {
					// Error occurred loading language file, continue on as best we can
					_fnInitialise( oSettings );
				}
			} );
			bInitHandedOff = true;
		}
		else {
			_fnCallbackFire( oSettings, null, 'i18n', [oSettings]);
		}
		
		/*
		 * Stripes
		 */
		if ( oInit.asStripeClasses === null )
		{
			oSettings.asStripeClasses =[
				oClasses.sStripeOdd,
				oClasses.sStripeEven
			];
		}
		
		/* Remove row stripe classes if they are already on the table row */
		var stripeClasses = oSettings.asStripeClasses;
		var rowOne = $this.children('tbody').find('tr').eq(0);
		if ( $.inArray( true, $.map( stripeClasses, function(el, i) {
			return rowOne.hasClass(el);
		} ) ) !== -1 ) {
			$('tbody tr', this).removeClass( stripeClasses.join(' ') );
			oSettings.asDestroyStripes = stripeClasses.slice();
		}
		
		/*
		 * Columns
		 * See if we should load columns automatically or use defined ones
		 */
		var anThs = [];
		var aoColumnsInit;
		var nThead = this.getElementsByTagName('thead');
		if ( nThead.length !== 0 )
		{
			_fnDetectHeader( oSettings.aoHeader, nThead[0] );
			anThs = _fnGetUniqueThs( oSettings );
		}
		
		/* If not given a column array, generate one with nulls */
		if ( oInit.aoColumns === null )
		{
			aoColumnsInit = [];
			for ( i=0, iLen=anThs.length ; i<iLen ; i++ )
			{
				aoColumnsInit.push( null );
			}
		}
		else
		{
			aoColumnsInit = oInit.aoColumns;
		}
		
		/* Add the columns */
		for ( i=0, iLen=aoColumnsInit.length ; i<iLen ; i++ )
		{
			_fnAddColumn( oSettings, anThs ? anThs[i] : null );
		}
		
		/* Apply the column definitions */
		_fnApplyColumnDefs( oSettings, oInit.aoColumnDefs, aoColumnsInit, function (iCol, oDef) {
			_fnColumnOptions( oSettings, iCol, oDef );
		} );
		
		/* HTML5 attribute detection - build an mData object automatically if the
		 * attributes are found
		 */
		if ( rowOne.length ) {
			var a = function ( cell, name ) {
				return cell.getAttribute( 'data-'+name ) !== null ? name : null;
			};
		
			$( rowOne[0] ).children('th, td').each( function (i, cell) {
				var col = oSettings.aoColumns[i];
		
				if (! col) {
					_fnLog( oSettings, 0, 'Incorrect column count', 18 );
				}
		
				if ( col.mData === i ) {
					var sort = a( cell, 'sort' ) || a( cell, 'order' );
					var filter = a( cell, 'filter' ) || a( cell, 'search' );
		
					if ( sort !== null || filter !== null ) {
						col.mData = {
							_:      i+'.display',
							sort:   sort !== null   ? i+'.@data-'+sort   : undefined,
							type:   sort !== null   ? i+'.@data-'+sort   : undefined,
							filter: filter !== null ? i+'.@data-'+filter : undefined
						};
						col._isArrayHost = true;
		
						_fnColumnOptions( oSettings, i );
					}
				}
			} );
		}
		
		var features = oSettings.oFeatures;
		var loadedInit = function () {
			/*
			 * Sorting
			 * @todo For modularisation (1.11) this needs to do into a sort start up handler
			 */
		
			// If aaSorting is not defined, then we use the first indicator in asSorting
			// in case that has been altered, so the default sort reflects that option
			if ( oInit.aaSorting === undefined ) {
				var sorting = oSettings.aaSorting;
				for ( i=0, iLen=sorting.length ; i<iLen ; i++ ) {
					sorting[i][1] = oSettings.aoColumns[ i ].asSorting[0];
				}
			}
		
			/* Do a first pass on the sorting classes (allows any size changes to be taken into
			 * account, and also will apply sorting disabled classes if disabled
			 */
			_fnSortingClasses( oSettings );
		
			if ( features.bSort ) {
				_fnCallbackReg( oSettings, 'aoDrawCallback', function () {
					if ( oSettings.bSorted ) {
						var aSort = _fnSortFlatten( oSettings );
						var sortedColumns = {};
		
						$.each( aSort, function (i, val) {
							sortedColumns[ val.src ] = val.dir;
						} );
		
						_fnCallbackFire( oSettings, null, 'order', [oSettings, aSort, sortedColumns] );
						_fnSortAria( oSettings );
					}
				} );
			}
		
			_fnCallbackReg( oSettings, 'aoDrawCallback', function () {
				if ( oSettings.bSorted || _fnDataSource( oSettings ) === 'ssp' || features.bDeferRender ) {
					_fnSortingClasses( oSettings );
				}
			}, 'sc' );
		
		
			/*
			 * Final init
			 * Cache the header, body and footer as required, creating them if needed
			 */
		
			// Work around for Webkit bug 83867 - store the caption-side before removing from doc
			var captions = $this.children('caption').each( function () {
				this._captionSide = $(this).css('caption-side');
			} );
		
			var thead = $this.children('thead');
			if ( thead.length === 0 ) {
				thead = $('<thead/>').appendTo($this);
			}
			oSettings.nTHead = thead[0];
		
			var tbody = $this.children('tbody');
			if ( tbody.length === 0 ) {
				tbody = $('<tbody/>').insertAfter(thead);
			}
			oSettings.nTBody = tbody[0];
		
			var tfoot = $this.children('tfoot');
			if ( tfoot.length === 0 && captions.length > 0 && (oSettings.oScroll.sX !== "" || oSettings.oScroll.sY !== "") ) {
				// If we are a scrolling table, and no footer has been given, then we need to create
				// a tfoot element for the caption element to be appended to
				tfoot = $('<tfoot/>').appendTo($this);
			}
		
			if ( tfoot.length === 0 || tfoot.children().length === 0 ) {
				$this.addClass( oClasses.sNoFooter );
			}
			else if ( tfoot.length > 0 ) {
				oSettings.nTFoot = tfoot[0];
				_fnDetectHeader( oSettings.aoFooter, oSettings.nTFoot );
			}
		
			/* Check if there is data passing into the constructor */
			if ( oInit.aaData ) {
				for ( i=0 ; i<oInit.aaData.length ; i++ ) {
					_fnAddData( oSettings, oInit.aaData[ i ] );
				}
			}
			else if ( oSettings.bDeferLoading || _fnDataSource( oSettings ) == 'dom' ) {
				/* Grab the data from the page - only do this when deferred loading or no Ajax
				 * source since there is no point in reading the DOM data if we are then going
				 * to replace it with Ajax data
				 */
				_fnAddTr( oSettings, $(oSettings.nTBody).children('tr') );
			}
		
			/* Copy the data index array */
			oSettings.aiDisplay = oSettings.aiDisplayMaster.slice();
		
			/* Initialisation complete - table can be drawn */
			oSettings.bInitialised = true;
		
			/* Check if we need to initialise the table (it might not have been handed off to the
			 * language processor)
			 */
			if ( bInitHandedOff === false ) {
				_fnInitialise( oSettings );
			}
		};
		
		/* Must be done after everything which can be overridden by the state saving! */
		_fnCallbackReg( oSettings, 'aoDrawCallback', _fnSaveState, 'state_save' );
		
		if ( oInit.bStateSave )
		{
			features.bStateSave = true;
			_fnLoadState( oSettings, oInit, loadedInit );
		}
		else {
			loadedInit();
		}
		
	} );
	_that = null;
	return this;
};


/*
 * It is useful to have variables which are scoped locally so only the
 * DataTables functions can access them and they don't leak into global space.
 * At the same time these functions are often useful over multiple files in the
 * core and API, so we list, or at least document, all variables which are used
 * by DataTables as private variables here. This also ensures that there is no
 * clashing of variable names and that they can easily referenced for reuse.
 */


// Defined else where
//  _selector_run
//  _selector_opts
//  _selector_first
//  _selector_row_indexes

var _ext; // DataTable.ext
var _Api; // DataTable.Api
var _api_register; // DataTable.Api.register
var _api_registerPlural; // DataTable.Api.registerPlural

var _re_dic = {};
var _re_new_lines = /[\r\n\u2028]/g;
var _re_html = /<.*?>/g;

// This is not strict ISO8601 - Date.parse() is quite lax, although
// implementations differ between browsers.
var _re_date = /^\d{2,4}[\.\/\-]\d{1,2}[\.\/\-]\d{1,2}([T ]{1}\d{1,2}[:\.]\d{2}([\.:]\d{2})?)?$/;

// Escape regular expression special characters
var _re_escape_regex = new RegExp( '(\\' + [ '/', '.', '*', '+', '?', '|', '(', ')', '[', ']', '{', '}', '\\', '$', '^', '-' ].join('|\\') + ')', 'g' );

// http://en.wikipedia.org/wiki/Foreign_exchange_market
// - \u20BD - Russian ruble.
// - \u20a9 - South Korean Won
// - \u20BA - Turkish Lira
// - \u20B9 - Indian Rupee
// - R - Brazil (R$) and South Africa
// - fr - Swiss Franc
// - kr - Swedish krona, Norwegian krone and Danish krone
// - \u2009 is thin space and \u202F is narrow no-break space, both used in many
// - Ƀ - Bitcoin
// - Ξ - Ethereum
//   standards as thousands separators.
var _re_formatted_numeric = /['\u00A0,$£€¥%\u2009\u202F\u20BD\u20a9\u20BArfkɃΞ]/gi;


var _empty = function ( d ) {
	return !d || d === true || d === '-' ? true : false;
};


var _intVal = function ( s ) {
	var integer = parseInt( s, 10 );
	return !isNaN(integer) && isFinite(s) ? integer : null;
};

// Convert from a formatted number with characters other than `.` as the
// decimal place, to a Javascript number
var _numToDecimal = function ( num, decimalPoint ) {
	// Cache created regular expressions for speed as this function is called often
	if ( ! _re_dic[ decimalPoint ] ) {
		_re_dic[ decimalPoint ] = new RegExp( _fnEscapeRegex( decimalPoint ), 'g' );
	}
	return typeof num === 'string' && decimalPoint !== '.' ?
		num.replace( /\./g, '' ).replace( _re_dic[ decimalPoint ], '.' ) :
		num;
};


var _isNumber = function ( d, decimalPoint, formatted ) {
	var type = typeof d;
	var strType = type === 'string';

	if ( type === 'number' || type === 'bigint') {
		return true;
	}

	// If empty return immediately so there must be a number if it is a
	// formatted string (this stops the string "k", or "kr", etc being detected
	// as a formatted number for currency
	if ( _empty( d ) ) {
		return true;
	}

	if ( decimalPoint && strType ) {
		d = _numToDecimal( d, decimalPoint );
	}

	if ( formatted && strType ) {
		d = d.replace( _re_formatted_numeric, '' );
	}

	return !isNaN( parseFloat(d) ) && isFinite( d );
};


// A string without HTML in it can be considered to be HTML still
var _isHtml = function ( d ) {
	return _empty( d ) || typeof d === 'string';
};


var _htmlNumeric = function ( d, decimalPoint, formatted ) {
	if ( _empty( d ) ) {
		return true;
	}

	var html = _isHtml( d );
	return ! html ?
		null :
		_isNumber( _stripHtml( d ), decimalPoint, formatted ) ?
			true :
			null;
};


var _pluck = function ( a, prop, prop2 ) {
	var out = [];
	var i=0, ien=a.length;

	// Could have the test in the loop for slightly smaller code, but speed
	// is essential here
	if ( prop2 !== undefined ) {
		for ( ; i<ien ; i++ ) {
			if ( a[i] && a[i][ prop ] ) {
				out.push( a[i][ prop ][ prop2 ] );
			}
		}
	}
	else {
		for ( ; i<ien ; i++ ) {
			if ( a[i] ) {
				out.push( a[i][ prop ] );
			}
		}
	}

	return out;
};


// Basically the same as _pluck, but rather than looping over `a` we use `order`
// as the indexes to pick from `a`
var _pluck_order = function ( a, order, prop, prop2 )
{
	var out = [];
	var i=0, ien=order.length;

	// Could have the test in the loop for slightly smaller code, but speed
	// is essential here
	if ( prop2 !== undefined ) {
		for ( ; i<ien ; i++ ) {
			if ( a[ order[i] ][ prop ] ) {
				out.push( a[ order[i] ][ prop ][ prop2 ] );
			}
		}
	}
	else {
		for ( ; i<ien ; i++ ) {
			out.push( a[ order[i] ][ prop ] );
		}
	}

	return out;
};


var _range = function ( len, start )
{
	var out = [];
	var end;

	if ( start === undefined ) {
		start = 0;
		end = len;
	}
	else {
		end = start;
		start = len;
	}

	for ( var i=start ; i<end ; i++ ) {
		out.push( i );
	}

	return out;
};


var _removeEmpty = function ( a )
{
	var out = [];

	for ( var i=0, ien=a.length ; i<ien ; i++ ) {
		if ( a[i] ) { // careful - will remove all falsy values!
			out.push( a[i] );
		}
	}

	return out;
};


var _stripHtml = function ( d ) {
	return d
		.replace( _re_html, '' ) // Complete tags
		.replace(/<script/i, ''); // Safety for incomplete script tag
};


/**
 * Determine if all values in the array are unique. This means we can short
 * cut the _unique method at the cost of a single loop. A sorted array is used
 * to easily check the values.
 *
 * @param  {array} src Source array
 * @return {boolean} true if all unique, false otherwise
 * @ignore
 */
var _areAllUnique = function ( src ) {
	if ( src.length < 2 ) {
		return true;
	}

	var sorted = src.slice().sort();
	var last = sorted[0];

	for ( var i=1, ien=sorted.length ; i<ien ; i++ ) {
		if ( sorted[i] === last ) {
			return false;
		}

		last = sorted[i];
	}

	return true;
};


/**
 * Find the unique elements in a source array.
 *
 * @param  {array} src Source array
 * @return {array} Array of unique items
 * @ignore
 */
var _unique = function ( src )
{
	if ( _areAllUnique( src ) ) {
		return src.slice();
	}

	// A faster unique method is to use object keys to identify used values,
	// but this doesn't work with arrays or objects, which we must also
	// consider. See jsperf.com/compare-array-unique-versions/4 for more
	// information.
	var
		out = [],
		val,
		i, ien=src.length,
		j, k=0;

	again: for ( i=0 ; i<ien ; i++ ) {
		val = src[i];

		for ( j=0 ; j<k ; j++ ) {
			if ( out[j] === val ) {
				continue again;
			}
		}

		out.push( val );
		k++;
	}

	return out;
};

// Surprisingly this is faster than [].concat.apply
// https://jsperf.com/flatten-an-array-loop-vs-reduce/2
var _flatten = function (out, val) {
	if (Array.isArray(val)) {
		for (var i=0 ; i<val.length ; i++) {
			_flatten(out, val[i]);
		}
	}
	else {
		out.push(val);
	}
  
	return out;
}

var _includes = function (search, start) {
	if (start === undefined) {
		start = 0;
	}

	return this.indexOf(search, start) !== -1;	
};

// Array.isArray polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray
if (! Array.isArray) {
    Array.isArray = function(arg) {
        return Object.prototype.toString.call(arg) === '[object Array]';
    };
}

if (! Array.prototype.includes) {
	Array.prototype.includes = _includes;
}

// .trim() polyfill
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/trim
if (!String.prototype.trim) {
  String.prototype.trim = function () {
    return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
  };
}

if (! String.prototype.includes) {
	String.prototype.includes = _includes;
}

/**
 * DataTables utility methods
 * 
 * This namespace provides helper methods that DataTables uses internally to
 * create a DataTable, but which are not exclusively used only for DataTables.
 * These methods can be used by extension authors to save the duplication of
 * code.
 *
 *  @namespace
 */
DataTable.util = {
	/**
	 * Throttle the calls to a function. Arguments and context are maintained
	 * for the throttled function.
	 *
	 * @param {function} fn Function to be called
	 * @param {integer} freq Call frequency in mS
	 * @return {function} Wrapped function
	 */
	throttle: function ( fn, freq ) {
		var
			frequency = freq !== undefined ? freq : 200,
			last,
			timer;

		return function () {
			var
				that = this,
				now  = +new Date(),
				args = arguments;

			if ( last && now < last + frequency ) {
				clearTimeout( timer );

				timer = setTimeout( function () {
					last = undefined;
					fn.apply( that, args );
				}, frequency );
			}
			else {
				last = now;
				fn.apply( that, args );
			}
		};
	},


	/**
	 * Escape a string such that it can be used in a regular expression
	 *
	 *  @param {string} val string to escape
	 *  @returns {string} escaped string
	 */
	escapeRegex: function ( val ) {
		return val.replace( _re_escape_regex, '\\$1' );
	},

	/**
	 * Create a function that will write to a nested object or array
	 * @param {*} source JSON notation string
	 * @returns Write function
	 */
	set: function ( source ) {
		if ( $.isPlainObject( source ) ) {
			/* Unlike get, only the underscore (global) option is used for for
			 * setting data since we don't know the type here. This is why an object
			 * option is not documented for `mData` (which is read/write), but it is
			 * for `mRender` which is read only.
			 */
			return DataTable.util.set( source._ );
		}
		else if ( source === null ) {
			// Nothing to do when the data source is null
			return function () {};
		}
		else if ( typeof source === 'function' ) {
			return function (data, val, meta) {
				source( data, 'set', val, meta );
			};
		}
		else if ( typeof source === 'string' && (source.indexOf('.') !== -1 ||
				  source.indexOf('[') !== -1 || source.indexOf('(') !== -1) )
		{
			// Like the get, we need to get data from a nested object
			var setData = function (data, val, src) {
				var a = _fnSplitObjNotation( src ), b;
				var aLast = a[a.length-1];
				var arrayNotation, funcNotation, o, innerSrc;
	
				for ( var i=0, iLen=a.length-1 ; i<iLen ; i++ ) {
					// Protect against prototype pollution
					if (a[i] === '__proto__' || a[i] === 'constructor') {
						throw new Error('Cannot set prototype values');
					}
	
					// Check if we are dealing with an array notation request
					arrayNotation = a[i].match(__reArray);
					funcNotation = a[i].match(__reFn);
	
					if ( arrayNotation ) {
						a[i] = a[i].replace(__reArray, '');
						data[ a[i] ] = [];
	
						// Get the remainder of the nested object to set so we can recurse
						b = a.slice();
						b.splice( 0, i+1 );
						innerSrc = b.join('.');
	
						// Traverse each entry in the array setting the properties requested
						if ( Array.isArray( val ) ) {
							for ( var j=0, jLen=val.length ; j<jLen ; j++ ) {
								o = {};
								setData( o, val[j], innerSrc );
								data[ a[i] ].push( o );
							}
						}
						else {
							// We've been asked to save data to an array, but it
							// isn't array data to be saved. Best that can be done
							// is to just save the value.
							data[ a[i] ] = val;
						}
	
						// The inner call to setData has already traversed through the remainder
						// of the source and has set the data, thus we can exit here
						return;
					}
					else if ( funcNotation ) {
						// Function call
						a[i] = a[i].replace(__reFn, '');
						data = data[ a[i] ]( val );
					}
	
					// If the nested object doesn't currently exist - since we are
					// trying to set the value - create it
					if ( data[ a[i] ] === null || data[ a[i] ] === undefined ) {
						data[ a[i] ] = {};
					}
					data = data[ a[i] ];
				}
	
				// Last item in the input - i.e, the actual set
				if ( aLast.match(__reFn ) ) {
					// Function call
					data = data[ aLast.replace(__reFn, '') ]( val );
				}
				else {
					// If array notation is used, we just want to strip it and use the property name
					// and assign the value. If it isn't used, then we get the result we want anyway
					data[ aLast.replace(__reArray, '') ] = val;
				}
			};
	
			return function (data, val) { // meta is also passed in, but not used
				return setData( data, val, source );
			};
		}
		else {
			// Array or flat object mapping
			return function (data, val) { // meta is also passed in, but not used
				data[source] = val;
			};
		}
	},

	/**
	 * Create a function that will read nested objects from arrays, based on JSON notation
	 * @param {*} source JSON notation string
	 * @returns Value read
	 */
	get: function ( source ) {
		if ( $.isPlainObject( source ) ) {
			// Build an object of get functions, and wrap them in a single call
			var o = {};
			$.each( source, function (key, val) {
				if ( val ) {
					o[key] = DataTable.util.get( val );
				}
			} );
	
			return function (data, type, row, meta) {
				var t = o[type] || o._;
				return t !== undefined ?
					t(data, type, row, meta) :
					data;
			};
		}
		else if ( source === null ) {
			// Give an empty string for rendering / sorting etc
			return function (data) { // type, row and meta also passed, but not used
				return data;
			};
		}
		else if ( typeof source === 'function' ) {
			return function (data, type, row, meta) {
				return source( data, type, row, meta );
			};
		}
		else if ( typeof source === 'string' && (source.indexOf('.') !== -1 ||
				  source.indexOf('[') !== -1 || source.indexOf('(') !== -1) )
		{
			/* If there is a . in the source string then the data source is in a
			 * nested object so we loop over the data for each level to get the next
			 * level down. On each loop we test for undefined, and if found immediately
			 * return. This allows entire objects to be missing and sDefaultContent to
			 * be used if defined, rather than throwing an error
			 */
			var fetchData = function (data, type, src) {
				var arrayNotation, funcNotation, out, innerSrc;
	
				if ( src !== "" ) {
					var a = _fnSplitObjNotation( src );
	
					for ( var i=0, iLen=a.length ; i<iLen ; i++ ) {
						// Check if we are dealing with special notation
						arrayNotation = a[i].match(__reArray);
						funcNotation = a[i].match(__reFn);
	
						if ( arrayNotation ) {
							// Array notation
							a[i] = a[i].replace(__reArray, '');
	
							// Condition allows simply [] to be passed in
							if ( a[i] !== "" ) {
								data = data[ a[i] ];
							}
							out = [];
	
							// Get the remainder of the nested object to get
							a.splice( 0, i+1 );
							innerSrc = a.join('.');
	
							// Traverse each entry in the array getting the properties requested
							if ( Array.isArray( data ) ) {
								for ( var j=0, jLen=data.length ; j<jLen ; j++ ) {
									out.push( fetchData( data[j], type, innerSrc ) );
								}
							}
	
							// If a string is given in between the array notation indicators, that
							// is used to join the strings together, otherwise an array is returned
							var join = arrayNotation[0].substring(1, arrayNotation[0].length-1);
							data = (join==="") ? out : out.join(join);
	
							// The inner call to fetchData has already traversed through the remainder
							// of the source requested, so we exit from the loop
							break;
						}
						else if ( funcNotation ) {
							// Function call
							a[i] = a[i].replace(__reFn, '');
							data = data[ a[i] ]();
							continue;
						}
	
						if (data === null || data[ a[i] ] === null) {
							return null;
						}
						else if ( data === undefined || data[ a[i] ] === undefined ) {
							return undefined;
						}

						data = data[ a[i] ];
					}
				}
	
				return data;
			};
	
			return function (data, type) { // row and meta also passed, but not used
				return fetchData( data, type, source );
			};
		}
		else {
			// Array or flat object mapping
			return function (data, type) { // row and meta also passed, but not used
				return data[source];
			};
		}
	}
};



/**
 * Create a mapping object that allows camel case parameters to be looked up
 * for their Hungarian counterparts. The mapping is stored in a private
 * parameter called `_hungarianMap` which can be accessed on the source object.
 *  @param {object} o
 *  @memberof DataTable#oApi
 */
function _fnHungarianMap ( o )
{
	var
		hungarian = 'a aa ai ao as b fn i m o s ',
		match,
		newKey,
		map = {};

	$.each( o, function (key, val) {
		match = key.match(/^([^A-Z]+?)([A-Z])/);

		if ( match && hungarian.indexOf(match[1]+' ') !== -1 )
		{
			newKey = key.replace( match[0], match[2].toLowerCase() );
			map[ newKey ] = key;

			if ( match[1] === 'o' )
			{
				_fnHungarianMap( o[key] );
			}
		}
	} );

	o._hungarianMap = map;
}


/**
 * Convert from camel case parameters to Hungarian, based on a Hungarian map
 * created by _fnHungarianMap.
 *  @param {object} src The model object which holds all parameters that can be
 *    mapped.
 *  @param {object} user The object to convert from camel case to Hungarian.
 *  @param {boolean} force When set to `true`, properties which already have a
 *    Hungarian value in the `user` object will be overwritten. Otherwise they
 *    won't be.
 *  @memberof DataTable#oApi
 */
function _fnCamelToHungarian ( src, user, force )
{
	if ( ! src._hungarianMap ) {
		_fnHungarianMap( src );
	}

	var hungarianKey;

	$.each( user, function (key, val) {
		hungarianKey = src._hungarianMap[ key ];

		if ( hungarianKey !== undefined && (force || user[hungarianKey] === undefined) )
		{
			// For objects, we need to buzz down into the object to copy parameters
			if ( hungarianKey.charAt(0) === 'o' )
			{
				// Copy the camelCase options over to the hungarian
				if ( ! user[ hungarianKey ] ) {
					user[ hungarianKey ] = {};
				}
				$.extend( true, user[hungarianKey], user[key] );

				_fnCamelToHungarian( src[hungarianKey], user[hungarianKey], force );
			}
			else {
				user[hungarianKey] = user[ key ];
			}
		}
	} );
}


/**
 * Language compatibility - when certain options are given, and others aren't, we
 * need to duplicate the values over, in order to provide backwards compatibility
 * with older language files.
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnLanguageCompat( lang )
{
	// Note the use of the Hungarian notation for the parameters in this method as
	// this is called after the mapping of camelCase to Hungarian
	var defaults = DataTable.defaults.oLanguage;

	// Default mapping
	var defaultDecimal = defaults.sDecimal;
	if ( defaultDecimal ) {
		_addNumericSort( defaultDecimal );
	}

	if ( lang ) {
		var zeroRecords = lang.sZeroRecords;

		// Backwards compatibility - if there is no sEmptyTable given, then use the same as
		// sZeroRecords - assuming that is given.
		if ( ! lang.sEmptyTable && zeroRecords &&
			defaults.sEmptyTable === "No data available in table" )
		{
			_fnMap( lang, lang, 'sZeroRecords', 'sEmptyTable' );
		}

		// Likewise with loading records
		if ( ! lang.sLoadingRecords && zeroRecords &&
			defaults.sLoadingRecords === "Loading..." )
		{
			_fnMap( lang, lang, 'sZeroRecords', 'sLoadingRecords' );
		}

		// Old parameter name of the thousands separator mapped onto the new
		if ( lang.sInfoThousands ) {
			lang.sThousands = lang.sInfoThousands;
		}

		var decimal = lang.sDecimal;
		if ( decimal && defaultDecimal !== decimal ) {
			_addNumericSort( decimal );
		}
	}
}


/**
 * Map one parameter onto another
 *  @param {object} o Object to map
 *  @param {*} knew The new parameter name
 *  @param {*} old The old parameter name
 */
var _fnCompatMap = function ( o, knew, old ) {
	if ( o[ knew ] !== undefined ) {
		o[ old ] = o[ knew ];
	}
};


/**
 * Provide backwards compatibility for the main DT options. Note that the new
 * options are mapped onto the old parameters, so this is an external interface
 * change only.
 *  @param {object} init Object to map
 */
function _fnCompatOpts ( init )
{
	_fnCompatMap( init, 'ordering',      'bSort' );
	_fnCompatMap( init, 'orderMulti',    'bSortMulti' );
	_fnCompatMap( init, 'orderClasses',  'bSortClasses' );
	_fnCompatMap( init, 'orderCellsTop', 'bSortCellsTop' );
	_fnCompatMap( init, 'order',         'aaSorting' );
	_fnCompatMap( init, 'orderFixed',    'aaSortingFixed' );
	_fnCompatMap( init, 'paging',        'bPaginate' );
	_fnCompatMap( init, 'pagingType',    'sPaginationType' );
	_fnCompatMap( init, 'pageLength',    'iDisplayLength' );
	_fnCompatMap( init, 'searching',     'bFilter' );

	// Boolean initialisation of x-scrolling
	if ( typeof init.sScrollX === 'boolean' ) {
		init.sScrollX = init.sScrollX ? '100%' : '';
	}
	if ( typeof init.scrollX === 'boolean' ) {
		init.scrollX = init.scrollX ? '100%' : '';
	}

	// Column search objects are in an array, so it needs to be converted
	// element by element
	var searchCols = init.aoSearchCols;

	if ( searchCols ) {
		for ( var i=0, ien=searchCols.length ; i<ien ; i++ ) {
			if ( searchCols[i] ) {
				_fnCamelToHungarian( DataTable.models.oSearch, searchCols[i] );
			}
		}
	}
}


/**
 * Provide backwards compatibility for column options. Note that the new options
 * are mapped onto the old parameters, so this is an external interface change
 * only.
 *  @param {object} init Object to map
 */
function _fnCompatCols ( init )
{
	_fnCompatMap( init, 'orderable',     'bSortable' );
	_fnCompatMap( init, 'orderData',     'aDataSort' );
	_fnCompatMap( init, 'orderSequence', 'asSorting' );
	_fnCompatMap( init, 'orderDataType', 'sortDataType' );

	// orderData can be given as an integer
	var dataSort = init.aDataSort;
	if ( typeof dataSort === 'number' && ! Array.isArray( dataSort ) ) {
		init.aDataSort = [ dataSort ];
	}
}


/**
 * Browser feature detection for capabilities, quirks
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnBrowserDetect( settings )
{
	// We don't need to do this every time DataTables is constructed, the values
	// calculated are specific to the browser and OS configuration which we
	// don't expect to change between initialisations
	if ( ! DataTable.__browser ) {
		var browser = {};
		DataTable.__browser = browser;

		// Scrolling feature / quirks detection
		var n = $('<div/>')
			.css( {
				position: 'fixed',
				top: 0,
				left: $(window).scrollLeft()*-1, // allow for scrolling
				height: 1,
				width: 1,
				overflow: 'hidden'
			} )
			.append(
				$('<div/>')
					.css( {
						position: 'absolute',
						top: 1,
						left: 1,
						width: 100,
						overflow: 'scroll'
					} )
					.append(
						$('<div/>')
							.css( {
								width: '100%',
								height: 10
							} )
					)
			)
			.appendTo( 'body' );

		var outer = n.children();
		var inner = outer.children();

		// Numbers below, in order, are:
		// inner.offsetWidth, inner.clientWidth, outer.offsetWidth, outer.clientWidth
		//
		// IE6 XP:                           100 100 100  83
		// IE7 Vista:                        100 100 100  83
		// IE 8+ Windows:                     83  83 100  83
		// Evergreen Windows:                 83  83 100  83
		// Evergreen Mac with scrollbars:     85  85 100  85
		// Evergreen Mac without scrollbars: 100 100 100 100

		// Get scrollbar width
		browser.barWidth = outer[0].offsetWidth - outer[0].clientWidth;

		// IE6/7 will oversize a width 100% element inside a scrolling element, to
		// include the width of the scrollbar, while other browsers ensure the inner
		// element is contained without forcing scrolling
		browser.bScrollOversize = inner[0].offsetWidth === 100 && outer[0].clientWidth !== 100;

		// In rtl text layout, some browsers (most, but not all) will place the
		// scrollbar on the left, rather than the right.
		browser.bScrollbarLeft = Math.round( inner.offset().left ) !== 1;

		// IE8- don't provide height and width for getBoundingClientRect
		browser.bBounding = n[0].getBoundingClientRect().width ? true : false;

		n.remove();
	}

	$.extend( settings.oBrowser, DataTable.__browser );
	settings.oScroll.iBarWidth = DataTable.__browser.barWidth;
}


/**
 * Array.prototype reduce[Right] method, used for browsers which don't support
 * JS 1.6. Done this way to reduce code size, since we iterate either way
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnReduce ( that, fn, init, start, end, inc )
{
	var
		i = start,
		value,
		isSet = false;

	if ( init !== undefined ) {
		value = init;
		isSet = true;
	}

	while ( i !== end ) {
		if ( ! that.hasOwnProperty(i) ) {
			continue;
		}

		value = isSet ?
			fn( value, that[i], i, that ) :
			that[i];

		isSet = true;
		i += inc;
	}

	return value;
}

/**
 * Add a column to the list used for the table with default values
 *  @param {object} oSettings dataTables settings object
 *  @param {node} nTh The th element for this column
 *  @memberof DataTable#oApi
 */
function _fnAddColumn( oSettings, nTh )
{
	// Add column to aoColumns array
	var oDefaults = DataTable.defaults.column;
	var iCol = oSettings.aoColumns.length;
	var oCol = $.extend( {}, DataTable.models.oColumn, oDefaults, {
		"nTh": nTh ? nTh : document.createElement('th'),
		"sTitle":    oDefaults.sTitle    ? oDefaults.sTitle    : nTh ? nTh.innerHTML : '',
		"aDataSort": oDefaults.aDataSort ? oDefaults.aDataSort : [iCol],
		"mData": oDefaults.mData ? oDefaults.mData : iCol,
		idx: iCol
	} );
	oSettings.aoColumns.push( oCol );

	// Add search object for column specific search. Note that the `searchCols[ iCol ]`
	// passed into extend can be undefined. This allows the user to give a default
	// with only some of the parameters defined, and also not give a default
	var searchCols = oSettings.aoPreSearchCols;
	searchCols[ iCol ] = $.extend( {}, DataTable.models.oSearch, searchCols[ iCol ] );

	// Use the default column options function to initialise classes etc
	_fnColumnOptions( oSettings, iCol, $(nTh).data() );
}


/**
 * Apply options for a column
 *  @param {object} oSettings dataTables settings object
 *  @param {int} iCol column index to consider
 *  @param {object} oOptions object with sType, bVisible and bSearchable etc
 *  @memberof DataTable#oApi
 */
function _fnColumnOptions( oSettings, iCol, oOptions )
{
	var oCol = oSettings.aoColumns[ iCol ];
	var oClasses = oSettings.oClasses;
	var th = $(oCol.nTh);

	// Try to get width information from the DOM. We can't get it from CSS
	// as we'd need to parse the CSS stylesheet. `width` option can override
	if ( ! oCol.sWidthOrig ) {
		// Width attribute
		oCol.sWidthOrig = th.attr('width') || null;

		// Style attribute
		var t = (th.attr('style') || '').match(/width:\s*(\d+[pxem%]+)/);
		if ( t ) {
			oCol.sWidthOrig = t[1];
		}
	}

	/* User specified column options */
	if ( oOptions !== undefined && oOptions !== null )
	{
		// Backwards compatibility
		_fnCompatCols( oOptions );

		// Map camel case parameters to their Hungarian counterparts
		_fnCamelToHungarian( DataTable.defaults.column, oOptions, true );

		/* Backwards compatibility for mDataProp */
		if ( oOptions.mDataProp !== undefined && !oOptions.mData )
		{
			oOptions.mData = oOptions.mDataProp;
		}

		if ( oOptions.sType )
		{
			oCol._sManualType = oOptions.sType;
		}

		// `class` is a reserved word in Javascript, so we need to provide
		// the ability to use a valid name for the camel case input
		if ( oOptions.className && ! oOptions.sClass )
		{
			oOptions.sClass = oOptions.className;
		}
		if ( oOptions.sClass ) {
			th.addClass( oOptions.sClass );
		}

		var origClass = oCol.sClass;

		$.extend( oCol, oOptions );
		_fnMap( oCol, oOptions, "sWidth", "sWidthOrig" );

		// Merge class from previously defined classes with this one, rather than just
		// overwriting it in the extend above
		if (origClass !== oCol.sClass) {
			oCol.sClass = origClass + ' ' + oCol.sClass;
		}

		/* iDataSort to be applied (backwards compatibility), but aDataSort will take
		 * priority if defined
		 */
		if ( oOptions.iDataSort !== undefined )
		{
			oCol.aDataSort = [ oOptions.iDataSort ];
		}
		_fnMap( oCol, oOptions, "aDataSort" );
	}

	/* Cache the data get and set functions for speed */
	var mDataSrc = oCol.mData;
	var mData = _fnGetObjectDataFn( mDataSrc );
	var mRender = oCol.mRender ? _fnGetObjectDataFn( oCol.mRender ) : null;

	var attrTest = function( src ) {
		return typeof src === 'string' && src.indexOf('@') !== -1;
	};
	oCol._bAttrSrc = $.isPlainObject( mDataSrc ) && (
		attrTest(mDataSrc.sort) || attrTest(mDataSrc.type) || attrTest(mDataSrc.filter)
	);
	oCol._setter = null;

	oCol.fnGetData = function (rowData, type, meta) {
		var innerData = mData( rowData, type, undefined, meta );

		return mRender && type ?
			mRender( innerData, type, rowData, meta ) :
			innerData;
	};
	oCol.fnSetData = function ( rowData, val, meta ) {
		return _fnSetObjectDataFn( mDataSrc )( rowData, val, meta );
	};

	// Indicate if DataTables should read DOM data as an object or array
	// Used in _fnGetRowElements
	if ( typeof mDataSrc !== 'number' && ! oCol._isArrayHost ) {
		oSettings._rowReadObject = true;
	}

	/* Feature sorting overrides column specific when off */
	if ( !oSettings.oFeatures.bSort )
	{
		oCol.bSortable = false;
		th.addClass( oClasses.sSortableNone ); // Have to add class here as order event isn't called
	}

	/* Check that the class assignment is correct for sorting */
	var bAsc = $.inArray('asc', oCol.asSorting) !== -1;
	var bDesc = $.inArray('desc', oCol.asSorting) !== -1;
	if ( !oCol.bSortable || (!bAsc && !bDesc) )
	{
		oCol.sSortingClass = oClasses.sSortableNone;
		oCol.sSortingClassJUI = "";
	}
	else if ( bAsc && !bDesc )
	{
		oCol.sSortingClass = oClasses.sSortableAsc;
		oCol.sSortingClassJUI = oClasses.sSortJUIAscAllowed;
	}
	else if ( !bAsc && bDesc )
	{
		oCol.sSortingClass = oClasses.sSortableDesc;
		oCol.sSortingClassJUI = oClasses.sSortJUIDescAllowed;
	}
	else
	{
		oCol.sSortingClass = oClasses.sSortable;
		oCol.sSortingClassJUI = oClasses.sSortJUI;
	}
}


/**
 * Adjust the table column widths for new data. Note: you would probably want to
 * do a redraw after calling this function!
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnAdjustColumnSizing ( settings )
{
	/* Not interested in doing column width calculation if auto-width is disabled */
	if ( settings.oFeatures.bAutoWidth !== false )
	{
		var columns = settings.aoColumns;

		_fnCalculateColumnWidths( settings );
		for ( var i=0 , iLen=columns.length ; i<iLen ; i++ )
		{
			columns[i].nTh.style.width = columns[i].sWidth;
		}
	}

	var scroll = settings.oScroll;
	if ( scroll.sY !== '' || scroll.sX !== '')
	{
		_fnScrollDraw( settings );
	}

	_fnCallbackFire( settings, null, 'column-sizing', [settings] );
}


/**
 * Convert the index of a visible column to the index in the data array (take account
 * of hidden columns)
 *  @param {object} oSettings dataTables settings object
 *  @param {int} iMatch Visible column index to lookup
 *  @returns {int} i the data index
 *  @memberof DataTable#oApi
 */
function _fnVisibleToColumnIndex( oSettings, iMatch )
{
	var aiVis = _fnGetColumns( oSettings, 'bVisible' );

	return typeof aiVis[iMatch] === 'number' ?
		aiVis[iMatch] :
		null;
}


/**
 * Convert the index of an index in the data array and convert it to the visible
 *   column index (take account of hidden columns)
 *  @param {int} iMatch Column index to lookup
 *  @param {object} oSettings dataTables settings object
 *  @returns {int} i the data index
 *  @memberof DataTable#oApi
 */
function _fnColumnIndexToVisible( oSettings, iMatch )
{
	var aiVis = _fnGetColumns( oSettings, 'bVisible' );
	var iPos = $.inArray( iMatch, aiVis );

	return iPos !== -1 ? iPos : null;
}


/**
 * Get the number of visible columns
 *  @param {object} oSettings dataTables settings object
 *  @returns {int} i the number of visible columns
 *  @memberof DataTable#oApi
 */
function _fnVisbleColumns( oSettings )
{
	var vis = 0;

	// No reduce in IE8, use a loop for now
	$.each( oSettings.aoColumns, function ( i, col ) {
		if ( col.bVisible && $(col.nTh).css('display') !== 'none' ) {
			vis++;
		}
	} );

	return vis;
}


/**
 * Get an array of column indexes that match a given property
 *  @param {object} oSettings dataTables settings object
 *  @param {string} sParam Parameter in aoColumns to look for - typically
 *    bVisible or bSearchable
 *  @returns {array} Array of indexes with matched properties
 *  @memberof DataTable#oApi
 */
function _fnGetColumns( oSettings, sParam )
{
	var a = [];

	$.map( oSettings.aoColumns, function(val, i) {
		if ( val[sParam] ) {
			a.push( i );
		}
	} );

	return a;
}


/**
 * Calculate the 'type' of a column
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnColumnTypes ( settings )
{
	var columns = settings.aoColumns;
	var data = settings.aoData;
	var types = DataTable.ext.type.detect;
	var i, ien, j, jen, k, ken;
	var col, cell, detectedType, cache;

	// For each column, spin over the 
	for ( i=0, ien=columns.length ; i<ien ; i++ ) {
		col = columns[i];
		cache = [];

		if ( ! col.sType && col._sManualType ) {
			col.sType = col._sManualType;
		}
		else if ( ! col.sType ) {
			for ( j=0, jen=types.length ; j<jen ; j++ ) {
				for ( k=0, ken=data.length ; k<ken ; k++ ) {
					// Use a cache array so we only need to get the type data
					// from the formatter once (when using multiple detectors)
					if ( cache[k] === undefined ) {
						cache[k] = _fnGetCellData( settings, k, i, 'type' );
					}

					detectedType = types[j]( cache[k], settings );

					// If null, then this type can't apply to this column, so
					// rather than testing all cells, break out. There is an
					// exception for the last type which is `html`. We need to
					// scan all rows since it is possible to mix string and HTML
					// types
					if ( ! detectedType && j !== types.length-1 ) {
						break;
					}

					// Only a single match is needed for html type since it is
					// bottom of the pile and very similar to string - but it
					// must not be empty
					if ( detectedType === 'html' && ! _empty(cache[k]) ) {
						break;
					}
				}

				// Type is valid for all data points in the column - use this
				// type
				if ( detectedType ) {
					col.sType = detectedType;
					break;
				}
			}

			// Fall back - if no type was detected, always use string
			if ( ! col.sType ) {
				col.sType = 'string';
			}
		}
	}
}


/**
 * Take the column definitions and static columns arrays and calculate how
 * they relate to column indexes. The callback function will then apply the
 * definition found for a column to a suitable configuration object.
 *  @param {object} oSettings dataTables settings object
 *  @param {array} aoColDefs The aoColumnDefs array that is to be applied
 *  @param {array} aoCols The aoColumns array that defines columns individually
 *  @param {function} fn Callback function - takes two parameters, the calculated
 *    column index and the definition for that column.
 *  @memberof DataTable#oApi
 */
function _fnApplyColumnDefs( oSettings, aoColDefs, aoCols, fn )
{
	var i, iLen, j, jLen, k, kLen, def;
	var columns = oSettings.aoColumns;

	// Column definitions with aTargets
	if ( aoColDefs )
	{
		/* Loop over the definitions array - loop in reverse so first instance has priority */
		for ( i=aoColDefs.length-1 ; i>=0 ; i-- )
		{
			def = aoColDefs[i];

			/* Each definition can target multiple columns, as it is an array */
			var aTargets = def.target !== undefined
				? def.target
				: def.targets !== undefined
					? def.targets
					: def.aTargets;

			if ( ! Array.isArray( aTargets ) )
			{
				aTargets = [ aTargets ];
			}

			for ( j=0, jLen=aTargets.length ; j<jLen ; j++ )
			{
				if ( typeof aTargets[j] === 'number' && aTargets[j] >= 0 )
				{
					/* Add columns that we don't yet know about */
					while( columns.length <= aTargets[j] )
					{
						_fnAddColumn( oSettings );
					}

					/* Integer, basic index */
					fn( aTargets[j], def );
				}
				else if ( typeof aTargets[j] === 'number' && aTargets[j] < 0 )
				{
					/* Negative integer, right to left column counting */
					fn( columns.length+aTargets[j], def );
				}
				else if ( typeof aTargets[j] === 'string' )
				{
					/* Class name matching on TH element */
					for ( k=0, kLen=columns.length ; k<kLen ; k++ )
					{
						if ( aTargets[j] == "_all" ||
						     $(columns[k].nTh).hasClass( aTargets[j] ) )
						{
							fn( k, def );
						}
					}
				}
			}
		}
	}

	// Statically defined columns array
	if ( aoCols )
	{
		for ( i=0, iLen=aoCols.length ; i<iLen ; i++ )
		{
			fn( i, aoCols[i] );
		}
	}
}

/**
 * Add a data array to the table, creating DOM node etc. This is the parallel to
 * _fnGatherData, but for adding rows from a Javascript source, rather than a
 * DOM source.
 *  @param {object} oSettings dataTables settings object
 *  @param {array} aData data array to be added
 *  @param {node} [nTr] TR element to add to the table - optional. If not given,
 *    DataTables will create a row automatically
 *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
 *    if nTr is.
 *  @returns {int} >=0 if successful (index of new aoData entry), -1 if failed
 *  @memberof DataTable#oApi
 */
function _fnAddData ( oSettings, aDataIn, nTr, anTds )
{
	/* Create the object for storing information about this new row */
	var iRow = oSettings.aoData.length;
	var oData = $.extend( true, {}, DataTable.models.oRow, {
		src: nTr ? 'dom' : 'data',
		idx: iRow
	} );

	oData._aData = aDataIn;
	oSettings.aoData.push( oData );

	/* Create the cells */
	var nTd, sThisType;
	var columns = oSettings.aoColumns;

	// Invalidate the column types as the new data needs to be revalidated
	for ( var i=0, iLen=columns.length ; i<iLen ; i++ )
	{
		columns[i].sType = null;
	}

	/* Add to the display array */
	oSettings.aiDisplayMaster.push( iRow );

	var id = oSettings.rowIdFn( aDataIn );
	if ( id !== undefined ) {
		oSettings.aIds[ id ] = oData;
	}

	/* Create the DOM information, or register it if already present */
	if ( nTr || ! oSettings.oFeatures.bDeferRender )
	{
		_fnCreateTr( oSettings, iRow, nTr, anTds );
	}

	return iRow;
}


/**
 * Add one or more TR elements to the table. Generally we'd expect to
 * use this for reading data from a DOM sourced table, but it could be
 * used for an TR element. Note that if a TR is given, it is used (i.e.
 * it is not cloned).
 *  @param {object} settings dataTables settings object
 *  @param {array|node|jQuery} trs The TR element(s) to add to the table
 *  @returns {array} Array of indexes for the added rows
 *  @memberof DataTable#oApi
 */
function _fnAddTr( settings, trs )
{
	var row;

	// Allow an individual node to be passed in
	if ( ! (trs instanceof $) ) {
		trs = $(trs);
	}

	return trs.map( function (i, el) {
		row = _fnGetRowElements( settings, el );
		return _fnAddData( settings, row.data, el, row.cells );
	} );
}


/**
 * Take a TR element and convert it to an index in aoData
 *  @param {object} oSettings dataTables settings object
 *  @param {node} n the TR element to find
 *  @returns {int} index if the node is found, null if not
 *  @memberof DataTable#oApi
 */
function _fnNodeToDataIndex( oSettings, n )
{
	return (n._DT_RowIndex!==undefined) ? n._DT_RowIndex : null;
}


/**
 * Take a TD element and convert it into a column data index (not the visible index)
 *  @param {object} oSettings dataTables settings object
 *  @param {int} iRow The row number the TD/TH can be found in
 *  @param {node} n The TD/TH element to find
 *  @returns {int} index if the node is found, -1 if not
 *  @memberof DataTable#oApi
 */
function _fnNodeToColumnIndex( oSettings, iRow, n )
{
	return $.inArray( n, oSettings.aoData[ iRow ].anCells );
}


/**
 * Get the data for a given cell from the internal cache, taking into account data mapping
 *  @param {object} settings dataTables settings object
 *  @param {int} rowIdx aoData row id
 *  @param {int} colIdx Column index
 *  @param {string} type data get type ('display', 'type' 'filter|search' 'sort|order')
 *  @returns {*} Cell data
 *  @memberof DataTable#oApi
 */
function _fnGetCellData( settings, rowIdx, colIdx, type )
{
	if (type === 'search') {
		type = 'filter';
	}
	else if (type === 'order') {
		type = 'sort';
	}

	var draw           = settings.iDraw;
	var col            = settings.aoColumns[colIdx];
	var rowData        = settings.aoData[rowIdx]._aData;
	var defaultContent = col.sDefaultContent;
	var cellData       = col.fnGetData( rowData, type, {
		settings: settings,
		row:      rowIdx,
		col:      colIdx
	} );

	if ( cellData === undefined ) {
		if ( settings.iDrawError != draw && defaultContent === null ) {
			_fnLog( settings, 0, "Requested unknown parameter "+
				(typeof col.mData=='function' ? '{function}' : "'"+col.mData+"'")+
				" for row "+rowIdx+", column "+colIdx, 4 );
			settings.iDrawError = draw;
		}
		return defaultContent;
	}

	// When the data source is null and a specific data type is requested (i.e.
	// not the original data), we can use default column data
	if ( (cellData === rowData || cellData === null) && defaultContent !== null && type !== undefined ) {
		cellData = defaultContent;
	}
	else if ( typeof cellData === 'function' ) {
		// If the data source is a function, then we run it and use the return,
		// executing in the scope of the data object (for instances)
		return cellData.call( rowData );
	}

	if ( cellData === null && type === 'display' ) {
		return '';
	}

	if ( type === 'filter' ) {
		var fomatters = DataTable.ext.type.search;

		if ( fomatters[ col.sType ] ) {
			cellData = fomatters[ col.sType ]( cellData );
		}
	}

	return cellData;
}


/**
 * Set the value for a specific cell, into the internal data cache
 *  @param {object} settings dataTables settings object
 *  @param {int} rowIdx aoData row id
 *  @param {int} colIdx Column index
 *  @param {*} val Value to set
 *  @memberof DataTable#oApi
 */
function _fnSetCellData( settings, rowIdx, colIdx, val )
{
	var col     = settings.aoColumns[colIdx];
	var rowData = settings.aoData[rowIdx]._aData;

	col.fnSetData( rowData, val, {
		settings: settings,
		row:      rowIdx,
		col:      colIdx
	}  );
}


// Private variable that is used to match action syntax in the data property object
var __reArray = /\[.*?\]$/;
var __reFn = /\(\)$/;

/**
 * Split string on periods, taking into account escaped periods
 * @param  {string} str String to split
 * @return {array} Split string
 */
function _fnSplitObjNotation( str )
{
	return $.map( str.match(/(\\.|[^\.])+/g) || [''], function ( s ) {
		return s.replace(/\\\./g, '.');
	} );
}


/**
 * Return a function that can be used to get data from a source object, taking
 * into account the ability to use nested objects as a source
 *  @param {string|int|function} mSource The data source for the object
 *  @returns {function} Data get function
 *  @memberof DataTable#oApi
 */
var _fnGetObjectDataFn = DataTable.util.get;


/**
 * Return a function that can be used to set data from a source object, taking
 * into account the ability to use nested objects as a source
 *  @param {string|int|function} mSource The data source for the object
 *  @returns {function} Data set function
 *  @memberof DataTable#oApi
 */
var _fnSetObjectDataFn = DataTable.util.set;


/**
 * Return an array with the full table data
 *  @param {object} oSettings dataTables settings object
 *  @returns array {array} aData Master data array
 *  @memberof DataTable#oApi
 */
function _fnGetDataMaster ( settings )
{
	return _pluck( settings.aoData, '_aData' );
}


/**
 * Nuke the table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnClearTable( settings )
{
	settings.aoData.length = 0;
	settings.aiDisplayMaster.length = 0;
	settings.aiDisplay.length = 0;
	settings.aIds = {};
}


 /**
 * Take an array of integers (index array) and remove a target integer (value - not
 * the key!)
 *  @param {array} a Index array to target
 *  @param {int} iTarget value to find
 *  @memberof DataTable#oApi
 */
function _fnDeleteIndex( a, iTarget, splice )
{
	var iTargetIndex = -1;

	for ( var i=0, iLen=a.length ; i<iLen ; i++ )
	{
		if ( a[i] == iTarget )
		{
			iTargetIndex = i;
		}
		else if ( a[i] > iTarget )
		{
			a[i]--;
		}
	}

	if ( iTargetIndex != -1 && splice === undefined )
	{
		a.splice( iTargetIndex, 1 );
	}
}


/**
 * Mark cached data as invalid such that a re-read of the data will occur when
 * the cached data is next requested. Also update from the data source object.
 *
 * @param {object} settings DataTables settings object
 * @param {int}    rowIdx   Row index to invalidate
 * @param {string} [src]    Source to invalidate from: undefined, 'auto', 'dom'
 *     or 'data'
 * @param {int}    [colIdx] Column index to invalidate. If undefined the whole
 *     row will be invalidated
 * @memberof DataTable#oApi
 *
 * @todo For the modularisation of v1.11 this will need to become a callback, so
 *   the sort and filter methods can subscribe to it. That will required
 *   initialisation options for sorting, which is why it is not already baked in
 */
function _fnInvalidate( settings, rowIdx, src, colIdx )
{
	var row = settings.aoData[ rowIdx ];
	var i, ien;
	var cellWrite = function ( cell, col ) {
		// This is very frustrating, but in IE if you just write directly
		// to innerHTML, and elements that are overwritten are GC'ed,
		// even if there is a reference to them elsewhere
		while ( cell.childNodes.length ) {
			cell.removeChild( cell.firstChild );
		}

		cell.innerHTML = _fnGetCellData( settings, rowIdx, col, 'display' );
	};

	// Are we reading last data from DOM or the data object?
	if ( src === 'dom' || ((! src || src === 'auto') && row.src === 'dom') ) {
		// Read the data from the DOM
		row._aData = _fnGetRowElements(
				settings, row, colIdx, colIdx === undefined ? undefined : row._aData
			)
			.data;
	}
	else {
		// Reading from data object, update the DOM
		var cells = row.anCells;

		if ( cells ) {
			if ( colIdx !== undefined ) {
				cellWrite( cells[colIdx], colIdx );
			}
			else {
				for ( i=0, ien=cells.length ; i<ien ; i++ ) {
					cellWrite( cells[i], i );
				}
			}
		}
	}

	// For both row and cell invalidation, the cached data for sorting and
	// filtering is nulled out
	row._aSortData = null;
	row._aFilterData = null;

	// Invalidate the type for a specific column (if given) or all columns since
	// the data might have changed
	var cols = settings.aoColumns;
	if ( colIdx !== undefined ) {
		cols[ colIdx ].sType = null;
	}
	else {
		for ( i=0, ien=cols.length ; i<ien ; i++ ) {
			cols[i].sType = null;
		}

		// Update DataTables special `DT_*` attributes for the row
		_fnRowAttributes( settings, row );
	}
}


/**
 * Build a data source object from an HTML row, reading the contents of the
 * cells that are in the row.
 *
 * @param {object} settings DataTables settings object
 * @param {node|object} TR element from which to read data or existing row
 *   object from which to re-read the data from the cells
 * @param {int} [colIdx] Optional column index
 * @param {array|object} [d] Data source object. If `colIdx` is given then this
 *   parameter should also be given and will be used to write the data into.
 *   Only the column in question will be written
 * @returns {object} Object with two parameters: `data` the data read, in
 *   document order, and `cells` and array of nodes (they can be useful to the
 *   caller, so rather than needing a second traversal to get them, just return
 *   them from here).
 * @memberof DataTable#oApi
 */
function _fnGetRowElements( settings, row, colIdx, d )
{
	var
		tds = [],
		td = row.firstChild,
		name, col, o, i=0, contents,
		columns = settings.aoColumns,
		objectRead = settings._rowReadObject;

	// Allow the data object to be passed in, or construct
	d = d !== undefined ?
		d :
		objectRead ?
			{} :
			[];

	var attr = function ( str, td  ) {
		if ( typeof str === 'string' ) {
			var idx = str.indexOf('@');

			if ( idx !== -1 ) {
				var attr = str.substring( idx+1 );
				var setter = _fnSetObjectDataFn( str );
				setter( d, td.getAttribute( attr ) );
			}
		}
	};

	// Read data from a cell and store into the data object
	var cellProcess = function ( cell ) {
		if ( colIdx === undefined || colIdx === i ) {
			col = columns[i];
			contents = (cell.innerHTML).trim();

			if ( col && col._bAttrSrc ) {
				var setter = _fnSetObjectDataFn( col.mData._ );
				setter( d, contents );

				attr( col.mData.sort, cell );
				attr( col.mData.type, cell );
				attr( col.mData.filter, cell );
			}
			else {
				// Depending on the `data` option for the columns the data can
				// be read to either an object or an array.
				if ( objectRead ) {
					if ( ! col._setter ) {
						// Cache the setter function
						col._setter = _fnSetObjectDataFn( col.mData );
					}
					col._setter( d, contents );
				}
				else {
					d[i] = contents;
				}
			}
		}

		i++;
	};

	if ( td ) {
		// `tr` element was passed in
		while ( td ) {
			name = td.nodeName.toUpperCase();

			if ( name == "TD" || name == "TH" ) {
				cellProcess( td );
				tds.push( td );
			}

			td = td.nextSibling;
		}
	}
	else {
		// Existing row object passed in
		tds = row.anCells;

		for ( var j=0, jen=tds.length ; j<jen ; j++ ) {
			cellProcess( tds[j] );
		}
	}

	// Read the ID from the DOM if present
	var rowNode = row.firstChild ? row : row.nTr;

	if ( rowNode ) {
		var id = rowNode.getAttribute( 'id' );

		if ( id ) {
			_fnSetObjectDataFn( settings.rowId )( d, id );
		}
	}

	return {
		data: d,
		cells: tds
	};
}
/**
 * Create a new TR element (and it's TD children) for a row
 *  @param {object} oSettings dataTables settings object
 *  @param {int} iRow Row to consider
 *  @param {node} [nTrIn] TR element to add to the table - optional. If not given,
 *    DataTables will create a row automatically
 *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
 *    if nTr is.
 *  @memberof DataTable#oApi
 */
function _fnCreateTr ( oSettings, iRow, nTrIn, anTds )
{
	var
		row = oSettings.aoData[iRow],
		rowData = row._aData,
		cells = [],
		nTr, nTd, oCol,
		i, iLen, create;

	if ( row.nTr === null )
	{
		nTr = nTrIn || document.createElement('tr');

		row.nTr = nTr;
		row.anCells = cells;

		/* Use a private property on the node to allow reserve mapping from the node
		 * to the aoData array for fast look up
		 */
		nTr._DT_RowIndex = iRow;

		/* Special parameters can be given by the data source to be used on the row */
		_fnRowAttributes( oSettings, row );

		/* Process each column */
		for ( i=0, iLen=oSettings.aoColumns.length ; i<iLen ; i++ )
		{
			oCol = oSettings.aoColumns[i];
			create = nTrIn ? false : true;

			nTd = create ? document.createElement( oCol.sCellType ) : anTds[i];

			if (! nTd) {
				_fnLog( oSettings, 0, 'Incorrect column count', 18 );
			}

			nTd._DT_CellIndex = {
				row: iRow,
				column: i
			};
			
			cells.push( nTd );

			// Need to create the HTML if new, or if a rendering function is defined
			if ( create || ((oCol.mRender || oCol.mData !== i) &&
				 (!$.isPlainObject(oCol.mData) || oCol.mData._ !== i+'.display')
			)) {
				nTd.innerHTML = _fnGetCellData( oSettings, iRow, i, 'display' );
			}

			/* Add user defined class */
			if ( oCol.sClass )
			{
				nTd.className += ' '+oCol.sClass;
			}

			// Visibility - add or remove as required
			if ( oCol.bVisible && ! nTrIn )
			{
				nTr.appendChild( nTd );
			}
			else if ( ! oCol.bVisible && nTrIn )
			{
				nTd.parentNode.removeChild( nTd );
			}

			if ( oCol.fnCreatedCell )
			{
				oCol.fnCreatedCell.call( oSettings.oInstance,
					nTd, _fnGetCellData( oSettings, iRow, i ), rowData, iRow, i
				);
			}
		}

		_fnCallbackFire( oSettings, 'aoRowCreatedCallback', null, [nTr, rowData, iRow, cells] );
	}
}


/**
 * Add attributes to a row based on the special `DT_*` parameters in a data
 * source object.
 *  @param {object} settings DataTables settings object
 *  @param {object} DataTables row object for the row to be modified
 *  @memberof DataTable#oApi
 */
function _fnRowAttributes( settings, row )
{
	var tr = row.nTr;
	var data = row._aData;

	if ( tr ) {
		var id = settings.rowIdFn( data );

		if ( id ) {
			tr.id = id;
		}

		if ( data.DT_RowClass ) {
			// Remove any classes added by DT_RowClass before
			var a = data.DT_RowClass.split(' ');
			row.__rowc = row.__rowc ?
				_unique( row.__rowc.concat( a ) ) :
				a;

			$(tr)
				.removeClass( row.__rowc.join(' ') )
				.addClass( data.DT_RowClass );
		}

		if ( data.DT_RowAttr ) {
			$(tr).attr( data.DT_RowAttr );
		}

		if ( data.DT_RowData ) {
			$(tr).data( data.DT_RowData );
		}
	}
}


/**
 * Create the HTML header for the table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnBuildHead( oSettings )
{
	var i, ien, cell, row, column;
	var thead = oSettings.nTHead;
	var tfoot = oSettings.nTFoot;
	var createHeader = $('th, td', thead).length === 0;
	var classes = oSettings.oClasses;
	var columns = oSettings.aoColumns;

	if ( createHeader ) {
		row = $('<tr/>').appendTo( thead );
	}

	for ( i=0, ien=columns.length ; i<ien ; i++ ) {
		column = columns[i];
		cell = $( column.nTh ).addClass( column.sClass );

		if ( createHeader ) {
			cell.appendTo( row );
		}

		// 1.11 move into sorting
		if ( oSettings.oFeatures.bSort ) {
			cell.addClass( column.sSortingClass );

			if ( column.bSortable !== false ) {
				cell
					.attr( 'tabindex', oSettings.iTabIndex )
					.attr( 'aria-controls', oSettings.sTableId );

				_fnSortAttachListener( oSettings, column.nTh, i );
			}
		}

		if ( column.sTitle != cell[0].innerHTML ) {
			cell.html( column.sTitle );
		}

		_fnRenderer( oSettings, 'header' )(
			oSettings, cell, column, classes
		);
	}

	if ( createHeader ) {
		_fnDetectHeader( oSettings.aoHeader, thead );
	}

	/* Deal with the footer - add classes if required */
	$(thead).children('tr').children('th, td').addClass( classes.sHeaderTH );
	$(tfoot).children('tr').children('th, td').addClass( classes.sFooterTH );

	// Cache the footer cells. Note that we only take the cells from the first
	// row in the footer. If there is more than one row the user wants to
	// interact with, they need to use the table().foot() method. Note also this
	// allows cells to be used for multiple columns using colspan
	if ( tfoot !== null ) {
		var cells = oSettings.aoFooter[0];

		for ( i=0, ien=cells.length ; i<ien ; i++ ) {
			column = columns[i];

			if (column) {
				column.nTf = cells[i].cell;
	
				if ( column.sClass ) {
					$(column.nTf).addClass( column.sClass );
				}
			}
			else {
				_fnLog( oSettings, 0, 'Incorrect column count', 18 );
			}
		}
	}
}


/**
 * Draw the header (or footer) element based on the column visibility states. The
 * methodology here is to use the layout array from _fnDetectHeader, modified for
 * the instantaneous column visibility, to construct the new layout. The grid is
 * traversed over cell at a time in a rows x columns grid fashion, although each
 * cell insert can cover multiple elements in the grid - which is tracks using the
 * aApplied array. Cell inserts in the grid will only occur where there isn't
 * already a cell in that position.
 *  @param {object} oSettings dataTables settings object
 *  @param array {objects} aoSource Layout array from _fnDetectHeader
 *  @param {boolean} [bIncludeHidden=false] If true then include the hidden columns in the calc,
 *  @memberof DataTable#oApi
 */
function _fnDrawHead( oSettings, aoSource, bIncludeHidden )
{
	var i, iLen, j, jLen, k, kLen, n, nLocalTr;
	var aoLocal = [];
	var aApplied = [];
	var iColumns = oSettings.aoColumns.length;
	var iRowspan, iColspan;

	if ( ! aoSource )
	{
		return;
	}

	if (  bIncludeHidden === undefined )
	{
		bIncludeHidden = false;
	}

	/* Make a copy of the master layout array, but without the visible columns in it */
	for ( i=0, iLen=aoSource.length ; i<iLen ; i++ )
	{
		aoLocal[i] = aoSource[i].slice();
		aoLocal[i].nTr = aoSource[i].nTr;

		/* Remove any columns which are currently hidden */
		for ( j=iColumns-1 ; j>=0 ; j-- )
		{
			if ( !oSettings.aoColumns[j].bVisible && !bIncludeHidden )
			{
				aoLocal[i].splice( j, 1 );
			}
		}

		/* Prep the applied array - it needs an element for each row */
		aApplied.push( [] );
	}

	for ( i=0, iLen=aoLocal.length ; i<iLen ; i++ )
	{
		nLocalTr = aoLocal[i].nTr;

		/* All cells are going to be replaced, so empty out the row */
		if ( nLocalTr )
		{
			while( (n = nLocalTr.firstChild) )
			{
				nLocalTr.removeChild( n );
			}
		}

		for ( j=0, jLen=aoLocal[i].length ; j<jLen ; j++ )
		{
			iRowspan = 1;
			iColspan = 1;

			/* Check to see if there is already a cell (row/colspan) covering our target
			 * insert point. If there is, then there is nothing to do.
			 */
			if ( aApplied[i][j] === undefined )
			{
				nLocalTr.appendChild( aoLocal[i][j].cell );
				aApplied[i][j] = 1;

				/* Expand the cell to cover as many rows as needed */
				while ( aoLocal[i+iRowspan] !== undefined &&
				        aoLocal[i][j].cell == aoLocal[i+iRowspan][j].cell )
				{
					aApplied[i+iRowspan][j] = 1;
					iRowspan++;
				}

				/* Expand the cell to cover as many columns as needed */
				while ( aoLocal[i][j+iColspan] !== undefined &&
				        aoLocal[i][j].cell == aoLocal[i][j+iColspan].cell )
				{
					/* Must update the applied array over the rows for the columns */
					for ( k=0 ; k<iRowspan ; k++ )
					{
						aApplied[i+k][j+iColspan] = 1;
					}
					iColspan++;
				}

				/* Do the actual expansion in the DOM */
				$(aoLocal[i][j].cell)
					.attr('rowspan', iRowspan)
					.attr('colspan', iColspan);
			}
		}
	}
}


/**
 * Insert the required TR nodes into the table for display
 *  @param {object} oSettings dataTables settings object
 *  @param ajaxComplete true after ajax call to complete rendering
 *  @memberof DataTable#oApi
 */
function _fnDraw( oSettings, ajaxComplete )
{
	// Allow for state saving and a custom start position
	_fnStart( oSettings );

	/* Provide a pre-callback function which can be used to cancel the draw is false is returned */
	var aPreDraw = _fnCallbackFire( oSettings, 'aoPreDrawCallback', 'preDraw', [oSettings] );
	if ( $.inArray( false, aPreDraw ) !== -1 )
	{
		_fnProcessingDisplay( oSettings, false );
		return;
	}

	var anRows = [];
	var iRowCount = 0;
	var asStripeClasses = oSettings.asStripeClasses;
	var iStripes = asStripeClasses.length;
	var oLang = oSettings.oLanguage;
	var bServerSide = _fnDataSource( oSettings ) == 'ssp';
	var aiDisplay = oSettings.aiDisplay;
	var iDisplayStart = oSettings._iDisplayStart;
	var iDisplayEnd = oSettings.fnDisplayEnd();

	oSettings.bDrawing = true;

	/* Server-side processing draw intercept */
	if ( oSettings.bDeferLoading )
	{
		oSettings.bDeferLoading = false;
		oSettings.iDraw++;
		_fnProcessingDisplay( oSettings, false );
	}
	else if ( !bServerSide )
	{
		oSettings.iDraw++;
	}
	else if ( !oSettings.bDestroying && !ajaxComplete)
	{
		_fnAjaxUpdate( oSettings );
		return;
	}

	if ( aiDisplay.length !== 0 )
	{
		var iStart = bServerSide ? 0 : iDisplayStart;
		var iEnd = bServerSide ? oSettings.aoData.length : iDisplayEnd;

		for ( var j=iStart ; j<iEnd ; j++ )
		{
			var iDataIndex = aiDisplay[j];
			var aoData = oSettings.aoData[ iDataIndex ];
			if ( aoData.nTr === null )
			{
				_fnCreateTr( oSettings, iDataIndex );
			}

			var nRow = aoData.nTr;

			/* Remove the old striping classes and then add the new one */
			if ( iStripes !== 0 )
			{
				var sStripe = asStripeClasses[ iRowCount % iStripes ];
				if ( aoData._sRowStripe != sStripe )
				{
					$(nRow).removeClass( aoData._sRowStripe ).addClass( sStripe );
					aoData._sRowStripe = sStripe;
				}
			}

			// Row callback functions - might want to manipulate the row
			// iRowCount and j are not currently documented. Are they at all
			// useful?
			_fnCallbackFire( oSettings, 'aoRowCallback', null,
				[nRow, aoData._aData, iRowCount, j, iDataIndex] );

			anRows.push( nRow );
			iRowCount++;
		}
	}
	else
	{
		/* Table is empty - create a row with an empty message in it */
		var sZero = oLang.sZeroRecords;
		if ( oSettings.iDraw == 1 &&  _fnDataSource( oSettings ) == 'ajax' )
		{
			sZero = oLang.sLoadingRecords;
		}
		else if ( oLang.sEmptyTable && oSettings.fnRecordsTotal() === 0 )
		{
			sZero = oLang.sEmptyTable;
		}

		anRows[ 0 ] = $( '<tr/>', { 'class': iStripes ? asStripeClasses[0] : '' } )
			.append( $('<td />', {
				'valign':  'top',
				'colSpan': _fnVisbleColumns( oSettings ),
				'class':   oSettings.oClasses.sRowEmpty
			} ).html( sZero ) )[0];
	}

	/* Header and footer callbacks */
	_fnCallbackFire( oSettings, 'aoHeaderCallback', 'header', [ $(oSettings.nTHead).children('tr')[0],
		_fnGetDataMaster( oSettings ), iDisplayStart, iDisplayEnd, aiDisplay ] );

	_fnCallbackFire( oSettings, 'aoFooterCallback', 'footer', [ $(oSettings.nTFoot).children('tr')[0],
		_fnGetDataMaster( oSettings ), iDisplayStart, iDisplayEnd, aiDisplay ] );

	var body = $(oSettings.nTBody);

	body.children().detach();
	body.append( $(anRows) );

	/* Call all required callback functions for the end of a draw */
	_fnCallbackFire( oSettings, 'aoDrawCallback', 'draw', [oSettings] );

	/* Draw is complete, sorting and filtering must be as well */
	oSettings.bSorted = false;
	oSettings.bFiltered = false;
	oSettings.bDrawing = false;
}


/**
 * Redraw the table - taking account of the various features which are enabled
 *  @param {object} oSettings dataTables settings object
 *  @param {boolean} [holdPosition] Keep the current paging position. By default
 *    the paging is reset to the first page
 *  @memberof DataTable#oApi
 */
function _fnReDraw( settings, holdPosition )
{
	var
		features = settings.oFeatures,
		sort     = features.bSort,
		filter   = features.bFilter;

	if ( sort ) {
		_fnSort( settings );
	}

	if ( filter ) {
		_fnFilterComplete( settings, settings.oPreviousSearch );
	}
	else {
		// No filtering, so we want to just use the display master
		settings.aiDisplay = settings.aiDisplayMaster.slice();
	}

	if ( holdPosition !== true ) {
		settings._iDisplayStart = 0;
	}

	// Let any modules know about the draw hold position state (used by
	// scrolling internally)
	settings._drawHold = holdPosition;

	_fnDraw( settings );

	settings._drawHold = false;
}


/**
 * Add the options to the page HTML for the table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnAddOptionsHtml ( oSettings )
{
	var classes = oSettings.oClasses;
	var table = $(oSettings.nTable);
	var holding = $('<div/>').insertBefore( table ); // Holding element for speed
	var features = oSettings.oFeatures;

	// All DataTables are wrapped in a div
	var insert = $('<div/>', {
		id:      oSettings.sTableId+'_wrapper',
		'class': classes.sWrapper + (oSettings.nTFoot ? '' : ' '+classes.sNoFooter)
	} );

	oSettings.nHolding = holding[0];
	oSettings.nTableWrapper = insert[0];
	oSettings.nTableReinsertBefore = oSettings.nTable.nextSibling;

	/* Loop over the user set positioning and place the elements as needed */
	var aDom = oSettings.sDom.split('');
	var featureNode, cOption, nNewNode, cNext, sAttr, j;
	for ( var i=0 ; i<aDom.length ; i++ )
	{
		featureNode = null;
		cOption = aDom[i];

		if ( cOption == '<' )
		{
			/* New container div */
			nNewNode = $('<div/>')[0];

			/* Check to see if we should append an id and/or a class name to the container */
			cNext = aDom[i+1];
			if ( cNext == "'" || cNext == '"' )
			{
				sAttr = "";
				j = 2;
				while ( aDom[i+j] != cNext )
				{
					sAttr += aDom[i+j];
					j++;
				}

				/* Replace jQuery UI constants @todo depreciated */
				if ( sAttr == "H" )
				{
					sAttr = classes.sJUIHeader;
				}
				else if ( sAttr == "F" )
				{
					sAttr = classes.sJUIFooter;
				}

				/* The attribute can be in the format of "#id.class", "#id" or "class" This logic
				 * breaks the string into parts and applies them as needed
				 */
				if ( sAttr.indexOf('.') != -1 )
				{
					var aSplit = sAttr.split('.');
					nNewNode.id = aSplit[0].substr(1, aSplit[0].length-1);
					nNewNode.className = aSplit[1];
				}
				else if ( sAttr.charAt(0) == "#" )
				{
					nNewNode.id = sAttr.substr(1, sAttr.length-1);
				}
				else
				{
					nNewNode.className = sAttr;
				}

				i += j; /* Move along the position array */
			}

			insert.append( nNewNode );
			insert = $(nNewNode);
		}
		else if ( cOption == '>' )
		{
			/* End container div */
			insert = insert.parent();
		}
		// @todo Move options into their own plugins?
		else if ( cOption == 'l' && features.bPaginate && features.bLengthChange )
		{
			/* Length */
			featureNode = _fnFeatureHtmlLength( oSettings );
		}
		else if ( cOption == 'f' && features.bFilter )
		{
			/* Filter */
			featureNode = _fnFeatureHtmlFilter( oSettings );
		}
		else if ( cOption == 'r' && features.bProcessing )
		{
			/* pRocessing */
			featureNode = _fnFeatureHtmlProcessing( oSettings );
		}
		else if ( cOption == 't' )
		{
			/* Table */
			featureNode = _fnFeatureHtmlTable( oSettings );
		}
		else if ( cOption ==  'i' && features.bInfo )
		{
			/* Info */
			featureNode = _fnFeatureHtmlInfo( oSettings );
		}
		else if ( cOption == 'p' && features.bPaginate )
		{
			/* Pagination */
			featureNode = _fnFeatureHtmlPaginate( oSettings );
		}
		else if ( DataTable.ext.feature.length !== 0 )
		{
			/* Plug-in features */
			var aoFeatures = DataTable.ext.feature;
			for ( var k=0, kLen=aoFeatures.length ; k<kLen ; k++ )
			{
				if ( cOption == aoFeatures[k].cFeature )
				{
					featureNode = aoFeatures[k].fnInit( oSettings );
					break;
				}
			}
		}

		/* Add to the 2D features array */
		if ( featureNode )
		{
			var aanFeatures = oSettings.aanFeatures;

			if ( ! aanFeatures[cOption] )
			{
				aanFeatures[cOption] = [];
			}

			aanFeatures[cOption].push( featureNode );
			insert.append( featureNode );
		}
	}

	/* Built our DOM structure - replace the holding div with what we want */
	holding.replaceWith( insert );
	oSettings.nHolding = null;
}


/**
 * Use the DOM source to create up an array of header cells. The idea here is to
 * create a layout grid (array) of rows x columns, which contains a reference
 * to the cell that that point in the grid (regardless of col/rowspan), such that
 * any column / row could be removed and the new grid constructed
 *  @param array {object} aLayout Array to store the calculated layout in
 *  @param {node} nThead The header/footer element for the table
 *  @memberof DataTable#oApi
 */
function _fnDetectHeader ( aLayout, nThead )
{
	var nTrs = $(nThead).children('tr');
	var nTr, nCell;
	var i, k, l, iLen, jLen, iColShifted, iColumn, iColspan, iRowspan;
	var bUnique;
	var fnShiftCol = function ( a, i, j ) {
		var k = a[i];
                while ( k[j] ) {
			j++;
		}
		return j;
	};

	aLayout.splice( 0, aLayout.length );

	/* We know how many rows there are in the layout - so prep it */
	for ( i=0, iLen=nTrs.length ; i<iLen ; i++ )
	{
		aLayout.push( [] );
	}

	/* Calculate a layout array */
	for ( i=0, iLen=nTrs.length ; i<iLen ; i++ )
	{
		nTr = nTrs[i];
		iColumn = 0;

		/* For every cell in the row... */
		nCell = nTr.firstChild;
		while ( nCell ) {
			if ( nCell.nodeName.toUpperCase() == "TD" ||
			     nCell.nodeName.toUpperCase() == "TH" )
			{
				/* Get the col and rowspan attributes from the DOM and sanitise them */
				iColspan = nCell.getAttribute('colspan') * 1;
				iRowspan = nCell.getAttribute('rowspan') * 1;
				iColspan = (!iColspan || iColspan===0 || iColspan===1) ? 1 : iColspan;
				iRowspan = (!iRowspan || iRowspan===0 || iRowspan===1) ? 1 : iRowspan;

				/* There might be colspan cells already in this row, so shift our target
				 * accordingly
				 */
				iColShifted = fnShiftCol( aLayout, i, iColumn );

				/* Cache calculation for unique columns */
				bUnique = iColspan === 1 ? true : false;

				/* If there is col / rowspan, copy the information into the layout grid */
				for ( l=0 ; l<iColspan ; l++ )
				{
					for ( k=0 ; k<iRowspan ; k++ )
					{
						aLayout[i+k][iColShifted+l] = {
							"cell": nCell,
							"unique": bUnique
						};
						aLayout[i+k].nTr = nTr;
					}
				}
			}
			nCell = nCell.nextSibling;
		}
	}
}


/**
 * Get an array of unique th elements, one for each column
 *  @param {object} oSettings dataTables settings object
 *  @param {node} nHeader automatically detect the layout from this node - optional
 *  @param {array} aLayout thead/tfoot layout from _fnDetectHeader - optional
 *  @returns array {node} aReturn list of unique th's
 *  @memberof DataTable#oApi
 */
function _fnGetUniqueThs ( oSettings, nHeader, aLayout )
{
	var aReturn = [];
	if ( !aLayout )
	{
		aLayout = oSettings.aoHeader;
		if ( nHeader )
		{
			aLayout = [];
			_fnDetectHeader( aLayout, nHeader );
		}
	}

	for ( var i=0, iLen=aLayout.length ; i<iLen ; i++ )
	{
		for ( var j=0, jLen=aLayout[i].length ; j<jLen ; j++ )
		{
			if ( aLayout[i][j].unique &&
				 (!aReturn[j] || !oSettings.bSortCellsTop) )
			{
				aReturn[j] = aLayout[i][j].cell;
			}
		}
	}

	return aReturn;
}

/**
 * Set the start position for draw
 *  @param {object} oSettings dataTables settings object
 */
function _fnStart( oSettings )
{
	var bServerSide = _fnDataSource( oSettings ) == 'ssp';
	var iInitDisplayStart = oSettings.iInitDisplayStart;

	// Check and see if we have an initial draw position from state saving
	if ( iInitDisplayStart !== undefined && iInitDisplayStart !== -1 )
	{
		oSettings._iDisplayStart = bServerSide ?
			iInitDisplayStart :
			iInitDisplayStart >= oSettings.fnRecordsDisplay() ?
				0 :
				iInitDisplayStart;

		oSettings.iInitDisplayStart = -1;
	}
}

/**
 * Create an Ajax call based on the table's settings, taking into account that
 * parameters can have multiple forms, and backwards compatibility.
 *
 * @param {object} oSettings dataTables settings object
 * @param {array} data Data to send to the server, required by
 *     DataTables - may be augmented by developer callbacks
 * @param {function} fn Callback function to run when data is obtained
 */
function _fnBuildAjax( oSettings, data, fn )
{
	// Compatibility with 1.9-, allow fnServerData and event to manipulate
	_fnCallbackFire( oSettings, 'aoServerParams', 'serverParams', [data] );

	// Convert to object based for 1.10+ if using the old array scheme which can
	// come from server-side processing or serverParams
	if ( data && Array.isArray(data) ) {
		var tmp = {};
		var rbracket = /(.*?)\[\]$/;

		$.each( data, function (key, val) {
			var match = val.name.match(rbracket);

			if ( match ) {
				// Support for arrays
				var name = match[0];

				if ( ! tmp[ name ] ) {
					tmp[ name ] = [];
				}
				tmp[ name ].push( val.value );
			}
			else {
				tmp[val.name] = val.value;
			}
		} );
		data = tmp;
	}

	var ajaxData;
	var ajax = oSettings.ajax;
	var instance = oSettings.oInstance;
	var callback = function ( json ) {
		var status = oSettings.jqXHR
			? oSettings.jqXHR.status
			: null;

		if ( json === null || (typeof status === 'number' && status == 204 ) ) {
			json = {};
			_fnAjaxDataSrc( oSettings, json, [] );
		}

		var error = json.error || json.sError;
		if ( error ) {
			_fnLog( oSettings, 0, error );
		}

		oSettings.json = json;

		_fnCallbackFire( oSettings, null, 'xhr', [oSettings, json, oSettings.jqXHR] );
		fn( json );
	};

	if ( $.isPlainObject( ajax ) && ajax.data )
	{
		ajaxData = ajax.data;

		var newData = typeof ajaxData === 'function' ?
			ajaxData( data, oSettings ) :  // fn can manipulate data or return
			ajaxData;                      // an object object or array to merge

		// If the function returned something, use that alone
		data = typeof ajaxData === 'function' && newData ?
			newData :
			$.extend( true, data, newData );

		// Remove the data property as we've resolved it already and don't want
		// jQuery to do it again (it is restored at the end of the function)
		delete ajax.data;
	}

	var baseAjax = {
		"data": data,
		"success": callback,
		"dataType": "json",
		"cache": false,
		"type": oSettings.sServerMethod,
		"error": function (xhr, error, thrown) {
			var ret = _fnCallbackFire( oSettings, null, 'xhr', [oSettings, null, oSettings.jqXHR] );

			if ( $.inArray( true, ret ) === -1 ) {
				if ( error == "parsererror" ) {
					_fnLog( oSettings, 0, 'Invalid JSON response', 1 );
				}
				else if ( xhr.readyState === 4 ) {
					_fnLog( oSettings, 0, 'Ajax error', 7 );
				}
			}

			_fnProcessingDisplay( oSettings, false );
		}
	};

	// Store the data submitted for the API
	oSettings.oAjaxData = data;

	// Allow plug-ins and external processes to modify the data
	_fnCallbackFire( oSettings, null, 'preXhr', [oSettings, data] );

	if ( oSettings.fnServerData )
	{
		// DataTables 1.9- compatibility
		oSettings.fnServerData.call( instance,
			oSettings.sAjaxSource,
			$.map( data, function (val, key) { // Need to convert back to 1.9 trad format
				return { name: key, value: val };
			} ),
			callback,
			oSettings
		);
	}
	else if ( oSettings.sAjaxSource || typeof ajax === 'string' )
	{
		// DataTables 1.9- compatibility
		oSettings.jqXHR = $.ajax( $.extend( baseAjax, {
			url: ajax || oSettings.sAjaxSource
		} ) );
	}
	else if ( typeof ajax === 'function' )
	{
		// Is a function - let the caller define what needs to be done
		oSettings.jqXHR = ajax.call( instance, data, callback, oSettings );
	}
	else
	{
		// Object to extend the base settings
		oSettings.jqXHR = $.ajax( $.extend( baseAjax, ajax ) );

		// Restore for next time around
		ajax.data = ajaxData;
	}
}


/**
 * Update the table using an Ajax call
 *  @param {object} settings dataTables settings object
 *  @returns {boolean} Block the table drawing or not
 *  @memberof DataTable#oApi
 */
function _fnAjaxUpdate( settings )
{
	settings.iDraw++;
	_fnProcessingDisplay( settings, true );

	// Keep track of drawHold state to handle scrolling after the Ajax call
	var drawHold = settings._drawHold;

	_fnBuildAjax(
		settings,
		_fnAjaxParameters( settings ),
		function(json) {
			settings._drawHold = drawHold;
			_fnAjaxUpdateDraw( settings, json );
			settings._drawHold = false;
		}
	);
}


/**
 * Build up the parameters in an object needed for a server-side processing
 * request. Note that this is basically done twice, is different ways - a modern
 * method which is used by default in DataTables 1.10 which uses objects and
 * arrays, or the 1.9- method with is name / value pairs. 1.9 method is used if
 * the sAjaxSource option is used in the initialisation, or the legacyAjax
 * option is set.
 *  @param {object} oSettings dataTables settings object
 *  @returns {bool} block the table drawing or not
 *  @memberof DataTable#oApi
 */
function _fnAjaxParameters( settings )
{
	var
		columns = settings.aoColumns,
		columnCount = columns.length,
		features = settings.oFeatures,
		preSearch = settings.oPreviousSearch,
		preColSearch = settings.aoPreSearchCols,
		i, data = [], dataProp, column, columnSearch,
		sort = _fnSortFlatten( settings ),
		displayStart = settings._iDisplayStart,
		displayLength = features.bPaginate !== false ?
			settings._iDisplayLength :
			-1;

	var param = function ( name, value ) {
		data.push( { 'name': name, 'value': value } );
	};

	// DataTables 1.9- compatible method
	param( 'sEcho',          settings.iDraw );
	param( 'iColumns',       columnCount );
	param( 'sColumns',       _pluck( columns, 'sName' ).join(',') );
	param( 'iDisplayStart',  displayStart );
	param( 'iDisplayLength', displayLength );

	// DataTables 1.10+ method
	var d = {
		draw:    settings.iDraw,
		columns: [],
		order:   [],
		start:   displayStart,
		length:  displayLength,
		search:  {
			value: preSearch.sSearch,
			regex: preSearch.bRegex
		}
	};

	for ( i=0 ; i<columnCount ; i++ ) {
		column = columns[i];
		columnSearch = preColSearch[i];
		dataProp = typeof column.mData=="function" ? 'function' : column.mData ;

		d.columns.push( {
			data:       dataProp,
			name:       column.sName,
			searchable: column.bSearchable,
			orderable:  column.bSortable,
			search:     {
				value: columnSearch.sSearch,
				regex: columnSearch.bRegex
			}
		} );

		param( "mDataProp_"+i, dataProp );

		if ( features.bFilter ) {
			param( 'sSearch_'+i,     columnSearch.sSearch );
			param( 'bRegex_'+i,      columnSearch.bRegex );
			param( 'bSearchable_'+i, column.bSearchable );
		}

		if ( features.bSort ) {
			param( 'bSortable_'+i, column.bSortable );
		}
	}

	if ( features.bFilter ) {
		param( 'sSearch', preSearch.sSearch );
		param( 'bRegex', preSearch.bRegex );
	}

	if ( features.bSort ) {
		$.each( sort, function ( i, val ) {
			d.order.push( { column: val.col, dir: val.dir } );

			param( 'iSortCol_'+i, val.col );
			param( 'sSortDir_'+i, val.dir );
		} );

		param( 'iSortingCols', sort.length );
	}

	// If the legacy.ajax parameter is null, then we automatically decide which
	// form to use, based on sAjaxSource
	var legacy = DataTable.ext.legacy.ajax;
	if ( legacy === null ) {
		return settings.sAjaxSource ? data : d;
	}

	// Otherwise, if legacy has been specified then we use that to decide on the
	// form
	return legacy ? data : d;
}


/**
 * Data the data from the server (nuking the old) and redraw the table
 *  @param {object} oSettings dataTables settings object
 *  @param {object} json json data return from the server.
 *  @param {string} json.sEcho Tracking flag for DataTables to match requests
 *  @param {int} json.iTotalRecords Number of records in the data set, not accounting for filtering
 *  @param {int} json.iTotalDisplayRecords Number of records in the data set, accounting for filtering
 *  @param {array} json.aaData The data to display on this page
 *  @param {string} [json.sColumns] Column ordering (sName, comma separated)
 *  @memberof DataTable#oApi
 */
function _fnAjaxUpdateDraw ( settings, json )
{
	// v1.10 uses camelCase variables, while 1.9 uses Hungarian notation.
	// Support both
	var compat = function ( old, modern ) {
		return json[old] !== undefined ? json[old] : json[modern];
	};

	var data = _fnAjaxDataSrc( settings, json );
	var draw            = compat( 'sEcho',                'draw' );
	var recordsTotal    = compat( 'iTotalRecords',        'recordsTotal' );
	var recordsFiltered = compat( 'iTotalDisplayRecords', 'recordsFiltered' );

	if ( draw !== undefined ) {
		// Protect against out of sequence returns
		if ( draw*1 < settings.iDraw ) {
			return;
		}
		settings.iDraw = draw * 1;
	}

	// No data in returned object, so rather than an array, we show an empty table
	if ( ! data ) {
		data = [];
	}

	_fnClearTable( settings );
	settings._iRecordsTotal   = parseInt(recordsTotal, 10);
	settings._iRecordsDisplay = parseInt(recordsFiltered, 10);

	for ( var i=0, ien=data.length ; i<ien ; i++ ) {
		_fnAddData( settings, data[i] );
	}
	settings.aiDisplay = settings.aiDisplayMaster.slice();

	_fnDraw( settings, true );

	if ( ! settings._bInitComplete ) {
		_fnInitComplete( settings, json );
	}

	_fnProcessingDisplay( settings, false );
}


/**
 * Get the data from the JSON data source to use for drawing a table. Using
 * `_fnGetObjectDataFn` allows the data to be sourced from a property of the
 * source object, or from a processing function.
 *  @param {object} oSettings dataTables settings object
 *  @param  {object} json Data source object / array from the server
 *  @return {array} Array of data to use
 */
 function _fnAjaxDataSrc ( oSettings, json, write )
 {
	var dataSrc = $.isPlainObject( oSettings.ajax ) && oSettings.ajax.dataSrc !== undefined ?
		oSettings.ajax.dataSrc :
		oSettings.sAjaxDataProp; // Compatibility with 1.9-.

	if ( ! write ) {
		if ( dataSrc === 'data' ) {
			// If the default, then we still want to support the old style, and safely ignore
			// it if possible
			return json.aaData || json[dataSrc];
		}

		return dataSrc !== "" ?
			_fnGetObjectDataFn( dataSrc )( json ) :
			json;
	}

	// set
	_fnSetObjectDataFn( dataSrc )( json, write );
}

/**
 * Generate the node required for filtering text
 *  @returns {node} Filter control element
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnFeatureHtmlFilter ( settings )
{
	var classes = settings.oClasses;
	var tableId = settings.sTableId;
	var language = settings.oLanguage;
	var previousSearch = settings.oPreviousSearch;
	var features = settings.aanFeatures;
	var input = '<input type="search" class="'+classes.sFilterInput+'"/>';

	var str = language.sSearch;
	str = str.match(/_INPUT_/) ?
		str.replace('_INPUT_', input) :
		str+input;

	var filter = $('<div/>', {
			'id': ! features.f ? tableId+'_filter' : null,
			'class': classes.sFilter
		} )
		.append( $('<label/>' ).append( str ) );

	var searchFn = function(event) {
		/* Update all other filter input elements for the new display */
		var n = features.f;
		var val = !this.value ? "" : this.value; // mental IE8 fix :-(
		if(previousSearch.return && event.key !== "Enter") {
			return;
		}
		/* Now do the filter */
		if ( val != previousSearch.sSearch ) {
			_fnFilterComplete( settings, {
				"sSearch": val,
				"bRegex": previousSearch.bRegex,
				"bSmart": previousSearch.bSmart ,
				"bCaseInsensitive": previousSearch.bCaseInsensitive,
				"return": previousSearch.return
			} );

			// Need to redraw, without resorting
			settings._iDisplayStart = 0;
			_fnDraw( settings );
		}
	};

	var searchDelay = settings.searchDelay !== null ?
		settings.searchDelay :
		_fnDataSource( settings ) === 'ssp' ?
			400 :
			0;

	var jqFilter = $('input', filter)
		.val( previousSearch.sSearch )
		.attr( 'placeholder', language.sSearchPlaceholder )
		.on(
			'keyup.DT search.DT input.DT paste.DT cut.DT',
			searchDelay ?
				_fnThrottle( searchFn, searchDelay ) :
				searchFn
		)
		.on( 'mouseup.DT', function(e) {
			// Edge fix! Edge 17 does not trigger anything other than mouse events when clicking
			// on the clear icon (Edge bug 17584515). This is safe in other browsers as `searchFn`
			// checks the value to see if it has changed. In other browsers it won't have.
			setTimeout( function () {
				searchFn.call(jqFilter[0], e);
			}, 10);
		} )
		.on( 'keypress.DT', function(e) {
			/* Prevent form submission */
			if ( e.keyCode == 13 ) {
				return false;
			}
		} )
		.attr('aria-controls', tableId);

	// Update the input elements whenever the table is filtered
	$(settings.nTable).on( 'search.dt.DT', function ( ev, s ) {
		if ( settings === s ) {
			// IE9 throws an 'unknown error' if document.activeElement is used
			// inside an iframe or frame...
			try {
				if ( jqFilter[0] !== document.activeElement ) {
					jqFilter.val( previousSearch.sSearch );
				}
			}
			catch ( e ) {}
		}
	} );

	return filter[0];
}


/**
 * Filter the table using both the global filter and column based filtering
 *  @param {object} oSettings dataTables settings object
 *  @param {object} oSearch search information
 *  @param {int} [iForce] force a research of the master array (1) or not (undefined or 0)
 *  @memberof DataTable#oApi
 */
function _fnFilterComplete ( oSettings, oInput, iForce )
{
	var oPrevSearch = oSettings.oPreviousSearch;
	var aoPrevSearch = oSettings.aoPreSearchCols;
	var fnSaveFilter = function ( oFilter ) {
		/* Save the filtering values */
		oPrevSearch.sSearch = oFilter.sSearch;
		oPrevSearch.bRegex = oFilter.bRegex;
		oPrevSearch.bSmart = oFilter.bSmart;
		oPrevSearch.bCaseInsensitive = oFilter.bCaseInsensitive;
		oPrevSearch.return = oFilter.return;
	};
	var fnRegex = function ( o ) {
		// Backwards compatibility with the bEscapeRegex option
		return o.bEscapeRegex !== undefined ? !o.bEscapeRegex : o.bRegex;
	};

	// Resolve any column types that are unknown due to addition or invalidation
	// @todo As per sort - can this be moved into an event handler?
	_fnColumnTypes( oSettings );

	/* In server-side processing all filtering is done by the server, so no point hanging around here */
	if ( _fnDataSource( oSettings ) != 'ssp' )
	{
		/* Global filter */
		_fnFilter( oSettings, oInput.sSearch, iForce, fnRegex(oInput), oInput.bSmart, oInput.bCaseInsensitive );
		fnSaveFilter( oInput );

		/* Now do the individual column filter */
		for ( var i=0 ; i<aoPrevSearch.length ; i++ )
		{
			_fnFilterColumn( oSettings, aoPrevSearch[i].sSearch, i, fnRegex(aoPrevSearch[i]),
				aoPrevSearch[i].bSmart, aoPrevSearch[i].bCaseInsensitive );
		}

		/* Custom filtering */
		_fnFilterCustom( oSettings );
	}
	else
	{
		fnSaveFilter( oInput );
	}

	/* Tell the draw function we have been filtering */
	oSettings.bFiltered = true;
	_fnCallbackFire( oSettings, null, 'search', [oSettings] );
}


/**
 * Apply custom filtering functions
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnFilterCustom( settings )
{
	var filters = DataTable.ext.search;
	var displayRows = settings.aiDisplay;
	var row, rowIdx;

	for ( var i=0, ien=filters.length ; i<ien ; i++ ) {
		var rows = [];

		// Loop over each row and see if it should be included
		for ( var j=0, jen=displayRows.length ; j<jen ; j++ ) {
			rowIdx = displayRows[ j ];
			row = settings.aoData[ rowIdx ];

			if ( filters[i]( settings, row._aFilterData, rowIdx, row._aData, j ) ) {
				rows.push( rowIdx );
			}
		}

		// So the array reference doesn't break set the results into the
		// existing array
		displayRows.length = 0;
		$.merge( displayRows, rows );
	}
}


/**
 * Filter the table on a per-column basis
 *  @param {object} oSettings dataTables settings object
 *  @param {string} sInput string to filter on
 *  @param {int} iColumn column to filter
 *  @param {bool} bRegex treat search string as a regular expression or not
 *  @param {bool} bSmart use smart filtering or not
 *  @param {bool} bCaseInsensitive Do case insensitive matching or not
 *  @memberof DataTable#oApi
 */
function _fnFilterColumn ( settings, searchStr, colIdx, regex, smart, caseInsensitive )
{
	if ( searchStr === '' ) {
		return;
	}

	var data;
	var out = [];
	var display = settings.aiDisplay;
	var rpSearch = _fnFilterCreateSearch( searchStr, regex, smart, caseInsensitive );

	for ( var i=0 ; i<display.length ; i++ ) {
		data = settings.aoData[ display[i] ]._aFilterData[ colIdx ];

		if ( rpSearch.test( data ) ) {
			out.push( display[i] );
		}
	}

	settings.aiDisplay = out;
}


/**
 * Filter the data table based on user input and draw the table
 *  @param {object} settings dataTables settings object
 *  @param {string} input string to filter on
 *  @param {int} force optional - force a research of the master array (1) or not (undefined or 0)
 *  @param {bool} regex treat as a regular expression or not
 *  @param {bool} smart perform smart filtering or not
 *  @param {bool} caseInsensitive Do case insensitive matching or not
 *  @memberof DataTable#oApi
 */
function _fnFilter( settings, input, force, regex, smart, caseInsensitive )
{
	var rpSearch = _fnFilterCreateSearch( input, regex, smart, caseInsensitive );
	var prevSearch = settings.oPreviousSearch.sSearch;
	var displayMaster = settings.aiDisplayMaster;
	var display, invalidated, i;
	var filtered = [];

	// Need to take account of custom filtering functions - always filter
	if ( DataTable.ext.search.length !== 0 ) {
		force = true;
	}

	// Check if any of the rows were invalidated
	invalidated = _fnFilterData( settings );

	// If the input is blank - we just want the full data set
	if ( input.length <= 0 ) {
		settings.aiDisplay = displayMaster.slice();
	}
	else {
		// New search - start from the master array
		if ( invalidated ||
			 force ||
			 regex ||
			 prevSearch.length > input.length ||
			 input.indexOf(prevSearch) !== 0 ||
			 settings.bSorted // On resort, the display master needs to be
			                  // re-filtered since indexes will have changed
		) {
			settings.aiDisplay = displayMaster.slice();
		}

		// Search the display array
		display = settings.aiDisplay;

		for ( i=0 ; i<display.length ; i++ ) {
			if ( rpSearch.test( settings.aoData[ display[i] ]._sFilterRow ) ) {
				filtered.push( display[i] );
			}
		}

		settings.aiDisplay = filtered;
	}
}


/**
 * Build a regular expression object suitable for searching a table
 *  @param {string} sSearch string to search for
 *  @param {bool} bRegex treat as a regular expression or not
 *  @param {bool} bSmart perform smart filtering or not
 *  @param {bool} bCaseInsensitive Do case insensitive matching or not
 *  @returns {RegExp} constructed object
 *  @memberof DataTable#oApi
 */
function _fnFilterCreateSearch( search, regex, smart, caseInsensitive )
{
	search = regex ?
		search :
		_fnEscapeRegex( search );
	
	if ( smart ) {
		/* For smart filtering we want to allow the search to work regardless of
		 * word order. We also want double quoted text to be preserved, so word
		 * order is important - a la google. So this is what we want to
		 * generate:
		 * 
		 * ^(?=.*?\bone\b)(?=.*?\btwo three\b)(?=.*?\bfour\b).*$
		 */
		var a = $.map( search.match( /["\u201C][^"\u201D]+["\u201D]|[^ ]+/g ) || [''], function ( word ) {
			if ( word.charAt(0) === '"' ) {
				var m = word.match( /^"(.*)"$/ );
				word = m ? m[1] : word;
			}
			else if ( word.charAt(0) === '\u201C' ) {
				var m = word.match( /^\u201C(.*)\u201D$/ );
				word = m ? m[1] : word;
			}

			return word.replace('"', '');
		} );

		search = '^(?=.*?'+a.join( ')(?=.*?' )+').*$';
	}

	return new RegExp( search, caseInsensitive ? 'i' : '' );
}


/**
 * Escape a string such that it can be used in a regular expression
 *  @param {string} sVal string to escape
 *  @returns {string} escaped string
 *  @memberof DataTable#oApi
 */
var _fnEscapeRegex = DataTable.util.escapeRegex;

var __filter_div = $('<div>')[0];
var __filter_div_textContent = __filter_div.textContent !== undefined;

// Update the filtering data for each row if needed (by invalidation or first run)
function _fnFilterData ( settings )
{
	var columns = settings.aoColumns;
	var column;
	var i, j, ien, jen, filterData, cellData, row;
	var wasInvalidated = false;

	for ( i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
		row = settings.aoData[i];

		if ( ! row._aFilterData ) {
			filterData = [];

			for ( j=0, jen=columns.length ; j<jen ; j++ ) {
				column = columns[j];

				if ( column.bSearchable ) {
					cellData = _fnGetCellData( settings, i, j, 'filter' );

					// Search in DataTables 1.10 is string based. In 1.11 this
					// should be altered to also allow strict type checking.
					if ( cellData === null ) {
						cellData = '';
					}

					if ( typeof cellData !== 'string' && cellData.toString ) {
						cellData = cellData.toString();
					}
				}
				else {
					cellData = '';
				}

				// If it looks like there is an HTML entity in the string,
				// attempt to decode it so sorting works as expected. Note that
				// we could use a single line of jQuery to do this, but the DOM
				// method used here is much faster http://jsperf.com/html-decode
				if ( cellData.indexOf && cellData.indexOf('&') !== -1 ) {
					__filter_div.innerHTML = cellData;
					cellData = __filter_div_textContent ?
						__filter_div.textContent :
						__filter_div.innerText;
				}

				if ( cellData.replace ) {
					cellData = cellData.replace(/[\r\n\u2028]/g, '');
				}

				filterData.push( cellData );
			}

			row._aFilterData = filterData;
			row._sFilterRow = filterData.join('  ');
			wasInvalidated = true;
		}
	}

	return wasInvalidated;
}


/**
 * Convert from the internal Hungarian notation to camelCase for external
 * interaction
 *  @param {object} obj Object to convert
 *  @returns {object} Inverted object
 *  @memberof DataTable#oApi
 */
function _fnSearchToCamel ( obj )
{
	return {
		search:          obj.sSearch,
		smart:           obj.bSmart,
		regex:           obj.bRegex,
		caseInsensitive: obj.bCaseInsensitive
	};
}



/**
 * Convert from camelCase notation to the internal Hungarian. We could use the
 * Hungarian convert function here, but this is cleaner
 *  @param {object} obj Object to convert
 *  @returns {object} Inverted object
 *  @memberof DataTable#oApi
 */
function _fnSearchToHung ( obj )
{
	return {
		sSearch:          obj.search,
		bSmart:           obj.smart,
		bRegex:           obj.regex,
		bCaseInsensitive: obj.caseInsensitive
	};
}

/**
 * Generate the node required for the info display
 *  @param {object} oSettings dataTables settings object
 *  @returns {node} Information element
 *  @memberof DataTable#oApi
 */
function _fnFeatureHtmlInfo ( settings )
{
	var
		tid = settings.sTableId,
		nodes = settings.aanFeatures.i,
		n = $('<div/>', {
			'class': settings.oClasses.sInfo,
			'id': ! nodes ? tid+'_info' : null
		} );

	if ( ! nodes ) {
		// Update display on each draw
		settings.aoDrawCallback.push( {
			"fn": _fnUpdateInfo,
			"sName": "information"
		} );

		n
			.attr( 'role', 'status' )
			.attr( 'aria-live', 'polite' );

		// Table is described by our info div
		$(settings.nTable).attr( 'aria-describedby', tid+'_info' );
	}

	return n[0];
}


/**
 * Update the information elements in the display
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnUpdateInfo ( settings )
{
	/* Show information about the table */
	var nodes = settings.aanFeatures.i;
	if ( nodes.length === 0 ) {
		return;
	}

	var
		lang  = settings.oLanguage,
		start = settings._iDisplayStart+1,
		end   = settings.fnDisplayEnd(),
		max   = settings.fnRecordsTotal(),
		total = settings.fnRecordsDisplay(),
		out   = total ?
			lang.sInfo :
			lang.sInfoEmpty;

	if ( total !== max ) {
		/* Record set after filtering */
		out += ' ' + lang.sInfoFiltered;
	}

	// Convert the macros
	out += lang.sInfoPostFix;
	out = _fnInfoMacros( settings, out );

	var callback = lang.fnInfoCallback;
	if ( callback !== null ) {
		out = callback.call( settings.oInstance,
			settings, start, end, max, total, out
		);
	}

	$(nodes).html( out );
}


function _fnInfoMacros ( settings, str )
{
	// When infinite scrolling, we are always starting at 1. _iDisplayStart is used only
	// internally
	var
		formatter  = settings.fnFormatNumber,
		start      = settings._iDisplayStart+1,
		len        = settings._iDisplayLength,
		vis        = settings.fnRecordsDisplay(),
		all        = len === -1;

	return str.
		replace(/_START_/g, formatter.call( settings, start ) ).
		replace(/_END_/g,   formatter.call( settings, settings.fnDisplayEnd() ) ).
		replace(/_MAX_/g,   formatter.call( settings, settings.fnRecordsTotal() ) ).
		replace(/_TOTAL_/g, formatter.call( settings, vis ) ).
		replace(/_PAGE_/g,  formatter.call( settings, all ? 1 : Math.ceil( start / len ) ) ).
		replace(/_PAGES_/g, formatter.call( settings, all ? 1 : Math.ceil( vis / len ) ) );
}



/**
 * Draw the table for the first time, adding all required features
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnInitialise ( settings )
{
	var i, iLen, iAjaxStart=settings.iInitDisplayStart;
	var columns = settings.aoColumns, column;
	var features = settings.oFeatures;
	var deferLoading = settings.bDeferLoading; // value modified by the draw

	/* Ensure that the table data is fully initialised */
	if ( ! settings.bInitialised ) {
		setTimeout( function(){ _fnInitialise( settings ); }, 200 );
		return;
	}

	/* Show the display HTML options */
	_fnAddOptionsHtml( settings );

	/* Build and draw the header / footer for the table */
	_fnBuildHead( settings );
	_fnDrawHead( settings, settings.aoHeader );
	_fnDrawHead( settings, settings.aoFooter );

	/* Okay to show that something is going on now */
	_fnProcessingDisplay( settings, true );

	/* Calculate sizes for columns */
	if ( features.bAutoWidth ) {
		_fnCalculateColumnWidths( settings );
	}

	for ( i=0, iLen=columns.length ; i<iLen ; i++ ) {
		column = columns[i];

		if ( column.sWidth ) {
			column.nTh.style.width = _fnStringToCss( column.sWidth );
		}
	}

	_fnCallbackFire( settings, null, 'preInit', [settings] );

	// If there is default sorting required - let's do it. The sort function
	// will do the drawing for us. Otherwise we draw the table regardless of the
	// Ajax source - this allows the table to look initialised for Ajax sourcing
	// data (show 'loading' message possibly)
	_fnReDraw( settings );

	// Server-side processing init complete is done by _fnAjaxUpdateDraw
	var dataSrc = _fnDataSource( settings );
	if ( dataSrc != 'ssp' || deferLoading ) {
		// if there is an ajax source load the data
		if ( dataSrc == 'ajax' ) {
			_fnBuildAjax( settings, [], function(json) {
				var aData = _fnAjaxDataSrc( settings, json );

				// Got the data - add it to the table
				for ( i=0 ; i<aData.length ; i++ ) {
					_fnAddData( settings, aData[i] );
				}

				// Reset the init display for cookie saving. We've already done
				// a filter, and therefore cleared it before. So we need to make
				// it appear 'fresh'
				settings.iInitDisplayStart = iAjaxStart;

				_fnReDraw( settings );

				_fnProcessingDisplay( settings, false );
				_fnInitComplete( settings, json );
			}, settings );
		}
		else {
			_fnProcessingDisplay( settings, false );
			_fnInitComplete( settings );
		}
	}
}


/**
 * Draw the table for the first time, adding all required features
 *  @param {object} oSettings dataTables settings object
 *  @param {object} [json] JSON from the server that completed the table, if using Ajax source
 *    with client-side processing (optional)
 *  @memberof DataTable#oApi
 */
function _fnInitComplete ( settings, json )
{
	settings._bInitComplete = true;

	// When data was added after the initialisation (data or Ajax) we need to
	// calculate the column sizing
	if ( json || settings.oInit.aaData ) {
		_fnAdjustColumnSizing( settings );
	}

	_fnCallbackFire( settings, null, 'plugin-init', [settings, json] );
	_fnCallbackFire( settings, 'aoInitComplete', 'init', [settings, json] );
}


function _fnLengthChange ( settings, val )
{
	var len = parseInt( val, 10 );
	settings._iDisplayLength = len;

	_fnLengthOverflow( settings );

	// Fire length change event
	_fnCallbackFire( settings, null, 'length', [settings, len] );
}


/**
 * Generate the node required for user display length changing
 *  @param {object} settings dataTables settings object
 *  @returns {node} Display length feature node
 *  @memberof DataTable#oApi
 */
function _fnFeatureHtmlLength ( settings )
{
	var
		classes  = settings.oClasses,
		tableId  = settings.sTableId,
		menu     = settings.aLengthMenu,
		d2       = Array.isArray( menu[0] ),
		lengths  = d2 ? menu[0] : menu,
		language = d2 ? menu[1] : menu;

	var select = $('<select/>', {
		'name':          tableId+'_length',
		'aria-controls': tableId,
		'class':         classes.sLengthSelect
	} );

	for ( var i=0, ien=lengths.length ; i<ien ; i++ ) {
		select[0][ i ] = new Option(
			typeof language[i] === 'number' ?
				settings.fnFormatNumber( language[i] ) :
				language[i],
			lengths[i]
		);
	}

	var div = $('<div><label/></div>').addClass( classes.sLength );
	if ( ! settings.aanFeatures.l ) {
		div[0].id = tableId+'_length';
	}

	div.children().append(
		settings.oLanguage.sLengthMenu.replace( '_MENU_', select[0].outerHTML )
	);

	// Can't use `select` variable as user might provide their own and the
	// reference is broken by the use of outerHTML
	$('select', div)
		.val( settings._iDisplayLength )
		.on( 'change.DT', function(e) {
			_fnLengthChange( settings, $(this).val() );
			_fnDraw( settings );
		} );

	// Update node value whenever anything changes the table's length
	$(settings.nTable).on( 'length.dt.DT', function (e, s, len) {
		if ( settings === s ) {
			$('select', div).val( len );
		}
	} );

	return div[0];
}



/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Note that most of the paging logic is done in
 * DataTable.ext.pager
 */

/**
 * Generate the node required for default pagination
 *  @param {object} oSettings dataTables settings object
 *  @returns {node} Pagination feature node
 *  @memberof DataTable#oApi
 */
function _fnFeatureHtmlPaginate ( settings )
{
	var
		type   = settings.sPaginationType,
		plugin = DataTable.ext.pager[ type ],
		modern = typeof plugin === 'function',
		redraw = function( settings ) {
			_fnDraw( settings );
		},
		node = $('<div/>').addClass( settings.oClasses.sPaging + type )[0],
		features = settings.aanFeatures;

	if ( ! modern ) {
		plugin.fnInit( settings, node, redraw );
	}

	/* Add a draw callback for the pagination on first instance, to update the paging display */
	if ( ! features.p )
	{
		node.id = settings.sTableId+'_paginate';

		settings.aoDrawCallback.push( {
			"fn": function( settings ) {
				if ( modern ) {
					var
						start      = settings._iDisplayStart,
						len        = settings._iDisplayLength,
						visRecords = settings.fnRecordsDisplay(),
						all        = len === -1,
						page = all ? 0 : Math.ceil( start / len ),
						pages = all ? 1 : Math.ceil( visRecords / len ),
						buttons = plugin(page, pages),
						i, ien;

					for ( i=0, ien=features.p.length ; i<ien ; i++ ) {
						_fnRenderer( settings, 'pageButton' )(
							settings, features.p[i], i, buttons, page, pages
						);
					}
				}
				else {
					plugin.fnUpdate( settings, redraw );
				}
			},
			"sName": "pagination"
		} );
	}

	return node;
}


/**
 * Alter the display settings to change the page
 *  @param {object} settings DataTables settings object
 *  @param {string|int} action Paging action to take: "first", "previous",
 *    "next" or "last" or page number to jump to (integer)
 *  @param [bool] redraw Automatically draw the update or not
 *  @returns {bool} true page has changed, false - no change
 *  @memberof DataTable#oApi
 */
function _fnPageChange ( settings, action, redraw )
{
	var
		start     = settings._iDisplayStart,
		len       = settings._iDisplayLength,
		records   = settings.fnRecordsDisplay();

	if ( records === 0 || len === -1 )
	{
		start = 0;
	}
	else if ( typeof action === "number" )
	{
		start = action * len;

		if ( start > records )
		{
			start = 0;
		}
	}
	else if ( action == "first" )
	{
		start = 0;
	}
	else if ( action == "previous" )
	{
		start = len >= 0 ?
			start - len :
			0;

		if ( start < 0 )
		{
		  start = 0;
		}
	}
	else if ( action == "next" )
	{
		if ( start + len < records )
		{
			start += len;
		}
	}
	else if ( action == "last" )
	{
		start = Math.floor( (records-1) / len) * len;
	}
	else
	{
		_fnLog( settings, 0, "Unknown paging action: "+action, 5 );
	}

	var changed = settings._iDisplayStart !== start;
	settings._iDisplayStart = start;

	if ( changed ) {
		_fnCallbackFire( settings, null, 'page', [settings] );

		if ( redraw ) {
			_fnDraw( settings );
		}
	}
	else {
		// No change event - paging was called, but no change
		_fnCallbackFire( settings, null, 'page-nc', [settings] );
	}

	return changed;
}



/**
 * Generate the node required for the processing node
 *  @param {object} settings dataTables settings object
 *  @returns {node} Processing element
 *  @memberof DataTable#oApi
 */
function _fnFeatureHtmlProcessing ( settings )
{
	return $('<div/>', {
			'id': ! settings.aanFeatures.r ? settings.sTableId+'_processing' : null,
			'class': settings.oClasses.sProcessing,
			'role': 'status'
		} )
		.html( settings.oLanguage.sProcessing )
		.append('<div><div></div><div></div><div></div><div></div></div>')
		.insertBefore( settings.nTable )[0];
}


/**
 * Display or hide the processing indicator
 *  @param {object} settings dataTables settings object
 *  @param {bool} show Show the processing indicator (true) or not (false)
 *  @memberof DataTable#oApi
 */
function _fnProcessingDisplay ( settings, show )
{
	if ( settings.oFeatures.bProcessing ) {
		$(settings.aanFeatures.r).css( 'display', show ? 'block' : 'none' );
	}

	_fnCallbackFire( settings, null, 'processing', [settings, show] );
}

/**
 * Add any control elements for the table - specifically scrolling
 *  @param {object} settings dataTables settings object
 *  @returns {node} Node to add to the DOM
 *  @memberof DataTable#oApi
 */
function _fnFeatureHtmlTable ( settings )
{
	var table = $(settings.nTable);

	// Scrolling from here on in
	var scroll = settings.oScroll;

	if ( scroll.sX === '' && scroll.sY === '' ) {
		return settings.nTable;
	}

	var scrollX = scroll.sX;
	var scrollY = scroll.sY;
	var classes = settings.oClasses;
	var caption = table.children('caption');
	var captionSide = caption.length ? caption[0]._captionSide : null;
	var headerClone = $( table[0].cloneNode(false) );
	var footerClone = $( table[0].cloneNode(false) );
	var footer = table.children('tfoot');
	var _div = '<div/>';
	var size = function ( s ) {
		return !s ? null : _fnStringToCss( s );
	};

	if ( ! footer.length ) {
		footer = null;
	}

	/*
	 * The HTML structure that we want to generate in this function is:
	 *  div - scroller
	 *    div - scroll head
	 *      div - scroll head inner
	 *        table - scroll head table
	 *          thead - thead
	 *    div - scroll body
	 *      table - table (master table)
	 *        thead - thead clone for sizing
	 *        tbody - tbody
	 *    div - scroll foot
	 *      div - scroll foot inner
	 *        table - scroll foot table
	 *          tfoot - tfoot
	 */
	var scroller = $( _div, { 'class': classes.sScrollWrapper } )
		.append(
			$(_div, { 'class': classes.sScrollHead } )
				.css( {
					overflow: 'hidden',
					position: 'relative',
					border: 0,
					width: scrollX ? size(scrollX) : '100%'
				} )
				.append(
					$(_div, { 'class': classes.sScrollHeadInner } )
						.css( {
							'box-sizing': 'content-box',
							width: scroll.sXInner || '100%'
						} )
						.append(
							headerClone
								.removeAttr('id')
								.css( 'margin-left', 0 )
								.append( captionSide === 'top' ? caption : null )
								.append(
									table.children('thead')
								)
						)
				)
		)
		.append(
			$(_div, { 'class': classes.sScrollBody } )
				.css( {
					position: 'relative',
					overflow: 'auto',
					width: size( scrollX )
				} )
				.append( table )
		);

	if ( footer ) {
		scroller.append(
			$(_div, { 'class': classes.sScrollFoot } )
				.css( {
					overflow: 'hidden',
					border: 0,
					width: scrollX ? size(scrollX) : '100%'
				} )
				.append(
					$(_div, { 'class': classes.sScrollFootInner } )
						.append(
							footerClone
								.removeAttr('id')
								.css( 'margin-left', 0 )
								.append( captionSide === 'bottom' ? caption : null )
								.append(
									table.children('tfoot')
								)
						)
				)
		);
	}

	var children = scroller.children();
	var scrollHead = children[0];
	var scrollBody = children[1];
	var scrollFoot = footer ? children[2] : null;

	// When the body is scrolled, then we also want to scroll the headers
	if ( scrollX ) {
		$(scrollBody).on( 'scroll.DT', function (e) {
			var scrollLeft = this.scrollLeft;

			scrollHead.scrollLeft = scrollLeft;

			if ( footer ) {
				scrollFoot.scrollLeft = scrollLeft;
			}
		} );
	}

	$(scrollBody).css('max-height', scrollY);
	if (! scroll.bCollapse) {
		$(scrollBody).css('height', scrollY);
	}

	settings.nScrollHead = scrollHead;
	settings.nScrollBody = scrollBody;
	settings.nScrollFoot = scrollFoot;

	// On redraw - align columns
	settings.aoDrawCallback.push( {
		"fn": _fnScrollDraw,
		"sName": "scrolling"
	} );

	return scroller[0];
}



/**
 * Update the header, footer and body tables for resizing - i.e. column
 * alignment.
 *
 * Welcome to the most horrible function DataTables. The process that this
 * function follows is basically:
 *   1. Re-create the table inside the scrolling div
 *   2. Take live measurements from the DOM
 *   3. Apply the measurements to align the columns
 *   4. Clean up
 *
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnScrollDraw ( settings )
{
	// Given that this is such a monster function, a lot of variables are use
	// to try and keep the minimised size as small as possible
	var
		scroll         = settings.oScroll,
		scrollX        = scroll.sX,
		scrollXInner   = scroll.sXInner,
		scrollY        = scroll.sY,
		barWidth       = scroll.iBarWidth,
		divHeader      = $(settings.nScrollHead),
		divHeaderStyle = divHeader[0].style,
		divHeaderInner = divHeader.children('div'),
		divHeaderInnerStyle = divHeaderInner[0].style,
		divHeaderTable = divHeaderInner.children('table'),
		divBodyEl      = settings.nScrollBody,
		divBody        = $(divBodyEl),
		divBodyStyle   = divBodyEl.style,
		divFooter      = $(settings.nScrollFoot),
		divFooterInner = divFooter.children('div'),
		divFooterTable = divFooterInner.children('table'),
		header         = $(settings.nTHead),
		table          = $(settings.nTable),
		tableEl        = table[0],
		tableStyle     = tableEl.style,
		footer         = settings.nTFoot ? $(settings.nTFoot) : null,
		browser        = settings.oBrowser,
		ie67           = browser.bScrollOversize,
		dtHeaderCells  = _pluck( settings.aoColumns, 'nTh' ),
		headerTrgEls, footerTrgEls,
		headerSrcEls, footerSrcEls,
		headerCopy, footerCopy,
		headerWidths=[], footerWidths=[],
		headerContent=[], footerContent=[],
		idx, correction, sanityWidth,
		zeroOut = function(nSizer) {
			var style = nSizer.style;
			style.paddingTop = "0";
			style.paddingBottom = "0";
			style.borderTopWidth = "0";
			style.borderBottomWidth = "0";
			style.height = 0;
		};

	// If the scrollbar visibility has changed from the last draw, we need to
	// adjust the column sizes as the table width will have changed to account
	// for the scrollbar
	var scrollBarVis = divBodyEl.scrollHeight > divBodyEl.clientHeight;
	
	if ( settings.scrollBarVis !== scrollBarVis && settings.scrollBarVis !== undefined ) {
		settings.scrollBarVis = scrollBarVis;
		_fnAdjustColumnSizing( settings );
		return; // adjust column sizing will call this function again
	}
	else {
		settings.scrollBarVis = scrollBarVis;
	}

	/*
	 * 1. Re-create the table inside the scrolling div
	 */

	// Remove the old minimised thead and tfoot elements in the inner table
	table.children('thead, tfoot').remove();

	if ( footer ) {
		footerCopy = footer.clone().prependTo( table );
		footerTrgEls = footer.find('tr'); // the original tfoot is in its own table and must be sized
		footerSrcEls = footerCopy.find('tr');
		footerCopy.find('[id]').removeAttr('id');
	}

	// Clone the current header and footer elements and then place it into the inner table
	headerCopy = header.clone().prependTo( table );
	headerTrgEls = header.find('tr'); // original header is in its own table
	headerSrcEls = headerCopy.find('tr');
	headerCopy.find('th, td').removeAttr('tabindex');
	headerCopy.find('[id]').removeAttr('id');


	/*
	 * 2. Take live measurements from the DOM - do not alter the DOM itself!
	 */

	// Remove old sizing and apply the calculated column widths
	// Get the unique column headers in the newly created (cloned) header. We want to apply the
	// calculated sizes to this header
	if ( ! scrollX )
	{
		divBodyStyle.width = '100%';
		divHeader[0].style.width = '100%';
	}

	$.each( _fnGetUniqueThs( settings, headerCopy ), function ( i, el ) {
		idx = _fnVisibleToColumnIndex( settings, i );
		el.style.width = settings.aoColumns[idx].sWidth;
	} );

	if ( footer ) {
		_fnApplyToChildren( function(n) {
			n.style.width = "";
		}, footerSrcEls );
	}

	// Size the table as a whole
	sanityWidth = table.outerWidth();
	if ( scrollX === "" ) {
		// No x scrolling
		tableStyle.width = "100%";

		// IE7 will make the width of the table when 100% include the scrollbar
		// - which is shouldn't. When there is a scrollbar we need to take this
		// into account.
		if ( ie67 && (table.find('tbody').height() > divBodyEl.offsetHeight ||
			divBody.css('overflow-y') == "scroll")
		) {
			tableStyle.width = _fnStringToCss( table.outerWidth() - barWidth);
		}

		// Recalculate the sanity width
		sanityWidth = table.outerWidth();
	}
	else if ( scrollXInner !== "" ) {
		// legacy x scroll inner has been given - use it
		tableStyle.width = _fnStringToCss(scrollXInner);

		// Recalculate the sanity width
		sanityWidth = table.outerWidth();
	}

	// Hidden header should have zero height, so remove padding and borders. Then
	// set the width based on the real headers

	// Apply all styles in one pass
	_fnApplyToChildren( zeroOut, headerSrcEls );

	// Read all widths in next pass
	_fnApplyToChildren( function(nSizer) {
		var style = window.getComputedStyle ?
			window.getComputedStyle(nSizer).width :
			_fnStringToCss( $(nSizer).width() );

		headerContent.push( nSizer.innerHTML );
		headerWidths.push( style );
	}, headerSrcEls );

	// Apply all widths in final pass
	_fnApplyToChildren( function(nToSize, i) {
		nToSize.style.width = headerWidths[i];
	}, headerTrgEls );

	$(headerSrcEls).css('height', 0);

	/* Same again with the footer if we have one */
	if ( footer )
	{
		_fnApplyToChildren( zeroOut, footerSrcEls );

		_fnApplyToChildren( function(nSizer) {
			footerContent.push( nSizer.innerHTML );
			footerWidths.push( _fnStringToCss( $(nSizer).css('width') ) );
		}, footerSrcEls );

		_fnApplyToChildren( function(nToSize, i) {
			nToSize.style.width = footerWidths[i];
		}, footerTrgEls );

		$(footerSrcEls).height(0);
	}


	/*
	 * 3. Apply the measurements
	 */

	// "Hide" the header and footer that we used for the sizing. We need to keep
	// the content of the cell so that the width applied to the header and body
	// both match, but we want to hide it completely. We want to also fix their
	// width to what they currently are
	_fnApplyToChildren( function(nSizer, i) {
		nSizer.innerHTML = '<div class="dataTables_sizing">'+headerContent[i]+'</div>';
		nSizer.childNodes[0].style.height = "0";
		nSizer.childNodes[0].style.overflow = "hidden";
		nSizer.style.width = headerWidths[i];
	}, headerSrcEls );

	if ( footer )
	{
		_fnApplyToChildren( function(nSizer, i) {
			nSizer.innerHTML = '<div class="dataTables_sizing">'+footerContent[i]+'</div>';
			nSizer.childNodes[0].style.height = "0";
			nSizer.childNodes[0].style.overflow = "hidden";
			nSizer.style.width = footerWidths[i];
		}, footerSrcEls );
	}

	// Sanity check that the table is of a sensible width. If not then we are going to get
	// misalignment - try to prevent this by not allowing the table to shrink below its min width
	if ( Math.round(table.outerWidth()) < Math.round(sanityWidth) )
	{
		// The min width depends upon if we have a vertical scrollbar visible or not */
		correction = ((divBodyEl.scrollHeight > divBodyEl.offsetHeight ||
			divBody.css('overflow-y') == "scroll")) ?
				sanityWidth+barWidth :
				sanityWidth;

		// IE6/7 are a law unto themselves...
		if ( ie67 && (divBodyEl.scrollHeight >
			divBodyEl.offsetHeight || divBody.css('overflow-y') == "scroll")
		) {
			tableStyle.width = _fnStringToCss( correction-barWidth );
		}

		// And give the user a warning that we've stopped the table getting too small
		if ( scrollX === "" || scrollXInner !== "" ) {
			_fnLog( settings, 1, 'Possible column misalignment', 6 );
		}
	}
	else
	{
		correction = '100%';
	}

	// Apply to the container elements
	divBodyStyle.width = _fnStringToCss( correction );
	divHeaderStyle.width = _fnStringToCss( correction );

	if ( footer ) {
		settings.nScrollFoot.style.width = _fnStringToCss( correction );
	}


	/*
	 * 4. Clean up
	 */
	if ( ! scrollY ) {
		/* IE7< puts a vertical scrollbar in place (when it shouldn't be) due to subtracting
		 * the scrollbar height from the visible display, rather than adding it on. We need to
		 * set the height in order to sort this. Don't want to do it in any other browsers.
		 */
		if ( ie67 ) {
			divBodyStyle.height = _fnStringToCss( tableEl.offsetHeight+barWidth );
		}
	}

	/* Finally set the width's of the header and footer tables */
	var iOuterWidth = table.outerWidth();
	divHeaderTable[0].style.width = _fnStringToCss( iOuterWidth );
	divHeaderInnerStyle.width = _fnStringToCss( iOuterWidth );

	// Figure out if there are scrollbar present - if so then we need a the header and footer to
	// provide a bit more space to allow "overflow" scrolling (i.e. past the scrollbar)
	var bScrolling = table.height() > divBodyEl.clientHeight || divBody.css('overflow-y') == "scroll";
	var padding = 'padding' + (browser.bScrollbarLeft ? 'Left' : 'Right' );
	divHeaderInnerStyle[ padding ] = bScrolling ? barWidth+"px" : "0px";

	if ( footer ) {
		divFooterTable[0].style.width = _fnStringToCss( iOuterWidth );
		divFooterInner[0].style.width = _fnStringToCss( iOuterWidth );
		divFooterInner[0].style[padding] = bScrolling ? barWidth+"px" : "0px";
	}

	// Correct DOM ordering for colgroup - comes before the thead
	table.children('colgroup').insertBefore( table.children('thead') );

	/* Adjust the position of the header in case we loose the y-scrollbar */
	divBody.trigger('scroll');

	// If sorting or filtering has occurred, jump the scrolling back to the top
	// only if we aren't holding the position
	if ( (settings.bSorted || settings.bFiltered) && ! settings._drawHold ) {
		divBodyEl.scrollTop = 0;
	}
}



/**
 * Apply a given function to the display child nodes of an element array (typically
 * TD children of TR rows
 *  @param {function} fn Method to apply to the objects
 *  @param array {nodes} an1 List of elements to look through for display children
 *  @param array {nodes} an2 Another list (identical structure to the first) - optional
 *  @memberof DataTable#oApi
 */
function _fnApplyToChildren( fn, an1, an2 )
{
	var index=0, i=0, iLen=an1.length;
	var nNode1, nNode2;

	while ( i < iLen ) {
		nNode1 = an1[i].firstChild;
		nNode2 = an2 ? an2[i].firstChild : null;

		while ( nNode1 ) {
			if ( nNode1.nodeType === 1 ) {
				if ( an2 ) {
					fn( nNode1, nNode2, index );
				}
				else {
					fn( nNode1, index );
				}

				index++;
			}

			nNode1 = nNode1.nextSibling;
			nNode2 = an2 ? nNode2.nextSibling : null;
		}

		i++;
	}
}



var __re_html_remove = /<.*?>/g;


/**
 * Calculate the width of columns for the table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnCalculateColumnWidths ( oSettings )
{
	var
		table = oSettings.nTable,
		columns = oSettings.aoColumns,
		scroll = oSettings.oScroll,
		scrollY = scroll.sY,
		scrollX = scroll.sX,
		scrollXInner = scroll.sXInner,
		columnCount = columns.length,
		visibleColumns = _fnGetColumns( oSettings, 'bVisible' ),
		headerCells = $('th', oSettings.nTHead),
		tableWidthAttr = table.getAttribute('width'), // from DOM element
		tableContainer = table.parentNode,
		userInputs = false,
		i, column, columnIdx, width, outerWidth,
		browser = oSettings.oBrowser,
		ie67 = browser.bScrollOversize;

	var styleWidth = table.style.width;
	if ( styleWidth && styleWidth.indexOf('%') !== -1 ) {
		tableWidthAttr = styleWidth;
	}

	/* Convert any user input sizes into pixel sizes */
	for ( i=0 ; i<visibleColumns.length ; i++ ) {
		column = columns[ visibleColumns[i] ];

		if ( column.sWidth !== null ) {
			column.sWidth = _fnConvertToWidth( column.sWidthOrig, tableContainer );

			userInputs = true;
		}
	}

	/* If the number of columns in the DOM equals the number that we have to
	 * process in DataTables, then we can use the offsets that are created by
	 * the web- browser. No custom sizes can be set in order for this to happen,
	 * nor scrolling used
	 */
	if ( ie67 || ! userInputs && ! scrollX && ! scrollY &&
	     columnCount == _fnVisbleColumns( oSettings ) &&
	     columnCount == headerCells.length
	) {
		for ( i=0 ; i<columnCount ; i++ ) {
			var colIdx = _fnVisibleToColumnIndex( oSettings, i );

			if ( colIdx !== null ) {
				columns[ colIdx ].sWidth = _fnStringToCss( headerCells.eq(i).width() );
			}
		}
	}
	else
	{
		// Otherwise construct a single row, worst case, table with the widest
		// node in the data, assign any user defined widths, then insert it into
		// the DOM and allow the browser to do all the hard work of calculating
		// table widths
		var tmpTable = $(table).clone() // don't use cloneNode - IE8 will remove events on the main table
			.css( 'visibility', 'hidden' )
			.removeAttr( 'id' );

		// Clean up the table body
		tmpTable.find('tbody tr').remove();
		var tr = $('<tr/>').appendTo( tmpTable.find('tbody') );

		// Clone the table header and footer - we can't use the header / footer
		// from the cloned table, since if scrolling is active, the table's
		// real header and footer are contained in different table tags
		tmpTable.find('thead, tfoot').remove();
		tmpTable
			.append( $(oSettings.nTHead).clone() )
			.append( $(oSettings.nTFoot).clone() );

		// Remove any assigned widths from the footer (from scrolling)
		tmpTable.find('tfoot th, tfoot td').css('width', '');

		// Apply custom sizing to the cloned header
		headerCells = _fnGetUniqueThs( oSettings, tmpTable.find('thead')[0] );

		for ( i=0 ; i<visibleColumns.length ; i++ ) {
			column = columns[ visibleColumns[i] ];

			headerCells[i].style.width = column.sWidthOrig !== null && column.sWidthOrig !== '' ?
				_fnStringToCss( column.sWidthOrig ) :
				'';

			// For scrollX we need to force the column width otherwise the
			// browser will collapse it. If this width is smaller than the
			// width the column requires, then it will have no effect
			if ( column.sWidthOrig && scrollX ) {
				$( headerCells[i] ).append( $('<div/>').css( {
					width: column.sWidthOrig,
					margin: 0,
					padding: 0,
					border: 0,
					height: 1
				} ) );
			}
		}

		// Find the widest cell for each column and put it into the table
		if ( oSettings.aoData.length ) {
			for ( i=0 ; i<visibleColumns.length ; i++ ) {
				columnIdx = visibleColumns[i];
				column = columns[ columnIdx ];

				$( _fnGetWidestNode( oSettings, columnIdx ) )
					.clone( false )
					.append( column.sContentPadding )
					.appendTo( tr );
			}
		}

		// Tidy the temporary table - remove name attributes so there aren't
		// duplicated in the dom (radio elements for example)
		$('[name]', tmpTable).removeAttr('name');

		// Table has been built, attach to the document so we can work with it.
		// A holding element is used, positioned at the top of the container
		// with minimal height, so it has no effect on if the container scrolls
		// or not. Otherwise it might trigger scrolling when it actually isn't
		// needed
		var holder = $('<div/>').css( scrollX || scrollY ?
				{
					position: 'absolute',
					top: 0,
					left: 0,
					height: 1,
					right: 0,
					overflow: 'hidden'
				} :
				{}
			)
			.append( tmpTable )
			.appendTo( tableContainer );

		// When scrolling (X or Y) we want to set the width of the table as 
		// appropriate. However, when not scrolling leave the table width as it
		// is. This results in slightly different, but I think correct behaviour
		if ( scrollX && scrollXInner ) {
			tmpTable.width( scrollXInner );
		}
		else if ( scrollX ) {
			tmpTable.css( 'width', 'auto' );
			tmpTable.removeAttr('width');

			// If there is no width attribute or style, then allow the table to
			// collapse
			if ( tmpTable.width() < tableContainer.clientWidth && tableWidthAttr ) {
				tmpTable.width( tableContainer.clientWidth );
			}
		}
		else if ( scrollY ) {
			tmpTable.width( tableContainer.clientWidth );
		}
		else if ( tableWidthAttr ) {
			tmpTable.width( tableWidthAttr );
		}

		// Get the width of each column in the constructed table - we need to
		// know the inner width (so it can be assigned to the other table's
		// cells) and the outer width so we can calculate the full width of the
		// table. This is safe since DataTables requires a unique cell for each
		// column, but if ever a header can span multiple columns, this will
		// need to be modified.
		var total = 0;
		for ( i=0 ; i<visibleColumns.length ; i++ ) {
			var cell = $(headerCells[i]);
			var border = cell.outerWidth() - cell.width();

			// Use getBounding... where possible (not IE8-) because it can give
			// sub-pixel accuracy, which we then want to round up!
			var bounding = browser.bBounding ?
				Math.ceil( headerCells[i].getBoundingClientRect().width ) :
				cell.outerWidth();

			// Total is tracked to remove any sub-pixel errors as the outerWidth
			// of the table might not equal the total given here (IE!).
			total += bounding;

			// Width for each column to use
			columns[ visibleColumns[i] ].sWidth = _fnStringToCss( bounding - border );
		}

		table.style.width = _fnStringToCss( total );

		// Finished with the table - ditch it
		holder.remove();
	}

	// If there is a width attr, we want to attach an event listener which
	// allows the table sizing to automatically adjust when the window is
	// resized. Use the width attr rather than CSS, since we can't know if the
	// CSS is a relative value or absolute - DOM read is always px.
	if ( tableWidthAttr ) {
		table.style.width = _fnStringToCss( tableWidthAttr );
	}

	if ( (tableWidthAttr || scrollX) && ! oSettings._reszEvt ) {
		var bindResize = function () {
			$(window).on('resize.DT-'+oSettings.sInstance, _fnThrottle( function () {
				_fnAdjustColumnSizing( oSettings );
			} ) );
		};

		// IE6/7 will crash if we bind a resize event handler on page load.
		// To be removed in 1.11 which drops IE6/7 support
		if ( ie67 ) {
			setTimeout( bindResize, 1000 );
		}
		else {
			bindResize();
		}

		oSettings._reszEvt = true;
	}
}


/**
 * Throttle the calls to a function. Arguments and context are maintained for
 * the throttled function
 *  @param {function} fn Function to be called
 *  @param {int} [freq=200] call frequency in mS
 *  @returns {function} wrapped function
 *  @memberof DataTable#oApi
 */
var _fnThrottle = DataTable.util.throttle;


/**
 * Convert a CSS unit width to pixels (e.g. 2em)
 *  @param {string} width width to be converted
 *  @param {node} parent parent to get the with for (required for relative widths) - optional
 *  @returns {int} width in pixels
 *  @memberof DataTable#oApi
 */
function _fnConvertToWidth ( width, parent )
{
	if ( ! width ) {
		return 0;
	}

	var n = $('<div/>')
		.css( 'width', _fnStringToCss( width ) )
		.appendTo( parent || document.body );

	var val = n[0].offsetWidth;
	n.remove();

	return val;
}


/**
 * Get the widest node
 *  @param {object} settings dataTables settings object
 *  @param {int} colIdx column of interest
 *  @returns {node} widest table node
 *  @memberof DataTable#oApi
 */
function _fnGetWidestNode( settings, colIdx )
{
	var idx = _fnGetMaxLenString( settings, colIdx );
	if ( idx < 0 ) {
		return null;
	}

	var data = settings.aoData[ idx ];
	return ! data.nTr ? // Might not have been created when deferred rendering
		$('<td/>').html( _fnGetCellData( settings, idx, colIdx, 'display' ) )[0] :
		data.anCells[ colIdx ];
}


/**
 * Get the maximum strlen for each data column
 *  @param {object} settings dataTables settings object
 *  @param {int} colIdx column of interest
 *  @returns {string} max string length for each column
 *  @memberof DataTable#oApi
 */
function _fnGetMaxLenString( settings, colIdx )
{
	var s, max=-1, maxIdx = -1;

	for ( var i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
		s = _fnGetCellData( settings, i, colIdx, 'display' )+'';
		s = s.replace( __re_html_remove, '' );
		s = s.replace( /&nbsp;/g, ' ' );

		if ( s.length > max ) {
			max = s.length;
			maxIdx = i;
		}
	}

	return maxIdx;
}


/**
 * Append a CSS unit (only if required) to a string
 *  @param {string} value to css-ify
 *  @returns {string} value with css unit
 *  @memberof DataTable#oApi
 */
function _fnStringToCss( s )
{
	if ( s === null ) {
		return '0px';
	}

	if ( typeof s == 'number' ) {
		return s < 0 ?
			'0px' :
			s+'px';
	}

	// Check it has a unit character already
	return s.match(/\d$/) ?
		s+'px' :
		s;
}



function _fnSortFlatten ( settings )
{
	var
		i, iLen, k, kLen,
		aSort = [],
		aiOrig = [],
		aoColumns = settings.aoColumns,
		aDataSort, iCol, sType, srcCol,
		fixed = settings.aaSortingFixed,
		fixedObj = $.isPlainObject( fixed ),
		nestedSort = [],
		add = function ( a ) {
			if ( a.length && ! Array.isArray( a[0] ) ) {
				// 1D array
				nestedSort.push( a );
			}
			else {
				// 2D array
				$.merge( nestedSort, a );
			}
		};

	// Build the sort array, with pre-fix and post-fix options if they have been
	// specified
	if ( Array.isArray( fixed ) ) {
		add( fixed );
	}

	if ( fixedObj && fixed.pre ) {
		add( fixed.pre );
	}

	add( settings.aaSorting );

	if (fixedObj && fixed.post ) {
		add( fixed.post );
	}

	for ( i=0 ; i<nestedSort.length ; i++ )
	{
		srcCol = nestedSort[i][0];
		aDataSort = aoColumns[ srcCol ].aDataSort;

		for ( k=0, kLen=aDataSort.length ; k<kLen ; k++ )
		{
			iCol = aDataSort[k];
			sType = aoColumns[ iCol ].sType || 'string';

			if ( nestedSort[i]._idx === undefined ) {
				nestedSort[i]._idx = $.inArray( nestedSort[i][1], aoColumns[iCol].asSorting );
			}

			aSort.push( {
				src:       srcCol,
				col:       iCol,
				dir:       nestedSort[i][1],
				index:     nestedSort[i]._idx,
				type:      sType,
				formatter: DataTable.ext.type.order[ sType+"-pre" ]
			} );
		}
	}

	return aSort;
}

/**
 * Change the order of the table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 *  @todo This really needs split up!
 */
function _fnSort ( oSettings )
{
	var
		i, ien, iLen, j, jLen, k, kLen,
		sDataType, nTh,
		aiOrig = [],
		oExtSort = DataTable.ext.type.order,
		aoData = oSettings.aoData,
		aoColumns = oSettings.aoColumns,
		aDataSort, data, iCol, sType, oSort,
		formatters = 0,
		sortCol,
		displayMaster = oSettings.aiDisplayMaster,
		aSort;

	// Resolve any column types that are unknown due to addition or invalidation
	// @todo Can this be moved into a 'data-ready' handler which is called when
	//   data is going to be used in the table?
	_fnColumnTypes( oSettings );

	aSort = _fnSortFlatten( oSettings );

	for ( i=0, ien=aSort.length ; i<ien ; i++ ) {
		sortCol = aSort[i];

		// Track if we can use the fast sort algorithm
		if ( sortCol.formatter ) {
			formatters++;
		}

		// Load the data needed for the sort, for each cell
		_fnSortData( oSettings, sortCol.col );
	}

	/* No sorting required if server-side or no sorting array */
	if ( _fnDataSource( oSettings ) != 'ssp' && aSort.length !== 0 )
	{
		// Create a value - key array of the current row positions such that we can use their
		// current position during the sort, if values match, in order to perform stable sorting
		for ( i=0, iLen=displayMaster.length ; i<iLen ; i++ ) {
			aiOrig[ displayMaster[i] ] = i;
		}

		/* Do the sort - here we want multi-column sorting based on a given data source (column)
		 * and sorting function (from oSort) in a certain direction. It's reasonably complex to
		 * follow on it's own, but this is what we want (example two column sorting):
		 *  fnLocalSorting = function(a,b){
		 *    var iTest;
		 *    iTest = oSort['string-asc']('data11', 'data12');
		 *      if (iTest !== 0)
		 *        return iTest;
		 *    iTest = oSort['numeric-desc']('data21', 'data22');
		 *    if (iTest !== 0)
		 *      return iTest;
		 *    return oSort['numeric-asc']( aiOrig[a], aiOrig[b] );
		 *  }
		 * Basically we have a test for each sorting column, if the data in that column is equal,
		 * test the next column. If all columns match, then we use a numeric sort on the row
		 * positions in the original data array to provide a stable sort.
		 *
		 * Note - I know it seems excessive to have two sorting methods, but the first is around
		 * 15% faster, so the second is only maintained for backwards compatibility with sorting
		 * methods which do not have a pre-sort formatting function.
		 */
		if ( formatters === aSort.length ) {
			// All sort types have formatting functions
			displayMaster.sort( function ( a, b ) {
				var
					x, y, k, test, sort,
					len=aSort.length,
					dataA = aoData[a]._aSortData,
					dataB = aoData[b]._aSortData;

				for ( k=0 ; k<len ; k++ ) {
					sort = aSort[k];

					x = dataA[ sort.col ];
					y = dataB[ sort.col ];

					test = x<y ? -1 : x>y ? 1 : 0;
					if ( test !== 0 ) {
						return sort.dir === 'asc' ? test : -test;
					}
				}

				x = aiOrig[a];
				y = aiOrig[b];
				return x<y ? -1 : x>y ? 1 : 0;
			} );
		}
		else {
			// Depreciated - remove in 1.11 (providing a plug-in option)
			// Not all sort types have formatting methods, so we have to call their sorting
			// methods.
			displayMaster.sort( function ( a, b ) {
				var
					x, y, k, l, test, sort, fn,
					len=aSort.length,
					dataA = aoData[a]._aSortData,
					dataB = aoData[b]._aSortData;

				for ( k=0 ; k<len ; k++ ) {
					sort = aSort[k];

					x = dataA[ sort.col ];
					y = dataB[ sort.col ];

					fn = oExtSort[ sort.type+"-"+sort.dir ] || oExtSort[ "string-"+sort.dir ];
					test = fn( x, y );
					if ( test !== 0 ) {
						return test;
					}
				}

				x = aiOrig[a];
				y = aiOrig[b];
				return x<y ? -1 : x>y ? 1 : 0;
			} );
		}
	}

	/* Tell the draw function that we have sorted the data */
	oSettings.bSorted = true;
}


function _fnSortAria ( settings )
{
	var label;
	var nextSort;
	var columns = settings.aoColumns;
	var aSort = _fnSortFlatten( settings );
	var oAria = settings.oLanguage.oAria;

	// ARIA attributes - need to loop all columns, to update all (removing old
	// attributes as needed)
	for ( var i=0, iLen=columns.length ; i<iLen ; i++ )
	{
		var col = columns[i];
		var asSorting = col.asSorting;
		var sTitle = col.ariaTitle || col.sTitle.replace( /<.*?>/g, "" );
		var th = col.nTh;

		// IE7 is throwing an error when setting these properties with jQuery's
		// attr() and removeAttr() methods...
		th.removeAttribute('aria-sort');

		/* In ARIA only the first sorting column can be marked as sorting - no multi-sort option */
		if ( col.bSortable ) {
			if ( aSort.length > 0 && aSort[0].col == i ) {
				th.setAttribute('aria-sort', aSort[0].dir=="asc" ? "ascending" : "descending" );
				nextSort = asSorting[ aSort[0].index+1 ] || asSorting[0];
			}
			else {
				nextSort = asSorting[0];
			}

			label = sTitle + ( nextSort === "asc" ?
				oAria.sSortAscending :
				oAria.sSortDescending
			);
		}
		else {
			label = sTitle;
		}

		th.setAttribute('aria-label', label);
	}
}


/**
 * Function to run on user sort request
 *  @param {object} settings dataTables settings object
 *  @param {node} attachTo node to attach the handler to
 *  @param {int} colIdx column sorting index
 *  @param {boolean} [append=false] Append the requested sort to the existing
 *    sort if true (i.e. multi-column sort)
 *  @param {function} [callback] callback function
 *  @memberof DataTable#oApi
 */
function _fnSortListener ( settings, colIdx, append, callback )
{
	var col = settings.aoColumns[ colIdx ];
	var sorting = settings.aaSorting;
	var asSorting = col.asSorting;
	var nextSortIdx;
	var next = function ( a, overflow ) {
		var idx = a._idx;
		if ( idx === undefined ) {
			idx = $.inArray( a[1], asSorting );
		}

		return idx+1 < asSorting.length ?
			idx+1 :
			overflow ?
				null :
				0;
	};

	// Convert to 2D array if needed
	if ( typeof sorting[0] === 'number' ) {
		sorting = settings.aaSorting = [ sorting ];
	}

	// If appending the sort then we are multi-column sorting
	if ( append && settings.oFeatures.bSortMulti ) {
		// Are we already doing some kind of sort on this column?
		var sortIdx = $.inArray( colIdx, _pluck(sorting, '0') );

		if ( sortIdx !== -1 ) {
			// Yes, modify the sort
			nextSortIdx = next( sorting[sortIdx], true );

			if ( nextSortIdx === null && sorting.length === 1 ) {
				nextSortIdx = 0; // can't remove sorting completely
			}

			if ( nextSortIdx === null ) {
				sorting.splice( sortIdx, 1 );
			}
			else {
				sorting[sortIdx][1] = asSorting[ nextSortIdx ];
				sorting[sortIdx]._idx = nextSortIdx;
			}
		}
		else {
			// No sort on this column yet
			sorting.push( [ colIdx, asSorting[0], 0 ] );
			sorting[sorting.length-1]._idx = 0;
		}
	}
	else if ( sorting.length && sorting[0][0] == colIdx ) {
		// Single column - already sorting on this column, modify the sort
		nextSortIdx = next( sorting[0] );

		sorting.length = 1;
		sorting[0][1] = asSorting[ nextSortIdx ];
		sorting[0]._idx = nextSortIdx;
	}
	else {
		// Single column - sort only on this column
		sorting.length = 0;
		sorting.push( [ colIdx, asSorting[0] ] );
		sorting[0]._idx = 0;
	}

	// Run the sort by calling a full redraw
	_fnReDraw( settings );

	// callback used for async user interaction
	if ( typeof callback == 'function' ) {
		callback( settings );
	}
}


/**
 * Attach a sort handler (click) to a node
 *  @param {object} settings dataTables settings object
 *  @param {node} attachTo node to attach the handler to
 *  @param {int} colIdx column sorting index
 *  @param {function} [callback] callback function
 *  @memberof DataTable#oApi
 */
function _fnSortAttachListener ( settings, attachTo, colIdx, callback )
{
	var col = settings.aoColumns[ colIdx ];

	_fnBindAction( attachTo, {}, function (e) {
		/* If the column is not sortable - don't to anything */
		if ( col.bSortable === false ) {
			return;
		}

		// If processing is enabled use a timeout to allow the processing
		// display to be shown - otherwise to it synchronously
		if ( settings.oFeatures.bProcessing ) {
			_fnProcessingDisplay( settings, true );

			setTimeout( function() {
				_fnSortListener( settings, colIdx, e.shiftKey, callback );

				// In server-side processing, the draw callback will remove the
				// processing display
				if ( _fnDataSource( settings ) !== 'ssp' ) {
					_fnProcessingDisplay( settings, false );
				}
			}, 0 );
		}
		else {
			_fnSortListener( settings, colIdx, e.shiftKey, callback );
		}
	} );
}


/**
 * Set the sorting classes on table's body, Note: it is safe to call this function
 * when bSort and bSortClasses are false
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnSortingClasses( settings )
{
	var oldSort = settings.aLastSort;
	var sortClass = settings.oClasses.sSortColumn;
	var sort = _fnSortFlatten( settings );
	var features = settings.oFeatures;
	var i, ien, colIdx;

	if ( features.bSort && features.bSortClasses ) {
		// Remove old sorting classes
		for ( i=0, ien=oldSort.length ; i<ien ; i++ ) {
			colIdx = oldSort[i].src;

			// Remove column sorting
			$( _pluck( settings.aoData, 'anCells', colIdx ) )
				.removeClass( sortClass + (i<2 ? i+1 : 3) );
		}

		// Add new column sorting
		for ( i=0, ien=sort.length ; i<ien ; i++ ) {
			colIdx = sort[i].src;

			$( _pluck( settings.aoData, 'anCells', colIdx ) )
				.addClass( sortClass + (i<2 ? i+1 : 3) );
		}
	}

	settings.aLastSort = sort;
}


// Get the data to sort a column, be it from cache, fresh (populating the
// cache), or from a sort formatter
function _fnSortData( settings, idx )
{
	// Custom sorting function - provided by the sort data type
	var column = settings.aoColumns[ idx ];
	var customSort = DataTable.ext.order[ column.sSortDataType ];
	var customData;

	if ( customSort ) {
		customData = customSort.call( settings.oInstance, settings, idx,
			_fnColumnIndexToVisible( settings, idx )
		);
	}

	// Use / populate cache
	var row, cellData;
	var formatter = DataTable.ext.type.order[ column.sType+"-pre" ];

	for ( var i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
		row = settings.aoData[i];

		if ( ! row._aSortData ) {
			row._aSortData = [];
		}

		if ( ! row._aSortData[idx] || customSort ) {
			cellData = customSort ?
				customData[i] : // If there was a custom sort function, use data from there
				_fnGetCellData( settings, i, idx, 'sort' );

			row._aSortData[ idx ] = formatter ?
				formatter( cellData ) :
				cellData;
		}
	}
}



/**
 * Save the state of a table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */
function _fnSaveState ( settings )
{
	if (settings._bLoadingState) {
		return;
	}

	/* Store the interesting variables */
	var state = {
		time:    +new Date(),
		start:   settings._iDisplayStart,
		length:  settings._iDisplayLength,
		order:   $.extend( true, [], settings.aaSorting ),
		search:  _fnSearchToCamel( settings.oPreviousSearch ),
		columns: $.map( settings.aoColumns, function ( col, i ) {
			return {
				visible: col.bVisible,
				search: _fnSearchToCamel( settings.aoPreSearchCols[i] )
			};
		} )
	};

	settings.oSavedState = state;
	_fnCallbackFire( settings, "aoStateSaveParams", 'stateSaveParams', [settings, state] );
	
	if ( settings.oFeatures.bStateSave && !settings.bDestroying )
	{
		settings.fnStateSaveCallback.call( settings.oInstance, settings, state );
	}	
}


/**
 * Attempt to load a saved table state
 *  @param {object} oSettings dataTables settings object
 *  @param {object} oInit DataTables init object so we can override settings
 *  @param {function} callback Callback to execute when the state has been loaded
 *  @memberof DataTable#oApi
 */
function _fnLoadState ( settings, oInit, callback )
{
	if ( ! settings.oFeatures.bStateSave ) {
		callback();
		return;
	}

	var loaded = function(state) {
		_fnImplementState(settings, state, callback);
	}

	var state = settings.fnStateLoadCallback.call( settings.oInstance, settings, loaded );

	if ( state !== undefined ) {
		_fnImplementState( settings, state, callback );
	}
	// otherwise, wait for the loaded callback to be executed

	return true;
}

function _fnImplementState ( settings, s, callback) {
	var i, ien;
	var columns = settings.aoColumns;
	settings._bLoadingState = true;

	// When StateRestore was introduced the state could now be implemented at any time
	// Not just initialisation. To do this an api instance is required in some places
	var api = settings._bInitComplete ? new DataTable.Api(settings) : null;

	if ( ! s || ! s.time ) {
		settings._bLoadingState = false;
		callback();
		return;
	}

	// Allow custom and plug-in manipulation functions to alter the saved data set and
	// cancelling of loading by returning false
	var abStateLoad = _fnCallbackFire( settings, 'aoStateLoadParams', 'stateLoadParams', [settings, s] );
	if ( $.inArray( false, abStateLoad ) !== -1 ) {
		settings._bLoadingState = false;
		callback();
		return;
	}

	// Reject old data
	var duration = settings.iStateDuration;
	if ( duration > 0 && s.time < +new Date() - (duration*1000) ) {
		settings._bLoadingState = false;
		callback();
		return;
	}

	// Number of columns have changed - all bets are off, no restore of settings
	if ( s.columns && columns.length !== s.columns.length ) {
		settings._bLoadingState = false;
		callback();
		return;
	}

	// Store the saved state so it might be accessed at any time
	settings.oLoadedState = $.extend( true, {}, s );

	// Page Length
	if ( s.length !== undefined ) {
		// If already initialised just set the value directly so that the select element is also updated
		if (api) {
			api.page.len(s.length)
		}
		else {
			settings._iDisplayLength   = s.length;
		}
	}

	// Restore key features - todo - for 1.11 this needs to be done by
	// subscribed events
	if ( s.start !== undefined ) {
		if(api === null) {
			settings._iDisplayStart    = s.start;
			settings.iInitDisplayStart = s.start;
		}
		else {
			_fnPageChange(settings, s.start/settings._iDisplayLength);
		}
	}

	// Order
	if ( s.order !== undefined ) {
		settings.aaSorting = [];
		$.each( s.order, function ( i, col ) {
			settings.aaSorting.push( col[0] >= columns.length ?
				[ 0, col[1] ] :
				col
			);
		} );
	}

	// Search
	if ( s.search !== undefined ) {
		$.extend( settings.oPreviousSearch, _fnSearchToHung( s.search ) );
	}

	// Columns
	if ( s.columns ) {
		for ( i=0, ien=s.columns.length ; i<ien ; i++ ) {
			var col = s.columns[i];

			// Visibility
			if ( col.visible !== undefined ) {
				// If the api is defined, the table has been initialised so we need to use it rather than internal settings
				if (api) {
					// Don't redraw the columns on every iteration of this loop, we will do this at the end instead
					api.column(i).visible(col.visible, false);
				}
				else {
					columns[i].bVisible = col.visible;
				}
			}

			// Search
			if ( col.search !== undefined ) {
				$.extend( settings.aoPreSearchCols[i], _fnSearchToHung( col.search ) );
			}
		}
		
		// If the api is defined then we need to adjust the columns once the visibility has been changed
		if (api) {
			api.columns.adjust();
		}
	}

	settings._bLoadingState = false;
	_fnCallbackFire( settings, 'aoStateLoaded', 'stateLoaded', [settings, s] );
	callback();
};


/**
 * Return the settings object for a particular table
 *  @param {node} table table we are using as a dataTable
 *  @returns {object} Settings object - or null if not found
 *  @memberof DataTable#oApi
 */
function _fnSettingsFromNode ( table )
{
	var settings = DataTable.settings;
	var idx = $.inArray( table, _pluck( settings, 'nTable' ) );

	return idx !== -1 ?
		settings[ idx ] :
		null;
}


/**
 * Log an error message
 *  @param {object} settings dataTables settings object
 *  @param {int} level log error messages, or display them to the user
 *  @param {string} msg error message
 *  @param {int} tn Technical note id to get more information about the error.
 *  @memberof DataTable#oApi
 */
function _fnLog( settings, level, msg, tn )
{
	msg = 'DataTables warning: '+
		(settings ? 'table id='+settings.sTableId+' - ' : '')+msg;

	if ( tn ) {
		msg += '. For more information about this error, please see '+
		'http://datatables.net/tn/'+tn;
	}

	if ( ! level  ) {
		// Backwards compatibility pre 1.10
		var ext = DataTable.ext;
		var type = ext.sErrMode || ext.errMode;

		if ( settings ) {
			_fnCallbackFire( settings, null, 'error', [ settings, tn, msg ] );
		}

		if ( type == 'alert' ) {
			alert( msg );
		}
		else if ( type == 'throw' ) {
			throw new Error(msg);
		}
		else if ( typeof type == 'function' ) {
			type( settings, tn, msg );
		}
	}
	else if ( window.console && console.log ) {
		console.log( msg );
	}
}


/**
 * See if a property is defined on one object, if so assign it to the other object
 *  @param {object} ret target object
 *  @param {object} src source object
 *  @param {string} name property
 *  @param {string} [mappedName] name to map too - optional, name used if not given
 *  @memberof DataTable#oApi
 */
function _fnMap( ret, src, name, mappedName )
{
	if ( Array.isArray( name ) ) {
		$.each( name, function (i, val) {
			if ( Array.isArray( val ) ) {
				_fnMap( ret, src, val[0], val[1] );
			}
			else {
				_fnMap( ret, src, val );
			}
		} );

		return;
	}

	if ( mappedName === undefined ) {
		mappedName = name;
	}

	if ( src[name] !== undefined ) {
		ret[mappedName] = src[name];
	}
}


/**
 * Extend objects - very similar to jQuery.extend, but deep copy objects, and
 * shallow copy arrays. The reason we need to do this, is that we don't want to
 * deep copy array init values (such as aaSorting) since the dev wouldn't be
 * able to override them, but we do want to deep copy arrays.
 *  @param {object} out Object to extend
 *  @param {object} extender Object from which the properties will be applied to
 *      out
 *  @param {boolean} breakRefs If true, then arrays will be sliced to take an
 *      independent copy with the exception of the `data` or `aaData` parameters
 *      if they are present. This is so you can pass in a collection to
 *      DataTables and have that used as your data source without breaking the
 *      references
 *  @returns {object} out Reference, just for convenience - out === the return.
 *  @memberof DataTable#oApi
 *  @todo This doesn't take account of arrays inside the deep copied objects.
 */
function _fnExtend( out, extender, breakRefs )
{
	var val;

	for ( var prop in extender ) {
		if ( extender.hasOwnProperty(prop) ) {
			val = extender[prop];

			if ( $.isPlainObject( val ) ) {
				if ( ! $.isPlainObject( out[prop] ) ) {
					out[prop] = {};
				}
				$.extend( true, out[prop], val );
			}
			else if ( breakRefs && prop !== 'data' && prop !== 'aaData' && Array.isArray(val) ) {
				out[prop] = val.slice();
			}
			else {
				out[prop] = val;
			}
		}
	}

	return out;
}


/**
 * Bind an event handers to allow a click or return key to activate the callback.
 * This is good for accessibility since a return on the keyboard will have the
 * same effect as a click, if the element has focus.
 *  @param {element} n Element to bind the action to
 *  @param {object} oData Data object to pass to the triggered function
 *  @param {function} fn Callback function for when the event is triggered
 *  @memberof DataTable#oApi
 */
function _fnBindAction( n, oData, fn )
{
	$(n)
		.on( 'click.DT', oData, function (e) {
				$(n).trigger('blur'); // Remove focus outline for mouse users
				fn(e);
			} )
		.on( 'keypress.DT', oData, function (e){
				if ( e.which === 13 ) {
					e.preventDefault();
					fn(e);
				}
			} )
		.on( 'selectstart.DT', function () {
				/* Take the brutal approach to cancelling text selection */
				return false;
			} );
}


/**
 * Register a callback function. Easily allows a callback function to be added to
 * an array store of callback functions that can then all be called together.
 *  @param {object} oSettings dataTables settings object
 *  @param {string} sStore Name of the array storage for the callbacks in oSettings
 *  @param {function} fn Function to be called back
 *  @param {string} sName Identifying name for the callback (i.e. a label)
 *  @memberof DataTable#oApi
 */
function _fnCallbackReg( oSettings, sStore, fn, sName )
{
	if ( fn )
	{
		oSettings[sStore].push( {
			"fn": fn,
			"sName": sName
		} );
	}
}


/**
 * Fire callback functions and trigger events. Note that the loop over the
 * callback array store is done backwards! Further note that you do not want to
 * fire off triggers in time sensitive applications (for example cell creation)
 * as its slow.
 *  @param {object} settings dataTables settings object
 *  @param {string} callbackArr Name of the array storage for the callbacks in
 *      oSettings
 *  @param {string} eventName Name of the jQuery custom event to trigger. If
 *      null no trigger is fired
 *  @param {array} args Array of arguments to pass to the callback function /
 *      trigger
 *  @memberof DataTable#oApi
 */
function _fnCallbackFire( settings, callbackArr, eventName, args )
{
	var ret = [];

	if ( callbackArr ) {
		ret = $.map( settings[callbackArr].slice().reverse(), function (val, i) {
			return val.fn.apply( settings.oInstance, args );
		} );
	}

	if ( eventName !== null ) {
		var e = $.Event( eventName+'.dt' );
		var table = $(settings.nTable);

		table.trigger( e, args );

		// If not yet attached to the document, trigger the event
		// on the body directly to sort of simulate the bubble
		if (table.parents('body').length === 0) {
			$('body').trigger( e, args );
		}

		ret.push( e.result );
	}

	return ret;
}


function _fnLengthOverflow ( settings )
{
	var
		start = settings._iDisplayStart,
		end = settings.fnDisplayEnd(),
		len = settings._iDisplayLength;

	/* If we have space to show extra rows (backing up from the end point - then do so */
	if ( start >= end )
	{
		start = end - len;
	}

	// Keep the start record on the current page
	start -= (start % len);

	if ( len === -1 || start < 0 )
	{
		start = 0;
	}

	settings._iDisplayStart = start;
}


function _fnRenderer( settings, type )
{
	var renderer = settings.renderer;
	var host = DataTable.ext.renderer[type];

	if ( $.isPlainObject( renderer ) && renderer[type] ) {
		// Specific renderer for this type. If available use it, otherwise use
		// the default.
		return host[renderer[type]] || host._;
	}
	else if ( typeof renderer === 'string' ) {
		// Common renderer - if there is one available for this type use it,
		// otherwise use the default
		return host[renderer] || host._;
	}

	// Use the default
	return host._;
}


/**
 * Detect the data source being used for the table. Used to simplify the code
 * a little (ajax) and to make it compress a little smaller.
 *
 *  @param {object} settings dataTables settings object
 *  @returns {string} Data source
 *  @memberof DataTable#oApi
 */
function _fnDataSource ( settings )
{
	if ( settings.oFeatures.bServerSide ) {
		return 'ssp';
	}
	else if ( settings.ajax || settings.sAjaxSource ) {
		return 'ajax';
	}
	return 'dom';
}




/**
 * Computed structure of the DataTables API, defined by the options passed to
 * `DataTable.Api.register()` when building the API.
 *
 * The structure is built in order to speed creation and extension of the Api
 * objects since the extensions are effectively pre-parsed.
 *
 * The array is an array of objects with the following structure, where this
 * base array represents the Api prototype base:
 *
 *     [
 *       {
 *         name:      'data'                -- string   - Property name
 *         val:       function () {},       -- function - Api method (or undefined if just an object
 *         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
 *         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
 *       },
 *       {
 *         name:     'row'
 *         val:       {},
 *         methodExt: [ ... ],
 *         propExt:   [
 *           {
 *             name:      'data'
 *             val:       function () {},
 *             methodExt: [ ... ],
 *             propExt:   [ ... ]
 *           },
 *           ...
 *         ]
 *       }
 *     ]
 *
 * @type {Array}
 * @ignore
 */
var __apiStruct = [];


/**
 * `Array.prototype` reference.
 *
 * @type object
 * @ignore
 */
var __arrayProto = Array.prototype;


/**
 * Abstraction for `context` parameter of the `Api` constructor to allow it to
 * take several different forms for ease of use.
 *
 * Each of the input parameter types will be converted to a DataTables settings
 * object where possible.
 *
 * @param  {string|node|jQuery|object} mixed DataTable identifier. Can be one
 *   of:
 *
 *   * `string` - jQuery selector. Any DataTables' matching the given selector
 *     with be found and used.
 *   * `node` - `TABLE` node which has already been formed into a DataTable.
 *   * `jQuery` - A jQuery object of `TABLE` nodes.
 *   * `object` - DataTables settings object
 *   * `DataTables.Api` - API instance
 * @return {array|null} Matching DataTables settings objects. `null` or
 *   `undefined` is returned if no matching DataTable is found.
 * @ignore
 */
var _toSettings = function ( mixed )
{
	var idx, jq;
	var settings = DataTable.settings;
	var tables = $.map( settings, function (el, i) {
		return el.nTable;
	} );

	if ( ! mixed ) {
		return [];
	}
	else if ( mixed.nTable && mixed.oApi ) {
		// DataTables settings object
		return [ mixed ];
	}
	else if ( mixed.nodeName && mixed.nodeName.toLowerCase() === 'table' ) {
		// Table node
		idx = $.inArray( mixed, tables );
		return idx !== -1 ? [ settings[idx] ] : null;
	}
	else if ( mixed && typeof mixed.settings === 'function' ) {
		return mixed.settings().toArray();
	}
	else if ( typeof mixed === 'string' ) {
		// jQuery selector
		jq = $(mixed);
	}
	else if ( mixed instanceof $ ) {
		// jQuery object (also DataTables instance)
		jq = mixed;
	}

	if ( jq ) {
		return jq.map( function(i) {
			idx = $.inArray( this, tables );
			return idx !== -1 ? settings[idx] : null;
		} ).toArray();
	}
};


/**
 * DataTables API class - used to control and interface with  one or more
 * DataTables enhanced tables.
 *
 * The API class is heavily based on jQuery, presenting a chainable interface
 * that you can use to interact with tables. Each instance of the API class has
 * a "context" - i.e. the tables that it will operate on. This could be a single
 * table, all tables on a page or a sub-set thereof.
 *
 * Additionally the API is designed to allow you to easily work with the data in
 * the tables, retrieving and manipulating it as required. This is done by
 * presenting the API class as an array like interface. The contents of the
 * array depend upon the actions requested by each method (for example
 * `rows().nodes()` will return an array of nodes, while `rows().data()` will
 * return an array of objects or arrays depending upon your table's
 * configuration). The API object has a number of array like methods (`push`,
 * `pop`, `reverse` etc) as well as additional helper methods (`each`, `pluck`,
 * `unique` etc) to assist your working with the data held in a table.
 *
 * Most methods (those which return an Api instance) are chainable, which means
 * the return from a method call also has all of the methods available that the
 * top level object had. For example, these two calls are equivalent:
 *
 *     // Not chained
 *     api.row.add( {...} );
 *     api.draw();
 *
 *     // Chained
 *     api.row.add( {...} ).draw();
 *
 * @class DataTable.Api
 * @param {array|object|string|jQuery} context DataTable identifier. This is
 *   used to define which DataTables enhanced tables this API will operate on.
 *   Can be one of:
 *
 *   * `string` - jQuery selector. Any DataTables' matching the given selector
 *     with be found and used.
 *   * `node` - `TABLE` node which has already been formed into a DataTable.
 *   * `jQuery` - A jQuery object of `TABLE` nodes.
 *   * `object` - DataTables settings object
 * @param {array} [data] Data to initialise the Api instance with.
 *
 * @example
 *   // Direct initialisation during DataTables construction
 *   var api = $('#example').DataTable();
 *
 * @example
 *   // Initialisation using a DataTables jQuery object
 *   var api = $('#example').dataTable().api();
 *
 * @example
 *   // Initialisation as a constructor
 *   var api = new $.fn.DataTable.Api( 'table.dataTable' );
 */
_Api = function ( context, data )
{
	if ( ! (this instanceof _Api) ) {
		return new _Api( context, data );
	}

	var settings = [];
	var ctxSettings = function ( o ) {
		var a = _toSettings( o );
		if ( a ) {
			settings.push.apply( settings, a );
		}
	};

	if ( Array.isArray( context ) ) {
		for ( var i=0, ien=context.length ; i<ien ; i++ ) {
			ctxSettings( context[i] );
		}
	}
	else {
		ctxSettings( context );
	}

	// Remove duplicates
	this.context = _unique( settings );

	// Initial data
	if ( data ) {
		$.merge( this, data );
	}

	// selector
	this.selector = {
		rows: null,
		cols: null,
		opts: null
	};

	_Api.extend( this, this, __apiStruct );
};

DataTable.Api = _Api;

// Don't destroy the existing prototype, just extend it. Required for jQuery 2's
// isPlainObject.
$.extend( _Api.prototype, {
	any: function ()
	{
		return this.count() !== 0;
	},


	concat:  __arrayProto.concat,


	context: [], // array of table settings objects


	count: function ()
	{
		return this.flatten().length;
	},


	each: function ( fn )
	{
		for ( var i=0, ien=this.length ; i<ien; i++ ) {
			fn.call( this, this[i], i, this );
		}

		return this;
	},


	eq: function ( idx )
	{
		var ctx = this.context;

		return ctx.length > idx ?
			new _Api( ctx[idx], this[idx] ) :
			null;
	},


	filter: function ( fn )
	{
		var a = [];

		if ( __arrayProto.filter ) {
			a = __arrayProto.filter.call( this, fn, this );
		}
		else {
			// Compatibility for browsers without EMCA-252-5 (JS 1.6)
			for ( var i=0, ien=this.length ; i<ien ; i++ ) {
				if ( fn.call( this, this[i], i, this ) ) {
					a.push( this[i] );
				}
			}
		}

		return new _Api( this.context, a );
	},


	flatten: function ()
	{
		var a = [];
		return new _Api( this.context, a.concat.apply( a, this.toArray() ) );
	},


	join:    __arrayProto.join,


	indexOf: __arrayProto.indexOf || function (obj, start)
	{
		for ( var i=(start || 0), ien=this.length ; i<ien ; i++ ) {
			if ( this[i] === obj ) {
				return i;
			}
		}
		return -1;
	},

	iterator: function ( flatten, type, fn, alwaysNew ) {
		var
			a = [], ret,
			i, ien, j, jen,
			context = this.context,
			rows, items, item,
			selector = this.selector;

		// Argument shifting
		if ( typeof flatten === 'string' ) {
			alwaysNew = fn;
			fn = type;
			type = flatten;
			flatten = false;
		}

		for ( i=0, ien=context.length ; i<ien ; i++ ) {
			var apiInst = new _Api( context[i] );

			if ( type === 'table' ) {
				ret = fn.call( apiInst, context[i], i );

				if ( ret !== undefined ) {
					a.push( ret );
				}
			}
			else if ( type === 'columns' || type === 'rows' ) {
				// this has same length as context - one entry for each table
				ret = fn.call( apiInst, context[i], this[i], i );

				if ( ret !== undefined ) {
					a.push( ret );
				}
			}
			else if ( type === 'column' || type === 'column-rows' || type === 'row' || type === 'cell' ) {
				// columns and rows share the same structure.
				// 'this' is an array of column indexes for each context
				items = this[i];

				if ( type === 'column-rows' ) {
					rows = _selector_row_indexes( context[i], selector.opts );
				}

				for ( j=0, jen=items.length ; j<jen ; j++ ) {
					item = items[j];

					if ( type === 'cell' ) {
						ret = fn.call( apiInst, context[i], item.row, item.column, i, j );
					}
					else {
						ret = fn.call( apiInst, context[i], item, i, j, rows );
					}

					if ( ret !== undefined ) {
						a.push( ret );
					}
				}
			}
		}

		if ( a.length || alwaysNew ) {
			var api = new _Api( context, flatten ? a.concat.apply( [], a ) : a );
			var apiSelector = api.selector;
			apiSelector.rows = selector.rows;
			apiSelector.cols = selector.cols;
			apiSelector.opts = selector.opts;
			return api;
		}
		return this;
	},


	lastIndexOf: __arrayProto.lastIndexOf || function (obj, start)
	{
		// Bit cheeky...
		return this.indexOf.apply( this.toArray.reverse(), arguments );
	},


	length:  0,


	map: function ( fn )
	{
		var a = [];

		if ( __arrayProto.map ) {
			a = __arrayProto.map.call( this, fn, this );
		}
		else {
			// Compatibility for browsers without EMCA-252-5 (JS 1.6)
			for ( var i=0, ien=this.length ; i<ien ; i++ ) {
				a.push( fn.call( this, this[i], i ) );
			}
		}

		return new _Api( this.context, a );
	},


	pluck: function ( prop )
	{
		var fn = DataTable.util.get(prop);

		return this.map( function ( el ) {
			return fn(el);
		} );
	},

	pop:     __arrayProto.pop,


	push:    __arrayProto.push,


	// Does not return an API instance
	reduce: __arrayProto.reduce || function ( fn, init )
	{
		return _fnReduce( this, fn, init, 0, this.length, 1 );
	},


	reduceRight: __arrayProto.reduceRight || function ( fn, init )
	{
		return _fnReduce( this, fn, init, this.length-1, -1, -1 );
	},


	reverse: __arrayProto.reverse,


	// Object with rows, columns and opts
	selector: null,


	shift:   __arrayProto.shift,


	slice: function () {
		return new _Api( this.context, this );
	},


	sort:    __arrayProto.sort, // ? name - order?


	splice:  __arrayProto.splice,


	toArray: function ()
	{
		return __arrayProto.slice.call( this );
	},


	to$: function ()
	{
		return $( this );
	},


	toJQuery: function ()
	{
		return $( this );
	},


	unique: function ()
	{
		return new _Api( this.context, _unique(this) );
	},


	unshift: __arrayProto.unshift
} );


_Api.extend = function ( scope, obj, ext )
{
	// Only extend API instances and static properties of the API
	if ( ! ext.length || ! obj || ( ! (obj instanceof _Api) && ! obj.__dt_wrapper ) ) {
		return;
	}

	var
		i, ien,
		struct,
		methodScoping = function ( scope, fn, struc ) {
			return function () {
				var ret = fn.apply( scope, arguments );

				// Method extension
				_Api.extend( ret, ret, struc.methodExt );
				return ret;
			};
		};

	for ( i=0, ien=ext.length ; i<ien ; i++ ) {
		struct = ext[i];

		// Value
		obj[ struct.name ] = struct.type === 'function' ?
			methodScoping( scope, struct.val, struct ) :
			struct.type === 'object' ?
				{} :
				struct.val;

		obj[ struct.name ].__dt_wrapper = true;

		// Property extension
		_Api.extend( scope, obj[ struct.name ], struct.propExt );
	}
};


// @todo - Is there need for an augment function?
// _Api.augment = function ( inst, name )
// {
// 	// Find src object in the structure from the name
// 	var parts = name.split('.');

// 	_Api.extend( inst, obj );
// };


//     [
//       {
//         name:      'data'                -- string   - Property name
//         val:       function () {},       -- function - Api method (or undefined if just an object
//         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
//         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
//       },
//       {
//         name:     'row'
//         val:       {},
//         methodExt: [ ... ],
//         propExt:   [
//           {
//             name:      'data'
//             val:       function () {},
//             methodExt: [ ... ],
//             propExt:   [ ... ]
//           },
//           ...
//         ]
//       }
//     ]

_Api.register = _api_register = function ( name, val )
{
	if ( Array.isArray( name ) ) {
		for ( var j=0, jen=name.length ; j<jen ; j++ ) {
			_Api.register( name[j], val );
		}
		return;
	}

	var
		i, ien,
		heir = name.split('.'),
		struct = __apiStruct,
		key, method;

	var find = function ( src, name ) {
		for ( var i=0, ien=src.length ; i<ien ; i++ ) {
			if ( src[i].name === name ) {
				return src[i];
			}
		}
		return null;
	};

	for ( i=0, ien=heir.length ; i<ien ; i++ ) {
		method = heir[i].indexOf('()') !== -1;
		key = method ?
			heir[i].replace('()', '') :
			heir[i];

		var src = find( struct, key );
		if ( ! src ) {
			src = {
				name:      key,
				val:       {},
				methodExt: [],
				propExt:   [],
				type:      'object'
			};
			struct.push( src );
		}

		if ( i === ien-1 ) {
			src.val = val;
			src.type = typeof val === 'function' ?
				'function' :
				$.isPlainObject( val ) ?
					'object' :
					'other';
		}
		else {
			struct = method ?
				src.methodExt :
				src.propExt;
		}
	}
};

_Api.registerPlural = _api_registerPlural = function ( pluralName, singularName, val ) {
	_Api.register( pluralName, val );

	_Api.register( singularName, function () {
		var ret = val.apply( this, arguments );

		if ( ret === this ) {
			// Returned item is the API instance that was passed in, return it
			return this;
		}
		else if ( ret instanceof _Api ) {
			// New API instance returned, want the value from the first item
			// in the returned array for the singular result.
			return ret.length ?
				Array.isArray( ret[0] ) ?
					new _Api( ret.context, ret[0] ) : // Array results are 'enhanced'
					ret[0] :
				undefined;
		}

		// Non-API return - just fire it back
		return ret;
	} );
};


/**
 * Selector for HTML tables. Apply the given selector to the give array of
 * DataTables settings objects.
 *
 * @param {string|integer} [selector] jQuery selector string or integer
 * @param  {array} Array of DataTables settings objects to be filtered
 * @return {array}
 * @ignore
 */
var __table_selector = function ( selector, a )
{
	if ( Array.isArray(selector) ) {
		return $.map( selector, function (item) {
			return __table_selector(item, a);
		} );
	}

	// Integer is used to pick out a table by index
	if ( typeof selector === 'number' ) {
		return [ a[ selector ] ];
	}

	// Perform a jQuery selector on the table nodes
	var nodes = $.map( a, function (el, i) {
		return el.nTable;
	} );

	return $(nodes)
		.filter( selector )
		.map( function (i) {
			// Need to translate back from the table node to the settings
			var idx = $.inArray( this, nodes );
			return a[ idx ];
		} )
		.toArray();
};



/**
 * Context selector for the API's context (i.e. the tables the API instance
 * refers to.
 *
 * @name    DataTable.Api#tables
 * @param {string|integer} [selector] Selector to pick which tables the iterator
 *   should operate on. If not given, all tables in the current context are
 *   used. This can be given as a jQuery selector (for example `':gt(0)'`) to
 *   select multiple tables or as an integer to select a single table.
 * @returns {DataTable.Api} Returns a new API instance if a selector is given.
 */
_api_register( 'tables()', function ( selector ) {
	// A new instance is created if there was a selector specified
	return selector !== undefined && selector !== null ?
		new _Api( __table_selector( selector, this.context ) ) :
		this;
} );


_api_register( 'table()', function ( selector ) {
	var tables = this.tables( selector );
	var ctx = tables.context;

	// Truncate to the first matched table
	return ctx.length ?
		new _Api( ctx[0] ) :
		tables;
} );


_api_registerPlural( 'tables().nodes()', 'table().node()' , function () {
	return this.iterator( 'table', function ( ctx ) {
		return ctx.nTable;
	}, 1 );
} );


_api_registerPlural( 'tables().body()', 'table().body()' , function () {
	return this.iterator( 'table', function ( ctx ) {
		return ctx.nTBody;
	}, 1 );
} );


_api_registerPlural( 'tables().header()', 'table().header()' , function () {
	return this.iterator( 'table', function ( ctx ) {
		return ctx.nTHead;
	}, 1 );
} );


_api_registerPlural( 'tables().footer()', 'table().footer()' , function () {
	return this.iterator( 'table', function ( ctx ) {
		return ctx.nTFoot;
	}, 1 );
} );


_api_registerPlural( 'tables().containers()', 'table().container()' , function () {
	return this.iterator( 'table', function ( ctx ) {
		return ctx.nTableWrapper;
	}, 1 );
} );



/**
 * Redraw the tables in the current context.
 */
_api_register( 'draw()', function ( paging ) {
	return this.iterator( 'table', function ( settings ) {
		if ( paging === 'page' ) {
			_fnDraw( settings );
		}
		else {
			if ( typeof paging === 'string' ) {
				paging = paging === 'full-hold' ?
					false :
					true;
			}

			_fnReDraw( settings, paging===false );
		}
	} );
} );



/**
 * Get the current page index.
 *
 * @return {integer} Current page index (zero based)
 *//**
 * Set the current page.
 *
 * Note that if you attempt to show a page which does not exist, DataTables will
 * not throw an error, but rather reset the paging.
 *
 * @param {integer|string} action The paging action to take. This can be one of:
 *  * `integer` - The page index to jump to
 *  * `string` - An action to take:
 *    * `first` - Jump to first page.
 *    * `next` - Jump to the next page
 *    * `previous` - Jump to previous page
 *    * `last` - Jump to the last page.
 * @returns {DataTables.Api} this
 */
_api_register( 'page()', function ( action ) {
	if ( action === undefined ) {
		return this.page.info().page; // not an expensive call
	}

	// else, have an action to take on all tables
	return this.iterator( 'table', function ( settings ) {
		_fnPageChange( settings, action );
	} );
} );


/**
 * Paging information for the first table in the current context.
 *
 * If you require paging information for another table, use the `table()` method
 * with a suitable selector.
 *
 * @return {object} Object with the following properties set:
 *  * `page` - Current page index (zero based - i.e. the first page is `0`)
 *  * `pages` - Total number of pages
 *  * `start` - Display index for the first record shown on the current page
 *  * `end` - Display index for the last record shown on the current page
 *  * `length` - Display length (number of records). Note that generally `start
 *    + length = end`, but this is not always true, for example if there are
 *    only 2 records to show on the final page, with a length of 10.
 *  * `recordsTotal` - Full data set length
 *  * `recordsDisplay` - Data set length once the current filtering criterion
 *    are applied.
 */
_api_register( 'page.info()', function ( action ) {
	if ( this.context.length === 0 ) {
		return undefined;
	}

	var
		settings   = this.context[0],
		start      = settings._iDisplayStart,
		len        = settings.oFeatures.bPaginate ? settings._iDisplayLength : -1,
		visRecords = settings.fnRecordsDisplay(),
		all        = len === -1;

	return {
		"page":           all ? 0 : Math.floor( start / len ),
		"pages":          all ? 1 : Math.ceil( visRecords / len ),
		"start":          start,
		"end":            settings.fnDisplayEnd(),
		"length":         len,
		"recordsTotal":   settings.fnRecordsTotal(),
		"recordsDisplay": visRecords,
		"serverSide":     _fnDataSource( settings ) === 'ssp'
	};
} );


/**
 * Get the current page length.
 *
 * @return {integer} Current page length. Note `-1` indicates that all records
 *   are to be shown.
 *//**
 * Set the current page length.
 *
 * @param {integer} Page length to set. Use `-1` to show all records.
 * @returns {DataTables.Api} this
 */
_api_register( 'page.len()', function ( len ) {
	// Note that we can't call this function 'length()' because `length`
	// is a Javascript property of functions which defines how many arguments
	// the function expects.
	if ( len === undefined ) {
		return this.context.length !== 0 ?
			this.context[0]._iDisplayLength :
			undefined;
	}

	// else, set the page length
	return this.iterator( 'table', function ( settings ) {
		_fnLengthChange( settings, len );
	} );
} );



var __reload = function ( settings, holdPosition, callback ) {
	// Use the draw event to trigger a callback
	if ( callback ) {
		var api = new _Api( settings );

		api.one( 'draw', function () {
			callback( api.ajax.json() );
		} );
	}

	if ( _fnDataSource( settings ) == 'ssp' ) {
		_fnReDraw( settings, holdPosition );
	}
	else {
		_fnProcessingDisplay( settings, true );

		// Cancel an existing request
		var xhr = settings.jqXHR;
		if ( xhr && xhr.readyState !== 4 ) {
			xhr.abort();
		}

		// Trigger xhr
		_fnBuildAjax( settings, [], function( json ) {
			_fnClearTable( settings );

			var data = _fnAjaxDataSrc( settings, json );
			for ( var i=0, ien=data.length ; i<ien ; i++ ) {
				_fnAddData( settings, data[i] );
			}

			_fnReDraw( settings, holdPosition );
			_fnProcessingDisplay( settings, false );
		} );
	}
};


/**
 * Get the JSON response from the last Ajax request that DataTables made to the
 * server. Note that this returns the JSON from the first table in the current
 * context.
 *
 * @return {object} JSON received from the server.
 */
_api_register( 'ajax.json()', function () {
	var ctx = this.context;

	if ( ctx.length > 0 ) {
		return ctx[0].json;
	}

	// else return undefined;
} );


/**
 * Get the data submitted in the last Ajax request
 */
_api_register( 'ajax.params()', function () {
	var ctx = this.context;

	if ( ctx.length > 0 ) {
		return ctx[0].oAjaxData;
	}

	// else return undefined;
} );


/**
 * Reload tables from the Ajax data source. Note that this function will
 * automatically re-draw the table when the remote data has been loaded.
 *
 * @param {boolean} [reset=true] Reset (default) or hold the current paging
 *   position. A full re-sort and re-filter is performed when this method is
 *   called, which is why the pagination reset is the default action.
 * @returns {DataTables.Api} this
 */
_api_register( 'ajax.reload()', function ( callback, resetPaging ) {
	return this.iterator( 'table', function (settings) {
		__reload( settings, resetPaging===false, callback );
	} );
} );


/**
 * Get the current Ajax URL. Note that this returns the URL from the first
 * table in the current context.
 *
 * @return {string} Current Ajax source URL
 *//**
 * Set the Ajax URL. Note that this will set the URL for all tables in the
 * current context.
 *
 * @param {string} url URL to set.
 * @returns {DataTables.Api} this
 */
_api_register( 'ajax.url()', function ( url ) {
	var ctx = this.context;

	if ( url === undefined ) {
		// get
		if ( ctx.length === 0 ) {
			return undefined;
		}
		ctx = ctx[0];

		return ctx.ajax ?
			$.isPlainObject( ctx.ajax ) ?
				ctx.ajax.url :
				ctx.ajax :
			ctx.sAjaxSource;
	}

	// set
	return this.iterator( 'table', function ( settings ) {
		if ( $.isPlainObject( settings.ajax ) ) {
			settings.ajax.url = url;
		}
		else {
			settings.ajax = url;
		}
		// No need to consider sAjaxSource here since DataTables gives priority
		// to `ajax` over `sAjaxSource`. So setting `ajax` here, renders any
		// value of `sAjaxSource` redundant.
	} );
} );


/**
 * Load data from the newly set Ajax URL. Note that this method is only
 * available when `ajax.url()` is used to set a URL. Additionally, this method
 * has the same effect as calling `ajax.reload()` but is provided for
 * convenience when setting a new URL. Like `ajax.reload()` it will
 * automatically redraw the table once the remote data has been loaded.
 *
 * @returns {DataTables.Api} this
 */
_api_register( 'ajax.url().load()', function ( callback, resetPaging ) {
	// Same as a reload, but makes sense to present it for easy access after a
	// url change
	return this.iterator( 'table', function ( ctx ) {
		__reload( ctx, resetPaging===false, callback );
	} );
} );




var _selector_run = function ( type, selector, selectFn, settings, opts )
{
	var
		out = [], res,
		a, i, ien, j, jen,
		selectorType = typeof selector;

	// Can't just check for isArray here, as an API or jQuery instance might be
	// given with their array like look
	if ( ! selector || selectorType === 'string' || selectorType === 'function' || selector.length === undefined ) {
		selector = [ selector ];
	}

	for ( i=0, ien=selector.length ; i<ien ; i++ ) {
		// Only split on simple strings - complex expressions will be jQuery selectors
		a = selector[i] && selector[i].split && ! selector[i].match(/[\[\(:]/) ?
			selector[i].split(',') :
			[ selector[i] ];

		for ( j=0, jen=a.length ; j<jen ; j++ ) {
			res = selectFn( typeof a[j] === 'string' ? (a[j]).trim() : a[j] );

			if ( res && res.length ) {
				out = out.concat( res );
			}
		}
	}

	// selector extensions
	var ext = _ext.selector[ type ];
	if ( ext.length ) {
		for ( i=0, ien=ext.length ; i<ien ; i++ ) {
			out = ext[i]( settings, opts, out );
		}
	}

	return _unique( out );
};


var _selector_opts = function ( opts )
{
	if ( ! opts ) {
		opts = {};
	}

	// Backwards compatibility for 1.9- which used the terminology filter rather
	// than search
	if ( opts.filter && opts.search === undefined ) {
		opts.search = opts.filter;
	}

	return $.extend( {
		search: 'none',
		order: 'current',
		page: 'all'
	}, opts );
};


var _selector_first = function ( inst )
{
	// Reduce the API instance to the first item found
	for ( var i=0, ien=inst.length ; i<ien ; i++ ) {
		if ( inst[i].length > 0 ) {
			// Assign the first element to the first item in the instance
			// and truncate the instance and context
			inst[0] = inst[i];
			inst[0].length = 1;
			inst.length = 1;
			inst.context = [ inst.context[i] ];

			return inst;
		}
	}

	// Not found - return an empty instance
	inst.length = 0;
	return inst;
};


var _selector_row_indexes = function ( settings, opts )
{
	var
		i, ien, tmp, a=[],
		displayFiltered = settings.aiDisplay,
		displayMaster = settings.aiDisplayMaster;

	var
		search = opts.search,  // none, applied, removed
		order  = opts.order,   // applied, current, index (original - compatibility with 1.9)
		page   = opts.page;    // all, current

	if ( _fnDataSource( settings ) == 'ssp' ) {
		// In server-side processing mode, most options are irrelevant since
		// rows not shown don't exist and the index order is the applied order
		// Removed is a special case - for consistency just return an empty
		// array
		return search === 'removed' ?
			[] :
			_range( 0, displayMaster.length );
	}
	else if ( page == 'current' ) {
		// Current page implies that order=current and filter=applied, since it is
		// fairly senseless otherwise, regardless of what order and search actually
		// are
		for ( i=settings._iDisplayStart, ien=settings.fnDisplayEnd() ; i<ien ; i++ ) {
			a.push( displayFiltered[i] );
		}
	}
	else if ( order == 'current' || order == 'applied' ) {
		if ( search == 'none') {
			a = displayMaster.slice();
		}
		else if ( search == 'applied' ) {
			a = displayFiltered.slice();
		}
		else if ( search == 'removed' ) {
			// O(n+m) solution by creating a hash map
			var displayFilteredMap = {};

			for ( var i=0, ien=displayFiltered.length ; i<ien ; i++ ) {
				displayFilteredMap[displayFiltered[i]] = null;
			}

			a = $.map( displayMaster, function (el) {
				return ! displayFilteredMap.hasOwnProperty(el) ?
					el :
					null;
			} );
		}
	}
	else if ( order == 'index' || order == 'original' ) {
		for ( i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
			if ( search == 'none' ) {
				a.push( i );
			}
			else { // applied | removed
				tmp = $.inArray( i, displayFiltered );

				if ((tmp === -1 && search == 'removed') ||
					(tmp >= 0   && search == 'applied') )
				{
					a.push( i );
				}
			}
		}
	}

	return a;
};


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Rows
 *
 * {}          - no selector - use all available rows
 * {integer}   - row aoData index
 * {node}      - TR node
 * {string}    - jQuery selector to apply to the TR elements
 * {array}     - jQuery array of nodes, or simply an array of TR nodes
 *
 */
var __row_selector = function ( settings, selector, opts )
{
	var rows;
	var run = function ( sel ) {
		var selInt = _intVal( sel );
		var i, ien;
		var aoData = settings.aoData;

		// Short cut - selector is a number and no options provided (default is
		// all records, so no need to check if the index is in there, since it
		// must be - dev error if the index doesn't exist).
		if ( selInt !== null && ! opts ) {
			return [ selInt ];
		}

		if ( ! rows ) {
			rows = _selector_row_indexes( settings, opts );
		}

		if ( selInt !== null && $.inArray( selInt, rows ) !== -1 ) {
			// Selector - integer
			return [ selInt ];
		}
		else if ( sel === null || sel === undefined || sel === '' ) {
			// Selector - none
			return rows;
		}

		// Selector - function
		if ( typeof sel === 'function' ) {
			return $.map( rows, function (idx) {
				var row = aoData[ idx ];
				return sel( idx, row._aData, row.nTr ) ? idx : null;
			} );
		}

		// Selector - node
		if ( sel.nodeName ) {
			var rowIdx = sel._DT_RowIndex;  // Property added by DT for fast lookup
			var cellIdx = sel._DT_CellIndex;

			if ( rowIdx !== undefined ) {
				// Make sure that the row is actually still present in the table
				return aoData[ rowIdx ] && aoData[ rowIdx ].nTr === sel ?
					[ rowIdx ] :
					[];
			}
			else if ( cellIdx ) {
				return aoData[ cellIdx.row ] && aoData[ cellIdx.row ].nTr === sel.parentNode ?
					[ cellIdx.row ] :
					[];
			}
			else {
				var host = $(sel).closest('*[data-dt-row]');
				return host.length ?
					[ host.data('dt-row') ] :
					[];
			}
		}

		// ID selector. Want to always be able to select rows by id, regardless
		// of if the tr element has been created or not, so can't rely upon
		// jQuery here - hence a custom implementation. This does not match
		// Sizzle's fast selector or HTML4 - in HTML5 the ID can be anything,
		// but to select it using a CSS selector engine (like Sizzle or
		// querySelect) it would need to need to be escaped for some characters.
		// DataTables simplifies this for row selectors since you can select
		// only a row. A # indicates an id any anything that follows is the id -
		// unescaped.
		if ( typeof sel === 'string' && sel.charAt(0) === '#' ) {
			// get row index from id
			var rowObj = settings.aIds[ sel.replace( /^#/, '' ) ];
			if ( rowObj !== undefined ) {
				return [ rowObj.idx ];
			}

			// need to fall through to jQuery in case there is DOM id that
			// matches
		}
		
		// Get nodes in the order from the `rows` array with null values removed
		var nodes = _removeEmpty(
			_pluck_order( settings.aoData, rows, 'nTr' )
		);

		// Selector - jQuery selector string, array of nodes or jQuery object/
		// As jQuery's .filter() allows jQuery objects to be passed in filter,
		// it also allows arrays, so this will cope with all three options
		return $(nodes)
			.filter( sel )
			.map( function () {
				return this._DT_RowIndex;
			} )
			.toArray();
	};

	return _selector_run( 'row', selector, run, settings, opts );
};


_api_register( 'rows()', function ( selector, opts ) {
	// argument shifting
	if ( selector === undefined ) {
		selector = '';
	}
	else if ( $.isPlainObject( selector ) ) {
		opts = selector;
		selector = '';
	}

	opts = _selector_opts( opts );

	var inst = this.iterator( 'table', function ( settings ) {
		return __row_selector( settings, selector, opts );
	}, 1 );

	// Want argument shifting here and in __row_selector?
	inst.selector.rows = selector;
	inst.selector.opts = opts;

	return inst;
} );

_api_register( 'rows().nodes()', function () {
	return this.iterator( 'row', function ( settings, row ) {
		return settings.aoData[ row ].nTr || undefined;
	}, 1 );
} );

_api_register( 'rows().data()', function () {
	return this.iterator( true, 'rows', function ( settings, rows ) {
		return _pluck_order( settings.aoData, rows, '_aData' );
	}, 1 );
} );

_api_registerPlural( 'rows().cache()', 'row().cache()', function ( type ) {
	return this.iterator( 'row', function ( settings, row ) {
		var r = settings.aoData[ row ];
		return type === 'search' ? r._aFilterData : r._aSortData;
	}, 1 );
} );

_api_registerPlural( 'rows().invalidate()', 'row().invalidate()', function ( src ) {
	return this.iterator( 'row', function ( settings, row ) {
		_fnInvalidate( settings, row, src );
	} );
} );

_api_registerPlural( 'rows().indexes()', 'row().index()', function () {
	return this.iterator( 'row', function ( settings, row ) {
		return row;
	}, 1 );
} );

_api_registerPlural( 'rows().ids()', 'row().id()', function ( hash ) {
	var a = [];
	var context = this.context;

	// `iterator` will drop undefined values, but in this case we want them
	for ( var i=0, ien=context.length ; i<ien ; i++ ) {
		for ( var j=0, jen=this[i].length ; j<jen ; j++ ) {
			var id = context[i].rowIdFn( context[i].aoData[ this[i][j] ]._aData );
			a.push( (hash === true ? '#' : '' )+ id );
		}
	}

	return new _Api( context, a );
} );

_api_registerPlural( 'rows().remove()', 'row().remove()', function () {
	var that = this;

	this.iterator( 'row', function ( settings, row, thatIdx ) {
		var data = settings.aoData;
		var rowData = data[ row ];
		var i, ien, j, jen;
		var loopRow, loopCells;

		data.splice( row, 1 );

		// Update the cached indexes
		for ( i=0, ien=data.length ; i<ien ; i++ ) {
			loopRow = data[i];
			loopCells = loopRow.anCells;

			// Rows
			if ( loopRow.nTr !== null ) {
				loopRow.nTr._DT_RowIndex = i;
			}

			// Cells
			if ( loopCells !== null ) {
				for ( j=0, jen=loopCells.length ; j<jen ; j++ ) {
					loopCells[j]._DT_CellIndex.row = i;
				}
			}
		}

		// Delete from the display arrays
		_fnDeleteIndex( settings.aiDisplayMaster, row );
		_fnDeleteIndex( settings.aiDisplay, row );
		_fnDeleteIndex( that[ thatIdx ], row, false ); // maintain local indexes

		// For server-side processing tables - subtract the deleted row from the count
		if ( settings._iRecordsDisplay > 0 ) {
			settings._iRecordsDisplay--;
		}

		// Check for an 'overflow' they case for displaying the table
		_fnLengthOverflow( settings );

		// Remove the row's ID reference if there is one
		var id = settings.rowIdFn( rowData._aData );
		if ( id !== undefined ) {
			delete settings.aIds[ id ];
		}
	} );

	this.iterator( 'table', function ( settings ) {
		for ( var i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
			settings.aoData[i].idx = i;
		}
	} );

	return this;
} );


_api_register( 'rows.add()', function ( rows ) {
	var newRows = this.iterator( 'table', function ( settings ) {
			var row, i, ien;
			var out = [];

			for ( i=0, ien=rows.length ; i<ien ; i++ ) {
				row = rows[i];

				if ( row.nodeName && row.nodeName.toUpperCase() === 'TR' ) {
					out.push( _fnAddTr( settings, row )[0] );
				}
				else {
					out.push( _fnAddData( settings, row ) );
				}
			}

			return out;
		}, 1 );

	// Return an Api.rows() extended instance, so rows().nodes() etc can be used
	var modRows = this.rows( -1 );
	modRows.pop();
	$.merge( modRows, newRows );

	return modRows;
} );





/**
 *
 */
_api_register( 'row()', function ( selector, opts ) {
	return _selector_first( this.rows( selector, opts ) );
} );


_api_register( 'row().data()', function ( data ) {
	var ctx = this.context;

	if ( data === undefined ) {
		// Get
		return ctx.length && this.length ?
			ctx[0].aoData[ this[0] ]._aData :
			undefined;
	}

	// Set
	var row = ctx[0].aoData[ this[0] ];
	row._aData = data;

	// If the DOM has an id, and the data source is an array
	if ( Array.isArray( data ) && row.nTr && row.nTr.id ) {
		_fnSetObjectDataFn( ctx[0].rowId )( data, row.nTr.id );
	}

	// Automatically invalidate
	_fnInvalidate( ctx[0], this[0], 'data' );

	return this;
} );


_api_register( 'row().node()', function () {
	var ctx = this.context;

	return ctx.length && this.length ?
		ctx[0].aoData[ this[0] ].nTr || null :
		null;
} );


_api_register( 'row.add()', function ( row ) {
	// Allow a jQuery object to be passed in - only a single row is added from
	// it though - the first element in the set
	if ( row instanceof $ && row.length ) {
		row = row[0];
	}

	var rows = this.iterator( 'table', function ( settings ) {
		if ( row.nodeName && row.nodeName.toUpperCase() === 'TR' ) {
			return _fnAddTr( settings, row )[0];
		}
		return _fnAddData( settings, row );
	} );

	// Return an Api.rows() extended instance, with the newly added row selected
	return this.row( rows[0] );
} );


$(document).on('plugin-init.dt', function (e, context) {
	var api = new _Api( context );
	var namespace = 'on-plugin-init';
	var stateSaveParamsEvent = 'stateSaveParams.' + namespace;
	var destroyEvent = 'destroy. ' + namespace;

	api.on( stateSaveParamsEvent, function ( e, settings, d ) {
		// This could be more compact with the API, but it is a lot faster as a simple
		// internal loop
		var idFn = settings.rowIdFn;
		var data = settings.aoData;
		var ids = [];

		for (var i=0 ; i<data.length ; i++) {
			if (data[i]._detailsShow) {
				ids.push( '#' + idFn(data[i]._aData) );
			}
		}

		d.childRows = ids;
	});

	api.on( destroyEvent, function () {
		api.off(stateSaveParamsEvent + ' ' + destroyEvent);
	});

	var loaded = api.state.loaded();

	if ( loaded && loaded.childRows ) {
		api
			.rows( $.map(loaded.childRows, function (id){
				return id.replace(/:/g, '\\:')
			}) )
			.every( function () {
				_fnCallbackFire( context, null, 'requestChild', [ this ] )
			});
	}
});

var __details_add = function ( ctx, row, data, klass )
{
	// Convert to array of TR elements
	var rows = [];
	var addRow = function ( r, k ) {
		// Recursion to allow for arrays of jQuery objects
		if ( Array.isArray( r ) || r instanceof $ ) {
			for ( var i=0, ien=r.length ; i<ien ; i++ ) {
				addRow( r[i], k );
			}
			return;
		}

		// If we get a TR element, then just add it directly - up to the dev
		// to add the correct number of columns etc
		if ( r.nodeName && r.nodeName.toLowerCase() === 'tr' ) {
			rows.push( r );
		}
		else {
			// Otherwise create a row with a wrapper
			var created = $('<tr><td></td></tr>').addClass( k );
			$('td', created)
				.addClass( k )
				.html( r )
				[0].colSpan = _fnVisbleColumns( ctx );

			rows.push( created[0] );
		}
	};

	addRow( data, klass );

	if ( row._details ) {
		row._details.detach();
	}

	row._details = $(rows);

	// If the children were already shown, that state should be retained
	if ( row._detailsShow ) {
		row._details.insertAfter( row.nTr );
	}
};


// Make state saving of child row details async to allow them to be batch processed
var __details_state = DataTable.util.throttle(
	function (ctx) {
		_fnSaveState( ctx[0] )
	},
	500
);


var __details_remove = function ( api, idx )
{
	var ctx = api.context;

	if ( ctx.length ) {
		var row = ctx[0].aoData[ idx !== undefined ? idx : api[0] ];

		if ( row && row._details ) {
			row._details.remove();

			row._detailsShow = undefined;
			row._details = undefined;
			$( row.nTr ).removeClass( 'dt-hasChild' );
			__details_state( ctx );
		}
	}
};


var __details_display = function ( api, show ) {
	var ctx = api.context;

	if ( ctx.length && api.length ) {
		var row = ctx[0].aoData[ api[0] ];

		if ( row._details ) {
			row._detailsShow = show;

			if ( show ) {
				row._details.insertAfter( row.nTr );
				$( row.nTr ).addClass( 'dt-hasChild' );
			}
			else {
				row._details.detach();
				$( row.nTr ).removeClass( 'dt-hasChild' );
			}

			_fnCallbackFire( ctx[0], null, 'childRow', [ show, api.row( api[0] ) ] )

			__details_events( ctx[0] );
			__details_state( ctx );
		}
	}
};


var __details_events = function ( settings )
{
	var api = new _Api( settings );
	var namespace = '.dt.DT_details';
	var drawEvent = 'draw'+namespace;
	var colvisEvent = 'column-sizing'+namespace;
	var destroyEvent = 'destroy'+namespace;
	var data = settings.aoData;

	api.off( drawEvent +' '+ colvisEvent +' '+ destroyEvent );

	if ( _pluck( data, '_details' ).length > 0 ) {
		// On each draw, insert the required elements into the document
		api.on( drawEvent, function ( e, ctx ) {
			if ( settings !== ctx ) {
				return;
			}

			api.rows( {page:'current'} ).eq(0).each( function (idx) {
				// Internal data grab
				var row = data[ idx ];

				if ( row._detailsShow ) {
					row._details.insertAfter( row.nTr );
				}
			} );
		} );

		// Column visibility change - update the colspan
		api.on( colvisEvent, function ( e, ctx, idx, vis ) {
			if ( settings !== ctx ) {
				return;
			}

			// Update the colspan for the details rows (note, only if it already has
			// a colspan)
			var row, visible = _fnVisbleColumns( ctx );

			for ( var i=0, ien=data.length ; i<ien ; i++ ) {
				row = data[i];

				if ( row._details ) {
					row._details.children('td[colspan]').attr('colspan', visible );
				}
			}
		} );

		// Table destroyed - nuke any child rows
		api.on( destroyEvent, function ( e, ctx ) {
			if ( settings !== ctx ) {
				return;
			}

			for ( var i=0, ien=data.length ; i<ien ; i++ ) {
				if ( data[i]._details ) {
					__details_remove( api, i );
				}
			}
		} );
	}
};

// Strings for the method names to help minification
var _emp = '';
var _child_obj = _emp+'row().child';
var _child_mth = _child_obj+'()';

// data can be:
//  tr
//  string
//  jQuery or array of any of the above
_api_register( _child_mth, function ( data, klass ) {
	var ctx = this.context;

	if ( data === undefined ) {
		// get
		return ctx.length && this.length ?
			ctx[0].aoData[ this[0] ]._details :
			undefined;
	}
	else if ( data === true ) {
		// show
		this.child.show();
	}
	else if ( data === false ) {
		// remove
		__details_remove( this );
	}
	else if ( ctx.length && this.length ) {
		// set
		__details_add( ctx[0], ctx[0].aoData[ this[0] ], data, klass );
	}

	return this;
} );


_api_register( [
	_child_obj+'.show()',
	_child_mth+'.show()' // only when `child()` was called with parameters (without
], function ( show ) {   // it returns an object and this method is not executed)
	__details_display( this, true );
	return this;
} );


_api_register( [
	_child_obj+'.hide()',
	_child_mth+'.hide()' // only when `child()` was called with parameters (without
], function () {         // it returns an object and this method is not executed)
	__details_display( this, false );
	return this;
} );


_api_register( [
	_child_obj+'.remove()',
	_child_mth+'.remove()' // only when `child()` was called with parameters (without
], function () {           // it returns an object and this method is not executed)
	__details_remove( this );
	return this;
} );


_api_register( _child_obj+'.isShown()', function () {
	var ctx = this.context;

	if ( ctx.length && this.length ) {
		// _detailsShown as false or undefined will fall through to return false
		return ctx[0].aoData[ this[0] ]._detailsShow || false;
	}
	return false;
} );



/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Columns
 *
 * {integer}           - column index (>=0 count from left, <0 count from right)
 * "{integer}:visIdx"  - visible column index (i.e. translate to column index)  (>=0 count from left, <0 count from right)
 * "{integer}:visible" - alias for {integer}:visIdx  (>=0 count from left, <0 count from right)
 * "{string}:name"     - column name
 * "{string}"          - jQuery selector on column header nodes
 *
 */

// can be an array of these items, comma separated list, or an array of comma
// separated lists

var __re_column_selector = /^([^:]+):(name|visIdx|visible)$/;


// r1 and r2 are redundant - but it means that the parameters match for the
// iterator callback in columns().data()
var __columnData = function ( settings, column, r1, r2, rows ) {
	var a = [];
	for ( var row=0, ien=rows.length ; row<ien ; row++ ) {
		a.push( _fnGetCellData( settings, rows[row], column ) );
	}
	return a;
};


var __column_selector = function ( settings, selector, opts )
{
	var
		columns = settings.aoColumns,
		names = _pluck( columns, 'sName' ),
		nodes = _pluck( columns, 'nTh' );

	var run = function ( s ) {
		var selInt = _intVal( s );

		// Selector - all
		if ( s === '' ) {
			return _range( columns.length );
		}

		// Selector - index
		if ( selInt !== null ) {
			return [ selInt >= 0 ?
				selInt : // Count from left
				columns.length + selInt // Count from right (+ because its a negative value)
			];
		}

		// Selector = function
		if ( typeof s === 'function' ) {
			var rows = _selector_row_indexes( settings, opts );

			return $.map( columns, function (col, idx) {
				return s(
						idx,
						__columnData( settings, idx, 0, 0, rows ),
						nodes[ idx ]
					) ? idx : null;
			} );
		}

		// jQuery or string selector
		var match = typeof s === 'string' ?
			s.match( __re_column_selector ) :
			'';

		if ( match ) {
			switch( match[2] ) {
				case 'visIdx':
				case 'visible':
					var idx = parseInt( match[1], 10 );
					// Visible index given, convert to column index
					if ( idx < 0 ) {
						// Counting from the right
						var visColumns = $.map( columns, function (col,i) {
							return col.bVisible ? i : null;
						} );
						return [ visColumns[ visColumns.length + idx ] ];
					}
					// Counting from the left
					return [ _fnVisibleToColumnIndex( settings, idx ) ];

				case 'name':
					// match by name. `names` is column index complete and in order
					return $.map( names, function (name, i) {
						return name === match[1] ? i : null;
					} );

				default:
					return [];
			}
		}

		// Cell in the table body
		if ( s.nodeName && s._DT_CellIndex ) {
			return [ s._DT_CellIndex.column ];
		}

		// jQuery selector on the TH elements for the columns
		var jqResult = $( nodes )
			.filter( s )
			.map( function () {
				return $.inArray( this, nodes ); // `nodes` is column index complete and in order
			} )
			.toArray();

		if ( jqResult.length || ! s.nodeName ) {
			return jqResult;
		}

		// Otherwise a node which might have a `dt-column` data attribute, or be
		// a child or such an element
		var host = $(s).closest('*[data-dt-column]');
		return host.length ?
			[ host.data('dt-column') ] :
			[];
	};

	return _selector_run( 'column', selector, run, settings, opts );
};


var __setColumnVis = function ( settings, column, vis ) {
	var
		cols = settings.aoColumns,
		col  = cols[ column ],
		data = settings.aoData,
		row, cells, i, ien, tr;

	// Get
	if ( vis === undefined ) {
		return col.bVisible;
	}

	// Set
	// No change
	if ( col.bVisible === vis ) {
		return;
	}

	if ( vis ) {
		// Insert column
		// Need to decide if we should use appendChild or insertBefore
		var insertBefore = $.inArray( true, _pluck(cols, 'bVisible'), column+1 );

		for ( i=0, ien=data.length ; i<ien ; i++ ) {
			tr = data[i].nTr;
			cells = data[i].anCells;

			if ( tr ) {
				// insertBefore can act like appendChild if 2nd arg is null
				tr.insertBefore( cells[ column ], cells[ insertBefore ] || null );
			}
		}
	}
	else {
		// Remove column
		$( _pluck( settings.aoData, 'anCells', column ) ).detach();
	}

	// Common actions
	col.bVisible = vis;
};


_api_register( 'columns()', function ( selector, opts ) {
	// argument shifting
	if ( selector === undefined ) {
		selector = '';
	}
	else if ( $.isPlainObject( selector ) ) {
		opts = selector;
		selector = '';
	}

	opts = _selector_opts( opts );

	var inst = this.iterator( 'table', function ( settings ) {
		return __column_selector( settings, selector, opts );
	}, 1 );

	// Want argument shifting here and in _row_selector?
	inst.selector.cols = selector;
	inst.selector.opts = opts;

	return inst;
} );

_api_registerPlural( 'columns().header()', 'column().header()', function ( selector, opts ) {
	return this.iterator( 'column', function ( settings, column ) {
		return settings.aoColumns[column].nTh;
	}, 1 );
} );

_api_registerPlural( 'columns().footer()', 'column().footer()', function ( selector, opts ) {
	return this.iterator( 'column', function ( settings, column ) {
		return settings.aoColumns[column].nTf;
	}, 1 );
} );

_api_registerPlural( 'columns().data()', 'column().data()', function () {
	return this.iterator( 'column-rows', __columnData, 1 );
} );

_api_registerPlural( 'columns().dataSrc()', 'column().dataSrc()', function () {
	return this.iterator( 'column', function ( settings, column ) {
		return settings.aoColumns[column].mData;
	}, 1 );
} );

_api_registerPlural( 'columns().cache()', 'column().cache()', function ( type ) {
	return this.iterator( 'column-rows', function ( settings, column, i, j, rows ) {
		return _pluck_order( settings.aoData, rows,
			type === 'search' ? '_aFilterData' : '_aSortData', column
		);
	}, 1 );
} );

_api_registerPlural( 'columns().nodes()', 'column().nodes()', function () {
	return this.iterator( 'column-rows', function ( settings, column, i, j, rows ) {
		return _pluck_order( settings.aoData, rows, 'anCells', column ) ;
	}, 1 );
} );

_api_registerPlural( 'columns().visible()', 'column().visible()', function ( vis, calc ) {
	var that = this;
	var ret = this.iterator( 'column', function ( settings, column ) {
		if ( vis === undefined ) {
			return settings.aoColumns[ column ].bVisible;
		} // else
		__setColumnVis( settings, column, vis );
	} );

	// Group the column visibility changes
	if ( vis !== undefined ) {
		this.iterator( 'table', function ( settings ) {
			// Redraw the header after changes
			_fnDrawHead( settings, settings.aoHeader );
			_fnDrawHead( settings, settings.aoFooter );
	
			// Update colspan for no records display. Child rows and extensions will use their own
			// listeners to do this - only need to update the empty table item here
			if ( ! settings.aiDisplay.length ) {
				$(settings.nTBody).find('td[colspan]').attr('colspan', _fnVisbleColumns(settings));
			}
	
			_fnSaveState( settings );

			// Second loop once the first is done for events
			that.iterator( 'column', function ( settings, column ) {
				_fnCallbackFire( settings, null, 'column-visibility', [settings, column, vis, calc] );
			} );

			if ( calc === undefined || calc ) {
				that.columns.adjust();
			}
		});
	}

	return ret;
} );

_api_registerPlural( 'columns().indexes()', 'column().index()', function ( type ) {
	return this.iterator( 'column', function ( settings, column ) {
		return type === 'visible' ?
			_fnColumnIndexToVisible( settings, column ) :
			column;
	}, 1 );
} );

_api_register( 'columns.adjust()', function () {
	return this.iterator( 'table', function ( settings ) {
		_fnAdjustColumnSizing( settings );
	}, 1 );
} );

_api_register( 'column.index()', function ( type, idx ) {
	if ( this.context.length !== 0 ) {
		var ctx = this.context[0];

		if ( type === 'fromVisible' || type === 'toData' ) {
			return _fnVisibleToColumnIndex( ctx, idx );
		}
		else if ( type === 'fromData' || type === 'toVisible' ) {
			return _fnColumnIndexToVisible( ctx, idx );
		}
	}
} );

_api_register( 'column()', function ( selector, opts ) {
	return _selector_first( this.columns( selector, opts ) );
} );

var __cell_selector = function ( settings, selector, opts )
{
	var data = settings.aoData;
	var rows = _selector_row_indexes( settings, opts );
	var cells = _removeEmpty( _pluck_order( data, rows, 'anCells' ) );
	var allCells = $(_flatten( [], cells ));
	var row;
	var columns = settings.aoColumns.length;
	var a, i, ien, j, o, host;

	var run = function ( s ) {
		var fnSelector = typeof s === 'function';

		if ( s === null || s === undefined || fnSelector ) {
			// All cells and function selectors
			a = [];

			for ( i=0, ien=rows.length ; i<ien ; i++ ) {
				row = rows[i];

				for ( j=0 ; j<columns ; j++ ) {
					o = {
						row: row,
						column: j
					};

					if ( fnSelector ) {
						// Selector - function
						host = data[ row ];

						if ( s( o, _fnGetCellData(settings, row, j), host.anCells ? host.anCells[j] : null ) ) {
							a.push( o );
						}
					}
					else {
						// Selector - all
						a.push( o );
					}
				}
			}

			return a;
		}
		
		// Selector - index
		if ( $.isPlainObject( s ) ) {
			// Valid cell index and its in the array of selectable rows
			return s.column !== undefined && s.row !== undefined && $.inArray( s.row, rows ) !== -1 ?
				[s] :
				[];
		}

		// Selector - jQuery filtered cells
		var jqResult = allCells
			.filter( s )
			.map( function (i, el) {
				return { // use a new object, in case someone changes the values
					row:    el._DT_CellIndex.row,
					column: el._DT_CellIndex.column
 				};
			} )
			.toArray();

		if ( jqResult.length || ! s.nodeName ) {
			return jqResult;
		}

		// Otherwise the selector is a node, and there is one last option - the
		// element might be a child of an element which has dt-row and dt-column
		// data attributes
		host = $(s).closest('*[data-dt-row]');
		return host.length ?
			[ {
				row: host.data('dt-row'),
				column: host.data('dt-column')
			} ] :
			[];
	};

	return _selector_run( 'cell', selector, run, settings, opts );
};




_api_register( 'cells()', function ( rowSelector, columnSelector, opts ) {
	// Argument shifting
	if ( $.isPlainObject( rowSelector ) ) {
		// Indexes
		if ( rowSelector.row === undefined ) {
			// Selector options in first parameter
			opts = rowSelector;
			rowSelector = null;
		}
		else {
			// Cell index objects in first parameter
			opts = columnSelector;
			columnSelector = null;
		}
	}
	if ( $.isPlainObject( columnSelector ) ) {
		opts = columnSelector;
		columnSelector = null;
	}

	// Cell selector
	if ( columnSelector === null || columnSelector === undefined ) {
		return this.iterator( 'table', function ( settings ) {
			return __cell_selector( settings, rowSelector, _selector_opts( opts ) );
		} );
	}

	// The default built in options need to apply to row and columns
	var internalOpts = opts ? {
		page: opts.page,
		order: opts.order,
		search: opts.search
	} : {};

	// Row + column selector
	var columns = this.columns( columnSelector, internalOpts );
	var rows = this.rows( rowSelector, internalOpts );
	var i, ien, j, jen;

	var cellsNoOpts = this.iterator( 'table', function ( settings, idx ) {
		var a = [];

		for ( i=0, ien=rows[idx].length ; i<ien ; i++ ) {
			for ( j=0, jen=columns[idx].length ; j<jen ; j++ ) {
				a.push( {
					row:    rows[idx][i],
					column: columns[idx][j]
				} );
			}
		}

		return a;
	}, 1 );

	// There is currently only one extension which uses a cell selector extension
	// It is a _major_ performance drag to run this if it isn't needed, so this is
	// an extension specific check at the moment
	var cells = opts && opts.selected ?
		this.cells( cellsNoOpts, opts ) :
		cellsNoOpts;

	$.extend( cells.selector, {
		cols: columnSelector,
		rows: rowSelector,
		opts: opts
	} );

	return cells;
} );


_api_registerPlural( 'cells().nodes()', 'cell().node()', function () {
	return this.iterator( 'cell', function ( settings, row, column ) {
		var data = settings.aoData[ row ];

		return data && data.anCells ?
			data.anCells[ column ] :
			undefined;
	}, 1 );
} );


_api_register( 'cells().data()', function () {
	return this.iterator( 'cell', function ( settings, row, column ) {
		return _fnGetCellData( settings, row, column );
	}, 1 );
} );


_api_registerPlural( 'cells().cache()', 'cell().cache()', function ( type ) {
	type = type === 'search' ? '_aFilterData' : '_aSortData';

	return this.iterator( 'cell', function ( settings, row, column ) {
		return settings.aoData[ row ][ type ][ column ];
	}, 1 );
} );


_api_registerPlural( 'cells().render()', 'cell().render()', function ( type ) {
	return this.iterator( 'cell', function ( settings, row, column ) {
		return _fnGetCellData( settings, row, column, type );
	}, 1 );
} );


_api_registerPlural( 'cells().indexes()', 'cell().index()', function () {
	return this.iterator( 'cell', function ( settings, row, column ) {
		return {
			row: row,
			column: column,
			columnVisible: _fnColumnIndexToVisible( settings, column )
		};
	}, 1 );
} );


_api_registerPlural( 'cells().invalidate()', 'cell().invalidate()', function ( src ) {
	return this.iterator( 'cell', function ( settings, row, column ) {
		_fnInvalidate( settings, row, src, column );
	} );
} );



_api_register( 'cell()', function ( rowSelector, columnSelector, opts ) {
	return _selector_first( this.cells( rowSelector, columnSelector, opts ) );
} );


_api_register( 'cell().data()', function ( data ) {
	var ctx = this.context;
	var cell = this[0];

	if ( data === undefined ) {
		// Get
		return ctx.length && cell.length ?
			_fnGetCellData( ctx[0], cell[0].row, cell[0].column ) :
			undefined;
	}

	// Set
	_fnSetCellData( ctx[0], cell[0].row, cell[0].column, data );
	_fnInvalidate( ctx[0], cell[0].row, 'data', cell[0].column );

	return this;
} );



/**
 * Get current ordering (sorting) that has been applied to the table.
 *
 * @returns {array} 2D array containing the sorting information for the first
 *   table in the current context. Each element in the parent array represents
 *   a column being sorted upon (i.e. multi-sorting with two columns would have
 *   2 inner arrays). The inner arrays may have 2 or 3 elements. The first is
 *   the column index that the sorting condition applies to, the second is the
 *   direction of the sort (`desc` or `asc`) and, optionally, the third is the
 *   index of the sorting order from the `column.sorting` initialisation array.
 *//**
 * Set the ordering for the table.
 *
 * @param {integer} order Column index to sort upon.
 * @param {string} direction Direction of the sort to be applied (`asc` or `desc`)
 * @returns {DataTables.Api} this
 *//**
 * Set the ordering for the table.
 *
 * @param {array} order 1D array of sorting information to be applied.
 * @param {array} [...] Optional additional sorting conditions
 * @returns {DataTables.Api} this
 *//**
 * Set the ordering for the table.
 *
 * @param {array} order 2D array of sorting information to be applied.
 * @returns {DataTables.Api} this
 */
_api_register( 'order()', function ( order, dir ) {
	var ctx = this.context;

	if ( order === undefined ) {
		// get
		return ctx.length !== 0 ?
			ctx[0].aaSorting :
			undefined;
	}

	// set
	if ( typeof order === 'number' ) {
		// Simple column / direction passed in
		order = [ [ order, dir ] ];
	}
	else if ( order.length && ! Array.isArray( order[0] ) ) {
		// Arguments passed in (list of 1D arrays)
		order = Array.prototype.slice.call( arguments );
	}
	// otherwise a 2D array was passed in

	return this.iterator( 'table', function ( settings ) {
		settings.aaSorting = order.slice();
	} );
} );


/**
 * Attach a sort listener to an element for a given column
 *
 * @param {node|jQuery|string} node Identifier for the element(s) to attach the
 *   listener to. This can take the form of a single DOM node, a jQuery
 *   collection of nodes or a jQuery selector which will identify the node(s).
 * @param {integer} column the column that a click on this node will sort on
 * @param {function} [callback] callback function when sort is run
 * @returns {DataTables.Api} this
 */
_api_register( 'order.listener()', function ( node, column, callback ) {
	return this.iterator( 'table', function ( settings ) {
		_fnSortAttachListener( settings, node, column, callback );
	} );
} );


_api_register( 'order.fixed()', function ( set ) {
	if ( ! set ) {
		var ctx = this.context;
		var fixed = ctx.length ?
			ctx[0].aaSortingFixed :
			undefined;

		return Array.isArray( fixed ) ?
			{ pre: fixed } :
			fixed;
	}

	return this.iterator( 'table', function ( settings ) {
		settings.aaSortingFixed = $.extend( true, {}, set );
	} );
} );


// Order by the selected column(s)
_api_register( [
	'columns().order()',
	'column().order()'
], function ( dir ) {
	var that = this;

	return this.iterator( 'table', function ( settings, i ) {
		var sort = [];

		$.each( that[i], function (j, col) {
			sort.push( [ col, dir ] );
		} );

		settings.aaSorting = sort;
	} );
} );



_api_register( 'search()', function ( input, regex, smart, caseInsen ) {
	var ctx = this.context;

	if ( input === undefined ) {
		// get
		return ctx.length !== 0 ?
			ctx[0].oPreviousSearch.sSearch :
			undefined;
	}

	// set
	return this.iterator( 'table', function ( settings ) {
		if ( ! settings.oFeatures.bFilter ) {
			return;
		}

		_fnFilterComplete( settings, $.extend( {}, settings.oPreviousSearch, {
			"sSearch": input+"",
			"bRegex":  regex === null ? false : regex,
			"bSmart":  smart === null ? true  : smart,
			"bCaseInsensitive": caseInsen === null ? true : caseInsen
		} ), 1 );
	} );
} );


_api_registerPlural(
	'columns().search()',
	'column().search()',
	function ( input, regex, smart, caseInsen ) {
		return this.iterator( 'column', function ( settings, column ) {
			var preSearch = settings.aoPreSearchCols;

			if ( input === undefined ) {
				// get
				return preSearch[ column ].sSearch;
			}

			// set
			if ( ! settings.oFeatures.bFilter ) {
				return;
			}

			$.extend( preSearch[ column ], {
				"sSearch": input+"",
				"bRegex":  regex === null ? false : regex,
				"bSmart":  smart === null ? true  : smart,
				"bCaseInsensitive": caseInsen === null ? true : caseInsen
			} );

			_fnFilterComplete( settings, settings.oPreviousSearch, 1 );
		} );
	}
);

/*
 * State API methods
 */

_api_register( 'state()', function () {
	return this.context.length ?
		this.context[0].oSavedState :
		null;
} );


_api_register( 'state.clear()', function () {
	return this.iterator( 'table', function ( settings ) {
		// Save an empty object
		settings.fnStateSaveCallback.call( settings.oInstance, settings, {} );
	} );
} );


_api_register( 'state.loaded()', function () {
	return this.context.length ?
		this.context[0].oLoadedState :
		null;
} );


_api_register( 'state.save()', function () {
	return this.iterator( 'table', function ( settings ) {
		_fnSaveState( settings );
	} );
} );



/**
 * Set the jQuery or window object to be used by DataTables
 *
 * @param {*} module Library / container object
 * @param {string} [type] Library or container type `lib`, `win` or `datetime`.
 *   If not provided, automatic detection is attempted.
 */
DataTable.use = function (module, type) {
	if (type === 'lib' || module.fn) {
		$ = module;
	}
	else if (type == 'win' || module.document) {
		window = module;
		document = module.document;
	}
	else if (type === 'datetime' || module.type === 'DateTime') {
		DataTable.DateTime = module;
	}
}

/**
 * CommonJS factory function pass through. This will check if the arguments
 * given are a window object or a jQuery object. If so they are set
 * accordingly.
 * @param {*} root Window
 * @param {*} jq jQUery
 * @returns {boolean} Indicator
 */
DataTable.factory = function (root, jq) {
	var is = false;

	// Test if the first parameter is a window object
	if (root && root.document) {
		window = root;
		document = root.document;
	}

	// Test if the second parameter is a jQuery object
	if (jq && jq.fn && jq.fn.jquery) {
		$ = jq;
		is = true;
	}

	return is;
}

/**
 * Provide a common method for plug-ins to check the version of DataTables being
 * used, in order to ensure compatibility.
 *
 *  @param {string} version Version string to check for, in the format "X.Y.Z".
 *    Note that the formats "X" and "X.Y" are also acceptable.
 *  @returns {boolean} true if this version of DataTables is greater or equal to
 *    the required version, or false if this version of DataTales is not
 *    suitable
 *  @static
 *  @dtopt API-Static
 *
 *  @example
 *    alert( $.fn.dataTable.versionCheck( '1.9.0' ) );
 */
DataTable.versionCheck = DataTable.fnVersionCheck = function( version )
{
	var aThis = DataTable.version.split('.');
	var aThat = version.split('.');
	var iThis, iThat;

	for ( var i=0, iLen=aThat.length ; i<iLen ; i++ ) {
		iThis = parseInt( aThis[i], 10 ) || 0;
		iThat = parseInt( aThat[i], 10 ) || 0;

		// Parts are the same, keep comparing
		if (iThis === iThat) {
			continue;
		}

		// Parts are different, return immediately
		return iThis > iThat;
	}

	return true;
};


/**
 * Check if a `<table>` node is a DataTable table already or not.
 *
 *  @param {node|jquery|string} table Table node, jQuery object or jQuery
 *      selector for the table to test. Note that if more than more than one
 *      table is passed on, only the first will be checked
 *  @returns {boolean} true the table given is a DataTable, or false otherwise
 *  @static
 *  @dtopt API-Static
 *
 *  @example
 *    if ( ! $.fn.DataTable.isDataTable( '#example' ) ) {
 *      $('#example').dataTable();
 *    }
 */
DataTable.isDataTable = DataTable.fnIsDataTable = function ( table )
{
	var t = $(table).get(0);
	var is = false;

	if ( table instanceof DataTable.Api ) {
		return true;
	}

	$.each( DataTable.settings, function (i, o) {
		var head = o.nScrollHead ? $('table', o.nScrollHead)[0] : null;
		var foot = o.nScrollFoot ? $('table', o.nScrollFoot)[0] : null;

		if ( o.nTable === t || head === t || foot === t ) {
			is = true;
		}
	} );

	return is;
};


/**
 * Get all DataTable tables that have been initialised - optionally you can
 * select to get only currently visible tables.
 *
 *  @param {boolean} [visible=false] Flag to indicate if you want all (default)
 *    or visible tables only.
 *  @returns {array} Array of `table` nodes (not DataTable instances) which are
 *    DataTables
 *  @static
 *  @dtopt API-Static
 *
 *  @example
 *    $.each( $.fn.dataTable.tables(true), function () {
 *      $(table).DataTable().columns.adjust();
 *    } );
 */
DataTable.tables = DataTable.fnTables = function ( visible )
{
	var api = false;

	if ( $.isPlainObject( visible ) ) {
		api = visible.api;
		visible = visible.visible;
	}

	var a = $.map( DataTable.settings, function (o) {
		if ( !visible || (visible && $(o.nTable).is(':visible')) ) {
			return o.nTable;
		}
	} );

	return api ?
		new _Api( a ) :
		a;
};


/**
 * Convert from camel case parameters to Hungarian notation. This is made public
 * for the extensions to provide the same ability as DataTables core to accept
 * either the 1.9 style Hungarian notation, or the 1.10+ style camelCase
 * parameters.
 *
 *  @param {object} src The model object which holds all parameters that can be
 *    mapped.
 *  @param {object} user The object to convert from camel case to Hungarian.
 *  @param {boolean} force When set to `true`, properties which already have a
 *    Hungarian value in the `user` object will be overwritten. Otherwise they
 *    won't be.
 */
DataTable.camelToHungarian = _fnCamelToHungarian;



/**
 *
 */
_api_register( '$()', function ( selector, opts ) {
	var
		rows   = this.rows( opts ).nodes(), // Get all rows
		jqRows = $(rows);

	return $( [].concat(
		jqRows.filter( selector ).toArray(),
		jqRows.find( selector ).toArray()
	) );
} );


// jQuery functions to operate on the tables
$.each( [ 'on', 'one', 'off' ], function (i, key) {
	_api_register( key+'()', function ( /* event, handler */ ) {
		var args = Array.prototype.slice.call(arguments);

		// Add the `dt` namespace automatically if it isn't already present
		args[0] = $.map( args[0].split( /\s/ ), function ( e ) {
			return ! e.match(/\.dt\b/) ?
				e+'.dt' :
				e;
			} ).join( ' ' );

		var inst = $( this.tables().nodes() );
		inst[key].apply( inst, args );
		return this;
	} );
} );


_api_register( 'clear()', function () {
	return this.iterator( 'table', function ( settings ) {
		_fnClearTable( settings );
	} );
} );


_api_register( 'settings()', function () {
	return new _Api( this.context, this.context );
} );


_api_register( 'init()', function () {
	var ctx = this.context;
	return ctx.length ? ctx[0].oInit : null;
} );


_api_register( 'data()', function () {
	return this.iterator( 'table', function ( settings ) {
		return _pluck( settings.aoData, '_aData' );
	} ).flatten();
} );


_api_register( 'destroy()', function ( remove ) {
	remove = remove || false;

	return this.iterator( 'table', function ( settings ) {
		var classes   = settings.oClasses;
		var table     = settings.nTable;
		var tbody     = settings.nTBody;
		var thead     = settings.nTHead;
		var tfoot     = settings.nTFoot;
		var jqTable   = $(table);
		var jqTbody   = $(tbody);
		var jqWrapper = $(settings.nTableWrapper);
		var rows      = $.map( settings.aoData, function (r) { return r.nTr; } );
		var i, ien;

		// Flag to note that the table is currently being destroyed - no action
		// should be taken
		settings.bDestroying = true;

		// Fire off the destroy callbacks for plug-ins etc
		_fnCallbackFire( settings, "aoDestroyCallback", "destroy", [settings] );

		// If not being removed from the document, make all columns visible
		if ( ! remove ) {
			new _Api( settings ).columns().visible( true );
		}

		// Blitz all `DT` namespaced events (these are internal events, the
		// lowercase, `dt` events are user subscribed and they are responsible
		// for removing them
		jqWrapper.off('.DT').find(':not(tbody *)').off('.DT');
		$(window).off('.DT-'+settings.sInstance);

		// When scrolling we had to break the table up - restore it
		if ( table != thead.parentNode ) {
			jqTable.children('thead').detach();
			jqTable.append( thead );
		}

		if ( tfoot && table != tfoot.parentNode ) {
			jqTable.children('tfoot').detach();
			jqTable.append( tfoot );
		}

		settings.aaSorting = [];
		settings.aaSortingFixed = [];
		_fnSortingClasses( settings );

		$( rows ).removeClass( settings.asStripeClasses.join(' ') );

		$('th, td', thead).removeClass( classes.sSortable+' '+
			classes.sSortableAsc+' '+classes.sSortableDesc+' '+classes.sSortableNone
		);

		// Add the TR elements back into the table in their original order
		jqTbody.children().detach();
		jqTbody.append( rows );

		var orig = settings.nTableWrapper.parentNode;

		// Remove the DataTables generated nodes, events and classes
		var removedMethod = remove ? 'remove' : 'detach';
		jqTable[ removedMethod ]();
		jqWrapper[ removedMethod ]();

		// If we need to reattach the table to the document
		if ( ! remove && orig ) {
			// insertBefore acts like appendChild if !arg[1]
			orig.insertBefore( table, settings.nTableReinsertBefore );

			// Restore the width of the original table - was read from the style property,
			// so we can restore directly to that
			jqTable
				.css( 'width', settings.sDestroyWidth )
				.removeClass( classes.sTable );

			// If the were originally stripe classes - then we add them back here.
			// Note this is not fool proof (for example if not all rows had stripe
			// classes - but it's a good effort without getting carried away
			ien = settings.asDestroyStripes.length;

			if ( ien ) {
				jqTbody.children().each( function (i) {
					$(this).addClass( settings.asDestroyStripes[i % ien] );
				} );
			}
		}

		/* Remove the settings object from the settings array */
		var idx = $.inArray( settings, DataTable.settings );
		if ( idx !== -1 ) {
			DataTable.settings.splice( idx, 1 );
		}
	} );
} );


// Add the `every()` method for rows, columns and cells in a compact form
$.each( [ 'column', 'row', 'cell' ], function ( i, type ) {
	_api_register( type+'s().every()', function ( fn ) {
		var opts = this.selector.opts;
		var api = this;

		return this.iterator( type, function ( settings, arg1, arg2, arg3, arg4 ) {
			// Rows and columns:
			//  arg1 - index
			//  arg2 - table counter
			//  arg3 - loop counter
			//  arg4 - undefined
			// Cells:
			//  arg1 - row index
			//  arg2 - column index
			//  arg3 - table counter
			//  arg4 - loop counter
			fn.call(
				api[ type ](
					arg1,
					type==='cell' ? arg2 : opts,
					type==='cell' ? opts : undefined
				),
				arg1, arg2, arg3, arg4
			);
		} );
	} );
} );


// i18n method for extensions to be able to use the language object from the
// DataTable
_api_register( 'i18n()', function ( token, def, plural ) {
	var ctx = this.context[0];
	var resolved = _fnGetObjectDataFn( token )( ctx.oLanguage );

	if ( resolved === undefined ) {
		resolved = def;
	}

	if ( plural !== undefined && $.isPlainObject( resolved ) ) {
		resolved = resolved[ plural ] !== undefined ?
			resolved[ plural ] :
			resolved._;
	}

	return typeof resolved === 'string'
		? resolved.replace( '%d', plural ) // nb: plural might be undefined,
		: resolved;
} );
/**
 * Version string for plug-ins to check compatibility. Allowed format is
 * `a.b.c-d` where: a:int, b:int, c:int, d:string(dev|beta|alpha). `d` is used
 * only for non-release builds. See http://semver.org/ for more information.
 *  @member
 *  @type string
 *  @default Version number
 */
DataTable.version = "1.13.5";

/**
 * Private data store, containing all of the settings objects that are
 * created for the tables on a given page.
 *
 * Note that the `DataTable.settings` object is aliased to
 * `jQuery.fn.dataTableExt` through which it may be accessed and
 * manipulated, or `jQuery.fn.dataTable.settings`.
 *  @member
 *  @type array
 *  @default []
 *  @private
 */
DataTable.settings = [];

/**
 * Object models container, for the various models that DataTables has
 * available to it. These models define the objects that are used to hold
 * the active state and configuration of the table.
 *  @namespace
 */
DataTable.models = {};



/**
 * Template object for the way in which DataTables holds information about
 * search information for the global filter and individual column filters.
 *  @namespace
 */
DataTable.models.oSearch = {
	/**
	 * Flag to indicate if the filtering should be case insensitive or not
	 *  @type boolean
	 *  @default true
	 */
	"bCaseInsensitive": true,

	/**
	 * Applied search term
	 *  @type string
	 *  @default <i>Empty string</i>
	 */
	"sSearch": "",

	/**
	 * Flag to indicate if the search term should be interpreted as a
	 * regular expression (true) or not (false) and therefore and special
	 * regex characters escaped.
	 *  @type boolean
	 *  @default false
	 */
	"bRegex": false,

	/**
	 * Flag to indicate if DataTables is to use its smart filtering or not.
	 *  @type boolean
	 *  @default true
	 */
	"bSmart": true,

	/**
	 * Flag to indicate if DataTables should only trigger a search when
	 * the return key is pressed.
	 *  @type boolean
	 *  @default false
	 */
	"return": false
};




/**
 * Template object for the way in which DataTables holds information about
 * each individual row. This is the object format used for the settings
 * aoData array.
 *  @namespace
 */
DataTable.models.oRow = {
	/**
	 * TR element for the row
	 *  @type node
	 *  @default null
	 */
	"nTr": null,

	/**
	 * Array of TD elements for each row. This is null until the row has been
	 * created.
	 *  @type array nodes
	 *  @default []
	 */
	"anCells": null,

	/**
	 * Data object from the original data source for the row. This is either
	 * an array if using the traditional form of DataTables, or an object if
	 * using mData options. The exact type will depend on the passed in
	 * data from the data source, or will be an array if using DOM a data
	 * source.
	 *  @type array|object
	 *  @default []
	 */
	"_aData": [],

	/**
	 * Sorting data cache - this array is ostensibly the same length as the
	 * number of columns (although each index is generated only as it is
	 * needed), and holds the data that is used for sorting each column in the
	 * row. We do this cache generation at the start of the sort in order that
	 * the formatting of the sort data need be done only once for each cell
	 * per sort. This array should not be read from or written to by anything
	 * other than the master sorting methods.
	 *  @type array
	 *  @default null
	 *  @private
	 */
	"_aSortData": null,

	/**
	 * Per cell filtering data cache. As per the sort data cache, used to
	 * increase the performance of the filtering in DataTables
	 *  @type array
	 *  @default null
	 *  @private
	 */
	"_aFilterData": null,

	/**
	 * Filtering data cache. This is the same as the cell filtering cache, but
	 * in this case a string rather than an array. This is easily computed with
	 * a join on `_aFilterData`, but is provided as a cache so the join isn't
	 * needed on every search (memory traded for performance)
	 *  @type array
	 *  @default null
	 *  @private
	 */
	"_sFilterRow": null,

	/**
	 * Cache of the class name that DataTables has applied to the row, so we
	 * can quickly look at this variable rather than needing to do a DOM check
	 * on className for the nTr property.
	 *  @type string
	 *  @default <i>Empty string</i>
	 *  @private
	 */
	"_sRowStripe": "",

	/**
	 * Denote if the original data source was from the DOM, or the data source
	 * object. This is used for invalidating data, so DataTables can
	 * automatically read data from the original source, unless uninstructed
	 * otherwise.
	 *  @type string
	 *  @default null
	 *  @private
	 */
	"src": null,

	/**
	 * Index in the aoData array. This saves an indexOf lookup when we have the
	 * object, but want to know the index
	 *  @type integer
	 *  @default -1
	 *  @private
	 */
	"idx": -1
};


/**
 * Template object for the column information object in DataTables. This object
 * is held in the settings aoColumns array and contains all the information that
 * DataTables needs about each individual column.
 *
 * Note that this object is related to {@link DataTable.defaults.column}
 * but this one is the internal data store for DataTables's cache of columns.
 * It should NOT be manipulated outside of DataTables. Any configuration should
 * be done through the initialisation options.
 *  @namespace
 */
DataTable.models.oColumn = {
	/**
	 * Column index. This could be worked out on-the-fly with $.inArray, but it
	 * is faster to just hold it as a variable
	 *  @type integer
	 *  @default null
	 */
	"idx": null,

	/**
	 * A list of the columns that sorting should occur on when this column
	 * is sorted. That this property is an array allows multi-column sorting
	 * to be defined for a column (for example first name / last name columns
	 * would benefit from this). The values are integers pointing to the
	 * columns to be sorted on (typically it will be a single integer pointing
	 * at itself, but that doesn't need to be the case).
	 *  @type array
	 */
	"aDataSort": null,

	/**
	 * Define the sorting directions that are applied to the column, in sequence
	 * as the column is repeatedly sorted upon - i.e. the first value is used
	 * as the sorting direction when the column if first sorted (clicked on).
	 * Sort it again (click again) and it will move on to the next index.
	 * Repeat until loop.
	 *  @type array
	 */
	"asSorting": null,

	/**
	 * Flag to indicate if the column is searchable, and thus should be included
	 * in the filtering or not.
	 *  @type boolean
	 */
	"bSearchable": null,

	/**
	 * Flag to indicate if the column is sortable or not.
	 *  @type boolean
	 */
	"bSortable": null,

	/**
	 * Flag to indicate if the column is currently visible in the table or not
	 *  @type boolean
	 */
	"bVisible": null,

	/**
	 * Store for manual type assignment using the `column.type` option. This
	 * is held in store so we can manipulate the column's `sType` property.
	 *  @type string
	 *  @default null
	 *  @private
	 */
	"_sManualType": null,

	/**
	 * Flag to indicate if HTML5 data attributes should be used as the data
	 * source for filtering or sorting. True is either are.
	 *  @type boolean
	 *  @default false
	 *  @private
	 */
	"_bAttrSrc": false,

	/**
	 * Developer definable function that is called whenever a cell is created (Ajax source,
	 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
	 * allowing you to modify the DOM element (add background colour for example) when the
	 * element is available.
	 *  @type function
	 *  @param {element} nTd The TD node that has been created
	 *  @param {*} sData The Data for the cell
	 *  @param {array|object} oData The data for the whole row
	 *  @param {int} iRow The row index for the aoData data store
	 *  @default null
	 */
	"fnCreatedCell": null,

	/**
	 * Function to get data from a cell in a column. You should <b>never</b>
	 * access data directly through _aData internally in DataTables - always use
	 * the method attached to this property. It allows mData to function as
	 * required. This function is automatically assigned by the column
	 * initialisation method
	 *  @type function
	 *  @param {array|object} oData The data array/object for the array
	 *    (i.e. aoData[]._aData)
	 *  @param {string} sSpecific The specific data type you want to get -
	 *    'display', 'type' 'filter' 'sort'
	 *  @returns {*} The data for the cell from the given row's data
	 *  @default null
	 */
	"fnGetData": null,

	/**
	 * Function to set data for a cell in the column. You should <b>never</b>
	 * set the data directly to _aData internally in DataTables - always use
	 * this method. It allows mData to function as required. This function
	 * is automatically assigned by the column initialisation method
	 *  @type function
	 *  @param {array|object} oData The data array/object for the array
	 *    (i.e. aoData[]._aData)
	 *  @param {*} sValue Value to set
	 *  @default null
	 */
	"fnSetData": null,

	/**
	 * Property to read the value for the cells in the column from the data
	 * source array / object. If null, then the default content is used, if a
	 * function is given then the return from the function is used.
	 *  @type function|int|string|null
	 *  @default null
	 */
	"mData": null,

	/**
	 * Partner property to mData which is used (only when defined) to get
	 * the data - i.e. it is basically the same as mData, but without the
	 * 'set' option, and also the data fed to it is the result from mData.
	 * This is the rendering method to match the data method of mData.
	 *  @type function|int|string|null
	 *  @default null
	 */
	"mRender": null,

	/**
	 * Unique header TH/TD element for this column - this is what the sorting
	 * listener is attached to (if sorting is enabled.)
	 *  @type node
	 *  @default null
	 */
	"nTh": null,

	/**
	 * Unique footer TH/TD element for this column (if there is one). Not used
	 * in DataTables as such, but can be used for plug-ins to reference the
	 * footer for each column.
	 *  @type node
	 *  @default null
	 */
	"nTf": null,

	/**
	 * The class to apply to all TD elements in the table's TBODY for the column
	 *  @type string
	 *  @default null
	 */
	"sClass": null,

	/**
	 * When DataTables calculates the column widths to assign to each column,
	 * it finds the longest string in each column and then constructs a
	 * temporary table and reads the widths from that. The problem with this
	 * is that "mmm" is much wider then "iiii", but the latter is a longer
	 * string - thus the calculation can go wrong (doing it properly and putting
	 * it into an DOM object and measuring that is horribly(!) slow). Thus as
	 * a "work around" we provide this option. It will append its value to the
	 * text that is found to be the longest string for the column - i.e. padding.
	 *  @type string
	 */
	"sContentPadding": null,

	/**
	 * Allows a default value to be given for a column's data, and will be used
	 * whenever a null data source is encountered (this can be because mData
	 * is set to null, or because the data source itself is null).
	 *  @type string
	 *  @default null
	 */
	"sDefaultContent": null,

	/**
	 * Name for the column, allowing reference to the column by name as well as
	 * by index (needs a lookup to work by name).
	 *  @type string
	 */
	"sName": null,

	/**
	 * Custom sorting data type - defines which of the available plug-ins in
	 * afnSortData the custom sorting will use - if any is defined.
	 *  @type string
	 *  @default std
	 */
	"sSortDataType": 'std',

	/**
	 * Class to be applied to the header element when sorting on this column
	 *  @type string
	 *  @default null
	 */
	"sSortingClass": null,

	/**
	 * Class to be applied to the header element when sorting on this column -
	 * when jQuery UI theming is used.
	 *  @type string
	 *  @default null
	 */
	"sSortingClassJUI": null,

	/**
	 * Title of the column - what is seen in the TH element (nTh).
	 *  @type string
	 */
	"sTitle": null,

	/**
	 * Column sorting and filtering type
	 *  @type string
	 *  @default null
	 */
	"sType": null,

	/**
	 * Width of the column
	 *  @type string
	 *  @default null
	 */
	"sWidth": null,

	/**
	 * Width of the column when it was first "encountered"
	 *  @type string
	 *  @default null
	 */
	"sWidthOrig": null
};


/*
 * Developer note: The properties of the object below are given in Hungarian
 * notation, that was used as the interface for DataTables prior to v1.10, however
 * from v1.10 onwards the primary interface is camel case. In order to avoid
 * breaking backwards compatibility utterly with this change, the Hungarian
 * version is still, internally the primary interface, but is is not documented
 * - hence the @name tags in each doc comment. This allows a Javascript function
 * to create a map from Hungarian notation to camel case (going the other direction
 * would require each property to be listed, which would add around 3K to the size
 * of DataTables, while this method is about a 0.5K hit).
 *
 * Ultimately this does pave the way for Hungarian notation to be dropped
 * completely, but that is a massive amount of work and will break current
 * installs (therefore is on-hold until v2).
 */

/**
 * Initialisation options that can be given to DataTables at initialisation
 * time.
 *  @namespace
 */
DataTable.defaults = {
	/**
	 * An array of data to use for the table, passed in at initialisation which
	 * will be used in preference to any data which is already in the DOM. This is
	 * particularly useful for constructing tables purely in Javascript, for
	 * example with a custom Ajax call.
	 *  @type array
	 *  @default null
	 *
	 *  @dtopt Option
	 *  @name DataTable.defaults.data
	 *
	 *  @example
	 *    // Using a 2D array data source
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "data": [
	 *          ['Trident', 'Internet Explorer 4.0', 'Win 95+', 4, 'X'],
	 *          ['Trident', 'Internet Explorer 5.0', 'Win 95+', 5, 'C'],
	 *        ],
	 *        "columns": [
	 *          { "title": "Engine" },
	 *          { "title": "Browser" },
	 *          { "title": "Platform" },
	 *          { "title": "Version" },
	 *          { "title": "Grade" }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using an array of objects as a data source (`data`)
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "data": [
	 *          {
	 *            "engine":   "Trident",
	 *            "browser":  "Internet Explorer 4.0",
	 *            "platform": "Win 95+",
	 *            "version":  4,
	 *            "grade":    "X"
	 *          },
	 *          {
	 *            "engine":   "Trident",
	 *            "browser":  "Internet Explorer 5.0",
	 *            "platform": "Win 95+",
	 *            "version":  5,
	 *            "grade":    "C"
	 *          }
	 *        ],
	 *        "columns": [
	 *          { "title": "Engine",   "data": "engine" },
	 *          { "title": "Browser",  "data": "browser" },
	 *          { "title": "Platform", "data": "platform" },
	 *          { "title": "Version",  "data": "version" },
	 *          { "title": "Grade",    "data": "grade" }
	 *        ]
	 *      } );
	 *    } );
	 */
	"aaData": null,


	/**
	 * If ordering is enabled, then DataTables will perform a first pass sort on
	 * initialisation. You can define which column(s) the sort is performed
	 * upon, and the sorting direction, with this variable. The `sorting` array
	 * should contain an array for each column to be sorted initially containing
	 * the column's index and a direction string ('asc' or 'desc').
	 *  @type array
	 *  @default [[0,'asc']]
	 *
	 *  @dtopt Option
	 *  @name DataTable.defaults.order
	 *
	 *  @example
	 *    // Sort by 3rd column first, and then 4th column
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "order": [[2,'asc'], [3,'desc']]
	 *      } );
	 *    } );
	 *
	 *    // No initial sorting
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "order": []
	 *      } );
	 *    } );
	 */
	"aaSorting": [[0,'asc']],


	/**
	 * This parameter is basically identical to the `sorting` parameter, but
	 * cannot be overridden by user interaction with the table. What this means
	 * is that you could have a column (visible or hidden) which the sorting
	 * will always be forced on first - any sorting after that (from the user)
	 * will then be performed as required. This can be useful for grouping rows
	 * together.
	 *  @type array
	 *  @default null
	 *
	 *  @dtopt Option
	 *  @name DataTable.defaults.orderFixed
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "orderFixed": [[0,'asc']]
	 *      } );
	 *    } )
	 */
	"aaSortingFixed": [],


	/**
	 * DataTables can be instructed to load data to display in the table from a
	 * Ajax source. This option defines how that Ajax call is made and where to.
	 *
	 * The `ajax` property has three different modes of operation, depending on
	 * how it is defined. These are:
	 *
	 * * `string` - Set the URL from where the data should be loaded from.
	 * * `object` - Define properties for `jQuery.ajax`.
	 * * `function` - Custom data get function
	 *
	 * `string`
	 * --------
	 *
	 * As a string, the `ajax` property simply defines the URL from which
	 * DataTables will load data.
	 *
	 * `object`
	 * --------
	 *
	 * As an object, the parameters in the object are passed to
	 * [jQuery.ajax](http://api.jquery.com/jQuery.ajax/) allowing fine control
	 * of the Ajax request. DataTables has a number of default parameters which
	 * you can override using this option. Please refer to the jQuery
	 * documentation for a full description of the options available, although
	 * the following parameters provide additional options in DataTables or
	 * require special consideration:
	 *
	 * * `data` - As with jQuery, `data` can be provided as an object, but it
	 *   can also be used as a function to manipulate the data DataTables sends
	 *   to the server. The function takes a single parameter, an object of
	 *   parameters with the values that DataTables has readied for sending. An
	 *   object may be returned which will be merged into the DataTables
	 *   defaults, or you can add the items to the object that was passed in and
	 *   not return anything from the function. This supersedes `fnServerParams`
	 *   from DataTables 1.9-.
	 *
	 * * `dataSrc` - By default DataTables will look for the property `data` (or
	 *   `aaData` for compatibility with DataTables 1.9-) when obtaining data
	 *   from an Ajax source or for server-side processing - this parameter
	 *   allows that property to be changed. You can use Javascript dotted
	 *   object notation to get a data source for multiple levels of nesting, or
	 *   it my be used as a function. As a function it takes a single parameter,
	 *   the JSON returned from the server, which can be manipulated as
	 *   required, with the returned value being that used by DataTables as the
	 *   data source for the table. This supersedes `sAjaxDataProp` from
	 *   DataTables 1.9-.
	 *
	 * * `success` - Should not be overridden it is used internally in
	 *   DataTables. To manipulate / transform the data returned by the server
	 *   use `ajax.dataSrc`, or use `ajax` as a function (see below).
	 *
	 * `function`
	 * ----------
	 *
	 * As a function, making the Ajax call is left up to yourself allowing
	 * complete control of the Ajax request. Indeed, if desired, a method other
	 * than Ajax could be used to obtain the required data, such as Web storage
	 * or an AIR database.
	 *
	 * The function is given four parameters and no return is required. The
	 * parameters are:
	 *
	 * 1. _object_ - Data to send to the server
	 * 2. _function_ - Callback function that must be executed when the required
	 *    data has been obtained. That data should be passed into the callback
	 *    as the only parameter
	 * 3. _object_ - DataTables settings object for the table
	 *
	 * Note that this supersedes `fnServerData` from DataTables 1.9-.
	 *
	 *  @type string|object|function
	 *  @default null
	 *
	 *  @dtopt Option
	 *  @name DataTable.defaults.ajax
	 *  @since 1.10.0
	 *
	 * @example
	 *   // Get JSON data from a file via Ajax.
	 *   // Note DataTables expects data in the form `{ data: [ ...data... ] }` by default).
	 *   $('#example').dataTable( {
	 *     "ajax": "data.json"
	 *   } );
	 *
	 * @example
	 *   // Get JSON data from a file via Ajax, using `dataSrc` to change
	 *   // `data` to `tableData` (i.e. `{ tableData: [ ...data... ] }`)
	 *   $('#example').dataTable( {
	 *     "ajax": {
	 *       "url": "data.json",
	 *       "dataSrc": "tableData"
	 *     }
	 *   } );
	 *
	 * @example
	 *   // Get JSON data from a file via Ajax, using `dataSrc` to read data
	 *   // from a plain array rather than an array in an object
	 *   $('#example').dataTable( {
	 *     "ajax": {
	 *       "url": "data.json",
	 *       "dataSrc": ""
	 *     }
	 *   } );
	 *
	 * @example
	 *   // Manipulate the data returned from the server - add a link to data
	 *   // (note this can, should, be done using `render` for the column - this
	 *   // is just a simple example of how the data can be manipulated).
	 *   $('#example').dataTable( {
	 *     "ajax": {
	 *       "url": "data.json",
	 *       "dataSrc": function ( json ) {
	 *         for ( var i=0, ien=json.length ; i<ien ; i++ ) {
	 *           json[i][0] = '<a href="/message/'+json[i][0]+'>View message</a>';
	 *         }
	 *         return json;
	 *       }
	 *     }
	 *   } );
	 *
	 * @example
	 *   // Add data to the request
	 *   $('#example').dataTable( {
	 *     "ajax": {
	 *       "url": "data.json",
	 *       "data": function ( d ) {
	 *         return {
	 *           "extra_search": $('#extra').val()
	 *         };
	 *       }
	 *     }
	 *   } );
	 *
	 * @example
	 *   // Send request as POST
	 *   $('#example').dataTable( {
	 *     "ajax": {
	 *       "url": "data.json",
	 *       "type": "POST"
	 *     }
	 *   } );
	 *
	 * @example
	 *   // Get the data from localStorage (could interface with a form for
	 *   // adding, editing and removing rows).
	 *   $('#example').dataTable( {
	 *     "ajax": function (data, callback, settings) {
	 *       callback(
	 *         JSON.parse( localStorage.getItem('dataTablesData') )
	 *       );
	 *     }
	 *   } );
	 */
	"ajax": null,


	/**
	 * This parameter allows you to readily specify the entries in the length drop
	 * down menu that DataTables shows when pagination is enabled. It can be
	 * either a 1D array of options which will be used for both the displayed
	 * option and the value, or a 2D array which will use the array in the first
	 * position as the value, and the array in the second position as the
	 * displayed options (useful for language strings such as 'All').
	 *
	 * Note that the `pageLength` property will be automatically set to the
	 * first value given in this array, unless `pageLength` is also provided.
	 *  @type array
	 *  @default [ 10, 25, 50, 100 ]
	 *
	 *  @dtopt Option
	 *  @name DataTable.defaults.lengthMenu
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]]
	 *      } );
	 *    } );
	 */
	"aLengthMenu": [ 10, 25, 50, 100 ],


	/**
	 * The `columns` option in the initialisation parameter allows you to define
	 * details about the way individual columns behave. For a full list of
	 * column options that can be set, please see
	 * {@link DataTable.defaults.column}. Note that if you use `columns` to
	 * define your columns, you must have an entry in the array for every single
	 * column that you have in your table (these can be null if you don't which
	 * to specify any options).
	 *  @member
	 *
	 *  @name DataTable.defaults.column
	 */
	"aoColumns": null,

	/**
	 * Very similar to `columns`, `columnDefs` allows you to target a specific
	 * column, multiple columns, or all columns, using the `targets` property of
	 * each object in the array. This allows great flexibility when creating
	 * tables, as the `columnDefs` arrays can be of any length, targeting the
	 * columns you specifically want. `columnDefs` may use any of the column
	 * options available: {@link DataTable.defaults.column}, but it _must_
	 * have `targets` defined in each object in the array. Values in the `targets`
	 * array may be:
	 *   <ul>
	 *     <li>a string - class name will be matched on the TH for the column</li>
	 *     <li>0 or a positive integer - column index counting from the left</li>
	 *     <li>a negative integer - column index counting from the right</li>
	 *     <li>the string "_all" - all columns (i.e. assign a default)</li>
	 *   </ul>
	 *  @member
	 *
	 *  @name DataTable.defaults.columnDefs
	 */
	"aoColumnDefs": null,


	/**
	 * Basically the same as `search`, this parameter defines the individual column
	 * filtering state at initialisation time. The array must be of the same size
	 * as the number of columns, and each element be an object with the parameters
	 * `search` and `escapeRegex` (the latter is optional). 'null' is also
	 * accepted and the default will be used.
	 *  @type array
	 *  @default []
	 *
	 *  @dtopt Option
	 *  @name DataTable.defaults.searchCols
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "searchCols": [
	 *          null,
	 *          { "search": "My filter" },
	 *          null,
	 *          { "search": "^[0-9]", "escapeRegex": false }
	 *        ]
	 *      } );
	 *    } )
	 */
	"aoSearchCols": [],


	/**
	 * An array of CSS classes that should be applied to displayed rows. This
	 * array may be of any length, and DataTables will apply each class
	 * sequentially, looping when required.
	 *  @type array
	 *  @default null <i>Will take the values determined by the `oClasses.stripe*`
	 *    options</i>
	 *
	 *  @dtopt Option
	 *  @name DataTable.defaults.stripeClasses
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "stripeClasses": [ 'strip1', 'strip2', 'strip3' ]
	 *      } );
	 *    } )
	 */
	"asStripeClasses": null,


	/**
	 * Enable or disable automatic column width calculation. This can be disabled
	 * as an optimisation (it takes some time to calculate the widths) if the
	 * tables widths are passed in using `columns`.
	 *  @type boolean
	 *  @default true
	 *
	 *  @dtopt Features
	 *  @name DataTable.defaults.autoWidth
	 *
	 *  @example
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "autoWidth": false
	 *      } );
	 *    } );
	 */
	"bAutoWidth": true,


	/**
	 * Deferred rendering can provide DataTables with a huge speed boost when you
	 * are using an Ajax or JS data source for the table. This option, when set to
	 * true, will cause DataTables to defer the creation of the table elements for
	 * each row until they are needed for a draw - saving a significant amount of
	 * time.
	 *  @type boolean
	 *  @default false
	 *
	 *  @dtopt Features
	 *  @name DataTable.defaults.deferRender
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "ajax": "sources/arrays.txt",
	 *        "deferRender": true
	 *      } );
	 *    } );
	 */
	"bDeferRender": false,


	/**
	 * Replace a DataTable which matches the given selector and replace it with
	 * one which has the properties of the new initialisation object passed. If no
	 * table matches the selector, then the new DataTable will be constructed as
	 * per normal.
	 *  @type boolean
	 *  @default false
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.destroy
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "srollY": "200px",
	 *        "paginate": false
	 *      } );
	 *
	 *      // Some time later....
	 *      $('#example').dataTable( {
	 *        "filter": false,
	 *        "destroy": true
	 *      } );
	 *    } );
	 */
	"bDestroy": false,


	/**
	 * Enable or disable filtering of data. Filtering in DataTables is "smart" in
	 * that it allows the end user to input multiple words (space separated) and
	 * will match a row containing those words, even if not in the order that was
	 * specified (this allow matching across multiple columns). Note that if you
	 * wish to use filtering in DataTables this must remain 'true' - to remove the
	 * default filtering input box and retain filtering abilities, please use
	 * {@link DataTable.defaults.dom}.
	 *  @type boolean
	 *  @default true
	 *
	 *  @dtopt Features
	 *  @name DataTable.defaults.searching
	 *
	 *  @example
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "searching": false
	 *      } );
	 *    } );
	 */
	"bFilter": true,


	/**
	 * Enable or disable the table information display. This shows information
	 * about the data that is currently visible on the page, including information
	 * about filtered data if that action is being performed.
	 *  @type boolean
	 *  @default true
	 *
	 *  @dtopt Features
	 *  @name DataTable.defaults.info
	 *
	 *  @example
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "info": false
	 *      } );
	 *    } );
	 */
	"bInfo": true,


	/**
	 * Allows the end user to select the size of a formatted page from a select
	 * menu (sizes are 10, 25, 50 and 100). Requires pagination (`paginate`).
	 *  @type boolean
	 *  @default true
	 *
	 *  @dtopt Features
	 *  @name DataTable.defaults.lengthChange
	 *
	 *  @example
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "lengthChange": false
	 *      } );
	 *    } );
	 */
	"bLengthChange": true,


	/**
	 * Enable or disable pagination.
	 *  @type boolean
	 *  @default true
	 *
	 *  @dtopt Features
	 *  @name DataTable.defaults.paging
	 *
	 *  @example
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "paging": false
	 *      } );
	 *    } );
	 */
	"bPaginate": true,


	/**
	 * Enable or disable the display of a 'processing' indicator when the table is
	 * being processed (e.g. a sort). This is particularly useful for tables with
	 * large amounts of data where it can take a noticeable amount of time to sort
	 * the entries.
	 *  @type boolean
	 *  @default false
	 *
	 *  @dtopt Features
	 *  @name DataTable.defaults.processing
	 *
	 *  @example
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "processing": true
	 *      } );
	 *    } );
	 */
	"bProcessing": false,


	/**
	 * Retrieve the DataTables object for the given selector. Note that if the
	 * table has already been initialised, this parameter will cause DataTables
	 * to simply return the object that has already been set up - it will not take
	 * account of any changes you might have made to the initialisation object
	 * passed to DataTables (setting this parameter to true is an acknowledgement
	 * that you understand this). `destroy` can be used to reinitialise a table if
	 * you need.
	 *  @type boolean
	 *  @default false
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.retrieve
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      initTable();
	 *      tableActions();
	 *    } );
	 *
	 *    function initTable ()
	 *    {
	 *      return $('#example').dataTable( {
	 *        "scrollY": "200px",
	 *        "paginate": false,
	 *        "retrieve": true
	 *      } );
	 *    }
	 *
	 *    function tableActions ()
	 *    {
	 *      var table = initTable();
	 *      // perform API operations with oTable
	 *    }
	 */
	"bRetrieve": false,


	/**
	 * When vertical (y) scrolling is enabled, DataTables will force the height of
	 * the table's viewport to the given height at all times (useful for layout).
	 * However, this can look odd when filtering data down to a small data set,
	 * and the footer is left "floating" further down. This parameter (when
	 * enabled) will cause DataTables to collapse the table's viewport down when
	 * the result set will fit within the given Y height.
	 *  @type boolean
	 *  @default false
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.scrollCollapse
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "scrollY": "200",
	 *        "scrollCollapse": true
	 *      } );
	 *    } );
	 */
	"bScrollCollapse": false,


	/**
	 * Configure DataTables to use server-side processing. Note that the
	 * `ajax` parameter must also be given in order to give DataTables a
	 * source to obtain the required data for each draw.
	 *  @type boolean
	 *  @default false
	 *
	 *  @dtopt Features
	 *  @dtopt Server-side
	 *  @name DataTable.defaults.serverSide
	 *
	 *  @example
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "serverSide": true,
	 *        "ajax": "xhr.php"
	 *      } );
	 *    } );
	 */
	"bServerSide": false,


	/**
	 * Enable or disable sorting of columns. Sorting of individual columns can be
	 * disabled by the `sortable` option for each column.
	 *  @type boolean
	 *  @default true
	 *
	 *  @dtopt Features
	 *  @name DataTable.defaults.ordering
	 *
	 *  @example
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "ordering": false
	 *      } );
	 *    } );
	 */
	"bSort": true,


	/**
	 * Enable or display DataTables' ability to sort multiple columns at the
	 * same time (activated by shift-click by the user).
	 *  @type boolean
	 *  @default true
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.orderMulti
	 *
	 *  @example
	 *    // Disable multiple column sorting ability
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "orderMulti": false
	 *      } );
	 *    } );
	 */
	"bSortMulti": true,


	/**
	 * Allows control over whether DataTables should use the top (true) unique
	 * cell that is found for a single column, or the bottom (false - default).
	 * This is useful when using complex headers.
	 *  @type boolean
	 *  @default false
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.orderCellsTop
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "orderCellsTop": true
	 *      } );
	 *    } );
	 */
	"bSortCellsTop": false,


	/**
	 * Enable or disable the addition of the classes `sorting\_1`, `sorting\_2` and
	 * `sorting\_3` to the columns which are currently being sorted on. This is
	 * presented as a feature switch as it can increase processing time (while
	 * classes are removed and added) so for large data sets you might want to
	 * turn this off.
	 *  @type boolean
	 *  @default true
	 *
	 *  @dtopt Features
	 *  @name DataTable.defaults.orderClasses
	 *
	 *  @example
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "orderClasses": false
	 *      } );
	 *    } );
	 */
	"bSortClasses": true,


	/**
	 * Enable or disable state saving. When enabled HTML5 `localStorage` will be
	 * used to save table display information such as pagination information,
	 * display length, filtering and sorting. As such when the end user reloads
	 * the page the display display will match what thy had previously set up.
	 *
	 * Due to the use of `localStorage` the default state saving is not supported
	 * in IE6 or 7. If state saving is required in those browsers, use
	 * `stateSaveCallback` to provide a storage solution such as cookies.
	 *  @type boolean
	 *  @default false
	 *
	 *  @dtopt Features
	 *  @name DataTable.defaults.stateSave
	 *
	 *  @example
	 *    $(document).ready( function () {
	 *      $('#example').dataTable( {
	 *        "stateSave": true
	 *      } );
	 *    } );
	 */
	"bStateSave": false,


	/**
	 * This function is called when a TR element is created (and all TD child
	 * elements have been inserted), or registered if using a DOM source, allowing
	 * manipulation of the TR element (adding classes etc).
	 *  @type function
	 *  @param {node} row "TR" element for the current row
	 *  @param {array} data Raw data array for this row
	 *  @param {int} dataIndex The index of this row in the internal aoData array
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.createdRow
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "createdRow": function( row, data, dataIndex ) {
	 *          // Bold the grade for all 'A' grade browsers
	 *          if ( data[4] == "A" )
	 *          {
	 *            $('td:eq(4)', row).html( '<b>A</b>' );
	 *          }
	 *        }
	 *      } );
	 *    } );
	 */
	"fnCreatedRow": null,


	/**
	 * This function is called on every 'draw' event, and allows you to
	 * dynamically modify any aspect you want about the created DOM.
	 *  @type function
	 *  @param {object} settings DataTables settings object
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.drawCallback
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "drawCallback": function( settings ) {
	 *          alert( 'DataTables has redrawn the table' );
	 *        }
	 *      } );
	 *    } );
	 */
	"fnDrawCallback": null,


	/**
	 * Identical to fnHeaderCallback() but for the table footer this function
	 * allows you to modify the table footer on every 'draw' event.
	 *  @type function
	 *  @param {node} foot "TR" element for the footer
	 *  @param {array} data Full table data (as derived from the original HTML)
	 *  @param {int} start Index for the current display starting point in the
	 *    display array
	 *  @param {int} end Index for the current display ending point in the
	 *    display array
	 *  @param {array int} display Index array to translate the visual position
	 *    to the full data array
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.footerCallback
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "footerCallback": function( tfoot, data, start, end, display ) {
	 *          tfoot.getElementsByTagName('th')[0].innerHTML = "Starting index is "+start;
	 *        }
	 *      } );
	 *    } )
	 */
	"fnFooterCallback": null,


	/**
	 * When rendering large numbers in the information element for the table
	 * (i.e. "Showing 1 to 10 of 57 entries") DataTables will render large numbers
	 * to have a comma separator for the 'thousands' units (e.g. 1 million is
	 * rendered as "1,000,000") to help readability for the end user. This
	 * function will override the default method DataTables uses.
	 *  @type function
	 *  @member
	 *  @param {int} toFormat number to be formatted
	 *  @returns {string} formatted string for DataTables to show the number
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.formatNumber
	 *
	 *  @example
	 *    // Format a number using a single quote for the separator (note that
	 *    // this can also be done with the language.thousands option)
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "formatNumber": function ( toFormat ) {
	 *          return toFormat.toString().replace(
	 *            /\B(?=(\d{3})+(?!\d))/g, "'"
	 *          );
	 *        };
	 *      } );
	 *    } );
	 */
	"fnFormatNumber": function ( toFormat ) {
		return toFormat.toString().replace(
			/\B(?=(\d{3})+(?!\d))/g,
			this.oLanguage.sThousands
		);
	},


	/**
	 * This function is called on every 'draw' event, and allows you to
	 * dynamically modify the header row. This can be used to calculate and
	 * display useful information about the table.
	 *  @type function
	 *  @param {node} head "TR" element for the header
	 *  @param {array} data Full table data (as derived from the original HTML)
	 *  @param {int} start Index for the current display starting point in the
	 *    display array
	 *  @param {int} end Index for the current display ending point in the
	 *    display array
	 *  @param {array int} display Index array to translate the visual position
	 *    to the full data array
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.headerCallback
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "fheaderCallback": function( head, data, start, end, display ) {
	 *          head.getElementsByTagName('th')[0].innerHTML = "Displaying "+(end-start)+" records";
	 *        }
	 *      } );
	 *    } )
	 */
	"fnHeaderCallback": null,


	/**
	 * The information element can be used to convey information about the current
	 * state of the table. Although the internationalisation options presented by
	 * DataTables are quite capable of dealing with most customisations, there may
	 * be times where you wish to customise the string further. This callback
	 * allows you to do exactly that.
	 *  @type function
	 *  @param {object} oSettings DataTables settings object
	 *  @param {int} start Starting position in data for the draw
	 *  @param {int} end End position in data for the draw
	 *  @param {int} max Total number of rows in the table (regardless of
	 *    filtering)
	 *  @param {int} total Total number of rows in the data set, after filtering
	 *  @param {string} pre The string that DataTables has formatted using it's
	 *    own rules
	 *  @returns {string} The string to be displayed in the information element.
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.infoCallback
	 *
	 *  @example
	 *    $('#example').dataTable( {
	 *      "infoCallback": function( settings, start, end, max, total, pre ) {
	 *        return start +" to "+ end;
	 *      }
	 *    } );
	 */
	"fnInfoCallback": null,


	/**
	 * Called when the table has been initialised. Normally DataTables will
	 * initialise sequentially and there will be no need for this function,
	 * however, this does not hold true when using external language information
	 * since that is obtained using an async XHR call.
	 *  @type function
	 *  @param {object} settings DataTables settings object
	 *  @param {object} json The JSON object request from the server - only
	 *    present if client-side Ajax sourced data is used
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.initComplete
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "initComplete": function(settings, json) {
	 *          alert( 'DataTables has finished its initialisation.' );
	 *        }
	 *      } );
	 *    } )
	 */
	"fnInitComplete": null,


	/**
	 * Called at the very start of each table draw and can be used to cancel the
	 * draw by returning false, any other return (including undefined) results in
	 * the full draw occurring).
	 *  @type function
	 *  @param {object} settings DataTables settings object
	 *  @returns {boolean} False will cancel the draw, anything else (including no
	 *    return) will allow it to complete.
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.preDrawCallback
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "preDrawCallback": function( settings ) {
	 *          if ( $('#test').val() == 1 ) {
	 *            return false;
	 *          }
	 *        }
	 *      } );
	 *    } );
	 */
	"fnPreDrawCallback": null,


	/**
	 * This function allows you to 'post process' each row after it have been
	 * generated for each table draw, but before it is rendered on screen. This
	 * function might be used for setting the row class name etc.
	 *  @type function
	 *  @param {node} row "TR" element for the current row
	 *  @param {array} data Raw data array for this row
	 *  @param {int} displayIndex The display index for the current table draw
	 *  @param {int} displayIndexFull The index of the data in the full list of
	 *    rows (after filtering)
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.rowCallback
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "rowCallback": function( row, data, displayIndex, displayIndexFull ) {
	 *          // Bold the grade for all 'A' grade browsers
	 *          if ( data[4] == "A" ) {
	 *            $('td:eq(4)', row).html( '<b>A</b>' );
	 *          }
	 *        }
	 *      } );
	 *    } );
	 */
	"fnRowCallback": null,


	/**
	 * __Deprecated__ The functionality provided by this parameter has now been
	 * superseded by that provided through `ajax`, which should be used instead.
	 *
	 * This parameter allows you to override the default function which obtains
	 * the data from the server so something more suitable for your application.
	 * For example you could use POST data, or pull information from a Gears or
	 * AIR database.
	 *  @type function
	 *  @member
	 *  @param {string} source HTTP source to obtain the data from (`ajax`)
	 *  @param {array} data A key/value pair object containing the data to send
	 *    to the server
	 *  @param {function} callback to be called on completion of the data get
	 *    process that will draw the data on the page.
	 *  @param {object} settings DataTables settings object
	 *
	 *  @dtopt Callbacks
	 *  @dtopt Server-side
	 *  @name DataTable.defaults.serverData
	 *
	 *  @deprecated 1.10. Please use `ajax` for this functionality now.
	 */
	"fnServerData": null,


	/**
	 * __Deprecated__ The functionality provided by this parameter has now been
	 * superseded by that provided through `ajax`, which should be used instead.
	 *
	 *  It is often useful to send extra data to the server when making an Ajax
	 * request - for example custom filtering information, and this callback
	 * function makes it trivial to send extra information to the server. The
	 * passed in parameter is the data set that has been constructed by
	 * DataTables, and you can add to this or modify it as you require.
	 *  @type function
	 *  @param {array} data Data array (array of objects which are name/value
	 *    pairs) that has been constructed by DataTables and will be sent to the
	 *    server. In the case of Ajax sourced data with server-side processing
	 *    this will be an empty array, for server-side processing there will be a
	 *    significant number of parameters!
	 *  @returns {undefined} Ensure that you modify the data array passed in,
	 *    as this is passed by reference.
	 *
	 *  @dtopt Callbacks
	 *  @dtopt Server-side
	 *  @name DataTable.defaults.serverParams
	 *
	 *  @deprecated 1.10. Please use `ajax` for this functionality now.
	 */
	"fnServerParams": null,


	/**
	 * Load the table state. With this function you can define from where, and how, the
	 * state of a table is loaded. By default DataTables will load from `localStorage`
	 * but you might wish to use a server-side database or cookies.
	 *  @type function
	 *  @member
	 *  @param {object} settings DataTables settings object
	 *  @param {object} callback Callback that can be executed when done. It
	 *    should be passed the loaded state object.
	 *  @return {object} The DataTables state object to be loaded
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.stateLoadCallback
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "stateSave": true,
	 *        "stateLoadCallback": function (settings, callback) {
	 *          $.ajax( {
	 *            "url": "/state_load",
	 *            "dataType": "json",
	 *            "success": function (json) {
	 *              callback( json );
	 *            }
	 *          } );
	 *        }
	 *      } );
	 *    } );
	 */
	"fnStateLoadCallback": function ( settings ) {
		try {
			return JSON.parse(
				(settings.iStateDuration === -1 ? sessionStorage : localStorage).getItem(
					'DataTables_'+settings.sInstance+'_'+location.pathname
				)
			);
		} catch (e) {
			return {};
		}
	},


	/**
	 * Callback which allows modification of the saved state prior to loading that state.
	 * This callback is called when the table is loading state from the stored data, but
	 * prior to the settings object being modified by the saved state. Note that for
	 * plug-in authors, you should use the `stateLoadParams` event to load parameters for
	 * a plug-in.
	 *  @type function
	 *  @param {object} settings DataTables settings object
	 *  @param {object} data The state object that is to be loaded
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.stateLoadParams
	 *
	 *  @example
	 *    // Remove a saved filter, so filtering is never loaded
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "stateSave": true,
	 *        "stateLoadParams": function (settings, data) {
	 *          data.oSearch.sSearch = "";
	 *        }
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Disallow state loading by returning false
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "stateSave": true,
	 *        "stateLoadParams": function (settings, data) {
	 *          return false;
	 *        }
	 *      } );
	 *    } );
	 */
	"fnStateLoadParams": null,


	/**
	 * Callback that is called when the state has been loaded from the state saving method
	 * and the DataTables settings object has been modified as a result of the loaded state.
	 *  @type function
	 *  @param {object} settings DataTables settings object
	 *  @param {object} data The state object that was loaded
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.stateLoaded
	 *
	 *  @example
	 *    // Show an alert with the filtering value that was saved
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "stateSave": true,
	 *        "stateLoaded": function (settings, data) {
	 *          alert( 'Saved filter was: '+data.oSearch.sSearch );
	 *        }
	 *      } );
	 *    } );
	 */
	"fnStateLoaded": null,


	/**
	 * Save the table state. This function allows you to define where and how the state
	 * information for the table is stored By default DataTables will use `localStorage`
	 * but you might wish to use a server-side database or cookies.
	 *  @type function
	 *  @member
	 *  @param {object} settings DataTables settings object
	 *  @param {object} data The state object to be saved
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.stateSaveCallback
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "stateSave": true,
	 *        "stateSaveCallback": function (settings, data) {
	 *          // Send an Ajax request to the server with the state object
	 *          $.ajax( {
	 *            "url": "/state_save",
	 *            "data": data,
	 *            "dataType": "json",
	 *            "method": "POST"
	 *            "success": function () {}
	 *          } );
	 *        }
	 *      } );
	 *    } );
	 */
	"fnStateSaveCallback": function ( settings, data ) {
		try {
			(settings.iStateDuration === -1 ? sessionStorage : localStorage).setItem(
				'DataTables_'+settings.sInstance+'_'+location.pathname,
				JSON.stringify( data )
			);
		} catch (e) {}
	},


	/**
	 * Callback which allows modification of the state to be saved. Called when the table
	 * has changed state a new state save is required. This method allows modification of
	 * the state saving object prior to actually doing the save, including addition or
	 * other state properties or modification. Note that for plug-in authors, you should
	 * use the `stateSaveParams` event to save parameters for a plug-in.
	 *  @type function
	 *  @param {object} settings DataTables settings object
	 *  @param {object} data The state object to be saved
	 *
	 *  @dtopt Callbacks
	 *  @name DataTable.defaults.stateSaveParams
	 *
	 *  @example
	 *    // Remove a saved filter, so filtering is never saved
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "stateSave": true,
	 *        "stateSaveParams": function (settings, data) {
	 *          data.oSearch.sSearch = "";
	 *        }
	 *      } );
	 *    } );
	 */
	"fnStateSaveParams": null,


	/**
	 * Duration for which the saved state information is considered valid. After this period
	 * has elapsed the state will be returned to the default.
	 * Value is given in seconds.
	 *  @type int
	 *  @default 7200 <i>(2 hours)</i>
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.stateDuration
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "stateDuration": 60*60*24; // 1 day
	 *      } );
	 *    } )
	 */
	"iStateDuration": 7200,


	/**
	 * When enabled DataTables will not make a request to the server for the first
	 * page draw - rather it will use the data already on the page (no sorting etc
	 * will be applied to it), thus saving on an XHR at load time. `deferLoading`
	 * is used to indicate that deferred loading is required, but it is also used
	 * to tell DataTables how many records there are in the full table (allowing
	 * the information element and pagination to be displayed correctly). In the case
	 * where a filtering is applied to the table on initial load, this can be
	 * indicated by giving the parameter as an array, where the first element is
	 * the number of records available after filtering and the second element is the
	 * number of records without filtering (allowing the table information element
	 * to be shown correctly).
	 *  @type int | array
	 *  @default null
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.deferLoading
	 *
	 *  @example
	 *    // 57 records available in the table, no filtering applied
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "serverSide": true,
	 *        "ajax": "scripts/server_processing.php",
	 *        "deferLoading": 57
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // 57 records after filtering, 100 without filtering (an initial filter applied)
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "serverSide": true,
	 *        "ajax": "scripts/server_processing.php",
	 *        "deferLoading": [ 57, 100 ],
	 *        "search": {
	 *          "search": "my_filter"
	 *        }
	 *      } );
	 *    } );
	 */
	"iDeferLoading": null,


	/**
	 * Number of rows to display on a single page when using pagination. If
	 * feature enabled (`lengthChange`) then the end user will be able to override
	 * this to a custom setting using a pop-up menu.
	 *  @type int
	 *  @default 10
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.pageLength
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "pageLength": 50
	 *      } );
	 *    } )
	 */
	"iDisplayLength": 10,


	/**
	 * Define the starting point for data display when using DataTables with
	 * pagination. Note that this parameter is the number of records, rather than
	 * the page number, so if you have 10 records per page and want to start on
	 * the third page, it should be "20".
	 *  @type int
	 *  @default 0
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.displayStart
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "displayStart": 20
	 *      } );
	 *    } )
	 */
	"iDisplayStart": 0,


	/**
	 * By default DataTables allows keyboard navigation of the table (sorting, paging,
	 * and filtering) by adding a `tabindex` attribute to the required elements. This
	 * allows you to tab through the controls and press the enter key to activate them.
	 * The tabindex is default 0, meaning that the tab follows the flow of the document.
	 * You can overrule this using this parameter if you wish. Use a value of -1 to
	 * disable built-in keyboard navigation.
	 *  @type int
	 *  @default 0
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.tabIndex
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "tabIndex": 1
	 *      } );
	 *    } );
	 */
	"iTabIndex": 0,


	/**
	 * Classes that DataTables assigns to the various components and features
	 * that it adds to the HTML table. This allows classes to be configured
	 * during initialisation in addition to through the static
	 * {@link DataTable.ext.oStdClasses} object).
	 *  @namespace
	 *  @name DataTable.defaults.classes
	 */
	"oClasses": {},


	/**
	 * All strings that DataTables uses in the user interface that it creates
	 * are defined in this object, allowing you to modified them individually or
	 * completely replace them all as required.
	 *  @namespace
	 *  @name DataTable.defaults.language
	 */
	"oLanguage": {
		/**
		 * Strings that are used for WAI-ARIA labels and controls only (these are not
		 * actually visible on the page, but will be read by screenreaders, and thus
		 * must be internationalised as well).
		 *  @namespace
		 *  @name DataTable.defaults.language.aria
		 */
		"oAria": {
			/**
			 * ARIA label that is added to the table headers when the column may be
			 * sorted ascending by activing the column (click or return when focused).
			 * Note that the column header is prefixed to this string.
			 *  @type string
			 *  @default : activate to sort column ascending
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.aria.sortAscending
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "aria": {
			 *            "sortAscending": " - click/return to sort ascending"
			 *          }
			 *        }
			 *      } );
			 *    } );
			 */
			"sSortAscending": ": activate to sort column ascending",

			/**
			 * ARIA label that is added to the table headers when the column may be
			 * sorted descending by activing the column (click or return when focused).
			 * Note that the column header is prefixed to this string.
			 *  @type string
			 *  @default : activate to sort column ascending
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.aria.sortDescending
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "aria": {
			 *            "sortDescending": " - click/return to sort descending"
			 *          }
			 *        }
			 *      } );
			 *    } );
			 */
			"sSortDescending": ": activate to sort column descending"
		},

		/**
		 * Pagination string used by DataTables for the built-in pagination
		 * control types.
		 *  @namespace
		 *  @name DataTable.defaults.language.paginate
		 */
		"oPaginate": {
			/**
			 * Text to use when using the 'full_numbers' type of pagination for the
			 * button to take the user to the first page.
			 *  @type string
			 *  @default First
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.paginate.first
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "paginate": {
			 *            "first": "First page"
			 *          }
			 *        }
			 *      } );
			 *    } );
			 */
			"sFirst": "First",


			/**
			 * Text to use when using the 'full_numbers' type of pagination for the
			 * button to take the user to the last page.
			 *  @type string
			 *  @default Last
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.paginate.last
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "paginate": {
			 *            "last": "Last page"
			 *          }
			 *        }
			 *      } );
			 *    } );
			 */
			"sLast": "Last",


			/**
			 * Text to use for the 'next' pagination button (to take the user to the
			 * next page).
			 *  @type string
			 *  @default Next
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.paginate.next
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "paginate": {
			 *            "next": "Next page"
			 *          }
			 *        }
			 *      } );
			 *    } );
			 */
			"sNext": "Next",


			/**
			 * Text to use for the 'previous' pagination button (to take the user to
			 * the previous page).
			 *  @type string
			 *  @default Previous
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.paginate.previous
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "paginate": {
			 *            "previous": "Previous page"
			 *          }
			 *        }
			 *      } );
			 *    } );
			 */
			"sPrevious": "Previous"
		},

		/**
		 * This string is shown in preference to `zeroRecords` when the table is
		 * empty of data (regardless of filtering). Note that this is an optional
		 * parameter - if it is not given, the value of `zeroRecords` will be used
		 * instead (either the default or given value).
		 *  @type string
		 *  @default No data available in table
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.emptyTable
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "emptyTable": "No data available in table"
		 *        }
		 *      } );
		 *    } );
		 */
		"sEmptyTable": "No data available in table",


		/**
		 * This string gives information to the end user about the information
		 * that is current on display on the page. The following tokens can be
		 * used in the string and will be dynamically replaced as the table
		 * display updates. This tokens can be placed anywhere in the string, or
		 * removed as needed by the language requires:
		 *
		 * * `\_START\_` - Display index of the first record on the current page
		 * * `\_END\_` - Display index of the last record on the current page
		 * * `\_TOTAL\_` - Number of records in the table after filtering
		 * * `\_MAX\_` - Number of records in the table without filtering
		 * * `\_PAGE\_` - Current page number
		 * * `\_PAGES\_` - Total number of pages of data in the table
		 *
		 *  @type string
		 *  @default Showing _START_ to _END_ of _TOTAL_ entries
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.info
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "info": "Showing page _PAGE_ of _PAGES_"
		 *        }
		 *      } );
		 *    } );
		 */
		"sInfo": "Showing _START_ to _END_ of _TOTAL_ entries",


		/**
		 * Display information string for when the table is empty. Typically the
		 * format of this string should match `info`.
		 *  @type string
		 *  @default Showing 0 to 0 of 0 entries
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.infoEmpty
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "infoEmpty": "No entries to show"
		 *        }
		 *      } );
		 *    } );
		 */
		"sInfoEmpty": "Showing 0 to 0 of 0 entries",


		/**
		 * When a user filters the information in a table, this string is appended
		 * to the information (`info`) to give an idea of how strong the filtering
		 * is. The variable _MAX_ is dynamically updated.
		 *  @type string
		 *  @default (filtered from _MAX_ total entries)
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.infoFiltered
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "infoFiltered": " - filtering from _MAX_ records"
		 *        }
		 *      } );
		 *    } );
		 */
		"sInfoFiltered": "(filtered from _MAX_ total entries)",


		/**
		 * If can be useful to append extra information to the info string at times,
		 * and this variable does exactly that. This information will be appended to
		 * the `info` (`infoEmpty` and `infoFiltered` in whatever combination they are
		 * being used) at all times.
		 *  @type string
		 *  @default <i>Empty string</i>
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.infoPostFix
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "infoPostFix": "All records shown are derived from real information."
		 *        }
		 *      } );
		 *    } );
		 */
		"sInfoPostFix": "",


		/**
		 * This decimal place operator is a little different from the other
		 * language options since DataTables doesn't output floating point
		 * numbers, so it won't ever use this for display of a number. Rather,
		 * what this parameter does is modify the sort methods of the table so
		 * that numbers which are in a format which has a character other than
		 * a period (`.`) as a decimal place will be sorted numerically.
		 *
		 * Note that numbers with different decimal places cannot be shown in
		 * the same table and still be sortable, the table must be consistent.
		 * However, multiple different tables on the page can use different
		 * decimal place characters.
		 *  @type string
		 *  @default 
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.decimal
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "decimal": ","
		 *          "thousands": "."
		 *        }
		 *      } );
		 *    } );
		 */
		"sDecimal": "",


		/**
		 * DataTables has a build in number formatter (`formatNumber`) which is
		 * used to format large numbers that are used in the table information.
		 * By default a comma is used, but this can be trivially changed to any
		 * character you wish with this parameter.
		 *  @type string
		 *  @default ,
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.thousands
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "thousands": "'"
		 *        }
		 *      } );
		 *    } );
		 */
		"sThousands": ",",


		/**
		 * Detail the action that will be taken when the drop down menu for the
		 * pagination length option is changed. The '_MENU_' variable is replaced
		 * with a default select list of 10, 25, 50 and 100, and can be replaced
		 * with a custom select box if required.
		 *  @type string
		 *  @default Show _MENU_ entries
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.lengthMenu
		 *
		 *  @example
		 *    // Language change only
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "lengthMenu": "Display _MENU_ records"
		 *        }
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Language and options change
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "lengthMenu": 'Display <select>'+
		 *            '<option value="10">10</option>'+
		 *            '<option value="20">20</option>'+
		 *            '<option value="30">30</option>'+
		 *            '<option value="40">40</option>'+
		 *            '<option value="50">50</option>'+
		 *            '<option value="-1">All</option>'+
		 *            '</select> records'
		 *        }
		 *      } );
		 *    } );
		 */
		"sLengthMenu": "Show _MENU_ entries",


		/**
		 * When using Ajax sourced data and during the first draw when DataTables is
		 * gathering the data, this message is shown in an empty row in the table to
		 * indicate to the end user the the data is being loaded. Note that this
		 * parameter is not used when loading data by server-side processing, just
		 * Ajax sourced data with client-side processing.
		 *  @type string
		 *  @default Loading...
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.loadingRecords
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "loadingRecords": "Please wait - loading..."
		 *        }
		 *      } );
		 *    } );
		 */
		"sLoadingRecords": "Loading...",


		/**
		 * Text which is displayed when the table is processing a user action
		 * (usually a sort command or similar).
		 *  @type string
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.processing
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "processing": "DataTables is currently busy"
		 *        }
		 *      } );
		 *    } );
		 */
		"sProcessing": "",


		/**
		 * Details the actions that will be taken when the user types into the
		 * filtering input text box. The variable "_INPUT_", if used in the string,
		 * is replaced with the HTML text box for the filtering input allowing
		 * control over where it appears in the string. If "_INPUT_" is not given
		 * then the input box is appended to the string automatically.
		 *  @type string
		 *  @default Search:
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.search
		 *
		 *  @example
		 *    // Input text box will be appended at the end automatically
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "search": "Filter records:"
		 *        }
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Specify where the filter should appear
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "search": "Apply filter _INPUT_ to table"
		 *        }
		 *      } );
		 *    } );
		 */
		"sSearch": "Search:",


		/**
		 * Assign a `placeholder` attribute to the search `input` element
		 *  @type string
		 *  @default 
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.searchPlaceholder
		 */
		"sSearchPlaceholder": "",


		/**
		 * All of the language information can be stored in a file on the
		 * server-side, which DataTables will look up if this parameter is passed.
		 * It must store the URL of the language file, which is in a JSON format,
		 * and the object has the same properties as the oLanguage object in the
		 * initialiser object (i.e. the above parameters). Please refer to one of
		 * the example language files to see how this works in action.
		 *  @type string
		 *  @default <i>Empty string - i.e. disabled</i>
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.url
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "url": "http://www.sprymedia.co.uk/dataTables/lang.txt"
		 *        }
		 *      } );
		 *    } );
		 */
		"sUrl": "",


		/**
		 * Text shown inside the table records when the is no information to be
		 * displayed after filtering. `emptyTable` is shown when there is simply no
		 * information in the table at all (regardless of filtering).
		 *  @type string
		 *  @default No matching records found
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.zeroRecords
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "language": {
		 *          "zeroRecords": "No records to display"
		 *        }
		 *      } );
		 *    } );
		 */
		"sZeroRecords": "No matching records found"
	},


	/**
	 * This parameter allows you to have define the global filtering state at
	 * initialisation time. As an object the `search` parameter must be
	 * defined, but all other parameters are optional. When `regex` is true,
	 * the search string will be treated as a regular expression, when false
	 * (default) it will be treated as a straight string. When `smart`
	 * DataTables will use it's smart filtering methods (to word match at
	 * any point in the data), when false this will not be done.
	 *  @namespace
	 *  @extends DataTable.models.oSearch
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.search
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "search": {"search": "Initial search"}
	 *      } );
	 *    } )
	 */
	"oSearch": $.extend( {}, DataTable.models.oSearch ),


	/**
	 * __Deprecated__ The functionality provided by this parameter has now been
	 * superseded by that provided through `ajax`, which should be used instead.
	 *
	 * By default DataTables will look for the property `data` (or `aaData` for
	 * compatibility with DataTables 1.9-) when obtaining data from an Ajax
	 * source or for server-side processing - this parameter allows that
	 * property to be changed. You can use Javascript dotted object notation to
	 * get a data source for multiple levels of nesting.
	 *  @type string
	 *  @default data
	 *
	 *  @dtopt Options
	 *  @dtopt Server-side
	 *  @name DataTable.defaults.ajaxDataProp
	 *
	 *  @deprecated 1.10. Please use `ajax` for this functionality now.
	 */
	"sAjaxDataProp": "data",


	/**
	 * __Deprecated__ The functionality provided by this parameter has now been
	 * superseded by that provided through `ajax`, which should be used instead.
	 *
	 * You can instruct DataTables to load data from an external
	 * source using this parameter (use aData if you want to pass data in you
	 * already have). Simply provide a url a JSON object can be obtained from.
	 *  @type string
	 *  @default null
	 *
	 *  @dtopt Options
	 *  @dtopt Server-side
	 *  @name DataTable.defaults.ajaxSource
	 *
	 *  @deprecated 1.10. Please use `ajax` for this functionality now.
	 */
	"sAjaxSource": null,


	/**
	 * This initialisation variable allows you to specify exactly where in the
	 * DOM you want DataTables to inject the various controls it adds to the page
	 * (for example you might want the pagination controls at the top of the
	 * table). DIV elements (with or without a custom class) can also be added to
	 * aid styling. The follow syntax is used:
	 *   <ul>
	 *     <li>The following options are allowed:
	 *       <ul>
	 *         <li>'l' - Length changing</li>
	 *         <li>'f' - Filtering input</li>
	 *         <li>'t' - The table!</li>
	 *         <li>'i' - Information</li>
	 *         <li>'p' - Pagination</li>
	 *         <li>'r' - pRocessing</li>
	 *       </ul>
	 *     </li>
	 *     <li>The following constants are allowed:
	 *       <ul>
	 *         <li>'H' - jQueryUI theme "header" classes ('fg-toolbar ui-widget-header ui-corner-tl ui-corner-tr ui-helper-clearfix')</li>
	 *         <li>'F' - jQueryUI theme "footer" classes ('fg-toolbar ui-widget-header ui-corner-bl ui-corner-br ui-helper-clearfix')</li>
	 *       </ul>
	 *     </li>
	 *     <li>The following syntax is expected:
	 *       <ul>
	 *         <li>'&lt;' and '&gt;' - div elements</li>
	 *         <li>'&lt;"class" and '&gt;' - div with a class</li>
	 *         <li>'&lt;"#id" and '&gt;' - div with an ID</li>
	 *       </ul>
	 *     </li>
	 *     <li>Examples:
	 *       <ul>
	 *         <li>'&lt;"wrapper"flipt&gt;'</li>
	 *         <li>'&lt;lf&lt;t&gt;ip&gt;'</li>
	 *       </ul>
	 *     </li>
	 *   </ul>
	 *  @type string
	 *  @default lfrtip <i>(when `jQueryUI` is false)</i> <b>or</b>
	 *    <"H"lfr>t<"F"ip> <i>(when `jQueryUI` is true)</i>
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.dom
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "dom": '&lt;"top"i&gt;rt&lt;"bottom"flp&gt;&lt;"clear"&gt;'
	 *      } );
	 *    } );
	 */
	"sDom": "lfrtip",


	/**
	 * Search delay option. This will throttle full table searches that use the
	 * DataTables provided search input element (it does not effect calls to
	 * `dt-api search()`, providing a delay before the search is made.
	 *  @type integer
	 *  @default 0
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.searchDelay
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "searchDelay": 200
	 *      } );
	 *    } )
	 */
	"searchDelay": null,


	/**
	 * DataTables features six different built-in options for the buttons to
	 * display for pagination control:
	 *
	 * * `numbers` - Page number buttons only
	 * * `simple` - 'Previous' and 'Next' buttons only
	 * * 'simple_numbers` - 'Previous' and 'Next' buttons, plus page numbers
	 * * `full` - 'First', 'Previous', 'Next' and 'Last' buttons
	 * * `full_numbers` - 'First', 'Previous', 'Next' and 'Last' buttons, plus page numbers
	 * * `first_last_numbers` - 'First' and 'Last' buttons, plus page numbers
	 *  
	 * Further methods can be added using {@link DataTable.ext.oPagination}.
	 *  @type string
	 *  @default simple_numbers
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.pagingType
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "pagingType": "full_numbers"
	 *      } );
	 *    } )
	 */
	"sPaginationType": "simple_numbers",


	/**
	 * Enable horizontal scrolling. When a table is too wide to fit into a
	 * certain layout, or you have a large number of columns in the table, you
	 * can enable x-scrolling to show the table in a viewport, which can be
	 * scrolled. This property can be `true` which will allow the table to
	 * scroll horizontally when needed, or any CSS unit, or a number (in which
	 * case it will be treated as a pixel measurement). Setting as simply `true`
	 * is recommended.
	 *  @type boolean|string
	 *  @default <i>blank string - i.e. disabled</i>
	 *
	 *  @dtopt Features
	 *  @name DataTable.defaults.scrollX
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "scrollX": true,
	 *        "scrollCollapse": true
	 *      } );
	 *    } );
	 */
	"sScrollX": "",


	/**
	 * This property can be used to force a DataTable to use more width than it
	 * might otherwise do when x-scrolling is enabled. For example if you have a
	 * table which requires to be well spaced, this parameter is useful for
	 * "over-sizing" the table, and thus forcing scrolling. This property can by
	 * any CSS unit, or a number (in which case it will be treated as a pixel
	 * measurement).
	 *  @type string
	 *  @default <i>blank string - i.e. disabled</i>
	 *
	 *  @dtopt Options
	 *  @name DataTable.defaults.scrollXInner
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "scrollX": "100%",
	 *        "scrollXInner": "110%"
	 *      } );
	 *    } );
	 */
	"sScrollXInner": "",


	/**
	 * Enable vertical scrolling. Vertical scrolling will constrain the DataTable
	 * to the given height, and enable scrolling for any data which overflows the
	 * current viewport. This can be used as an alternative to paging to display
	 * a lot of data in a small area (although paging and scrolling can both be
	 * enabled at the same time). This property can be any CSS unit, or a number
	 * (in which case it will be treated as a pixel measurement).
	 *  @type string
	 *  @default <i>blank string - i.e. disabled</i>
	 *
	 *  @dtopt Features
	 *  @name DataTable.defaults.scrollY
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "scrollY": "200px",
	 *        "paginate": false
	 *      } );
	 *    } );
	 */
	"sScrollY": "",


	/**
	 * __Deprecated__ The functionality provided by this parameter has now been
	 * superseded by that provided through `ajax`, which should be used instead.
	 *
	 * Set the HTTP method that is used to make the Ajax call for server-side
	 * processing or Ajax sourced data.
	 *  @type string
	 *  @default GET
	 *
	 *  @dtopt Options
	 *  @dtopt Server-side
	 *  @name DataTable.defaults.serverMethod
	 *
	 *  @deprecated 1.10. Please use `ajax` for this functionality now.
	 */
	"sServerMethod": "GET",


	/**
	 * DataTables makes use of renderers when displaying HTML elements for
	 * a table. These renderers can be added or modified by plug-ins to
	 * generate suitable mark-up for a site. For example the Bootstrap
	 * integration plug-in for DataTables uses a paging button renderer to
	 * display pagination buttons in the mark-up required by Bootstrap.
	 *
	 * For further information about the renderers available see
	 * DataTable.ext.renderer
	 *  @type string|object
	 *  @default null
	 *
	 *  @name DataTable.defaults.renderer
	 *
	 */
	"renderer": null,


	/**
	 * Set the data property name that DataTables should use to get a row's id
	 * to set as the `id` property in the node.
	 *  @type string
	 *  @default DT_RowId
	 *
	 *  @name DataTable.defaults.rowId
	 */
	"rowId": "DT_RowId"
};

_fnHungarianMap( DataTable.defaults );



/*
 * Developer note - See note in model.defaults.js about the use of Hungarian
 * notation and camel case.
 */

/**
 * Column options that can be given to DataTables at initialisation time.
 *  @namespace
 */
DataTable.defaults.column = {
	/**
	 * Define which column(s) an order will occur on for this column. This
	 * allows a column's ordering to take multiple columns into account when
	 * doing a sort or use the data from a different column. For example first
	 * name / last name columns make sense to do a multi-column sort over the
	 * two columns.
	 *  @type array|int
	 *  @default null <i>Takes the value of the column index automatically</i>
	 *
	 *  @name DataTable.defaults.column.orderData
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columnDefs`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [
	 *          { "orderData": [ 0, 1 ], "targets": [ 0 ] },
	 *          { "orderData": [ 1, 0 ], "targets": [ 1 ] },
	 *          { "orderData": 2, "targets": [ 2 ] }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          { "orderData": [ 0, 1 ] },
	 *          { "orderData": [ 1, 0 ] },
	 *          { "orderData": 2 },
	 *          null,
	 *          null
	 *        ]
	 *      } );
	 *    } );
	 */
	"aDataSort": null,
	"iDataSort": -1,


	/**
	 * You can control the default ordering direction, and even alter the
	 * behaviour of the sort handler (i.e. only allow ascending ordering etc)
	 * using this parameter.
	 *  @type array
	 *  @default [ 'asc', 'desc' ]
	 *
	 *  @name DataTable.defaults.column.orderSequence
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columnDefs`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [
	 *          { "orderSequence": [ "asc" ], "targets": [ 1 ] },
	 *          { "orderSequence": [ "desc", "asc", "asc" ], "targets": [ 2 ] },
	 *          { "orderSequence": [ "desc" ], "targets": [ 3 ] }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          null,
	 *          { "orderSequence": [ "asc" ] },
	 *          { "orderSequence": [ "desc", "asc", "asc" ] },
	 *          { "orderSequence": [ "desc" ] },
	 *          null
	 *        ]
	 *      } );
	 *    } );
	 */
	"asSorting": [ 'asc', 'desc' ],


	/**
	 * Enable or disable filtering on the data in this column.
	 *  @type boolean
	 *  @default true
	 *
	 *  @name DataTable.defaults.column.searchable
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columnDefs`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [
	 *          { "searchable": false, "targets": [ 0 ] }
	 *        ] } );
	 *    } );
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          { "searchable": false },
	 *          null,
	 *          null,
	 *          null,
	 *          null
	 *        ] } );
	 *    } );
	 */
	"bSearchable": true,


	/**
	 * Enable or disable ordering on this column.
	 *  @type boolean
	 *  @default true
	 *
	 *  @name DataTable.defaults.column.orderable
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columnDefs`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [
	 *          { "orderable": false, "targets": [ 0 ] }
	 *        ] } );
	 *    } );
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          { "orderable": false },
	 *          null,
	 *          null,
	 *          null,
	 *          null
	 *        ] } );
	 *    } );
	 */
	"bSortable": true,


	/**
	 * Enable or disable the display of this column.
	 *  @type boolean
	 *  @default true
	 *
	 *  @name DataTable.defaults.column.visible
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columnDefs`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [
	 *          { "visible": false, "targets": [ 0 ] }
	 *        ] } );
	 *    } );
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          { "visible": false },
	 *          null,
	 *          null,
	 *          null,
	 *          null
	 *        ] } );
	 *    } );
	 */
	"bVisible": true,


	/**
	 * Developer definable function that is called whenever a cell is created (Ajax source,
	 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
	 * allowing you to modify the DOM element (add background colour for example) when the
	 * element is available.
	 *  @type function
	 *  @param {element} td The TD node that has been created
	 *  @param {*} cellData The Data for the cell
	 *  @param {array|object} rowData The data for the whole row
	 *  @param {int} row The row index for the aoData data store
	 *  @param {int} col The column index for aoColumns
	 *
	 *  @name DataTable.defaults.column.createdCell
	 *  @dtopt Columns
	 *
	 *  @example
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [ {
	 *          "targets": [3],
	 *          "createdCell": function (td, cellData, rowData, row, col) {
	 *            if ( cellData == "1.7" ) {
	 *              $(td).css('color', 'blue')
	 *            }
	 *          }
	 *        } ]
	 *      });
	 *    } );
	 */
	"fnCreatedCell": null,


	/**
	 * This parameter has been replaced by `data` in DataTables to ensure naming
	 * consistency. `dataProp` can still be used, as there is backwards
	 * compatibility in DataTables for this option, but it is strongly
	 * recommended that you use `data` in preference to `dataProp`.
	 *  @name DataTable.defaults.column.dataProp
	 */


	/**
	 * This property can be used to read data from any data source property,
	 * including deeply nested objects / properties. `data` can be given in a
	 * number of different ways which effect its behaviour:
	 *
	 * * `integer` - treated as an array index for the data source. This is the
	 *   default that DataTables uses (incrementally increased for each column).
	 * * `string` - read an object property from the data source. There are
	 *   three 'special' options that can be used in the string to alter how
	 *   DataTables reads the data from the source object:
	 *    * `.` - Dotted Javascript notation. Just as you use a `.` in
	 *      Javascript to read from nested objects, so to can the options
	 *      specified in `data`. For example: `browser.version` or
	 *      `browser.name`. If your object parameter name contains a period, use
	 *      `\\` to escape it - i.e. `first\\.name`.
	 *    * `[]` - Array notation. DataTables can automatically combine data
	 *      from and array source, joining the data with the characters provided
	 *      between the two brackets. For example: `name[, ]` would provide a
	 *      comma-space separated list from the source array. If no characters
	 *      are provided between the brackets, the original array source is
	 *      returned.
	 *    * `()` - Function notation. Adding `()` to the end of a parameter will
	 *      execute a function of the name given. For example: `browser()` for a
	 *      simple function on the data source, `browser.version()` for a
	 *      function in a nested property or even `browser().version` to get an
	 *      object property if the function called returns an object. Note that
	 *      function notation is recommended for use in `render` rather than
	 *      `data` as it is much simpler to use as a renderer.
	 * * `null` - use the original data source for the row rather than plucking
	 *   data directly from it. This action has effects on two other
	 *   initialisation options:
	 *    * `defaultContent` - When null is given as the `data` option and
	 *      `defaultContent` is specified for the column, the value defined by
	 *      `defaultContent` will be used for the cell.
	 *    * `render` - When null is used for the `data` option and the `render`
	 *      option is specified for the column, the whole data source for the
	 *      row is used for the renderer.
	 * * `function` - the function given will be executed whenever DataTables
	 *   needs to set or get the data for a cell in the column. The function
	 *   takes three parameters:
	 *    * Parameters:
	 *      * `{array|object}` The data source for the row
	 *      * `{string}` The type call data requested - this will be 'set' when
	 *        setting data or 'filter', 'display', 'type', 'sort' or undefined
	 *        when gathering data. Note that when `undefined` is given for the
	 *        type DataTables expects to get the raw data for the object back<
	 *      * `{*}` Data to set when the second parameter is 'set'.
	 *    * Return:
	 *      * The return value from the function is not required when 'set' is
	 *        the type of call, but otherwise the return is what will be used
	 *        for the data requested.
	 *
	 * Note that `data` is a getter and setter option. If you just require
	 * formatting of data for output, you will likely want to use `render` which
	 * is simply a getter and thus simpler to use.
	 *
	 * Note that prior to DataTables 1.9.2 `data` was called `mDataProp`. The
	 * name change reflects the flexibility of this property and is consistent
	 * with the naming of mRender. If 'mDataProp' is given, then it will still
	 * be used by DataTables, as it automatically maps the old name to the new
	 * if required.
	 *
	 *  @type string|int|function|null
	 *  @default null <i>Use automatically calculated column index</i>
	 *
	 *  @name DataTable.defaults.column.data
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Read table data from objects
	 *    // JSON structure for each row:
	 *    //   {
	 *    //      "engine": {value},
	 *    //      "browser": {value},
	 *    //      "platform": {value},
	 *    //      "version": {value},
	 *    //      "grade": {value}
	 *    //   }
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "ajaxSource": "sources/objects.txt",
	 *        "columns": [
	 *          { "data": "engine" },
	 *          { "data": "browser" },
	 *          { "data": "platform" },
	 *          { "data": "version" },
	 *          { "data": "grade" }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Read information from deeply nested objects
	 *    // JSON structure for each row:
	 *    //   {
	 *    //      "engine": {value},
	 *    //      "browser": {value},
	 *    //      "platform": {
	 *    //         "inner": {value}
	 *    //      },
	 *    //      "details": [
	 *    //         {value}, {value}
	 *    //      ]
	 *    //   }
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "ajaxSource": "sources/deep.txt",
	 *        "columns": [
	 *          { "data": "engine" },
	 *          { "data": "browser" },
	 *          { "data": "platform.inner" },
	 *          { "data": "details.0" },
	 *          { "data": "details.1" }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using `data` as a function to provide different information for
	 *    // sorting, filtering and display. In this case, currency (price)
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [ {
	 *          "targets": [ 0 ],
	 *          "data": function ( source, type, val ) {
	 *            if (type === 'set') {
	 *              source.price = val;
	 *              // Store the computed display and filter values for efficiency
	 *              source.price_display = val=="" ? "" : "$"+numberFormat(val);
	 *              source.price_filter  = val=="" ? "" : "$"+numberFormat(val)+" "+val;
	 *              return;
	 *            }
	 *            else if (type === 'display') {
	 *              return source.price_display;
	 *            }
	 *            else if (type === 'filter') {
	 *              return source.price_filter;
	 *            }
	 *            // 'sort', 'type' and undefined all just use the integer
	 *            return source.price;
	 *          }
	 *        } ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using default content
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [ {
	 *          "targets": [ 0 ],
	 *          "data": null,
	 *          "defaultContent": "Click to edit"
	 *        } ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using array notation - outputting a list from an array
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [ {
	 *          "targets": [ 0 ],
	 *          "data": "name[, ]"
	 *        } ]
	 *      } );
	 *    } );
	 *
	 */
	"mData": null,


	/**
	 * This property is the rendering partner to `data` and it is suggested that
	 * when you want to manipulate data for display (including filtering,
	 * sorting etc) without altering the underlying data for the table, use this
	 * property. `render` can be considered to be the the read only companion to
	 * `data` which is read / write (then as such more complex). Like `data`
	 * this option can be given in a number of different ways to effect its
	 * behaviour:
	 *
	 * * `integer` - treated as an array index for the data source. This is the
	 *   default that DataTables uses (incrementally increased for each column).
	 * * `string` - read an object property from the data source. There are
	 *   three 'special' options that can be used in the string to alter how
	 *   DataTables reads the data from the source object:
	 *    * `.` - Dotted Javascript notation. Just as you use a `.` in
	 *      Javascript to read from nested objects, so to can the options
	 *      specified in `data`. For example: `browser.version` or
	 *      `browser.name`. If your object parameter name contains a period, use
	 *      `\\` to escape it - i.e. `first\\.name`.
	 *    * `[]` - Array notation. DataTables can automatically combine data
	 *      from and array source, joining the data with the characters provided
	 *      between the two brackets. For example: `name[, ]` would provide a
	 *      comma-space separated list from the source array. If no characters
	 *      are provided between the brackets, the original array source is
	 *      returned.
	 *    * `()` - Function notation. Adding `()` to the end of a parameter will
	 *      execute a function of the name given. For example: `browser()` for a
	 *      simple function on the data source, `browser.version()` for a
	 *      function in a nested property or even `browser().version` to get an
	 *      object property if the function called returns an object.
	 * * `object` - use different data for the different data types requested by
	 *   DataTables ('filter', 'display', 'type' or 'sort'). The property names
	 *   of the object is the data type the property refers to and the value can
	 *   defined using an integer, string or function using the same rules as
	 *   `render` normally does. Note that an `_` option _must_ be specified.
	 *   This is the default value to use if you haven't specified a value for
	 *   the data type requested by DataTables.
	 * * `function` - the function given will be executed whenever DataTables
	 *   needs to set or get the data for a cell in the column. The function
	 *   takes three parameters:
	 *    * Parameters:
	 *      * {array|object} The data source for the row (based on `data`)
	 *      * {string} The type call data requested - this will be 'filter',
	 *        'display', 'type' or 'sort'.
	 *      * {array|object} The full data source for the row (not based on
	 *        `data`)
	 *    * Return:
	 *      * The return value from the function is what will be used for the
	 *        data requested.
	 *
	 *  @type string|int|function|object|null
	 *  @default null Use the data source value.
	 *
	 *  @name DataTable.defaults.column.render
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Create a comma separated list from an array of objects
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "ajaxSource": "sources/deep.txt",
	 *        "columns": [
	 *          { "data": "engine" },
	 *          { "data": "browser" },
	 *          {
	 *            "data": "platform",
	 *            "render": "[, ].name"
	 *          }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Execute a function to obtain data
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [ {
	 *          "targets": [ 0 ],
	 *          "data": null, // Use the full data source object for the renderer's source
	 *          "render": "browserName()"
	 *        } ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // As an object, extracting different data for the different types
	 *    // This would be used with a data source such as:
	 *    //   { "phone": 5552368, "phone_filter": "5552368 555-2368", "phone_display": "555-2368" }
	 *    // Here the `phone` integer is used for sorting and type detection, while `phone_filter`
	 *    // (which has both forms) is used for filtering for if a user inputs either format, while
	 *    // the formatted phone number is the one that is shown in the table.
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [ {
	 *          "targets": [ 0 ],
	 *          "data": null, // Use the full data source object for the renderer's source
	 *          "render": {
	 *            "_": "phone",
	 *            "filter": "phone_filter",
	 *            "display": "phone_display"
	 *          }
	 *        } ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Use as a function to create a link from the data source
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [ {
	 *          "targets": [ 0 ],
	 *          "data": "download_link",
	 *          "render": function ( data, type, full ) {
	 *            return '<a href="'+data+'">Download</a>';
	 *          }
	 *        } ]
	 *      } );
	 *    } );
	 */
	"mRender": null,


	/**
	 * Change the cell type created for the column - either TD cells or TH cells. This
	 * can be useful as TH cells have semantic meaning in the table body, allowing them
	 * to act as a header for a row (you may wish to add scope='row' to the TH elements).
	 *  @type string
	 *  @default td
	 *
	 *  @name DataTable.defaults.column.cellType
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Make the first column use TH cells
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [ {
	 *          "targets": [ 0 ],
	 *          "cellType": "th"
	 *        } ]
	 *      } );
	 *    } );
	 */
	"sCellType": "td",


	/**
	 * Class to give to each cell in this column.
	 *  @type string
	 *  @default <i>Empty string</i>
	 *
	 *  @name DataTable.defaults.column.class
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columnDefs`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [
	 *          { "class": "my_class", "targets": [ 0 ] }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          { "class": "my_class" },
	 *          null,
	 *          null,
	 *          null,
	 *          null
	 *        ]
	 *      } );
	 *    } );
	 */
	"sClass": "",

	/**
	 * When DataTables calculates the column widths to assign to each column,
	 * it finds the longest string in each column and then constructs a
	 * temporary table and reads the widths from that. The problem with this
	 * is that "mmm" is much wider then "iiii", but the latter is a longer
	 * string - thus the calculation can go wrong (doing it properly and putting
	 * it into an DOM object and measuring that is horribly(!) slow). Thus as
	 * a "work around" we provide this option. It will append its value to the
	 * text that is found to be the longest string for the column - i.e. padding.
	 * Generally you shouldn't need this!
	 *  @type string
	 *  @default <i>Empty string<i>
	 *
	 *  @name DataTable.defaults.column.contentPadding
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          null,
	 *          null,
	 *          null,
	 *          {
	 *            "contentPadding": "mmm"
	 *          }
	 *        ]
	 *      } );
	 *    } );
	 */
	"sContentPadding": "",


	/**
	 * Allows a default value to be given for a column's data, and will be used
	 * whenever a null data source is encountered (this can be because `data`
	 * is set to null, or because the data source itself is null).
	 *  @type string
	 *  @default null
	 *
	 *  @name DataTable.defaults.column.defaultContent
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columnDefs`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [
	 *          {
	 *            "data": null,
	 *            "defaultContent": "Edit",
	 *            "targets": [ -1 ]
	 *          }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          null,
	 *          null,
	 *          null,
	 *          {
	 *            "data": null,
	 *            "defaultContent": "Edit"
	 *          }
	 *        ]
	 *      } );
	 *    } );
	 */
	"sDefaultContent": null,


	/**
	 * This parameter is only used in DataTables' server-side processing. It can
	 * be exceptionally useful to know what columns are being displayed on the
	 * client side, and to map these to database fields. When defined, the names
	 * also allow DataTables to reorder information from the server if it comes
	 * back in an unexpected order (i.e. if you switch your columns around on the
	 * client-side, your server-side code does not also need updating).
	 *  @type string
	 *  @default <i>Empty string</i>
	 *
	 *  @name DataTable.defaults.column.name
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columnDefs`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [
	 *          { "name": "engine", "targets": [ 0 ] },
	 *          { "name": "browser", "targets": [ 1 ] },
	 *          { "name": "platform", "targets": [ 2 ] },
	 *          { "name": "version", "targets": [ 3 ] },
	 *          { "name": "grade", "targets": [ 4 ] }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          { "name": "engine" },
	 *          { "name": "browser" },
	 *          { "name": "platform" },
	 *          { "name": "version" },
	 *          { "name": "grade" }
	 *        ]
	 *      } );
	 *    } );
	 */
	"sName": "",


	/**
	 * Defines a data source type for the ordering which can be used to read
	 * real-time information from the table (updating the internally cached
	 * version) prior to ordering. This allows ordering to occur on user
	 * editable elements such as form inputs.
	 *  @type string
	 *  @default std
	 *
	 *  @name DataTable.defaults.column.orderDataType
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columnDefs`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [
	 *          { "orderDataType": "dom-text", "targets": [ 2, 3 ] },
	 *          { "type": "numeric", "targets": [ 3 ] },
	 *          { "orderDataType": "dom-select", "targets": [ 4 ] },
	 *          { "orderDataType": "dom-checkbox", "targets": [ 5 ] }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          null,
	 *          null,
	 *          { "orderDataType": "dom-text" },
	 *          { "orderDataType": "dom-text", "type": "numeric" },
	 *          { "orderDataType": "dom-select" },
	 *          { "orderDataType": "dom-checkbox" }
	 *        ]
	 *      } );
	 *    } );
	 */
	"sSortDataType": "std",


	/**
	 * The title of this column.
	 *  @type string
	 *  @default null <i>Derived from the 'TH' value for this column in the
	 *    original HTML table.</i>
	 *
	 *  @name DataTable.defaults.column.title
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columnDefs`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [
	 *          { "title": "My column title", "targets": [ 0 ] }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          { "title": "My column title" },
	 *          null,
	 *          null,
	 *          null,
	 *          null
	 *        ]
	 *      } );
	 *    } );
	 */
	"sTitle": null,


	/**
	 * The type allows you to specify how the data for this column will be
	 * ordered. Four types (string, numeric, date and html (which will strip
	 * HTML tags before ordering)) are currently available. Note that only date
	 * formats understood by Javascript's Date() object will be accepted as type
	 * date. For example: "Mar 26, 2008 5:03 PM". May take the values: 'string',
	 * 'numeric', 'date' or 'html' (by default). Further types can be adding
	 * through plug-ins.
	 *  @type string
	 *  @default null <i>Auto-detected from raw data</i>
	 *
	 *  @name DataTable.defaults.column.type
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columnDefs`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [
	 *          { "type": "html", "targets": [ 0 ] }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          { "type": "html" },
	 *          null,
	 *          null,
	 *          null,
	 *          null
	 *        ]
	 *      } );
	 *    } );
	 */
	"sType": null,


	/**
	 * Defining the width of the column, this parameter may take any CSS value
	 * (3em, 20px etc). DataTables applies 'smart' widths to columns which have not
	 * been given a specific width through this interface ensuring that the table
	 * remains readable.
	 *  @type string
	 *  @default null <i>Automatic</i>
	 *
	 *  @name DataTable.defaults.column.width
	 *  @dtopt Columns
	 *
	 *  @example
	 *    // Using `columnDefs`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columnDefs": [
	 *          { "width": "20%", "targets": [ 0 ] }
	 *        ]
	 *      } );
	 *    } );
	 *
	 *  @example
	 *    // Using `columns`
	 *    $(document).ready( function() {
	 *      $('#example').dataTable( {
	 *        "columns": [
	 *          { "width": "20%" },
	 *          null,
	 *          null,
	 *          null,
	 *          null
	 *        ]
	 *      } );
	 *    } );
	 */
	"sWidth": null
};

_fnHungarianMap( DataTable.defaults.column );



/**
 * DataTables settings object - this holds all the information needed for a
 * given table, including configuration, data and current application of the
 * table options. DataTables does not have a single instance for each DataTable
 * with the settings attached to that instance, but rather instances of the
 * DataTable "class" are created on-the-fly as needed (typically by a
 * $().dataTable() call) and the settings object is then applied to that
 * instance.
 *
 * Note that this object is related to {@link DataTable.defaults} but this
 * one is the internal data store for DataTables's cache of columns. It should
 * NOT be manipulated outside of DataTables. Any configuration should be done
 * through the initialisation options.
 *  @namespace
 *  @todo Really should attach the settings object to individual instances so we
 *    don't need to create new instances on each $().dataTable() call (if the
 *    table already exists). It would also save passing oSettings around and
 *    into every single function. However, this is a very significant
 *    architecture change for DataTables and will almost certainly break
 *    backwards compatibility with older installations. This is something that
 *    will be done in 2.0.
 */
DataTable.models.oSettings = {
	/**
	 * Primary features of DataTables and their enablement state.
	 *  @namespace
	 */
	"oFeatures": {

		/**
		 * Flag to say if DataTables should automatically try to calculate the
		 * optimum table and columns widths (true) or not (false).
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bAutoWidth": null,

		/**
		 * Delay the creation of TR and TD elements until they are actually
		 * needed by a driven page draw. This can give a significant speed
		 * increase for Ajax source and Javascript source data, but makes no
		 * difference at all for DOM and server-side processing tables.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bDeferRender": null,

		/**
		 * Enable filtering on the table or not. Note that if this is disabled
		 * then there is no filtering at all on the table, including fnFilter.
		 * To just remove the filtering input use sDom and remove the 'f' option.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bFilter": null,

		/**
		 * Table information element (the 'Showing x of y records' div) enable
		 * flag.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bInfo": null,

		/**
		 * Present a user control allowing the end user to change the page size
		 * when pagination is enabled.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bLengthChange": null,

		/**
		 * Pagination enabled or not. Note that if this is disabled then length
		 * changing must also be disabled.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bPaginate": null,

		/**
		 * Processing indicator enable flag whenever DataTables is enacting a
		 * user request - typically an Ajax request for server-side processing.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bProcessing": null,

		/**
		 * Server-side processing enabled flag - when enabled DataTables will
		 * get all data from the server for every draw - there is no filtering,
		 * sorting or paging done on the client-side.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bServerSide": null,

		/**
		 * Sorting enablement flag.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bSort": null,

		/**
		 * Multi-column sorting
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bSortMulti": null,

		/**
		 * Apply a class to the columns which are being sorted to provide a
		 * visual highlight or not. This can slow things down when enabled since
		 * there is a lot of DOM interaction.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bSortClasses": null,

		/**
		 * State saving enablement flag.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bStateSave": null
	},


	/**
	 * Scrolling settings for a table.
	 *  @namespace
	 */
	"oScroll": {
		/**
		 * When the table is shorter in height than sScrollY, collapse the
		 * table container down to the height of the table (when true).
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bCollapse": null,

		/**
		 * Width of the scrollbar for the web-browser's platform. Calculated
		 * during table initialisation.
		 *  @type int
		 *  @default 0
		 */
		"iBarWidth": 0,

		/**
		 * Viewport width for horizontal scrolling. Horizontal scrolling is
		 * disabled if an empty string.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 */
		"sX": null,

		/**
		 * Width to expand the table to when using x-scrolling. Typically you
		 * should not need to use this.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 *  @deprecated
		 */
		"sXInner": null,

		/**
		 * Viewport height for vertical scrolling. Vertical scrolling is disabled
		 * if an empty string.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 */
		"sY": null
	},

	/**
	 * Language information for the table.
	 *  @namespace
	 *  @extends DataTable.defaults.oLanguage
	 */
	"oLanguage": {
		/**
		 * Information callback function. See
		 * {@link DataTable.defaults.fnInfoCallback}
		 *  @type function
		 *  @default null
		 */
		"fnInfoCallback": null
	},

	/**
	 * Browser support parameters
	 *  @namespace
	 */
	"oBrowser": {
		/**
		 * Indicate if the browser incorrectly calculates width:100% inside a
		 * scrolling element (IE6/7)
		 *  @type boolean
		 *  @default false
		 */
		"bScrollOversize": false,

		/**
		 * Determine if the vertical scrollbar is on the right or left of the
		 * scrolling container - needed for rtl language layout, although not
		 * all browsers move the scrollbar (Safari).
		 *  @type boolean
		 *  @default false
		 */
		"bScrollbarLeft": false,

		/**
		 * Flag for if `getBoundingClientRect` is fully supported or not
		 *  @type boolean
		 *  @default false
		 */
		"bBounding": false,

		/**
		 * Browser scrollbar width
		 *  @type integer
		 *  @default 0
		 */
		"barWidth": 0
	},


	"ajax": null,


	/**
	 * Array referencing the nodes which are used for the features. The
	 * parameters of this object match what is allowed by sDom - i.e.
	 *   <ul>
	 *     <li>'l' - Length changing</li>
	 *     <li>'f' - Filtering input</li>
	 *     <li>'t' - The table!</li>
	 *     <li>'i' - Information</li>
	 *     <li>'p' - Pagination</li>
	 *     <li>'r' - pRocessing</li>
	 *   </ul>
	 *  @type array
	 *  @default []
	 */
	"aanFeatures": [],

	/**
	 * Store data information - see {@link DataTable.models.oRow} for detailed
	 * information.
	 *  @type array
	 *  @default []
	 */
	"aoData": [],

	/**
	 * Array of indexes which are in the current display (after filtering etc)
	 *  @type array
	 *  @default []
	 */
	"aiDisplay": [],

	/**
	 * Array of indexes for display - no filtering
	 *  @type array
	 *  @default []
	 */
	"aiDisplayMaster": [],

	/**
	 * Map of row ids to data indexes
	 *  @type object
	 *  @default {}
	 */
	"aIds": {},

	/**
	 * Store information about each column that is in use
	 *  @type array
	 *  @default []
	 */
	"aoColumns": [],

	/**
	 * Store information about the table's header
	 *  @type array
	 *  @default []
	 */
	"aoHeader": [],

	/**
	 * Store information about the table's footer
	 *  @type array
	 *  @default []
	 */
	"aoFooter": [],

	/**
	 * Store the applied global search information in case we want to force a
	 * research or compare the old search to a new one.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @namespace
	 *  @extends DataTable.models.oSearch
	 */
	"oPreviousSearch": {},

	/**
	 * Store the applied search for each column - see
	 * {@link DataTable.models.oSearch} for the format that is used for the
	 * filtering information for each column.
	 *  @type array
	 *  @default []
	 */
	"aoPreSearchCols": [],

	/**
	 * Sorting that is applied to the table. Note that the inner arrays are
	 * used in the following manner:
	 * <ul>
	 *   <li>Index 0 - column number</li>
	 *   <li>Index 1 - current sorting direction</li>
	 * </ul>
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type array
	 *  @todo These inner arrays should really be objects
	 */
	"aaSorting": null,

	/**
	 * Sorting that is always applied to the table (i.e. prefixed in front of
	 * aaSorting).
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type array
	 *  @default []
	 */
	"aaSortingFixed": [],

	/**
	 * Classes to use for the striping of a table.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type array
	 *  @default []
	 */
	"asStripeClasses": null,

	/**
	 * If restoring a table - we should restore its striping classes as well
	 *  @type array
	 *  @default []
	 */
	"asDestroyStripes": [],

	/**
	 * If restoring a table - we should restore its width
	 *  @type int
	 *  @default 0
	 */
	"sDestroyWidth": 0,

	/**
	 * Callback functions array for every time a row is inserted (i.e. on a draw).
	 *  @type array
	 *  @default []
	 */
	"aoRowCallback": [],

	/**
	 * Callback functions for the header on each draw.
	 *  @type array
	 *  @default []
	 */
	"aoHeaderCallback": [],

	/**
	 * Callback function for the footer on each draw.
	 *  @type array
	 *  @default []
	 */
	"aoFooterCallback": [],

	/**
	 * Array of callback functions for draw callback functions
	 *  @type array
	 *  @default []
	 */
	"aoDrawCallback": [],

	/**
	 * Array of callback functions for row created function
	 *  @type array
	 *  @default []
	 */
	"aoRowCreatedCallback": [],

	/**
	 * Callback functions for just before the table is redrawn. A return of
	 * false will be used to cancel the draw.
	 *  @type array
	 *  @default []
	 */
	"aoPreDrawCallback": [],

	/**
	 * Callback functions for when the table has been initialised.
	 *  @type array
	 *  @default []
	 */
	"aoInitComplete": [],


	/**
	 * Callbacks for modifying the settings to be stored for state saving, prior to
	 * saving state.
	 *  @type array
	 *  @default []
	 */
	"aoStateSaveParams": [],

	/**
	 * Callbacks for modifying the settings that have been stored for state saving
	 * prior to using the stored values to restore the state.
	 *  @type array
	 *  @default []
	 */
	"aoStateLoadParams": [],

	/**
	 * Callbacks for operating on the settings object once the saved state has been
	 * loaded
	 *  @type array
	 *  @default []
	 */
	"aoStateLoaded": [],

	/**
	 * Cache the table ID for quick access
	 *  @type string
	 *  @default <i>Empty string</i>
	 */
	"sTableId": "",

	/**
	 * The TABLE node for the main table
	 *  @type node
	 *  @default null
	 */
	"nTable": null,

	/**
	 * Permanent ref to the thead element
	 *  @type node
	 *  @default null
	 */
	"nTHead": null,

	/**
	 * Permanent ref to the tfoot element - if it exists
	 *  @type node
	 *  @default null
	 */
	"nTFoot": null,

	/**
	 * Permanent ref to the tbody element
	 *  @type node
	 *  @default null
	 */
	"nTBody": null,

	/**
	 * Cache the wrapper node (contains all DataTables controlled elements)
	 *  @type node
	 *  @default null
	 */
	"nTableWrapper": null,

	/**
	 * Indicate if when using server-side processing the loading of data
	 * should be deferred until the second draw.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type boolean
	 *  @default false
	 */
	"bDeferLoading": false,

	/**
	 * Indicate if all required information has been read in
	 *  @type boolean
	 *  @default false
	 */
	"bInitialised": false,

	/**
	 * Information about open rows. Each object in the array has the parameters
	 * 'nTr' and 'nParent'
	 *  @type array
	 *  @default []
	 */
	"aoOpenRows": [],

	/**
	 * Dictate the positioning of DataTables' control elements - see
	 * {@link DataTable.model.oInit.sDom}.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type string
	 *  @default null
	 */
	"sDom": null,

	/**
	 * Search delay (in mS)
	 *  @type integer
	 *  @default null
	 */
	"searchDelay": null,

	/**
	 * Which type of pagination should be used.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type string
	 *  @default two_button
	 */
	"sPaginationType": "two_button",

	/**
	 * The state duration (for `stateSave`) in seconds.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type int
	 *  @default 0
	 */
	"iStateDuration": 0,

	/**
	 * Array of callback functions for state saving. Each array element is an
	 * object with the following parameters:
	 *   <ul>
	 *     <li>function:fn - function to call. Takes two parameters, oSettings
	 *       and the JSON string to save that has been thus far created. Returns
	 *       a JSON string to be inserted into a json object
	 *       (i.e. '"param": [ 0, 1, 2]')</li>
	 *     <li>string:sName - name of callback</li>
	 *   </ul>
	 *  @type array
	 *  @default []
	 */
	"aoStateSave": [],

	/**
	 * Array of callback functions for state loading. Each array element is an
	 * object with the following parameters:
	 *   <ul>
	 *     <li>function:fn - function to call. Takes two parameters, oSettings
	 *       and the object stored. May return false to cancel state loading</li>
	 *     <li>string:sName - name of callback</li>
	 *   </ul>
	 *  @type array
	 *  @default []
	 */
	"aoStateLoad": [],

	/**
	 * State that was saved. Useful for back reference
	 *  @type object
	 *  @default null
	 */
	"oSavedState": null,

	/**
	 * State that was loaded. Useful for back reference
	 *  @type object
	 *  @default null
	 */
	"oLoadedState": null,

	/**
	 * Source url for AJAX data for the table.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type string
	 *  @default null
	 */
	"sAjaxSource": null,

	/**
	 * Property from a given object from which to read the table data from. This
	 * can be an empty string (when not server-side processing), in which case
	 * it is  assumed an an array is given directly.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type string
	 */
	"sAjaxDataProp": null,

	/**
	 * The last jQuery XHR object that was used for server-side data gathering.
	 * This can be used for working with the XHR information in one of the
	 * callbacks
	 *  @type object
	 *  @default null
	 */
	"jqXHR": null,

	/**
	 * JSON returned from the server in the last Ajax request
	 *  @type object
	 *  @default undefined
	 */
	"json": undefined,

	/**
	 * Data submitted as part of the last Ajax request
	 *  @type object
	 *  @default undefined
	 */
	"oAjaxData": undefined,

	/**
	 * Function to get the server-side data.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type function
	 */
	"fnServerData": null,

	/**
	 * Functions which are called prior to sending an Ajax request so extra
	 * parameters can easily be sent to the server
	 *  @type array
	 *  @default []
	 */
	"aoServerParams": [],

	/**
	 * Send the XHR HTTP method - GET or POST (could be PUT or DELETE if
	 * required).
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type string
	 */
	"sServerMethod": null,

	/**
	 * Format numbers for display.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type function
	 */
	"fnFormatNumber": null,

	/**
	 * List of options that can be used for the user selectable length menu.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type array
	 *  @default []
	 */
	"aLengthMenu": null,

	/**
	 * Counter for the draws that the table does. Also used as a tracker for
	 * server-side processing
	 *  @type int
	 *  @default 0
	 */
	"iDraw": 0,

	/**
	 * Indicate if a redraw is being done - useful for Ajax
	 *  @type boolean
	 *  @default false
	 */
	"bDrawing": false,

	/**
	 * Draw index (iDraw) of the last error when parsing the returned data
	 *  @type int
	 *  @default -1
	 */
	"iDrawError": -1,

	/**
	 * Paging display length
	 *  @type int
	 *  @default 10
	 */
	"_iDisplayLength": 10,

	/**
	 * Paging start point - aiDisplay index
	 *  @type int
	 *  @default 0
	 */
	"_iDisplayStart": 0,

	/**
	 * Server-side processing - number of records in the result set
	 * (i.e. before filtering), Use fnRecordsTotal rather than
	 * this property to get the value of the number of records, regardless of
	 * the server-side processing setting.
	 *  @type int
	 *  @default 0
	 *  @private
	 */
	"_iRecordsTotal": 0,

	/**
	 * Server-side processing - number of records in the current display set
	 * (i.e. after filtering). Use fnRecordsDisplay rather than
	 * this property to get the value of the number of records, regardless of
	 * the server-side processing setting.
	 *  @type boolean
	 *  @default 0
	 *  @private
	 */
	"_iRecordsDisplay": 0,

	/**
	 * The classes to use for the table
	 *  @type object
	 *  @default {}
	 */
	"oClasses": {},

	/**
	 * Flag attached to the settings object so you can check in the draw
	 * callback if filtering has been done in the draw. Deprecated in favour of
	 * events.
	 *  @type boolean
	 *  @default false
	 *  @deprecated
	 */
	"bFiltered": false,

	/**
	 * Flag attached to the settings object so you can check in the draw
	 * callback if sorting has been done in the draw. Deprecated in favour of
	 * events.
	 *  @type boolean
	 *  @default false
	 *  @deprecated
	 */
	"bSorted": false,

	/**
	 * Indicate that if multiple rows are in the header and there is more than
	 * one unique cell per column, if the top one (true) or bottom one (false)
	 * should be used for sorting / title by DataTables.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 *  @type boolean
	 */
	"bSortCellsTop": null,

	/**
	 * Initialisation object that is used for the table
	 *  @type object
	 *  @default null
	 */
	"oInit": null,

	/**
	 * Destroy callback functions - for plug-ins to attach themselves to the
	 * destroy so they can clean up markup and events.
	 *  @type array
	 *  @default []
	 */
	"aoDestroyCallback": [],


	/**
	 * Get the number of records in the current record set, before filtering
	 *  @type function
	 */
	"fnRecordsTotal": function ()
	{
		return _fnDataSource( this ) == 'ssp' ?
			this._iRecordsTotal * 1 :
			this.aiDisplayMaster.length;
	},

	/**
	 * Get the number of records in the current record set, after filtering
	 *  @type function
	 */
	"fnRecordsDisplay": function ()
	{
		return _fnDataSource( this ) == 'ssp' ?
			this._iRecordsDisplay * 1 :
			this.aiDisplay.length;
	},

	/**
	 * Get the display end point - aiDisplay index
	 *  @type function
	 */
	"fnDisplayEnd": function ()
	{
		var
			len      = this._iDisplayLength,
			start    = this._iDisplayStart,
			calc     = start + len,
			records  = this.aiDisplay.length,
			features = this.oFeatures,
			paginate = features.bPaginate;

		if ( features.bServerSide ) {
			return paginate === false || len === -1 ?
				start + records :
				Math.min( start+len, this._iRecordsDisplay );
		}
		else {
			return ! paginate || calc>records || len===-1 ?
				records :
				calc;
		}
	},

	/**
	 * The DataTables object for this table
	 *  @type object
	 *  @default null
	 */
	"oInstance": null,

	/**
	 * Unique identifier for each instance of the DataTables object. If there
	 * is an ID on the table node, then it takes that value, otherwise an
	 * incrementing internal counter is used.
	 *  @type string
	 *  @default null
	 */
	"sInstance": null,

	/**
	 * tabindex attribute value that is added to DataTables control elements, allowing
	 * keyboard navigation of the table and its controls.
	 */
	"iTabIndex": 0,

	/**
	 * DIV container for the footer scrolling table if scrolling
	 */
	"nScrollHead": null,

	/**
	 * DIV container for the footer scrolling table if scrolling
	 */
	"nScrollFoot": null,

	/**
	 * Last applied sort
	 *  @type array
	 *  @default []
	 */
	"aLastSort": [],

	/**
	 * Stored plug-in instances
	 *  @type object
	 *  @default {}
	 */
	"oPlugins": {},

	/**
	 * Function used to get a row's id from the row's data
	 *  @type function
	 *  @default null
	 */
	"rowIdFn": null,

	/**
	 * Data location where to store a row's id
	 *  @type string
	 *  @default null
	 */
	"rowId": null
};

/**
 * Extension object for DataTables that is used to provide all extension
 * options.
 *
 * Note that the `DataTable.ext` object is available through
 * `jQuery.fn.dataTable.ext` where it may be accessed and manipulated. It is
 * also aliased to `jQuery.fn.dataTableExt` for historic reasons.
 *  @namespace
 *  @extends DataTable.models.ext
 */


/**
 * DataTables extensions
 * 
 * This namespace acts as a collection area for plug-ins that can be used to
 * extend DataTables capabilities. Indeed many of the build in methods
 * use this method to provide their own capabilities (sorting methods for
 * example).
 *
 * Note that this namespace is aliased to `jQuery.fn.dataTableExt` for legacy
 * reasons
 *
 *  @namespace
 */
DataTable.ext = _ext = {
	/**
	 * Buttons. For use with the Buttons extension for DataTables. This is
	 * defined here so other extensions can define buttons regardless of load
	 * order. It is _not_ used by DataTables core.
	 *
	 *  @type object
	 *  @default {}
	 */
	buttons: {},


	/**
	 * Element class names
	 *
	 *  @type object
	 *  @default {}
	 */
	classes: {},


	/**
	 * DataTables build type (expanded by the download builder)
	 *
	 *  @type string
	 */
	builder: "-source-",


	/**
	 * Error reporting.
	 * 
	 * How should DataTables report an error. Can take the value 'alert',
	 * 'throw', 'none' or a function.
	 *
	 *  @type string|function
	 *  @default alert
	 */
	errMode: "alert",


	/**
	 * Feature plug-ins.
	 * 
	 * This is an array of objects which describe the feature plug-ins that are
	 * available to DataTables. These feature plug-ins are then available for
	 * use through the `dom` initialisation option.
	 * 
	 * Each feature plug-in is described by an object which must have the
	 * following properties:
	 * 
	 * * `fnInit` - function that is used to initialise the plug-in,
	 * * `cFeature` - a character so the feature can be enabled by the `dom`
	 *   instillation option. This is case sensitive.
	 *
	 * The `fnInit` function has the following input parameters:
	 *
	 * 1. `{object}` DataTables settings object: see
	 *    {@link DataTable.models.oSettings}
	 *
	 * And the following return is expected:
	 * 
	 * * {node|null} The element which contains your feature. Note that the
	 *   return may also be void if your plug-in does not require to inject any
	 *   DOM elements into DataTables control (`dom`) - for example this might
	 *   be useful when developing a plug-in which allows table control via
	 *   keyboard entry
	 *
	 *  @type array
	 *
	 *  @example
	 *    $.fn.dataTable.ext.features.push( {
	 *      "fnInit": function( oSettings ) {
	 *        return new TableTools( { "oDTSettings": oSettings } );
	 *      },
	 *      "cFeature": "T"
	 *    } );
	 */
	feature: [],


	/**
	 * Row searching.
	 * 
	 * This method of searching is complimentary to the default type based
	 * searching, and a lot more comprehensive as it allows you complete control
	 * over the searching logic. Each element in this array is a function
	 * (parameters described below) that is called for every row in the table,
	 * and your logic decides if it should be included in the searching data set
	 * or not.
	 *
	 * Searching functions have the following input parameters:
	 *
	 * 1. `{object}` DataTables settings object: see
	 *    {@link DataTable.models.oSettings}
	 * 2. `{array|object}` Data for the row to be processed (same as the
	 *    original format that was passed in as the data source, or an array
	 *    from a DOM data source
	 * 3. `{int}` Row index ({@link DataTable.models.oSettings.aoData}), which
	 *    can be useful to retrieve the `TR` element if you need DOM interaction.
	 *
	 * And the following return is expected:
	 *
	 * * {boolean} Include the row in the searched result set (true) or not
	 *   (false)
	 *
	 * Note that as with the main search ability in DataTables, technically this
	 * is "filtering", since it is subtractive. However, for consistency in
	 * naming we call it searching here.
	 *
	 *  @type array
	 *  @default []
	 *
	 *  @example
	 *    // The following example shows custom search being applied to the
	 *    // fourth column (i.e. the data[3] index) based on two input values
	 *    // from the end-user, matching the data in a certain range.
	 *    $.fn.dataTable.ext.search.push(
	 *      function( settings, data, dataIndex ) {
	 *        var min = document.getElementById('min').value * 1;
	 *        var max = document.getElementById('max').value * 1;
	 *        var version = data[3] == "-" ? 0 : data[3]*1;
	 *
	 *        if ( min == "" && max == "" ) {
	 *          return true;
	 *        }
	 *        else if ( min == "" && version < max ) {
	 *          return true;
	 *        }
	 *        else if ( min < version && "" == max ) {
	 *          return true;
	 *        }
	 *        else if ( min < version && version < max ) {
	 *          return true;
	 *        }
	 *        return false;
	 *      }
	 *    );
	 */
	search: [],


	/**
	 * Selector extensions
	 *
	 * The `selector` option can be used to extend the options available for the
	 * selector modifier options (`selector-modifier` object data type) that
	 * each of the three built in selector types offer (row, column and cell +
	 * their plural counterparts). For example the Select extension uses this
	 * mechanism to provide an option to select only rows, columns and cells
	 * that have been marked as selected by the end user (`{selected: true}`),
	 * which can be used in conjunction with the existing built in selector
	 * options.
	 *
	 * Each property is an array to which functions can be pushed. The functions
	 * take three attributes:
	 *
	 * * Settings object for the host table
	 * * Options object (`selector-modifier` object type)
	 * * Array of selected item indexes
	 *
	 * The return is an array of the resulting item indexes after the custom
	 * selector has been applied.
	 *
	 *  @type object
	 */
	selector: {
		cell: [],
		column: [],
		row: []
	},


	/**
	 * Internal functions, exposed for used in plug-ins.
	 * 
	 * Please note that you should not need to use the internal methods for
	 * anything other than a plug-in (and even then, try to avoid if possible).
	 * The internal function may change between releases.
	 *
	 *  @type object
	 *  @default {}
	 */
	internal: {},


	/**
	 * Legacy configuration options. Enable and disable legacy options that
	 * are available in DataTables.
	 *
	 *  @type object
	 */
	legacy: {
		/**
		 * Enable / disable DataTables 1.9 compatible server-side processing
		 * requests
		 *
		 *  @type boolean
		 *  @default null
		 */
		ajax: null
	},


	/**
	 * Pagination plug-in methods.
	 * 
	 * Each entry in this object is a function and defines which buttons should
	 * be shown by the pagination rendering method that is used for the table:
	 * {@link DataTable.ext.renderer.pageButton}. The renderer addresses how the
	 * buttons are displayed in the document, while the functions here tell it
	 * what buttons to display. This is done by returning an array of button
	 * descriptions (what each button will do).
	 *
	 * Pagination types (the four built in options and any additional plug-in
	 * options defined here) can be used through the `paginationType`
	 * initialisation parameter.
	 *
	 * The functions defined take two parameters:
	 *
	 * 1. `{int} page` The current page index
	 * 2. `{int} pages` The number of pages in the table
	 *
	 * Each function is expected to return an array where each element of the
	 * array can be one of:
	 *
	 * * `first` - Jump to first page when activated
	 * * `last` - Jump to last page when activated
	 * * `previous` - Show previous page when activated
	 * * `next` - Show next page when activated
	 * * `{int}` - Show page of the index given
	 * * `{array}` - A nested array containing the above elements to add a
	 *   containing 'DIV' element (might be useful for styling).
	 *
	 * Note that DataTables v1.9- used this object slightly differently whereby
	 * an object with two functions would be defined for each plug-in. That
	 * ability is still supported by DataTables 1.10+ to provide backwards
	 * compatibility, but this option of use is now decremented and no longer
	 * documented in DataTables 1.10+.
	 *
	 *  @type object
	 *  @default {}
	 *
	 *  @example
	 *    // Show previous, next and current page buttons only
	 *    $.fn.dataTableExt.oPagination.current = function ( page, pages ) {
	 *      return [ 'previous', page, 'next' ];
	 *    };
	 */
	pager: {},


	renderer: {
		pageButton: {},
		header: {}
	},


	/**
	 * Ordering plug-ins - custom data source
	 * 
	 * The extension options for ordering of data available here is complimentary
	 * to the default type based ordering that DataTables typically uses. It
	 * allows much greater control over the the data that is being used to
	 * order a column, but is necessarily therefore more complex.
	 * 
	 * This type of ordering is useful if you want to do ordering based on data
	 * live from the DOM (for example the contents of an 'input' element) rather
	 * than just the static string that DataTables knows of.
	 * 
	 * The way these plug-ins work is that you create an array of the values you
	 * wish to be ordering for the column in question and then return that
	 * array. The data in the array much be in the index order of the rows in
	 * the table (not the currently ordering order!). Which order data gathering
	 * function is run here depends on the `dt-init columns.orderDataType`
	 * parameter that is used for the column (if any).
	 *
	 * The functions defined take two parameters:
	 *
	 * 1. `{object}` DataTables settings object: see
	 *    {@link DataTable.models.oSettings}
	 * 2. `{int}` Target column index
	 *
	 * Each function is expected to return an array:
	 *
	 * * `{array}` Data for the column to be ordering upon
	 *
	 *  @type array
	 *
	 *  @example
	 *    // Ordering using `input` node values
	 *    $.fn.dataTable.ext.order['dom-text'] = function  ( settings, col )
	 *    {
	 *      return this.api().column( col, {order:'index'} ).nodes().map( function ( td, i ) {
	 *        return $('input', td).val();
	 *      } );
	 *    }
	 */
	order: {},


	/**
	 * Type based plug-ins.
	 *
	 * Each column in DataTables has a type assigned to it, either by automatic
	 * detection or by direct assignment using the `type` option for the column.
	 * The type of a column will effect how it is ordering and search (plug-ins
	 * can also make use of the column type if required).
	 *
	 * @namespace
	 */
	type: {
		/**
		 * Type detection functions.
		 *
		 * The functions defined in this object are used to automatically detect
		 * a column's type, making initialisation of DataTables super easy, even
		 * when complex data is in the table.
		 *
		 * The functions defined take two parameters:
		 *
	     *  1. `{*}` Data from the column cell to be analysed
	     *  2. `{settings}` DataTables settings object. This can be used to
	     *     perform context specific type detection - for example detection
	     *     based on language settings such as using a comma for a decimal
	     *     place. Generally speaking the options from the settings will not
	     *     be required
		 *
		 * Each function is expected to return:
		 *
		 * * `{string|null}` Data type detected, or null if unknown (and thus
		 *   pass it on to the other type detection functions.
		 *
		 *  @type array
		 *
		 *  @example
		 *    // Currency type detection plug-in:
		 *    $.fn.dataTable.ext.type.detect.push(
		 *      function ( data, settings ) {
		 *        // Check the numeric part
		 *        if ( ! data.substring(1).match(/[0-9]/) ) {
		 *          return null;
		 *        }
		 *
		 *        // Check prefixed by currency
		 *        if ( data.charAt(0) == '$' || data.charAt(0) == '&pound;' ) {
		 *          return 'currency';
		 *        }
		 *        return null;
		 *      }
		 *    );
		 */
		detect: [],


		/**
		 * Type based search formatting.
		 *
		 * The type based searching functions can be used to pre-format the
		 * data to be search on. For example, it can be used to strip HTML
		 * tags or to de-format telephone numbers for numeric only searching.
		 *
		 * Note that is a search is not defined for a column of a given type,
		 * no search formatting will be performed.
		 * 
		 * Pre-processing of searching data plug-ins - When you assign the sType
		 * for a column (or have it automatically detected for you by DataTables
		 * or a type detection plug-in), you will typically be using this for
		 * custom sorting, but it can also be used to provide custom searching
		 * by allowing you to pre-processing the data and returning the data in
		 * the format that should be searched upon. This is done by adding
		 * functions this object with a parameter name which matches the sType
		 * for that target column. This is the corollary of <i>afnSortData</i>
		 * for searching data.
		 *
		 * The functions defined take a single parameter:
		 *
	     *  1. `{*}` Data from the column cell to be prepared for searching
		 *
		 * Each function is expected to return:
		 *
		 * * `{string|null}` Formatted string that will be used for the searching.
		 *
		 *  @type object
		 *  @default {}
		 *
		 *  @example
		 *    $.fn.dataTable.ext.type.search['title-numeric'] = function ( d ) {
		 *      return d.replace(/\n/g," ").replace( /<.*?>/g, "" );
		 *    }
		 */
		search: {},


		/**
		 * Type based ordering.
		 *
		 * The column type tells DataTables what ordering to apply to the table
		 * when a column is sorted upon. The order for each type that is defined,
		 * is defined by the functions available in this object.
		 *
		 * Each ordering option can be described by three properties added to
		 * this object:
		 *
		 * * `{type}-pre` - Pre-formatting function
		 * * `{type}-asc` - Ascending order function
		 * * `{type}-desc` - Descending order function
		 *
		 * All three can be used together, only `{type}-pre` or only
		 * `{type}-asc` and `{type}-desc` together. It is generally recommended
		 * that only `{type}-pre` is used, as this provides the optimal
		 * implementation in terms of speed, although the others are provided
		 * for compatibility with existing Javascript sort functions.
		 *
		 * `{type}-pre`: Functions defined take a single parameter:
		 *
	     *  1. `{*}` Data from the column cell to be prepared for ordering
		 *
		 * And return:
		 *
		 * * `{*}` Data to be sorted upon
		 *
		 * `{type}-asc` and `{type}-desc`: Functions are typical Javascript sort
		 * functions, taking two parameters:
		 *
	     *  1. `{*}` Data to compare to the second parameter
	     *  2. `{*}` Data to compare to the first parameter
		 *
		 * And returning:
		 *
		 * * `{*}` Ordering match: <0 if first parameter should be sorted lower
		 *   than the second parameter, ===0 if the two parameters are equal and
		 *   >0 if the first parameter should be sorted height than the second
		 *   parameter.
		 * 
		 *  @type object
		 *  @default {}
		 *
		 *  @example
		 *    // Numeric ordering of formatted numbers with a pre-formatter
		 *    $.extend( $.fn.dataTable.ext.type.order, {
		 *      "string-pre": function(x) {
		 *        a = (a === "-" || a === "") ? 0 : a.replace( /[^\d\-\.]/g, "" );
		 *        return parseFloat( a );
		 *      }
		 *    } );
		 *
		 *  @example
		 *    // Case-sensitive string ordering, with no pre-formatting method
		 *    $.extend( $.fn.dataTable.ext.order, {
		 *      "string-case-asc": function(x,y) {
		 *        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
		 *      },
		 *      "string-case-desc": function(x,y) {
		 *        return ((x < y) ? 1 : ((x > y) ? -1 : 0));
		 *      }
		 *    } );
		 */
		order: {}
	},

	/**
	 * Unique DataTables instance counter
	 *
	 * @type int
	 * @private
	 */
	_unique: 0,


	//
	// Depreciated
	// The following properties are retained for backwards compatibility only.
	// The should not be used in new projects and will be removed in a future
	// version
	//

	/**
	 * Version check function.
	 *  @type function
	 *  @depreciated Since 1.10
	 */
	fnVersionCheck: DataTable.fnVersionCheck,


	/**
	 * Index for what 'this' index API functions should use
	 *  @type int
	 *  @deprecated Since v1.10
	 */
	iApiIndex: 0,


	/**
	 * jQuery UI class container
	 *  @type object
	 *  @deprecated Since v1.10
	 */
	oJUIClasses: {},


	/**
	 * Software version
	 *  @type string
	 *  @deprecated Since v1.10
	 */
	sVersion: DataTable.version
};


//
// Backwards compatibility. Alias to pre 1.10 Hungarian notation counter parts
//
$.extend( _ext, {
	afnFiltering: _ext.search,
	aTypes:       _ext.type.detect,
	ofnSearch:    _ext.type.search,
	oSort:        _ext.type.order,
	afnSortData:  _ext.order,
	aoFeatures:   _ext.feature,
	oApi:         _ext.internal,
	oStdClasses:  _ext.classes,
	oPagination:  _ext.pager
} );


$.extend( DataTable.ext.classes, {
	"sTable": "dataTable",
	"sNoFooter": "no-footer",

	/* Paging buttons */
	"sPageButton": "paginate_button",
	"sPageButtonActive": "current",
	"sPageButtonDisabled": "disabled",

	/* Striping classes */
	"sStripeOdd": "odd",
	"sStripeEven": "even",

	/* Empty row */
	"sRowEmpty": "dataTables_empty",

	/* Features */
	"sWrapper": "dataTables_wrapper",
	"sFilter": "dataTables_filter",
	"sInfo": "dataTables_info",
	"sPaging": "dataTables_paginate paging_", /* Note that the type is postfixed */
	"sLength": "dataTables_length",
	"sProcessing": "dataTables_processing",

	/* Sorting */
	"sSortAsc": "sorting_asc",
	"sSortDesc": "sorting_desc",
	"sSortable": "sorting", /* Sortable in both directions */
	"sSortableAsc": "sorting_desc_disabled",
	"sSortableDesc": "sorting_asc_disabled",
	"sSortableNone": "sorting_disabled",
	"sSortColumn": "sorting_", /* Note that an int is postfixed for the sorting order */

	/* Filtering */
	"sFilterInput": "",

	/* Page length */
	"sLengthSelect": "",

	/* Scrolling */
	"sScrollWrapper": "dataTables_scroll",
	"sScrollHead": "dataTables_scrollHead",
	"sScrollHeadInner": "dataTables_scrollHeadInner",
	"sScrollBody": "dataTables_scrollBody",
	"sScrollFoot": "dataTables_scrollFoot",
	"sScrollFootInner": "dataTables_scrollFootInner",

	/* Misc */
	"sHeaderTH": "",
	"sFooterTH": "",

	// Deprecated
	"sSortJUIAsc": "",
	"sSortJUIDesc": "",
	"sSortJUI": "",
	"sSortJUIAscAllowed": "",
	"sSortJUIDescAllowed": "",
	"sSortJUIWrapper": "",
	"sSortIcon": "",
	"sJUIHeader": "",
	"sJUIFooter": ""
} );


var extPagination = DataTable.ext.pager;

function _numbers ( page, pages ) {
	var
		numbers = [],
		buttons = extPagination.numbers_length,
		half = Math.floor( buttons / 2 ),
		i = 1;

	if ( pages <= buttons ) {
		numbers = _range( 0, pages );
	}
	else if ( page <= half ) {
		numbers = _range( 0, buttons-2 );
		numbers.push( 'ellipsis' );
		numbers.push( pages-1 );
	}
	else if ( page >= pages - 1 - half ) {
		numbers = _range( pages-(buttons-2), pages );
		numbers.splice( 0, 0, 'ellipsis' ); // no unshift in ie6
		numbers.splice( 0, 0, 0 );
	}
	else {
		numbers = _range( page-half+2, page+half-1 );
		numbers.push( 'ellipsis' );
		numbers.push( pages-1 );
		numbers.splice( 0, 0, 'ellipsis' );
		numbers.splice( 0, 0, 0 );
	}

	numbers.DT_el = 'span';
	return numbers;
}


$.extend( extPagination, {
	simple: function ( page, pages ) {
		return [ 'previous', 'next' ];
	},

	full: function ( page, pages ) {
		return [  'first', 'previous', 'next', 'last' ];
	},

	numbers: function ( page, pages ) {
		return [ _numbers(page, pages) ];
	},

	simple_numbers: function ( page, pages ) {
		return [ 'previous', _numbers(page, pages), 'next' ];
	},

	full_numbers: function ( page, pages ) {
		return [ 'first', 'previous', _numbers(page, pages), 'next', 'last' ];
	},
	
	first_last_numbers: function (page, pages) {
 		return ['first', _numbers(page, pages), 'last'];
 	},

	// For testing and plug-ins to use
	_numbers: _numbers,

	// Number of number buttons (including ellipsis) to show. _Must be odd!_
	numbers_length: 7
} );


$.extend( true, DataTable.ext.renderer, {
	pageButton: {
		_: function ( settings, host, idx, buttons, page, pages ) {
			var classes = settings.oClasses;
			var lang = settings.oLanguage.oPaginate;
			var aria = settings.oLanguage.oAria.paginate || {};
			var btnDisplay, btnClass;

			var attach = function( container, buttons ) {
				var i, ien, node, button, tabIndex;
				var disabledClass = classes.sPageButtonDisabled;
				var clickHandler = function ( e ) {
					_fnPageChange( settings, e.data.action, true );
				};

				for ( i=0, ien=buttons.length ; i<ien ; i++ ) {
					button = buttons[i];

					if ( Array.isArray( button ) ) {
						var inner = $( '<'+(button.DT_el || 'div')+'/>' )
							.appendTo( container );
						attach( inner, button );
					}
					else {
						btnDisplay = null;
						btnClass = button;
						tabIndex = settings.iTabIndex;

						switch ( button ) {
							case 'ellipsis':
								container.append('<span class="ellipsis">&#x2026;</span>');
								break;

							case 'first':
								btnDisplay = lang.sFirst;

								if ( page === 0 ) {
									tabIndex = -1;
									btnClass += ' ' + disabledClass;
								}
								break;

							case 'previous':
								btnDisplay = lang.sPrevious;

								if ( page === 0 ) {
									tabIndex = -1;
									btnClass += ' ' + disabledClass;
								}
								break;

							case 'next':
								btnDisplay = lang.sNext;

								if ( pages === 0 || page === pages-1 ) {
									tabIndex = -1;
									btnClass += ' ' + disabledClass;
								}
								break;

							case 'last':
								btnDisplay = lang.sLast;

								if ( pages === 0 || page === pages-1 ) {
									tabIndex = -1;
									btnClass += ' ' + disabledClass;
								}
								break;

							default:
								btnDisplay = settings.fnFormatNumber( button + 1 );
								btnClass = page === button ?
									classes.sPageButtonActive : '';
								break;
						}

						if ( btnDisplay !== null ) {
							var tag = settings.oInit.pagingTag || 'a';
							var disabled = btnClass.indexOf(disabledClass) !== -1;
		

							node = $('<'+tag+'>', {
									'class': classes.sPageButton+' '+btnClass,
									'aria-controls': settings.sTableId,
									'aria-disabled': disabled ? 'true' : null,
									'aria-label': aria[ button ],
									'role': 'link',
									'aria-current': btnClass === classes.sPageButtonActive ? 'page' : null,
									'data-dt-idx': button,
									'tabindex': tabIndex,
									'id': idx === 0 && typeof button === 'string' ?
										settings.sTableId +'_'+ button :
										null
								} )
								.html( btnDisplay )
								.appendTo( container );

							_fnBindAction(
								node, {action: button}, clickHandler
							);
						}
					}
				}
			};

			// IE9 throws an 'unknown error' if document.activeElement is used
			// inside an iframe or frame. Try / catch the error. Not good for
			// accessibility, but neither are frames.
			var activeEl;

			try {
				// Because this approach is destroying and recreating the paging
				// elements, focus is lost on the select button which is bad for
				// accessibility. So we want to restore focus once the draw has
				// completed
				activeEl = $(host).find(document.activeElement).data('dt-idx');
			}
			catch (e) {}

			attach( $(host).empty(), buttons );

			if ( activeEl !== undefined ) {
				$(host).find( '[data-dt-idx='+activeEl+']' ).trigger('focus');
			}
		}
	}
} );



// Built in type detection. See model.ext.aTypes for information about
// what is required from this methods.
$.extend( DataTable.ext.type.detect, [
	// Plain numbers - first since V8 detects some plain numbers as dates
	// e.g. Date.parse('55') (but not all, e.g. Date.parse('22')...).
	function ( d, settings )
	{
		var decimal = settings.oLanguage.sDecimal;
		return _isNumber( d, decimal ) ? 'num'+decimal : null;
	},

	// Dates (only those recognised by the browser's Date.parse)
	function ( d, settings )
	{
		// V8 tries _very_ hard to make a string passed into `Date.parse()`
		// valid, so we need to use a regex to restrict date formats. Use a
		// plug-in for anything other than ISO8601 style strings
		if ( d && !(d instanceof Date) && ! _re_date.test(d) ) {
			return null;
		}
		var parsed = Date.parse(d);
		return (parsed !== null && !isNaN(parsed)) || _empty(d) ? 'date' : null;
	},

	// Formatted numbers
	function ( d, settings )
	{
		var decimal = settings.oLanguage.sDecimal;
		return _isNumber( d, decimal, true ) ? 'num-fmt'+decimal : null;
	},

	// HTML numeric
	function ( d, settings )
	{
		var decimal = settings.oLanguage.sDecimal;
		return _htmlNumeric( d, decimal ) ? 'html-num'+decimal : null;
	},

	// HTML numeric, formatted
	function ( d, settings )
	{
		var decimal = settings.oLanguage.sDecimal;
		return _htmlNumeric( d, decimal, true ) ? 'html-num-fmt'+decimal : null;
	},

	// HTML (this is strict checking - there must be html)
	function ( d, settings )
	{
		return _empty( d ) || (typeof d === 'string' && d.indexOf('<') !== -1) ?
			'html' : null;
	}
] );



// Filter formatting functions. See model.ext.ofnSearch for information about
// what is required from these methods.
// 
// Note that additional search methods are added for the html numbers and
// html formatted numbers by `_addNumericSort()` when we know what the decimal
// place is


$.extend( DataTable.ext.type.search, {
	html: function ( data ) {
		return _empty(data) ?
			data :
			typeof data === 'string' ?
				data
					.replace( _re_new_lines, " " )
					.replace( _re_html, "" ) :
				'';
	},

	string: function ( data ) {
		return _empty(data) ?
			data :
			typeof data === 'string' ?
				data.replace( _re_new_lines, " " ) :
				data;
	}
} );



var __numericReplace = function ( d, decimalPlace, re1, re2 ) {
	if ( d !== 0 && (!d || d === '-') ) {
		return -Infinity;
	}
	
	var type = typeof d;

	if (type === 'number' || type === 'bigint') {
		return d;
	}

	// If a decimal place other than `.` is used, it needs to be given to the
	// function so we can detect it and replace with a `.` which is the only
	// decimal place Javascript recognises - it is not locale aware.
	if ( decimalPlace ) {
		d = _numToDecimal( d, decimalPlace );
	}

	if ( d.replace ) {
		if ( re1 ) {
			d = d.replace( re1, '' );
		}

		if ( re2 ) {
			d = d.replace( re2, '' );
		}
	}

	return d * 1;
};


// Add the numeric 'deformatting' functions for sorting and search. This is done
// in a function to provide an easy ability for the language options to add
// additional methods if a non-period decimal place is used.
function _addNumericSort ( decimalPlace ) {
	$.each(
		{
			// Plain numbers
			"num": function ( d ) {
				return __numericReplace( d, decimalPlace );
			},

			// Formatted numbers
			"num-fmt": function ( d ) {
				return __numericReplace( d, decimalPlace, _re_formatted_numeric );
			},

			// HTML numeric
			"html-num": function ( d ) {
				return __numericReplace( d, decimalPlace, _re_html );
			},

			// HTML numeric, formatted
			"html-num-fmt": function ( d ) {
				return __numericReplace( d, decimalPlace, _re_html, _re_formatted_numeric );
			}
		},
		function ( key, fn ) {
			// Add the ordering method
			_ext.type.order[ key+decimalPlace+'-pre' ] = fn;

			// For HTML types add a search formatter that will strip the HTML
			if ( key.match(/^html\-/) ) {
				_ext.type.search[ key+decimalPlace ] = _ext.type.search.html;
			}
		}
	);
}


// Default sort methods
$.extend( _ext.type.order, {
	// Dates
	"date-pre": function ( d ) {
		var ts = Date.parse( d );
		return isNaN(ts) ? -Infinity : ts;
	},

	// html
	"html-pre": function ( a ) {
		return _empty(a) ?
			'' :
			a.replace ?
				a.replace( /<.*?>/g, "" ).toLowerCase() :
				a+'';
	},

	// string
	"string-pre": function ( a ) {
		// This is a little complex, but faster than always calling toString,
		// http://jsperf.com/tostring-v-check
		return _empty(a) ?
			'' :
			typeof a === 'string' ?
				a.toLowerCase() :
				! a.toString ?
					'' :
					a.toString();
	},

	// string-asc and -desc are retained only for compatibility with the old
	// sort methods
	"string-asc": function ( x, y ) {
		return ((x < y) ? -1 : ((x > y) ? 1 : 0));
	},

	"string-desc": function ( x, y ) {
		return ((x < y) ? 1 : ((x > y) ? -1 : 0));
	}
} );


// Numeric sorting types - order doesn't matter here
_addNumericSort( '' );


$.extend( true, DataTable.ext.renderer, {
	header: {
		_: function ( settings, cell, column, classes ) {
			// No additional mark-up required
			// Attach a sort listener to update on sort - note that using the
			// `DT` namespace will allow the event to be removed automatically
			// on destroy, while the `dt` namespaced event is the one we are
			// listening for
			$(settings.nTable).on( 'order.dt.DT', function ( e, ctx, sorting, columns ) {
				if ( settings !== ctx ) { // need to check this this is the host
					return;               // table, not a nested one
				}

				var colIdx = column.idx;

				cell
					.removeClass(
						classes.sSortAsc +' '+
						classes.sSortDesc
					)
					.addClass( columns[ colIdx ] == 'asc' ?
						classes.sSortAsc : columns[ colIdx ] == 'desc' ?
							classes.sSortDesc :
							column.sSortingClass
					);
			} );
		},

		jqueryui: function ( settings, cell, column, classes ) {
			$('<div/>')
				.addClass( classes.sSortJUIWrapper )
				.append( cell.contents() )
				.append( $('<span/>')
					.addClass( classes.sSortIcon+' '+column.sSortingClassJUI )
				)
				.appendTo( cell );

			// Attach a sort listener to update on sort
			$(settings.nTable).on( 'order.dt.DT', function ( e, ctx, sorting, columns ) {
				if ( settings !== ctx ) {
					return;
				}

				var colIdx = column.idx;

				cell
					.removeClass( classes.sSortAsc +" "+classes.sSortDesc )
					.addClass( columns[ colIdx ] == 'asc' ?
						classes.sSortAsc : columns[ colIdx ] == 'desc' ?
							classes.sSortDesc :
							column.sSortingClass
					);

				cell
					.find( 'span.'+classes.sSortIcon )
					.removeClass(
						classes.sSortJUIAsc +" "+
						classes.sSortJUIDesc +" "+
						classes.sSortJUI +" "+
						classes.sSortJUIAscAllowed +" "+
						classes.sSortJUIDescAllowed
					)
					.addClass( columns[ colIdx ] == 'asc' ?
						classes.sSortJUIAsc : columns[ colIdx ] == 'desc' ?
							classes.sSortJUIDesc :
							column.sSortingClassJUI
					);
			} );
		}
	}
} );

/*
 * Public helper functions. These aren't used internally by DataTables, or
 * called by any of the options passed into DataTables, but they can be used
 * externally by developers working with DataTables. They are helper functions
 * to make working with DataTables a little bit easier.
 */

var __htmlEscapeEntities = function ( d ) {
	if (Array.isArray(d)) {
		d = d.join(',');
	}

	return typeof d === 'string' ?
		d
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;') :
		d;
};

// Common logic for moment, luxon or a date action
function __mld( dt, momentFn, luxonFn, dateFn, arg1 ) {
	if (window.moment) {
		return dt[momentFn]( arg1 );
	}
	else if (window.luxon) {
		return dt[luxonFn]( arg1 );
	}
	
	return dateFn ? dt[dateFn]( arg1 ) : dt;
}


var __mlWarning = false;
function __mldObj (d, format, locale) {
	var dt;

	if (window.moment) {
		dt = window.moment.utc( d, format, locale, true );

		if (! dt.isValid()) {
			return null;
		}
	}
	else if (window.luxon) {
		dt = format && typeof d === 'string'
			? window.luxon.DateTime.fromFormat( d, format )
			: window.luxon.DateTime.fromISO( d );

		if (! dt.isValid) {
			return null;
		}

		dt.setLocale(locale);
	}
	else if (! format) {
		// No format given, must be ISO
		dt = new Date(d);
	}
	else {
		if (! __mlWarning) {
			alert('DataTables warning: Formatted date without Moment.js or Luxon - https://datatables.net/tn/17');
		}

		__mlWarning = true;
	}

	return dt;
}

// Wrapper for date, datetime and time which all operate the same way with the exception of
// the output string for auto locale support
function __mlHelper (localeString) {
	return function ( from, to, locale, def ) {
		// Luxon and Moment support
		// Argument shifting
		if ( arguments.length === 0 ) {
			locale = 'en';
			to = null; // means toLocaleString
			from = null; // means iso8601
		}
		else if ( arguments.length === 1 ) {
			locale = 'en';
			to = from;
			from = null;
		}
		else if ( arguments.length === 2 ) {
			locale = to;
			to = from;
			from = null;
		}

		var typeName = 'datetime-' + to;

		// Add type detection and sorting specific to this date format - we need to be able to identify
		// date type columns as such, rather than as numbers in extensions. Hence the need for this.
		if (! DataTable.ext.type.order[typeName]) {
			// The renderer will give the value to type detect as the type!
			DataTable.ext.type.detect.unshift(function (d) {
				return d === typeName ? typeName : false;
			});

			// The renderer gives us Moment, Luxon or Date obects for the sorting, all of which have a
			// `valueOf` which gives milliseconds epoch
			DataTable.ext.type.order[typeName + '-asc'] = function (a, b) {
				var x = a.valueOf();
				var y = b.valueOf();

				return x === y
					? 0
					: x < y
						? -1
						: 1;
			}

			DataTable.ext.type.order[typeName + '-desc'] = function (a, b) {
				var x = a.valueOf();
				var y = b.valueOf();

				return x === y
					? 0
					: x > y
						? -1
						: 1;
			}
		}
	
		return function ( d, type ) {
			// Allow for a default value
			if (d === null || d === undefined) {
				if (def === '--now') {
					// We treat everything as UTC further down, so no changes are
					// made, as such need to get the local date / time as if it were
					// UTC
					var local = new Date();
					d = new Date( Date.UTC(
						local.getFullYear(), local.getMonth(), local.getDate(),
						local.getHours(), local.getMinutes(), local.getSeconds()
					) );
				}
				else {
					d = '';
				}
			}

			if (type === 'type') {
				// Typing uses the type name for fast matching
				return typeName;
			}

			if (d === '') {
				return type !== 'sort'
					? ''
					: __mldObj('0000-01-01 00:00:00', null, locale);
			}

			// Shortcut. If `from` and `to` are the same, we are using the renderer to
			// format for ordering, not display - its already in the display format.
			if ( to !== null && from === to && type !== 'sort' && type !== 'type' && ! (d instanceof Date) ) {
				return d;
			}

			var dt = __mldObj(d, from, locale);

			if (dt === null) {
				return d;
			}

			if (type === 'sort') {
				return dt;
			}
			
			var formatted = to === null
				? __mld(dt, 'toDate', 'toJSDate', '')[localeString]()
				: __mld(dt, 'format', 'toFormat', 'toISOString', to);

			// XSS protection
			return type === 'display' ?
				__htmlEscapeEntities( formatted ) :
				formatted;
		};
	}
}

// Based on locale, determine standard number formatting
// Fallback for legacy browsers is US English
var __thousands = ',';
var __decimal = '.';

if (window.Intl !== undefined) {
	try {
		var num = new Intl.NumberFormat().formatToParts(100000.1);
	
		for (var i=0 ; i<num.length ; i++) {
			if (num[i].type === 'group') {
				__thousands = num[i].value;
			}
			else if (num[i].type === 'decimal') {
				__decimal = num[i].value;
			}
		}
	}
	catch (e) {
		// noop
	}
}

// Formatted date time detection - use by declaring the formats you are going to use
DataTable.datetime = function ( format, locale ) {
	var typeName = 'datetime-detect-' + format;

	if (! locale) {
		locale = 'en';
	}

	if (! DataTable.ext.type.order[typeName]) {
		DataTable.ext.type.detect.unshift(function (d) {
			var dt = __mldObj(d, format, locale);
			return d === '' || dt ? typeName : false;
		});

		DataTable.ext.type.order[typeName + '-pre'] = function (d) {
			return __mldObj(d, format, locale) || 0;
		}
	}
}

/**
 * Helpers for `columns.render`.
 *
 * The options defined here can be used with the `columns.render` initialisation
 * option to provide a display renderer. The following functions are defined:
 *
 * * `number` - Will format numeric data (defined by `columns.data`) for
 *   display, retaining the original unformatted data for sorting and filtering.
 *   It takes 5 parameters:
 *   * `string` - Thousands grouping separator
 *   * `string` - Decimal point indicator
 *   * `integer` - Number of decimal points to show
 *   * `string` (optional) - Prefix.
 *   * `string` (optional) - Postfix (/suffix).
 * * `text` - Escape HTML to help prevent XSS attacks. It has no optional
 *   parameters.
 *
 * @example
 *   // Column definition using the number renderer
 *   {
 *     data: "salary",
 *     render: $.fn.dataTable.render.number( '\'', '.', 0, '$' )
 *   }
 *
 * @namespace
 */
DataTable.render = {
	date: __mlHelper('toLocaleDateString'),
	datetime: __mlHelper('toLocaleString'),
	time: __mlHelper('toLocaleTimeString'),
	number: function ( thousands, decimal, precision, prefix, postfix ) {
		// Auto locale detection
		if (thousands === null || thousands === undefined) {
			thousands = __thousands;
		}

		if (decimal === null || decimal === undefined) {
			decimal = __decimal;
		}

		return {
			display: function ( d ) {
				if ( typeof d !== 'number' && typeof d !== 'string' ) {
					return d;
				}

				if (d === '' || d === null) {
					return d;
				}

				var negative = d < 0 ? '-' : '';
				var flo = parseFloat( d );

				// If NaN then there isn't much formatting that we can do - just
				// return immediately, escaping any HTML (this was supposed to
				// be a number after all)
				if ( isNaN( flo ) ) {
					return __htmlEscapeEntities( d );
				}

				flo = flo.toFixed( precision );
				d = Math.abs( flo );

				var intPart = parseInt( d, 10 );
				var floatPart = precision ?
					decimal+(d - intPart).toFixed( precision ).substring( 2 ):
					'';

				// If zero, then can't have a negative prefix
				if (intPart === 0 && parseFloat(floatPart) === 0) {
					negative = '';
				}

				return negative + (prefix||'') +
					intPart.toString().replace(
						/\B(?=(\d{3})+(?!\d))/g, thousands
					) +
					floatPart +
					(postfix||'');
			}
		};
	},

	text: function () {
		return {
			display: __htmlEscapeEntities,
			filter: __htmlEscapeEntities
		};
	}
};


/*
 * This is really a good bit rubbish this method of exposing the internal methods
 * publicly... - To be fixed in 2.0 using methods on the prototype
 */


/**
 * Create a wrapper function for exporting an internal functions to an external API.
 *  @param {string} fn API function name
 *  @returns {function} wrapped function
 *  @memberof DataTable#internal
 */
function _fnExternApiFunc (fn)
{
	return function() {
		var args = [_fnSettingsFromNode( this[DataTable.ext.iApiIndex] )].concat(
			Array.prototype.slice.call(arguments)
		);
		return DataTable.ext.internal[fn].apply( this, args );
	};
}


/**
 * Reference to internal functions for use by plug-in developers. Note that
 * these methods are references to internal functions and are considered to be
 * private. If you use these methods, be aware that they are liable to change
 * between versions.
 *  @namespace
 */
$.extend( DataTable.ext.internal, {
	_fnExternApiFunc: _fnExternApiFunc,
	_fnBuildAjax: _fnBuildAjax,
	_fnAjaxUpdate: _fnAjaxUpdate,
	_fnAjaxParameters: _fnAjaxParameters,
	_fnAjaxUpdateDraw: _fnAjaxUpdateDraw,
	_fnAjaxDataSrc: _fnAjaxDataSrc,
	_fnAddColumn: _fnAddColumn,
	_fnColumnOptions: _fnColumnOptions,
	_fnAdjustColumnSizing: _fnAdjustColumnSizing,
	_fnVisibleToColumnIndex: _fnVisibleToColumnIndex,
	_fnColumnIndexToVisible: _fnColumnIndexToVisible,
	_fnVisbleColumns: _fnVisbleColumns,
	_fnGetColumns: _fnGetColumns,
	_fnColumnTypes: _fnColumnTypes,
	_fnApplyColumnDefs: _fnApplyColumnDefs,
	_fnHungarianMap: _fnHungarianMap,
	_fnCamelToHungarian: _fnCamelToHungarian,
	_fnLanguageCompat: _fnLanguageCompat,
	_fnBrowserDetect: _fnBrowserDetect,
	_fnAddData: _fnAddData,
	_fnAddTr: _fnAddTr,
	_fnNodeToDataIndex: _fnNodeToDataIndex,
	_fnNodeToColumnIndex: _fnNodeToColumnIndex,
	_fnGetCellData: _fnGetCellData,
	_fnSetCellData: _fnSetCellData,
	_fnSplitObjNotation: _fnSplitObjNotation,
	_fnGetObjectDataFn: _fnGetObjectDataFn,
	_fnSetObjectDataFn: _fnSetObjectDataFn,
	_fnGetDataMaster: _fnGetDataMaster,
	_fnClearTable: _fnClearTable,
	_fnDeleteIndex: _fnDeleteIndex,
	_fnInvalidate: _fnInvalidate,
	_fnGetRowElements: _fnGetRowElements,
	_fnCreateTr: _fnCreateTr,
	_fnBuildHead: _fnBuildHead,
	_fnDrawHead: _fnDrawHead,
	_fnDraw: _fnDraw,
	_fnReDraw: _fnReDraw,
	_fnAddOptionsHtml: _fnAddOptionsHtml,
	_fnDetectHeader: _fnDetectHeader,
	_fnGetUniqueThs: _fnGetUniqueThs,
	_fnFeatureHtmlFilter: _fnFeatureHtmlFilter,
	_fnFilterComplete: _fnFilterComplete,
	_fnFilterCustom: _fnFilterCustom,
	_fnFilterColumn: _fnFilterColumn,
	_fnFilter: _fnFilter,
	_fnFilterCreateSearch: _fnFilterCreateSearch,
	_fnEscapeRegex: _fnEscapeRegex,
	_fnFilterData: _fnFilterData,
	_fnFeatureHtmlInfo: _fnFeatureHtmlInfo,
	_fnUpdateInfo: _fnUpdateInfo,
	_fnInfoMacros: _fnInfoMacros,
	_fnInitialise: _fnInitialise,
	_fnInitComplete: _fnInitComplete,
	_fnLengthChange: _fnLengthChange,
	_fnFeatureHtmlLength: _fnFeatureHtmlLength,
	_fnFeatureHtmlPaginate: _fnFeatureHtmlPaginate,
	_fnPageChange: _fnPageChange,
	_fnFeatureHtmlProcessing: _fnFeatureHtmlProcessing,
	_fnProcessingDisplay: _fnProcessingDisplay,
	_fnFeatureHtmlTable: _fnFeatureHtmlTable,
	_fnScrollDraw: _fnScrollDraw,
	_fnApplyToChildren: _fnApplyToChildren,
	_fnCalculateColumnWidths: _fnCalculateColumnWidths,
	_fnThrottle: _fnThrottle,
	_fnConvertToWidth: _fnConvertToWidth,
	_fnGetWidestNode: _fnGetWidestNode,
	_fnGetMaxLenString: _fnGetMaxLenString,
	_fnStringToCss: _fnStringToCss,
	_fnSortFlatten: _fnSortFlatten,
	_fnSort: _fnSort,
	_fnSortAria: _fnSortAria,
	_fnSortListener: _fnSortListener,
	_fnSortAttachListener: _fnSortAttachListener,
	_fnSortingClasses: _fnSortingClasses,
	_fnSortData: _fnSortData,
	_fnSaveState: _fnSaveState,
	_fnLoadState: _fnLoadState,
	_fnImplementState: _fnImplementState,
	_fnSettingsFromNode: _fnSettingsFromNode,
	_fnLog: _fnLog,
	_fnMap: _fnMap,
	_fnBindAction: _fnBindAction,
	_fnCallbackReg: _fnCallbackReg,
	_fnCallbackFire: _fnCallbackFire,
	_fnLengthOverflow: _fnLengthOverflow,
	_fnRenderer: _fnRenderer,
	_fnDataSource: _fnDataSource,
	_fnRowAttributes: _fnRowAttributes,
	_fnExtend: _fnExtend,
	_fnCalculateEnd: function () {} // Used by a lot of plug-ins, but redundant
	                                // in 1.10, so this dead-end function is
	                                // added to prevent errors
} );


// jQuery access
$.fn.dataTable = DataTable;

// Provide access to the host jQuery object (circular reference)
DataTable.$ = $;

// Legacy aliases
$.fn.dataTableSettings = DataTable.settings;
$.fn.dataTableExt = DataTable.ext;

// With a capital `D` we return a DataTables API instance rather than a
// jQuery object
$.fn.DataTable = function ( opts ) {
	return $(this).dataTable( opts ).api();
};

// All properties that are available to $.fn.dataTable should also be
// available on $.fn.DataTable
$.each( DataTable, function ( prop, val ) {
	$.fn.DataTable[ prop ] = val;
} );

/* unused harmony default export */ var _unused_webpack_default_export = (DataTable);


/***/ }),
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(744),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, jQuery) {/*! AdminLTE app.js
 * ================
 * Main JS application file for AdminLTE v2. This file
 * should be included in all pages. It controls some layout
 * options and implements exclusive AdminLTE plugins.
 *
 * @Author  Almsaeed Studio
 * @Support <http://www.almsaeedstudio.com>
 * @Email   <abdullah@almsaeedstudio.com>
 * @version 2.3.12
 * @license MIT <http://opensource.org/licenses/MIT>
 */
function _init(){"use strict";$.AdminLTE.layout={activate:function(){var a=this;a.fix(),a.fixSidebar(),$("body, html, .wrapper").css("height","auto"),$(window,".wrapper").resize(function(){a.fix(),a.fixSidebar()})},fix:function(){$(".layout-boxed > .wrapper").css("overflow","hidden");var a=$(".main-footer").outerHeight()||0,b=$(".main-header").outerHeight()+a,c=$(window).height(),d=$(".sidebar").height()||0;if($("body").hasClass("fixed"))$(".content-wrapper, .right-side").css("min-height",c-a);else{var e;c>=d?($(".content-wrapper, .right-side").css("min-height",c-b),e=c-b):($(".content-wrapper, .right-side").css("min-height",d),e=d);var f=$($.AdminLTE.options.controlSidebarOptions.selector);"undefined"!=typeof f&&f.height()>e&&$(".content-wrapper, .right-side").css("min-height",f.height())}},fixSidebar:function(){return $("body").hasClass("fixed")?("undefined"==typeof $.fn.slimScroll&&window.console&&window.console.error("Error: the fixed layout requires the slimscroll plugin!"),void($.AdminLTE.options.sidebarSlimScroll&&"undefined"!=typeof $.fn.slimScroll&&($(".sidebar").slimScroll({destroy:!0}).height("auto"),$(".sidebar").slimScroll({height:$(window).height()-$(".main-header").height()+"px",color:"rgba(0,0,0,0.2)",size:"3px"})))):void("undefined"!=typeof $.fn.slimScroll&&$(".sidebar").slimScroll({destroy:!0}).height("auto"))}},$.AdminLTE.pushMenu={activate:function(a){var b=$.AdminLTE.options.screenSizes;$(document).on("click",a,function(a){a.preventDefault(),$(window).width()>b.sm-1?$("body").hasClass("sidebar-collapse")?$("body").removeClass("sidebar-collapse").trigger("expanded.pushMenu"):$("body").addClass("sidebar-collapse").trigger("collapsed.pushMenu"):$("body").hasClass("sidebar-open")?$("body").removeClass("sidebar-open").removeClass("sidebar-collapse").trigger("collapsed.pushMenu"):$("body").addClass("sidebar-open").trigger("expanded.pushMenu")}),$(".content-wrapper").click(function(){$(window).width()<=b.sm-1&&$("body").hasClass("sidebar-open")&&$("body").removeClass("sidebar-open")}),($.AdminLTE.options.sidebarExpandOnHover||$("body").hasClass("fixed")&&$("body").hasClass("sidebar-mini"))&&this.expandOnHover()},expandOnHover:function(){var a=this,b=$.AdminLTE.options.screenSizes.sm-1;$(".main-sidebar").hover(function(){$("body").hasClass("sidebar-mini")&&$("body").hasClass("sidebar-collapse")&&$(window).width()>b&&a.expand()},function(){$("body").hasClass("sidebar-mini")&&$("body").hasClass("sidebar-expanded-on-hover")&&$(window).width()>b&&a.collapse()})},expand:function(){$("body").removeClass("sidebar-collapse").addClass("sidebar-expanded-on-hover")},collapse:function(){$("body").hasClass("sidebar-expanded-on-hover")&&$("body").removeClass("sidebar-expanded-on-hover").addClass("sidebar-collapse")}},$.AdminLTE.tree=function(a){var b=this,c=$.AdminLTE.options.animationSpeed;$(document).off("click",a+" li a").on("click",a+" li a",function(a){var d=$(this),e=d.next();if(e.is(".treeview-menu")&&e.is(":visible")&&!$("body").hasClass("sidebar-collapse"))e.slideUp(c,function(){e.removeClass("menu-open")}),e.parent("li").removeClass("active");else if(e.is(".treeview-menu")&&!e.is(":visible")){var f=d.parents("ul").first(),g=f.find("ul:visible").slideUp(c);g.removeClass("menu-open");var h=d.parent("li");e.slideDown(c,function(){e.addClass("menu-open"),f.find("li.active").removeClass("active"),h.addClass("active"),b.layout.fix()})}e.is(".treeview-menu")&&a.preventDefault()})},$.AdminLTE.controlSidebar={activate:function(){var a=this,b=$.AdminLTE.options.controlSidebarOptions,c=$(b.selector),d=$(b.toggleBtnSelector);d.on("click",function(d){d.preventDefault(),c.hasClass("control-sidebar-open")||$("body").hasClass("control-sidebar-open")?a.close(c,b.slide):a.open(c,b.slide)});var e=$(".control-sidebar-bg");a._fix(e),$("body").hasClass("fixed")?a._fixForFixed(c):$(".content-wrapper, .right-side").height()<c.height()&&a._fixForContent(c)},open:function(a,b){b?a.addClass("control-sidebar-open"):$("body").addClass("control-sidebar-open")},close:function(a,b){b?a.removeClass("control-sidebar-open"):$("body").removeClass("control-sidebar-open")},_fix:function(a){var b=this;if($("body").hasClass("layout-boxed")){if(a.css("position","absolute"),a.height($(".wrapper").height()),b.hasBindedResize)return;$(window).resize(function(){b._fix(a)}),b.hasBindedResize=!0}else a.css({position:"fixed",height:"auto"})},_fixForFixed:function(a){a.css({position:"fixed","max-height":"100%",overflow:"auto","padding-bottom":"50px"})},_fixForContent:function(a){$(".content-wrapper, .right-side").css("min-height",a.height())}},$.AdminLTE.boxWidget={selectors:$.AdminLTE.options.boxWidgetOptions.boxWidgetSelectors,icons:$.AdminLTE.options.boxWidgetOptions.boxWidgetIcons,animationSpeed:$.AdminLTE.options.animationSpeed,activate:function(a){var b=this;a||(a=document),$(a).on("click",b.selectors.collapse,function(a){a.preventDefault(),b.collapse($(this))}),$(a).on("click",b.selectors.remove,function(a){a.preventDefault(),b.remove($(this))})},collapse:function(a){var b=this,c=a.parents(".box").first(),d=c.find("> .box-body, > .box-footer, > form  >.box-body, > form > .box-footer");c.hasClass("collapsed-box")?(a.children(":first").removeClass(b.icons.open).addClass(b.icons.collapse),d.slideDown(b.animationSpeed,function(){c.removeClass("collapsed-box")})):(a.children(":first").removeClass(b.icons.collapse).addClass(b.icons.open),d.slideUp(b.animationSpeed,function(){c.addClass("collapsed-box")}))},remove:function(a){var b=a.parents(".box").first();b.slideUp(this.animationSpeed)}}}if("undefined"==typeof jQuery)throw new Error("AdminLTE requires jQuery");$.AdminLTE={},$.AdminLTE.options={navbarMenuSlimscroll:!0,navbarMenuSlimscrollWidth:"3px",navbarMenuHeight:"200px",animationSpeed:500,sidebarToggleSelector:"[data-toggle='offcanvas']",sidebarPushMenu:!0,sidebarSlimScroll:!0,sidebarExpandOnHover:!1,enableBoxRefresh:!0,enableBSToppltip:!0,BSTooltipSelector:"[data-toggle='tooltip']",enableFastclick:!1,enableControlTreeView:!0,enableControlSidebar:!0,controlSidebarOptions:{toggleBtnSelector:"[data-toggle='control-sidebar']",selector:".control-sidebar",slide:!0},enableBoxWidget:!0,boxWidgetOptions:{boxWidgetIcons:{collapse:"fa-minus",open:"fa-plus",remove:"fa-times"},boxWidgetSelectors:{remove:'[data-widget="remove"]',collapse:'[data-widget="collapse"]'}},directChat:{enable:!0,contactToggleSelector:'[data-widget="chat-pane-toggle"]'},colors:{lightBlue:"#3c8dbc",red:"#f56954",green:"#00a65a",aqua:"#00c0ef",yellow:"#f39c12",blue:"#0073b7",navy:"#001F3F",teal:"#39CCCC",olive:"#3D9970",lime:"#01FF70",orange:"#FF851B",fuchsia:"#F012BE",purple:"#8E24AA",maroon:"#D81B60",black:"#222222",gray:"#d2d6de"},screenSizes:{xs:480,sm:768,md:992,lg:1200}},$(function(){"use strict";$("body").removeClass("hold-transition"),"undefined"!=typeof AdminLTEOptions&&$.extend(!0,$.AdminLTE.options,AdminLTEOptions);var a=$.AdminLTE.options;_init(),$.AdminLTE.layout.activate(),a.enableControlTreeView&&$.AdminLTE.tree(".sidebar"),a.enableControlSidebar&&$.AdminLTE.controlSidebar.activate(),a.navbarMenuSlimscroll&&"undefined"!=typeof $.fn.slimscroll&&$(".navbar .menu").slimscroll({height:a.navbarMenuHeight,alwaysVisible:!1,size:a.navbarMenuSlimscrollWidth}).css("width","100%"),a.sidebarPushMenu&&$.AdminLTE.pushMenu.activate(a.sidebarToggleSelector),a.enableBSToppltip&&$("body").tooltip({selector:a.BSTooltipSelector,container:"body"}),a.enableBoxWidget&&$.AdminLTE.boxWidget.activate(),a.enableFastclick&&"undefined"!=typeof FastClick&&FastClick.attach(document.body),a.directChat.enable&&$(document).on("click",a.directChat.contactToggleSelector,function(){var a=$(this).parents(".direct-chat").first();a.toggleClass("direct-chat-contacts-open")}),$('.btn-group[data-toggle="btn-toggle"]').each(function(){var a=$(this);$(this).find(".btn").on("click",function(b){a.find(".btn.active").removeClass("active"),$(this).addClass("active"),b.preventDefault()})})}),function(a){"use strict";a.fn.boxRefresh=function(b){function c(a){a.append(f),e.onLoadStart.call(a)}function d(a){a.find(f).remove(),e.onLoadDone.call(a)}var e=a.extend({trigger:".refresh-btn",source:"",onLoadStart:function(a){return a},onLoadDone:function(a){return a}},b),f=a('<div class="overlay"><div class="fa fa-refresh fa-spin"></div></div>');return this.each(function(){if(""===e.source)return void(window.console&&window.console.log("Please specify a source first - boxRefresh()"));var b=a(this),f=b.find(e.trigger).first();f.on("click",function(a){a.preventDefault(),c(b),b.find(".box-body").load(e.source,function(){d(b)})})})}}(jQuery),function(a){"use strict";a.fn.activateBox=function(){a.AdminLTE.boxWidget.activate(this)},a.fn.toggleBox=function(){var b=a(a.AdminLTE.boxWidget.selectors.collapse,this);a.AdminLTE.boxWidget.collapse(b)},a.fn.removeBox=function(){var b=a(a.AdminLTE.boxWidget.selectors.remove,this);a.AdminLTE.boxWidget.remove(b)}}(jQuery),function(a){"use strict";a.fn.todolist=function(b){var c=a.extend({onCheck:function(a){return a},onUncheck:function(a){return a}},b);return this.each(function(){"undefined"!=typeof a.fn.iCheck?(a("input",this).on("ifChecked",function(){var b=a(this).parents("li").first();b.toggleClass("done"),c.onCheck.call(b)}),a("input",this).on("ifUnchecked",function(){var b=a(this).parents("li").first();b.toggleClass("done"),c.onUncheck.call(b)})):a("input",this).on("change",function(){var b=a(this).parents("li").first();b.toggleClass("done"),a("input",b).is(":checked")?c.onCheck.call(b):c.onUncheck.call(b)})})}}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(4)))

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*! DataTables Bootstrap 3 integration
 * ©2011-2014 SpryMedia Ltd - datatables.net/license
 */

/**
 * DataTables integration for Bootstrap 3. This requires Bootstrap 3 and
 * DataTables 1.10 or newer.
 *
 * This file sets the defaults and adds options to DataTables to style its
 * controls using Bootstrap. See http://datatables.net/manual/styling/bootstrap
 * for further information.
 */
(function(window, document, undefined){

var factory = function( $, DataTable ) {
"use strict";


/* Set the defaults for DataTables initialisation */
$.extend( true, DataTable.defaults, {
	dom:
		"<'row'<'col-sm-6'l><'col-sm-6'f>>" +
		"<'row'<'col-sm-12'tr>>" +
		"<'row'<'col-sm-5'i><'col-sm-7'p>>",
	renderer: 'bootstrap'
} );


/* Default class modification */
$.extend( DataTable.ext.classes, {
	sWrapper:      "dataTables_wrapper form-inline dt-bootstrap",
	sFilterInput:  "form-control input-sm",
	sLengthSelect: "form-control input-sm"
} );


/* Bootstrap paging button renderer */
DataTable.ext.renderer.pageButton.bootstrap = function ( settings, host, idx, buttons, page, pages ) {
	var api     = new DataTable.Api( settings );
	var classes = settings.oClasses;
	var lang    = settings.oLanguage.oPaginate;
	var btnDisplay, btnClass, counter=0;

	var attach = function( container, buttons ) {
		var i, ien, node, button;
		var clickHandler = function ( e ) {
			e.preventDefault();
			if ( !$(e.currentTarget).hasClass('disabled') ) {
				api.page( e.data.action ).draw( false );
			}
		};

		for ( i=0, ien=buttons.length ; i<ien ; i++ ) {
			button = buttons[i];

			if ( $.isArray( button ) ) {
				attach( container, button );
			}
			else {
				btnDisplay = '';
				btnClass = '';

				switch ( button ) {
					case 'ellipsis':
						btnDisplay = '&hellip;';
						btnClass = 'disabled';
						break;

					case 'first':
						btnDisplay = lang.sFirst;
						btnClass = button + (page > 0 ?
							'' : ' disabled');
						break;

					case 'previous':
						btnDisplay = lang.sPrevious;
						btnClass = button + (page > 0 ?
							'' : ' disabled');
						break;

					case 'next':
						btnDisplay = lang.sNext;
						btnClass = button + (page < pages-1 ?
							'' : ' disabled');
						break;

					case 'last':
						btnDisplay = lang.sLast;
						btnClass = button + (page < pages-1 ?
							'' : ' disabled');
						break;

					default:
						btnDisplay = button + 1;
						btnClass = page === button ?
							'active' : '';
						break;
				}

				if ( btnDisplay ) {
					node = $('<li>', {
							'class': classes.sPageButton+' '+btnClass,
							'id': idx === 0 && typeof button === 'string' ?
								settings.sTableId +'_'+ button :
								null
						} )
						.append( $('<a>', {
								'href': '#',
								'aria-controls': settings.sTableId,
								'data-dt-idx': counter,
								'tabindex': settings.iTabIndex
							} )
							.html( btnDisplay )
						)
						.appendTo( container );

					settings.oApi._fnBindAction(
						node, {action: button}, clickHandler
					);

					counter++;
				}
			}
		}
	};

	// IE9 throws an 'unknown error' if document.activeElement is used
	// inside an iframe or frame.
	var activeEl;

	try {
		// Because this approach is destroying and recreating the paging
		// elements, focus is lost on the select button which is bad for
		// accessibility. So we want to restore focus once the draw has
		// completed
		activeEl = $(document.activeElement).data('dt-idx');
	}
	catch (e) {}

	attach(
		$(host).empty().html('<ul class="pagination"/>').children('ul'),
		buttons
	);

	if ( activeEl ) {
		$(host).find( '[data-dt-idx='+activeEl+']' ).focus();
	}
};


/*
 * TableTools Bootstrap compatibility
 * Required TableTools 2.1+
 */
if ( DataTable.TableTools ) {
	// Set the classes that TableTools uses to something suitable for Bootstrap
	$.extend( true, DataTable.TableTools.classes, {
		"container": "DTTT btn-group",
		"buttons": {
			"normal": "btn btn-default",
			"disabled": "disabled"
		},
		"collection": {
			"container": "DTTT_dropdown dropdown-menu",
			"buttons": {
				"normal": "",
				"disabled": "disabled"
			}
		},
		"print": {
			"info": "DTTT_print_info"
		},
		"select": {
			"row": "active"
		}
	} );

	// Have the collection use a bootstrap compatible drop down
	$.extend( true, DataTable.TableTools.DEFAULTS.oTags, {
		"collection": {
			"container": "ul",
			"button": "li",
			"liner": "a"
		}
	} );
}

}; // /factory


if ( jQuery ) {
	// Otherwise simply initialise as normal, stopping multiple evaluation
	factory( jQuery, jQuery.fn.dataTable );
}


})(window, document);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_config__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_i18n__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_translations_js__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_html5_editor__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_html5_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_html5_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_google_maps__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_progressbar__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_notification__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_notification__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

__webpack_require__(344);

__webpack_require__(345);












__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_i18n__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_6_vue_i18n__["a" /* default */]({
  locale: 'pt',
  messages: __WEBPACK_IMPORTED_MODULE_7__i18n_translations_js__["a" /* default */]
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_config___default.a, __WEBPACK_IMPORTED_MODULE_8__config___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_html5_editor___default.a, {
  showModuleName: true,
  image: {
    sizeLimit: 512 * 1024,
    compress: true,
    width: 500,
    height: 500,
    quality: 80
  },
  hiddenModules: ['full-screen']
});
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue2_google_maps__, {
  load: {
    key: 'AIzaSyCcLej7e0XowuzLDp8ur4K_-_lR1p4UhN8'
  }
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_progressbar___default.a, {
  color: '#B1D3E7',
  failedColor: '#874b4b',
  thickness: '5px',
  transition: {
    speed: '0.3s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_notification___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a },
  i18n: i18n
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_admin_Home__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_admin_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_admin_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_quizzes_ParkQuizValidationList__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_quizzes_ParkQuizValidationList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_quizzes_ParkQuizValidationList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_quizzes_ParkQuizValidation__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_quizzes_ParkQuizValidation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_quizzes_ParkQuizValidation__);




var routes = [{
  path: '/admin',
  name: 'AdminHome',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_admin_Home___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_ADMIN']
  }
}, {
  path: '/park-quiz-validation-list',
  name: 'ParkQuizValidationList',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_quizzes_ParkQuizValidationList___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_ADMIN']
  }
}, {
  path: '/park-quiz-validation/:parkId/:referenceYear/:quizUuid/:parkName?',
  name: 'ParkQuizValidation',
  component: __WEBPACK_IMPORTED_MODULE_2__pages_quizzes_ParkQuizValidation___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_ADMIN']
  },
  props: true
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_cms_ParksCms__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_cms_ParksCms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_cms_ParksCms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_cms_AboutCms__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_cms_AboutCms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_cms_AboutCms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_cms_CompaniesCms__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_cms_CompaniesCms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_cms_CompaniesCms__);




var routes = [{
  path: '/parks-cms',
  name: 'ParksCms',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_cms_ParksCms___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_ADMIN']
  }
}, {
  path: '/about-cms',
  name: 'AboutCms',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_cms_AboutCms___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_ADMIN']
  }
}, {
  path: '/companies-cms',
  name: 'CompaniesCms',
  component: __WEBPACK_IMPORTED_MODULE_2__pages_cms_CompaniesCms___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_ADMIN']
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_companies_CompaniesHome__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_companies_CompaniesHome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_companies_CompaniesHome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_companies_CreateCompany__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_companies_CreateCompany___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_companies_CreateCompany__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_companies_EditCompany__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_companies_EditCompany___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_companies_EditCompany__);




var routes = [{
  path: '/companies/:parkId',
  name: 'CompaniesHome',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_companies_CompaniesHome___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_PARK']
  },
  props: true
}, {
  path: '/create-company/:parkId',
  name: 'CreateCompany',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_companies_CreateCompany___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_PARK']
  },
  props: true
}, {
  path: '/edit-company/:id',
  name: 'EditCompany',
  component: __WEBPACK_IMPORTED_MODULE_2__pages_companies_EditCompany___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_PARK']
  },
  props: true
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_error_ServerError__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_error_ServerError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_error_ServerError__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_error_NotFoundError__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_error_NotFoundError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_error_NotFoundError__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_error_UnauthorizedError__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_error_UnauthorizedError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_error_UnauthorizedError__);




var routes = [{
  path: '/server-error',
  name: 'ServerError',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_error_ServerError___default.a
}, {
  path: '/not-found-error',
  name: 'NotFoundError',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_error_NotFoundError___default.a
}, {
  path: '/unauthorized-error',
  name: 'UnauthorizedError',
  component: __WEBPACK_IMPORTED_MODULE_2__pages_error_UnauthorizedError___default.a
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_export_ExportParks__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_export_ExportParks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_export_ExportParks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_export_ExportCompanies__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_export_ExportCompanies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_export_ExportCompanies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_export_ExportGeneralInformation__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_export_ExportGeneralInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_export_ExportGeneralInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_export_ExportParkQuiz__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_export_ExportParkQuiz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_export_ExportParkQuiz__);






var routes = [{
  path: '/export/parks',
  name: 'ExportParks',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_export_ExportParks___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_RESEARCHER'],
    preLoad: function preLoad(to, authentication, router) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (authentication.userHasResearcherRole()) {
          resolve();
          return;
        }
        reject();
        router.push({ name: 'UnauthorizedError' });
      });
    }
  }
}, {
  path: '/export/companies',
  name: 'ExportCompanies',
  component: __WEBPACK_IMPORTED_MODULE_2__pages_export_ExportCompanies___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_RESEARCHER'],
    preLoad: function preLoad(to, authentication, router) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (authentication.userHasResearcherRole()) {
          resolve();
          return;
        }
        reject();
        router.push({ name: 'UnauthorizedError' });
      });
    }
  }
}, {
  path: '/export/general-information',
  name: 'ExportGeneralInformation',
  component: __WEBPACK_IMPORTED_MODULE_3__pages_export_ExportGeneralInformation___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_RESEARCHER'],
    preLoad: function preLoad(to, authentication, router) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (authentication.userHasResearcherRole()) {
          resolve();
          return;
        }
        reject();
        router.push({ name: 'UnauthorizedError' });
      });
    }
  }
}, {
  path: '/export/park-quiz',
  name: 'ExportParkQuiz',
  component: __WEBPACK_IMPORTED_MODULE_4__pages_export_ExportParkQuiz___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_RESEARCHER'],
    preLoad: function preLoad(to, authentication, router) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (authentication.userHasResearcherRole()) {
          resolve();
          return;
        }
        reject();
        router.push({ name: 'UnauthorizedError' });
      });
    }
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_mailing_MailingHome__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_mailing_MailingHome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_mailing_MailingHome__);


var routes = [{
  path: '/mailing',
  name: 'MailingHome',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_mailing_MailingHome___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_ADMIN']
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_maintenance_ParkStageAudit__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_maintenance_ParkStageAudit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_maintenance_ParkStageAudit__);


var routes = [{
  path: '/maintenance/park-stages',
  name: 'ParkStageAudit',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_maintenance_ParkStageAudit___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_ADMIN', 'ROLE_RESEARCHER']
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_news_NewsHome__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_news_NewsHome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_news_NewsHome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_news_CreateNews__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_news_CreateNews___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_news_CreateNews__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_news_EditNews__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_news_EditNews___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_news_EditNews__);




var routes = [{
  path: '/news',
  name: 'NewsHome',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_news_NewsHome___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_ADMIN']
  }
}, {
  path: '/create-news',
  name: 'CreateNews',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_news_CreateNews___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_ADMIN']
  }
}, {
  path: '/edit-news/:id',
  name: 'EditNews',
  component: __WEBPACK_IMPORTED_MODULE_2__pages_news_EditNews___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_ADMIN']
  },
  props: true
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_parks_ParkHome__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_parks_ParkHome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_parks_ParkHome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_parks_Parks__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_parks_Parks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_parks_Parks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_parks_CreatePark__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_parks_CreatePark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_parks_CreatePark__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_parks_EditPark__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_parks_EditPark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_parks_EditPark__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_quizzes_GeneralInformations__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_quizzes_GeneralInformations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_quizzes_GeneralInformations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_quizzes_ParkQuiz__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_quizzes_ParkQuiz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_quizzes_ParkQuiz__);








var routes = [{
  path: '/park',
  name: 'ParkHome',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_parks_ParkHome___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_PARK']
  }
}, {
  path: '/general-informations/:parkId',
  name: 'GeneralInformations',
  component: __WEBPACK_IMPORTED_MODULE_5__pages_quizzes_GeneralInformations___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_PARK'],
    preLoad: function preLoad(to, authentication, router) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (authentication.userHasResearcherRole() || authentication.userHasAdminRole()) {
          resolve();
          return;
        }
        if (to.params.parkId !== authentication.getParkId()) {
          router.push({ name: 'UnauthorizedError' });
        }
        resolve();
      });
    }
  },
  props: true
}, {
  path: '/park-quiz/:parkId/:referenceYear/:quizUuid?',
  name: 'ParkQuiz',
  component: __WEBPACK_IMPORTED_MODULE_6__pages_quizzes_ParkQuiz___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_PARK']
  },
  props: true
}, {
  path: '/parks',
  name: 'Parks',
  component: __WEBPACK_IMPORTED_MODULE_2__pages_parks_Parks___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_ADMIN']
  }
}, {
  path: '/create-park',
  name: 'CreatePark',
  component: __WEBPACK_IMPORTED_MODULE_3__pages_parks_CreatePark___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_ADMIN']
  }
}, {
  path: '/edit-park/:id',
  name: 'EditPark',
  component: __WEBPACK_IMPORTED_MODULE_4__pages_parks_EditPark___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_PARK'],
    preLoad: function preLoad(to, authentication, router) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (authentication.userHasResearcherRole() || authentication.userHasAdminRole()) {
          resolve();
          return;
        }
        if (to.params.id !== authentication.getParkId()) {
          router.push({ name: 'UnauthorizedError' });
        }
        resolve();
      });
    }
  },
  props: true
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_partners_Partners__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_partners_Partners___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_partners_Partners__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_partners_CreatePartner__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_partners_CreatePartner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_partners_CreatePartner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_partners_EditPartner__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_partners_EditPartner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_partners_EditPartner__);




var routes = [{
  path: '/partners',
  name: 'Partners',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_partners_Partners___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_ADMIN']
  }
}, {
  path: '/create-partner',
  name: 'CreatePartner',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_partners_CreatePartner___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_ADMIN']
  }
}, {
  path: '/edit-partner/:id',
  name: 'EditPartner',
  component: __WEBPACK_IMPORTED_MODULE_2__pages_partners_EditPartner___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_ADMIN']
  },
  props: true
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_portal_Homepage__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_portal_Homepage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_portal_Homepage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_portal_ParksPage__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_portal_ParksPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_portal_ParksPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_portal_AboutPage__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_portal_AboutPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_portal_AboutPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_portal_CompaniesPage__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_portal_CompaniesPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_portal_CompaniesPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_portal_ReadNews__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_portal_ReadNews___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_portal_ReadNews__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_portal_Contact__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_portal_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_portal_Contact__);







var routes = [{
  path: '/',
  name: 'Homepage',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_portal_Homepage___default.a,
  meta: { requiresAuthentication: false }
}, {
  path: '/parks-page',
  name: 'ParksPage',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_portal_ParksPage___default.a,
  meta: { requiresAuthentication: false }
}, {
  path: '/companies-page',
  name: 'CompaniesPage',
  component: __WEBPACK_IMPORTED_MODULE_3__pages_portal_CompaniesPage___default.a,
  meta: { requiresAuthentication: false }
}, {
  path: '/about-page',
  name: 'AboutPage',
  component: __WEBPACK_IMPORTED_MODULE_2__pages_portal_AboutPage___default.a,
  meta: { requiresAuthentication: false }
}, {
  path: '/read-news/:id',
  name: 'ReadNews',
  component: __WEBPACK_IMPORTED_MODULE_4__pages_portal_ReadNews___default.a,
  meta: { requiresAuthentication: false },
  props: true
}, {
  path: '/contact',
  name: 'ContactPage',
  component: __WEBPACK_IMPORTED_MODULE_5__pages_portal_Contact___default.a,
  meta: { requiresAuthentication: false }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_quiz_period_QuizPeriod__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_quiz_period_QuizPeriod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_quiz_period_QuizPeriod__);


var routes = [{
  path: '/quiz-period',
  name: 'QuizPeriod',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_quiz_period_QuizPeriod___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_ADMIN']
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_reports_SegmentedChartsReports__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_reports_SegmentedChartsReports___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_reports_SegmentedChartsReports__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_reports_SegmentedTextualReports__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_reports_SegmentedTextualReports___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_reports_SegmentedTextualReports__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_reports_QuizReports__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_reports_QuizReports___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_reports_QuizReports__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_reports_RelatorioEstatistico__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_reports_RelatorioEstatistico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_reports_RelatorioEstatistico__);





var routes = [{
  path: '/relatorio-estatistico',
  name: 'RelatorioEstatistico',
  component: __WEBPACK_IMPORTED_MODULE_3__pages_reports_RelatorioEstatistico___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_RESEARCHER'],
    researcherOnly: true
  }
}, {
  path: '/segmented-charts-reports',
  name: 'SegmentedChartsReports',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_reports_SegmentedChartsReports___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_PARTNER', 'ROLE_ADMIN']
  }
}, {
  path: '/segmented-textual-reports',
  name: 'SegmentedTextualReports',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_reports_SegmentedTextualReports___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_PARTNER', 'ROLE_ADMIN']
  }
}, {
  path: '/quiz-reports',
  name: 'QuizReports',
  component: __WEBPACK_IMPORTED_MODULE_2__pages_reports_QuizReports___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_PARK', 'ROLE_PARTNER']
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_researcher_ResearcherHome__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_researcher_ResearcherHome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_researcher_ResearcherHome__);


var routes = [{
  path: '/researcher',
  name: 'ResearcherHome',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_researcher_ResearcherHome___default.a,
  meta: {
    requiresAuthentication: true,
    roleRequired: ['ROLE_RESEARCHER']
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_security_Login__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_security_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_security_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_security_ResetPassword__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_security_ResetPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_security_ResetPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_security_ForgotPassword__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_security_ForgotPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_security_ForgotPassword__);




var routes = [{
  path: '/login',
  name: 'Login',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_security_Login___default.a,
  meta: { requiresAuthentication: false }
}, {
  path: '/reset-password/:token',
  name: 'ResetPassword',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_security_ResetPassword___default.a,
  meta: { requiresAuthentication: false },
  props: true
}, {
  path: '/forgot-password',
  name: 'ForgotPassword',
  component: __WEBPACK_IMPORTED_MODULE_2__pages_security_ForgotPassword___default.a
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_authentication__ = __webpack_require__(23);




/* harmony default export */ __webpack_exports__["a"] = ({
  addGlobalRequestInterceptors: function addGlobalRequestInterceptors(axios) {
    axios.interceptors.request.use(function (response) {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].app.$Progress.start();
      return response;
    }, function (error) {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].app.$Progress.fail();
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  addGlobalResponseInterceptors: function addGlobalResponseInterceptors(axios) {
    axios.interceptors.response.use(function (response) {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].app.$Progress.finish();
      return response;
    }, function (error) {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].app.$Progress.fail();
      if (error.response && error.response.status === 500) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'ServerError' });
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  addUnauthorizedResponseInterceptor: function addUnauthorizedResponseInterceptor(axios) {
    axios.interceptors.response.use(undefined, function (error) {
      if (error.response && error.response.status === 401 && error.response.data && error.response.data.message === 'Expired JWT Token') {
        __WEBPACK_IMPORTED_MODULE_2__services_authentication__["a" /* default */].logout();
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'Login' });
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_finite__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_report_formatter__ = __webpack_require__(50);








function resolveSeriesData(indicator, viewMode) {
  var data = indicator.data || {};

  if (viewMode === 'nominal' || viewMode === '' || viewMode === null || viewMode === undefined) {
    return data;
  }

  if (viewMode === 'deflated' && data.adjustments && data.adjustments.deflated) {
    return data.adjustments.deflated;
  }

  if (viewMode === 'withoutKnownParkOutliers' && data.adjustments && data.adjustments.withoutKnownParkOutliers) {
    return data.adjustments.withoutKnownParkOutliers;
  }

  return data;
}

function resolveTableData(indicator, viewMode) {
  var data = indicator.data || {};

  if (viewMode === 'deflated' && data.adjustments && data.adjustments.deflated) {
    return data.adjustments.deflated;
  }

  return data;
}

function isPercentageDistribution(data) {
  if (!data || !data.columns || !data.rows || data.rows.length === 0) {
    return false;
  }

  var valueColumn = data.columns[data.columns.length - 1];
  var valueColumnLabel = String(valueColumn || '').toLowerCase();

  return valueColumnLabel.indexOf('%') !== -1 || valueColumnLabel.indexOf('percent') !== -1;
}

function tableDataToChartResult(data) {
  var result = {};(data.rows || []).forEach(function (row) {
    var cells = row.cells || row;
    if (!cells || cells.length < 2) {
      return;
    }

    var label = extractCellValue(cells[0]);
    var value = normalizeChartValue(extractCellValue(cells[cells.length - 1]));
    if (label !== undefined && label !== null && label !== '' && value !== null) {
      result[label] = value;
    }
  });

  return result;
}

function snapshotStageResult(snapshot) {
  if (snapshot.planejamento === undefined && snapshot.implantacao === undefined && snapshot.operacao === undefined) {
    return null;
  }

  return {
    Planejamento: snapshot.planejamento || 0,
    Implantação: snapshot.implantacao || 0,
    Operação: snapshot.operacao || 0
  };
}

function normalizeChartValue(value) {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(value)) === 'object' && value !== null && value.value !== undefined) {
    return normalizeChartValue(value.value);
  }

  var num = Number(value);
  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_finite___default()(num) ? num : null;
}

function extractCellValue(cell) {
  if (cell === null || cell === undefined) {
    return null;
  }
  if ((typeof cell === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(cell)) === 'object' && cell.value !== undefined) {
    return cell.value;
  }
  return cell;
}

function seriesToChartPayload(seriesData) {
  return {
    labels: seriesData.labels || [],
    datasets: (seriesData.datasets || []).map(function (dataset) {
      return {
        label: dataset.label,
        result: dataset.values || {}
      };
    })
  };
}

function isPercentageSeries(indicator, seriesData) {
  var unit = indicator.metadata && indicator.metadata.unit;
  if (unit === 'BRL') {
    return false;
  }

  var datasets = seriesData && seriesData.datasets || indicator.data && indicator.data.datasets || [];
  if (datasets.length === 0) {
    return false;
  }

  var values = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(datasets[0].values || {}).map(normalizeChartValue).filter(function (value) {
    return value !== null;
  });

  if (values.length === 0) {
    return false;
  }

  var max = Math.max.apply(null, values);
  return max <= 100;
}

function countDistributionCategories(result) {
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(result || {}).length;
}

function buildDistributionChart(chartPayload, title) {
  var categoryCount = countDistributionCategories(chartPayload[0] && chartPayload[0].result);
  if (categoryCount === 0) {
    return null;
  }

  if (categoryCount <= 8) {
    var _chart = __WEBPACK_IMPORTED_MODULE_6__services_report_formatter__["a" /* default */].percentageDoughnutChart(chartPayload, title);
    _chart.layout = {
      type: 'doughnut',
      minHeight: 460,
      maintainAspectRatio: true
    };
    return _chart;
  }

  var chart = __WEBPACK_IMPORTED_MODULE_6__services_report_formatter__["a" /* default */].percentageHorizontalBarChart(chartPayload, title);
  chart.layout = {
    type: 'horizontalBar',
    minHeight: Math.max(320, categoryCount * 44 + 100),
    maintainAspectRatio: false
  };
  return chart;
}

function _shouldShowHistoricalSeriesChart(indicator) {
  if (indicator.type !== 'series') {
    return false;
  }

  var data = indicator.data || {};
  var datasets = data.datasets || [];
  if (datasets.length === 0) {
    return false;
  }

  var snapshot = data.snapshot;
  if (snapshot && isPercentageDistribution(snapshot) && datasets.length > 4) {
    return false;
  }

  return true;
}

function inferCellDataType(value, columnIndex, columns, metadata) {
  if (columnIndex === 0 || typeof value === 'string') {
    return 'text';
  }
  if (metadata && metadata.unit === 'BRL') {
    return 'currency';
  }
  var columnLabel = columns && columns[columnIndex] ? String(columns[columnIndex]) : '';
  if (columnLabel.indexOf('%') !== -1) {
    return 'percentage';
  }
  if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(Number(value))) {
    return 'integer';
  }
  return 'text';
}

function formatRows(indicator, columns, rawRows) {
  return (rawRows || []).map(function (row) {
    var cells = row.cells || row;

    var formattedRow = {
      cells: cells.map(function (value, index) {
        return {
          value: value,
          dataType: inferCellDataType(value, index, columns, indicator.metadata)
        };
      })
    };

    if (row.group !== undefined && row.group !== null && row.group !== '') {
      formattedRow.group = row.group;
    }

    return formattedRow;
  });
}

function tablePayloadFromData(indicator, data, title) {
  var columns = data.columns || [];
  var rows = formatRows(indicator, columns, data.rows);

  return __WEBPACK_IMPORTED_MODULE_6__services_report_formatter__["a" /* default */].textual({
    columns: columns,
    rows: rows,
    metadata: indicator.metadata
  }, title);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  seriesToChart: function seriesToChart(indicator, viewMode) {
    var seriesData = resolveSeriesData(indicator, viewMode);
    var chartPayload = seriesToChartPayload(seriesData);
    var chart = __WEBPACK_IMPORTED_MODULE_6__services_report_formatter__["a" /* default */].chart(chartPayload, indicator.title);
    var datasetCount = (seriesData.datasets || []).length;

    chart.layout = {
      type: 'line',
      minHeight: 420,
      maintainAspectRatio: false
    };

    if (datasetCount > 4) {
      chart.options.legend = {
        display: true,
        position: 'bottom',
        labels: {
          boxWidth: 12,
          fontSize: 11,
          padding: 8
        }
      };
    }

    if (isPercentageSeries(indicator, seriesData)) {
      chart.options.scales.yAxes[0].ticks.max = 100;
      chart.options.tooltips.callbacks.label = function (tooltipItems) {
        var value = normalizeChartValue(tooltipItems.yLabel);
        if (value === null) {
          return 'Sem dado';
        }
        return value.toFixed(1).replace('.', ',') + '%';
      };
      chart.options.scales.yAxes[0].ticks.callback = function (value) {
        if (!__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_finite___default()(Number(value))) {
          return '';
        }
        return Number(value).toFixed(0) + '%';
      };
    } else {
      chart.options.tooltips.callbacks.label = function (tooltipItems) {
        var value = normalizeChartValue(tooltipItems.yLabel);
        if (value === null) {
          return 'Sem dado';
        }
        return value.toLocaleString('pt-BR');
      };
    }

    return chart;
  },
  seriesToBarChart: function seriesToBarChart(indicator, titleSuffix) {
    var snapshot = indicator.data && indicator.data.snapshot;
    if (!snapshot || !snapshot.values) {
      return null;
    }

    var chartPayload = [{
      label: indicator.title,
      result: snapshot.values
    }];

    var suffix = titleSuffix || snapshot.year || '';
    var title = suffix ? indicator.title + ' (' + suffix + ')' : indicator.title;

    return __WEBPACK_IMPORTED_MODULE_6__services_report_formatter__["a" /* default */].percentageHorizontalBarChart(chartPayload, title);
  },
  snapshotToChart: function snapshotToChart(indicator) {
    var snapshot = indicator.data && indicator.data.snapshot;
    if (!snapshot) {
      return null;
    }

    var yearLabel = snapshot.year ? String(snapshot.year) : '';

    if (isPercentageDistribution(snapshot)) {
      var chartPayload = [{
        label: indicator.title,
        result: tableDataToChartResult(snapshot)
      }];
      var title = yearLabel ? 'Distribuição em ' + yearLabel : 'Distribuição';
      return buildDistributionChart(chartPayload, title);
    }

    if (snapshot.values && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(snapshot.values).length > 0) {
      var normalizedValues = {};
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(snapshot.values).forEach(function (key) {
        var value = normalizeChartValue(snapshot.values[key]);
        if (value !== null) {
          normalizedValues[key] = value;
        }
      });
      var _chartPayload = [{ label: indicator.title, result: normalizedValues }];
      var _title = yearLabel ? indicator.title + ' (' + yearLabel + ')' : indicator.title;
      return buildDistributionChart(_chartPayload, _title);
    }

    var stageResult = snapshotStageResult(snapshot);
    if (stageResult) {
      var _chartPayload2 = [{
        label: indicator.title,
        result: stageResult
      }];
      var _title2 = yearLabel ? 'Parques por estágio em ' + yearLabel : 'Parques por estágio';
      var chart = __WEBPACK_IMPORTED_MODULE_6__services_report_formatter__["a" /* default */].chart(_chartPayload2, _title2);
      chart.layout = {
        type: 'bar',
        minHeight: 420,
        maintainAspectRatio: false
      };
      chart.options.layout = {
        padding: {
          top: 12,
          right: 16,
          bottom: 36,
          left: 16
        }
      };
      if (chart.options.scales && chart.options.scales.xAxes && chart.options.scales.xAxes[0]) {
        chart.options.scales.xAxes[0].ticks = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, chart.options.scales.xAxes[0].ticks || {}, {
          autoSkip: false,
          maxRotation: 0,
          minRotation: 0,
          padding: 10
        });
      }
      return chart;
    }

    return null;
  },
  tableToDistributionChart: function tableToDistributionChart(indicator, viewMode) {
    if (indicator.type !== 'table') {
      return null;
    }

    var data = resolveTableData(indicator, viewMode || 'nominal');
    if (!isPercentageDistribution(data)) {
      return null;
    }

    var chartPayload = [{
      label: indicator.title,
      result: tableDataToChartResult(data)
    }];

    return buildDistributionChart(chartPayload, indicator.title);
  },
  resolveTablePayload: function resolveTablePayload(indicator, viewMode) {
    var data = resolveTableData(indicator, viewMode || 'nominal');
    return tablePayloadFromData(indicator, data, indicator.title);
  },
  tableToReport: function tableToReport(indicator, viewMode) {
    if (viewMode) {
      return this.resolveTablePayload(indicator, viewMode);
    }
    return tablePayloadFromData(indicator, indicator.data || {}, indicator.title);
  },
  rankingToReport: function rankingToReport(indicator) {
    return tablePayloadFromData(indicator, indicator.data || {}, indicator.title);
  },
  nestedTablesToReports: function nestedTablesToReports(indicator) {
    var data = indicator.data || {};
    var reports = [];

    if (data.byRegion && data.byRegion.rows && data.byRegion.rows.length > 0) {
      reports.push(tablePayloadFromData(indicator, data.byRegion, 'Por região'));
    }

    return reports;
  },
  seriesDetailToReport: function seriesDetailToReport(indicator) {
    var detail = indicator.data && indicator.data.detail;
    if (!detail || (typeof detail === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(detail)) !== 'object') {
      return null;
    }

    var years = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(detail).sort();
    var firstRow = detail[years[0]] || {};
    var columnKeys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(firstRow);

    if (columnKeys.indexOf('desligadas') !== -1) {
      var _rows = years.map(function (year) {
        var values = detail[year] || {};
        return {
          cells: [{ value: year, dataType: 'text' }, { value: values.desligadas, dataType: 'integer' }, { value: values.acumulado, dataType: 'integer' }, { value: values.vinculadas, dataType: 'integer' }, { value: values.percentual, dataType: 'percentage' }]
        };
      });

      return __WEBPACK_IMPORTED_MODULE_6__services_report_formatter__["a" /* default */].textual({
        columns: ['Ano', 'Desligadas no ano', 'Acumulado', 'Vinculadas', '% desligamento'],
        rows: _rows,
        metadata: indicator.metadata
      }, 'Detalhamento por ano');
    }

    var columns = ['Ano'].concat(columnKeys);
    var rows = years.map(function (year) {
      var values = detail[year] || {};
      var cells = [{ value: year, dataType: 'text' }].concat(columnKeys.map(function (key) {
        var value = values[key];
        var dataType = typeof value === 'number' && !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(value) ? 'percentage' : 'integer';
        return { value: value, dataType: dataType };
      }));
      return { cells: cells };
    });

    return __WEBPACK_IMPORTED_MODULE_6__services_report_formatter__["a" /* default */].textual({
      columns: columns,
      rows: rows,
      metadata: indicator.metadata
    }, 'Detalhamento por ano');
  },
  seriesVariationsToReport: function seriesVariationsToReport(indicator) {
    return this.comparisonToReport(indicator);
  },
  comparisonToReport: function comparisonToReport(indicator) {
    var comparison = indicator.data && indicator.data.comparison;
    if (!comparison) {
      return null;
    }

    var compareYear = comparison.compareYear;
    var referenceYear = comparison.referenceYear;
    var title = 'Comparação ' + compareYear + ' vs ' + referenceYear + ' (%)';

    if (comparison.rows && comparison.rows.length > 0 && comparison.rows[0].label !== undefined) {
      var columns = ['Série', String(compareYear), String(referenceYear), 'Var. %'];
      var rows = comparison.rows.map(function (row) {
        return {
          cells: [{ value: row.label, dataType: 'text' }, { value: row.compareValue, dataType: 'integer' }, { value: row.referenceValue, dataType: 'integer' }, {
            value: row.variationPercent === null || row.variationPercent === undefined ? '-' : row.variationPercent,
            dataType: row.variationPercent === null || row.variationPercent === undefined ? 'text' : 'percentage'
          }]
        };
      });

      return __WEBPACK_IMPORTED_MODULE_6__services_report_formatter__["a" /* default */].textual({
        columns: columns,
        rows: rows,
        metadata: indicator.metadata
      }, title);
    }

    if (comparison.referenceValue !== undefined || comparison.compareValue !== undefined) {
      return __WEBPACK_IMPORTED_MODULE_6__services_report_formatter__["a" /* default */].textual({
        columns: ['Ano', 'Valor'],
        rows: [{ cells: [{ value: compareYear, dataType: 'text' }, { value: comparison.compareValue, dataType: 'integer' }] }, { cells: [{ value: referenceYear, dataType: 'text' }, { value: comparison.referenceValue, dataType: 'integer' }] }, {
          cells: [{ value: 'Var. %', dataType: 'text' }, {
            value: comparison.variationPercent === null || comparison.variationPercent === undefined ? '-' : comparison.variationPercent,
            dataType: comparison.variationPercent === null || comparison.variationPercent === undefined ? 'text' : 'percentage'
          }]
        }],
        metadata: indicator.metadata
      }, title);
    }

    if (!comparison.columns || !comparison.rows || comparison.rows.length === 0) {
      return null;
    }

    return tablePayloadFromData(indicator, comparison, title);
  },
  comparisonNestedTablesToReports: function comparisonNestedTablesToReports(indicator) {
    var comparison = indicator.data && indicator.data.comparison;
    if (!comparison || !comparison.byRegion || !comparison.byRegion.rows) {
      return [];
    }

    return [tablePayloadFromData(indicator, comparison.byRegion, 'Por região — comparação ' + comparison.compareYear + ' vs ' + comparison.referenceYear)];
  },
  concentrationSummary: function concentrationSummary(indicator) {
    var concentration = indicator.data && indicator.data.concentration;
    if (!concentration || concentration.parksFor80Percent === undefined) {
      return null;
    }

    return concentration.parksFor80Percent + ' de ' + concentration.totalParks + ' parques concentram 80% das empresas vinculadas';
  },
  hasFinancialAdjustments: function hasFinancialAdjustments(indicator) {
    return !!(indicator.data && indicator.data.adjustments);
  },
  shouldShowHistoricalSeriesChart: function shouldShowHistoricalSeriesChart(indicator) {
    return _shouldShowHistoricalSeriesChart(indicator);
  },
  distributionChartComponent: function distributionChartComponent(chartData) {
    if (!chartData || !chartData.layout) {
      return 'horizontalBar';
    }
    return chartData.layout.type || 'horizontalBar';
  },
  isPercentageDistributionTable: function isPercentageDistributionTable(data) {
    return isPercentageDistribution(data);
  },
  formatKpiValue: function formatKpiValue(indicator) {
    var value = indicator.data && indicator.data.value;
    if (value === undefined || value === null) {
      return '-';
    }
    if (indicator.metadata && indicator.metadata.unit === 'BRL') {
      return Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
    return Number(value).toLocaleString('pt-BR');
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_backend_api__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  post: function post(senderName, senderEmail, contactSubject, contactMessage, recaptchaToken) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getAnonymousClient().post('contact', { senderName: senderName, senderEmail: senderEmail, contactSubject: contactSubject, contactMessage: contactMessage, recaptchaToken: recaptchaToken }).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GENERAL_INFORMATIONS_QUIZ_TEMPLATE_UUID; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_backend_api__ = __webpack_require__(3);


var GENERAL_INFORMATIONS_QUIZ_TEMPLATE_UUID = 'cac508fb-205c-3e51-ae14-d4f8b0ba5c83';

/* harmony default export */ __webpack_exports__["b"] = ({
  get: function get(parkId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().get('general-informations/?parkId=' + parkId).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  post: function post(parkId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().post('general-informations/', { parkId: parkId, quizTemplateUuid: GENERAL_INFORMATIONS_QUIZ_TEMPLATE_UUID }).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  put: function put(uuid, answers) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().put('general-informations/' + uuid, { answers: answers }).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_backend_api__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  auditParkStages: function auditParkStages() {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().get('maintenance/park-stages/audit').then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  syncParkStages: function syncParkStages() {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().post('maintenance/park-stages/sync').then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  updateManagementEntityLegalNatureOptions: function updateManagementEntityLegalNatureOptions() {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().post('maintenance/management-entity-legal-nature-options').then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  fixParkLandAreas: function fixParkLandAreas(parkId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().post('maintenance/park-land-areas/fix', { parkId: parkId }).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  auditFinancialOutliers: function auditFinancialOutliers() {
    var includeUnanswered = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().get('maintenance/financial-outliers/audit', {
      params: { includeUnanswered: includeUnanswered ? 1 : 0 }
    }).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  },
  fixFinancialOutliers: function fixFinancialOutliers() {
    var includeUnanswered = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().post('maintenance/financial-outliers/fix', {
      includeUnanswered: includeUnanswered
    }).then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_backend_api__ = __webpack_require__(3);


var BASE_PATH = 'relatorios/estatistico';
var EXPORT_TIMEOUT_MS = 600000;
var DOWNLOAD_TIMEOUT_MS = 120000;

function buildExportParams(year, relatorio) {
  var params = {};
  if (relatorio && relatorio.compareYear) {
    params.compareYear = relatorio.compareYear;
  }
  return params;
}

function buildPreparePath(type, year) {
  if (type === 'pdf') {
    return BASE_PATH + '/' + year + '/document/prepare';
  }

  return BASE_PATH + '/' + year + '/' + type + '/prepare';
}

function downloadPrepared(type, year, relatorio) {
  var client = __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient();
  var params = buildExportParams(year, relatorio);

  return client.get(buildPreparePath(type, year), {
    params: params,
    timeout: EXPORT_TIMEOUT_MS
  }).then(function (prepareResponse) {
    var payload = prepareResponse.data || {};

    if (payload.errors && payload.errors.length > 0) {
      throw new Error(payload.errors.join(', '));
    }

    if (!payload.downloadUrl) {
      throw new Error('Não foi possível preparar o arquivo para download.');
    }

    return client.get(payload.downloadUrl, {
      responseType: 'blob',
      timeout: DOWNLOAD_TIMEOUT_MS
    }).then(function (fileResponse) {
      fileResponse.preparedFilename = payload.filename;
      fileResponse.preparedFallback = payload.fallback;
      return fileResponse;
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(year) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().get(BASE_PATH + '/' + year, {
      params: params,
      timeout: 600000
    }).then(function (response) {
      return response.data;
    });
  },
  downloadExcel: function downloadExcel(year) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().get(BASE_PATH + '/' + year + '/excel', {
      params: params,
      responseType: 'blob',
      timeout: EXPORT_TIMEOUT_MS
    });
  },
  downloadExcelFromPayload: function downloadExcelFromPayload(year, relatorio) {
    return downloadPrepared('excel', year, relatorio);
  },
  downloadPdf: function downloadPdf(year) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().get(BASE_PATH + '/' + year + '/pdf', {
      params: params,
      responseType: 'blob',
      timeout: EXPORT_TIMEOUT_MS
    });
  },
  downloadPdfFromPayload: function downloadPdfFromPayload(year, relatorio) {
    return downloadPrepared('pdf', year, relatorio);
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_backend_api__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  getCurrentUser: function getCurrentUser() {
    return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getClient().get('users/current').then(function (response) {
      return response;
    }).catch(function (e) {
      throw e;
    });
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);


//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['tableId', 'url', 'columnDefs', 'columns', 'order'],
  mounted: function mounted() {
    var dtColumns = [];
    for (var el in this.columns) {
      dtColumns.push({ data: this.columns[el].field });
    }
    $('#' + this.tableId).DataTable({
      processing: true,
      serverSide: true,
      order: this.order ? this.order : [[0, 'asc']],
      ajax: {
        url: this.url,
        data: function data(d) {
          return {
            limit: d.length,
            offset: d.start,
            search: d.search.value ? d.search.value : null,
            orderBy: d.columns[d.order[0]['column']].data,
            orderDirection: d.order[0].dir
          };
        },
        dataFilter: function dataFilter(response) {
          response = JSON.parse(response);

          var total = response.total;
          delete response['total'];

          var elements = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(response);
          elements.splice(-1, 1);

          var fd = {
            data: elements,
            recordsTotal: total,
            recordsFiltered: total
          };
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(fd);
        }
      },
      columnDefs: this.columnDefs,
      columns: dtColumns
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_TableReport__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_TableReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_elements_TableReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_ListReport__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_ListReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_elements_ListReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_ReportFilterBadge__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_ReportFilterBadge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_elements_ReportFilterBadge__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EvolutionTextualReport',
  components: { TableReport: __WEBPACK_IMPORTED_MODULE_1__components_elements_TableReport___default.a, ListReport: __WEBPACK_IMPORTED_MODULE_2__components_elements_ListReport___default.a, ReportFilterBadge: __WEBPACK_IMPORTED_MODULE_3__components_elements_ReportFilterBadge___default.a },
  props: {
    title: String,
    metadata: Object,
    reportType: {
      type: String,
      default: 'table'
    },
    entries: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    reportComponent: function reportComponent() {
      return this.reportType === 'list' ? __WEBPACK_IMPORTED_MODULE_2__components_elements_ListReport___default.a : __WEBPACK_IMPORTED_MODULE_1__components_elements_TableReport___default.a;
    },
    maxColumnCount: function maxColumnCount() {
      var max = 0;
      this.entries.forEach(function (entry) {
        var report = entry.data && entry.data.report;
        if (!report || !Array.isArray(report.columns)) {
          return;
        }
        var hasGroupColumn = Array.isArray(report.rows) && report.rows.some(function (row) {
          return row.hasOwnProperty('group');
        });
        var columnCount = report.columns.length + (hasGroupColumn ? 1 : 0);
        if (columnCount > max) {
          max = columnCount;
        }
      });
      return max;
    },
    cardMinWidth: function cardMinWidth() {
      if (this.reportType === 'list' || this.maxColumnCount === 0) {
        return 320;
      }
      var widthPerColumn = 130;
      var horizontalPadding = 40;
      var computed = this.maxColumnCount * widthPerColumn + horizontalPadding;
      return Math.min(Math.max(computed, 320), 1000);
    },
    gridStyle: function gridStyle() {
      return {
        gridTemplateColumns: 'repeat(auto-fill, minmax(' + this.cardMinWidth + 'px, 1fr))'
      };
    }
  },
  methods: {
    entryData: function entryData(entry) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, entry.data, { title: null, metadata: null });
    }
  }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GoBackButton',
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    }
  }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_report_formatter__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_ReportFilterBadge__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_ReportFilterBadge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_elements_ReportFilterBadge__);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ListReport',
  components: { ReportFilterBadge: __WEBPACK_IMPORTED_MODULE_1__components_elements_ReportFilterBadge___default.a },
  props: ['data'],
  methods: {
    formatDataForRecursiveChildComponent: function formatDataForRecursiveChildComponent(data) {
      return __WEBPACK_IMPORTED_MODULE_0__services_report_formatter__["a" /* default */].textual(data);
    }
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Notifier',
  methods: {
    showSavedFormNotification: function showSavedFormNotification() {
      this.$notify({ type: 'success', title: 'Sucesso', text: 'As informações foram salvas!' });
    },
    showErrorNotification: function showErrorNotification() {
      this.$notify({ type: 'error', title: 'Ocorreu um erro', text: 'Verifique se as informações foram preenchidas corretamente e tente novamente.' });
    }
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_ReportFilterBadge__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_ReportFilterBadge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_elements_ReportFilterBadge__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReportChartContainer',
  components: { ReportFilterBadge: __WEBPACK_IMPORTED_MODULE_0__components_elements_ReportFilterBadge___default.a },
  props: {
    data: {
      type: Object,
      required: true
    },
    chartComponent: {
      type: Object,
      required: true
    }
  },
  computed: {
    layout: function layout() {
      return this.data && this.data.layout || {};
    },
    layoutType: function layoutType() {
      return this.layout.type || 'line';
    },
    containerClass: function containerClass() {
      return 'report-chart-container--' + this.layoutType;
    },
    canvasStyle: function canvasStyle() {
      var minHeight = this.layout.minHeight || 420;

      if (this.layoutType === 'doughnut') {
        return {
          width: '480px',
          height: '480px',
          margin: '0 auto'
        };
      }

      if (this.layoutType === 'horizontalBar') {
        return {
          width: '100%',
          maxWidth: '760px',
          height: minHeight + 'px',
          minHeight: minHeight + 'px',
          margin: '0 auto'
        };
      }

      return {
        width: '100%',
        maxWidth: '760px',
        height: minHeight + 'px',
        minHeight: minHeight + 'px',
        margin: '0 auto'
      };
    }
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReportFilterBadge',
  props: {
    metadata: {
      type: Object,
      default: null
    }
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_report_period__ = __webpack_require__(73);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReportPeriodFilter',
  components: { DatePicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__["a" /* default */] },
  props: {
    title: {
      type: String,
      default: 'Período'
    },
    isRange: {
      type: Boolean,
      default: true
    },
    showViewMode: {
      type: Boolean,
      default: false
    },
    viewMode: {
      type: String,
      default: 'snapshot'
    },
    periodType: {
      type: String,
      default: 'years'
    },
    startYear: Number,
    endYear: Number,
    year: Number
  },
  data: function data() {
    return {
      datepickerLanguage: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["ptBR"],
      localViewMode: this.viewMode,
      localPeriodType: this.periodType,
      localStartYear: this.startYear,
      localEndYear: this.endYear,
      localYear: this.year,
      localStartDate: this.startYear + '-01-01',
      localEndDate: this.endYear + '-12-31'
    };
  },

  computed: {
    availableYears: function availableYears() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constants_report_period__["c" /* buildYearRange */])(new Date().getFullYear(), __WEBPACK_IMPORTED_MODULE_2__constants_report_period__["a" /* FIRST_AVAILABLE_YEAR */]);
    },
    startDateObject: function startDateObject() {
      return this.parseDate(this.localStartDate);
    },
    endDateObject: function endDateObject() {
      return this.parseDate(this.localEndDate);
    }
  },
  watch: {
    localViewMode: function localViewMode(value) {
      this.$emit('update:viewMode', value);
      this.emitChange();
    },
    localPeriodType: function localPeriodType() {
      this.emitChange();
    },
    localStartYear: function localStartYear() {
      this.emitChange();
    },
    localEndYear: function localEndYear() {
      this.emitChange();
    },
    localYear: function localYear() {
      this.emitChange();
    },
    localStartDate: function localStartDate() {
      this.emitChange();
    },
    localEndDate: function localEndDate() {
      this.emitChange();
    }
  },
  methods: {
    parseDate: function parseDate(value) {
      if (!value) return null;
      var parts = value.split('-');
      return new Date(parts[0], parts[1] - 1, parts[2]);
    },
    formatDate: function formatDate(date) {
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      return date.getFullYear() + '-' + month + '-' + day;
    },
    onStartDateSelected: function onStartDateSelected(date) {
      if (!date) return;
      this.localStartDate = this.formatDate(date);
    },
    onEndDateSelected: function onEndDateSelected(date) {
      if (!date) return;
      this.localEndDate = this.formatDate(date);
    },
    emitChange: function emitChange() {
      this.$emit('change', this.getPeriod());
    },
    getPeriod: function getPeriod() {
      return {
        viewMode: this.localViewMode,
        periodType: this.localPeriodType,
        startYear: this.localStartYear,
        endYear: this.localEndYear,
        year: this.localYear,
        startDate: this.localStartDate,
        endDate: this.localEndDate
      };
    }
  }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_ReportFilterBadge__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_ReportFilterBadge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_elements_ReportFilterBadge__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TableReport',
  components: { ReportFilterBadge: __WEBPACK_IMPORTED_MODULE_1__components_elements_ReportFilterBadge___default.a },
  props: ['data'],
  data: function data() {
    return {
      formatterByDataType: {
        'text': function text(value) {
          if (value === '') return '-';
          return value;
        },
        'currency': function currency(value) {
          var formatter = Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 });
          return formatter.format(value);
        },
        'percentage': function percentage(value) {
          return Number(value).toFixed(2).replace('.', ',') + '%';
        },
        'integer': function integer(value) {
          return Number(value).toLocaleString('pt-BR');
        }
      }
    };
  },

  computed: {
    headers: function headers() {
      if (!this.data.report || !this.data.report.rows) return [];

      var hasGroupedRows = this.data.report.rows.some(function (row) {
        return row.group !== undefined && row.group !== null && row.group !== '';
      });
      if (hasGroupedRows) {
        return [''].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.data.report.columns));
      }

      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.data.report.columns));
    },
    rowsByGroup: function rowsByGroup() {
      if (!this.data.report || !this.data.report.rows) return [];

      var rowsByGroup = {};
      this.data.report.rows.forEach(function (row) {
        var groupKey = row.group !== undefined && row.group !== null && row.group !== '' ? row.group : '__ungrouped__';
        if (!rowsByGroup.hasOwnProperty(groupKey)) {
          rowsByGroup[groupKey] = [];
        }
        rowsByGroup[groupKey].push(row.cells);
      });

      return rowsByGroup;
    }
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_charts_chartRendererMixin__ = __webpack_require__(72);




/* harmony default export */ __webpack_exports__["default"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* Bar */],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_elements_charts_chartRendererMixin__["a" /* default */]]
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_charts_chartRendererMixin__ = __webpack_require__(72);




/* harmony default export */ __webpack_exports__["default"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Doughnut */],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_elements_charts_chartRendererMixin__["a" /* default */]]
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_charts_chartRendererMixin__ = __webpack_require__(72);




/* harmony default export */ __webpack_exports__["default"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* HorizontalBar */],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_elements_charts_chartRendererMixin__["a" /* default */]]
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_charts_chartRendererMixin__ = __webpack_require__(72);




/* harmony default export */ __webpack_exports__["default"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["d" /* Line */],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_elements_charts_chartRendererMixin__["a" /* default */]]
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_charts_LineChart__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_charts_LineChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_elements_charts_LineChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_charts_BarChart__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_charts_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_elements_charts_BarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_charts_DoughnutChart__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_charts_DoughnutChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_elements_charts_DoughnutChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_charts_HorizontalBarChart__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_charts_HorizontalBarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_elements_charts_HorizontalBarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_ReportChartContainer__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_ReportChartContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_elements_ReportChartContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_TableReport__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_TableReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_elements_TableReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_relatorio_estatistico_formatter__ = __webpack_require__(380);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IndicatorResult',
  components: { ReportChartContainer: __WEBPACK_IMPORTED_MODULE_4__components_elements_ReportChartContainer___default.a, TableReport: __WEBPACK_IMPORTED_MODULE_5__components_elements_TableReport___default.a, LineChart: __WEBPACK_IMPORTED_MODULE_0__components_elements_charts_LineChart___default.a, BarChart: __WEBPACK_IMPORTED_MODULE_1__components_elements_charts_BarChart___default.a, DoughnutChart: __WEBPACK_IMPORTED_MODULE_2__components_elements_charts_DoughnutChart___default.a, HorizontalBarChart: __WEBPACK_IMPORTED_MODULE_3__components_elements_charts_HorizontalBarChart___default.a },
  props: {
    indicator: {
      type: Object,
      required: true
    },
    chartVisible: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      LineChart: __WEBPACK_IMPORTED_MODULE_0__components_elements_charts_LineChart___default.a,
      BarChart: __WEBPACK_IMPORTED_MODULE_1__components_elements_charts_BarChart___default.a,
      DoughnutChart: __WEBPACK_IMPORTED_MODULE_2__components_elements_charts_DoughnutChart___default.a,
      HorizontalBarChart: __WEBPACK_IMPORTED_MODULE_3__components_elements_charts_HorizontalBarChart___default.a,
      financialView: 'nominal',
      chartRenderKey: 0
    };
  },

  watch: {
    chartVisible: function chartVisible(isVisible) {
      if (isVisible) {
        this.bumpChartRenderKey();
      }
    }
  },
  computed: {
    showFinancialToggle: function showFinancialToggle() {
      return this.indicator.type === 'series' && __WEBPACK_IMPORTED_MODULE_6__services_relatorio_estatistico_formatter__["a" /* default */].hasFinancialAdjustments(this.indicator);
    },
    showLineChart: function showLineChart() {
      return __WEBPACK_IMPORTED_MODULE_6__services_relatorio_estatistico_formatter__["a" /* default */].shouldShowHistoricalSeriesChart(this.indicator);
    },
    lineChartData: function lineChartData() {
      if (this.indicator.type !== 'series') {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_6__services_relatorio_estatistico_formatter__["a" /* default */].seriesToChart(this.indicator, this.financialView);
    },
    snapshotChartData: function snapshotChartData() {
      return __WEBPACK_IMPORTED_MODULE_6__services_relatorio_estatistico_formatter__["a" /* default */].snapshotToChart(this.indicator);
    },
    snapshotChartComponent: function snapshotChartComponent() {
      return this.resolveChartComponent(this.snapshotChartData);
    },
    distributionChartData: function distributionChartData() {
      if (this.indicator.type !== 'table') {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_6__services_relatorio_estatistico_formatter__["a" /* default */].tableToDistributionChart(this.indicator, this.financialView);
    },
    distributionChartComponent: function distributionChartComponent() {
      return this.resolveChartComponent(this.distributionChartData);
    },
    tableData: function tableData() {
      if (this.indicator.type === 'table') {
        if (this.showFinancialToggle) {
          return __WEBPACK_IMPORTED_MODULE_6__services_relatorio_estatistico_formatter__["a" /* default */].tableToReport(this.indicator, this.financialView);
        }
        return __WEBPACK_IMPORTED_MODULE_6__services_relatorio_estatistico_formatter__["a" /* default */].tableToReport(this.indicator);
      }
      if (this.indicator.type === 'ranking') {
        return __WEBPACK_IMPORTED_MODULE_6__services_relatorio_estatistico_formatter__["a" /* default */].rankingToReport(this.indicator);
      }
      return null;
    },
    nestedTables: function nestedTables() {
      if (this.indicator.type !== 'table') {
        return [];
      }
      return __WEBPACK_IMPORTED_MODULE_6__services_relatorio_estatistico_formatter__["a" /* default */].nestedTablesToReports(this.indicator);
    },
    seriesDetailTable: function seriesDetailTable() {
      if (this.indicator.type !== 'series') {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_6__services_relatorio_estatistico_formatter__["a" /* default */].seriesDetailToReport(this.indicator);
    },
    comparisonTable: function comparisonTable() {
      return __WEBPACK_IMPORTED_MODULE_6__services_relatorio_estatistico_formatter__["a" /* default */].comparisonToReport(this.indicator);
    },
    comparisonNestedTables: function comparisonNestedTables() {
      if (this.indicator.type !== 'table' && this.indicator.type !== 'ranking') {
        return [];
      }
      return __WEBPACK_IMPORTED_MODULE_6__services_relatorio_estatistico_formatter__["a" /* default */].comparisonNestedTablesToReports(this.indicator);
    },
    concentrationText: function concentrationText() {
      if (this.indicator.type !== 'ranking') {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_6__services_relatorio_estatistico_formatter__["a" /* default */].concentrationSummary(this.indicator);
    },
    kpiValue: function kpiValue() {
      if (this.indicator.type !== 'kpi') {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_6__services_relatorio_estatistico_formatter__["a" /* default */].formatKpiValue(this.indicator);
    },
    adjustmentNote: function adjustmentNote() {
      var adjustments = this.indicator.data && this.indicator.data.adjustments;
      if (!adjustments) {
        return null;
      }
      if (this.financialView === 'deflated') {
        return adjustments.note || null;
      }
      if (this.financialView === 'withoutKnownParkOutliers' && adjustments.knownParkOutlierExclusions) {
        var resolved = adjustments.knownParkOutlierExclusions.filter(function (item) {
          return item.resolved;
        });
        if (resolved.length === 0) {
          return 'Nenhum outlier conhecido foi aplicado (parques não encontrados no cadastro).';
        }
        return 'Exclusão de contribuições de parques com valores atípicos documentados na planilha manual.';
      }
      return null;
    }
  },
  methods: {
    resolveChartComponent: function resolveChartComponent(chartData) {
      var layoutType = chartData && chartData.layout && chartData.layout.type;
      if (layoutType === 'doughnut') {
        return __WEBPACK_IMPORTED_MODULE_2__components_elements_charts_DoughnutChart___default.a;
      }
      if (layoutType === 'horizontalBar') {
        return __WEBPACK_IMPORTED_MODULE_3__components_elements_charts_HorizontalBarChart___default.a;
      }
      if (layoutType === 'bar') {
        return __WEBPACK_IMPORTED_MODULE_1__components_elements_charts_BarChart___default.a;
      }
      return __WEBPACK_IMPORTED_MODULE_1__components_elements_charts_BarChart___default.a;
    },
    bumpChartRenderKey: function bumpChartRenderKey() {
      this.chartRenderKey += 1;
      // Only when a section becomes visible: Chart.js needs a layout pass.
      // Do not fire this on financialView changes — a global resize rebuilds
      // every chart on the page and freezes the browser.
      this.$nextTick(function () {
        window.dispatchEvent(new Event('resize'));
      });
    }
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminSidebar',
  computed: {
    cmsMenuStyle: function cmsMenuStyle() {
      var cmsRouteNames = ['ParksCms', 'CompaniesCms', 'AboutCms'];
      return {
        display: cmsRouteNames.indexOf(this.$route.name) > -1 ? 'block' : ''
      };
    },
    reportsMenuStyle: function reportsMenuStyle() {
      var reportsRoutesNames = ['SegmentedChartsReports', 'SegmentedTextualReports', 'QuizReports'];
      return {
        display: reportsRoutesNames.indexOf(this.$route.name) > -1 ? 'block' : ''
      };
    }
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResearcherSidebar__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResearcherSidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ResearcherSidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AdminSidebar__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AdminSidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AdminSidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ParkSidebar__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ParkSidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ParkSidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PartnerSidebar__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PartnerSidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PartnerSidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Footer__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_authentication__ = __webpack_require__(23);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Adminlte',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__Header___default.a,
    ResearcherSidebar: __WEBPACK_IMPORTED_MODULE_1__ResearcherSidebar___default.a,
    AdminSidebar: __WEBPACK_IMPORTED_MODULE_2__AdminSidebar___default.a,
    ParkSidebar: __WEBPACK_IMPORTED_MODULE_3__ParkSidebar___default.a,
    PartnerSidebar: __WEBPACK_IMPORTED_MODULE_4__PartnerSidebar___default.a,
    AppFooter: __WEBPACK_IMPORTED_MODULE_5__Footer___default.a
  },
  mounted: function mounted() {
    document.body.classList = 'sidebar-mini ' + this.$config.adminlte.skin;
    this.fixContentWrapperSize();
  },

  methods: {
    fixContentWrapperSize: function fixContentWrapperSize() {
      var windowHeight = $(window).height();
      var footerHeight = $('.main-footer').outerHeight() || 0;
      var headerHeight = $('.main-header').outerHeight() || 0;
      $('.content-wrapper, .right-side').css('min-height', windowHeight - footerHeight - headerHeight);
    },
    userHasResearcherRole: function userHasResearcherRole() {
      return __WEBPACK_IMPORTED_MODULE_6__services_authentication__["a" /* default */].userHasResearcherRole();
    },
    userHasAdminRole: function userHasAdminRole() {
      return __WEBPACK_IMPORTED_MODULE_6__services_authentication__["a" /* default */].userHasAdminRole();
    },
    userHasParkRole: function userHasParkRole() {
      return __WEBPACK_IMPORTED_MODULE_6__services_authentication__["a" /* default */].userHasParkRole();
    },
    userHasPartnerRole: function userHasPartnerRole() {
      return __WEBPACK_IMPORTED_MODULE_6__services_authentication__["a" /* default */].userHasPartnerRole();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      creatorName: null,
      projectName: null
    };
  },
  mounted: function mounted() {
    this.creatorName = this.$config.creatorName;
    this.projectName = this.$config.projectName;
  }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_authentication__ = __webpack_require__(23);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Header',
  data: function data() {
    return {
      projectName: null
    };
  },

  methods: {
    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_0__services_authentication__["a" /* default */].logout();
      this.$router.push({ name: 'Homepage' });
    }
  },
  mounted: function mounted() {
    this.projectName = this.$config.projectName;
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_authentication__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_resource_client_quiz_period__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_resource_client_park_quiz__ = __webpack_require__(74);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ParkSidebar',
  data: function data() {
    return {
      showAnswerMenu: false,
      parkQuizUuid: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.isAnswerMenuVisible().then(function (r) {
      _this.showAnswerMenu = r;
    });
  },

  methods: {
    getParkId: function getParkId() {
      return __WEBPACK_IMPORTED_MODULE_1__services_authentication__["a" /* default */].getParkId();
    },
    isAnswerMenuVisible: function isAnswerMenuVisible() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.isParkQuizAvailable().then(function (r) {
          resolve(_this2.isAtOperationStage() && r);
        }).catch(reject);
      });
    },
    isAtOperationStage: function isAtOperationStage() {
      return __WEBPACK_IMPORTED_MODULE_1__services_authentication__["a" /* default */].getParkCurrentStage() === 'Operação';
    },
    isParkQuizAvailable: function isParkQuizAvailable() {
      var _this3 = this;

      return this.getQuizPeriod().then(function (quizPeriod) {
        var today = new Date().toISOString().substring(0, 10);
        if (!quizPeriod || quizPeriod.startingDate > today) {
          return false;
        }

        return _this3.getParkQuiz().then(function (parkQuiz) {
          if (!parkQuiz && quizPeriod.endingDate < today) {
            return false;
          }
          if (parkQuiz && !parkQuiz.isAvailableForAnswering) {
            return false;
          }
          _this3.parkQuizUuid = parkQuiz ? parkQuiz.uuid : null;
          return true;
        });
      });
    },
    getQuizPeriod: function getQuizPeriod() {
      var currentYear = new Date().getFullYear();
      return __WEBPACK_IMPORTED_MODULE_2__services_resource_client_quiz_period__["a" /* default */].getByYear(currentYear).then(function (r) {
        if (r.data.total === 0) {
          return null;
        }
        return r.data[0];
      });
    },
    getParkQuiz: function getParkQuiz() {
      var referenceYear = this.getReferenceYear();
      var parkId = __WEBPACK_IMPORTED_MODULE_1__services_authentication__["a" /* default */].getParkId();
      return __WEBPACK_IMPORTED_MODULE_3__services_resource_client_park_quiz__["a" /* default */].getByYear(parkId, referenceYear).then(function (r) {
        if (r.data.total === 0) {
          return null;
        }
        return r.data[0];
      });
    },
    getReferenceYear: function getReferenceYear() {
      return new Date().getFullYear() - 1;
    }
  }
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PartnerSidebar',
  computed: {
    reportsMenuStyle: function reportsMenuStyle() {
      var reportsRoutesNames = ['SegmentedChartsReports', 'SegmentedTextualReports', 'QuizReports'];
      return {
        display: reportsRoutesNames.indexOf(this.$route.name) > -1 ? 'block' : ''
      };
    }
  }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ResearcherSidebar',
  computed: {
    cmsMenuStyle: function cmsMenuStyle() {
      var cmsRouteNames = ['ParksCms', 'CompaniesCms', 'AboutCms'];
      return {
        display: cmsRouteNames.indexOf(this.$route.name) > -1 ? 'block' : ''
      };
    },
    reportsMenuStyle: function reportsMenuStyle() {
      var reportsRoutesNames = ['RelatorioEstatistico', 'SegmentedChartsReports', 'SegmentedTextualReports', 'QuizReports'];
      return {
        display: reportsRoutesNames.indexOf(this.$route.name) > -1 ? 'block' : ''
      };
    },
    exportMenuStyle: function exportMenuStyle() {
      var exportRoutesNames = ['ExportParks', 'ExportCompanies', 'ExportParkQuiz', 'ExportGeneralInformation'];
      return {
        display: exportRoutesNames.indexOf(this.$route.name) > -1 ? 'block' : ''
      };
    }
  }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminHome',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default.a }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_cms_Cms__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_cms_Cms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_cms_Cms__);
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AboutCms',
  components: { Cms: __WEBPACK_IMPORTED_MODULE_0__pages_cms_Cms___default.a }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_resource_client_cms__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_Notifier__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_Notifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_elements_Notifier__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ParksCms',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default.a, Notifier: __WEBPACK_IMPORTED_MODULE_2__components_elements_Notifier___default.a },
  props: ['pageTitle', 'pageName'],
  data: function data() {
    return {
      pageContent: {
        pageName: '',
        portugueseBody: '',
        englishBody: ''
      },
      activeContent: 'pt'
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.pageContent.pageName = this.pageName;
    __WEBPACK_IMPORTED_MODULE_1__services_resource_client_cms__["a" /* default */].get(this.pageName).then(function (r) {
      _this.pageContent = r.data;
    }).catch(function (e) {
      if (e.response.status !== 404) {
        throw e;
      }
    });
  },

  methods: {
    showPtContent: function showPtContent() {
      this.activeContent = 'pt';
    },
    showEnContent: function showEnContent() {
      this.activeContent = 'en';
    },
    updatePortugueseData: function updatePortugueseData(data) {
      this.pageContent.portugueseBody = data;
    },
    updateEnglishData: function updateEnglishData(data) {
      this.pageContent.englishBody = data;
    },
    save: function save() {
      __WEBPACK_IMPORTED_MODULE_1__services_resource_client_cms__["a" /* default */].put(this.pageContent).then(this.$refs.notifier.showSavedFormNotification());
    }
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_cms_Cms__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_cms_Cms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_cms_Cms__);
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CompaniesCms',
  components: { Cms: __WEBPACK_IMPORTED_MODULE_0__pages_cms_Cms___default.a }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_cms_Cms__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_cms_Cms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_cms_Cms__);
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ParksCms',
  components: { Cms: __WEBPACK_IMPORTED_MODULE_0__pages_cms_Cms___default.a }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_DataTables__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_DataTables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_elements_DataTables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_resource_client_park__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_GoBackButton__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_GoBackButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_elements_GoBackButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_backend_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_resource_client_company__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_date_formatter__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_Notifier__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_Notifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_elements_Notifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_authentication__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuejs_datepicker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuejs_datepicker_dist_locale__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuejs_datepicker_dist_locale__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CompaniesHome',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default.a, DataTables: __WEBPACK_IMPORTED_MODULE_1__components_elements_DataTables___default.a, GoBackButton: __WEBPACK_IMPORTED_MODULE_3__components_elements_GoBackButton___default.a, Notifier: __WEBPACK_IMPORTED_MODULE_7__components_elements_Notifier___default.a, DatePicker: __WEBPACK_IMPORTED_MODULE_9_vuejs_datepicker__["a" /* default */] },
  data: function data() {
    var _this = this;

    return {
      datepickerLanguage: __WEBPACK_IMPORTED_MODULE_10_vuejs_datepicker_dist_locale__["ptBR"],
      park: {},
      columns: [{ label: 'Nome', field: 'name' }, { label: 'Email', field: 'email' }, { label: 'Desligada', field: 'isLinkedToPark' }, { label: 'Opções', field: null }],
      columnDefs: [{
        targets: 2,
        render: function render(isLinkedToPark, type, full, meta) {
          return isLinkedToPark ? 'Não' : 'Sim';
        }
      }, {
        targets: -1,
        orderable: false,
        render: function render(data, type, full, meta) {
          var unlinkOrRelinkButtonBasedUponCurrentState = data.isLinkedToPark ? '<button\n                class="btn btn-xs btn-warning unlink-company"\n                data-company-id=' + data.id + '\n                data-toggle="modal"\n                data-target="#unlink-company-modal"\n                >\n                  <i class="fa fa-trash"></i>&nbsp Desligar\n              </button>' : '<button\n                class="btn btn-xs btn-warning relink-company"\n                data-company-id=' + data.id + '\n                data-toggle="modal"\n                data-target="#relink-company-modal"\n                >\n                  <i class="fa fa-trash"></i>&nbsp Religar\n              </button>';

          var buttons = '\n              <button\n                class="btn btn-xs btn-primary edit-company"\n                data-company-id=' + data.id + ('>\n                  <i class="fa fa-pencil"></i>&nbsp Editar\n              </button>\n              ' + unlinkOrRelinkButtonBasedUponCurrentState + '\n            ');

          if (_this.canDeleteCompany) {
            buttons = buttons + '\n              <button\n                class="btn btn-xs btn-danger delete-company"\n                data-company-id=' + data.id + '\n                data-toggle="modal"\n                data-target="#delete-company-modal"\n                >\n                  <i class="fa fa-trash"></i>&nbsp Excluir\n              </button>';
          }

          return buttons;
        }
      }],
      deleteCompanyId: '',
      unlinkCompanyId: null,
      unlinkCompanyDate: null,
      relinkCompanyId: null,
      relinkCompanyDate: null
    };
  },

  props: ['parkId'],
  created: function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_2__services_resource_client_park__["a" /* default */].get(this.parkId).then(function (r) {
      _this2.park = r.data;
    });
  },
  mounted: function mounted() {
    this.bindEditCompanyButtonClick();
    this.bindDeleteCompanyButtonClick();
    this.bindConfirmDeleteCompany();
    this.bindUnlinkCompanyButtonClick();
    this.bindConfirmUnlinkCompany();
    this.bindRelinkCompanyButtonClick();
    this.bindConfirmRelinkCompany();
  },

  methods: {
    getApiUrl: function getApiUrl() {
      return "https://api.inovadata-br.ufv.br/" + 'parks/' + this.parkId + '/companies/';
    },
    createCompany: function createCompany() {
      this.$router.push({ name: 'CreateCompany', params: { parkId: this.parkId } });
    },
    bindEditCompanyButtonClick: function bindEditCompanyButtonClick() {
      var that = this;
      $(document).on('click', '.edit-company', function (e) {
        var companyId = $(this).data('company-id');
        that.editCompany(companyId);
      });
    },
    editCompany: function editCompany(id) {
      this.$router.push({ name: 'EditCompany', params: { id: id } });
    },
    bindDeleteCompanyButtonClick: function bindDeleteCompanyButtonClick() {
      var that = this;
      $('body').off('click', '.delete-company').on('click', '.delete-company', function (e) {
        that.deleteCompanyId = $(this).data('company-id');
        console.log($(this).data('company-id'));
      });
    },
    bindConfirmDeleteCompany: function bindConfirmDeleteCompany() {
      var that = this;
      $('body').off('click', '#delete-company-modal-confirm').on('click', '#delete-company-modal-confirm', function (e) {
        that.deleteCompany();
      });
    },
    deleteCompany: function deleteCompany() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4__services_backend_api__["a" /* BackendApi */].getClient().delete('companies/' + this.deleteCompanyId).then(function (response) {
        _this3.reloadTable();
        _this3.showCompanyDeleteSuccessNotification();
      }).catch(function (e) {
        _this3.showCompanyDeleteErrorNotification();
      });
    },
    bindUnlinkCompanyButtonClick: function bindUnlinkCompanyButtonClick() {
      var that = this;
      $('body').off('click', '.unlink-company').on('click', '.unlink-company', function (e) {
        that.unlinkCompanyId = $(this).data('company-id');
        that.unlinkCompanyDate = null;
      });
    },
    bindConfirmUnlinkCompany: function bindConfirmUnlinkCompany() {
      var that = this;
      $('body').off('click', '#unlink-company-modal-confirm').on('click', '#unlink-company-modal-confirm', function (e) {
        that.unlinkCompany();
      });
    },
    unlinkCompany: function unlinkCompany() {
      var _this4 = this;

      var dateAsApiFormat = __WEBPACK_IMPORTED_MODULE_6__services_date_formatter__["a" /* default */].formatAPIDate(this.unlinkCompanyDate);
      __WEBPACK_IMPORTED_MODULE_5__services_resource_client_company__["a" /* default */].unlink(this.unlinkCompanyId, dateAsApiFormat).then(function (response) {
        _this4.reloadTable();
        _this4.showCompanyUnlinkSuccessNotification();
      }).catch(function (e) {
        _this4.showCompanyUnlinkErrorNotification();
      });
    },
    bindRelinkCompanyButtonClick: function bindRelinkCompanyButtonClick() {
      var that = this;
      $('body').off('click', '.relink-company').on('click', '.relink-company', function (e) {
        that.relinkCompanyId = $(this).data('company-id');
        that.relinkCompanyDate = null;
      });
    },
    bindConfirmRelinkCompany: function bindConfirmRelinkCompany() {
      var that = this;
      $('body').off('click', '#relink-company-modal-confirm').on('click', '#relink-company-modal-confirm', function (e) {
        that.relinkCompany();
      });
    },
    relinkCompany: function relinkCompany() {
      var _this5 = this;

      var dateAsApiFormat = __WEBPACK_IMPORTED_MODULE_6__services_date_formatter__["a" /* default */].formatAPIDate(this.relinkCompanyDate);
      __WEBPACK_IMPORTED_MODULE_5__services_resource_client_company__["a" /* default */].relink(this.relinkCompanyId, dateAsApiFormat).then(function (response) {
        _this5.reloadTable();
        _this5.showCompanyRelinkSuccessNotification();
      }).catch(function (e) {
        _this5.showCompanyRelinkErrorNotification();
      });
    },
    reloadTable: function reloadTable() {
      $('#parks-table').DataTable().ajax.reload();
    },
    showCompanyDeleteSuccessNotification: function showCompanyDeleteSuccessNotification() {
      this.$notify({ type: 'success', title: 'Sucesso', text: 'A empresa foi excluída do sistema!' });
    },
    showCompanyDeleteErrorNotification: function showCompanyDeleteErrorNotification() {
      this.$notify({ type: 'error', title: 'Erro', text: 'Ocorreu um erro ao excluir a empresa! Entre em contato com a equipe de desenvolvimento.' });
    },
    showCompanyUnlinkSuccessNotification: function showCompanyUnlinkSuccessNotification() {
      this.$notify({ type: 'success', title: 'Sucesso', text: 'A empresa foi desligada do parque!' });
    },
    showCompanyUnlinkErrorNotification: function showCompanyUnlinkErrorNotification() {
      this.$notify({ type: 'error', title: 'Erro', text: 'Ocorreu um erro ao desligar a empresa! Entre em contato com a equipe de desenvolvimento.' });
    },
    showCompanyRelinkSuccessNotification: function showCompanyRelinkSuccessNotification() {
      this.$notify({ type: 'success', title: 'Sucesso', text: 'A empresa foi religada ao parque!' });
    },
    showCompanyRelinkErrorNotification: function showCompanyRelinkErrorNotification() {
      this.$notify({ type: 'error', title: 'Erro', text: 'Ocorreu um erro ao religar a empresa! Entre em contato com a equipe de desenvolvimento.' });
    }
  },
  computed: {
    canDeleteCompany: function canDeleteCompany() {
      return __WEBPACK_IMPORTED_MODULE_8__services_authentication__["a" /* default */].userHasAdminRole() || __WEBPACK_IMPORTED_MODULE_8__services_authentication__["a" /* default */].userHasResearcherRole();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_the_mask__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_GoBackButton__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_GoBackButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_elements_GoBackButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_base64_file_upload__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_base64_file_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_base64_file_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_search_select__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_search_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker_dist_locale__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker_dist_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_date_formatter__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_json_brazil_cities_by_state_initials_json__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_json_brazil_cities_by_state_initials_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_json_brazil_cities_by_state_initials_json__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CompanyForm',
  components: { TheMask: __WEBPACK_IMPORTED_MODULE_1_vue_the_mask___default.a, GoBackButton: __WEBPACK_IMPORTED_MODULE_2__components_elements_GoBackButton___default.a, VueBase64FileUpload: __WEBPACK_IMPORTED_MODULE_3_vue_base64_file_upload___default.a, ModelSelect: __WEBPACK_IMPORTED_MODULE_4_vue_search_select__["ModelSelect"], DatePicker: __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__["a" /* default */] },
  props: ['company', 'errors', 'onSubmit'],
  data: function data() {
    return {
      datepickerLanguage: __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker_dist_locale__["ptBR"],
      customImageMaxSize: 3,
      areasOfExpertise: ['Aeronáutico', 'Agronegócio', 'Alimentos', 'Automotiva', 'Biotecnologia', 'De suporte à C, T & I', 'Economia criativa', 'Eletrônica', 'Energia', 'Espacial', 'Meio ambiente', 'Mineral', 'Petróleo e gás natural', 'Química', 'Recursos hídricos', 'Saúde animal', 'Saúde humana', 'Tecnologia da informação', 'Telecomunicações', 'Transporte aquaviario e construção naval', 'Transporte terrestre e hidroviário']
    };
  },
  mounted: function mounted() {
    if (!this.company.hasOwnProperty('areasOfExpertise')) {
      this.company.areasOfExpertise = [];
    }

    $('#state').attr('autocomplete', 'disable-state-field-autocomplete');
    $('#city').attr('autocomplete', 'disable-city-field-autocomplete');
  },

  methods: {
    onLoad: function onLoad(dataUri) {
      this.company.logoPicture = dataUri;
    },
    onSizeExceeded: function onSizeExceeded(size) {
      alert('Image ' + size + 'Mb size exceeds limits of ' + this.customImageMaxSize + 'Mb!');
    },
    customSelectItemClass: function customSelectItemClass() {
      return 'search-select-item';
    },
    onCreationDateSelected: function onCreationDateSelected(date) {
      this.company.creationDate = __WEBPACK_IMPORTED_MODULE_7__services_date_formatter__["a" /* default */].formatAPIDate(date);
    },
    getCreationDateAsDateObject: function getCreationDateAsDateObject() {
      if (!this.company.creationDate) {
        return null;
      }
      return new Date(this.company.creationDate.split('-'));
    }
  },
  computed: {
    getYearsRange: function getYearsRange() {
      var currentYear = new Date().getFullYear();
      var startYear = 1985;
      var years = [];
      while (currentYear >= startYear) {
        years.push(currentYear--);
      }

      return years;
    },

    states: function states() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__assets_json_brazil_cities_by_state_initials_json___default.a).map(function (e) {
        return {
          value: e, text: __WEBPACK_IMPORTED_MODULE_8__assets_json_brazil_cities_by_state_initials_json___default.a[e].name
        };
      });
    },
    cities: function cities() {
      if (!this.company.state) {
        return [];
      }
      var cities = __WEBPACK_IMPORTED_MODULE_8__assets_json_brazil_cities_by_state_initials_json___default.a[this.company.state].cities;
      return cities.map(function (e) {
        return { value: e, text: e };
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_resource_client_park__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_resource_client_company__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_companies_CompanyForm__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_companies_CompanyForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_companies_CompanyForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateCompany',
  props: ['parkId'],
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default.a, CompanyForm: __WEBPACK_IMPORTED_MODULE_3__pages_companies_CompanyForm___default.a },
  data: function data() {
    return {
      company: {},
      park: {},
      errors: {}
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__services_resource_client_park__["a" /* default */].get(this.parkId).then(function (r) {
      _this.park = r.data;
    });
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__services_resource_client_company__["a" /* default */].post(this.parkId, this.company).then(function (r) {
        _this2.$router.push({ name: 'CompaniesHome', params: { parkId: _this2.parkId } });
      }).catch(function (e) {
        _this2.errors = e.response.data.errors;
      });
    }
  }
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_resource_client_company__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_companies_CompanyForm__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_companies_CompanyForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_companies_CompanyForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditCompany',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default.a, CompanyForm: __WEBPACK_IMPORTED_MODULE_2__pages_companies_CompanyForm___default.a },
  data: function data() {
    return {
      company: {},
      errors: {}
    };
  },
  props: ['id'],
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__services_resource_client_company__["a" /* default */].put(this.company).then(function (r) {
        _this.$router.push({ name: 'CompaniesHome', params: { parkId: _this.company._links['ea:park'].id } });
      }).catch(function (e) {
        _this.errors = e.response.data.errors;
      });
    }
  },
  created: function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_1__services_resource_client_company__["a" /* default */].get(this.id).then(function (r) {
      _this2.company = r.data;
    });
  }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotFoundError'
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ServerError'
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UnauthorizedError'
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ParksFilter__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ParksFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ParksFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_backend_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_file_saver__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_file_saver__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var CURRENT_YEAR = new Date().getFullYear();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ExportCompanies',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_4__components_template_Adminlte___default.a, ParksFilter: __WEBPACK_IMPORTED_MODULE_5__ParksFilter___default.a },
  data: function data() {
    return {
      parks: [],
      selectedYear: CURRENT_YEAR,
      waitingDownload: false,
      defaultLinked: 'ativas',
      linked: 1
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getParks();

            case 2:
              _this.parks = _context.sent;

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getParks: function getParks() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, parksResponseWithNoLinksNeitherTotalElements;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__services_backend_api__["a" /* BackendApi */].getAnonymousClient().get('/parks?hideLogo=true&orderBy=name&limit=0');

              case 2:
                response = _context2.sent;
                parksResponseWithNoLinksNeitherTotalElements = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(response.data).slice(0, -2);
                return _context2.abrupt('return', parksResponseWithNoLinksNeitherTotalElements.map(function (park) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ isSelected: true }, park);
                }));

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleDownloadClick: function handleDownloadClick(e) {
      var _this3 = this;

      e.preventDefault();

      var queryParams = {
        parks: this.selectedParksIds.join(','),
        year: this.selectedYear,
        linked: this.linked
      };

      this.waitingDownload = true;
      __WEBPACK_IMPORTED_MODULE_6__services_backend_api__["a" /* BackendApi */].getClient().get('/spreadsheet/companies', {
        params: queryParams, responseType: 'blob'
      }).then(function (response) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_file_saver__["saveAs"])(response.data, 'companies.xlsx');
      }).finally(function () {
        _this3.waitingDownload = false;
      });
    },
    alterLinked: function alterLinked() {
      this.defaultLinked = this.defaultLinked === 'ativas' ? 'inativas' : 'ativas';
      this.linked = this.linked ? 0 : 1;
    }
  },
  computed: {
    availableYears: function availableYears() {
      var firstAvailableYear = 1985;

      var years = [];
      for (var i = CURRENT_YEAR; i >= firstAvailableYear; i--) {
        years.push(i);
      }
      return years;
    },
    selectedParksIds: function selectedParksIds() {
      return this.parks.filter(function (park) {
        return park.isSelected;
      }).map(function (park) {
        return park.id;
      });
    }
  }
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ParksFilter__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ParksFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ParksFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_backend_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_file_saver__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_file_saver__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var FIRST_AVAILABLE_YEAR = 1980;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ExportGeneralInformation',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_4__components_template_Adminlte___default.a, ParksFilter: __WEBPACK_IMPORTED_MODULE_5__ParksFilter___default.a },
  data: function data() {
    return {
      parks: [],
      selectedYear: FIRST_AVAILABLE_YEAR,
      waitingDownload: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getParks();

            case 2:
              _this.parks = _context.sent;

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getParks: function getParks() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, parksResponseWithNoLinksNeitherTotalElements;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__services_backend_api__["a" /* BackendApi */].getAnonymousClient().get('/parks/that-answered-general-information-quiz?hideLogo=true&orderBy=name&limit=0');

              case 2:
                response = _context2.sent;
                parksResponseWithNoLinksNeitherTotalElements = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(response.data).slice(0, -2);
                return _context2.abrupt('return', parksResponseWithNoLinksNeitherTotalElements.map(function (park) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ isSelected: true }, park);
                }));

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleDownloadClick: function handleDownloadClick(e) {
      var _this3 = this;

      e.preventDefault();

      var queryParams = {
        parks: this.selectedParksIds.join(','),
        year: this.selectedYear
      };

      this.waitingDownload = true;
      __WEBPACK_IMPORTED_MODULE_6__services_backend_api__["a" /* BackendApi */].getClient().get('/spreadsheet/general-information', {
        params: queryParams, responseType: 'blob'
      }).then(function (response) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_file_saver__["saveAs"])(response.data, 'general-information.xlsx');
      }).finally(function () {
        _this3.waitingDownload = false;
      });
    }
  },
  computed: {
    availableYears: function availableYears() {
      var currentYear = new Date().getFullYear();

      var years = [];
      for (var i = currentYear; i >= FIRST_AVAILABLE_YEAR; i--) {
        years.push(i);
      }
      return years;
    },
    selectedParksIds: function selectedParksIds() {
      return this.parks.filter(function (park) {
        return park.isSelected;
      }).map(function (park) {
        return park.id;
      });
    }
  }
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ParksFilter__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ParksFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ParksFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_resource_client_park__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_backend_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_file_saver__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_file_saver__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ExportParkQuiz',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_4__components_template_Adminlte___default.a, ParksFilter: __WEBPACK_IMPORTED_MODULE_5__ParksFilter___default.a },
  data: function data() {
    return {
      parks: [],
      selectedYear: null,
      waitingDownload: null,
      parksWithApprovedQuizPerYear: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getParksWithApprovedParkQuizPerYear();

            case 2:
              _this.parksWithApprovedQuizPerYear = _context.sent;

              if (_this.availableYears.length > 0) {
                _this.selectedYear = _this.availableYears[0];
              }

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getParksWithApprovedParkQuizPerYear: function getParksWithApprovedParkQuizPerYear() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__services_resource_client_park__["a" /* default */].withApprovedParkQuizPerYear();

              case 2:
                response = _context2.sent;
                return _context2.abrupt('return', response.data || {});

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleDownloadClick: function handleDownloadClick(variant) {
      var _this3 = this;

      var queryParams = {
        parks: this.selectedParksIds.join(','),
        year: this.selectedYear
      };

      var path = variant === 'readable' ? '/spreadsheet/park-quiz/readable' : '/spreadsheet/park-quiz';
      var filename = variant === 'readable' ? 'park-quiz-readable_' + this.selectedYear + '.xlsx' : 'park-quiz_' + this.selectedYear + '.xlsx';

      this.waitingDownload = variant;
      __WEBPACK_IMPORTED_MODULE_7__services_backend_api__["a" /* BackendApi */].getClient().get(path, {
        params: queryParams, responseType: 'blob'
      }).then(function (response) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_file_saver__["saveAs"])(response.data, filename);
      }).finally(function () {
        _this3.waitingDownload = null;
      });
    }
  },
  watch: {
    selectedYear: function selectedYear(currentSelectedYear) {
      var _this4 = this;

      this.parks = [];

      if (!currentSelectedYear) {
        return;
      }

      var parksWithApprovedQuizInSelectedYear = this.parksWithApprovedQuizPerYear[currentSelectedYear] || [];
      parksWithApprovedQuizInSelectedYear.forEach(function (park) {
        _this4.parks.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, park, { 'isSelected': true }));
      });
    }
  },
  computed: {
    availableYears: function availableYears() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.parksWithApprovedQuizPerYear).sort().reverse();
    },
    isDownloading: function isDownloading() {
      return this.waitingDownload !== null;
    },
    selectedParksIds: function selectedParksIds() {
      return this.parks.filter(function (park) {
        return park.isSelected;
      }).map(function (park) {
        return park.id;
      });
    }
  }
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ParksFilter__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ParksFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ParksFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_backend_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_file_saver__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_file_saver__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ExportParks',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_4__components_template_Adminlte___default.a, ParksFilter: __WEBPACK_IMPORTED_MODULE_5__ParksFilter___default.a },
  data: function data() {
    return {
      parks: [],
      waitingDownload: false,
      waitingConfirmedDownload: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getParks();

            case 2:
              _this.parks = _context.sent;

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getParks: function getParks() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, parksResponseWithNoLinksNeitherTotalElements;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__services_backend_api__["a" /* BackendApi */].getAnonymousClient().get('/parks?hideLogo=true&orderBy=name&limit=0');

              case 2:
                response = _context2.sent;
                parksResponseWithNoLinksNeitherTotalElements = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(response.data).slice(0, -2);
                return _context2.abrupt('return', parksResponseWithNoLinksNeitherTotalElements.map(function (park) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ isSelected: true }, park);
                }));

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleDownloadClick: function handleDownloadClick(e) {
      var _this3 = this;

      e.preventDefault();

      var queryParams = {
        parks: this.selectedParksIds.join(',')
      };

      this.waitingDownload = true;
      __WEBPACK_IMPORTED_MODULE_6__services_backend_api__["a" /* BackendApi */].getClient().get('/spreadsheet/parks', {
        params: queryParams, responseType: 'blob'
      }).then(function (response) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_file_saver__["saveAs"])(response.data, 'parks.xlsx');
      }).finally(function () {
        _this3.waitingDownload = false;
      });
    },
    handleConfirmedDownloadClick: function handleConfirmedDownloadClick(e) {
      var _this4 = this;

      e.preventDefault();

      this.waitingConfirmedDownload = true;
      __WEBPACK_IMPORTED_MODULE_6__services_backend_api__["a" /* BackendApi */].getClient().get('spreadsheet/parks/confirmed', {
        responseType: 'blob'
      }).then(function (response) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_file_saver__["saveAs"])(response.data, 'confirmed-parks.xlsx');
      }).finally(function () {
        _this4.waitingConfirmedDownload = false;
      });
    }
  },
  computed: {
    selectedParksIds: function selectedParksIds() {
      return this.parks.filter(function (park) {
        return park.isSelected;
      }).map(function (park) {
        return park.id;
      });
    }
  }
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ParksFilter',
  props: ['parks', 'disabled'],
  methods: {
    selectAllParks: function selectAllParks() {
      this.parks.forEach(function (park) {
        park.isSelected = true;
      });
    },
    clearSelectedParks: function clearSelectedParks() {
      this.parks.forEach(function (park) {
        park.isSelected = false;
      });
    }
  }
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_backend_api__ = __webpack_require__(3);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MailingHome',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_4__components_template_Adminlte___default.a },
  data: function data() {
    return {
      parks: [],
      subject: '',
      body: '',
      errors: {
        recipients: '',
        subject: '',
        body: ''
      },
      isSending: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getParks();

            case 2:
              _this.parks = _context.sent;

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getParks: function getParks() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, parksResponseWithNoLinksNeitherTotalElements;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__services_backend_api__["a" /* BackendApi */].getAnonymousClient().get('/parks?hideLogo=true&orderBy=name&limit=0');

              case 2:
                response = _context2.sent;
                parksResponseWithNoLinksNeitherTotalElements = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(response.data).slice(0, -2);
                return _context2.abrupt('return', parksResponseWithNoLinksNeitherTotalElements.map(function (park) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ isSelected: false }, park);
                }));

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    selectAllParks: function selectAllParks() {
      this.parks.forEach(function (park) {
        park.isSelected = true;
      });
    },
    clearSelectedParks: function clearSelectedParks() {
      this.parks.forEach(function (park) {
        park.isSelected = false;
      });
    },
    updateContent: function updateContent(data) {
      this.body = data;
    },
    onSend: function onSend() {
      if (this.validateAndGetErrors()) {
        this.sendMails();
      }
    },
    sendMails: function sendMails() {
      var _this3 = this;

      this.isSending = true;

      __WEBPACK_IMPORTED_MODULE_5__services_backend_api__["a" /* BackendApi */].getClient().post('/mailing', {
        recipients: this.recipients,
        subject: this.subject,
        body: this.body
      }).then(function () {
        _this3.subject = '';
        _this3.body = '';
        _this3.clearSelectedParks();

        _this3.isSending = false;

        _this3.$notify({
          type: 'success',
          title: 'E-mails enviados',
          text: 'A mensagem foi enviada por e-mail para os destinatários selecionados.'
        });
      }).catch(function () {
        _this3.isSending = false;

        _this3.$notify({
          type: 'error',
          title: 'Erro ao enviar e-mails',
          text: 'Ocorreu algum erro ao enviar a mensagem para os destinatários selecionados.'
        });
      });
    },
    validateAndGetErrors: function validateAndGetErrors() {
      this.validate();
      return this.isValid();
    },
    validate: function validate() {
      this.errors.recipients = !this.recipients.length ? 'Selecione ao menos um destinatário na caixa ao lado' : '';
      this.errors.subject = this.validateSubject();
      this.errors.body = this.validateBody();
    },
    validateSubject: function validateSubject() {
      if (!this.subject) {
        return 'Por favor, preencha um assunto para o e-mail a ser enviado';
      }
      if (this.subject.length < 5) {
        return 'O assunto do e-mail deve ter pelo menos 5 caracteres';
      }
      if (this.subject.length > 80) {
        return 'O assunto do e-mail deve ter no máximo 80 caracteres';
      }
      return '';
    },
    validateBody: function validateBody() {
      if (!this.body) {
        return 'Por favor, preencha o corpo do e-mail';
      }
      if (this.body.length < 5) {
        return 'O corpo do e-mail deve ter pelo menos 5 caracteres';
      }
      if (this.body.length > 5242880) {
        return 'O corpo do e-mail ultrapassou o limite máximo de caracteres permitido';
      }
      return '';
    },
    isValid: function isValid() {
      return !this.errors.recipients && !this.errors.subject && !this.errors.body;
    }
  },
  computed: {
    recipients: function recipients() {
      return this.parks.filter(function (park) {
        return park.isSelected;
      }).map(function (park) {
        return park.email;
      });
    }
  }
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_resource_client_maintenance__ = __webpack_require__(383);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ParkStageAudit',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_1__components_template_Adminlte___default.a },
  data: function data() {
    return {
      parkStagesLoading: false,
      parkStagesAction: null,
      parkStagesResult: null,
      parkStagesError: null,
      legalNatureLoading: false,
      legalNatureResult: null,
      legalNatureError: null,
      parkId: null,
      landAreasLoading: false,
      landAreasResult: null,
      landAreasError: null,
      financialIncludeUnanswered: true,
      financialLoading: false,
      financialAction: null,
      financialResult: null,
      financialError: null
    };
  },

  computed: {
    financialVisibleRows: function financialVisibleRows() {
      if (!this.financialResult || !this.financialResult.rows) {
        return [];
      }
      return this.financialResult.rows.filter(function (row) {
        return row.status !== 'unchanged' && row.status !== 'skipped_pending';
      });
    },
    financialHiddenUnchanged: function financialHiddenUnchanged() {
      if (!this.financialResult || !this.financialResult.rows) {
        return 0;
      }
      return this.financialResult.rows.length - this.financialVisibleRows.length;
    }
  },
  methods: {
    parseMaintenanceError: function parseMaintenanceError(error) {
      if (!error || !error.response) {
        return 'Erro ao conectar com a API. Verifique sua conexão e tente novamente.';
      }

      var status = error.response.status;
      var apiMessage = error.response.data && error.response.data.message;

      if (status === 401) {
        return 'Sessão expirada ou token inválido. Faça login novamente como administrador.';
      }
      if (status === 403) {
        return 'Seu usuário não tem permissão para executar rotinas de manutenção.';
      }
      if (status === 404) {
        return 'Endpoint de manutenção não encontrado. Verifique se a API foi atualizada e se o cache de produção (var/cache/prod) foi limpo após o deploy.';
      }
      if (apiMessage) {
        return apiMessage;
      }

      return 'Não foi possível executar a rotina. Tente novamente mais tarde.';
    },
    runAudit: function runAudit() {
      this.executeParkStages('audit', function () {
        return __WEBPACK_IMPORTED_MODULE_2__services_resource_client_maintenance__["a" /* default */].auditParkStages();
      });
    },
    runSync: function runSync() {
      if (!window.confirm('Isso irá atualizar o estágio cadastrado dos parques com base nas datas das Informações Gerais. Deseja continuar?')) {
        return;
      }
      this.executeParkStages('sync', function () {
        return __WEBPACK_IMPORTED_MODULE_2__services_resource_client_maintenance__["a" /* default */].syncParkStages();
      });
    },
    runLegalNatureUpdate: function runLegalNatureUpdate() {
      var _this = this;

      if (!window.confirm('Isso irá atualizar as opções de natureza jurídica no banco de dados. Deseja continuar?')) {
        return;
      }

      this.legalNatureLoading = true;
      this.legalNatureError = null;
      this.legalNatureResult = null;

      __WEBPACK_IMPORTED_MODULE_2__services_resource_client_maintenance__["a" /* default */].updateManagementEntityLegalNatureOptions().then(function (response) {
        _this.legalNatureResult = response.data;
      }).catch(function (error) {
        _this.legalNatureError = _this.parseMaintenanceError(error);
      }).finally(function () {
        _this.legalNatureLoading = false;
      });
    },
    runLandAreasFix: function runLandAreasFix() {
      var _this2 = this;

      if (!this.parkId) {
        return;
      }

      if (!window.confirm('Isso irá recriar as respostas de áreas do questionário com base nas Informações Gerais. Deseja continuar?')) {
        return;
      }

      this.landAreasLoading = true;
      this.landAreasError = null;
      this.landAreasResult = null;

      __WEBPACK_IMPORTED_MODULE_2__services_resource_client_maintenance__["a" /* default */].fixParkLandAreas(this.parkId).then(function (response) {
        _this2.landAreasResult = response.data;
      }).catch(function (error) {
        _this2.landAreasError = _this2.parseMaintenanceError(error);
      }).finally(function () {
        _this2.landAreasLoading = false;
      });
    },
    executeParkStages: function executeParkStages(action, request) {
      var _this3 = this;

      this.parkStagesLoading = true;
      this.parkStagesAction = action;
      this.parkStagesError = null;
      request().then(function (response) {
        _this3.parkStagesResult = response.data;
      }).catch(function (error) {
        _this3.parkStagesError = _this3.parseMaintenanceError(error);
      }).finally(function () {
        _this3.parkStagesLoading = false;
      });
    },
    runFinancialAudit: function runFinancialAudit() {
      var _this4 = this;

      this.executeFinancial('audit', function () {
        return __WEBPACK_IMPORTED_MODULE_2__services_resource_client_maintenance__["a" /* default */].auditFinancialOutliers(_this4.financialIncludeUnanswered);
      });
    },
    runFinancialFix: function runFinancialFix() {
      var _this5 = this;

      if (!window.confirm('Isso irá atualizar valores monetários no banco conforme a planilha de outliers. Deseja continuar?')) {
        return;
      }
      this.executeFinancial('fix', function () {
        return __WEBPACK_IMPORTED_MODULE_2__services_resource_client_maintenance__["a" /* default */].fixFinancialOutliers(_this5.financialIncludeUnanswered);
      });
    },
    executeFinancial: function executeFinancial(action, request) {
      var _this6 = this;

      this.financialLoading = true;
      this.financialAction = action;
      this.financialError = null;
      request().then(function (response) {
        _this6.financialResult = response.data;
      }).catch(function (error) {
        _this6.financialError = _this6.parseMaintenanceError(error);
      }).finally(function () {
        _this6.financialLoading = false;
      });
    },
    formatMoney: function formatMoney(value) {
      if (value === null || value === undefined || value === '') {
        return '—';
      }
      var number = Number(value);
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(number)) {
        return String(value);
      }
      return number.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    financialStatusClass: function financialStatusClass(status) {
      if (!status) {
        return 'label-default';
      }
      if (status.indexOf('updated') === 0 || status === 'would_update' || status.indexOf('would_update') === 0) {
        return 'label-warning';
      }
      if (status === 'unchanged') {
        return 'label-success';
      }
      if (status === 'answer_not_found' || status === 'park_not_found' || status === 'ambiguous') {
        return 'label-danger';
      }
      return 'label-default';
    }
  }
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_resource_client_news__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_news_NewsForm__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_news_NewsForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_news_NewsForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateNews',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default.a, NewsForm: __WEBPACK_IMPORTED_MODULE_2__pages_news_NewsForm___default.a },
  data: function data() {
    return {
      news: {},
      errors: {}
    };
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__services_resource_client_news__["a" /* default */].post(this.news).then(function (r) {
        _this.$router.push({ name: 'NewsHome' });
      }).catch(function (e) {
        _this.errors = e.response.data.errors;
      });
    }
  }
});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_resource_client_news__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_news_NewsForm__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_news_NewsForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_news_NewsForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditNews',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default.a, NewsForm: __WEBPACK_IMPORTED_MODULE_2__pages_news_NewsForm___default.a },
  data: function data() {
    return {
      news: {},
      errors: {}
    };
  },
  props: ['id'],
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__services_resource_client_news__["a" /* default */].put(this.news).then(function (r) {
        _this.$router.push({ name: 'NewsHome' });
      }).catch(function (e) {
        _this.errors = e.response.data.errors;
      });
    }
  },
  created: function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_1__services_resource_client_news__["a" /* default */].get(this.id).then(function (r) {
      _this2.news = r.data;
    });
  }
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_GoBackButton__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_GoBackButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_elements_GoBackButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker_dist_locale__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker_dist_locale__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NewsForm',
  components: { GoBackButton: __WEBPACK_IMPORTED_MODULE_0__components_elements_GoBackButton___default.a, DatePicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */] },
  props: ['news', 'errors', 'onSubmit'],
  data: function data() {
    return {
      datepickerLanguage: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker_dist_locale__["ptBR"]
    };
  },

  methods: {
    updateContent: function updateContent(data) {
      this.news.content = data;
    }
  }
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_DataTables__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_DataTables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_elements_DataTables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_date_formatter__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_backend_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_Notifier__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_Notifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_elements_Notifier__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NewsHome',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default.a, Notifier: __WEBPACK_IMPORTED_MODULE_4__components_elements_Notifier___default.a, DataTables: __WEBPACK_IMPORTED_MODULE_1__components_elements_DataTables___default.a },
  data: function data() {
    return {
      apiUrl: "https://api.inovadata-br.ufv.br/" + 'news',
      columns: [{ label: 'Titulo', field: 'title' }, { label: 'Data', field: 'dateTime' }, { label: 'Opções', field: null }],
      columnDefs: [{
        targets: 1,
        render: __WEBPACK_IMPORTED_MODULE_2__services_date_formatter__["a" /* default */].formatIsoDate
      }, {
        targets: 2,
        orderable: false,
        render: function render(data, type, full, meta) {
          return '\n            <button\n              class="btn btn-xs btn-primary edit-news"\n              data-news-id=' + data.id + '>\n                <i class="fa fa-pencil"></i>\n                &nbsp; Editar\n            </button>\n            <button\n              class="btn btn-xs btn-danger delete-news"\n              data-news-id=' + data.id + '\n              data-toggle="modal"\n              data-target="#delete-news-modal">\n              <i class="fa fa-close"></i>\n              &nbsp; Excluir\n            </button>\n            ';
        }
      }],
      deleteNewsId: null
    };
  },
  mounted: function mounted() {
    this.bindConfirmDeleteNews();
    this.bindEditNewsButtonClick();
    this.bindDeleteNewsButtonClick();
  },

  methods: {
    createNews: function createNews() {
      this.$router.push({ name: 'CreateNews' });
    },
    bindEditNewsButtonClick: function bindEditNewsButtonClick() {
      var that = this;
      $('body').off('click', '.edit-news').on('click', '.edit-news', function (e) {
        var newsId = $(this).data('news-id');
        that.editNews(newsId);
      });
    },
    editNews: function editNews(id) {
      this.$router.push({ name: 'EditNews', params: { id: id } });
    },
    bindDeleteNewsButtonClick: function bindDeleteNewsButtonClick() {
      var that = this;
      $('body').off('click', '.delete-news').on('click', '.delete-news', function (e) {
        that.deleteNewsId = $(this).data('news-id');
      });
    },
    bindConfirmDeleteNews: function bindConfirmDeleteNews() {
      var that = this;
      $('body').off('click', '#delete-news-modal-confirm').on('click', '#delete-news-modal-confirm', function (e) {
        that.deleteNews();
      });
    },
    deleteNews: function deleteNews() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__services_backend_api__["a" /* BackendApi */].getClient().delete('news/' + this.deleteNewsId).then(function (response) {
        _this.reloadTable();
        _this.showNewsDeleteSuccessNotification();
      }).catch(function (e) {
        _this.showNewsDeleteErrorNotification();
      });
    },
    reloadTable: function reloadTable() {
      $('#news-table').DataTable().ajax.reload();
    },
    showNewsDeleteSuccessNotification: function showNewsDeleteSuccessNotification() {
      this.$notify({ type: 'success', title: 'Sucesso', text: 'A notícia foi excluída do sistema!' });
    },
    showNewsDeleteErrorNotification: function showNewsDeleteErrorNotification() {
      this.$notify({ type: 'error', title: 'Erro', text: 'Ocorreu um erro ao excluir a notícia! Entre em contato com a equipe de desenvolvimento.' });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_resource_client_park__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_parks_ParkForm__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_parks_ParkForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_parks_ParkForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreatePark',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default.a, ParkForm: __WEBPACK_IMPORTED_MODULE_2__pages_parks_ParkForm___default.a },
  data: function data() {
    return {
      park: {},
      errors: {}
    };
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__services_resource_client_park__["a" /* default */].post(this.park).then(function (r) {
        _this.$router.push({ name: 'Parks' });
      }).catch(function (e) {
        _this.errors = e.response.data.errors;
      });
    }
  }
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_resource_client_park__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_parks_ParkForm__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_parks_ParkForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_parks_ParkForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_Notifier__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_Notifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_elements_Notifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_authentication__ = __webpack_require__(23);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditPark',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default.a, ParkForm: __WEBPACK_IMPORTED_MODULE_2__pages_parks_ParkForm___default.a, Notifier: __WEBPACK_IMPORTED_MODULE_3__components_elements_Notifier___default.a },
  data: function data() {
    return {
      park: {},
      errors: {}
    };
  },
  props: ['id'],
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__services_resource_client_park__["a" /* default */].put(this.park).then(function (r) {
        _this.$refs.notifier.showSavedFormNotification();
        _this.errors = {};

        if (__WEBPACK_IMPORTED_MODULE_4__services_authentication__["a" /* default */].userHasParkRole()) {
          __WEBPACK_IMPORTED_MODULE_4__services_authentication__["a" /* default */].getParkData();
        }
      }).catch(function (e) {
        _this.errors = e.response.data.errors;
        _this.$refs.notifier.showErrorNotification();
      });
    }
  },
  created: function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_1__services_resource_client_park__["a" /* default */].get(this.id).then(function (r) {
      _this2.park = r.data;
    });
  }
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_the_mask__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_GoBackButton__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_GoBackButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_elements_GoBackButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_base64_file_upload__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_base64_file_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_base64_file_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_search_select__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_search_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_json_brazil_cities_by_state_initials_json__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_json_brazil_cities_by_state_initials_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_json_brazil_cities_by_state_initials_json__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ParkForm',
  components: { TheMask: __WEBPACK_IMPORTED_MODULE_1_vue_the_mask___default.a, GoBackButton: __WEBPACK_IMPORTED_MODULE_2__components_elements_GoBackButton___default.a, VueBase64FileUpload: __WEBPACK_IMPORTED_MODULE_3_vue_base64_file_upload___default.a, ModelSelect: __WEBPACK_IMPORTED_MODULE_4_vue_search_select__["ModelSelect"] },
  props: ['park', 'errors', 'onSubmit'],
  data: function data() {
    return {
      customImageMaxSize: 3
    };
  },
  mounted: function mounted() {
    $('#state').attr('autocomplete', 'disable-state-field-autocomplete');
    $('#city').attr('autocomplete', 'disable-city-field-autocomplete');
  },

  computed: {
    states: function states() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_5__assets_json_brazil_cities_by_state_initials_json___default.a).map(function (e) {
        return {
          value: e, text: __WEBPACK_IMPORTED_MODULE_5__assets_json_brazil_cities_by_state_initials_json___default.a[e].name
        };
      });
    },
    cities: function cities() {
      if (!this.park.state) {
        return [];
      }
      var cities = __WEBPACK_IMPORTED_MODULE_5__assets_json_brazil_cities_by_state_initials_json___default.a[this.park.state].cities;
      return cities.map(function (e) {
        return { value: e, text: e };
      });
    }
  },
  methods: {
    onLoad: function onLoad(dataUri) {
      this.park.logoPicture = dataUri;
    },
    onSizeExceeded: function onSizeExceeded(size) {
      alert('Image ' + size + 'Mb size exceeds limits of ' + this.customImageMaxSize + 'Mb!');
    },
    customSelectItemClass: function customSelectItemClass() {
      return 'search-select-item';
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ParkHome',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default.a }
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_DataTables__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_DataTables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_elements_DataTables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_backend_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_Notifier__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_Notifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_elements_Notifier__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Parks',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default.a, DataTables: __WEBPACK_IMPORTED_MODULE_1__components_elements_DataTables___default.a, Notifier: __WEBPACK_IMPORTED_MODULE_3__components_elements_Notifier___default.a },
  data: function data() {
    return {
      apiUrl: "https://api.inovadata-br.ufv.br/" + 'parks',
      columns: [{ label: 'Nome', field: 'name' }, { label: 'Email', field: 'email' }, { label: 'Estágio', field: 'currentStage' }, { label: 'Opções', field: null }],
      columnDefs: [{
        targets: -1,
        orderable: false,
        render: function render(data, type, full, meta) {
          return '\n            <button\n              class="btn btn-xs btn-primary edit-park"\n              data-park-id=' + data.id + '>\n                <i class="fa fa-pencil"></i>&nbsp Editar\n            </button>\n            <button\n              class="btn btn-xs btn-primary companies"\n              data-park-id=' + data.id + '>\n                <i class="fa fa-send"></i>&nbsp Empresas\n            </button>\n            <button\n              class="btn btn-xs btn-primary general-informations"\n              data-park-id=' + data.id + '>\n                <i class="fa fa-info"></i>&nbsp Informa\xE7\xF5es Gerais\n            </button>\n            <button\n              class="btn btn-xs btn-danger delete-park"\n              data-park-id=' + data.id + '\n              data-toggle="modal"\n              data-target="#delete-park-modal"\n              >\n                <i class="fa fa-trash"></i>&nbsp Excluir\n            </button>\n            <button\n              class="btn btn-xs btn-warning recover-password"\n              data-park-id=' + data.id + '\n              data-toggle="modal"\n              data-target="#recover-password-modal"\n              >\n                <i class="fa fa-unlock-alt"></i>&nbsp Recuperar Senha\n            </button>\n            ';
        }
      }],
      recoverPasswordParkId: '',
      deleteParkId: '',
      eventsBound: false
    };
  },
  mounted: function mounted() {
    this.bindEditParkButtonClick();
    this.bindCompaniesButtonClick();
    this.bindGeneralInformationsButtonClick();
    this.bindDeleteParkButtonClick();
    this.bindConfirmDeletePark();
    this.bindRecoverPasswordButtonClick();
    this.bindConfirmPasswordRecovery();
  },

  methods: {
    createPark: function createPark() {
      this.$router.push({ name: 'CreatePark' });
    },
    bindEditParkButtonClick: function bindEditParkButtonClick() {
      var that = this;
      $('body').off('click', '.edit-park').on('click', '.edit-park', function (e) {
        var parkId = $(this).data('park-id');
        that.editPark(parkId);
      });
    },
    editPark: function editPark(id) {
      this.$router.push({ name: 'EditPark', params: { id: id } });
    },
    bindCompaniesButtonClick: function bindCompaniesButtonClick() {
      var that = this;
      $('body').off('click', '.companies').on('click', '.companies', function (e) {
        var parkId = $(this).data('park-id');
        that.companies(parkId);
      });
    },
    companies: function companies(parkId) {
      this.$router.push({ name: 'CompaniesHome', params: { parkId: parkId } });
    },
    bindGeneralInformationsButtonClick: function bindGeneralInformationsButtonClick() {
      var that = this;
      $('body').off('click', '.general-informations').on('click', '.general-informations', function (e) {
        var parkId = $(this).data('park-id');
        that.generalInformations(parkId);
      });
    },
    generalInformations: function generalInformations(parkId) {
      this.$router.push({ name: 'GeneralInformations', params: { parkId: parkId } });
    },
    bindDeleteParkButtonClick: function bindDeleteParkButtonClick() {
      var that = this;
      $('body').off('click', '.delete-park').on('click', '.delete-park', function (e) {
        that.deleteParkId = $(this).data('park-id');
      });
    },
    bindConfirmDeletePark: function bindConfirmDeletePark() {
      var that = this;
      $('body').off('click', '#delete-park-modal-confirm').on('click', '#delete-park-modal-confirm', function (e) {
        that.deletePark();
      });
    },
    deletePark: function deletePark() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__services_backend_api__["a" /* BackendApi */].getClient().delete('parks/' + this.deleteParkId).then(function (response) {
        _this.reloadTable();
        _this.showParkDeleteSuccessNotification();
      }).catch(function (e) {
        _this.showParkDeleteErrorNotification();
      });
    },
    reloadTable: function reloadTable() {
      $('#parks-table').DataTable().ajax.reload();
    },
    showParkDeleteSuccessNotification: function showParkDeleteSuccessNotification() {
      this.$notify({ type: 'success', title: 'Sucesso', text: 'O parque foi excluído do sistema!' });
    },
    showParkDeleteErrorNotification: function showParkDeleteErrorNotification() {
      this.$notify({ type: 'error', title: 'Erro', text: 'Ocorreu um erro ao excluir o parque! Entre em contato com a equipe de desenvolvimento.' });
    },
    bindRecoverPasswordButtonClick: function bindRecoverPasswordButtonClick() {
      var that = this;
      $('body').off('click', '.recover-password').on('click', '.recover-password', function (e) {
        that.recoverPasswordParkId = $(this).data('park-id');
      });
    },
    bindConfirmPasswordRecovery: function bindConfirmPasswordRecovery() {
      var that = this;
      $('body').off('click', '#recover-password-modal-confirm').on('click', '#recover-password-modal-confirm', function (e) {
        that.recoverParkPassword();
      });
    },
    recoverParkPassword: function recoverParkPassword() {
      __WEBPACK_IMPORTED_MODULE_2__services_backend_api__["a" /* BackendApi */].getClient().put('users/park-password-recovery/' + this.recoverPasswordParkId).then(function (response) {}).catch(function (e) {
        throw e;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_resource_client_partner__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_partners_PartnerForm__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_partners_PartnerForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_partners_PartnerForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreatePartner',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default.a, PartnerForm: __WEBPACK_IMPORTED_MODULE_2__pages_partners_PartnerForm___default.a },
  data: function data() {
    return {
      partner: {},
      errors: {}
    };
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__services_resource_client_partner__["a" /* default */].post(this.partner).then(function (r) {
        _this.$router.push({ name: 'Partners' });
      }).catch(function (e) {
        _this.errors = e.response.data.errors;
      });
    }
  }
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_resource_client_partner__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_partners_PartnerForm__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_partners_PartnerForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_partners_PartnerForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_Notifier__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_Notifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_elements_Notifier__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditPartner',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default.a, PartnerForm: __WEBPACK_IMPORTED_MODULE_2__pages_partners_PartnerForm___default.a, Notifier: __WEBPACK_IMPORTED_MODULE_3__components_elements_Notifier___default.a },
  data: function data() {
    return {
      partner: {},
      errors: {}
    };
  },
  props: ['id'],
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__services_resource_client_partner__["a" /* default */].put(this.partner).then(function (r) {
        _this.$refs.notifier.showSavedFormNotification();
        _this.errors = {};
        _this.$router.push({ name: 'Partners' });
      }).catch(function (e) {
        _this.errors = e.response.data.errors;
        _this.$refs.notifier.showErrorNotification();
      });
    }
  },
  created: function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_1__services_resource_client_partner__["a" /* default */].get(this.id).then(function (r) {
      _this2.partner = r.data;
    });
  }
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_GoBackButton__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_GoBackButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_elements_GoBackButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_the_mask__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_the_mask__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PartnerForm',
  components: { TheMask: __WEBPACK_IMPORTED_MODULE_1_vue_the_mask___default.a, GoBackButton: __WEBPACK_IMPORTED_MODULE_0__components_elements_GoBackButton___default.a },
  props: ['partner', 'errors', 'onSubmit']
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_resource_client_partner__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_Notifier__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_Notifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_elements_Notifier__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Partners',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_2__components_template_Adminlte___default.a, Notifier: __WEBPACK_IMPORTED_MODULE_4__components_elements_Notifier___default.a },
  data: function data() {
    return {
      partnersCollection: [],
      deletePartnerId: null,
      recoverPasswordPartnerId: null
    };
  },
  created: function created() {
    this.fetchPartners().then(this.reloadTable);
  },
  mounted: function mounted() {
    this.bindConfirmDeletePartner();
    this.bindConfirmPasswordRecovery();
  },

  methods: {
    fetchPartners: function fetchPartners() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3__services_resource_client_partner__["a" /* default */].cget().then(function (r) {
        _this.partnersCollection = [];

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(r.data)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var object = _step.value;

            if (!object.hasOwnProperty('id')) {
              return;
            }
            _this.partnersCollection.push(object);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    },
    reloadTable: function reloadTable() {
      $('#partners-table').DataTable();
    },
    createPartner: function createPartner() {
      this.$router.push({ name: 'CreatePartner' });
    },
    editPartner: function editPartner(id) {
      this.$router.push({ name: 'EditPartner', params: { id: id } });
    },
    onDeletePartnerButtonClick: function onDeletePartnerButtonClick(id) {
      this.deletePartnerId = id;
    },
    bindConfirmDeletePartner: function bindConfirmDeletePartner() {
      var that = this;
      $('body').off('click', '#delete-partner-modal-confirm').on('click', '#delete-partner-modal-confirm', function (e) {
        that.deletePartner();
      });
    },
    deletePartner: function deletePartner() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__services_resource_client_partner__["a" /* default */].delete(this.deletePartnerId).then(function (r) {
        _this2.fetchPartners().then(_this2.reloadTable);
        _this2.showPartnerDeleteSuccessNotification();
      }).catch(function (e) {
        _this2.showPartnerDeleteErrorNotification();
      });
    },
    showPartnerDeleteSuccessNotification: function showPartnerDeleteSuccessNotification() {
      this.$notify({ type: 'success', title: 'Sucesso', text: 'O parceiro foi excluído do sistema!' });
    },
    showPartnerDeleteErrorNotification: function showPartnerDeleteErrorNotification() {
      this.$notify({ type: 'error', title: 'Erro', text: 'Ocorreu um erro ao excluir o parceiro! Entre em contato com a equipe de desenvolvimento.' });
    },
    onRecoverPasswordPartnerButtonClick: function onRecoverPasswordPartnerButtonClick(id) {
      this.recoverPasswordPartnerId = id;
    },
    bindConfirmPasswordRecovery: function bindConfirmPasswordRecovery() {
      var self = this;
      $('body').off('click', '#recover-password-modal-confirm').on('click', '#recover-password-modal-confirm', function (e) {
        self.recoverPartnerPassword();
      });
    },
    recoverPartnerPassword: function recoverPartnerPassword() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3__services_resource_client_partner__["a" /* default */].recoverPassword(this.recoverPasswordPartnerId).then(function (r) {
        _this3.showPartnerRecoverPasswordSuccessNotification();
      }).catch(function (e) {
        _this3.showPartnerRecoverPasswordErrorNotification();
      });
    },
    showPartnerRecoverPasswordSuccessNotification: function showPartnerRecoverPasswordSuccessNotification() {
      this.$notify({ type: 'success', title: 'Sucesso', text: 'Instruções de redefinição de senha foram enviadas por e-mail para o parceiro!' });
    },
    showPartnerRecoverPasswordErrorNotification: function showPartnerRecoverPasswordErrorNotification() {
      this.$notify({ type: 'error', title: 'Erro', text: 'Ocorreu um erro ao tentar recuperar a senha do parceiro! Entre em contato com a equipe de desenvolvimento.' });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_portal_CmsTemplate__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_portal_CmsTemplate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_portal_CmsTemplate__);
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AboutPage',
  components: { CmsTemplate: __WEBPACK_IMPORTED_MODULE_0__pages_portal_CmsTemplate___default.a }
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_portal_Homepage__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_portal_Homepage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_portal_Homepage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_resource_client_cms__ = __webpack_require__(153);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CmsTemplate',
  components: { Homepage: __WEBPACK_IMPORTED_MODULE_0__pages_portal_Homepage___default.a },
  props: ['pageName', 'pageTitle'],
  data: function data() {
    return {
      content: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__services_resource_client_cms__["a" /* default */].get(this.pageName).then(function (r) {
      _this.content = r.data;
    }).catch(function (e) {
      if (e.response.status !== 404) {
        throw e;
      }
    });
  }
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_portal_CmsTemplate__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_portal_CmsTemplate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_portal_CmsTemplate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_DataTables__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_DataTables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_elements_DataTables__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CompaniesPage',
  components: { CmsTemplate: __WEBPACK_IMPORTED_MODULE_0__pages_portal_CmsTemplate___default.a, DataTables: __WEBPACK_IMPORTED_MODULE_1__components_elements_DataTables___default.a },
  data: function data() {
    return {
      columns: [{ label: '', field: 'logoPicture' }, { label: 'Nome', field: 'name' }, { label: 'Email', field: 'email' }, { label: 'Cidade', field: 'city' }, { label: 'Estado', field: 'state' }, { label: 'Parque Tecnológico', field: '_links.ea:park.initials' }],
      columnDefs: [{
        targets: 0,
        orderable: false,
        render: function render(data, type, full, meta) {
          return '\n              <img class="img-responsive center-block" style="max-height: 30px;" src=' + data + '>\n            ';
        }
      }],
      focus: ''
    };
  },

  methods: {
    getApiUrl: function getApiUrl() {
      return "https://api.inovadata-br.ufv.br/" + 'companies/';
    },
    applyFilters: function applyFilters() {
      $('#parks-table').DataTable().ajax.url(this.getApiUrl() + '?focus=' + encodeURIComponent(this.focus)).load();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_resource_client_contact__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_portal_Homepage__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_portal_Homepage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_portal_Homepage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_recaptcha__ = __webpack_require__(785);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var FORM_STATUS_SUBMITTING = 'submitting';
var FORM_STATUS_SUBMIT_SUCCESS = 'submit_success';
var FORM_STATUS_SUBMIT_ERROR = 'submit_error';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ContactPage',
  components: { Homepage: __WEBPACK_IMPORTED_MODULE_2__pages_portal_Homepage___default.a, VueRecaptcha: __WEBPACK_IMPORTED_MODULE_3_vue_recaptcha__["a" /* default */] },
  data: function data() {
    return {
      recaptcha_site_key: "6LchiKAUAAAAABg7whMgTXtYvfhcBxff--4Yq0PI",

      formData: {
        name: {
          value: '',
          error: ''
        },
        email: {
          value: '',
          error: ''
        },
        subject: {
          value: '',
          error: ''
        },
        message: {
          value: '',
          error: ''
        }
      },

      formStatus: '',
      FORM_STATUS_SUBMITTING: FORM_STATUS_SUBMITTING,
      FORM_STATUS_SUBMIT_SUCCESS: FORM_STATUS_SUBMIT_SUCCESS,
      FORM_STATUS_SUBMIT_ERROR: FORM_STATUS_SUBMIT_ERROR
    };
  },

  methods: {
    onCaptchaVerified: function onCaptchaVerified(recaptchaToken) {
      var _this = this;

      if (!this.validateForm() || this.formStatus === FORM_STATUS_SUBMITTING) {
        return;
      }
      this.formStatus = FORM_STATUS_SUBMITTING;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_1__services_resource_client_contact__["a" /* default */].post(this.formData.name.value, this.formData.email.value, this.formData.subject.value, this.formData.message.value, recaptchaToken).then(function () {
        self.clearFormValuesAndErrors();
        _this.formSubmissionSuccess = true;
        _this.formStatus = FORM_STATUS_SUBMIT_SUCCESS;
      }).catch(function () {
        _this.formSubmissionError = true;
        _this.formStatus = FORM_STATUS_SUBMIT_ERROR;
      });
    },
    onCaptchaExpired: function onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
    validateRequiredField: function validateRequiredField(fieldName) {
      this.formData[fieldName].error = '';

      if (!this.formData[fieldName].value) {
        this.formData[fieldName].error = 'requiredField';
        return false;
      }
      return true;
    },
    validateEmailField: function validateEmailField(fieldName) {
      this.formData[fieldName].error = '';

      var emailValue = this.formData[fieldName].value;
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(String(emailValue).toLowerCase())) {
        this.formData[fieldName].error = 'invalidEmailAddress';
        return false;
      }
      return true;
    },
    validateForm: function validateForm() {
      var _this2 = this;

      var isValid = true;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.formData).forEach(function (fieldKey) {
        if (!_this2.validateRequiredField(fieldKey)) {
          isValid = false;
        }
      });

      if (!this.validateEmailField('email')) {
        isValid = false;
      }

      return isValid;
    },
    clearFormValuesAndErrors: function clearFormValuesAndErrors() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.formData).forEach(function (key) {
        _this3.formData[key].value = '';
        _this3.formData[key].error = '';
      });
    }
  }
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Header',
  methods: {
    login: function login() {
      this.$router.push({ name: 'Login' });
    },
    setLocale: function setLocale(language) {
      this.$i18n.locale = language;
    }
  }
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header_vue__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Footer_vue__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__News_vue__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__News_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__News_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Map_vue__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Map_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Map_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_resource_client_indicators__ = __webpack_require__(154);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Homepage',
  components: {
    News: __WEBPACK_IMPORTED_MODULE_2__News_vue___default.a,
    PortalMap: __WEBPACK_IMPORTED_MODULE_3__Map_vue___default.a,
    PortalHeader: __WEBPACK_IMPORTED_MODULE_0__Header_vue___default.a,
    PortalFooter: __WEBPACK_IMPORTED_MODULE_1__Footer_vue___default.a
  },
  data: function data() {
    return {
      indicators: {
        parksInOperationStage: 0,
        parksInImplantationStage: 0,
        parksInPlanningStage: 0,
        companies: 0,
        revenuesEstimate: 0,
        taxesEstimate: 0,
        jobsEstimate: 0
      }
    };
  },
  mounted: function mounted() {
    this.fetchIndicators();
  },

  methods: {
    fetchIndicators: function fetchIndicators() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4__services_resource_client_indicators__["a" /* default */].get().then(function (r) {
        _this.indicators = r.data;
      });
    }
  }
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_leaflet__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_leaflet_dist_leaflet_css__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_leaflet_dist_leaflet_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_leaflet_dist_leaflet_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_backend_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_resource_client_indicators__ = __webpack_require__(154);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var BRAZIL_CENTER = [-14.24, -51.93];
var BRAZIL_ZOOM = 4;
var BRAZIL_ZOOM_MOBILE = 3;
var BRAZIL_CENTER_MOBILE = [-18.5, -52];
var COLOR_EMPTY = '#e8eef2';
var STATE_FILL_OPACITY = 0.75;
var BASE_TILE_LAYER = {
  url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
  attribution: '&copy; OpenStreetMap &copy; CARTO',
  subdomains: 'abcd'
};
var CHOROPLETH_PALETTES = {
  parks: { min: '#b8d4e8', max: '#2C698C' },
  companies: { min: '#c5e3f3', max: '#73B0D3' },
  both: { min: '#c8dbe8', max: '#1f5f82' }
};
var MARKER_COLORS = {
  parks: '#2C698C',
  companies: '#73B0D3'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Map',
  data: function data() {
    return {
      map: null,
      statesLayer: null,
      parksLayer: null,
      companiesLayer: null,
      parksCountByState: {},
      companiesCountByState: {},
      currentYear: new Date().getFullYear(),
      showParksMarkers: true,
      showCompaniesMarkers: false,
      mapCanvasStyle: 'width: 500px; height: 500px',
      isMobile: false,
      parksMarkersLoaded: false,
      companiesMarkersLoaded: false
    };
  },

  computed: {
    hasActiveLayer: function hasActiveLayer() {
      return this.showParksMarkers || this.showCompaniesMarkers;
    },
    choroplethMode: function choroplethMode() {
      if (this.showParksMarkers && this.showCompaniesMarkers) {
        return 'both';
      }
      if (this.showCompaniesMarkers) {
        return 'companies';
      }
      if (this.showParksMarkers) {
        return 'parks';
      }
      return 'none';
    },
    activeCountsByState: function activeCountsByState() {
      var _this = this;

      if (this.choroplethMode === 'none') {
        return {};
      }

      if (this.choroplethMode === 'parks') {
        return this.parksCountByState;
      }

      if (this.choroplethMode === 'companies') {
        return this.companiesCountByState;
      }

      var combined = {};
      var states = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a([].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.parksCountByState)), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.companiesCountByState))));

      states.forEach(function (uf) {
        combined[uf] = (_this.parksCountByState[uf] || 0) + (_this.companiesCountByState[uf] || 0);
      });

      return combined;
    },
    maxStateCount: function maxStateCount() {
      var values = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.activeCountsByState);
      return values.length ? Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(values)) : 0;
    },
    legendTitle: function legendTitle() {
      if (this.choroplethMode === 'parks') {
        return this.$t('content.mapLegendParks');
      }
      if (this.choroplethMode === 'companies') {
        return this.$t('content.mapLegendCompanies');
      }
      return this.$t('content.mapLegendBoth');
    },
    legendGradientStyle: function legendGradientStyle() {
      var palette = CHOROPLETH_PALETTES[this.choroplethMode] || CHOROPLETH_PALETTES.parks;
      return {
        background: 'linear-gradient(to right, ' + COLOR_EMPTY + ', ' + palette.min + ', ' + palette.max + ')'
      };
    },
    currentPalette: function currentPalette() {
      return CHOROPLETH_PALETTES[this.choroplethMode] || CHOROPLETH_PALETTES.parks;
    }
  },
  mounted: function mounted() {
    this.isMobile = document.documentElement.clientWidth <= 550;
    if (this.isMobile) {
      this.mapCanvasStyle = 'width: 300px; height: 255px';
    }
    this.initMap();
    this.loadStatesLayer();
    this.loadIndicators();
    this.syncMarkerLayers();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  },

  methods: {
    initMap: function initMap() {
      var center = this.isMobile ? BRAZIL_CENTER_MOBILE : BRAZIL_CENTER;
      var zoom = this.isMobile ? BRAZIL_ZOOM_MOBILE : BRAZIL_ZOOM;

      this.map = __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.map(this.$refs.mapContainer, {
        center: center,
        zoom: zoom,
        scrollWheelZoom: false,
        dragging: false,
        doubleClickZoom: false,
        touchZoom: false,
        boxZoom: false,
        keyboard: false,
        zoomControl: false,
        attributionControl: true
      });

      __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.tileLayer(BASE_TILE_LAYER.url, {
        attribution: BASE_TILE_LAYER.attribution,
        subdomains: BASE_TILE_LAYER.subdomains,
        maxZoom: 19
      }).addTo(this.map);

      this.parksLayer = __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.layerGroup().addTo(this.map);
      this.companiesLayer = __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.layerGroup();
    },
    loadStatesLayer: function loadStatesLayer() {
      var _this2 = this;

      fetch('/static/geojson/brazil-states.json').then(function (response) {
        return response.json();
      }).then(function (geojson) {
        if (_this2.statesLayer) {
          _this2.map.removeLayer(_this2.statesLayer);
        }

        _this2.statesLayer = __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.geoJSON(geojson, {
          style: function style(feature) {
            return _this2.getStateStyle(feature);
          },
          onEachFeature: function onEachFeature(feature, layer) {
            layer.bindTooltip(_this2.getStateTooltip(feature.properties.UF), { sticky: true });
            layer.on({
              mouseover: function mouseover(event) {
                event.target.setStyle({
                  weight: 2,
                  color: '#1a5276',
                  fillOpacity: Math.min(STATE_FILL_OPACITY + 0.1, 1)
                });
              },
              mouseout: function mouseout(event) {
                _this2.statesLayer.resetStyle(event.target);
              }
            });
          }
        }).addTo(_this2.map);

        _this2.fitBrazilBounds();
      });
    },
    loadIndicators: function loadIndicators() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_7__services_resource_client_indicators__["a" /* default */].get().then(function (response) {
        _this3.parksCountByState = response.data.parksCountByState || {};
        _this3.companiesCountByState = response.data.companiesCountByState || {};
        _this3.refreshStatesLayer();
      });
    },
    refreshStatesLayer: function refreshStatesLayer() {
      var _this4 = this;

      if (!this.statesLayer) {
        return;
      }

      this.statesLayer.setStyle(function (feature) {
        return _this4.getStateStyle(feature);
      });
      this.statesLayer.eachLayer(function (layer) {
        var uf = layer.feature.properties.UF;
        layer.setTooltipContent(_this4.getStateTooltip(uf));
      });
    },
    getStateTooltip: function getStateTooltip(uf) {
      var parksCount = this.parksCountByState[uf] || 0;
      var companiesCount = this.companiesCountByState[uf] || 0;

      if (this.showParksMarkers && this.showCompaniesMarkers) {
        return uf + ': ' + parksCount + ' ' + this.$t('content.mapTooltipParks') + ', ' + companiesCount + ' ' + this.$t('content.mapTooltipCompanies');
      }
      if (this.showCompaniesMarkers) {
        return uf + ': ' + companiesCount + ' ' + this.$t('content.mapTooltipCompanies');
      }
      if (this.showParksMarkers) {
        return uf + ': ' + parksCount + ' ' + this.$t('content.mapTooltipParks');
      }
      return uf;
    },
    getStateStyle: function getStateStyle(feature) {
      var uf = feature.properties.UF;
      var count = this.activeCountsByState[uf] || 0;

      return {
        fillColor: this.getStateColor(count),
        weight: 1,
        opacity: 1,
        color: '#ffffff',
        fillOpacity: this.hasActiveLayer ? STATE_FILL_OPACITY : 0.35
      };
    },
    getStateColor: function getStateColor(count) {
      if (!this.hasActiveLayer || !count || !this.maxStateCount) {
        return COLOR_EMPTY;
      }

      var ratio = count / this.maxStateCount;
      var palette = this.currentPalette;
      return this.interpolateColor(palette.min, palette.max, ratio);
    },
    interpolateColor: function interpolateColor(fromHex, toHex, ratio) {
      var from = this.hexToRgb(fromHex);
      var to = this.hexToRgb(toHex);
      var r = Math.round(from.r + (to.r - from.r) * ratio);
      var g = Math.round(from.g + (to.g - from.g) * ratio);
      var b = Math.round(from.b + (to.b - from.b) * ratio);

      return 'rgb(' + r + ', ' + g + ', ' + b + ')';
    },
    hexToRgb: function hexToRgb(hex) {
      var normalized = hex.replace('#', '');
      return {
        r: parseInt(normalized.substring(0, 2), 16),
        g: parseInt(normalized.substring(2, 4), 16),
        b: parseInt(normalized.substring(4, 6), 16)
      };
    },
    fitBrazilBounds: function fitBrazilBounds() {
      if (!this.statesLayer || !this.map) {
        return;
      }

      this.map.fitBounds(this.statesLayer.getBounds(), { padding: [8, 8] });
    },
    onLayerSelectionChange: function onLayerSelectionChange() {
      this.refreshStatesLayer();
      this.syncMarkerLayers();
    },
    syncMarkerLayers: function syncMarkerLayers() {
      if (this.showParksMarkers) {
        if (!this.map.hasLayer(this.parksLayer)) {
          this.parksLayer.addTo(this.map);
        }
        if (!this.parksMarkersLoaded) {
          this.loadParksMarkers();
        }
      } else if (this.map.hasLayer(this.parksLayer)) {
        this.map.removeLayer(this.parksLayer);
      }

      if (this.showCompaniesMarkers) {
        if (!this.map.hasLayer(this.companiesLayer)) {
          this.companiesLayer.addTo(this.map);
        }
        if (!this.companiesMarkersLoaded) {
          this.loadCompaniesMarkers();
        }
      } else if (this.map.hasLayer(this.companiesLayer)) {
        this.map.removeLayer(this.companiesLayer);
      }
    },
    loadParksMarkers: function loadParksMarkers() {
      var _this5 = this;

      if (this.parksMarkersLoaded) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_6__services_backend_api__["a" /* BackendApi */].get(__WEBPACK_IMPORTED_MODULE_6__services_backend_api__["a" /* BackendApi */].getAnonymousClient(), '/lat-lngs/parks').then(function (response) {
        _this5.parksLayer.clearLayers();
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(response.data).forEach(function (key) {
          if (key === '_links') {
            return;
          }
          var point = response.data[key];
          if (!point.lat || !point.lng) {
            return;
          }
          __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.circleMarker([point.lat, point.lng], {
            radius: 5,
            color: MARKER_COLORS.parks,
            fillColor: MARKER_COLORS.parks,
            fillOpacity: 1,
            weight: 1
          }).addTo(_this5.parksLayer);
        });
        _this5.parksMarkersLoaded = true;
      });
    },
    loadCompaniesMarkers: function loadCompaniesMarkers() {
      var _this6 = this;

      if (this.companiesMarkersLoaded) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_6__services_backend_api__["a" /* BackendApi */].get(__WEBPACK_IMPORTED_MODULE_6__services_backend_api__["a" /* BackendApi */].getAnonymousClient(), '/lat-lngs/companies').then(function (response) {
        _this6.companiesLayer.clearLayers();
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(response.data).forEach(function (key) {
          if (key === '_links') {
            return;
          }
          var point = response.data[key];
          if (!point.lat || !point.lng) {
            return;
          }
          __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.circleMarker([point.lat, point.lng], {
            radius: 4,
            color: MARKER_COLORS.companies,
            fillColor: MARKER_COLORS.companies,
            fillOpacity: 1,
            weight: 1
          }).addTo(_this6.companiesLayer);
        });
        _this6.companiesMarkersLoaded = true;
      });
    }
  }
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_backend_api__ = __webpack_require__(3);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'News',
  data: function data() {
    return {
      newsCollection: []
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getAnonymousClient().get('news/?limit=0&orderBy=dateTime&orderDirection=desc').then(function (r) {
      _this.newsCollection = r.data;
    });
  }
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_portal_CmsTemplate__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_portal_CmsTemplate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_portal_CmsTemplate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_backend_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ParksPage',
  components: { CmsTemplate: __WEBPACK_IMPORTED_MODULE_0__pages_portal_CmsTemplate___default.a, InfiniteLoading: __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default.a },
  data: function data() {
    return {
      parks: [],
      search: '',
      state: '',
      stage: '',
      focus: '',
      nextUri: '/parks/that-answered-general-information-quiz'
    };
  },

  methods: {
    applyFilters: function applyFilters() {
      var _this = this;

      this.parks = [];
      this.nextUri = '/parks/that-answered-general-information-quiz';
      this.$nextTick(function () {
        _this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
      });
    },
    getParkDataForTooltip: function getParkDataForTooltip(park) {
      var website = park.website;
      if (!/^(f|ht)tps?:\/\//i.test(website)) {
        website = 'http://' + website;
      }

      return '<p><strong>' + this.$i18n.t('commons.name') + ':</strong> ' + park.name + '</p>' + '<p><strong>' + this.$i18n.t('commons.initials') + ':</strong> ' + park.initials + '</p>' + '<p><strong>' + this.$i18n.t('commons.email') + ':</strong> ' + park.email + '</p>' + '<p><strong>' + this.$i18n.t('commons.city') + ':</strong> ' + park.city + '</p>' + '<p><strong>' + this.$i18n.t('commons.state') + ':</strong> ' + park.state + '</p>' + '<p><strong>' + this.$i18n.t('commons.phoneNumber') + ':</strong> ' + park.phoneNumber + '</p>' + '<p><strong>' + this.$i18n.t('commons.website') + ':</strong><a href="' + website + '" target="_blank"> ' + website + '</a></p>' + '<p><strong>' + this.$i18n.t('commons.legalResponsible') + ':</strong> ' + park.legalResponsible + '</p>';
    },
    infiniteHandler: function infiniteHandler($state) {
      var _this2 = this;

      var uri = this.createUri();
      this.getParks(uri).then(function (r) {
        var payload = r.data;
        _this2.updateNextUri(payload);
        _this2.updateParksObject(payload);
        _this2.updatePopovers();

        $state.loaded();
        if (!_this2.nextUri) {
          $state.complete();
        }
      });
    },
    createUri: function createUri() {
      var uri = this.nextUri;
      if (uri.indexOf('?') < 0) {
        uri += '?';
      }
      if (this.stage) {
        uri += '&stage=' + this.stage;
      }
      if (this.state) {
        uri += '&state=' + this.state;
      }
      if (this.focus) {
        uri += '&focus=' + this.focus;
      }
      return uri;
    },
    getParks: function getParks(uri) {
      return __WEBPACK_IMPORTED_MODULE_1__services_backend_api__["a" /* BackendApi */].get(__WEBPACK_IMPORTED_MODULE_1__services_backend_api__["a" /* BackendApi */].getAnonymousClient(), uri);
    },
    updateNextUri: function updateNextUri(payload) {
      var nextUri = null;
      for (var obj in payload) {
        if (this.isPaginationObject(payload[obj]) && this.hasNextUri(payload[obj]._links)) {
          nextUri = payload[obj]._links.next.href;
        }
      }
      this.nextUri = nextUri;
    },
    updateParksObject: function updateParksObject(payload) {
      for (var obj in payload) {
        if (!this.isPaginationObject(payload[obj]) && obj !== 'total') {
          this.parks.push(payload[obj]);
        }
      }
    },
    updatePopovers: function updatePopovers() {
      setTimeout(function () {
        $('[data-toggle="popover"]').popover();
      }, 100);
    },
    isPaginationObject: function isPaginationObject(payload) {
      return payload._links && payload._links.first;
    },
    hasNextUri: function hasNextUri(links) {
      return links.next;
    }
  },
  computed: {
    filteredParks: function filteredParks() {
      var _this3 = this;

      return this.parks.filter(function (p) {
        return p.name.toLowerCase().includes(_this3.search.toLowerCase()) || p.initials.toLowerCase().includes(_this3.search.toLowerCase()) || p.email.toLowerCase().includes(_this3.search.toLowerCase()) || p.city.toLowerCase().includes(_this3.search.toLowerCase()) || p.state.toLowerCase().includes(_this3.search.toLowerCase()) || p.phoneNumber.toLowerCase().includes(_this3.search.toLowerCase()) || p.website.toLowerCase().includes(_this3.search.toLowerCase()) || p.legalResponsible.toLowerCase().includes(_this3.search.toLowerCase());
      });
    }
  },
  watch: {
    search: function search() {
      this.updatePopovers();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_portal_Homepage__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_portal_Homepage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_portal_Homepage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_resource_client_news__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_date_formatter__ = __webpack_require__(49);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReadNews',
  components: { Homepage: __WEBPACK_IMPORTED_MODULE_0__pages_portal_Homepage___default.a },
  props: ['id'],
  data: function data() {
    return {
      news: {}
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__services_resource_client_news__["a" /* default */].get(this.id).then(function (r) {
      _this.news = r.data;
    });
  },

  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_2__services_date_formatter__["a" /* default */].formatIsoDate(date);
    }
  }
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_GoBackButton__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_GoBackButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_elements_GoBackButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_resource_client_quiz_period__ = __webpack_require__(156);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'QuizPeriod',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_1__components_template_Adminlte___default.a, DatePicker: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__["a" /* default */], GoBackButton: __WEBPACK_IMPORTED_MODULE_4__components_elements_GoBackButton___default.a },
  data: function data() {
    return {
      datepickerLanguage: __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale__["ptBR"],
      quizPeriod: {
        id: null,
        startingDate: null,
        endingDate: null,
        approvalLimitDate: null
      },
      disabledStartingDates: {
        from: new Date(new Date().getFullYear(), 11, 31),
        to: new Date(new Date().getFullYear(), 0, 1)
      },
      disabledEndingDates: {
        from: new Date(new Date().getFullYear(), 11, 31),
        to: new Date(new Date().getFullYear(), 0, 1)
      },
      disabledApprovalLimitDates: {
        from: new Date(new Date().getFullYear(), 11, 31),
        to: new Date(new Date().getFullYear(), 0, 1)
      },
      errors: []
    };
  },
  mounted: function mounted() {
    this.getCurrentYearQuizPeriod();
  },

  methods: {
    onSubmit: function onSubmit() {
      this.validateForm();
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.errors).length > 0) {
        return;
      }
      if (this.quizPeriod.id !== null) {
        this.updateQuizPeriod();
        return;
      }
      this.createQuizPeriod();
    },
    getCurrentYearQuizPeriod: function getCurrentYearQuizPeriod() {
      var _this = this;

      var currentYear = new Date().getFullYear();
      __WEBPACK_IMPORTED_MODULE_5__services_resource_client_quiz_period__["a" /* default */].getByYear(currentYear).then(function (r) {
        if (r.data.total === 1) {
          _this.quizPeriod.id = r.data[0].id;
          _this.quizPeriod.startingDate = new Date(r.data[0].startingDate.replaceAll('-', '/'));
          _this.quizPeriod.endingDate = new Date(r.data[0].endingDate.replaceAll('-', '/'));
          _this.quizPeriod.approvalLimitDate = new Date(r.data[0].approvalLimitDate.replaceAll('-', '/'));

          _this.disabledEndingDates.to = _this.quizPeriod.endingDate;
          _this.disabledApprovalLimitDates.to = _this.quizPeriod.endingDate;
        }
      });
    },
    createQuizPeriod: function createQuizPeriod() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_5__services_resource_client_quiz_period__["a" /* default */].post(this.quizPeriod).then(function (r) {
        _this2.$notify({ type: 'success', title: 'Sucesso', text: 'Período definido com sucesso.' });
        _this2.quizPeriod.id = r.data.id;
      }).catch(function (e) {
        _this2.showFormErrorsNotification();
        _this2.errors = e.response.data.errors;
      });
    },
    updateQuizPeriod: function updateQuizPeriod() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_5__services_resource_client_quiz_period__["a" /* default */].put(this.quizPeriod).then(function (r) {
        _this3.$notify({ type: 'success', title: 'Sucesso', text: 'Período redefinido com sucesso.' });
      }).catch(function (e) {
        _this3.showFormErrorsNotification();
        _this3.errors = e.response.data.errors;
      });
    },
    validateForm: function validateForm() {
      this.errors = [];
      if (this.quizPeriod.startingDate >= this.quizPeriod.endingDate) {
        this.errors['startingDate'] = 'A data de abertura não pode ser maior que a data de fechamento';
        this.errors['endingDate'] = 'A data de fechamento não pode ser menor que a data de abertura';
      }

      if (this.quizPeriod.approvalLimitDate <= this.quizPeriod.endingDate) {
        this.errors['approvalLimitDate'] = 'A data limite para aprovação deve ser maior que a data de fechamento';
      }

      if (this.quizPeriod.startingDate === null) {
        this.errors['startingDate'] = 'Selecione a data de abertura';
      }
      if (this.quizPeriod.endingDate === null) {
        this.errors['endingDate'] = 'Selecione a data de fechamento';
      }
      if (this.quizPeriod.approvalLimitDate === null) {
        this.errors['approvalLimitDate'] = 'Selecione a data limite para aprovação';
      }

      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.errors).length > 0) {
        this.showFormErrorsNotification();
      }
    },
    showFormErrorsNotification: function showFormErrorsNotification() {
      this.$notify({
        type: 'error',
        title: 'Ocorreu um erro',
        text: 'Verifique se as informações foram preenchidas corretamente e tente novamente.'
      });
    }
  }
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_GoBackButton__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_GoBackButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_elements_GoBackButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_resource_client_quiz_template__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_resource_client_general_information__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__questions_DateQuestion__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__questions_DateQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__questions_DateQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__questions_DateLteTodayQuestion__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__questions_DateLteTodayQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__questions_DateLteTodayQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__questions_MultipleChoiceQuestion__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__questions_MultipleChoiceQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__questions_MultipleChoiceQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__questions_CollectionQuestion__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__questions_CollectionQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__questions_CollectionQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__questions_BooleanFormQuestion__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__questions_BooleanFormQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__questions_BooleanFormQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__questions_BooleanCollectionQuestion__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__questions_BooleanCollectionQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__questions_BooleanCollectionQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__questions_FormQuestion__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__questions_FormQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__questions_FormQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__questions_ItemsQuestion__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__questions_ItemsQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__questions_ItemsQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_elements_Notifier__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_elements_Notifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_elements_Notifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_resource_client_park__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_quizValidationErrors__ = __webpack_require__(157);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GeneralInformations',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_1__components_template_Adminlte___default.a, GoBackButton: __WEBPACK_IMPORTED_MODULE_2__components_elements_GoBackButton___default.a, DateQuestion: __WEBPACK_IMPORTED_MODULE_5__questions_DateQuestion___default.a, Notifier: __WEBPACK_IMPORTED_MODULE_13__components_elements_Notifier___default.a, ParkClient: __WEBPACK_IMPORTED_MODULE_14__services_resource_client_park__["a" /* default */] },
  data: function data() {
    return {
      quizTemplate: null,
      quiz: null,
      componentsPerType: {
        'date': __WEBPACK_IMPORTED_MODULE_5__questions_DateQuestion___default.a,
        'multiple-choice': __WEBPACK_IMPORTED_MODULE_7__questions_MultipleChoiceQuestion___default.a,
        'collection': __WEBPACK_IMPORTED_MODULE_8__questions_CollectionQuestion___default.a,
        'boolean-form': __WEBPACK_IMPORTED_MODULE_9__questions_BooleanFormQuestion___default.a,
        'boolean-collection': __WEBPACK_IMPORTED_MODULE_10__questions_BooleanCollectionQuestion___default.a,
        'form': __WEBPACK_IMPORTED_MODULE_11__questions_FormQuestion___default.a,
        'items': __WEBPACK_IMPORTED_MODULE_12__questions_ItemsQuestion___default.a
      },
      customComponentsPerQuestionUuid: {
        'ce9c4656-e0d7-31f0-a1f0-06870af0f413': __WEBPACK_IMPORTED_MODULE_6__questions_DateLteTodayQuestion___default.a,
        '40a146f5-c57a-306f-9187-fa743d0749a3': __WEBPACK_IMPORTED_MODULE_6__questions_DateLteTodayQuestion___default.a,
        '21b007d0-3357-3ae5-8d07-cf6c8582262c': __WEBPACK_IMPORTED_MODULE_6__questions_DateLteTodayQuestion___default.a,
        '0428805b-b645-3ec4-9cfe-d7b7d0247c96': __WEBPACK_IMPORTED_MODULE_6__questions_DateLteTodayQuestion___default.a
      },
      park: {}
    };
  },

  props: ['parkId'],
  created: function created() {
    this.getQuizTemplate();
    this.getQuiz();
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_14__services_resource_client_park__["a" /* default */].get(this.parkId).then(function (r) {
      _this.park = r.data;
    });
  },

  methods: {
    onAnswerUpdated: function onAnswerUpdated(answer) {
      var questionFound = false;
      this.quiz.answers.forEach(function (a) {
        if (a.questionUuid === answer.questionUuid) {
          a.value = answer.value;
          questionFound = true;
          return;
        }
      });
      if (!questionFound) {
        throw new Error('AnswerNotFoundException');
      }
    },
    getQuestionComponent: function getQuestionComponent(q) {
      if (this.customComponentsPerQuestionUuid.hasOwnProperty(q.uuid)) {
        return this.customComponentsPerQuestionUuid[q.uuid];
      }
      return this.componentsPerType[q.type];
    },
    getQuestionAnswer: function getQuestionAnswer(q) {
      if (!q.isVisible || this.quiz === null) {
        return;
      }
      for (var answerIndex in this.quiz.answers) {
        var answer = this.quiz.answers[answerIndex];
        if (answer.questionUuid === q.uuid) {
          return answer;
        }
      }
      return this.addDefaultAnswerForQuestion(q);
    },
    addDefaultAnswerForQuestion: function addDefaultAnswerForQuestion(question) {
      var defaultAnswer = {
        'questionUuid': question.uuid,
        'value': null
      };

      var answersLength = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.quiz.answers).length;
      this.quiz.answers[answersLength] = defaultAnswer;

      return defaultAnswer;
    },
    getQuizTemplate: function getQuizTemplate() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__services_resource_client_quiz_template__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_4__services_resource_client_general_information__["a" /* GENERAL_INFORMATIONS_QUIZ_TEMPLATE_UUID */], this.parkId).then(function (r) {
        _this2.quizTemplate = _this2.sortQuizQuestionsByRenderingOrder(r.data);
      });
    },
    sortQuizQuestionsByRenderingOrder: function sortQuizQuestionsByRenderingOrder(quiz) {
      quiz.questions.sort(function (a, b) {
        return a.renderingOrder - b.renderingOrder;
      });
      return quiz;
    },
    getQuiz: function getQuiz() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4__services_resource_client_general_information__["b" /* default */].get(this.parkId).then(function (r) {
        if (!_this3.quizExists(r.data)) {
          return _this3.createQuiz(_this3.parkId);
        }
        _this3.quiz = r.data[0];
      });
    },
    quizExists: function quizExists(quiz) {
      return quiz.total !== 0;
    },
    createQuiz: function createQuiz(parkId) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_4__services_resource_client_general_information__["b" /* default */].post(parkId).then(function (r) {
        _this4.quiz = r.data;
      });
    },
    onSubmit: function onSubmit() {
      var _this5 = this;

      var isAnswersValid = true;
      this.$refs.questions.forEach(function (child) {
        if (!child.isValid()) {
          isAnswersValid = false;
        }
      });
      if (!isAnswersValid) {
        this.showErrorNotification();
        return;
      }

      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_4__services_resource_client_general_information__["b" /* default */].put(_this5.quiz.uuid, _this5.quiz.answers.filter(_this5.checkEmptyAnswer)).then(_this5.$refs.notifier.showSavedFormNotification()).catch(function (e) {
          _this5.notifyGeneralInformationsSubmitError(e);
        });
      }, 0);
    },
    checkEmptyAnswer: function checkEmptyAnswer(answer) {
      return answer.value !== null;
    },
    showSavedFormNotification: function showSavedFormNotification() {
      this.$notify({ type: 'success', title: 'Sucesso', text: 'As informações foram salvas!' });
    },
    showErrorNotification: function showErrorNotification() {
      this.$notify({ type: 'error', title: 'Ocorreu um erro', text: 'Verifique se as informações foram preenchidas corretamente e tente novamente.' });
    },
    notifyGeneralInformationsSubmitError: function notifyGeneralInformationsSubmitError(e) {
      var payload = e.response && e.response.data ? e.response.data : null;
      if (payload && payload.errors) {
        this.errors = payload.errors;
      } else {
        this.errors = null;
      }
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_quizValidationErrors__["a" /* responseContainsCpfCnpjValidationError */])(payload)) {
        this.$notify({
          type: 'error',
          title: 'CPF ou CNPJ inválido',
          text: 'Corrija os documentos informados nas informações gerais e tente novamente.'
        });
        return;
      }
      this.$refs.notifier.showErrorNotification();
    }
  }
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_GoBackButton__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_GoBackButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_elements_GoBackButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_Notifier__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_Notifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_elements_Notifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_resource_client_quiz_template__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_resource_client_park_quiz__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_resource_client_quiz_evaluation__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__questions_DateQuestion__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__questions_DateQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__questions_DateQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__questions_MultipleChoiceQuestion__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__questions_MultipleChoiceQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__questions_MultipleChoiceQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__questions_CollectionQuestion__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__questions_CollectionQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__questions_CollectionQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__questions_BooleanFormQuestion__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__questions_BooleanFormQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__questions_BooleanFormQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__questions_BooleanCollectionQuestion__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__questions_BooleanCollectionQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__questions_BooleanCollectionQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__questions_FormQuestion__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__questions_FormQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__questions_FormQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__questions_ItemsQuestion__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__questions_ItemsQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__questions_ItemsQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__questions_AccelerationProgramItemsQuestion__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__questions_AccelerationProgramItemsQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__questions_AccelerationProgramItemsQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__questions_AssociationProgramItemsQuestion__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__questions_AssociationProgramItemsQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__questions_AssociationProgramItemsQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__questions_CoworkingProgramItemsQuestion__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__questions_CoworkingProgramItemsQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__questions_CoworkingProgramItemsQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__questions_IncubationProgramItemsQuestion__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__questions_IncubationProgramItemsQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__questions_IncubationProgramItemsQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__questions_PreIncubationProgramItemsQuestion__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__questions_PreIncubationProgramItemsQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__questions_PreIncubationProgramItemsQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__questions_ResidencyProgramItemsQuestion__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__questions_ResidencyProgramItemsQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__questions_ResidencyProgramItemsQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__questions_OwnRevenuesQuestion__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__questions_OwnRevenuesQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__questions_OwnRevenuesQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__questions_FinanceIndicatorsQuestion__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__questions_FinanceIndicatorsQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__questions_FinanceIndicatorsQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_quizValidationErrors__ = __webpack_require__(157);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ParkQuiz',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_4__components_template_Adminlte___default.a, GoBackButton: __WEBPACK_IMPORTED_MODULE_5__components_elements_GoBackButton___default.a, Notifier: __WEBPACK_IMPORTED_MODULE_6__components_elements_Notifier___default.a, tabs: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["tabs"], tab: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["tab"] },
  props: ['parkId', 'referenceYear', 'quizUuid'],
  data: function data() {
    return {
      questionsByAxis: {},
      quiz: null,
      quizEvaluation: {},
      componentsPerType: {
        'date': __WEBPACK_IMPORTED_MODULE_10__questions_DateQuestion___default.a,
        'multiple-choice': __WEBPACK_IMPORTED_MODULE_11__questions_MultipleChoiceQuestion___default.a,
        'collection': __WEBPACK_IMPORTED_MODULE_12__questions_CollectionQuestion___default.a,
        'boolean-form': __WEBPACK_IMPORTED_MODULE_13__questions_BooleanFormQuestion___default.a,
        'boolean-collection': __WEBPACK_IMPORTED_MODULE_14__questions_BooleanCollectionQuestion___default.a,
        'form': __WEBPACK_IMPORTED_MODULE_15__questions_FormQuestion___default.a,
        'items': __WEBPACK_IMPORTED_MODULE_16__questions_ItemsQuestion___default.a
      },
      customComponentsPerQuestionUuid: {
        'ec210184-aae4-467b-b67b-41e2bb4ec248': __WEBPACK_IMPORTED_MODULE_17__questions_AccelerationProgramItemsQuestion___default.a,
        'debead3c-5c14-4858-a9f0-5015b89d660c': __WEBPACK_IMPORTED_MODULE_17__questions_AccelerationProgramItemsQuestion___default.a,
        '3b776879-6b54-49ee-8c0c-cd2ed248fe8c': __WEBPACK_IMPORTED_MODULE_18__questions_AssociationProgramItemsQuestion___default.a,
        'ea306bbe-5372-4227-810e-2e03a37359ca': __WEBPACK_IMPORTED_MODULE_18__questions_AssociationProgramItemsQuestion___default.a,
        'd35c23ef-3212-4d3d-84e9-5c259e9322f9': __WEBPACK_IMPORTED_MODULE_19__questions_CoworkingProgramItemsQuestion___default.a,
        '058138e8-b55c-4e0f-9f2b-ec3be0ebd421': __WEBPACK_IMPORTED_MODULE_20__questions_IncubationProgramItemsQuestion___default.a,
        'd183149d-ea40-49c1-961e-da109a3ee94f': __WEBPACK_IMPORTED_MODULE_20__questions_IncubationProgramItemsQuestion___default.a,
        '4d59ba81-3b4d-4261-b892-f9a0987e2922': __WEBPACK_IMPORTED_MODULE_20__questions_IncubationProgramItemsQuestion___default.a,
        '1badbc7c-74a9-44f0-a389-1bc55c317573': __WEBPACK_IMPORTED_MODULE_20__questions_IncubationProgramItemsQuestion___default.a,
        '8a7dfc6e-2b34-4c32-bccb-af968c948493': __WEBPACK_IMPORTED_MODULE_21__questions_PreIncubationProgramItemsQuestion___default.a,
        'bf704709-1bd9-4617-b2a8-5298ef3280d4': __WEBPACK_IMPORTED_MODULE_21__questions_PreIncubationProgramItemsQuestion___default.a,
        'dca08a13-f0e2-4be1-9686-0f14837e2373': __WEBPACK_IMPORTED_MODULE_22__questions_ResidencyProgramItemsQuestion___default.a,
        'eb4d4380-1651-43c4-9459-8d93c89f493d': __WEBPACK_IMPORTED_MODULE_22__questions_ResidencyProgramItemsQuestion___default.a,
        '6b023903-50e0-48ab-8942-6b56c78ddb1a': __WEBPACK_IMPORTED_MODULE_23__questions_OwnRevenuesQuestion___default.a,
        'b234f9fb-c8af-4ee1-85fd-3d4dc4072cbb': __WEBPACK_IMPORTED_MODULE_24__questions_FinanceIndicatorsQuestion___default.a
      },
      activeAxis: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.getQuizTemplate();

    if (!this.quizUuid) {
      this.createParkQuiz();
      return;
    }

    this.getQuiz().then(function () {
      _this.getQuizEvaluation();
    });

    $('#send-for-approval-modal').on('hidden.bs.modal', this.scrollToTop);
  },

  computed: {
    isQuizAllowedToBeSent: function isQuizAllowedToBeSent() {
      return this.quiz !== null && this.quiz.status !== __WEBPACK_IMPORTED_MODULE_8__services_resource_client_park_quiz__["b" /* PARK_QUIZ_STATUS_UNANSWERED */];
    },
    activeAxisName: function activeAxisName() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.questionsByAxis)[this.activeAxis];
    }
  },
  methods: {
    setActiveAxis: function setActiveAxis(index) {
      this.activeAxis = index;
    },
    getQuizTemplate: function getQuizTemplate() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_7__services_resource_client_quiz_template__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_8__services_resource_client_park_quiz__["c" /* PARK_QUIZ_TEMPLATE_UUID */], this.parkId).then(function (r) {
        _this2.questionsByAxis = _this2.getQuestionsByAxis(r.data.questions);
      });
    },
    createParkQuiz: function createParkQuiz() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_8__services_resource_client_park_quiz__["a" /* default */].post(this.parkId, this.referenceYear).then(function (r) {
        _this3.quiz = r.data;

        if (_this3.existsAnyManagementAxisQuestionAnswered()) {
          _this3.showUpdateAnswersNotification();
        }
      });
    },
    existsAnyManagementAxisQuestionAnswered: function existsAnyManagementAxisQuestionAnswered() {
      var managementAxisQuestions = this.questionsByAxis['Gestão'];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(managementAxisQuestions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var question = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.quiz.answers)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var answer = _step2.value;

              if (answer.questionUuid === question.uuid && answer.value) {
                return true;
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    },
    getQuiz: function getQuiz() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_8__services_resource_client_park_quiz__["a" /* default */].getByYear(this.parkId, this.referenceYear).then(function (r) {
        _this4.quiz = r.data[0];
      });
    },
    hasQuizEvaluation: function hasQuizEvaluation() {
      return this.quizEvaluation && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.quizEvaluation).length > 0;
    },
    getQuizEvaluation: function getQuizEvaluation() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_9__services_resource_client_quiz_evaluation__["a" /* default */].byParkQuizUuid(this.quiz.uuid).then(function (r) {
        if (r.data.total > 0) {
          _this5.quizEvaluation = r.data[0];
        }
      });
    },
    axisHeader: function axisHeader(axisName) {
      if (!this.hasQuizEvaluation()) {
        return axisName;
      }
      if (this.quizEvaluation.approvedAxis.includes(axisName)) {
        return '<i class="fa fa-check-square-o text-green"></i> ' + axisName;
      }
      if (this.quizEvaluation.disapprovedAxis.includes(axisName)) {
        return '<i class="fa fa-window-close-o text-danger"></i> ' + axisName;
      }
      return '<i class="fa fa-square-o"></i> ' + axisName;
    },
    getQuestionsByAxis: function getQuestionsByAxis(questions) {
      var _this6 = this;

      var questionsByAxis = this.sortQuestionsByAxis(questions);
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(questionsByAxis).forEach(function (k) {
        questionsByAxis[k] = _this6.sortQuestionsByRenderingOrder(questionsByAxis[k]);
      });
      return questionsByAxis;
    },
    sortQuestionsByAxis: function sortQuestionsByAxis(questions) {
      var questionsByAxis = {
        'Gestão': [],
        'Serviços': [],
        'Infraestrutura': [],
        'Equipe': [],
        'Parceiros': []
      };
      questions.forEach(function (e) {
        var axis = e.axis;
        if (!questionsByAxis.hasOwnProperty(e.axis)) {
          questionsByAxis[axis] = [];
        }
        questionsByAxis[axis].push(e);
      });
      return questionsByAxis;
    },
    sortQuestionsByRenderingOrder: function sortQuestionsByRenderingOrder(questions) {
      questions.sort(function (a, b) {
        return a.renderingOrder - b.renderingOrder;
      });
      return questions;
    },
    onAnswerUpdated: function onAnswerUpdated(answer) {
      var questionFound = false;
      this.quiz.answers.forEach(function (a) {
        if (a.questionUuid === answer.questionUuid) {
          a.value = answer.value;
          questionFound = true;
          return;
        }
      });
      if (!questionFound) {
        throw new Error('AnswerNotFoundException');
      }
    },
    getQuestionComponent: function getQuestionComponent(q) {
      if (this.customComponentsPerQuestionUuid.hasOwnProperty(q.uuid)) {
        return this.customComponentsPerQuestionUuid[q.uuid];
      }
      return this.componentsPerType[q.type];
    },
    getQuestionAnswer: function getQuestionAnswer(q) {
      if (!q.isVisible || this.quiz === null) {
        return;
      }
      for (var answerIndex in this.quiz.answers) {
        var answer = this.quiz.answers[answerIndex];
        if (answer.questionUuid === q.uuid) {
          return answer;
        }
      }
      return this.addDefaultAnswerForQuestion(q);
    },
    addDefaultAnswerForQuestion: function addDefaultAnswerForQuestion(question) {
      var defaultAnswer = {
        'questionUuid': question.uuid,
        'value': null
      };

      var answersLength = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.quiz.answers).length;
      this.$set(this.quiz.answers, answersLength, defaultAnswer);

      return defaultAnswer;
    },
    onSubmit: function onSubmit() {
      this.saveQuiz();
    },
    saveQuiz: function saveQuiz() {
      var _this7 = this;

      if (!this.isActiveAxisValid()) {
        this.showActiveAxisErrorNotification();
        return;
      }
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_8__services_resource_client_park_quiz__["a" /* default */].put(_this7.quiz.uuid, __WEBPACK_IMPORTED_MODULE_8__services_resource_client_park_quiz__["d" /* PARK_QUIZ_STATUS_ANSWERED */], _this7.quiz.answers.filter(_this7.checkEmptyAnswer), _this7.activeAxisName).then(function (response) {
          _this7.showSavedFormNotification();
          _this7.quiz.status = response.data.status;
        }).catch(function (e) {
          _this7.notifyParkQuizSubmitError(e);
        });
      }, 0);
    },
    isActiveAxisValid: function isActiveAxisValid() {
      var _this8 = this;

      var isValid = true;
      this.$refs.questions.forEach(function (child) {
        if (!child.isValid() && child.question && child.question.axis === _this8.activeAxisName) {
          isValid = false;
        }
      });
      return isValid;
    },
    sendQuiz: function sendQuiz() {
      var _this9 = this;

      $('#send-for-approval-modal').modal('toggle');

      if (!this.areAllAxesValid()) {
        this.activateFirstInvalidAxis();
        this.showActiveAxisErrorNotification();
        return;
      }

      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_8__services_resource_client_park_quiz__["a" /* default */].put(_this9.quiz.uuid, __WEBPACK_IMPORTED_MODULE_8__services_resource_client_park_quiz__["e" /* PARK_QUIZ_STATUS_WAITING_APPROVAL */], _this9.quiz.answers.filter(_this9.checkEmptyAnswer)).then(function (response) {
          _this9.showSavedFormNotification();
          _this9.quiz.status = response.data.status;
          _this9.$router.push({ name: 'ParkHome' });
        }).catch(function (e) {
          _this9.notifyParkQuizSubmitError(e);
        });
      }, 0);
    },
    areAllAxesValid: function areAllAxesValid() {
      var isValid = true;
      this.$refs.questions.forEach(function (child) {
        if (!child.isValid()) {
          isValid = false;
        }
      });
      return isValid;
    },
    activateFirstInvalidAxis: function activateFirstInvalidAxis() {
      for (var i = 0; i < this.$refs.questions.length; i++) {
        var child = this.$refs.questions[i];
        if (!child.isValid()) {
          this.activeAxis = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.questionsByAxis).indexOf(child.question.axis);
          return;
        }
      }
    },
    checkEmptyAnswer: function checkEmptyAnswer(answer) {
      return answer.value !== null;
    },
    showUpdateAnswersNotification: function showUpdateAnswersNotification() {
      this.$notify({
        type: 'warning',
        title: 'Atenção',
        text: 'As respostas a seguir foram recuperadas de seu último questionário respondido. Por favor, verifique-as e atualize as informações necessárias!',
        duration: 30000
      });
      this.scrollToTop();
    },
    showSavedFormNotification: function showSavedFormNotification() {
      this.$notify({ type: 'success', title: 'Sucesso', text: 'As informações foram salvas!' });
      this.scrollToTop();
    },
    showErrorNotification: function showErrorNotification() {
      this.$notify({ type: 'error', title: 'Ocorreu um erro', text: 'Verifique se as informações foram preenchidas corretamente e tente novamente.' });
      this.scrollToTop();
    },
    showActiveAxisErrorNotification: function showActiveAxisErrorNotification() {
      this.$notify({ type: 'error', title: 'Eixo inválido', text: 'Este eixo do questionário possui respostas inválidas.' });
      this.scrollToTop();
    },
    showUnexpectedErrorNotification: function showUnexpectedErrorNotification() {
      this.$notify({ type: 'error', title: 'Ocorreu um erro inesperado', text: 'Por favor, entre em contato com nossa equipe relatando o problema.' });
      this.scrollToTop();
    },
    notifyParkQuizSubmitError: function notifyParkQuizSubmitError(e) {
      var payload = e.response && e.response.data ? e.response.data : null;
      if (payload && payload.errors) {
        this.errors = payload.errors;
      } else {
        this.errors = null;
      }
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__utils_quizValidationErrors__["a" /* responseContainsCpfCnpjValidationError */])(payload)) {
        this.$notify({
          type: 'error',
          title: 'CPF ou CNPJ inválido',
          text: 'Corrija os documentos informados no questionário e tente novamente.'
        });
        this.scrollToTop();
        return;
      }
      this.showUnexpectedErrorNotification();
    },
    scrollToTop: function scrollToTop() {
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 0);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_Notifier__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_Notifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_elements_Notifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__questions_DateQuestion__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__questions_DateQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__questions_DateQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__questions_MultipleChoiceQuestion__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__questions_MultipleChoiceQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__questions_MultipleChoiceQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__questions_CollectionQuestion__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__questions_CollectionQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__questions_CollectionQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__questions_BooleanFormQuestion__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__questions_BooleanFormQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__questions_BooleanFormQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__questions_BooleanCollectionQuestion__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__questions_BooleanCollectionQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__questions_BooleanCollectionQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__questions_FormQuestion__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__questions_FormQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__questions_FormQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__questions_ItemsQuestion__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__questions_ItemsQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__questions_ItemsQuestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_resource_client_park_quiz__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_resource_client_quiz_template__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_resource_client_quiz_evaluation__ = __webpack_require__(155);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ParkQuizValidation',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_1__components_template_Adminlte___default.a, tabs: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["tabs"], tab: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["tab"], Notifier: __WEBPACK_IMPORTED_MODULE_3__components_elements_Notifier___default.a },
  props: ['parkId', 'parkName', 'referenceYear', 'quizUuid'],
  data: function data() {
    return {
      questionsByAxis: {},
      quiz: null,
      quizEvaluation: {},
      activeAxis: 0,
      componentsPerType: {
        'date': __WEBPACK_IMPORTED_MODULE_4__questions_DateQuestion___default.a,
        'multiple-choice': __WEBPACK_IMPORTED_MODULE_5__questions_MultipleChoiceQuestion___default.a,
        'collection': __WEBPACK_IMPORTED_MODULE_6__questions_CollectionQuestion___default.a,
        'boolean-form': __WEBPACK_IMPORTED_MODULE_7__questions_BooleanFormQuestion___default.a,
        'boolean-collection': __WEBPACK_IMPORTED_MODULE_8__questions_BooleanCollectionQuestion___default.a,
        'form': __WEBPACK_IMPORTED_MODULE_9__questions_FormQuestion___default.a,
        'items': __WEBPACK_IMPORTED_MODULE_10__questions_ItemsQuestion___default.a
      }
    };
  },
  mounted: function mounted() {
    this.getQuizTemplate();
    this.getQuiz();
    this.setQuizEvaluation();
  },

  computed: {
    isAbleToDisapproveQuiz: function isAbleToDisapproveQuiz() {
      return this.hasAllAxisBeenValidated && this.quizEvaluation.disapprovedAxis.length > 0;
    },
    isAbleToApproveQuiz: function isAbleToApproveQuiz() {
      return this.hasAllAxisBeenValidated && this.quizEvaluation.disapprovedAxis.length === 0;
    },
    hasAllAxisBeenValidated: function hasAllAxisBeenValidated() {
      if (!this.quizEvaluation || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.quizEvaluation).length < 1) {
        return false;
      }
      var numberOfAxis = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.questionsByAxis).length;
      return this.quizEvaluation.approvedAxis.length + this.quizEvaluation.disapprovedAxis.length === numberOfAxis;
    }
  },
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    getQuizTemplate: function getQuizTemplate() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_12__services_resource_client_quiz_template__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_11__services_resource_client_park_quiz__["c" /* PARK_QUIZ_TEMPLATE_UUID */], this.parkId).then(function (r) {
        _this.questionsByAxis = _this.getQuestionsByAxis(r.data.questions);
      });
    },
    getQuiz: function getQuiz() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_11__services_resource_client_park_quiz__["a" /* default */].getByYear(this.parkId, this.referenceYear).then(function (r) {
        _this2.quiz = r.data[0];
      });
    },
    setQuizEvaluation: function setQuizEvaluation() {
      var _this3 = this;

      this.getQuizEvaluation().then(function (r) {
        if (r.total === 1) {
          _this3.quizEvaluation = r[0];
          _this3.quizEvaluation.isParkQuizApproved = null;
          return;
        }
        _this3.createQuizEvaluation().then(function (r) {
          _this3.quizEvaluation = r;
        });
      });
    },
    getQuizEvaluation: function getQuizEvaluation() {
      return __WEBPACK_IMPORTED_MODULE_13__services_resource_client_quiz_evaluation__["a" /* default */].byParkQuizUuid(this.quizUuid).then(function (r) {
        return r.data;
      });
    },
    createQuizEvaluation: function createQuizEvaluation() {
      return __WEBPACK_IMPORTED_MODULE_13__services_resource_client_quiz_evaluation__["a" /* default */].post(this.quizUuid).then(function (r) {
        return r.data;
      });
    },
    putQuizEvaluation: function putQuizEvaluation() {
      return __WEBPACK_IMPORTED_MODULE_13__services_resource_client_quiz_evaluation__["a" /* default */].put(this.quizEvaluation.id, this.parkQuizUuid, this.quizEvaluation.approvedAxis, this.quizEvaluation.disapprovedAxis, this.quizEvaluation.isParkQuizApproved);
    },
    getQuestionsByAxis: function getQuestionsByAxis(questions) {
      var _this4 = this;

      var questionsByAxis = this.sortQuestionsByAxis(questions);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(questionsByAxis).forEach(function (k) {
        questionsByAxis[k] = _this4.sortQuestionsByRenderingOrder(questionsByAxis[k]);
      });
      return questionsByAxis;
    },
    sortQuestionsByAxis: function sortQuestionsByAxis(questions) {
      var questionsByAxis = {
        'Gestão': [],
        'Serviços': [],
        'Infraestrutura': [],
        'Equipe': [],
        'Parceiros': []
      };
      questions.forEach(function (e) {
        var axis = e.axis;
        if (!questionsByAxis.hasOwnProperty(e.axis)) {
          questionsByAxis[axis] = [];
        }
        questionsByAxis[axis].push(e);
      });
      return questionsByAxis;
    },
    sortQuestionsByRenderingOrder: function sortQuestionsByRenderingOrder(questions) {
      questions.sort(function (a, b) {
        return a.renderingOrder - b.renderingOrder;
      });
      return questions;
    },
    getQuestionComponent: function getQuestionComponent(q) {
      return this.componentsPerType[q.type];
    },
    getQuestionAnswer: function getQuestionAnswer(q) {
      if (!q.isVisible || this.quiz === null) {
        return;
      }
      for (var answerIndex in this.quiz.answers) {
        var answer = this.quiz.answers[answerIndex];
        if (answer.questionUuid === q.uuid) {
          return answer;
        }
      }
      return this.addDefaultAnswerForQuestion(q);
    },
    addDefaultAnswerForQuestion: function addDefaultAnswerForQuestion(question) {
      var defaultAnswer = {
        'questionUuid': question.uuid,
        'value': null
      };

      var answersLength = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.quiz.answers).length;
      this.quiz.answers[answersLength] = defaultAnswer;

      return defaultAnswer;
    },
    setActiveAxis: function setActiveAxis(index) {
      this.activeAxis = index;
    },
    approveCurrentAxis: function approveCurrentAxis() {
      var _this5 = this;

      var currentAxisName = this.getCurrentAxisName();
      if (this.quizEvaluation.approvedAxis.includes(currentAxisName)) {
        this.goToNextAxisAndScrollToTop();
        return;
      }
      this.quizEvaluation.disapprovedAxis = this.quizEvaluation.disapprovedAxis.filter(function (el) {
        return el !== currentAxisName;
      });
      this.quizEvaluation.approvedAxis.push(currentAxisName);
      this.putQuizEvaluation().then(function () {
        _this5.goToNextAxisAndScrollToTop();
      });
    },
    disapproveCurrentAxis: function disapproveCurrentAxis() {
      var _this6 = this;

      var currentAxisName = this.getCurrentAxisName();
      if (this.quizEvaluation.disapprovedAxis.includes(currentAxisName)) {
        this.goToNextAxisAndScrollToTop();
        return;
      }
      this.quizEvaluation.approvedAxis = this.quizEvaluation.approvedAxis.filter(function (el) {
        return el !== currentAxisName;
      });
      this.quizEvaluation.disapprovedAxis.push(currentAxisName);
      this.putQuizEvaluation().then(function () {
        _this6.goToNextAxisAndScrollToTop();
      });
    },
    getCurrentAxisName: function getCurrentAxisName() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.questionsByAxis)[this.activeAxis];
    },
    goToNextAxisAndScrollToTop: function goToNextAxisAndScrollToTop() {
      this.goToNextAxis();
      this.scrollToTop();
    },
    goToNextAxis: function goToNextAxis() {
      if (this.isLastAxis(this.activeAxis)) {
        this.goToFirstAxis();
        return;
      }
      this.activeAxis += 1;
    },
    isLastAxis: function isLastAxis(axis) {
      return axis === __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.questionsByAxis).length - 1;
    },
    goToFirstAxis: function goToFirstAxis() {
      this.activeAxis = 0;
    },
    scrollToTop: function scrollToTop() {
      window.scrollTo(0, 0);
    },
    axisHeader: function axisHeader(axisName) {
      if (!this.quizEvaluation || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.quizEvaluation).length < 1) {
        return '<i class="fa fa-square-o"></i> ' + axisName;
      }
      if (this.quizEvaluation.approvedAxis.includes(axisName)) {
        return '<i class="fa fa-check-square-o text-green"></i> ' + axisName;
      }
      if (this.quizEvaluation.disapprovedAxis.includes(axisName)) {
        return '<i class="fa fa-window-close-o text-danger"></i> ' + axisName;
      }
      return '<i class="fa fa-square-o"></i> ' + axisName;
    },
    disapproveQuiz: function disapproveQuiz() {
      var _this7 = this;

      if (this.isAbleToDisapproveQuiz) {
        this.quizEvaluation.isParkQuizApproved = false;
        this.putQuizEvaluation().then(function () {
          _this7.$notify({ type: 'success', title: 'Questionário Reprovado', text: 'O questionário foi reprovado.' });
          _this7.goBack();
        });
        return;
      }
      throw Error('Unable to disapprove quiz');
    },
    approveQuiz: function approveQuiz() {
      var _this8 = this;

      if (this.isAbleToApproveQuiz) {
        this.quizEvaluation.isParkQuizApproved = true;
        this.putQuizEvaluation().then(function () {
          _this8.$notify({ type: 'success', title: 'Questionário Aprovado', text: 'O questionário foi aprovado.' });
          _this8.goBack();
        });
        return;
      }
      throw Error('Unable to approve quiz');
    }
  }
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_resource_client_park_quiz__ = __webpack_require__(74);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ParkQuizValidationList',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default.a },
  data: function data() {
    return {
      waittingApprovalParkQuizzes: []
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__services_resource_client_park_quiz__["a" /* default */].waittingApproval().then(function (r) {
      _this.waittingApprovalParkQuizzes = r.data;
    }).then(function () {
      return $('#park-quiz-validation-table').DataTable();
    });
  },

  methods: {
    validateParkQuiz: function validateParkQuiz(parkId, parkName, parkQuizUuid, parkQuizYear) {
      this.$router.push({
        name: 'ParkQuizValidation',
        params: {
          parkId: parkId,
          'parkName': parkName,
          'quizUuid': parkQuizUuid,
          'referenceYear': parkQuizYear
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_park_programs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ItemsQuestion__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ItemsQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ItemsQuestion__);

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AccelerationProgramItemsQuestion',
  components: { ItemsQuestion: __WEBPACK_IMPORTED_MODULE_2__ItemsQuestion___default.a },
  props: ['question', 'answer', 'quizAnswers', 'isDisabled'],
  methods: {
    isValid: function isValid() {
      if (!this.parkOffersAcceleration) {
        return true;
      }
      return this.$refs.child.isValid();
    },
    onAnswerUpdated: function onAnswerUpdated(answer) {
      this.$emit('answerUpdated', answer);
    }
  },
  computed: {
    parkOffersAcceleration: function parkOffersAcceleration() {
      return __WEBPACK_IMPORTED_MODULE_1__services_park_programs__["a" /* default */].has(__WEBPACK_IMPORTED_MODULE_1__services_park_programs__["a" /* default */].ACCELERATION, this.quizAnswers);
    }
  },
  watch: {
    parkOffersAcceleration: {
      immediate: true,
      handler: function handler() {
        if (!this.parkOffersAcceleration) {
          this.$emit('answerUpdated', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.answer, { value: null }));
        }
      }
    }
  }
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_park_programs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ItemsQuestion__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ItemsQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ItemsQuestion__);

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AssociationProgramItemsQuestion',
  components: { ItemsQuestion: __WEBPACK_IMPORTED_MODULE_2__ItemsQuestion___default.a },
  props: ['question', 'answer', 'quizAnswers', 'isDisabled'],
  methods: {
    isValid: function isValid() {
      if (!this.parkOffersAssociation) {
        return true;
      }
      return this.$refs.child.isValid();
    },
    onAnswerUpdated: function onAnswerUpdated(answer) {
      this.$emit('answerUpdated', answer);
    }
  },
  computed: {
    parkOffersAssociation: function parkOffersAssociation() {
      return __WEBPACK_IMPORTED_MODULE_1__services_park_programs__["a" /* default */].has(__WEBPACK_IMPORTED_MODULE_1__services_park_programs__["a" /* default */].ASSOCIATION, this.quizAnswers);
    }
  },
  watch: {
    parkOffersAssociation: {
      immediate: true,
      handler: function handler() {
        if (!this.parkOffersAssociation) {
          this.$emit('answerUpdated', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.answer, { value: null }));
        }
      }
    }
  }
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fields_CNPJField__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fields_CNPJField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__fields_CNPJField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fields_StringField__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fields_StringField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fields_StringField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fields_YearField__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fields_YearField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fields_YearField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fields_EmailField__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fields_EmailField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fields_EmailField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fields_PhoneNumberField__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fields_PhoneNumberField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fields_PhoneNumberField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_MultipleChoiceField__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_MultipleChoiceField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__fields_MultipleChoiceField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fields_IntegerField__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fields_IntegerField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__fields_IntegerField__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['question', 'answer', 'isDisabled'],
  name: 'BooleanCollectionQuestion',
  data: function data() {
    return {
      componentsPerType: {
        'cnpj': __WEBPACK_IMPORTED_MODULE_0__fields_CNPJField___default.a,
        'string': __WEBPACK_IMPORTED_MODULE_1__fields_StringField___default.a,
        'year': __WEBPACK_IMPORTED_MODULE_2__fields_YearField___default.a,
        'email': __WEBPACK_IMPORTED_MODULE_3__fields_EmailField___default.a,
        'phone_number': __WEBPACK_IMPORTED_MODULE_4__fields_PhoneNumberField___default.a,
        'multiple-choice': __WEBPACK_IMPORTED_MODULE_5__fields_MultipleChoiceField___default.a,
        'integer': __WEBPACK_IMPORTED_MODULE_6__fields_IntegerField___default.a
      },
      m_answer: {
        questionUuid: this.question.uuid,
        value: {
          booleanAnswer: this.answer.value && this.answer.value.booleanAnswer !== null ? this.answer.value.booleanAnswer : null,
          rowsWhenTrue: this.answer.value && this.answer.value.rowsWhenTrue ? this.answer.value.rowsWhenTrue : []
        }
      },
      m_error: null
    };
  },
  mounted: function mounted() {
    this.question = this.sortQuestionFieldsByRenderingOrder(this.question);

    if (this.rowsWhenTrueLength === 0 && this.m_answer.value.booleanAnswer) {
      this.addRow();
    }
  },

  computed: {
    rowsWhenTrueLength: function rowsWhenTrueLength() {
      return this.m_answer.value.rowsWhenTrue.length;
    },
    disabledAttribute: function disabledAttribute() {
      return this.question.disabled === true || this.isDisabled === true;
    }
  },
  watch: {
    m_answer: {
      handler: function handler() {
        this.$emit('answerUpdated', this.m_answer);
      },

      deep: true
    }
  },
  methods: {
    onBooleanAnswerChange: function onBooleanAnswerChange(data) {
      this.m_answer.value.booleanAnswer = data.target.value === 'true';
      if (!this.m_answer.value.booleanAnswer) {
        this.m_answer.value.rowsWhenTrue = [];
        return;
      }

      if (this.m_answer.value.rowsWhenTrue.length < 1) {
        this.addRow();
      }
    },
    getBooleanAnswerValue: function getBooleanAnswerValue() {
      return this.m_answer.value.booleanAnswer;
    },
    onFieldUpdated: function onFieldUpdated(rowIndex, newFieldAnswer) {
      var fieldAnswerFound = false;
      var row = this.m_answer.value.rowsWhenTrue[rowIndex];
      for (var fieldIndex in row) {
        var fieldAnswer = row[fieldIndex];
        if (fieldAnswer.fieldUuid === newFieldAnswer.fieldUuid) {
          fieldAnswer.value = newFieldAnswer.value;
          fieldAnswerFound = true;
        }
      }
      if (!fieldAnswerFound) {
        throw new Error('FieldAnswerNotFoundException');
      }
    },
    removeRow: function removeRow() {
      this.m_answer.value.rowsWhenTrue.pop();
    },
    addRow: function addRow() {
      var emptyAnswer = [];
      this.question.fieldsWhenTrue.forEach(function (field) {
        emptyAnswer.push({ 'fieldUuid': field.uuid, 'value': null });
      });
      this.m_answer.value.rowsWhenTrue.push(emptyAnswer);
    },
    getFieldComponent: function getFieldComponent(f) {
      return this.componentsPerType[f.type];
    },
    getFieldAnswer: function getFieldAnswer(rowCounter, field) {
      var fieldAnswerFound = false;
      var rowIndex = rowCounter - 1;
      var row = this.m_answer.value.rowsWhenTrue[rowIndex];
      for (var fieldIndex in row) {
        var fieldAnswer = row[fieldIndex];
        if (fieldAnswer.fieldUuid === field.uuid) {
          fieldAnswerFound = true;
          return { 'rowIndex': rowIndex, 'value': fieldAnswer.value };
        }
      }
      if (!fieldAnswerFound) {
        throw new Error('FieldAnswerNotFoundException');
      }
    },
    sortQuestionFieldsByRenderingOrder: function sortQuestionFieldsByRenderingOrder(question) {
      question.fieldsWhenTrue.sort(function (a, b) {
        return a.renderingOrder - b.renderingOrder;
      });
      return question;
    },
    isValid: function isValid() {
      this.m_error = null;

      if (this.question.required && this.m_answer.value.booleanAnswer === null) {
        this.m_error = 'Esta campo é de preenchimento obrigatório';
        return false;
      }

      var areFieldAnswersBlank = true;
      for (var rowIndex in this.m_answer.value.rowsWhenTrue) {
        for (var fieldIndex in this.m_answer.value.rowsWhenTrue[rowIndex]) {
          if (this.m_answer.value.rowsWhenTrue[rowIndex][fieldIndex].value) {
            areFieldAnswersBlank = false;
          }
        }
      }
      if (!this.question.required && areFieldAnswersBlank) {
        this.m_answer.value.rowsWhenTrue = [];
        return true;
      }

      if (!this.$refs.fieldsWhenTrue) {
        return true;
      }

      var areFieldAnswersValid = true;
      this.$refs.fieldsWhenTrue.forEach(function (f) {
        if (!f.isValid()) {
          areFieldAnswersValid = false;
        }
      });

      return areFieldAnswersValid;
    }
  }
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fields_CNPJField__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fields_CNPJField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__fields_CNPJField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fields_StringField__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fields_StringField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fields_StringField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fields_YearField__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fields_YearField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fields_YearField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fields_EmailField__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fields_EmailField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fields_EmailField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fields_PhoneNumberField__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fields_PhoneNumberField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fields_PhoneNumberField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_MultipleChoiceField__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_MultipleChoiceField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__fields_MultipleChoiceField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fields_IntegerField__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fields_IntegerField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__fields_IntegerField__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BooleanFormQuestion',
  props: ['question', 'answer', 'isDisabled'],
  data: function data() {
    return {
      m_question: this.question,
      m_answer: {
        questionUuid: this.question.uuid,
        value: {
          booleanAnswer: this.answer.value && this.answer.value.booleanAnswer !== null ? this.answer.value.booleanAnswer : null,
          fieldsAnswersWhenTrue: this.answer.value && this.answer.value.fieldsAnswersWhenTrue ? this.answer.value.fieldsAnswersWhenTrue : []
        }
      },
      m_error: null,
      componentsPerType: {
        'cnpj': __WEBPACK_IMPORTED_MODULE_0__fields_CNPJField___default.a,
        'string': __WEBPACK_IMPORTED_MODULE_1__fields_StringField___default.a,
        'year': __WEBPACK_IMPORTED_MODULE_2__fields_YearField___default.a,
        'email': __WEBPACK_IMPORTED_MODULE_3__fields_EmailField___default.a,
        'phone_number': __WEBPACK_IMPORTED_MODULE_4__fields_PhoneNumberField___default.a,
        'multiple-choice': __WEBPACK_IMPORTED_MODULE_5__fields_MultipleChoiceField___default.a,
        'integer': __WEBPACK_IMPORTED_MODULE_6__fields_IntegerField___default.a
      }
    };
  },

  computed: {
    disabledAttribute: function disabledAttribute() {
      return this.question.disabled === true || this.isDisabled === true;
    }
  },
  watch: {
    'm_answer.value': {
      handler: function handler() {
        this.$emit('answerUpdated', { 'questionUuid': this.question.uuid, 'value': this.m_answer.value });
      },

      deep: true
    }
  },
  mounted: function mounted() {
    this.question = this.sortQuestionFieldsByRenderingOrder(this.question);
  },

  methods: {
    sortQuestionFieldsByRenderingOrder: function sortQuestionFieldsByRenderingOrder(question) {
      question.fieldsWhenTrue.sort(function (a, b) {
        return a.renderingOrder - b.renderingOrder;
      });
      return question;
    },
    onBooleanAnswerChange: function onBooleanAnswerChange(data) {
      this.m_answer.value.booleanAnswer = data.target.value === 'true';
      if (!this.m_answer.value.booleanAnswer) {
        this.m_answer.value.fieldsAnswersWhenTrue = [];
      }
    },
    getBooleanAnswerValue: function getBooleanAnswerValue() {
      return this.m_answer.value.booleanAnswer;
    },
    getFieldComponent: function getFieldComponent(f) {
      return this.componentsPerType[f.type];
    },
    onFieldUpdated: function onFieldUpdated(rowIndex, newFieldAnswer) {
      for (var i in this.m_answer.value.fieldsAnswersWhenTrue) {
        if (this.m_answer.value.fieldsAnswersWhenTrue[i].fieldUuid === newFieldAnswer.fieldUuid) {
          this.m_answer.value.fieldsAnswersWhenTrue[i] = newFieldAnswer;
          return;
        }
      }

      this.m_answer.value.fieldsAnswersWhenTrue.push({ fieldUuid: newFieldAnswer.fieldUuid, value: newFieldAnswer.value });
    },
    getFieldAnswer: function getFieldAnswer(field) {
      for (var i in this.m_answer.value.fieldsAnswersWhenTrue) {
        if (this.m_answer.value.fieldsAnswersWhenTrue[i].fieldUuid === field.uuid) {
          return { fieldUuid: this.m_answer.value.fieldsAnswersWhenTrue[i].fieldUuid, value: this.m_answer.value.fieldsAnswersWhenTrue[i].value };
        }
      }

      return { fieldUuid: field.uuid, value: null };
    },
    isValid: function isValid() {
      this.m_error = null;

      if (this.question.required && this.m_answer.value.booleanAnswer === null) {
        this.m_error = 'Esta campo é de preenchimento obrigatório';
        return false;
      }

      var areFieldAnswersBlank = true;
      for (var field in this.m_answer.value.fieldsAnswersWhenTrue) {
        if (this.m_answer.value.fieldsAnswersWhenTrue[field].value) {
          areFieldAnswersBlank = false;
        }
      }
      if (!this.question.required && areFieldAnswersBlank) {
        this.m_answer.value.fieldsAnswersWhenTrue = [];
        return true;
      }

      if (!this.$refs.fields) {
        return true;
      }

      var areFieldAnswersValid = true;
      this.$refs.fields.forEach(function (f) {
        if (!f.isValid()) {
          areFieldAnswersValid = false;
        }
      });

      return areFieldAnswersValid;
    }
  }
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fields_CNPJField__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fields_CNPJField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fields_CNPJField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fields_CPFField__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fields_CPFField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fields_CPFField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fields_StringField__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fields_StringField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fields_StringField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fields_YearField__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fields_YearField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fields_YearField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_EmailField__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_EmailField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__fields_EmailField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fields_PhoneNumberField__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fields_PhoneNumberField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__fields_PhoneNumberField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fields_MultipleChoiceField__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fields_MultipleChoiceField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__fields_MultipleChoiceField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fields_IntegerField__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fields_IntegerField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__fields_IntegerField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fields_MoneyField__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fields_MoneyField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__fields_MoneyField__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['question', 'answer', 'isDisabled'],
  name: 'CollectionQuestion',

  data: function data() {
    return {
      m_error: null,
      componentsPerType: {
        cnpj: __WEBPACK_IMPORTED_MODULE_1__fields_CNPJField___default.a,
        cpf: __WEBPACK_IMPORTED_MODULE_2__fields_CPFField___default.a,
        string: __WEBPACK_IMPORTED_MODULE_3__fields_StringField___default.a,
        year: __WEBPACK_IMPORTED_MODULE_4__fields_YearField___default.a,
        email: __WEBPACK_IMPORTED_MODULE_5__fields_EmailField___default.a,
        phone_number: __WEBPACK_IMPORTED_MODULE_6__fields_PhoneNumberField___default.a,
        'multiple-choice': __WEBPACK_IMPORTED_MODULE_7__fields_MultipleChoiceField___default.a,
        integer: __WEBPACK_IMPORTED_MODULE_8__fields_IntegerField___default.a,
        money: __WEBPACK_IMPORTED_MODULE_9__fields_MoneyField___default.a
      },
      rows: [],
      rowCounter: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.sortQuestionFieldsByRenderingOrder(this.question);

    if (this.answer.value) {
      this.rows = this.answer.value.map(function (oldRow) {
        return {
          id: _this.rowCounter++,
          fields: oldRow
        };
      });
    }

    if (this.rowsLength === 0) {
      this.addRow();
    }
  },


  computed: {
    rowsLength: function rowsLength() {
      return this.rows.length;
    },
    disabledAttribute: function disabledAttribute() {
      return this.question.disabled === true || this.isDisabled === true;
    }
  },

  watch: {
    rows: {
      deep: true,
      handler: function handler() {
        var formatted = this.rows.map(function (r) {
          return r.fields;
        }).filter(this.notEmptyRow);

        this.$emit('answerUpdated', {
          questionUuid: this.question.uuid,
          value: formatted
        });
      }
    }
  },

  methods: {
    onFieldUpdated: function onFieldUpdated(rowIndex, newFieldAnswer) {
      var row = this.rows[rowIndex].fields;
      var field = row.find(function (f) {
        return f.fieldUuid === newFieldAnswer.fieldUuid;
      });
      if (field) {
        field.value = newFieldAnswer.value;
      }
    },
    removeRow: function removeRow(rowIndex) {
      this.rows.splice(rowIndex, 1);
    },
    addRow: function addRow() {
      var emptyFields = this.question.fields.map(function (field) {
        return {
          fieldUuid: field.uuid,
          value: null
        };
      });

      this.rows.push({
        id: this.rowCounter++,
        fields: emptyFields
      });
    },
    getFieldComponent: function getFieldComponent(f) {
      return this.componentsPerType[f.type];
    },
    getFieldAnswer: function getFieldAnswer(rowIndex, field) {
      var row = this.rows[rowIndex].fields;
      var answer = row.find(function (r) {
        return r.fieldUuid === field.uuid;
      });

      return {
        rowIndex: rowIndex,
        value: answer ? answer.value : null
      };
    },
    sortQuestionFieldsByRenderingOrder: function sortQuestionFieldsByRenderingOrder(question) {
      question.fields.sort(function (a, b) {
        return a.renderingOrder - b.renderingOrder;
      });
      return question;
    },
    notEmptyRow: function notEmptyRow(row) {
      return row.some(function (field) {
        return field.value !== null && field.value !== '';
      });
    },
    isValid: function isValid() {
      this.m_error = null;

      var areFieldAnswersBlank = true;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.rows), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var r = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(r.fields), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var f = _step2.value;

              if (f.value) {
                areFieldAnswersBlank = false;
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (!this.question.required && areFieldAnswersBlank) {
        this.rows = [];
        return true;
      }

      if (this.question.required && areFieldAnswersBlank) {
        this.m_error = 'Esta questão é de preenchimento obrigatório';
        return false;
      }

      var areFieldAnswersValid = true;
      var fields = this.$refs.fields || [];

      fields.forEach(function (field) {
        if (!field.isValid()) {
          areFieldAnswersValid = false;
        }
      });

      return areFieldAnswersValid;
    }
  }
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_park_programs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ItemsQuestion__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ItemsQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ItemsQuestion__);

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CoworkingProgramItemsQuestion',
  components: { ItemsQuestion: __WEBPACK_IMPORTED_MODULE_2__ItemsQuestion___default.a },
  props: ['question', 'answer', 'quizAnswers', 'isDisabled'],
  methods: {
    isValid: function isValid() {
      if (!this.parkOffersCoworking) {
        return true;
      }
      return this.$refs.child.isValid();
    },
    onAnswerUpdated: function onAnswerUpdated(answer) {
      this.$emit('answerUpdated', answer);
    }
  },
  computed: {
    parkOffersCoworking: function parkOffersCoworking() {
      return __WEBPACK_IMPORTED_MODULE_1__services_park_programs__["a" /* default */].has(__WEBPACK_IMPORTED_MODULE_1__services_park_programs__["a" /* default */].COWORKING, this.quizAnswers);
    }
  },
  watch: {
    parkOffersCoworking: {
      immediate: true,
      handler: function handler() {
        if (!this.parkOffersCoworking) {
          this.$emit('answerUpdated', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.answer, { value: null }));
        }
      }
    }
  }
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DateQuestion__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DateQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DateQuestion__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['question', 'answer', 'isDisabled'],
  name: 'DateLteTodayQuestion',
  components: { DateQuestion: __WEBPACK_IMPORTED_MODULE_0__DateQuestion___default.a },
  methods: {
    isValid: function isValid() {
      return this.$refs.child.isValid();
    },
    onAnswerUpdated: function onAnswerUpdated(answer) {
      this.$emit('answerUpdated', answer);
    }
  }
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_date_formatter__ = __webpack_require__(49);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['question', 'answer', 'isDisabled', 'disableFutureDates'],
  name: 'DateQuestion',
  components: { DatePicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__["a" /* default */] },
  data: function data() {
    return {
      datepickerLanguage: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["ptBR"],
      m_question: this.question,
      m_answer: {
        questionUuid: this.question.uuid,
        value: this.answer ? this.answer.value : null
      },
      m_error: null
    };
  },

  computed: {
    disabledAttribute: function disabledAttribute() {
      return this.question.disabled === true || this.isDisabled === true;
    },
    disabledDates: function disabledDates() {
      if (this.disableFutureDates) {
        return {
          from: new Date()
        };
      }
      return {};
    }
  },
  watch: {
    'm_answer.value': function m_answerValue() {
      this.$emit('answerUpdated', this.m_answer);
    }
  },
  methods: {
    getAnswerAsDateObject: function getAnswerAsDateObject() {
      if (!this.answer.value) {
        return null;
      }
      return new Date(this.answer.value.split('-'));
    },
    onDateSelected: function onDateSelected(date) {
      this.m_answer.value = __WEBPACK_IMPORTED_MODULE_2__services_date_formatter__["a" /* default */].formatAPIDate(date);
    },
    isValid: function isValid() {
      if (this.question.required && !this.m_answer.value) {
        this.m_error = 'Este campo é de preenchimento obrigatório.';
        return false;
      }
      this.m_error = null;
      return true;
    }
  }
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_park_programs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CollectionQuestion__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CollectionQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__CollectionQuestion__);



//
//
//
//
//
//
//
//
//
//
//
//





var PROGRAMS_FIELD_UUID = 'eada268d-ca2d-4466-950a-9324ba93ddb6';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FinanceIndicatorsQuestion',
  components: { CollectionQuestion: __WEBPACK_IMPORTED_MODULE_5__CollectionQuestion___default.a },
  props: ['question', 'answer', 'quizAnswers', 'isDisabled'],
  data: function data() {
    return {
      dependenciesByOptionName: {
        'Aceleração de empresas': __WEBPACK_IMPORTED_MODULE_4__services_park_programs__["a" /* default */].ACCELERATION,
        'Empresa associada': __WEBPACK_IMPORTED_MODULE_4__services_park_programs__["a" /* default */].ASSOCIATION,
        'Coworking': __WEBPACK_IMPORTED_MODULE_4__services_park_programs__["a" /* default */].COWORKING,
        'Incubação de empresas': __WEBPACK_IMPORTED_MODULE_4__services_park_programs__["a" /* default */].INCUBATION,
        'Graduação de empresas': __WEBPACK_IMPORTED_MODULE_4__services_park_programs__["a" /* default */].INCUBATION,
        'Pré-incubação de empresas': __WEBPACK_IMPORTED_MODULE_4__services_park_programs__["a" /* default */].PRE_INCUBATION,
        'Empresa residente': __WEBPACK_IMPORTED_MODULE_4__services_park_programs__["a" /* default */].RESIDENCY
      },
      childKey: Math.floor(Math.random() * 999)
    };
  },

  computed: {
    someProgramIsOffered: function someProgramIsOffered() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.dependenciesByOptionName).some(function (program) {
        return __WEBPACK_IMPORTED_MODULE_4__services_park_programs__["a" /* default */].has(program, _this.quizAnswers);
      });
    },
    questionWithFilteredProgramOptions: function questionWithFilteredProgramOptions() {
      var _this2 = this;

      var filteredQuestion = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["cloneDeep"])(this.question);

      var programsField = filteredQuestion.fields.find(function (field) {
        return field.uuid === PROGRAMS_FIELD_UUID;
      });
      programsField.options = programsField.options.filter(function (option) {
        return __WEBPACK_IMPORTED_MODULE_4__services_park_programs__["a" /* default */].has(_this2.dependenciesByOptionName[option], _this2.quizAnswers);
      });

      return this.sortQuestionFieldsByRenderingOrder(filteredQuestion);
    },
    offeredParkPrograms: function offeredParkPrograms() {
      var programsField = this.questionWithFilteredProgramOptions.fields.find(function (field) {
        return field.uuid === PROGRAMS_FIELD_UUID;
      });
      return programsField.options;
    }
  },
  methods: {
    onAnswerUpdated: function onAnswerUpdated(answer) {
      this.$emit('answerUpdated', answer);
    },
    sortQuestionFieldsByRenderingOrder: function sortQuestionFieldsByRenderingOrder(question) {
      question.fields.sort(function (a, b) {
        return a.renderingOrder - b.renderingOrder;
      });
      return question;
    },
    isValid: function isValid() {
      if (!this.someProgramIsOffered) {
        return true;
      }
      return this.$refs.child.isValid();
    },
    updateAnswerWhenParkProgramsChange: function updateAnswerWhenParkProgramsChange() {
      if (!this.answer || !this.answer.value) {
        return;
      }

      var updatedAnswer = this.answerWithoutUnavailableProgramsSelected(this.answer);
      this.$emit('answerUpdated', updatedAnswer);
    },
    answerWithoutUnavailableProgramsSelected: function answerWithoutUnavailableProgramsSelected(answer) {
      var _this3 = this;

      var mappedRows = answer.value.map(function (row) {
        var programFieldAnswerIndex = row.findIndex(function (field) {
          return field.fieldUuid === PROGRAMS_FIELD_UUID;
        });
        if (_this3.rowSelectedProgramIsOffered(row, programFieldAnswerIndex)) {
          return row;
        }
        return _this3.rowWithoutInconsistentSelectedProgram(row, programFieldAnswerIndex);
      });

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, answer, { value: mappedRows });
    },
    rowSelectedProgramIsOffered: function rowSelectedProgramIsOffered(row, programFieldAnswerIndex) {
      var programFieldAnswer = row[programFieldAnswerIndex];

      var _ref = programFieldAnswer.value ? programFieldAnswer.value : [],
          _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 1),
          selectedProgram = _ref2[0];

      return this.offeredParkPrograms.includes(selectedProgram);
    },
    rowWithoutInconsistentSelectedProgram: function rowWithoutInconsistentSelectedProgram(row, programFieldAnswerIndex) {
      var rowClone = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["cloneDeep"])(row);
      rowClone[programFieldAnswerIndex].value = null;
      return rowClone;
    },
    forceChildRerender: function forceChildRerender() {
      this.childKey += 1;
    }
  },
  watch: {
    questionWithFilteredProgramOptions: {
      immediate: true,
      handler: function handler() {
        this.updateAnswerWhenParkProgramsChange();
        this.forceChildRerender();
      }
    }
  }
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fields_CNPJField__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fields_CNPJField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__fields_CNPJField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fields_StringField__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fields_StringField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fields_StringField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fields_YearField__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fields_YearField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fields_YearField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fields_EmailField__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fields_EmailField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fields_EmailField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fields_PhoneNumberField__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fields_PhoneNumberField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fields_PhoneNumberField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_MultipleChoiceField__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_MultipleChoiceField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__fields_MultipleChoiceField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fields_IntegerField__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fields_IntegerField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__fields_IntegerField__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FormQuestion',
  props: ['question', 'answer', 'isDisabled'],
  data: function data() {
    return {
      m_question: this.question,
      m_answer: {
        questionUuid: this.question.uuid,
        value: {
          fieldsAnswers: this.answer.value && this.answer.value.fieldsAnswers ? this.answer.value.fieldsAnswers : []
        }
      },
      m_error: null,
      componentsPerType: {
        'cnpj': __WEBPACK_IMPORTED_MODULE_0__fields_CNPJField___default.a,
        'string': __WEBPACK_IMPORTED_MODULE_1__fields_StringField___default.a,
        'year': __WEBPACK_IMPORTED_MODULE_2__fields_YearField___default.a,
        'email': __WEBPACK_IMPORTED_MODULE_3__fields_EmailField___default.a,
        'phone_number': __WEBPACK_IMPORTED_MODULE_4__fields_PhoneNumberField___default.a,
        'multiple-choice': __WEBPACK_IMPORTED_MODULE_5__fields_MultipleChoiceField___default.a,
        'integer': __WEBPACK_IMPORTED_MODULE_6__fields_IntegerField___default.a
      }
    };
  },

  computed: {
    disabledAttribute: function disabledAttribute() {
      return this.question.disabled === true || this.isDisabled === true;
    }
  },
  watch: {
    'm_answer.value': {
      handler: function handler() {
        this.$emit('answerUpdated', { 'questionUuid': this.question.uuid, 'value': this.m_answer.value });
      },

      deep: true
    }
  },
  mounted: function mounted() {
    this.question = this.sortQuestionFieldsByRenderingOrder(this.question);
  },

  methods: {
    sortQuestionFieldsByRenderingOrder: function sortQuestionFieldsByRenderingOrder(question) {
      question.fields.sort(function (a, b) {
        return a.renderingOrder - b.renderingOrder;
      });
      return question;
    },
    getFieldComponent: function getFieldComponent(f) {
      return this.componentsPerType[f.type];
    },
    onFieldUpdated: function onFieldUpdated(rowIndex, newFieldAnswer) {
      for (var i in this.m_answer.value.fieldsAnswers) {
        if (this.m_answer.value.fieldsAnswers[i].fieldUuid === newFieldAnswer.fieldUuid) {
          this.m_answer.value.fieldsAnswers[i] = newFieldAnswer;
          return;
        }
      }

      this.m_answer.value.fieldsAnswers.push({ fieldUuid: newFieldAnswer.fieldUuid, value: newFieldAnswer.value });
    },
    getFieldAnswer: function getFieldAnswer(field) {
      for (var i in this.m_answer.value.fieldsAnswers) {
        if (this.m_answer.value.fieldsAnswers[i].fieldUuid === field.uuid) {
          return { fieldUuid: this.m_answer.value.fieldsAnswers[i].fieldUuid, value: this.m_answer.value.fieldsAnswers[i].value };
        }
      }

      return { fieldUuid: field.uuid, value: null };
    },
    isValid: function isValid() {
      this.m_error = null;

      var areFieldAnswersBlank = true;
      for (var field in this.m_answer.value.fieldsAnswers) {
        if (this.m_answer.value.fieldsAnswers[field].value) {
          areFieldAnswersBlank = false;
        }
      }
      if (!this.question.required && areFieldAnswersBlank) {
        this.m_answer.value.fieldsAnswers = [];
        return true;
      }

      if (!this.$refs.fields) {
        return true;
      }

      var areFieldAnswersValid = true;
      this.$refs.fields.forEach(function (f) {
        if (!f.isValid()) {
          areFieldAnswersValid = false;
        }
      });

      return areFieldAnswersValid;
    }
  }
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_park_programs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ItemsQuestion__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ItemsQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ItemsQuestion__);

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IncubationProgramItemsQuestion',
  components: { ItemsQuestion: __WEBPACK_IMPORTED_MODULE_2__ItemsQuestion___default.a },
  props: ['question', 'answer', 'quizAnswers', 'isDisabled'],
  methods: {
    isValid: function isValid() {
      if (!this.parkOffersIncubation) {
        return true;
      }
      return this.$refs.child.isValid();
    },
    onAnswerUpdated: function onAnswerUpdated(answer) {
      this.$emit('answerUpdated', answer);
    }
  },
  computed: {
    parkOffersIncubation: function parkOffersIncubation() {
      return __WEBPACK_IMPORTED_MODULE_1__services_park_programs__["a" /* default */].has(__WEBPACK_IMPORTED_MODULE_1__services_park_programs__["a" /* default */].INCUBATION, this.quizAnswers);
    }
  },
  watch: {
    parkOffersIncubation: {
      immediate: true,
      handler: function handler() {
        if (!this.parkOffersIncubation) {
          this.$emit('answerUpdated', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.answer, { value: null }));
        }
      }
    }
  }
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fields_CNPJField__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fields_CNPJField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__fields_CNPJField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fields_StringField__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fields_StringField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fields_StringField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fields_YearField__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fields_YearField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fields_YearField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fields_EmailField__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fields_EmailField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fields_EmailField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fields_PhoneNumberField__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fields_PhoneNumberField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fields_PhoneNumberField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_MultipleChoiceField__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_MultipleChoiceField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__fields_MultipleChoiceField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fields_IntegerField__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fields_IntegerField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__fields_IntegerField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fields_MoneyField__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fields_MoneyField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__fields_MoneyField__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ItemsQuestion',
  props: ['question', 'answer', 'isDisabled'],
  data: function data() {
    return {
      m_question: this.question,
      m_answer: {
        questionUuid: this.question.uuid,
        value: this.answer.value ? this.answer.value : []
      },
      m_error: null,
      fieldsPerType: {
        'cnpj': __WEBPACK_IMPORTED_MODULE_0__fields_CNPJField___default.a,
        'string': __WEBPACK_IMPORTED_MODULE_1__fields_StringField___default.a,
        'year': __WEBPACK_IMPORTED_MODULE_2__fields_YearField___default.a,
        'email': __WEBPACK_IMPORTED_MODULE_3__fields_EmailField___default.a,
        'phone_number': __WEBPACK_IMPORTED_MODULE_4__fields_PhoneNumberField___default.a,
        'multiple-choice': __WEBPACK_IMPORTED_MODULE_5__fields_MultipleChoiceField___default.a,
        'integer': __WEBPACK_IMPORTED_MODULE_6__fields_IntegerField___default.a,
        'money': __WEBPACK_IMPORTED_MODULE_7__fields_MoneyField___default.a
      }
    };
  },
  mounted: function mounted() {
    this.sortItemRowsByRenderingOrder(this.question);
    this.sortQuestionFieldsByRenderingOrder(this.question);
  },

  watch: {
    'm_answer.value': {
      handler: function handler() {
        this.$emit('answerUpdated', { 'questionUuid': this.question.uuid, 'value': this.m_answer.value });
      },

      deep: true
    }
  },
  computed: {
    disabledAttribute: function disabledAttribute() {
      return this.question.disabled === true || this.isDisabled === true;
    }
  },
  methods: {
    sortItemRowsByRenderingOrder: function sortItemRowsByRenderingOrder(question) {
      question.itemsRows.sort(function (a, b) {
        return a.renderingOrder - b.renderingOrder;
      });
      return question;
    },
    sortQuestionFieldsByRenderingOrder: function sortQuestionFieldsByRenderingOrder(question) {
      question.itemsRows.forEach(function (i) {
        i.fields.sort(function (a, b) {
          return a.renderingOrder - b.renderingOrder;
        });
      });
      return question;
    },
    getFieldComponent: function getFieldComponent(f) {
      return this.fieldsPerType[f.type];
    },
    onFieldUpdated: function onFieldUpdated(itemRowUuid, newFieldAnswer) {
      // Return if already exists
      var fieldAnswer = this.findFieldAnswer(itemRowUuid, newFieldAnswer.fieldUuid);
      if (fieldAnswer) {
        this.copyFieldAnswer(newFieldAnswer, fieldAnswer);
        return;
      }

      // Check if the itemRowAnswer already exists in the answer value
      if (!this.hasItemRowAnswer(itemRowUuid)) {
        this.m_answer.value.push({ itemRowUuid: itemRowUuid, fieldsAnswers: [] });
      }

      this.findItemRowAnswer(itemRowUuid).fieldsAnswers.push(newFieldAnswer);
    },
    findFieldAnswer: function findFieldAnswer(itemRowUuid, fieldUuid) {
      for (var itemRowAnswer in this.m_answer.value) {
        if (this.m_answer.value[itemRowAnswer].itemRowUuid === itemRowUuid) {
          for (var fieldAnswer in this.m_answer.value[itemRowAnswer].fieldsAnswers) {
            if (this.m_answer.value[itemRowAnswer].fieldsAnswers[fieldAnswer] && this.m_answer.value[itemRowAnswer].fieldsAnswers[fieldAnswer].fieldUuid === fieldUuid) {
              return this.m_answer.value[itemRowAnswer].fieldsAnswers[fieldAnswer];
            }
          }
        }
      }
    },
    copyFieldAnswer: function copyFieldAnswer(fromAnswer, toAnswer) {
      toAnswer.fieldUuid = fromAnswer.fieldUuid;
      toAnswer.value = fromAnswer.value;
    },
    hasItemRowAnswer: function hasItemRowAnswer(itemRowUuid) {
      for (var itemRowAnswer in this.m_answer.value) {
        if (this.m_answer.value[itemRowAnswer].itemRowUuid === itemRowUuid) {
          return true;
        }
      }
      return false;
    },
    findItemRowAnswer: function findItemRowAnswer(itemRowUuid) {
      for (var itemRowAnswer in this.m_answer.value) {
        if (this.m_answer.value[itemRowAnswer].itemRowUuid === itemRowUuid) {
          return this.m_answer.value[itemRowAnswer];
        }
      }
    },
    getFieldAnswer: function getFieldAnswer(itemRow, field) {
      for (var itemRowAnswer in this.m_answer.value) {
        if (this.m_answer.value[itemRowAnswer].itemRowUuid === itemRow.itemRowUuid) {
          for (var fieldAnswer in this.m_answer.value[itemRowAnswer].fieldsAnswers) {
            if (this.m_answer.value[itemRowAnswer].fieldsAnswers[fieldAnswer].fieldUuid === field.uuid) {
              return { 'rowIndex': itemRow.itemRowUuid, 'value': this.m_answer.value[itemRowAnswer].fieldsAnswers[fieldAnswer].value };
            }
          }
        }
      }

      return { 'rowIndex': itemRow.itemRowUuid, 'value': null };
    },
    isValid: function isValid() {
      var areFieldAnswersBlank = true;
      for (var itemRowAnswer in this.m_answer.value) {
        for (var fieldAnswer in this.m_answer.value[itemRowAnswer].fieldsAnswers) {
          if (this.m_answer.value[itemRowAnswer].fieldsAnswers[fieldAnswer].value) {
            areFieldAnswersBlank = false;
          }
        }
      }

      if (!this.question.required && areFieldAnswersBlank) {
        this.rows = [];
        return true;
      }

      var areFieldAnswersValid = true;
      this.$refs.fields.forEach(function (f) {
        if (!f.isValid()) {
          areFieldAnswersValid = false;
        }
      });

      return areFieldAnswersValid;
    }
  }
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['question', 'answer', 'isDisabled'],
  name: 'MultipleChoiceQuestion',
  data: function data() {
    return {
      m_question: this.question,
      m_answer: {
        questionUuid: this.question.uuid,
        value: this.answer && this.answer.value !== null ? this.answer.value : []
      },
      m_error: null
    };
  },

  watch: {
    'm_answer.value': function m_answerValue() {
      this.$emit('answerUpdated', this.m_answer);
    }
  },
  computed: {
    disabledAttribute: function disabledAttribute() {
      return this.question.disabled === true || this.isDisabled === true;
    }
  },
  methods: {
    getAnswerValueForSelect: function getAnswerValueForSelect() {
      return this.m_answer.value ? this.m_answer.value[0] : null;
    },
    onChange: function onChange(data) {
      this.m_answer.value = [data.target.value];
    },
    isValid: function isValid() {
      if (this.question.required && !this.m_answer.value.length) {
        this.m_error = 'Esta questão é de preenchimento obrigatório.';
        return false;
      }
      this.m_error = null;
      return true;
    }
  }
});

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_park_programs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ItemsQuestion__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ItemsQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ItemsQuestion__);

//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OwnRevenuesQuestion',
  components: { ItemsQuestion: __WEBPACK_IMPORTED_MODULE_3__ItemsQuestion___default.a },
  props: ['question', 'answer', 'quizAnswers', 'isDisabled'],
  data: function data() {
    return {
      dependenciesByItemRowUuid: {
        '633a8b2d-ca75-4ce1-a52d-7471f0ad59c0': __WEBPACK_IMPORTED_MODULE_2__services_park_programs__["a" /* default */].ACCELERATION,
        '34f8cee1-b731-4c54-84e5-a792c49d71c8': __WEBPACK_IMPORTED_MODULE_2__services_park_programs__["a" /* default */].ASSOCIATION,
        '5c7c7940-fedd-474c-9f08-a59fc87b7d06': __WEBPACK_IMPORTED_MODULE_2__services_park_programs__["a" /* default */].COWORKING,
        '577c92c3-da33-4f47-9961-b6cefdf07e5d': __WEBPACK_IMPORTED_MODULE_2__services_park_programs__["a" /* default */].INCUBATION,
        '010bdcd0-c214-45a8-a6aa-30a91080b238': __WEBPACK_IMPORTED_MODULE_2__services_park_programs__["a" /* default */].RESIDENCY
      },
      childKey: Math.floor(Math.random() * 999)
    };
  },

  computed: {
    questionWithFilteredItemRows: function questionWithFilteredItemRows() {
      var _this = this;

      var questionWithFilteredItemRows = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["cloneDeep"])(this.question);

      questionWithFilteredItemRows.itemsRows = questionWithFilteredItemRows.itemsRows.filter(function (itemRow) {
        var itemRowUuid = itemRow.itemRowUuid;

        return !_this.dependenciesByItemRowUuid.hasOwnProperty(itemRowUuid) || __WEBPACK_IMPORTED_MODULE_2__services_park_programs__["a" /* default */].has(_this.dependenciesByItemRowUuid[itemRowUuid], _this.quizAnswers);
      });

      return this.sortItemRowsByRenderingOrder(questionWithFilteredItemRows);
    }
  },
  methods: {
    onAnswerUpdated: function onAnswerUpdated(answer) {
      this.$emit('answerUpdated', answer);
    },
    sortItemRowsByRenderingOrder: function sortItemRowsByRenderingOrder(question) {
      question.itemsRows.sort(function (a, b) {
        return a.renderingOrder - b.renderingOrder;
      });
      return question;
    },
    isValid: function isValid() {
      return this.$refs.child.isValid();
    },
    updateAnswerWhenParkProgramsChange: function updateAnswerWhenParkProgramsChange() {
      if (!this.answer || !this.answer.value) {
        return;
      }

      var updatedAnswer = this.answerHavingOnlyItemRowsAvailableToAnswer(this.answer, this.questionWithFilteredItemRows.itemsRows);
      this.$emit('answerUpdated', updatedAnswer);
    },
    answerHavingOnlyItemRowsAvailableToAnswer: function answerHavingOnlyItemRowsAvailableToAnswer(answer, availableItemsRows) {
      var filteredAnswerValue = answer.value.filter(function (answerItemRow) {
        return availableItemsRows.find(function (itemRow) {
          return itemRow.itemRowUuid === answerItemRow.itemRowUuid;
        });
      });

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, answer, { value: filteredAnswerValue });
    },
    forceChildRerender: function forceChildRerender() {
      this.childKey += 1;
    }
  },
  watch: {
    questionWithFilteredItemRows: {
      immediate: true,
      handler: function handler() {
        this.updateAnswerWhenParkProgramsChange();
        this.forceChildRerender();
      }
    }
  }
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_park_programs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ItemsQuestion__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ItemsQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ItemsQuestion__);

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PreIncubationProgramItemsQuestion',
  components: { ItemsQuestion: __WEBPACK_IMPORTED_MODULE_2__ItemsQuestion___default.a },
  props: ['question', 'answer', 'quizAnswers', 'isDisabled'],
  methods: {
    isValid: function isValid() {
      if (!this.parkOffersPreIncubation) {
        return true;
      }
      return this.$refs.child.isValid();
    },
    onAnswerUpdated: function onAnswerUpdated(answer) {
      this.$emit('answerUpdated', answer);
    }
  },
  computed: {
    parkOffersPreIncubation: function parkOffersPreIncubation() {
      return __WEBPACK_IMPORTED_MODULE_1__services_park_programs__["a" /* default */].has(__WEBPACK_IMPORTED_MODULE_1__services_park_programs__["a" /* default */].PRE_INCUBATION, this.quizAnswers);
    }
  },
  watch: {
    parkOffersPreIncubation: {
      immediate: true,
      handler: function handler() {
        if (!this.parkOffersPreIncubation) {
          this.$emit('answerUpdated', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.answer, { value: null }));
        }
      }
    }
  }
});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_park_programs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ItemsQuestion__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ItemsQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ItemsQuestion__);

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ResidencyProgramItemsQuestion',
  components: { ItemsQuestion: __WEBPACK_IMPORTED_MODULE_2__ItemsQuestion___default.a },
  props: ['question', 'answer', 'quizAnswers', 'isDisabled'],
  methods: {
    isValid: function isValid() {
      if (!this.parkOffersResidency) {
        return true;
      }
      return this.$refs.child.isValid();
    },
    onAnswerUpdated: function onAnswerUpdated(answer) {
      this.$emit('answerUpdated', answer);
    }
  },
  computed: {
    parkOffersResidency: function parkOffersResidency() {
      return __WEBPACK_IMPORTED_MODULE_1__services_park_programs__["a" /* default */].has(__WEBPACK_IMPORTED_MODULE_1__services_park_programs__["a" /* default */].RESIDENCY, this.quizAnswers);
    }
  },
  watch: {
    parkOffersResidency: {
      immediate: true,
      handler: function handler() {
        if (!this.parkOffersResidency) {
          this.$emit('answerUpdated', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.answer, { value: null }));
        }
      }
    }
  }
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_the_mask__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_the_mask__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['field', 'fieldAnswer', 'isDisabled'],
  name: 'CNPJField',
  components: { TheMask: __WEBPACK_IMPORTED_MODULE_0_vue_the_mask___default.a },
  data: function data() {
    return {
      m_fieldAnswer: {
        fieldUuid: this.field.uuid,
        value: this.fieldAnswer.value
      },
      m_error: null,
      m_rowIndex: this.fieldAnswer.rowIndex
    };
  },

  watch: {
    'm_fieldAnswer.value': function m_fieldAnswerValue() {
      this.$emit('fieldUpdated', this.m_rowIndex, this.m_fieldAnswer);
    }
  },
  computed: {
    disabledAttribute: function disabledAttribute() {
      return this.field.disabled === true || this.isDisabled === true;
    }
  },
  methods: {
    isValid: function isValid() {
      if (this.field.required && !this.m_fieldAnswer.value || this.m_fieldAnswer.value && !this.validateCNPJ(this.m_fieldAnswer.value)) {
        this.m_error = true;
        return false;
      }

      this.m_error = null;
      return true;
    },
    validateCNPJ: function validateCNPJ(value) {
      value = value.replace(/[^\d]+/g, '');

      if (value.length !== 14) {
        return false;
      }

      // Elimina CNPJs invalidos conhecidos
      if (value === '00000000000000' || value === '11111111111111' || value === '22222222222222' || value === '33333333333333' || value === '44444444444444' || value === '55555555555555' || value === '66666666666666' || value === '77777777777777' || value === '88888888888888' || value === '99999999999999') {
        return false;
      }

      // Valida DVs
      var tamanho = value.length - 2;
      var numeros = value.substring(0, tamanho);
      var digitos = value.substring(tamanho);
      var soma = 0;
      var pos = tamanho - 7;
      for (var i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) {
          pos = 9;
        }
      }
      var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (parseFloat(resultado) !== parseFloat(digitos.charAt(0))) {
        return false;
      }

      tamanho = tamanho + 1;
      numeros = value.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (var _i = tamanho; _i >= 1; _i--) {
        soma += numeros.charAt(tamanho - _i) * pos--;
        if (pos < 2) {
          pos = 9;
        }
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (parseFloat(resultado) !== parseFloat(digitos.charAt(1))) {
        return false;
      }
      return true;
    }
  }
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_the_mask__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_the_mask__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['field', 'fieldAnswer', 'isDisabled'],
  name: 'CPFField',
  components: { TheMask: __WEBPACK_IMPORTED_MODULE_0_vue_the_mask___default.a },
  data: function data() {
    return {
      m_fieldAnswer: {
        fieldUuid: this.field.uuid,
        value: this.fieldAnswer.value
      },
      m_error: null,
      m_rowIndex: this.fieldAnswer.rowIndex
    };
  },

  computed: {
    disabledAttribute: function disabledAttribute() {
      return this.field.disabled === true || this.isDisabled === true;
    }
  },
  watch: {
    'm_fieldAnswer.value': function m_fieldAnswerValue() {
      this.$emit('fieldUpdated', this.m_rowIndex, this.m_fieldAnswer);
    }
  },
  methods: {
    isValid: function isValid() {
      if (this.field.required && !this.m_fieldAnswer.value || this.m_fieldAnswer.value && !this.validateCPF(this.m_fieldAnswer.value)) {
        this.m_error = true;
        return false;
      }

      this.m_error = null;
      return true;
    },
    validateCPF: function validateCPF(value) {
      value = value.replace(/[^\d]+/g, '');

      if (value.length !== 11) {
        return false;
      }

      // Elimina CPFs invalidos conhecidos
      if (value === '00000000000' || value === '11111111111' || value === '22222222222' || value === '33333333333' || value === '44444444444' || value === '55555555555' || value === '66666666666' || value === '77777777777' || value === '88888888888' || value === '99999999999') {
        return false;
      }

      // Valida DVs
      var tamanho = value.length - 2;
      var numeros = value.substring(0, tamanho);
      var digitos = value.substring(tamanho);
      var soma = 0;

      for (var i = 10; i > 1; i--) {
        soma += numeros.charAt(10 - i) * i;
      }
      var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (parseFloat(resultado) !== parseFloat(digitos.charAt(0))) {
        return false;
      }

      numeros = value.substring(0, tamanho + 1);
      soma = 0;
      for (var _i = 11; _i > 1; _i--) {
        soma += numeros.charAt(11 - _i) * _i;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (parseFloat(resultado) !== parseFloat(digitos.charAt(1))) {
        return false;
      }

      return true;
    }
  }
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['field', 'fieldAnswer', 'isDisabled'],
  name: 'EmailField',
  data: function data() {
    return {
      m_fieldAnswer: {
        fieldUuid: this.field.uuid,
        value: this.fieldAnswer.value
      },
      m_error: null,
      m_rowIndex: this.fieldAnswer.rowIndex
    };
  },

  watch: {
    'm_fieldAnswer.value': function m_fieldAnswerValue() {
      this.$emit('fieldUpdated', this.m_rowIndex, this.m_fieldAnswer);
    }
  },
  computed: {
    disabledAttribute: function disabledAttribute() {
      return this.field.disabled === true || this.isDisabled === true;
    }
  },
  methods: {
    isValid: function isValid() {
      if (this.field.required && !this.m_fieldAnswer.value || this.m_fieldAnswer.value && !this.isEmailValid()) {
        this.m_error = true;
        return false;
      }

      this.m_error = null;
      return true;
    },
    isEmailValid: function isEmailValid() {
      var filter = /^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
      return filter.test(this.m_fieldAnswer.value);
    }
  }
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['field', 'fieldAnswer', 'isDisabled'],
  name: 'IntegerField',
  data: function data() {
    return {
      m_fieldAnswer: {
        fieldUuid: this.field.uuid,
        value: this.fieldAnswer.value
      },
      m_error: null,
      m_rowIndex: this.fieldAnswer.rowIndex
    };
  },

  computed: {
    disabledAttribute: function disabledAttribute() {
      return this.field.disabled === true || this.isDisabled === true;
    }
  },
  watch: {
    'm_fieldAnswer.value': function m_fieldAnswerValue() {
      this.$emit('fieldUpdated', this.m_rowIndex, { fieldUuid: this.m_fieldAnswer.fieldUuid, value: parseInt(this.m_fieldAnswer.value) });
    }
  },
  methods: {
    isNumber: function isNumber(evt) {
      evt = !evt ? window.event : evt;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
        return false;
      }
      return true;
    },
    isValid: function isValid() {
      if (this.field.required && !this.m_fieldAnswer.value && this.m_fieldAnswer.value !== 0) {
        this.m_error = true;
        return false;
      }
      if (this.m_fieldAnswer.value && (!/^\d+$/.test(this.m_fieldAnswer.value) || this.m_fieldAnswer.value.toString().length > 19)) {
        this.m_error = true;
        return false;
      }

      this.m_error = null;
      return true;
    }
  }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_autonumeric__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_autonumeric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_autonumeric__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { VueAutonumeric: __WEBPACK_IMPORTED_MODULE_0_vue_autonumeric___default.a },
  props: ['field', 'fieldAnswer', 'isDisabled'],
  name: 'EmailField',
  data: function data() {
    return {
      m_fieldAnswer: {
        fieldUuid: this.field.uuid,
        value: this.fieldAnswer.value
      },
      m_error: null,
      m_rowIndex: this.fieldAnswer.rowIndex
    };
  },

  computed: {
    disabledAttribute: function disabledAttribute() {
      return this.field.disabled === true || this.isDisabled === true;
    }
  },
  watch: {
    'm_fieldAnswer.value': function m_fieldAnswerValue() {
      this.$emit('fieldUpdated', this.m_rowIndex, this.m_fieldAnswer);
    }
  },
  methods: {
    isValid: function isValid() {
      if (this.field.required && !this.m_fieldAnswer.value && this.m_fieldAnswer.value !== 0) {
        this.m_error = true;
        return false;
      }

      this.m_error = null;
      return true;
    }
  }
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['field', 'fieldAnswer', 'isDisabled'],
  name: 'MultipleChoiceField',
  data: function data() {
    return {
      m_fieldAnswer: {
        fieldUuid: this.field.uuid,
        value: this.fieldAnswer && this.fieldAnswer.value !== null ? this.fieldAnswer.value : []
      },
      m_error: null,
      m_rowIndex: this.fieldAnswer.rowIndex
    };
  },

  computed: {
    disabledAttribute: function disabledAttribute() {
      return this.field.disabled === true || this.isDisabled === true;
    }
  },
  watch: {
    'm_fieldAnswer.value': function m_fieldAnswerValue() {
      this.$emit('fieldUpdated', this.m_rowIndex, this.m_fieldAnswer);
    }
  },
  methods: {
    getAnswerValueForSelect: function getAnswerValueForSelect() {
      return this.m_fieldAnswer.value ? this.m_fieldAnswer.value[0] : null;
    },
    onChange: function onChange(data) {
      this.m_fieldAnswer.value = [data.target.value];
    },
    isValid: function isValid() {
      if (this.field.required && !this.m_fieldAnswer.value.length) {
        this.m_error = true;
        return false;
      }
      this.m_error = null;
      return true;
    }
  }
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_the_mask__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_the_mask__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['field', 'fieldAnswer', 'isDisabled'],
  name: 'PhoneNumberField',
  components: { TheMask: __WEBPACK_IMPORTED_MODULE_0_vue_the_mask___default.a },
  data: function data() {
    return {
      m_fieldAnswer: {
        fieldUuid: this.field.uuid,
        value: this.fieldAnswer.value
      },
      m_error: null,
      m_rowIndex: this.fieldAnswer.rowIndex
    };
  },

  computed: {
    disabledAttribute: function disabledAttribute() {
      return this.field.disabled === true || this.isDisabled === true;
    }
  },
  watch: {
    'm_fieldAnswer.value': function m_fieldAnswerValue() {
      this.$emit('fieldUpdated', this.m_rowIndex, this.m_fieldAnswer);
    }
  },
  methods: {
    isValid: function isValid() {
      if (this.field.required && !this.m_fieldAnswer.value) {
        this.m_error = true;
        return false;
      }
      this.m_error = null;
      return true;
    }
  }
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['field', 'fieldAnswer', 'isDisabled'],
  name: 'StringField',
  data: function data() {
    return {
      m_fieldAnswer: {
        fieldUuid: this.field.uuid,
        value: this.fieldAnswer.value
      },
      m_error: null,
      m_rowIndex: this.fieldAnswer.rowIndex
    };
  },

  computed: {
    disabledAttribute: function disabledAttribute() {
      return this.field.disabled === true || this.isDisabled === true;
    }
  },
  watch: {
    'm_fieldAnswer.value': function m_fieldAnswerValue() {
      this.$emit('fieldUpdated', this.m_rowIndex, this.m_fieldAnswer);
    }
  },
  methods: {
    isValid: function isValid() {
      if (this.field.required && !this.m_fieldAnswer.value) {
        this.m_error = true;
        return false;
      }
      this.m_error = null;
      return true;
    }
  }
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['field', 'fieldAnswer', 'isDisabled'],
  name: 'YearField',
  data: function data() {
    return {
      m_fieldAnswer: {
        fieldUuid: this.field.uuid,
        value: parseInt(this.fieldAnswer.value)
      },
      m_error: null,
      m_rowIndex: this.fieldAnswer.rowIndex
    };
  },

  computed: {
    disabledAttribute: function disabledAttribute() {
      return this.field.disabled === true || this.isDisabled === true;
    }
  },
  watch: {
    'm_fieldAnswer.value': function m_fieldAnswerValue() {
      this.$emit('fieldUpdated', this.m_rowIndex, this.m_fieldAnswer);
    }
  },
  methods: {
    getYearsRange: function getYearsRange() {
      var currentYear = new Date().getFullYear();
      var startYear = 1985;
      var years = [];
      while (currentYear >= startYear) {
        years.push(currentYear--);
      }

      return years;
    },
    isValid: function isValid() {
      if (this.field.required && !this.m_fieldAnswer.value) {
        this.m_error = true;
        return false;
      }
      this.m_error = null;
      return true;
    }
  }
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_resource_client_park__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_resource_client_report__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_report_formatter__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_authentication__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_TableReport__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_TableReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_elements_TableReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_ListReport__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_ListReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_elements_ListReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_elements_charts_BarChart__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_elements_charts_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_elements_charts_BarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_elements_charts_DoughnutChart__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_elements_charts_DoughnutChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_elements_charts_DoughnutChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_elements_charts_HorizontalBarChart__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_elements_charts_HorizontalBarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_elements_charts_HorizontalBarChart__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'QuizReports',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_1__components_template_Adminlte___default.a, TableReport: __WEBPACK_IMPORTED_MODULE_6__components_elements_TableReport___default.a, BarChart: __WEBPACK_IMPORTED_MODULE_8__components_elements_charts_BarChart___default.a, DoughnutChart: __WEBPACK_IMPORTED_MODULE_9__components_elements_charts_DoughnutChart___default.a, HorizontalBarChart: __WEBPACK_IMPORTED_MODULE_10__components_elements_charts_HorizontalBarChart___default.a },
  data: function data() {
    return {
      isRenderingReports: false,
      year: null,
      componentsPerType: {
        'table': __WEBPACK_IMPORTED_MODULE_6__components_elements_TableReport___default.a,
        'list': __WEBPACK_IMPORTED_MODULE_7__components_elements_ListReport___default.a,
        'bar': __WEBPACK_IMPORTED_MODULE_8__components_elements_charts_BarChart___default.a,
        'doughnut': __WEBPACK_IMPORTED_MODULE_9__components_elements_charts_DoughnutChart___default.a,
        'horizontalBar': __WEBPACK_IMPORTED_MODULE_10__components_elements_charts_HorizontalBarChart___default.a
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      },
      parksWithApprovedParkQuizPerYear: {},
      respondents: [],
      axes: [{ key: 'management', description: 'Gestão', isSelected: false }, { key: 'services', description: 'Serviços', isSelected: false }, { key: 'infrastructure', description: 'Infraestrutura', isSelected: false }, { key: 'team', description: 'Equipe', isSelected: false }, { key: 'partners', description: 'Parceiros', isSelected: false }, { key: 'indicators', description: 'Indicadores', isSelected: false }, { key: 'evaluation', description: 'Avaliação', isSelected: false }],
      reports: [{ id: 1, title: 'Receitas próprias do parque tecnológico', uri: 'reports/park-own-revenues-in-year', data: {}, axis: 'indicators', type: 'table', isSelected: false }, { id: 2, title: 'Custos e despesas do parque tecnológico', uri: 'reports/park-costs-in-year', data: {}, axis: 'indicators', type: 'table', isSelected: false }, { id: 3, title: 'Investimentos do parque tecnológico', uri: 'reports/park-investments-in-year-compared-to-previous-years', data: {}, axis: 'indicators', type: 'table', isSelected: false }, { id: 4, title: 'Recursos captados para o parque tecnológico', uri: 'reports/park-investments-by-source-in-year', data: {}, axis: 'indicators', type: 'table', isSelected: false }, { id: 5, title: 'Recursos de projetos de subvenção obtidos pelo parque tecnológico', uri: 'reports/park-resources-by-institution-in-year', data: {}, axis: 'indicators', type: 'table', isSelected: false }, { id: 6, title: 'Necessidades futuras para investimento do parque tecnológico', uri: 'reports/park-future-needs-for-investments-in-year', data: {}, axis: 'indicators', type: 'table', isSelected: false }, { id: 7, title: 'Indicadores do parque tecnológico', uri: 'reports/park-indicators-in-year', data: {}, axis: 'indicators', type: 'table', isSelected: false }, { id: 8, title: 'Indicadores de inovação', uri: 'reports/park-innovations-in-year', data: {}, axis: 'indicators', type: 'table', isSelected: false }, { id: 9, title: 'Áreas de atuação das empresas âncora', uri: 'reports/park-anchor-companies-focus-action-in-year', data: {}, axis: 'indicators', type: 'table', isSelected: false }, { id: 10, title: 'Como o parque tecnológico busca a sustentabilidade financeira', uri: 'reports/how-park-seeks-financial-sustainability-in-year', data: {}, axis: 'indicators', type: 'bar', isSelected: false }, { id: 11, title: 'Indicadores de empresas âncoras', uri: 'reports/anchor-companies-indicators-in-year', data: {}, axis: 'indicators', type: 'table', isSelected: false }, { id: 12, title: 'Indicadores financeiros das empresas vinculadas ao parque tecnológico - Valor Total', uri: 'reports/linked-companies-financial-indicators-in-year', data: {}, axis: 'indicators', type: 'table', isSelected: false }, { id: 13, title: 'O parque tecnológico possui planejamento estratégico', uri: 'reports/park-has-strategic-planning-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false }, { id: 14, title: 'O parque tecnológico realiza auditorias', uri: 'reports/park-offers-auditing-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false }, { id: 15, title: 'Compõem a estrutura organizacional do parque tecnológico', uri: 'reports/park-organizational-structure-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false }, { id: 16, title: 'Instituições que compõem o(s) conselho(s) do parque tecnológico', uri: 'reports/park-council-institutions-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false }, { id: 17, title: 'O parque tecnológico está associado formalmente a quais instituições', uri: 'reports/park-related-institutions-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false }, { id: 18, title: 'O parque tecnológico possui alguma certificação', uri: 'reports/park-has-certifications-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false }, { id: 19, title: 'O parque tecnológico possui interação com algum programa de incubação e/ou aceleração de empresas', uri: 'reports/incubation-acceleration-programs-interaction-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false }, { id: 20, title: 'O parque tecnológico possui processo de seleção de empresas e empreendimentos', uri: 'reports/park-has-selection-process-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false }, { id: 21, title: 'Critérios utilizados no processo de seleção de empresas', uri: 'reports/park-selection-process-criteria-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false }, { id: 22, title: 'Quem são os responsáveis por avaliar as empresas durante o processo de seleção', uri: 'reports/park-selection-process-responsible-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false }, { id: 23, title: 'Quanto tempo leva, em média, o processo de seleção de empresas', uri: 'reports/park-selection-process-duration-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false }, { id: 24, title: 'Itens de dificuldade financeira para o parque tecnológico', uri: 'reports/park-financial-difficulties-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false }, { id: 25, title: 'Políticas públicas do país que podem melhorar a atuação de empresas instaladas em parques tecnológicos', uri: 'reports/public-politics-improvements-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false }, { id: 26, title: 'Mudanças de políticas públicas necessárias para melhorar a atuação dos parques tecnológicos', uri: 'reports/public-politics-needed-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false }, { id: 27, title: 'Programas oferecidos pelo parque tecnológico', uri: 'reports/programs-offered-in-year', data: {}, axis: 'services', type: 'bar', isSelected: false }, { id: 28, title: 'Características dos programas oferecidos pelo parque tecnológico', uri: 'reports/features-offered-programs-in-year', data: {}, axis: 'services', type: 'table', isSelected: false }, { id: 29, title: 'Quais cursos o parque tecnológico oferece aos empresários', uri: 'reports/courses-offered-in-year', data: {}, axis: 'services', type: 'bar', isSelected: false }, { id: 30, title: 'Dificuldades enfrentadas pelo parque tecnológico para o oferecimento de cursos aos empresários', uri: 'reports/courses-offering-difficulties-in-year', data: {}, axis: 'services', type: 'bar', isSelected: false }, { id: 31, title: 'O parque tecnológico possui um processo sistematizado para acompanhar o desenvolvimento das empresas', uri: 'reports/park-has-process-monitor-development-companies-in-year', data: {}, axis: 'services', type: 'bar', isSelected: false }, { id: 32, title: 'Indicadores utilizados pelo parque para acompanhar o desenvolvimento de suas empresas residentes', uri: 'reports/company-development-indicators-in-year', data: {}, axis: 'services', type: 'bar', isSelected: false }, { id: 33, title: 'Quais incentivos fiscais, creditícios e/ou subsídios, são oferecidos às empresas residentes', uri: 'reports/incentives-offered-resident-companies-in-year', data: {}, axis: 'services', type: 'bar', isSelected: false }, { id: 34, title: 'Motivos de desistência e/ou desligamento das empresas do parque tecnológico', uri: 'reports/companies-abandonment-reasons-in-year', data: {}, axis: 'services', type: 'bar', isSelected: false }, { id: 35, title: 'Por meio de quais atividades o parque tecnológico se relaciona com as empresas residentes', uri: 'reports/activities-park-relate-companies-in-year', data: {}, axis: 'services', type: 'bar', isSelected: false }, { id: 36, title: 'Quais serviços são oferecidos pelo parque tecnológico', uri: 'reports/services-offered-by-park-in-year', data: {}, axis: 'services', type: 'bar', isSelected: false }, { id: 37, title: 'Áreas do terreno e lotes do parque tecnológico (m²)', uri: 'reports/park-land-areas-occupied-in-year', data: {}, axis: 'infrastructure', type: 'table', isSelected: false }, { id: 38, title: 'Áreas de prédios e edificações do parque tecnológico (m²)', uri: 'reports/park-edification-areas-occupied-in-year', data: {}, axis: 'infrastructure', type: 'table', isSelected: false }, { id: 39, title: 'Infraestrutura, recursos e equipamentos disponíveis para as empresas', uri: 'reports/resources-available-for-companies-in-year', data: {}, axis: 'infrastructure', type: 'bar', isSelected: false }, { id: 40, title: 'Distribuição de gênero da equipe do parque', uri: 'reports/park-team-gender-distribution-in-year', data: {}, axis: 'team', type: 'bar', isSelected: false }, { id: 41, title: 'Idade média da equipe do parque', uri: 'reports/park-team-average-age-in-year', data: {}, axis: 'team', type: 'list', isSelected: false }, { id: 42, title: 'Distribuição de escolaridade da equipe do parque', uri: 'reports/park-team-schooling-distribution-in-year', data: {}, axis: 'team', type: 'bar', isSelected: false }, { id: 43, title: 'Dificuldades enfrentadas pelo parque tecnológico na contratação de mão de obra qualificada', uri: 'reports/park-hiring-difficulties-in-year', data: {}, axis: 'team', type: 'bar', isSelected: false }, { id: 44, title: 'Problemas enfrentados pelo parque tecnológico com relação à sua equipe interna', uri: 'reports/park-team-issues-in-year', data: {}, axis: 'team', type: 'bar', isSelected: false }, { id: 45, title: 'Em quais áreas o parque tecnológico contrata seus profissionais', uri: 'reports/park-hiring-areas-in-year', data: {}, axis: 'team', type: 'bar', isSelected: false }, { id: 46, title: 'Percentual de funcionários por nível de escolaridade', uri: 'reports/team-education-in-year', data: {}, axis: 'team', type: 'doughnut', isSelected: false }, { id: 47, title: 'Área de formação dos membros da equipe', uri: 'reports/team-formation-area-in-year', data: {}, axis: 'team', type: 'horizontalBar', isSelected: false }, { id: 48, title: 'Quantidade de membros por tipo de vínculo', uri: 'reports/team-bond-in-year', data: {}, axis: 'team', type: 'bar', isSelected: false }, { id: 49, title: 'Quantidade de membros por função', uri: 'reports/team-function-in-year', data: {}, axis: 'team', type: 'bar', isSelected: false }, { id: 50, title: 'Atores com os quais o parque tecnológico possui parceria', uri: 'reports/park-has-partnership-with-actors-in-year', data: {}, axis: 'partners', type: 'bar', isSelected: false }, { id: 51, title: 'Com quais órgãos e/ou instituições o parque tecnológico possui parcerias internacionais formalizadas', uri: 'reports/park-formalized-international-partnerships-in-year', data: {}, axis: 'partners', type: 'bar', isSelected: false }, { id: 52, title: 'Parcerias que são fundamentais para o fortalecimento do parque tecnológico', uri: 'reports/park-key-partnerships-in-year', data: {}, axis: 'partners', type: 'bar', isSelected: false }, { id: 53, title: 'Quais atividades o parque tecnológico realiza para promoção de networking', uri: 'reports/park-activities-promote-networking-in-year', data: {}, axis: 'partners', type: 'bar', isSelected: false }, { id: 54, title: 'Condições necessárias para o sucesso dos parques tecnológicos', uri: 'reports/park-success-necessary-conditions-in-year', data: {}, axis: 'evaluation', type: 'bar', isSelected: false }, { id: 55, title: 'Itens associados à proposta de valor do parque tecnológico para as empresas residentes', uri: 'reports/park-value-offer-in-year', data: {}, axis: 'evaluation', type: 'bar', isSelected: false }, { id: 56, title: 'Recursos que são oferecidos pelo parque tecnológico para atender às demandas tecnológicas das empresas residentes', uri: 'reports/park-resources-offered-in-year', data: {}, axis: 'evaluation', type: 'bar', isSelected: false }, { id: 57, title: 'Impactos gerados pelo parque tecnológico para a comunidade local', uri: 'reports/park-impacts-generated-in-year', data: {}, axis: 'evaluation', type: 'bar', isSelected: false }]
    };
  },
  mounted: function mounted() {
    this.getParksWithApprovedParkQuizPerYear();
  },

  methods: {
    getParksWithApprovedParkQuizPerYear: function getParksWithApprovedParkQuizPerYear() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__services_resource_client_park__["a" /* default */].withApprovedParkQuizPerYear().then(function (response) {
        _this.parksWithApprovedParkQuizPerYear = response.data;
      });
    },
    selectAll: function selectAll(list) {
      list.forEach(function (el) {
        el.isSelected = true;
      });
    },
    clearSelected: function clearSelected(list) {
      list.forEach(function (el) {
        el.isSelected = false;
      });
    },
    selectCurrentAuthenticatedParkAsRespondent: function selectCurrentAuthenticatedParkAsRespondent() {
      this.clearSelected(this.respondents);
      if (this.currentAuthenticatedParkIndexAtRespondentsList < 0) {
        return;
      }
      this.respondents[this.currentAuthenticatedParkIndexAtRespondentsList].isSelected = true;
    },
    renderReports: function renderReports() {
      var _this2 = this;

      if (this.selectedRespondents.length === 0) return;
      this.isRenderingReports = true;
      this.selectedReports.forEach(function (r) {
        return _this2.renderReport(r.id);
      });
    },
    renderReport: function renderReport(id) {
      var report = this.reports.find(function (r) {
        return r.id === id;
      });
      var respondentsIds = this.selectedRespondents.map(function (el) {
        return el.id;
      });
      __WEBPACK_IMPORTED_MODULE_3__services_resource_client_report__["a" /* default */].getInYearForRespondents(report.uri, this.year, respondentsIds).then(function (response) {
        switch (report.type) {
          case 'bar':
            report.data = __WEBPACK_IMPORTED_MODULE_4__services_report_formatter__["a" /* default */].chart(response.data, report.title);
            break;
          case 'doughnut':
            report.data = __WEBPACK_IMPORTED_MODULE_4__services_report_formatter__["a" /* default */].doughnutChart(response.data, report.title);
            break;
          case 'horizontalBar':
            report.data = __WEBPACK_IMPORTED_MODULE_4__services_report_formatter__["a" /* default */].horizontalBarChart(response.data, report.title);
            break;
          default:
            report.data = __WEBPACK_IMPORTED_MODULE_4__services_report_formatter__["a" /* default */].textual(response.data, report.title);
        }
        report.isSelected = true;
      });
    },
    getReportComponent: function getReportComponent(r) {
      return this.componentsPerType[r.type];
    }
  },
  computed: {
    getAvailableYears: function getAvailableYears() {
      var availableYears = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.parksWithApprovedParkQuizPerYear);
      availableYears.sort().reverse();
      return availableYears;
    },
    availableReports: function availableReports() {
      var selectedAxes = this.axes.filter(function (a) {
        return a.isSelected;
      }).map(function (a) {
        return a.key;
      });
      return this.reports.filter(function (r) {
        return selectedAxes.includes(r.axis);
      });
    },
    selectedReports: function selectedReports() {
      return this.availableReports.filter(function (r) {
        return r.isSelected;
      });
    },
    selectedRespondents: function selectedRespondents() {
      return this.respondents.filter(function (r) {
        return r.isSelected;
      });
    },
    userHasAdminRole: function userHasAdminRole() {
      return __WEBPACK_IMPORTED_MODULE_5__services_authentication__["a" /* default */].userHasAdminRole();
    },
    userHasParkRole: function userHasParkRole() {
      return __WEBPACK_IMPORTED_MODULE_5__services_authentication__["a" /* default */].userHasParkRole();
    },
    userHasPartnerRole: function userHasPartnerRole() {
      return __WEBPACK_IMPORTED_MODULE_5__services_authentication__["a" /* default */].userHasPartnerRole();
    },
    currentAuthenticatedParkIndexAtRespondentsList: function currentAuthenticatedParkIndexAtRespondentsList() {
      return this.respondents.findIndex(function (r) {
        return r.id === __WEBPACK_IMPORTED_MODULE_5__services_authentication__["a" /* default */].getParkId();
      });
    },
    isAllRespondentsSelected: function isAllRespondentsSelected() {
      return this.respondents.every(function (r) {
        return r.isSelected;
      });
    },
    isCurrentAuthenticatedParkSelected: function isCurrentAuthenticatedParkSelected() {
      if (this.currentAuthenticatedParkIndexAtRespondentsList < 0) {
        return false;
      }
      return this.respondents[this.currentAuthenticatedParkIndexAtRespondentsList].isSelected;
    }
  },
  watch: {
    year: function year(newYear, oldYear) {
      var _this3 = this;

      this.respondents = [];
      var parksWithApprovedParkQuizAtSelectedYear = this.parksWithApprovedParkQuizPerYear[newYear];
      parksWithApprovedParkQuizAtSelectedYear.forEach(function (park) {
        _this3.respondents.push({ 'id': park.id, 'name': park.name, 'isSelected': false });
      });
    }
  }
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_relatorio_estatistico_IndicatorResult__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_relatorio_estatistico_IndicatorResult___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_elements_relatorio_estatistico_IndicatorResult__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_resource_client_relatorio_estatistico__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_report_period__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_file_saver__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RelatorioEstatistico',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default.a, IndicatorResult: __WEBPACK_IMPORTED_MODULE_1__components_elements_relatorio_estatistico_IndicatorResult___default.a },
  data: function data() {
    var currentYear = new Date().getFullYear();
    return {
      year: currentYear - 1,
      compareYear: '',
      loading: false,
      downloading: null,
      errorMessage: null,
      infoMessage: null,
      relatorio: null,
      activeSectionId: null,
      expandedSections: {},
      yearHint: 'Ano principal do relatório. Todos os indicadores, tabelas e gráficos são calculados com base neste período.',
      compareYearHint: 'Ano anterior opcional para comparação. Quando selecionado, indicadores compatíveis mostram o valor do ano de referência, do ano comparativo e a variação percentual entre eles. Escolha um ano menor que o de referência.'
    };
  },

  computed: {
    isBusy: function isBusy() {
      return this.loading || this.downloading !== null;
    },
    exportStatusMessage: function exportStatusMessage() {
      if (this.downloading === 'excel') {
        return 'Gerando planilha Excel… isso pode levar vários minutos.';
      }
      if (this.downloading === 'pdf') {
        return 'Gerando PDF a partir do relatório exibido… isso pode levar alguns minutos.';
      }
      return '';
    },
    availableYears: function availableYears() {
      var years = [];
      var end = new Date().getFullYear() + 1;
      for (var y = end; y >= __WEBPACK_IMPORTED_MODULE_3__constants_report_period__["a" /* FIRST_AVAILABLE_YEAR */]; y--) {
        years.push(y);
      }
      return years;
    },
    compareYearOptions: function compareYearOptions() {
      return this.availableYears.filter(function (y) {
        return y < this.year;
      }.bind(this));
    },
    summaryKpis: function summaryKpis() {
      if (!this.relatorio) {
        return { totalParques: null };
      }

      var evolucao = this.relatorio.indicators.find(function (item) {
        return item.id === 'evolucao_historica_parques';
      });

      if (!evolucao || !evolucao.data || !evolucao.data.snapshot) {
        return { totalParques: null };
      }

      return {
        totalParques: evolucao.data.snapshot.operacao || evolucao.data.snapshot.total || null
      };
    }
  },
  watch: {
    year: function year(newYear) {
      if (this.compareYear && Number(this.compareYear) >= Number(newYear)) {
        this.compareYear = '';
      }
    }
  },
  methods: {
    buildParams: function buildParams() {
      var params = {};
      if (this.compareYear) {
        params.compareYear = this.compareYear;
      }
      return params;
    },
    loadRelatorio: function loadRelatorio() {
      this.loading = true;
      this.errorMessage = null;
      this.infoMessage = null;

      __WEBPACK_IMPORTED_MODULE_2__services_resource_client_relatorio_estatistico__["a" /* default */].get(this.year, this.buildParams()).then(function (data) {
        this.relatorio = data;
        this.expandedSections = {};
        if (data.sections.length > 0) {
          this.expandedSections[data.sections[0].id] = true;
          this.activeSectionId = data.sections[0].id;
        }
      }.bind(this)).catch(function (error) {
        if (error.response && error.response.data && error.response.data.errors) {
          this.errorMessage = error.response.data.errors.join(', ');
          return;
        }
        if (error.response && error.response.status === 401) {
          this.errorMessage = 'Sessão expirada. Faça login novamente.';
          return;
        }
        if (error.code === 'ECONNABORTED' || !error.response) {
          this.errorMessage = 'A requisição demorou demais ou foi interrompida. Tente novamente ou escolha um ano anterior.';
          return;
        }
        this.errorMessage = 'Não foi possível carregar o relatório estatístico.';
      }.bind(this)).finally(function () {
        this.loading = false;
      }.bind(this));
    },
    downloadExcel: function downloadExcel() {
      this.downloadFile('excel', 'relatorio-estatistico-' + this.year + '.xlsx');
    },
    downloadPdf: function downloadPdf() {
      this.downloadFile('pdf', 'relatorio-estatistico-' + this.year + '.pdf');
    },
    downloadFile: function downloadFile(type, filename) {
      var self = this;
      this.downloading = type;
      this.errorMessage = null;
      this.infoMessage = null;

      var download = type === 'excel' ? __WEBPACK_IMPORTED_MODULE_2__services_resource_client_relatorio_estatistico__["a" /* default */].downloadExcelFromPayload(this.year, this.relatorio) : __WEBPACK_IMPORTED_MODULE_2__services_resource_client_relatorio_estatistico__["a" /* default */].downloadPdfFromPayload(this.year, this.relatorio);

      download.then(function (response) {
        var contentType = (response.headers['content-type'] || '').toLowerCase();

        if (contentType.indexOf('json') !== -1) {
          return response.data.text().then(function (text) {
            var message = 'Não foi possível baixar o arquivo.';
            try {
              var payload = JSON.parse(text);
              if (payload.errors && payload.errors.length > 0) {
                message = payload.errors.join(', ');
              }
            } catch (error) {
              // keep default message
            }
            throw new Error(message);
          });
        }

        if (type === 'pdf') {
          if (contentType.indexOf('html') !== -1 || response.preparedFallback === 'html') {
            var htmlFilename = response.preparedFilename || filename.replace(/\.pdf$/i, '.html');
            if (self.openHtmlExportInNewTab(response.data)) {
              self.infoMessage = 'Relatório aberto em nova aba. Use Imprimir > Salvar como PDF, se desejar.';
            } else {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_file_saver__["saveAs"])(response.data, htmlFilename);
              self.errorMessage = 'Não foi possível abrir nova aba. O arquivo HTML foi baixado — abra-o e use Imprimir > Salvar como PDF.';
            }
            return;
          }

          if (contentType.indexOf('pdf') === -1) {
            throw new Error('O servidor não retornou um arquivo PDF válido.');
          }

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_file_saver__["saveAs"])(response.data, response.preparedFilename || filename);
          return;
        }

        if (type === 'excel' && contentType.indexOf('html') !== -1) {
          throw new Error('O servidor retornou HTML em vez de Excel. Tente gerar o relatório novamente.');
        }

        if (contentType.indexOf('html') !== -1) {
          throw new Error('O servidor retornou uma página de erro em vez do arquivo. ' + 'Tente novamente em alguns instantes.');
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_file_saver__["saveAs"])(response.data, response.preparedFilename || filename);
      }).catch(function (error) {
        var data = error && error.response && error.response.data;
        if (data && typeof data.text === 'function') {
          data.text().then(function (text) {
            var message = null;
            try {
              var payload = JSON.parse(text);
              if (payload.errors && payload.errors.length > 0) {
                message = payload.errors.join(', ');
              }
            } catch (parseError) {
              // ignore
            }
            self.errorMessage = message || self.resolveDownloadError(error, type);
          }).catch(function () {
            self.errorMessage = self.resolveDownloadError(error, type);
          });
          return;
        }

        self.errorMessage = self.resolveDownloadError(error, type);
      }).finally(function () {
        self.downloading = null;
      });
    },
    toggleSection: function toggleSection(sectionId) {
      var willExpand = !this.expandedSections[sectionId];
      this.$set(this.expandedSections, sectionId, willExpand);
      this.activeSectionId = sectionId;
      if (willExpand) {
        this.$nextTick(function () {
          window.dispatchEvent(new Event('resize'));
        });
      }
    },
    isSectionExpanded: function isSectionExpanded(sectionId) {
      return !!this.expandedSections[sectionId];
    },
    scrollToSection: function scrollToSection(sectionId) {
      this.$set(this.expandedSections, sectionId, true);
      this.activeSectionId = sectionId;
      var element = document.getElementById('section-' + sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      this.$nextTick(function () {
        window.dispatchEvent(new Event('resize'));
      });
    },
    formatGeneratedAt: function formatGeneratedAt(isoDate) {
      if (!isoDate) {
        return '';
      }
      return new Date(isoDate).toLocaleString('pt-BR');
    },
    openHtmlExportInNewTab: function openHtmlExportInNewTab(blob) {
      var htmlBlob = blob instanceof Blob ? blob.type ? blob : new Blob([blob], { type: 'text/html;charset=utf-8' }) : new Blob([blob], { type: 'text/html;charset=utf-8' });
      var url = URL.createObjectURL(htmlBlob);
      var newWindow = window.open(url, '_blank');

      if (!newWindow) {
        URL.revokeObjectURL(url);
        return false;
      }

      window.setTimeout(function () {
        URL.revokeObjectURL(url);
      }, 60000);

      return true;
    },
    resolveDownloadError: function resolveDownloadError(error, type) {
      var label = type === 'pdf' ? 'PDF' : 'Excel';

      if (!error) {
        return 'Não foi possível baixar o ' + label + '.';
      }

      if (error.code === 'ECONNABORTED' || !error.response) {
        if (error.message && error.message !== 'Network Error') {
          return error.message;
        }

        return 'A geração do ' + label + ' falhou na conexão com o servidor. Gere o relatório novamente e tente outra vez.';
      }

      if (error.response.status === 401) {
        return 'Sessão expirada. Faça login novamente.';
      }

      if (error.response.status === 403) {
        return 'O servidor bloqueou o download do ' + label + ' (limite do hosting). Tente novamente em alguns instantes.';
      }

      if (error.response.status === 404) {
        return 'Arquivo de exportação expirado. Gere o relatório novamente e tente outra vez.';
      }

      var data = error.response.data;
      if (data && data.errors && data.errors.length > 0) {
        return data.errors.join(', ');
      }

      if (error.message && error.message !== 'Network Error') {
        return error.message;
      }

      return 'Não foi possível baixar o ' + label + '.';
    }
  }
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_resource_client_report__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_report_formatter__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_charts_LineChart__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_elements_charts_LineChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_elements_charts_LineChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_charts_BarChart__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_charts_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_elements_charts_BarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_ReportChartContainer__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_ReportChartContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_elements_ReportChartContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_ReportPeriodFilter__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_ReportPeriodFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_elements_ReportPeriodFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_report_period__ = __webpack_require__(73);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SegmentedChartsReports',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default.a, LineChart: __WEBPACK_IMPORTED_MODULE_3__components_elements_charts_LineChart___default.a, BarChart: __WEBPACK_IMPORTED_MODULE_4__components_elements_charts_BarChart___default.a, ReportChartContainer: __WEBPACK_IMPORTED_MODULE_5__components_elements_ReportChartContainer___default.a, ReportPeriodFilter: __WEBPACK_IMPORTED_MODULE_6__components_elements_ReportPeriodFilter___default.a },
  data: function data() {
    return {
      isRenderingReports: false,
      currentYear: new Date().getFullYear(),
      firstAvailableYear: __WEBPACK_IMPORTED_MODULE_7__constants_report_period__["a" /* FIRST_AVAILABLE_YEAR */],
      startYear: 2000,
      endYear: new Date().getFullYear(),
      periodType: 'years',
      startDate: '2000-01-01',
      endDate: new Date().getFullYear() + '-12-31',
      componentsPerType: {
        'line': __WEBPACK_IMPORTED_MODULE_3__components_elements_charts_LineChart___default.a,
        'stackedBar': __WEBPACK_IMPORTED_MODULE_4__components_elements_charts_BarChart___default.a,
        'bar': __WEBPACK_IMPORTED_MODULE_4__components_elements_charts_BarChart___default.a
      },
      reports: [{ id: 1, title: 'Número de parques tecnológicos em planejamento', uri: 'reports/parks-in-planning-stage-per-year', data: {}, type: 'line', isSelected: false }, { id: 2, title: 'Número de parques tecnológicos em implantação', uri: 'reports/parks-in-implantation-stage-per-year', data: {}, type: 'line', isSelected: false }, { id: 3, title: 'Número de parques tecnológicos em operação', uri: 'reports/parks-in-operation-stage-per-year', data: {}, type: 'line', isSelected: false }, { id: 4, title: 'Número de empresas residentes', uri: 'reports/resident-companies-per-year', data: {}, type: 'line', isSelected: false }, { id: 5, title: 'Estimativa de faturamento das empresas vinculadas aos parques tecnológicos', uri: 'reports/companies-revenues-estimate-per-year', data: {}, type: 'line', isSelected: false }, { id: 6, title: 'Estimativa de impostos das empresas vinculadas aos parques tecnológicos', uri: 'reports/companies-taxes-estimate-per-year', data: {}, type: 'line', isSelected: false }, { id: 7, title: 'Estimativa de postos de trabalho gerados pelas empresas vinculadas aos parques tecnológicos', uri: 'reports/companies-jobs-estimate-per-year', data: {}, type: 'line', isSelected: false }, { id: 8, title: 'Indicadores financeiros das empresas residentes - Faturamento', uri: 'reports/resident-companies-revenues-per-year', data: {}, type: 'line', isSelected: false }, { id: 9, title: 'Indicadores financeiros das empresas residentes - Impostos', uri: 'reports/resident-companies-taxes-per-year', data: {}, type: 'line', isSelected: false }, { id: 10, title: 'Indicadores financeiros das empresas residentes - Postos de trabalho gerados', uri: 'reports/resident-companies-jobs-per-year', data: {}, type: 'line', isSelected: false }, { id: 11, title: 'Indicadores financeiros das empresas associadas - Faturamento', uri: 'reports/associated-companies-revenues-per-year', data: {}, type: 'line', isSelected: false }, { id: 12, title: 'Indicadores financeiros das empresas associadas - Impostos', uri: 'reports/associated-companies-taxes-per-year', data: {}, type: 'line', isSelected: false }, { id: 13, title: 'Indicadores financeiros das empresas associadas - Postos de trabalho gerados', uri: 'reports/associated-companies-jobs-per-year', data: {}, type: 'line', isSelected: false }, { id: 14, title: 'Indicadores financeiros das empresas - Faturamento', uri: 'reports/companies-revenues-per-year', data: {}, type: 'line', isSelected: false }, { id: 15, title: 'Indicadores financeiros das empresas - Impostos', uri: 'reports/companies-taxes-per-year', data: {}, type: 'line', isSelected: false }, { id: 16, title: 'Indicadores financeiros das empresas - Postos de trabalho gerados', uri: 'reports/companies-jobs-per-year', data: {}, type: 'line', isSelected: false }, { id: 17, title: 'Indicadores financeiros das empresas nos demais programas - Faturamento', uri: 'reports/companies-revenues-in-other-programs-per-year', data: {}, type: 'line', isSelected: false }, { id: 18, title: 'Indicadores financeiros das empresas nos demais programas - Impostos', uri: 'reports/companies-taxes-in-other-programs-per-year', data: {}, type: 'line', isSelected: false }, { id: 19, title: 'Indicadores financeiros das empresas nos demais programas - Postos de trabalho gerados', uri: 'reports/companies-jobs-in-other-programs-per-year', data: {}, type: 'line', isSelected: false }, { id: 20, title: 'Indicadores de inovação - Empresa residente', uri: 'reports/resident-companies-innovation-indicators-per-year', data: {}, type: 'line', isSelected: false }, { id: 21, title: 'Indicadores de inovação - Empresa associada', uri: 'reports/associated-companies-innovation-indicators-per-year', data: {}, type: 'line', isSelected: false }, { id: 22, title: 'Indicadores de inovação - Pré-incubação', uri: 'reports/pre-incubation-innovation-indicators-per-year', data: {}, type: 'line', isSelected: false }, { id: 23, title: 'Indicadores de inovação - Incubação', uri: 'reports/incubation-innovation-indicators-per-year', data: {}, type: 'line', isSelected: false }, { id: 24, title: 'Indicadores de inovação - Empresa graduada', uri: 'reports/graduated-companies-innovation-indicators-per-year', data: {}, type: 'line', isSelected: false }, { id: 25, title: 'Indicadores de inovação - Aceleração', uri: 'reports/acceleration-innovation-indicators-per-year', data: {}, type: 'line', isSelected: false }, { id: 26, title: 'Indicadores de inovação - Total', uri: 'reports/total-innovation-indicators-per-year', data: {}, type: 'line', isSelected: false }, { id: 27, title: 'Natureza jurídica da entidade gestora financeira', uri: 'reports/finance-management-entities-per-year', data: {}, type: 'stackedBar', isSelected: false }, { id: 28, title: 'Natureza jurídica da entidade gestora administrativa', uri: 'reports/administrative-management-entities-per-year', data: {}, type: 'stackedBar', isSelected: false }, { id: 29, title: 'Tamanho da equipe de funcionários', uri: 'reports/team-size-per-year', data: {}, type: 'line', isSelected: false }, { id: 30, title: 'Receitas próprias do parque tecnológico - Valor Total', uri: 'reports/own-revenues-total-per-year', data: {}, type: 'line', isSelected: false }, { id: 31, title: 'Receitas próprias do parque tecnológico - Valor Médio', uri: 'reports/own-revenues-average-per-year', data: {}, type: 'line', isSelected: false }, { id: 32, title: 'Custos e despesas do parque tecnológico - Valor Total', uri: 'reports/total-costs-per-year', data: {}, type: 'line', isSelected: false }, { id: 33, title: 'Custos e despesas do parque tecnológico - Valor Médio', uri: 'reports/average-costs-per-year', data: {}, type: 'line', isSelected: false }, { id: 34, title: 'Investimentos do parque tecnológico - Valor Total', uri: 'reports/total-investments-per-year', data: {}, type: 'line', isSelected: false }, { id: 35, title: 'Investimentos do parque tecnológico - Valor Médio', uri: 'reports/average-investments-per-year', data: {}, type: 'line', isSelected: false }, { id: 36, title: 'Recursos Captados - Governo Federal', uri: 'reports/federal-government-resources-raised-per-year', data: {}, type: 'line', isSelected: false }, { id: 37, title: 'Recursos Captados - Governo Estadual', uri: 'reports/state-government-resources-raised-per-year', data: {}, type: 'line', isSelected: false }, { id: 38, title: 'Recursos Captados - Governo Municipal', uri: 'reports/municipal-government-resources-raised-per-year', data: {}, type: 'line', isSelected: false }, { id: 39, title: 'Recursos Captados - Universidades', uri: 'reports/universities-resources-raised-per-year', data: {}, type: 'line', isSelected: false }, { id: 40, title: 'Recursos Captados - Parceiros privados', uri: 'reports/private-partners-resources-raised-per-year', data: {}, type: 'line', isSelected: false }, { id: 41, title: 'Recursos Captados - Outras fontes', uri: 'reports/other-sources-resources-raised-per-year', data: {}, type: 'line', isSelected: false }, { id: 42, title: 'Recursos de projetos de subvenção obtidos pelo parque tecnológico - Valor Total', uri: 'reports/total-project-resources-per-year', data: {}, type: 'line', isSelected: false }, { id: 43, title: 'Recursos de projetos de subvenção obtidos pelo parque tecnológico - Valor Médio', uri: 'reports/average-project-resources-per-year', data: {}, type: 'line', isSelected: false }, { id: 44, title: 'Necessidades futuras para investimento do parque tecnológico - Valor Total', uri: 'reports/total-future-needs-per-year', data: {}, type: 'line', isSelected: false }, { id: 45, title: 'Necessidades futuras para investimento do parque tecnológico - Valor Médio', uri: 'reports/average-future-needs-per-year', data: {}, type: 'line', isSelected: false }, { id: 46, title: 'Indicadores do parque tecnológico - Empresa residente - Nº total de propostas submetidas ao programa', uri: 'reports/park-indicators-resident-submitted-proposals-per-year', data: {}, type: 'line', isSelected: false }, { id: 47, title: 'Indicadores do parque tecnológico - Empresa residente - Nº total de propostas selecionadas no programa', uri: 'reports/park-indicators-resident-selected-proposals-per-year', data: {}, type: 'line', isSelected: false }, { id: 48, title: 'Indicadores do parque tecnológico - Empresa residente - Nº de empresas no programa', uri: 'reports/park-indicators-resident-companies-per-year', data: {}, type: 'line', isSelected: false }, { id: 49, title: 'Indicadores do parque tecnológico - Empresa residente - Nº de empresas desligadas do programa', uri: 'reports/park-indicators-resident-companies-disconnected-per-year', data: {}, type: 'line', isSelected: false }, { id: 50, title: 'Indicadores do parque tecnológico - Empresa associada - Nº total de propostas submetidas ao programa', uri: 'reports/park-indicators-associated-submitted-proposals-per-year', data: {}, type: 'line', isSelected: false }, { id: 51, title: 'Indicadores do parque tecnológico - Empresa associada - Nº total de propostas selecionadas no programa', uri: 'reports/park-indicators-associated-selected-proposals-per-year', data: {}, type: 'line', isSelected: false }, { id: 52, title: 'Indicadores do parque tecnológico - Empresa associada - Nº de empresas no programa', uri: 'reports/park-indicators-associated-companies-per-year', data: {}, type: 'line', isSelected: false }, { id: 53, title: 'Indicadores do parque tecnológico - Empresa associada - Nº de empresas desligadas do programa', uri: 'reports/park-indicators-associated-companies-disconnected-per-year', data: {}, type: 'line', isSelected: false }, { id: 54, title: 'Indicadores do parque tecnológico - Pré-incubação - Nº total de propostas submetidas ao programa', uri: 'reports/park-indicators-pre-incubation-submitted-proposals-per-year', data: {}, type: 'line', isSelected: false }, { id: 55, title: 'Indicadores do parque tecnológico - Pré-incubação - Nº total de propostas selecionadas no programa', uri: 'reports/park-indicators-pre-incubation-selected-proposals-per-year', data: {}, type: 'line', isSelected: false }, { id: 56, title: 'Indicadores do parque tecnológico - Pré-incubação - Nº de empresas no programa', uri: 'reports/park-indicators-pre-incubation-companies-per-year', data: {}, type: 'line', isSelected: false }, { id: 57, title: 'Indicadores do parque tecnológico - Pré-incubação - Nº de empresas desligadas do programa', uri: 'reports/park-indicators-pre-incubation-companies-disconnected-per-year', data: {}, type: 'line', isSelected: false }, { id: 58, title: 'Indicadores do parque tecnológico - Incubação - Nº total de propostas submetidas ao programa', uri: 'reports/park-indicators-incubation-submitted-proposals-per-year', data: {}, type: 'line', isSelected: false }, { id: 59, title: 'Indicadores do parque tecnológico - Incubação - Nº total de propostas selecionadas no programa', uri: 'reports/park-indicators-incubation-selected-proposals-per-year', data: {}, type: 'line', isSelected: false }, { id: 60, title: 'Indicadores do parque tecnológico - Incubação - Nº de empresas no programa', uri: 'reports/park-indicators-incubation-companies-per-year', data: {}, type: 'line', isSelected: false }, { id: 61, title: 'Indicadores do parque tecnológico - Incubação - Nº de empresas desligadas do programa', uri: 'reports/park-indicators-incubation-companies-disconnected-per-year', data: {}, type: 'line', isSelected: false }, { id: 62, title: 'Indicadores do parque tecnológico - Empresa graduada - Nº total de propostas submetidas ao programa', uri: 'reports/park-indicators-graduated-submitted-proposals-per-year', data: {}, type: 'line', isSelected: false }, { id: 63, title: 'Indicadores do parque tecnológico - Empresa graduada - Nº total de propostas selecionadas no programa', uri: 'reports/park-indicators-graduated-selected-proposals-per-year', data: {}, type: 'line', isSelected: false }, { id: 64, title: 'Indicadores do parque tecnológico - Empresa graduada - Nº de empresas no programa', uri: 'reports/park-indicators-graduated-companies-per-year', data: {}, type: 'line', isSelected: false }, { id: 65, title: 'Indicadores do parque tecnológico - Empresa graduada - Nº de empresas desligadas do programa', uri: 'reports/park-indicators-graduated-companies-disconnected-per-year', data: {}, type: 'line', isSelected: false }, { id: 66, title: 'Indicadores do parque tecnológico - Aceleração - Nº total de propostas submetidas ao programa', uri: 'reports/park-indicators-acceleration-submitted-proposals-per-year', data: {}, type: 'line', isSelected: false }, { id: 67, title: 'Indicadores do parque tecnológico - Aceleração - Nº total de propostas selecionadas no programa', uri: 'reports/park-indicators-acceleration-selected-proposals-per-year', data: {}, type: 'line', isSelected: false }, { id: 68, title: 'Indicadores do parque tecnológico - Aceleração - Nº de empresas no programa', uri: 'reports/park-indicators-acceleration-companies-per-year', data: {}, type: 'line', isSelected: false }, { id: 69, title: 'Indicadores do parque tecnológico - Aceleração - Nº de empresas desligadas do programa', uri: 'reports/park-indicators-acceleration-companies-disconnected-per-year', data: {}, type: 'line', isSelected: false }, { id: 70, title: 'Indicadores do parque tecnológico - Coworking - Nº total de propostas submetidas ao programa', uri: 'reports/park-indicators-coworking-submitted-proposals-per-year', data: {}, type: 'line', isSelected: false }, { id: 71, title: 'Indicadores do parque tecnológico - Coworking - Nº total de propostas selecionadas no programa', uri: 'reports/park-indicators-coworking-selected-proposals-per-year', data: {}, type: 'line', isSelected: false }, { id: 72, title: 'Indicadores do parque tecnológico - Coworking - Nº de empresas no programa', uri: 'reports/park-indicators-coworking-companies-per-year', data: {}, type: 'line', isSelected: false }, { id: 73, title: 'Indicadores do parque tecnológico - Coworking - Nº de empresas desligadas do programa', uri: 'reports/park-indicators-coworking-companies-disconnected-per-year', data: {}, type: 'line', isSelected: false }, { id: 74, title: 'Indicadores do parque tecnológico - Total - Nº total de propostas submetidas ao programa', uri: 'reports/park-indicators-total-submitted-proposals-per-year', data: {}, type: 'line', isSelected: false }, { id: 75, title: 'Indicadores do parque tecnológico - Total - Nº total de propostas selecionadas no programa', uri: 'reports/park-indicators-total-selected-proposals-per-year', data: {}, type: 'line', isSelected: false }, { id: 76, title: 'Indicadores do parque tecnológico - Total - Nº total de empresas nos programas', uri: 'reports/park-indicators-total-companies-per-year', data: {}, type: 'line', isSelected: false }, { id: 77, title: 'Indicadores do parque tecnológico - Total - Nº total de empresas desligadas dos programas', uri: 'reports/park-indicators-total-companies-disconnected-per-year', data: {}, type: 'line', isSelected: false }, { id: 78, title: 'Indicadores de empresas âncoras - Total de empresas âncoras', uri: 'reports/anchor-companies-total-per-year', data: {}, type: 'line', isSelected: false }, { id: 79, title: 'Indicadores de empresas âncoras - Total de investimento em infraestrutura no parque tecnológico', uri: 'reports/anchor-companies-total-infrastructure-investments-per-year', data: {}, type: 'line', isSelected: false }, { id: 80, title: 'Indicadores de empresas âncoras - Total de investimento em Pesquisa, Desenvolvimento e Inovação (PD & I)', uri: 'reports/anchor-companies-total-research-investments-per-year', data: {}, type: 'line', isSelected: false }, { id: 81, title: 'Indicadores de empresas âncoras - Número total de postos de trabalho', uri: 'reports/anchor-companies-total-jobs-per-year', data: {}, type: 'line', isSelected: false }, { id: 82, title: 'Indicadores de empresas âncoras - Faturamento total', uri: 'reports/anchor-companies-total-revenues-per-year', data: {}, type: 'line', isSelected: false }, { id: 83, title: 'Indicadores de empresas âncoras - Total de impostos federais', uri: 'reports/anchor-companies-total-federal-taxes-per-year', data: {}, type: 'line', isSelected: false }, { id: 84, title: 'Indicadores de empresas âncoras - Total de impostos estaduais', uri: 'reports/anchor-companies-total-state-taxes-per-year', data: {}, type: 'line', isSelected: false }, { id: 85, title: 'Indicadores de empresas âncoras - Total de impostos municipais', uri: 'reports/anchor-companies-total-municipal-taxes-per-year', data: {}, type: 'line', isSelected: false }, { id: 86, title: 'Programas oferecidos - Capacidade atual de atendimento - Empresa residente', uri: 'reports/current-capacity-for-resident-companies-per-year', data: {}, type: 'line', isSelected: false }, { id: 87, title: 'Programas oferecidos - Capacidade atual de atendimento - Empresa associada', uri: 'reports/current-capacity-for-associated-companies-per-year', data: {}, type: 'line', isSelected: false }, { id: 88, title: 'Programas oferecidos - Capacidade atual de atendimento - Pré-incubação de empresas', uri: 'reports/current-capacity-for-pre-incubation-per-year', data: {}, type: 'line', isSelected: false }, { id: 89, title: 'Programas oferecidos - Capacidade atual de atendimento - Incubação de empresas', uri: 'reports/current-capacity-for-incubation-per-year', data: {}, type: 'line', isSelected: false }, { id: 90, title: 'Programas oferecidos - Capacidade atual de atendimento - Aceleração de empresas', uri: 'reports/current-capacity-for-acceleration-per-year', data: {}, type: 'line', isSelected: false }, { id: 91, title: 'Programas oferecidos - Capacidade atual de atendimento - Coworking', uri: 'reports/current-capacity-for-coworking-per-year', data: {}, type: 'line', isSelected: false }, { id: 92, title: 'Programas oferecidos - Nº de projetos atendidos atualmente - Empresa residente', uri: 'reports/resident-companies-current-projects-per-year', data: {}, type: 'line', isSelected: false }, { id: 93, title: 'Programas oferecidos - Nº de projetos atendidos atualmente - Empresa associada', uri: 'reports/associated-companies-current-projects-per-year', data: {}, type: 'line', isSelected: false }, { id: 94, title: 'Programas oferecidos - Nº de projetos atendidos atualmente - Pré-incubação de empresas', uri: 'reports/pre-incubation-current-projects-per-year', data: {}, type: 'line', isSelected: false }, { id: 95, title: 'Programas oferecidos - Nº de projetos atendidos atualmente - Incubação de empresas', uri: 'reports/incubation-current-projects-per-year', data: {}, type: 'line', isSelected: false }, { id: 96, title: 'Programas oferecidos - Nº de projetos atendidos atualmente - Aceleração de empresas', uri: 'reports/acceleration-current-projects-per-year', data: {}, type: 'line', isSelected: false }, { id: 97, title: 'Programas oferecidos - Nº de projetos atendidos atualmente - Coworking', uri: 'reports/coworking-current-projects-per-year', data: {}, type: 'line', isSelected: false }, { id: 98, title: 'Programas oferecidos - Nº de projetos atendidos desde a criação do programa - Empresa residente', uri: 'reports/resident-companies-projects-since-creation-per-year', data: {}, type: 'line', isSelected: false }, { id: 99, title: 'Programas oferecidos - Nº de projetos atendidos desde a criação do programa - Empresa associada', uri: 'reports/associated-companies-projects-since-creation-per-year', data: {}, type: 'line', isSelected: false }, { id: 100, title: 'Programas oferecidos - Nº de projetos atendidos desde a criação do programa - Pré-incubação de empresas', uri: 'reports/pre-incubation-projects-since-creation-per-year', data: {}, type: 'line', isSelected: false }, { id: 101, title: 'Programas oferecidos - Nº de projetos atendidos desde a criação do programa - Incubação de empresas', uri: 'reports/incubation-projects-since-creation-per-year', data: {}, type: 'line', isSelected: false }, { id: 102, title: 'Programas oferecidos - Nº de projetos atendidos desde a criação do programa - Aceleração de empresas', uri: 'reports/acceleration-projects-since-creation-per-year', data: {}, type: 'line', isSelected: false }, { id: 103, title: 'Programas oferecidos - Nº de projetos atendidos desde a criação do programa - Coworking', uri: 'reports/coworking-projects-since-creation-per-year', data: {}, type: 'line', isSelected: false }, { id: 104, title: 'Áreas do parque tecnológico - Terrenos e Lotes - Área do terreno (m²)', uri: 'reports/parks-land-area-per-year', data: {}, type: 'line', isSelected: false }, { id: 105, title: 'Áreas do parque tecnológico - Terrenos e Lotes - Área de preservação ambiental (m²)', uri: 'reports/parks-preservation-area-per-year', data: {}, type: 'line', isSelected: false }, { id: 106, title: 'Áreas do parque tecnológico - Terrenos e Lotes - Área urbanizável (m²)', uri: 'reports/parks-urbanizable-area-per-year', data: {}, type: 'line', isSelected: false }, { id: 107, title: 'Áreas do parque tecnológico - Terrenos e Lotes - Área edificável (m²)', uri: 'reports/parks-buildable-area-per-year', data: {}, type: 'line', isSelected: false }, { id: 108, title: 'Áreas do parque tecnológico - Terrenos e Lotes - Taxa de ocupação da área do terreno', uri: 'reports/parks-land-area-occupancy-rate-per-year', data: {}, type: 'line', isSelected: false }, { id: 109, title: 'Áreas do parque tecnológico - Terrenos e Lotes - Taxa de ocupação da área urbanizável', uri: 'reports/parks-urbanizable-area-occupancy-rate-per-year', data: {}, type: 'line', isSelected: false }, { id: 110, title: 'Áreas do parque tecnológico - Terrenos e Lotes - Taxa de ocupação da área edificável', uri: 'reports/parks-buildable-area-occupancy-rate-per-year', data: {}, type: 'line', isSelected: false }, { id: 111, title: 'Áreas do parque tecnológico - Prédios e edificações - Área disponível para instalação de empresas no condomínio empresarial (m²)', uri: 'reports/parks-companies-area-per-year', data: {}, type: 'line', isSelected: false }, { id: 112, title: 'Áreas do parque tecnológico - Prédios e edificações - Área de uso compartilhado (salas de reuniões, treinamento, auditórios e outras) (m²)', uri: 'reports/parks-shared-area-per-year', data: {}, type: 'line', isSelected: false }, { id: 113, title: 'Áreas do parque tecnológico - Prédios e edificações - Área de laboratórios de uso compartilhado (m²)', uri: 'reports/parks-labs-area-per-year', data: {}, type: 'line', isSelected: false }, { id: 114, title: 'Áreas do parque tecnológico - Prédios e edificações - Área de lazer e alimentação (m²)', uri: 'reports/parks-recreation-area-per-year', data: {}, type: 'line', isSelected: false }, { id: 115, title: 'Áreas do parque tecnológico - Prédios e edificações - Taxa de ocupação da área disponível para instalação de empresas no condomínio empresarial', uri: 'reports/parks-companies-area-occupancy-rate-per-year', data: {}, type: 'line', isSelected: false }, { id: 116, title: 'Equipe atual do parque tecnológico - Percentual de funcionários por faixa etária', uri: 'reports/team-age-group-per-year', data: {}, type: 'bar', isSelected: false }, { id: 117, title: 'Equipe atual do parque tecnológico - Funcionários por tipo de vínculo', uri: 'reports/team-bond-per-year', data: {}, type: 'stackedBar', isSelected: false }, { id: 118, title: 'Equipe atual do parque tecnológico - Funcionários por função', uri: 'reports/team-function-per-year', data: {}, type: 'stackedBar', isSelected: false }, { id: 119, title: 'Personalidade jurídica do parque tecnológico', uri: 'reports/park-legal-nature-per-year', data: {}, type: 'stackedBar', isSelected: false }, { id: 120, title: 'Principais focos de atuação dos parques tecnológicos (evolução)', uri: 'reports/park-focus-action-per-year', data: {}, type: 'stackedBar', isSelected: false }, { id: 121, title: 'Evolução anual do número de empresas desligadas', uri: 'reports/companies-unlinked-per-year', data: {}, type: 'line', isSelected: false }, { id: 122, title: 'Evolução anual dos motivos de desligamento de empresas', uri: 'reports/companies-abandonment-reasons-per-year', data: {}, type: 'stackedBar', isSelected: false }]
    };
  },

  methods: {
    onPeriodChange: function onPeriodChange(period) {
      this.periodType = period.periodType;
      this.startYear = period.startYear;
      this.endYear = period.endYear;
      this.startDate = period.startDate;
      this.endDate = period.endDate;
    },
    renderReports: function renderReports() {
      var _this = this;

      this.isRenderingReports = true;
      this.selectedReports.forEach(function (r) {
        return _this.renderReport(r.id);
      });
    },
    fetchPeriodReport: function fetchPeriodReport(uri) {
      if (this.periodType === 'dates') {
        return __WEBPACK_IMPORTED_MODULE_1__services_resource_client_report__["a" /* default */].getInDateRange(uri, this.startDate, this.endDate);
      }
      return __WEBPACK_IMPORTED_MODULE_1__services_resource_client_report__["a" /* default */].getInPeriod(uri, this.startYear, this.endYear);
    },
    renderReport: function renderReport(id) {
      var report = this.reports.find(function (r) {
        return r.id === id;
      });
      this.fetchPeriodReport(report.uri).then(function (response) {
        switch (report.type) {
          case 'stackedBar':
            report.data = __WEBPACK_IMPORTED_MODULE_2__services_report_formatter__["a" /* default */].stackedBarChart(response.data, report.title);
            break;
          default:
            report.data = __WEBPACK_IMPORTED_MODULE_2__services_report_formatter__["a" /* default */].chart(response.data, report.title);
        }

        report.isSelected = true;
      });
    },
    selectAll: function selectAll() {
      this.reports.forEach(function (r) {
        r.isSelected = true;
      });
    },
    clearSelected: function clearSelected() {
      this.reports.forEach(function (r) {
        r.isSelected = false;
      });
    },
    getReportComponent: function getReportComponent(r) {
      return this.componentsPerType[r.type];
    }
  },
  computed: {
    selectedReports: function selectedReports() {
      return this.reports.filter(function (r) {
        return r.isSelected;
      });
    }
  }
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_template_Adminlte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_resource_client_report__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_report_formatter__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_TableReport__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_TableReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_elements_TableReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_ListReport__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_ListReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_elements_ListReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_EvolutionTextualReport__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_EvolutionTextualReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_elements_EvolutionTextualReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_ReportPeriodFilter__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_elements_ReportPeriodFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_elements_ReportPeriodFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_report_period__ = __webpack_require__(73);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SegmentedTextualReports',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_1__components_template_Adminlte___default.a, TableReport: __WEBPACK_IMPORTED_MODULE_4__components_elements_TableReport___default.a, EvolutionTextualReport: __WEBPACK_IMPORTED_MODULE_6__components_elements_EvolutionTextualReport___default.a, ReportPeriodFilter: __WEBPACK_IMPORTED_MODULE_7__components_elements_ReportPeriodFilter___default.a },
  data: function data() {
    return {
      isRenderingReports: false,
      currentYear: new Date().getFullYear(),
      firstAvailableYear: __WEBPACK_IMPORTED_MODULE_8__constants_report_period__["a" /* FIRST_AVAILABLE_YEAR */],
      year: new Date().getFullYear(),
      startYear: 2000,
      endYear: new Date().getFullYear(),
      viewMode: 'snapshot',
      periodType: 'years',
      startDate: new Date().getFullYear() + '-01-01',
      endDate: new Date().getFullYear() + '-12-31',
      componentsPerType: {
        'table': __WEBPACK_IMPORTED_MODULE_4__components_elements_TableReport___default.a,
        'list': __WEBPACK_IMPORTED_MODULE_5__components_elements_ListReport___default.a
      },
      reports: [{ id: 1, title: 'Principais focos de atuação dos parques tecnológicos', uri: 'reports/park-focus-action-in-year', data: {}, type: 'table', isSelected: false }, { id: 2, title: 'Principais áreas de atuação das empresas', uri: 'reports/company-areas-expertise-in-year', data: {}, type: 'table', isSelected: false }, { id: 3, title: 'Valor de investimentos do parque tecnológico', uri: 'reports/park-investments-in-year', data: {}, type: 'table', isSelected: false }, { id: 4, title: 'Origem dos recursos captados para o parque tecnológico, de acordo com a fonte', uri: 'reports/funds-raised-source-in-year', data: {}, type: 'table', isSelected: false }, { id: 5, title: 'Recursos de projetos de subvenção obtidos pelo parque tecnológico', uri: 'reports/resources-obtained-in-year', data: {}, type: 'table', isSelected: false }, { id: 6, title: 'O parque tecnológico possui', uri: 'reports/park-has-in-year', data: {}, type: 'table', isSelected: false }, { id: 7, title: 'Porcentagem de parques tecnológicos que oferecem local próprio para instalação de empresas', uri: 'reports/offers-installation-place-in-year', data: {}, type: 'table', isSelected: false }, { id: 8, title: 'Em relação às modalidades para instalação de empresas residentes, o parque tecnológico, possui', uri: 'reports/installation-place-model-in-year', data: {}, type: 'table', isSelected: false }, { id: 9, title: 'De quem é a propriedade do terreno do parque', uri: 'reports/park-land-ownership-in-year', data: {}, type: 'table', isSelected: false }, { id: 10, title: 'Local onde o parque tecnológico se encontra instalado', uri: 'reports/park-installation-location-in-year', data: {}, type: 'table', isSelected: false }, { id: 11, title: 'Áreas do parque tecnológico (m²) - Terreno e lotes', uri: 'reports/park-land-areas-in-year', data: {}, type: 'table', isSelected: false }, { id: 12, title: 'Áreas do parque tecnológico (m²) - Prédios e edificações', uri: 'reports/park-edification-areas-in-year', data: {}, type: 'table', isSelected: false }, { id: 13, title: 'Relação de parques em operação', uri: 'reports/list-parks-in-operation-stage-in-year', data: {}, type: 'table', isSelected: false }, { id: 14, title: 'Relação de parques em implantação', uri: 'reports/list-parks-in-implantation-stage-in-year', data: {}, type: 'table', isSelected: false }, { id: 15, title: 'Relação de parques em planejamento', uri: 'reports/list-parks-in-planning-stage-in-year', data: {}, type: 'table', isSelected: false }, { id: 16, title: 'Número de empresas por parque tecnológico em operação', uri: 'reports/companies-in-parks-in-operation-stage-in-year', data: {}, type: 'table', isSelected: false }, { id: 17, title: 'Relação dos parques em operação por natureza jurídica', uri: 'reports/parks-in-operation-stage-by-legal-nature-in-year', data: {}, type: 'table', isSelected: false }, { id: 18, title: 'Relação dos parques em operação por "Natureza jurídica da entidade gestora administrativa"', uri: 'reports/parks-in-operation-stage-by-administrative-entity-legal-nature-in-year', data: {}, type: 'table', isSelected: false }, { id: 19, title: 'Relação dos parques em operação por "Natureza jurídica da entidade gestora financeira"', uri: 'reports/parks-in-operation-stage-by-finance-entity-legal-nature-in-year', data: {}, type: 'table', isSelected: false }, { id: 20, title: 'Relação dos parques em operação que têm incubadora', uri: 'reports/parks-in-operation-stage-having-incubator-in-year', data: {}, type: 'table', isSelected: false }, { id: 21, title: 'Relação dos parques em operação que têm aceleradora', uri: 'reports/parks-in-operation-stage-having-accelerator-in-year', data: {}, type: 'table', isSelected: false }, { id: 22, title: 'Relação dos parques em operação que têm relação formal com instituição de ensino superior', uri: 'reports/parks-in-operation-stage-having-higher-education-link-in-year', data: {}, type: 'table', isSelected: false }, { id: 23, title: 'Relação dos parques em operação que têm relação formal com institutos de pesquisa', uri: 'reports/parks-in-operation-stage-having-research-center-link-in-year', data: {}, type: 'table', isSelected: false }, { id: 24, title: 'Relação dos parques tecnológicos por focos de atuação', uri: 'reports/parks-by-focus-action-in-year', data: {}, type: 'table', isSelected: false }, { id: 25, title: 'Relação dos parques tecnológicos que possuem planejamento estratégico', uri: 'reports/parks-having-strategic-planning-in-year', data: {}, type: 'list', isSelected: false }, { id: 26, title: 'Relação dos parques que estão formalmente associados à instituições', uri: 'reports/parks-which-are-related-to-institutions-in-year', data: {}, type: 'list', isSelected: false }, { id: 27, title: 'Relação dos parques que possuem certificações', uri: 'reports/parks-which-has-certifications-in-year', data: {}, type: 'list', isSelected: false }, { id: 28, title: 'Relação dos parques tecnológicos que possuem interação com algum programa de incubação e/ou aceleração', uri: 'reports/parks-having-incubation-acceleration-interaction-in-year', data: {}, type: 'list', isSelected: false }, { id: 29, title: 'Relação de parques que oferecem incentivos fiscais, creditícios e/ou benefícos às empresas', uri: 'reports/parks-by-incentives-offered-in-year', data: {}, type: 'list', isSelected: false }, { id: 30, title: 'Relação de empresas âncoras por área de atuação', uri: 'reports/anchor-companies-by-area-in-year', data: {}, type: 'table', isSelected: false }, { id: 31, title: 'Necessidades futuras para investimentos do parque tecnológico', uri: 'reports/parks-future-investment-needs-in-year', data: {}, type: 'table', isSelected: false }, { id: 32, title: 'Necessidades futuras para investimentos do parque tecnológico - Parques em Planejamento', uri: 'reports/parks-in-planning-stage-future-investment-needs-in-year', data: {}, type: 'table', isSelected: false }, { id: 33, title: 'Necessidades futuras para investimentos do parque tecnológico - Parques em Implantação', uri: 'reports/parks-in-implantation-stage-future-investment-needs-in-year', data: {}, type: 'table', isSelected: false }, { id: 34, title: 'Necessidades futuras para investimentos do parque tecnológico - Parques em Operação', uri: 'reports/parks-in-operation-stage-future-investment-needs-in-year', data: {}, type: 'table', isSelected: false }, { id: 35, title: 'Quantidade de parques em operação por Estado', uri: 'reports/parks-count-by-state-in-year', data: {}, type: 'table', isSelected: false }, { id: 36, title: 'Quantidade de parques em operação por Região', uri: 'reports/parks-count-by-region-in-year', data: {}, type: 'table', isSelected: false }, { id: 37, title: 'Idade dos parques e tempos entre estágios', uri: 'reports/park-ages-in-year', data: {}, type: 'table', isSelected: false }, { id: 38, title: 'Parques que não confirmaram Informações Gerais', uri: 'reports/list-parks-without-confirmed-general-information-in-year', data: {}, type: 'list', isSelected: false }]
    };
  },

  methods: {
    onPeriodChange: function onPeriodChange(period) {
      this.viewMode = period.viewMode;
      this.periodType = period.periodType;
      this.year = period.year;
      this.startYear = period.startYear;
      this.endYear = period.endYear;
      this.startDate = period.startDate;
      this.endDate = period.endDate;
    },
    renderReports: function renderReports() {
      var _this = this;

      this.isRenderingReports = true;
      this.selectedReports.forEach(function (r) {
        return _this.renderReport(r.id);
      });
    },
    fetchSnapshotReport: function fetchSnapshotReport(uri) {
      if (this.periodType === 'dates') {
        return __WEBPACK_IMPORTED_MODULE_2__services_resource_client_report__["a" /* default */].getInDateRange(uri, this.startDate, this.endDate);
      }
      return __WEBPACK_IMPORTED_MODULE_2__services_resource_client_report__["a" /* default */].getInYear(uri, this.year);
    },
    renderReport: function renderReport(id) {
      var report = this.reports.find(function (r) {
        return r.id === id;
      });
      this.$set(report, 'evolutionData', null);

      if (this.viewMode === 'evolution') {
        this.renderEvolutionReport(report);
        return;
      }

      this.fetchSnapshotReport(report.uri).then(function (response) {
        report.data = __WEBPACK_IMPORTED_MODULE_3__services_report_formatter__["a" /* default */].textual(response.data, report.title);
        report.isSelected = true;
      });
    },
    evolutionYears: function evolutionYears() {
      if (this.periodType === 'dates') {
        var startYear = new Date(this.startDate).getFullYear();
        var endYear = new Date(this.endDate).getFullYear();
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constants_report_period__["b" /* yearsInRange */])(startYear, endYear);
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constants_report_period__["b" /* yearsInRange */])(this.startYear, this.endYear);
    },
    renderEvolutionReport: function renderEvolutionReport(report) {
      var _this2 = this;

      var years = this.evolutionYears();
      var requests = years.map(function (year) {
        return __WEBPACK_IMPORTED_MODULE_2__services_resource_client_report__["a" /* default */].getInYear(report.uri, year).then(function (response) {
          return {
            year: year,
            data: __WEBPACK_IMPORTED_MODULE_3__services_report_formatter__["a" /* default */].textual(response.data, report.title)
          };
        });
      });

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(requests).then(function (entries) {
        var entryWithMetadata = entries.find(function (entry) {
          return entry.data && entry.data.metadata;
        });
        _this2.$set(report, 'evolutionData', {
          metadata: entryWithMetadata ? entryWithMetadata.data.metadata : null,
          entries: entries
        });
        report.isSelected = true;
      });
    },
    selectAll: function selectAll() {
      this.reports.forEach(function (r) {
        r.isSelected = true;
      });
    },
    clearSelected: function clearSelected() {
      this.reports.forEach(function (r) {
        r.isSelected = false;
      });
    },
    getReportComponent: function getReportComponent(r) {
      return this.componentsPerType[r.type];
    }
  },
  computed: {
    selectedReports: function selectedReports() {
      return this.reports.filter(function (r) {
        return r.isSelected;
      });
    }
  }
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ResearcherHome',
  components: { Adminlte: __WEBPACK_IMPORTED_MODULE_0__components_template_Adminlte___default.a }
});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_backend_api__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ForgotPassword',
  data: function data() {
    return {
      email: '',
      loading: false,
      sent: false
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.loading = true;

      __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getAnonymousClient().put('users/password/recovery', { email: this.email }).then(function () {
        _this.sent = true;
        _this.email = '';
      }).finally(function () {
        _this.loading = false;
      });
    }
  },
  mounted: function mounted() {
    document.body.className = 'login-page';
  }
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_authentication__ = __webpack_require__(23);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  data: function data() {
    return {
      email: '',
      password: '',
      loginError: '',
      errorsByStatusCodes: {
        401: 'Credenciais Inválidas',
        500: 'Erro - Por favor entre em contato conosco'
      },
      logo: '',
      homePathPerRole: {
        'ROLE_RESEARCHER': 'ResearcherHome',
        'ROLE_ADMIN': 'AdminHome',
        'ROLE_PARK': 'ParkHome',
        'ROLE_PARTNER': 'QuizReports'
      }
    };
  },
  methods: {
    login: function login() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services_authentication__["a" /* default */].login(this.email, this.password).then(function (response) {
        _this.clearFormErrors();
        _this.redirect();
      }).catch(function (e) {
        if (e.message.includes('ROLE_PARK')) {
          _this.loginError = 'O acesso de Parques foi temporariamente desativado. Qualquer necessidade, envie um e-mail para ntg@ufv.br';
          return;
        }
        if (e.response) {
          _this.loginError = _this.errorsByStatusCodes[e.response.status] || 'Erro desconhecido. Tente novamente mais tarde.';
        } else {
          _this.loginError = 'Erro ao conectar. Verifique sua conexão com a internet.';
        }
      });
    },
    clearFormErrors: function clearFormErrors() {
      this.loginError = '';
    },
    redirect: function redirect() {
      var redirect = this.$route.query.redirect;
      if (redirect) {
        this.$router.push({ path: redirect });
        return;
      }

      this.$router.push({ name: this.homePathPerRole[__WEBPACK_IMPORTED_MODULE_0__services_authentication__["a" /* default */].getUserRole()] });
    },
    isValid: function isValid() {
      return this.email && this.password;
    }
  },
  mounted: function mounted() {
    this.logo = this.$config.logo;
    document.body.classList = 'login-page';
  }
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_backend_api__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ResetPassword',
  props: ['token'],
  data: function data() {
    return {
      password: '',
      repeatPassword: '',
      passwordError: '',
      logo: ''
    };
  },
  methods: {
    submit: function submit() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getAnonymousClient().put('users/password', { token: this.token, plainPassword: this.password }).then(function (response) {
        _this.redirect();
      }).catch(function (e) {
        throw e;
      });
    },
    clearFormErrors: function clearFormErrors() {
      this.passwordError = '';
    },
    redirect: function redirect() {
      this.$router.push({ name: 'Homepage' });
    },
    validateForm: function validateForm() {
      this.clearFormErrors();

      if (this.password !== this.repeatPassword) {
        this.passwordError = 'As senhas não coincidem';
        return;
      }

      if (this.password.length < 8) {
        this.passwordError = 'A senha deve ter no mínimo 8 caracteres';
      }
    },
    isValid: function isValid() {
      return this.password && this.password === this.repeatPassword && this.password.length > 7;
    },
    isTokenValid: function isTokenValid() {
      return __WEBPACK_IMPORTED_MODULE_0__services_backend_api__["a" /* BackendApi */].getAnonymousClient().get('users/password-creation-token/' + this.token);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.logo = this.$config.logo;
    document.body.classList = 'login-page';

    this.isTokenValid().catch(function (e) {
      if (e.response.status === 404) {
        _this2.$router.push({ name: 'NotFoundError' });
      }
    });
  }
});

/***/ }),
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 159,
	"./af.js": 159,
	"./ar": 166,
	"./ar-dz": 160,
	"./ar-dz.js": 160,
	"./ar-kw": 161,
	"./ar-kw.js": 161,
	"./ar-ly": 162,
	"./ar-ly.js": 162,
	"./ar-ma": 163,
	"./ar-ma.js": 163,
	"./ar-sa": 164,
	"./ar-sa.js": 164,
	"./ar-tn": 165,
	"./ar-tn.js": 165,
	"./ar.js": 166,
	"./az": 167,
	"./az.js": 167,
	"./be": 168,
	"./be.js": 168,
	"./bg": 169,
	"./bg.js": 169,
	"./bm": 170,
	"./bm.js": 170,
	"./bn": 172,
	"./bn-bd": 171,
	"./bn-bd.js": 171,
	"./bn.js": 172,
	"./bo": 173,
	"./bo.js": 173,
	"./br": 174,
	"./br.js": 174,
	"./bs": 175,
	"./bs.js": 175,
	"./ca": 176,
	"./ca.js": 176,
	"./cs": 177,
	"./cs.js": 177,
	"./cv": 178,
	"./cv.js": 178,
	"./cy": 179,
	"./cy.js": 179,
	"./da": 180,
	"./da.js": 180,
	"./de": 183,
	"./de-at": 181,
	"./de-at.js": 181,
	"./de-ch": 182,
	"./de-ch.js": 182,
	"./de.js": 183,
	"./dv": 184,
	"./dv.js": 184,
	"./el": 185,
	"./el.js": 185,
	"./en-au": 186,
	"./en-au.js": 186,
	"./en-ca": 187,
	"./en-ca.js": 187,
	"./en-gb": 188,
	"./en-gb.js": 188,
	"./en-ie": 189,
	"./en-ie.js": 189,
	"./en-il": 190,
	"./en-il.js": 190,
	"./en-in": 191,
	"./en-in.js": 191,
	"./en-nz": 192,
	"./en-nz.js": 192,
	"./en-sg": 193,
	"./en-sg.js": 193,
	"./eo": 194,
	"./eo.js": 194,
	"./es": 198,
	"./es-do": 195,
	"./es-do.js": 195,
	"./es-mx": 196,
	"./es-mx.js": 196,
	"./es-us": 197,
	"./es-us.js": 197,
	"./es.js": 198,
	"./et": 199,
	"./et.js": 199,
	"./eu": 200,
	"./eu.js": 200,
	"./fa": 201,
	"./fa.js": 201,
	"./fi": 202,
	"./fi.js": 202,
	"./fil": 203,
	"./fil.js": 203,
	"./fo": 204,
	"./fo.js": 204,
	"./fr": 207,
	"./fr-ca": 205,
	"./fr-ca.js": 205,
	"./fr-ch": 206,
	"./fr-ch.js": 206,
	"./fr.js": 207,
	"./fy": 208,
	"./fy.js": 208,
	"./ga": 209,
	"./ga.js": 209,
	"./gd": 210,
	"./gd.js": 210,
	"./gl": 211,
	"./gl.js": 211,
	"./gom-deva": 212,
	"./gom-deva.js": 212,
	"./gom-latn": 213,
	"./gom-latn.js": 213,
	"./gu": 214,
	"./gu.js": 214,
	"./he": 215,
	"./he.js": 215,
	"./hi": 216,
	"./hi.js": 216,
	"./hr": 217,
	"./hr.js": 217,
	"./hu": 218,
	"./hu.js": 218,
	"./hy-am": 219,
	"./hy-am.js": 219,
	"./id": 220,
	"./id.js": 220,
	"./is": 221,
	"./is.js": 221,
	"./it": 223,
	"./it-ch": 222,
	"./it-ch.js": 222,
	"./it.js": 223,
	"./ja": 224,
	"./ja.js": 224,
	"./jv": 225,
	"./jv.js": 225,
	"./ka": 226,
	"./ka.js": 226,
	"./kk": 227,
	"./kk.js": 227,
	"./km": 228,
	"./km.js": 228,
	"./kn": 229,
	"./kn.js": 229,
	"./ko": 230,
	"./ko.js": 230,
	"./ku": 231,
	"./ku.js": 231,
	"./ky": 232,
	"./ky.js": 232,
	"./lb": 233,
	"./lb.js": 233,
	"./lo": 234,
	"./lo.js": 234,
	"./lt": 235,
	"./lt.js": 235,
	"./lv": 236,
	"./lv.js": 236,
	"./me": 237,
	"./me.js": 237,
	"./mi": 238,
	"./mi.js": 238,
	"./mk": 239,
	"./mk.js": 239,
	"./ml": 240,
	"./ml.js": 240,
	"./mn": 241,
	"./mn.js": 241,
	"./mr": 242,
	"./mr.js": 242,
	"./ms": 244,
	"./ms-my": 243,
	"./ms-my.js": 243,
	"./ms.js": 244,
	"./mt": 245,
	"./mt.js": 245,
	"./my": 246,
	"./my.js": 246,
	"./nb": 247,
	"./nb.js": 247,
	"./ne": 248,
	"./ne.js": 248,
	"./nl": 250,
	"./nl-be": 249,
	"./nl-be.js": 249,
	"./nl.js": 250,
	"./nn": 251,
	"./nn.js": 251,
	"./oc-lnc": 252,
	"./oc-lnc.js": 252,
	"./pa-in": 253,
	"./pa-in.js": 253,
	"./pl": 254,
	"./pl.js": 254,
	"./pt": 256,
	"./pt-br": 255,
	"./pt-br.js": 255,
	"./pt.js": 256,
	"./ro": 257,
	"./ro.js": 257,
	"./ru": 258,
	"./ru.js": 258,
	"./sd": 259,
	"./sd.js": 259,
	"./se": 260,
	"./se.js": 260,
	"./si": 261,
	"./si.js": 261,
	"./sk": 262,
	"./sk.js": 262,
	"./sl": 263,
	"./sl.js": 263,
	"./sq": 264,
	"./sq.js": 264,
	"./sr": 266,
	"./sr-cyrl": 265,
	"./sr-cyrl.js": 265,
	"./sr.js": 266,
	"./ss": 267,
	"./ss.js": 267,
	"./sv": 268,
	"./sv.js": 268,
	"./sw": 269,
	"./sw.js": 269,
	"./ta": 270,
	"./ta.js": 270,
	"./te": 271,
	"./te.js": 271,
	"./tet": 272,
	"./tet.js": 272,
	"./tg": 273,
	"./tg.js": 273,
	"./th": 274,
	"./th.js": 274,
	"./tk": 275,
	"./tk.js": 275,
	"./tl-ph": 276,
	"./tl-ph.js": 276,
	"./tlh": 277,
	"./tlh.js": 277,
	"./tr": 278,
	"./tr.js": 278,
	"./tzl": 279,
	"./tzl.js": 279,
	"./tzm": 281,
	"./tzm-latn": 280,
	"./tzm-latn.js": 280,
	"./tzm.js": 281,
	"./ug-cn": 282,
	"./ug-cn.js": 282,
	"./uk": 283,
	"./uk.js": 283,
	"./ur": 284,
	"./ur.js": 284,
	"./uz": 286,
	"./uz-latn": 285,
	"./uz-latn.js": 285,
	"./uz.js": 286,
	"./vi": 287,
	"./vi.js": 287,
	"./x-pseudo": 288,
	"./x-pseudo.js": 288,
	"./yo": 289,
	"./yo.js": 289,
	"./zh-cn": 290,
	"./zh-cn.js": 290,
	"./zh-hk": 291,
	"./zh-hk.js": 291,
	"./zh-mo": 292,
	"./zh-mo.js": 292,
	"./zh-tw": 293,
	"./zh-tw.js": 293
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 514;

/***/ }),
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 577 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 578 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 579 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 580 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 581 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 582 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 584 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 587 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 588 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 589 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 590 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 592 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 593 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 594 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 595 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 596 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 597 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 599 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 602 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(601)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(777),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ee216bdc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(598)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(770),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cd511bbe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(716),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(685),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(710),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(713),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(729),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(715),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(717),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(784),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(778),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(687),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(753),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(693),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(738),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(714),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(758),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(739),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(590)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(746),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7346bd44",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(581)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(697),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1e7c89b1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(591)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(755),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7e5df4ac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(578)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(690),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-152dc068",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(594)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(764),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a5f88bf8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(597)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(769),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ca6df316",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(754),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(702),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(701),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(781),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(707),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(760),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(681),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(761),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(748),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(728),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(751),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(726),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(600)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(774),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-db446fa2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(783),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(768),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(583)
  __webpack_require__(582)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(708),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2702c22a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(706),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(686),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(742),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(691),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(684),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(749),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(584)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(712),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-31e72306",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(725),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(747),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(721),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(762),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(767),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(773),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(782),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(757),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(704),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(730),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(471),
  /* template */
  __webpack_require__(682),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(579)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(695),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1dfd1058",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(592)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(756),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-82b1981e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(587)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(722),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-48ff157a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(585)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(718),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3b2db28c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(776),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(700),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(683),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(752),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(705),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(732),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(596)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(766),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(737),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(589)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(745),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 681 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('p', [_c('button', {
    staticClass: "btn btn-sm btn-success",
    on: {
      "click": function($event) {
        return _vm.createPark()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("  Novo")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Parques Tecnológicos")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('DataTables', {
    attrs: {
      "tableId": "parks-table",
      "url": this.apiUrl,
      "columns": this.columns,
      "columnDefs": this.columnDefs
    }
  })], 1)]), _vm._v(" "), _c('notifier', {
    ref: "notifier"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "recover-password-modal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Recuperar Senha")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("Ao clicar em \"Ok\" um link para criação de uma nova senha será enviado por email ao parque. Deseja continuar?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "recover-password-modal-confirm",
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Ok")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "delete-park-modal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Excluir Parque")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("\n            Ao clicar em \"Ok\" o parque será excluída do sistema, bem como seus respectivos questionários e empresas associadas. \n            Esta ação é irreversível! Deseja continuar?\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "delete-park-modal-confirm",
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Ok")])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 682 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'form-group': true,
      'has-error': this.m_error !== null
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.field.label))]), _vm._v(" "), _c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "mask": ['###.###.###-##'],
      "type": "text",
      "masked": true,
      "placeholder": "Informe o CPF",
      "disabled": _vm.disabledAttribute
    },
    model: {
      value: (_vm.m_fieldAnswer.value),
      callback: function($$v) {
        _vm.$set(_vm.m_fieldAnswer, "value", $$v)
      },
      expression: "m_fieldAnswer.value"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 683 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "login-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.$config.imgDir + '/logo.png'
    }
  })]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "login-box-body",
    staticStyle: {
      "border-top": "4px solid #3c8dbc"
    }
  }, [_c('p', {
    staticClass: "login-box-msg"
  }, [_vm._v("Entrar")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group has-feedback"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "type": "text",
      "required": "",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-envelope form-control-feedback"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "senha",
      "id": "senha",
      "required": "",
      "placeholder": "Senha"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-lock form-control-feedback"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.loginError))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary pull-right",
    attrs: {
      "type": "submit",
      "disabled": !_vm.isValid()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.login.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-in"
  }), _vm._v("  Entrar\n            ")])])])]), _vm._v(" "), _c('br')])])])
},staticRenderFns: []}

/***/ }),
/* 684 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Informações Gerais - " + _vm._s(_vm.park.name))])]), _vm._v(" "), (_vm.quizTemplate) ? _c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, _vm._l((_vm.quizTemplate.questions), function(q) {
    return (_vm.quiz && q.isVisible) ? _c(_vm.getQuestionComponent(q), {
      key: q.uuid,
      ref: "questions",
      refInFor: true,
      tag: "component",
      attrs: {
        "question": q,
        "answer": _vm.getQuestionAnswer(q)
      },
      on: {
        "answerUpdated": _vm.onAnswerUpdated
      }
    }) : _vm._e()
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v("  Salvar\n            ")]), _vm._v(" "), _c('go-back-button')], 1)]) : _vm._e()])])]), _vm._v(" "), _c('notifier', {
    ref: "notifier"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 685 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer"
  }, [_c('div', {
    staticClass: "pull-right hidden-xs"
  }), _vm._v(" "), _c('strong', [_vm._v("Copyright © " + _vm._s(new Date().getFullYear()) + " " + _vm._s(_vm.creatorName) + " - "), _vm._m(0)]), _vm._v(" - Todos os direitos reservados.\n")])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo-interna.png"
    }
  })])
}]}

/***/ }),
/* 686 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('CmsTemplate', {
    attrs: {
      "pageName": 'parks',
      "pageTitle": _vm.$t('content.tecnoparks')
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-3 pull-right"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('content.byFocus')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.focus),
      expression: "focus"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.focus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.applyFilters]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('content.selectFocus')))]), _vm._v(" "), _c('option', [_vm._v("Aeronáutico")]), _vm._v(" "), _c('option', [_vm._v("Agronegócio")]), _vm._v(" "), _c('option', [_vm._v("Alimentos")]), _vm._v(" "), _c('option', [_vm._v("Economia criativa")]), _vm._v(" "), _c('option', [_vm._v("Eletrônica")]), _vm._v(" "), _c('option', [_vm._v("Energia")]), _vm._v(" "), _c('option', [_vm._v("Espacial")]), _vm._v(" "), _c('option', [_vm._v("Meio ambiente")]), _vm._v(" "), _c('option', [_vm._v("Mineral")]), _vm._v(" "), _c('option', [_vm._v("Petróleo e gás natural")]), _vm._v(" "), _c('option', [_vm._v("Química")]), _vm._v(" "), _c('option', [_vm._v("Recursos hídricos")]), _vm._v(" "), _c('option', [_vm._v("Saúde animal")]), _vm._v(" "), _c('option', [_vm._v("Saúde humana")]), _vm._v(" "), _c('option', [_vm._v("Tecnologia da informação")]), _vm._v(" "), _c('option', [_vm._v("Telecomunicações")]), _vm._v(" "), _c('option', [_vm._v("Transporte aquaviario e construção naval")]), _vm._v(" "), _c('option', [_vm._v("Transporte terrestre e hidroviário")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-3 pull-right"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('content.byState')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.state),
      expression: "state"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.applyFilters]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('content.selectState')))]), _vm._v(" "), _c('option', [_vm._v("AC")]), _vm._v(" "), _c('option', [_vm._v("AL")]), _vm._v(" "), _c('option', [_vm._v("AP")]), _vm._v(" "), _c('option', [_vm._v("AM")]), _vm._v(" "), _c('option', [_vm._v("BA")]), _vm._v(" "), _c('option', [_vm._v("CE")]), _vm._v(" "), _c('option', [_vm._v("DF")]), _vm._v(" "), _c('option', [_vm._v("ES")]), _vm._v(" "), _c('option', [_vm._v("GO")]), _vm._v(" "), _c('option', [_vm._v("MA")]), _vm._v(" "), _c('option', [_vm._v("MT")]), _vm._v(" "), _c('option', [_vm._v("MS")]), _vm._v(" "), _c('option', [_vm._v("MG")]), _vm._v(" "), _c('option', [_vm._v("PA")]), _vm._v(" "), _c('option', [_vm._v("PB")]), _vm._v(" "), _c('option', [_vm._v("PR")]), _vm._v(" "), _c('option', [_vm._v("PE")]), _vm._v(" "), _c('option', [_vm._v("PI")]), _vm._v(" "), _c('option', [_vm._v("RJ")]), _vm._v(" "), _c('option', [_vm._v("RN")]), _vm._v(" "), _c('option', [_vm._v("RS")]), _vm._v(" "), _c('option', [_vm._v("RO")]), _vm._v(" "), _c('option', [_vm._v("RR")]), _vm._v(" "), _c('option', [_vm._v("SC")]), _vm._v(" "), _c('option', [_vm._v("SP")]), _vm._v(" "), _c('option', [_vm._v("SE")]), _vm._v(" "), _c('option', [_vm._v("TO")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-3 pull-right"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('commons.stage')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stage),
      expression: "stage"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.stage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.applyFilters]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('content.selectStage')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Planejamento"
    }
  }, [_vm._v(_vm._s(_vm.$t('commons.planning')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Implantação"
    }
  }, [_vm._v(_vm._s(_vm.$t('commons.implantation')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Operação"
    }
  }, [_vm._v(_vm._s(_vm.$t('commons.operation')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-3 pull-right"
  }, [_c('label', {
    attrs: {
      "for": "search-text"
    }
  }, [_vm._v(_vm._s(_vm.$t('content.search')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-text",
      "type": "search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.parks.length < 1) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_c('h4', [_c('i', {
    staticClass: "icon fa fa-info"
  }), _vm._v(" " + _vm._s(_vm.$t('content.notFound')) + " ")]), _vm._v("\n        " + _vm._s(_vm.$t('content.noParksFound')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.filteredParks), function(park) {
    return _c('div', {
      key: park.id,
      staticClass: "col-xs-12 col-sm-4 col-lg-3"
    }, [_c('a', {
      attrs: {
        "tabindex": "0",
        "role": "button",
        "data-toggle": "popover",
        "data-trigger": "focus",
        "data-placement": "top",
        "data-html": "true",
        "data-content": _vm.getParkDataForTooltip(park)
      }
    }, [_c('div', {
      staticClass: "box box-solid"
    }, [_c('div', {
      staticClass: "box-header with-border m-box__header"
    }, [_c('h3', {
      staticClass: "box-title"
    }, [_vm._v(_vm._s(park.name))])]), _vm._v(" "), _c('div', {
      staticClass: "box-body"
    }, [_c('div', {
      staticClass: "m-box__logo-picture",
      style: ({
        'background-image': 'url(' + park.logoPicture + ')'
      })
    })])])])])
  }), 0), _vm._v(" "), _c('infinite-loading', {
    ref: "infiniteLoading",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 687 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Cms', {
    attrs: {
      "pageTitle": 'Conteúdo da Página de Parques',
      "pageName": 'parks'
    }
  })
},staticRenderFns: []}

/***/ }),
/* 688 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.title))])])])]), _vm._v(" "), (_vm.showViewMode) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localViewMode),
      expression: "localViewMode"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 'snapshot',
      "checked": _vm._q(_vm.localViewMode, 'snapshot')
    },
    on: {
      "change": function($event) {
        _vm.localViewMode = 'snapshot'
      }
    }
  }), _vm._v(" Por ano\n    ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localViewMode),
      expression: "localViewMode"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 'evolution',
      "checked": _vm._q(_vm.localViewMode, 'evolution')
    },
    on: {
      "change": function($event) {
        _vm.localViewMode = 'evolution'
      }
    }
  }), _vm._v(" Evolução\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localPeriodType),
      expression: "localPeriodType"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 'years',
      "checked": _vm._q(_vm.localPeriodType, 'years')
    },
    on: {
      "change": function($event) {
        _vm.localPeriodType = 'years'
      }
    }
  }), _vm._v(" Anos\n    ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localPeriodType),
      expression: "localPeriodType"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 'dates',
      "checked": _vm._q(_vm.localPeriodType, 'dates')
    },
    on: {
      "change": function($event) {
        _vm.localPeriodType = 'dates'
      }
    }
  }), _vm._v(" Datas\n    ")])]), _vm._v(" "), (_vm.localPeriodType === 'years' && _vm.isRange) ? [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.localStartYear),
      expression: "localStartYear",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.localStartYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.availableYears), function(year) {
    return _c('option', {
      key: 'start-' + year,
      attrs: {
        "disabled": year > _vm.localEndYear
      },
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.localEndYear),
      expression: "localEndYear",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.localEndYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.availableYears), function(year) {
    return _c('option', {
      key: 'end-' + year,
      attrs: {
        "disabled": year < _vm.localStartYear
      },
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  }), 0)])])] : _vm._e(), _vm._v(" "), (_vm.localPeriodType === 'years' && !_vm.isRange) ? [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.localYear),
      expression: "localYear",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.localYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.availableYears), function(year) {
    return _c('option', {
      key: year,
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  }), 0)] : _vm._e(), _vm._v(" "), (_vm.localPeriodType === 'dates') ? [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Data inicial")]), _vm._v(" "), _c('DatePicker', {
    attrs: {
      "bootstrapStyling": true,
      "language": _vm.datepickerLanguage,
      "value": _vm.startDateObject,
      "typeable": true,
      "format": "dd-MM-yyyy"
    },
    on: {
      "selected": _vm.onStartDateSelected
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Data final")]), _vm._v(" "), _c('DatePicker', {
    attrs: {
      "bootstrapStyling": true,
      "language": _vm.datepickerLanguage,
      "value": _vm.endDateObject,
      "typeable": true,
      "format": "dd-MM-yyyy"
    },
    on: {
      "selected": _vm.onEndDateSelected
    }
  })], 1)] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-4 col-md-2"
  }, [_c('p', {
    staticClass: "year-label"
  }, [_c('strong', [_vm._v("De")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-4 col-md-2"
  }, [_c('p', {
    staticClass: "year-label"
  }, [_c('strong', [_vm._v("Até")])])])
}]}

/***/ }),
/* 689 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'form-group': true,
      'has-error': this.m_error !== null
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.field.label))]), _vm._v(" "), _c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "mask": ['(##) ####-####', '(##) #####-####'],
      "type": "text",
      "masked": true,
      "placeholder": "Entre com o telefone",
      "disabled": _vm.disabledAttribute
    },
    model: {
      value: (_vm.m_fieldAnswer.value),
      callback: function($$v) {
        _vm.$set(_vm.m_fieldAnswer, "value", $$v)
      },
      expression: "m_fieldAnswer.value"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 690 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-table font-dark"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Exportação de dados - Parques")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row main-row"
  }, [_c('div', {
    staticClass: "col-md-offset-2 col-md-8 col-lg-offset-3 col-lg-6"
  }, [_c('div', {
    staticClass: "inner-box"
  }, [_c('ParksFilter', {
    attrs: {
      "parks": _vm.parks,
      "disabled": _vm.waitingDownload
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "disabled": _vm.waitingDownload || _vm.selectedParksIds.length === 0
    },
    on: {
      "click": _vm.handleDownloadClick
    }
  }, [_vm._v("\n              Baixar parques selecionados (Excel)  \n              "), (_vm.waitingDownload) ? _c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-primary confirmed-export-btn",
    attrs: {
      "disabled": _vm.waitingConfirmedDownload
    },
    on: {
      "click": _vm.handleConfirmedDownloadClick
    }
  }, [_vm._v("\n              Baixar parques com Informações Gerais confirmadas  \n              "), (_vm.waitingConfirmedDownload) ? _c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }) : _vm._e()])])])])])])
},staticRenderFns: []}

/***/ }),
/* 691 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Período para Respostas - " + _vm._s((new Date()).getFullYear()))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body center-block"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Data de abertura")]), _vm._v(" "), _c('DatePicker', {
    attrs: {
      "placeholder": "Selecione a data",
      "bootstrapStyling": true,
      "disabled": this.quizPeriod.id != null,
      "disabled-dates": _vm.disabledStartingDates,
      "language": _vm.datepickerLanguage
    },
    model: {
      value: (_vm.quizPeriod.startingDate),
      callback: function($$v) {
        _vm.$set(_vm.quizPeriod, "startingDate", $$v)
      },
      expression: "quizPeriod.startingDate"
    }
  }), _vm._v(" "), (_vm.errors.startingDate) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.startingDate))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Data de fechamento")]), _vm._v(" "), _c('DatePicker', {
    attrs: {
      "placeholder": "Selecione a data",
      "bootstrapStyling": true,
      "disabled-dates": _vm.disabledEndingDates,
      "language": _vm.datepickerLanguage
    },
    model: {
      value: (_vm.quizPeriod.endingDate),
      callback: function($$v) {
        _vm.$set(_vm.quizPeriod, "endingDate", $$v)
      },
      expression: "quizPeriod.endingDate"
    }
  }), _vm._v(" "), (_vm.errors.endingDate) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.endingDate))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Data limite para aprovação")]), _vm._v(" "), _c('DatePicker', {
    attrs: {
      "placeholder": "Selecione a data",
      "bootstrapStyling": true,
      "disabled-dates": _vm.disabledApprovalLimitDates,
      "language": _vm.datepickerLanguage
    },
    model: {
      value: (_vm.quizPeriod.approvalLimitDate),
      callback: function($$v) {
        _vm.$set(_vm.quizPeriod, "approvalLimitDate", $$v)
      },
      expression: "quizPeriod.approvalLimitDate"
    }
  }), _vm._v(" "), (_vm.errors.approvalLimitDate) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.approvalLimitDate))]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v("  Salvar\n        ")]), _vm._v(" "), _c('go-back-button')], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 692 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nome do Parceiro")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partner.name),
      expression: "partner.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "Entre com o nome do Parceiro"
    },
    domProps: {
      "value": (_vm.partner.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.partner, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.name) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "responsible"
    }
  }, [_vm._v("Nome do Responsável")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partner.responsible),
      expression: "partner.responsible"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "responsible",
      "placeholder": "Entre com o nome do Responsável"
    },
    domProps: {
      "value": (_vm.partner.responsible)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.partner, "responsible", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.responsible) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.responsible))]) : _vm._e()]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Contato")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partner.email),
      expression: "partner.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email",
      "placeholder": "Entre com o email"
    },
    domProps: {
      "value": (_vm.partner.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.partner, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.email) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.email))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "mask": ['(##) ####-####', '(##) #####-####'],
      "id": "phone",
      "type": "text",
      "masked": true,
      "placeholder": "Entre com o telefone"
    },
    model: {
      value: (_vm.partner.phone),
      callback: function($$v) {
        _vm.$set(_vm.partner, "phone", $$v)
      },
      expression: "partner.phone"
    }
  }), _vm._v(" "), (_vm.errors.phone) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.phone))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v("  Salvar\n      ")]), _vm._v(" "), _c('go-back-button')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 693 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Adicionar Empresa ao " + _vm._s(this.park.initials))])]), _vm._v(" "), _c('CompanyForm', {
    attrs: {
      "company": _vm.company,
      "errors": _vm.errors,
      "onSubmit": _vm.onSubmit
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 694 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'form-group': true,
      'has-error': this.m_error !== null
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.field.label))]), _vm._v(" "), _c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "mask": ['##.###.###/####-##'],
      "type": "text",
      "masked": true,
      "placeholder": "Informe o CNPJ",
      "disabled": _vm.disabledAttribute
    },
    model: {
      value: (_vm.m_fieldAnswer.value),
      callback: function($$v) {
        _vm.$set(_vm.m_fieldAnswer, "value", $$v)
      },
      expression: "m_fieldAnswer.value"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 695 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart font-dark"
  }), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Relatórios - Questionários")])]), _vm._v(" "), (!_vm.isRenderingReports) ? _c('section', {
    staticClass: "content"
  }, [_c('button', {
    staticClass: "btn btn-primary top-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.renderReports()
      }
    }
  }, [_vm._v("Gerar")]), _vm._v(" "), _c('div', {
    staticClass: "row main-row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-9"
  }, [_c('div', {
    staticClass: "report-row"
  }, [_c('h4', [_vm._v("\n              Eixo do Questionário\n              "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectAll(_vm.axes)
      }
    }
  }, [_vm._v("Selecionar todos")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearSelected(_vm.axes)
      }
    }
  }, [_vm._v("Limpar")])]), _vm._v(" "), _c('div', {
    staticClass: "axes-container"
  }, _vm._l((_vm.axes), function(axis) {
    return _c('span', {
      class: {
        highlight: axis.isSelected
      },
      on: {
        "click": function($event) {
          axis.isSelected = !axis.isSelected
        }
      }
    }, [_vm._v("\n                " + _vm._s(axis.description) + "\n              ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('div', {
    staticClass: "report-row"
  }, [_c('p', [_c('strong', [_vm._v("Ano")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "center-inside-col"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.year),
      expression: "year"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.year = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.getAvailableYears), function(year) {
    return _c('option', {
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row main-row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [((_vm.availableReports.length > 0 || _vm.respondents.length > 0) && (_vm.userHasAdminRole || _vm.userHasPartnerRole)) ? _c('div', {
    staticClass: "report-row"
  }, [_c('h4', [_vm._v("\n              Respondentes\n              "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectAll(_vm.respondents)
      }
    }
  }, [_vm._v("Selecionar todos")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearSelected(_vm.respondents)
      }
    }
  }, [_vm._v("Limpar")])]), _vm._v(" "), _vm._l((_vm.respondents), function(park) {
    return _c('div', {
      key: park.id,
      staticClass: "checkbox"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (park.isSelected),
        expression: "park.isSelected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(park.isSelected) ? _vm._i(park.isSelected, null) > -1 : (park.isSelected)
      },
      on: {
        "change": function($event) {
          var $$a = park.isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(park, "isSelected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(park, "isSelected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(park, "isSelected", $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(park.name) + "\n              ")])])
  })], 2) : _vm._e(), _vm._v(" "), ((_vm.availableReports.length > 0 || _vm.respondents.length > 0) && _vm.userHasParkRole) ? _c('div', {
    staticClass: "report-row"
  }, [_c('h4', [_vm._v("\n              Respondentes\n              "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectAll(_vm.respondents)
      }
    }
  }, [_vm._v("Todos os Parques")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectCurrentAuthenticatedParkAsRespondent()
      }
    }
  }, [_vm._v("Apenas eu")])]), _vm._v(" "), (_vm.isAllRespondentsSelected) ? _c('p', [_vm._v("Você visualizará relatórios referentes às respostas de todos os Parques Tecnológicos cadastrados na plataforma que responderam o questionário no ano selecionado.")]) : _vm._e(), _vm._v(" "), (!_vm.isAllRespondentsSelected && _vm.isCurrentAuthenticatedParkSelected) ? _c('p', [_vm._v("Você visualizará relatórios referentes às respostas do seu questionário no ano selecionado.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-8"
  }, [((_vm.availableReports.length > 0 || _vm.respondents.length > 0)) ? _c('div', {
    staticClass: "report-row"
  }, [_c('h4', [_vm._v("\n              Relatórios\n              "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectAll(_vm.availableReports)
      }
    }
  }, [_vm._v("Selecionar todos")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearSelected(_vm.availableReports)
      }
    }
  }, [_vm._v("Limpar")])]), _vm._v(" "), _vm._l((_vm.availableReports), function(report) {
    return _c('div', {
      key: report.id,
      staticClass: "checkbox"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (report.isSelected),
        expression: "report.isSelected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(report.isSelected) ? _vm._i(report.isSelected, null) > -1 : (report.isSelected)
      },
      on: {
        "change": function($event) {
          var $$a = report.isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(report, "isSelected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(report, "isSelected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(report, "isSelected", $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(report.title) + "\n              ")])])
  })], 2) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.isRenderingReports) ? _c('section', {
    staticClass: "content"
  }, [_c('button', {
    staticClass: "btn btn-primary top-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isRenderingReports = false
      }
    }
  }, [_vm._v("Voltar")]), _vm._v(" "), _c('div', {
    staticClass: "row text-center display-flex"
  }, _vm._l((_vm.selectedReports), function(report) {
    return _c('div', {
      key: report.id,
      staticClass: "col-xs-12 col-lg-6"
    }, [_c(_vm.getReportComponent(report), {
      tag: "component",
      attrs: {
        "data": report.data
      }
    })], 1)
  }), 0)]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 696 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.park.name),
      expression: "park.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "Entre com o nome do parque"
    },
    domProps: {
      "value": (_vm.park.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.park, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.name) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "initials"
    }
  }, [_vm._v("Sigla")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.park.initials),
      expression: "park.initials"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "initials",
      "placeholder": "Entre com a sigla do parque"
    },
    domProps: {
      "value": (_vm.park.initials)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.park, "initials", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.initials) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.initials))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "cnpj"
    }
  }, [_vm._v("Cnpj")]), _vm._v(" "), _c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "mask": ['##.###.###/####-##'],
      "id": "cnpj",
      "type": "text",
      "masked": true,
      "placeholder": "Entre com o Cnpj"
    },
    model: {
      value: (_vm.park.cnpj),
      callback: function($$v) {
        _vm.$set(_vm.park, "cnpj", $$v)
      },
      expression: "park.cnpj"
    }
  }), _vm._v(" "), (_vm.errors.cnpj) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.cnpj))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "legalResponsible"
    }
  }, [_vm._v("Responsável Legal")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.park.legalResponsible),
      expression: "park.legalResponsible"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "legalResponsible",
      "placeholder": "Entre com o nome do responsável legal"
    },
    domProps: {
      "value": (_vm.park.legalResponsible)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.park, "legalResponsible", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.legalResponsible) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.legalResponsible))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "website"
    }
  }, [_vm._v("Website")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.park.website),
      expression: "park.website"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "website",
      "placeholder": "Entre com o website"
    },
    domProps: {
      "value": (_vm.park.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.park, "website", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.website) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.website))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "instagram"
    }
  }, [_vm._v("Instagram")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.park.instagram),
      expression: "park.instagram"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "instagram",
      "placeholder": "Entre com o Instagram"
    },
    domProps: {
      "value": (_vm.park.instagram)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.park, "instagram", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.instagram) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.instagram))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "linkedin"
    }
  }, [_vm._v("Linkedin")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.park.linkedin),
      expression: "park.linkedin"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "linkedin",
      "placeholder": "Entre com o Linkedin"
    },
    domProps: {
      "value": (_vm.park.linkedin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.park, "linkedin", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.linkedin) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.linkedin))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "currentStage"
    }
  }, [_vm._v("Estágio em que se encontra o parque tecnológico")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.park.currentStage),
      expression: "park.currentStage"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "currentStage"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.park, "currentStage", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Selecione...")]), _vm._v(" "), _c('option', [_vm._v("Planejamento")]), _vm._v(" "), _c('option', [_vm._v("Implantação")]), _vm._v(" "), _c('option', [_vm._v("Operação")])]), _vm._v(" "), (_vm.errors.currentStage) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.currentStage))]) : _vm._e()]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "street"
    }
  }, [_vm._v("Rua")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.park.street),
      expression: "park.street"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "street",
      "placeholder": "Entre com a rua"
    },
    domProps: {
      "value": (_vm.park.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.park, "street", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.street) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.street))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "neighborhood"
    }
  }, [_vm._v("Bairro")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.park.neighborhood),
      expression: "park.neighborhood"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "neighborhood",
      "placeholder": "Entre com o bairro"
    },
    domProps: {
      "value": (_vm.park.neighborhood)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.park, "neighborhood", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.neighborhood) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.neighborhood))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "number"
    }
  }, [_vm._v("Número")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.park.number),
      expression: "park.number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "number",
      "placeholder": "Entre com o número"
    },
    domProps: {
      "value": (_vm.park.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.park, "number", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.number) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.number))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "state"
    }
  }, [_vm._v("Estado")]), _vm._v(" "), _c('model-select', {
    staticClass: "form-control",
    attrs: {
      "options": _vm.states,
      "id": "state",
      "placeholder": "Entre com o estado",
      "custom-attr": _vm.customSelectItemClass
    },
    model: {
      value: (_vm.park.state),
      callback: function($$v) {
        _vm.$set(_vm.park, "state", $$v)
      },
      expression: "park.state"
    }
  }), _vm._v(" "), (_vm.errors.state) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.state))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "city"
    }
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('model-select', {
    staticClass: "form-control",
    attrs: {
      "options": _vm.cities,
      "id": "city",
      "placeholder": "Entre com a cidade",
      "custom-attr": _vm.customSelectItemClass
    },
    model: {
      value: (_vm.park.city),
      callback: function($$v) {
        _vm.$set(_vm.park, "city", $$v)
      },
      expression: "park.city"
    }
  }), _vm._v(" "), (_vm.errors.city) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.city))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "postalCode"
    }
  }, [_vm._v("CEP")]), _vm._v(" "), _c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "mask": ['#####-###'],
      "id": "postalCode",
      "type": "text",
      "masked": true,
      "placeholder": "Entre com o CEP"
    },
    model: {
      value: (_vm.park.postalCode),
      callback: function($$v) {
        _vm.$set(_vm.park, "postalCode", $$v)
      },
      expression: "park.postalCode"
    }
  }), _vm._v(" "), (_vm.errors.postalCode) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.postalCode))]) : _vm._e()], 1)])])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Contato")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.park.email),
      expression: "park.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email",
      "placeholder": "Entre com o email"
    },
    domProps: {
      "value": (_vm.park.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.park, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.email) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.email))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "phoneNumber"
    }
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "mask": ['(##) ####-####', '(##) #####-####'],
      "id": "phoneNumber",
      "type": "text",
      "masked": true,
      "placeholder": "Entre com o telefone"
    },
    model: {
      value: (_vm.park.phoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.park, "phoneNumber", $$v)
      },
      expression: "park.phoneNumber"
    }
  }), _vm._v(" "), (_vm.errors.phoneNumber) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.phoneNumber))]) : _vm._e()], 1)]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Logo")]), _vm._v(" "), _c('small', [_vm._v("Tamanho recomendado: 200x200px")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(this.park['id'] !== undefined) ? _c('img', {
    attrs: {
      "src": _vm.park.logoPicture
    }
  }) : _vm._e()]), _vm._v(" "), _c('vue-base64-file-upload', {
    staticClass: "text-center",
    attrs: {
      "accept": "image/png,image/jpeg",
      "image-class": "v1-image",
      "input-class": "v1-input",
      "max-size": _vm.customImageMaxSize,
      "placeholder": 'Clique para fazer o upload do logo',
      "disable-preview": this.park['id'] !== undefined
    },
    on: {
      "size-exceeded": _vm.onSizeExceeded,
      "load": _vm.onLoad
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v("  Salvar\n      ")]), _vm._v(" "), _c('go-back-button')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 697 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-table font-dark"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Exportação de dados - Informações Gerais dos Parques")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row main-row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "inner-box"
  }, [_c('ParksFilter', {
    attrs: {
      "parks": _vm.parks,
      "disabled": _vm.waitingDownload
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "inner-box"
  }, [_c('h4', [_vm._v("Filtrar Parques concebidos a partir de")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "center-inside-col"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedYear),
      expression: "selectedYear"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.waitingDownload
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.availableYears), function(year) {
    return _c('option', {
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  }), 0)])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "disabled": _vm.waitingDownload || _vm.selectedParksIds.length === 0
    },
    on: {
      "click": _vm.handleDownloadClick
    }
  }, [_vm._v("\n              Baixar arquivo em formato Excel  \n              "), (_vm.waitingDownload) ? _c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }) : _vm._e()])])])])])])
},staticRenderFns: []}

/***/ }),
/* 698 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'form-group': true,
      'has-error': this.m_error !== null
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.field.label))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v("R$")]), _vm._v(" "), _c('vue-autonumeric', {
    staticClass: "form-control",
    attrs: {
      "options": ['Brazilian', {
        currencySymbol: '',
        emptyInputBehavior: 'null',
        minimumValue: '0'
      }],
      "disabled": _vm.disabledAttribute
    },
    model: {
      value: (_vm.m_fieldAnswer.value),
      callback: function($$v) {
        _vm.$set(_vm.m_fieldAnswer, "value", $$v)
      },
      expression: "m_fieldAnswer.value"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 699 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'form-group': true,
      'has-error': this.m_error !== null
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.field.label))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.m_fieldAnswer.value),
      expression: "m_fieldAnswer.value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Preencha o campo",
      "disabled": _vm.disabledAttribute
    },
    domProps: {
      "value": (_vm.m_fieldAnswer.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.m_fieldAnswer, "value", $event.target.value)
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 700 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "login-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.$config.imgDir + '/logo.png'
    }
  })]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "login-box-body",
    staticStyle: {
      "border-top": "4px solid #3c8dbc"
    }
  }, [_c('p', {
    staticClass: "login-box-msg"
  }, [_vm._v("Recuperar Senha")]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "required": "",
      "placeholder": "Digite seu e-mail"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-envelope form-control-feedback"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('router-link', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "to": "/login"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" Voltar\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary pull-right",
    attrs: {
      "type": "submit",
      "disabled": !_vm.email || _vm.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v("  Enviar\n          ")])])]), _vm._v(" "), (_vm.sent) ? _c('p', {
    staticClass: "text-green",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_vm._v("\n        Se o e-mail existir, você receberá um link para redefinir sua senha (verifique em sua caixa de entrada).\n      ")]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 701 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('p', [_c('button', {
    staticClass: "btn btn-sm btn-success",
    on: {
      "click": function($event) {
        return _vm.createNews()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("  Novo")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Notícias")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('DataTables', {
    attrs: {
      "tableId": "news-table",
      "url": this.apiUrl,
      "columns": this.columns,
      "columnDefs": this.columnDefs,
      "order": [
        [1, 'desc']
      ]
    }
  })], 1)]), _vm._v(" "), _c('notifier', {
    ref: "notifier"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "delete-news-modal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Excluir Notícia")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("\n            Ao clicar em \"Ok\" a notícia será excluída do sistema.\n            Esta ação é irreversível! Deseja continuar?\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "delete-news-modal-confirm",
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Ok")])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 702 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Editar Notícia")])]), _vm._v(" "), _c('NewsForm', {
    attrs: {
      "news": _vm.news,
      "errors": _vm.errors,
      "onSubmit": _vm.onSubmit
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 703 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.question.statement))]), _vm._v(" "), (_vm.m_error) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.m_error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid box-primary"
  }, [_c('div', {
    staticClass: "box-body"
  }, _vm._l((_vm.question.fields), function(field) {
    return _c(_vm.getFieldComponent(field), {
      key: field.uuid,
      ref: "fields",
      refInFor: true,
      tag: "component",
      attrs: {
        "field": field,
        "fieldAnswer": _vm.getFieldAnswer(field),
        "isDisabled": _vm.disabledAttribute
      },
      on: {
        "fieldUpdated": _vm.onFieldUpdated
      }
    })
  }), 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 704 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.parkOffersPreIncubation) ? _c('ItemsQuestion', {
    ref: "child",
    attrs: {
      "question": _vm.question,
      "answer": _vm.answer,
      "isDisabled": _vm.isDisabled
    },
    on: {
      "answerUpdated": _vm.onAnswerUpdated
    }
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 705 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "m-news list-unstyled"
  }, _vm._l((_vm.newsCollection), function(news) {
    return _c('li', {
      staticClass: "m-news__item"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'ReadNews',
          params: {
            id: news.id
          }
        }
      }
    }, [_vm._v(_vm._s(news.title))])], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Editar Parque Tecnológico")])]), _vm._v(" "), _c('ParkForm', {
    attrs: {
      "park": _vm.park,
      "errors": _vm.errors,
      "onSubmit": _vm.onSubmit
    }
  })], 1)])]), _vm._v(" "), _c('notifier', {
    ref: "notifier"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 708 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-map"
  }, [_c('ul', {
    staticClass: "m-map__options list-unstyled"
  }, [_c('li', [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showParksMarkers),
      expression: "showParksMarkers"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showParksMarkers) ? _vm._i(_vm.showParksMarkers, null) > -1 : (_vm.showParksMarkers)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showParksMarkers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showParksMarkers = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showParksMarkers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showParksMarkers = $$c
        }
      }, _vm.onLayerSelectionChange]
    }
  }), _vm._v(" " + _vm._s(_vm.$t('content.tecnoparks')) + "\n        ")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showCompaniesMarkers),
      expression: "showCompaniesMarkers"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showCompaniesMarkers) ? _vm._i(_vm.showCompaniesMarkers, null) > -1 : (_vm.showCompaniesMarkers)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showCompaniesMarkers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showCompaniesMarkers = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showCompaniesMarkers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showCompaniesMarkers = $$c
        }
      }, _vm.onLayerSelectionChange]
    }
  }), _vm._v(" " + _vm._s(_vm.$t('commons.companies')) + "\n        ")])])])]), _vm._v(" "), _c('div', {
    ref: "mapContainer",
    staticClass: "m-map__canvas",
    style: (_vm.mapCanvasStyle)
  }), _vm._v(" "), (_vm.hasActiveLayer) ? _c('div', {
    staticClass: "m-map__legend"
  }, [_c('strong', [_vm._v(_vm._s(_vm.legendTitle))]), _vm._v(" "), _c('span', {
    staticClass: "m-map__legend-year"
  }, [_vm._v(_vm._s(_vm.currentYear))]), _vm._v(" "), _c('div', {
    staticClass: "m-map__legend-scale"
  }, [_c('span', {
    staticClass: "m-map__legend-min"
  }, [_vm._v("0")]), _vm._v(" "), _c('span', {
    staticClass: "m-map__legend-gradient",
    style: (_vm.legendGradientStyle)
  }), _vm._v(" "), _c('span', {
    staticClass: "m-map__legend-max"
  }, [_vm._v(_vm._s(_vm.maxStateCount))])]), _vm._v(" "), (_vm.showParksMarkers && _vm.showCompaniesMarkers) ? _c('div', {
    staticClass: "m-map__legend-hint"
  }, [_c('span', {
    staticClass: "m-map__legend-dot m-map__legend-dot--parks"
  }), _vm._v(" " + _vm._s(_vm.$t('content.tecnoparks')) + "\n      "), _c('span', {
    staticClass: "m-map__legend-dot m-map__legend-dot--companies"
  }), _vm._v(" " + _vm._s(_vm.$t('commons.companies')) + "\n    ")]) : _vm._e()]) : _c('p', {
    staticClass: "m-map__legend m-map__legend--empty"
  }, [_vm._v(_vm._s(_vm.$t('content.mapLegendEmpty')))])])
},staticRenderFns: []}

/***/ }),
/* 709 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    domProps: {
      "innerHTML": _vm._s(_vm.question.statement)
    }
  }), _vm._v(" "), _vm._l((_vm.question.itemsRows), function(itemRow, rowIndex) {
    return _c('div', {
      staticClass: "row"
    }, [_c('h4', {
      staticClass: "col-xs-12 text-muted",
      domProps: {
        "innerHTML": _vm._s(itemRow.label)
      }
    }), _vm._v(" "), _vm._l((itemRow.fields), function(field, fieldIndex) {
      return [_c('div', {
        staticClass: "col-xs-12 col-md-6 col-lg-4"
      }, [_c(_vm.getFieldComponent(field), {
        key: field.uuid,
        ref: "fields",
        refInFor: true,
        tag: "component",
        attrs: {
          "field": field,
          "fieldAnswer": _vm.getFieldAnswer(itemRow, field),
          "isDisabled": _vm.disabledAttribute
        },
        on: {
          "fieldUpdated": _vm.onFieldUpdated
        }
      })], 1)]
    })], 2)
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Sair"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" sair")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo"
  }, [_c('span', {
    staticClass: "logo-mini"
  }, [_vm._v("I")]), _vm._v(" "), _c('span', {
    staticClass: "logo-lg"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo-interna.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
}]}

/***/ }),
/* 711 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.question.statement))]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.disabledAttribute
    },
    domProps: {
      "value": _vm.getBooleanAnswerValue()
    },
    on: {
      "change": _vm.onBooleanAnswerChange
    }
  }, [_c('option', {
    domProps: {
      "value": 'true'
    }
  }, [_vm._v("Sim")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'false'
    }
  }, [_vm._v("Não")])]), _vm._v(" "), (_vm.m_error) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.m_error))]) : _vm._e(), _vm._v(" "), (_vm.getBooleanAnswerValue()) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.rowsWhenTrueLength), function(rowCounter) {
    return _c('div', {
      class: [_vm.rowsWhenTrueLength === 1 ? 'col-xs-12' : 'col-sm-6']
    }, [_c('div', {
      staticClass: "box box-solid box-primary"
    }, [_c('div', {
      staticClass: "box-body"
    }, _vm._l((_vm.question.fieldsWhenTrue), function(f) {
      return _c(_vm.getFieldComponent(f), {
        key: f.uuid,
        ref: "fieldsWhenTrue",
        refInFor: true,
        tag: "component",
        attrs: {
          "field": f,
          "fieldAnswer": _vm.getFieldAnswer(rowCounter, f),
          "isDisabled": _vm.disabledAttribute
        },
        on: {
          "fieldUpdated": _vm.onFieldUpdated
        }
      })
    }), 1)])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.getBooleanAnswerValue() && !_vm.disabledAttribute) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default center-block pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeRow.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default center-block pull-left",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addRow.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 712 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Validar Questionário - \"" + _vm._s(_vm.parkName) + "\" - " + _vm._s(_vm.referenceYear))]), _vm._v(" "), (this.questionsByAxis) ? _c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('tabs', {
    staticClass: "nav-tabs-custom",
    attrs: {
      "value": this.activeAxis
    },
    on: {
      "active": _vm.setActiveAxis
    }
  }, _vm._l((Object.keys(this.questionsByAxis)), function(axis, index) {
    return _c('tab', {
      key: index,
      attrs: {
        "header": _vm.axisHeader(axis)
      }
    }, _vm._l((_vm.questionsByAxis[axis]), function(q) {
      return (_vm.quiz && q.isVisible) ? _c(_vm.getQuestionComponent(q), {
        key: q.uuid,
        ref: "questions",
        refInFor: true,
        tag: "component",
        attrs: {
          "question": q,
          "isDisabled": true,
          "answer": _vm.getQuestionAnswer(q)
        }
      }) : _vm._e()
    }), 1)
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "footer-btns"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v("  Voltar\n                ")]), _vm._v(" "), _c('span', [_c('button', {
    staticClass: "btn btn-sm btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.disapproveCurrentAxis()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v("  Reprovar Eixo\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.approveCurrentAxis()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("  Aprovar Eixo\n                  ")])]), _vm._v(" "), _c('span', [_c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "button",
      "disabled": !_vm.isAbleToDisapproveQuiz,
      "data-toggle": "modal",
      "data-target": "#disapproval-modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  }), _vm._v("  Reprovar Questionário\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button",
      "disabled": !_vm.isAbleToApproveQuiz,
      "data-toggle": "modal",
      "data-target": "#approval-modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v("  Aprovar Questionário\n                  ")])])])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "disapproval-modal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Reprovar Questionário")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("Ao clicar em \"Ok\" o questionário será reprovado e devolvido ao parque tecnológico. Deseja continuar?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.disapproveQuiz()
      }
    }
  }, [_vm._v("Ok")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "approval-modal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Aprovar Questionário")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("Ao clicar em \"Ok\" o questionário será aprovado e finalizado. Deseja continuar?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.approveQuiz()
      }
    }
  }, [_vm._v("Ok")])])])])]), _vm._v(" "), _c('notifier', {
    ref: "notifier"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 713 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('ul', {
    staticClass: "sidebar-menu"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'EditPark',
        params: {
          id: this.getParkId()
        }
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', [_vm._v("Meu Cadastro")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'CompaniesHome',
        params: {
          parkId: this.getParkId()
        }
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" "), _c('span', [_vm._v("Empresas")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'GeneralInformations',
        params: {
          parkId: this.getParkId()
        }
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-info"
  }), _vm._v(" "), _c('span', [_vm._v("Informações Gerais")])])]), _vm._v(" "), (this.showAnswerMenu) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'ParkQuiz',
        params: {
          'parkId': this.getParkId(),
          'referenceYear': this.getReferenceYear(),
          'quizUuid': this.parkQuizUuid
        }
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-question"
  }), _vm._v(" "), _c('span', [_vm._v("Responder")])])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'QuizReports'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v("\n          Relatórios\n        ")])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "header"
  }, [_c('strong', [_vm._v("Menu")])])
}]}

/***/ }),
/* 714 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "error-page"
  }, [_c('h2', {
    staticClass: "headline text-red"
  }, [_vm._v("404")]), _vm._v(" "), _c('div', {
    staticClass: "error-content"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n          Clique "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Homepage'
      },
      "exact": ""
    }
  }, [_c('a', [_c('span', [_vm._v("aqui")])])]), _vm._v(" para continuar da página inicial\n        ")], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('i', {
    staticClass: "fa fa-warning text-red"
  }), _vm._v(" Página não encontrada.")])
}]}

/***/ }),
/* 715 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('ul', {
    staticClass: "sidebar-menu"
  }, [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu",
    style: (_vm.reportsMenuStyle)
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'RelatorioEstatistico'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Estatístico Nacional")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'QuizReports'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v("Questionários")])]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu",
    style: (_vm.reportsMenuStyle)
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'SegmentedChartsReports'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-line-chart"
  }), _vm._v(" "), _c('span', [_vm._v("Gráficos")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'SegmentedTextualReports'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v(" "), _c('span', [_vm._v("Textuais")])])])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Parks'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-tree"
  }), _vm._v(" "), _c('span', [_vm._v("Parques")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Partners'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-group"
  }), _vm._v(" "), _c('span', [_vm._v("Parceiros")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'NewsHome'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-bullhorn"
  }), _vm._v(" "), _c('span', [_vm._v("Notícias")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'MailingHome'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" "), _c('span', [_vm._v("Envio de e-mails")])])]), _vm._v(" "), _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu",
    style: (_vm.cmsMenuStyle)
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ParksCms'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" Parques Tecnológicos")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'CompaniesCms'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" Empresas")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'AboutCms'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" Institucional")])])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'QuizPeriod'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" "), _c('span', [_vm._v("Período para Resposta")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ParkQuizValidationList'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" "), _c('span', [_vm._v("Validação de Questionários")])])]), _vm._v(" "), _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(4), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu",
    style: (_vm.exportMenuStyle)
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ExportParks'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" "), _c('span', [_vm._v("Parques")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ExportCompanies'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" "), _c('span', [_vm._v("Empresas")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ExportParkQuiz'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" "), _c('span', [_vm._v("Questionários")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ExportGeneralInformation'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" "), _c('span', [_vm._v("Informações Gerais")])])])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ParkStageAudit'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-wrench"
  }), _vm._v(" "), _c('span', [_vm._v("Manutenção")])])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "header"
  }, [_c('strong', [_vm._v("Menu")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" "), _c('span', [_vm._v("Relatórios")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-center"
  }), _vm._v(" "), _c('span', [_vm._v("Segmentados")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-files-o"
  }), _vm._v(" "), _c('span', [_vm._v("Gerenciador de Conteúdo")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v(" "), _c('span', [_vm._v("Exportar")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
}]}

/***/ }),
/* 716 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('ul', {
    staticClass: "sidebar-menu"
  }, [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu",
    style: (_vm.reportsMenuStyle)
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'QuizReports'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v("Questionários")])]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu",
    style: (_vm.reportsMenuStyle)
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'SegmentedChartsReports'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-line-chart"
  }), _vm._v(" "), _c('span', [_vm._v("Gráficos")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'SegmentedTextualReports'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v(" "), _c('span', [_vm._v("Textuais")])])])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Parks'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-tree"
  }), _vm._v(" "), _c('span', [_vm._v("Parques")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Partners'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-group"
  }), _vm._v(" "), _c('span', [_vm._v("Parceiros")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'NewsHome'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-bullhorn"
  }), _vm._v(" "), _c('span', [_vm._v("Notícias")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'MailingHome'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" "), _c('span', [_vm._v("Envio de e-mails")])])]), _vm._v(" "), _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu",
    style: (_vm.cmsMenuStyle)
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ParksCms'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" Parques Tecnológicos")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'CompaniesCms'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" Empresas")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'AboutCms'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" Institucional")])])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'QuizPeriod'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" "), _c('span', [_vm._v("Período para Resposta")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ParkQuizValidationList'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" "), _c('span', [_vm._v("Validação de Questionários")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ParkStageAudit'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-wrench"
  }), _vm._v(" "), _c('span', [_vm._v("Manutenção")])])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "header"
  }, [_c('strong', [_vm._v("Menu")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" "), _c('span', [_vm._v("Relatórios")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-center"
  }), _vm._v(" "), _c('span', [_vm._v("Segmentados")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-files-o"
  }), _vm._v(" "), _c('span', [_vm._v("Gerenciador de Conteúdo")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
}]}

/***/ }),
/* 717 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_vm._v("\n  Welcome Admin!\n")])
},staticRenderFns: []}

/***/ }),
/* 718 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart font-dark"
  }), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Relatórios - Segmentados - Textuais")])]), _vm._v(" "), (!_vm.isRenderingReports) ? _c('section', {
    staticClass: "content"
  }, [_c('button', {
    staticClass: "btn btn-primary top-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.renderReports()
      }
    }
  }, [_vm._v("Gerar")]), _vm._v(" "), _c('div', {
    staticClass: "row main-row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-9 col-lg-9"
  }, [_c('div', {
    staticClass: "report-row"
  }, [_c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectAll()
      }
    }
  }, [_vm._v("Selecionar todos")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearSelected()
      }
    }
  }, [_vm._v("Limpar")]), _vm._v(" "), _vm._l((_vm.reports), function(report) {
    return _c('div', {
      key: report.id,
      staticClass: "checkbox"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (report.isSelected),
        expression: "report.isSelected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(report.isSelected) ? _vm._i(report.isSelected, null) > -1 : (report.isSelected)
      },
      on: {
        "change": function($event) {
          var $$a = report.isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(report, "isSelected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(report, "isSelected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(report, "isSelected", $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(report.title) + "\n              ")])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-2"
  }, [_c('ReportPeriodFilter', {
    attrs: {
      "is-range": _vm.viewMode === 'evolution',
      "show-view-mode": true,
      "view-mode": _vm.viewMode,
      "start-year": _vm.startYear,
      "end-year": _vm.endYear,
      "year": _vm.year,
      "title": "Período"
    },
    on: {
      "change": _vm.onPeriodChange
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isRenderingReports) ? _c('section', {
    staticClass: "content"
  }, [_c('button', {
    staticClass: "btn btn-primary top-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isRenderingReports = false
      }
    }
  }, [_vm._v("Voltar")]), _vm._v(" "), _c('div', {
    staticClass: "row text-center display-flex"
  }, _vm._l((_vm.selectedReports), function(report) {
    return _c('div', {
      key: report.id,
      class: _vm.viewMode === 'evolution' ? 'col-xs-12' : 'col-xs-12 col-lg-6'
    }, [(report.evolutionData) ? _c('EvolutionTextualReport', {
      attrs: {
        "title": report.title,
        "metadata": report.evolutionData.metadata,
        "entries": report.evolutionData.entries,
        "report-type": report.type
      }
    }) : _c(_vm.getReportComponent(report), {
      tag: "component",
      attrs: {
        "data": report.data
      }
    })], 1)
  }), 0)]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": _vm.tableId
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.columns), function(c) {
    return _c('th', [_vm._v(" " + _vm._s(c.label))])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 720 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("\n    Filtrar por Parque\n    "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.selectAllParks()
      }
    }
  }, [_vm._v("\n      Selecionar todos\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.clearSelectedParks()
      }
    }
  }, [_vm._v("\n      Limpar\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "scrollable-content"
  }, _vm._l((_vm.parks), function(park) {
    return _c('div', {
      key: park.id,
      staticClass: "checkbox"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (park.isSelected),
        expression: "park.isSelected"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": _vm.disabled
      },
      domProps: {
        "checked": Array.isArray(park.isSelected) ? _vm._i(park.isSelected, null) > -1 : (park.isSelected)
      },
      on: {
        "change": function($event) {
          var $$a = park.isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(park, "isSelected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(park, "isSelected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(park, "isSelected", $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(park.name) + "\n      ")])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 721 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.parkOffersAssociation) ? _c('ItemsQuestion', {
    ref: "child",
    attrs: {
      "question": _vm.question,
      "answer": _vm.answer,
      "isDisabled": _vm.isDisabled
    },
    on: {
      "answerUpdated": _vm.onAnswerUpdated
    }
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 722 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart font-dark"
  }), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Relatórios - Segmentados - Gráficos")])]), _vm._v(" "), (!_vm.isRenderingReports) ? _c('section', {
    staticClass: "content"
  }, [_c('button', {
    staticClass: "btn btn-primary top-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.renderReports()
      }
    }
  }, [_vm._v("Gerar")]), _vm._v(" "), _c('div', {
    staticClass: "row main-row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-9 col-lg-9"
  }, [_c('div', {
    staticClass: "report-row"
  }, [_c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectAll()
      }
    }
  }, [_vm._v("Selecionar todos")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearSelected()
      }
    }
  }, [_vm._v("Limpar")]), _vm._v(" "), _vm._l((_vm.reports), function(report) {
    return _c('div', {
      key: report.id,
      staticClass: "checkbox"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (report.isSelected),
        expression: "report.isSelected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(report.isSelected) ? _vm._i(report.isSelected, null) > -1 : (report.isSelected)
      },
      on: {
        "change": function($event) {
          var $$a = report.isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(report, "isSelected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(report, "isSelected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(report, "isSelected", $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(report.title) + "\n              ")])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-2"
  }, [_c('ReportPeriodFilter', {
    attrs: {
      "start-year": _vm.startYear,
      "end-year": _vm.endYear
    },
    on: {
      "change": _vm.onPeriodChange
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isRenderingReports) ? _c('section', {
    staticClass: "content"
  }, [_c('button', {
    staticClass: "btn btn-primary top-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isRenderingReports = false
      }
    }
  }, [_vm._v("Voltar")]), _vm._v(" "), _c('div', {
    staticClass: "row main-row text-center"
  }, _vm._l((_vm.selectedReports), function(report) {
    return _c('div', {
      key: report.id,
      staticClass: "report-container"
    }, [_c('ReportChartContainer', {
      attrs: {
        "data": report.data,
        "chart-component": _vm.getReportComponent(report)
      }
    })], 1)
  }), 0)]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 723 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.question.statement))]), _vm._v(" "), (_vm.m_error) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.m_error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.rows), function(row, rowIndex) {
    return _c('div', {
      key: row.id,
      class: [_vm.rowsLength === 1 ? 'col-xs-12' : 'col-sm-6']
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "box-body"
    }, [_vm._l((_vm.question.fields), function(field, fieldIndex) {
      return _c(_vm.getFieldComponent(field), {
        key: ("field-" + (row.id) + "-" + (field.uuid)),
        tag: "component",
        attrs: {
          "field": field,
          "fieldAnswer": _vm.getFieldAnswer(rowIndex, field),
          "isDisabled": _vm.disabledAttribute
        },
        on: {
          "fieldUpdated": _vm.onFieldUpdated
        }
      })
    }), _vm._v(" "), (!_vm.disabledAttribute) ? _c('button', {
      staticClass: "btn btn-sm btn-default center-block pull-right",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeRow(rowIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus"
    })]) : _vm._e()], 2)])])
  }), 0), _vm._v(" "), (!_vm.disabledAttribute) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default center-block",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addRow.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 724 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.name),
      expression: "company.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "Entre com o nome da empresa"
    },
    domProps: {
      "value": (_vm.company.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.name) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "cnpj"
    }
  }, [_vm._v("Cnpj")]), _vm._v(" "), _c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "mask": ['##.###.###/####-##'],
      "id": "cnpj",
      "type": "text",
      "masked": true,
      "placeholder": "Entre com o Cnpj"
    },
    model: {
      value: (_vm.company.cnpj),
      callback: function($$v) {
        _vm.$set(_vm.company, "cnpj", $$v)
      },
      expression: "company.cnpj"
    }
  }), _vm._v(" "), (_vm.errors.cnpj) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.cnpj))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "parkEntryYear"
    }
  }, [_vm._v("Ano de Ingresso no Parque")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.parkEntryYear),
      expression: "company.parkEntryYear"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parkEntryYear"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.company, "parkEntryYear", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    },
    domProps: {
      "value": 1
    }
  }), _vm._v(" "), _vm._l((_vm.getYearsRange), function(year) {
    return _c('option', [_vm._v(_vm._s(year))])
  })], 2), _vm._v(" "), (_vm.errors.parkEntryYear) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.parkEntryYear))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "creationDate"
    }
  }, [_vm._v("Data de Criação da Empresa")]), _vm._v(" "), _c('DatePicker', {
    attrs: {
      "id": "creationDate",
      "placeholder": "Selecione a data",
      "bootstrapStyling": true,
      "language": _vm.datepickerLanguage,
      "value": _vm.getCreationDateAsDateObject()
    },
    on: {
      "selected": _vm.onCreationDateSelected
    }
  }), _vm._v(" "), (_vm.errors.creationDate) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.creationDate))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Áreas de Atuação")]), _vm._v(" "), _vm._l((_vm.areasOfExpertise), function(area) {
    return _c('div', [_c('label', {
      staticClass: "checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.company.areasOfExpertise),
        expression: "company.areasOfExpertise"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": area,
        "checked": Array.isArray(_vm.company.areasOfExpertise) ? _vm._i(_vm.company.areasOfExpertise, area) > -1 : (_vm.company.areasOfExpertise)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.company.areasOfExpertise,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = area,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.company, "areasOfExpertise", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.company, "areasOfExpertise", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.company, "areasOfExpertise", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(area))])])])
  }), _vm._v(" "), (_vm.errors.areasOfExpertise) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.areasOfExpertise))]) : _vm._e()], 2)])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "street"
    }
  }, [_vm._v("Rua")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.street),
      expression: "company.street"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "street",
      "placeholder": "Entre com a rua"
    },
    domProps: {
      "value": (_vm.company.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "street", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.street) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.street))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "neighborhood"
    }
  }, [_vm._v("Bairro")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.neighborhood),
      expression: "company.neighborhood"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "neighborhood",
      "placeholder": "Entre com o bairro"
    },
    domProps: {
      "value": (_vm.company.neighborhood)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "neighborhood", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.neighborhood) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.neighborhood))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "number"
    }
  }, [_vm._v("Número")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.number),
      expression: "company.number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "number",
      "placeholder": "Entre com o número"
    },
    domProps: {
      "value": (_vm.company.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "number", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.number) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.number))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "state"
    }
  }, [_vm._v("Estado")]), _vm._v(" "), _c('model-select', {
    staticClass: "form-control",
    attrs: {
      "options": _vm.states,
      "id": "state",
      "placeholder": "Entre com o estado",
      "custom-attr": _vm.customSelectItemClass
    },
    model: {
      value: (_vm.company.state),
      callback: function($$v) {
        _vm.$set(_vm.company, "state", $$v)
      },
      expression: "company.state"
    }
  }), _vm._v(" "), (_vm.errors.state) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.state))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "city"
    }
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('model-select', {
    staticClass: "form-control",
    attrs: {
      "options": _vm.cities,
      "id": "city",
      "placeholder": "Entre com a cidade",
      "custom-attr": _vm.customSelectItemClass
    },
    model: {
      value: (_vm.company.city),
      callback: function($$v) {
        _vm.$set(_vm.company, "city", $$v)
      },
      expression: "company.city"
    }
  }), _vm._v(" "), (_vm.errors.city) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.city))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "postalCode"
    }
  }, [_vm._v("CEP")]), _vm._v(" "), _c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "mask": ['#####-###'],
      "id": "postalCode",
      "type": "text",
      "masked": true,
      "placeholder": "Entre com o CEP"
    },
    model: {
      value: (_vm.company.postalCode),
      callback: function($$v) {
        _vm.$set(_vm.company, "postalCode", $$v)
      },
      expression: "company.postalCode"
    }
  }), _vm._v(" "), (_vm.errors.postalCode) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.postalCode))]) : _vm._e()], 1)])])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Contato")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.email),
      expression: "company.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email",
      "placeholder": "Entre com o email"
    },
    domProps: {
      "value": (_vm.company.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.email) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.email))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "phoneNumber"
    }
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "mask": ['(##) ####-####', '(##) #####-####'],
      "id": "phoneNumber",
      "type": "text",
      "masked": true,
      "placeholder": "Entre com o telefone"
    },
    model: {
      value: (_vm.company.phoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.company, "phoneNumber", $$v)
      },
      expression: "company.phoneNumber"
    }
  }), _vm._v(" "), (_vm.errors.phoneNumber) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.phoneNumber))]) : _vm._e()], 1)]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Logo")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(this.company['id'] !== undefined) ? _c('img', {
    attrs: {
      "src": _vm.company.logoPicture
    }
  }) : _vm._e()]), _vm._v(" "), _c('vue-base64-file-upload', {
    staticClass: "text-center",
    attrs: {
      "accept": "image/png,image/jpeg",
      "image-class": "v1-image",
      "input-class": "v1-input",
      "max-size": _vm.customImageMaxSize,
      "placeholder": 'Clique para fazer o upload do logo',
      "disable-preview": this.company['id'] !== undefined
    },
    on: {
      "size-exceeded": _vm.onSizeExceeded,
      "load": _vm.onLoad
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('go-back-button')], 1)])
},staticRenderFns: []}

/***/ }),
/* 725 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Validação de Questionários")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "park-quiz-validation-table"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Parque Tecnológico")]), _vm._v(" "), _c('th', [_vm._v("Ano")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.waittingApprovalParkQuizzes), function(row) {
    return (_vm.waittingApprovalParkQuizzes.length > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(row.parkName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.parkQuizYear))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-xs btn-primary",
      on: {
        "click": function($event) {
          return _vm.validateParkQuiz(row.parkId, row.parkName, row.parkQuizUuid, row.parkQuizYear)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v("  Validar\n            ")])])]) : _vm._e()
  }), 0)])])])])
},staticRenderFns: []}

/***/ }),
/* 726 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('CmsTemplate', {
    attrs: {
      "pageName": 'companies',
      "pageTitle": _vm.$t('commons.companies')
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-3 pull-right"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('content.byFocus')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.focus),
      expression: "focus"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.focus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.applyFilters]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('content.selectFocus')))]), _vm._v(" "), _c('option', [_vm._v("Aeronáutico")]), _vm._v(" "), _c('option', [_vm._v("Agronegócio")]), _vm._v(" "), _c('option', [_vm._v("Alimentos")]), _vm._v(" "), _c('option', [_vm._v("Economia criativa")]), _vm._v(" "), _c('option', [_vm._v("Eletrônica")]), _vm._v(" "), _c('option', [_vm._v("Energia")]), _vm._v(" "), _c('option', [_vm._v("Espacial")]), _vm._v(" "), _c('option', [_vm._v("Meio ambiente")]), _vm._v(" "), _c('option', [_vm._v("Mineral")]), _vm._v(" "), _c('option', [_vm._v("Petróleo e gás natural")]), _vm._v(" "), _c('option', [_vm._v("Química")]), _vm._v(" "), _c('option', [_vm._v("Recursos hídricos")]), _vm._v(" "), _c('option', [_vm._v("Saúde animal")]), _vm._v(" "), _c('option', [_vm._v("Saúde humana")]), _vm._v(" "), _c('option', [_vm._v("Tecnologia da informação")]), _vm._v(" "), _c('option', [_vm._v("Telecomunicações")]), _vm._v(" "), _c('option', [_vm._v("Transporte aquaviario e construção naval")]), _vm._v(" "), _c('option', [_vm._v("Transporte terrestre e hidroviário")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t("commons.companies")))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('DataTables', {
    attrs: {
      "tableId": "parks-table",
      "url": this.getApiUrl(),
      "columns": this.columns,
      "columnDefs": this.columnDefs,
      "order": [
        [1, 'asc']
      ]
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 727 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    domProps: {
      "innerHTML": _vm._s(_vm.question.statement)
    }
  }), _vm._v(" "), (!_vm.question.allowsMultipleChoice) ? _c('select', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.disabledAttribute
    },
    domProps: {
      "value": _vm.getAnswerValueForSelect()
    },
    on: {
      "change": _vm.onChange
    }
  }, _vm._l((_vm.question.options), function(o) {
    return _c('option', [_vm._v(_vm._s(o))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.question.allowsMultipleChoice) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.question.options), function(o) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [_c('label', {
      staticClass: "checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.m_answer.value),
        expression: "m_answer.value"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": _vm.disabledAttribute
      },
      domProps: {
        "value": o,
        "checked": Array.isArray(_vm.m_answer.value) ? _vm._i(_vm.m_answer.value, o) > -1 : (_vm.m_answer.value)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.m_answer.value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = o,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.m_answer, "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.m_answer, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.m_answer, "value", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(o)
      }
    })])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.m_error) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.m_error))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('p', [_c('button', {
    staticClass: "btn btn-sm btn-success",
    on: {
      "click": function($event) {
        return _vm.createPartner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("  Novo")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Parceiros")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "partners-table"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("E-mail")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.partnersCollection), function(partner) {
    return (Object.keys(_vm.partnersCollection).length > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(partner.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(partner.email))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-xs btn-primary",
      on: {
        "click": function($event) {
          return _vm.editPartner(partner.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v("\n                   Editar\n               ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#delete-partner-modal"
      },
      on: {
        "click": function($event) {
          return _vm.onDeletePartnerButtonClick(partner.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    }), _vm._v("\n                  Excluir\n              ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs btn-warning recover-password",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#recover-password-modal"
      },
      on: {
        "click": function($event) {
          return _vm.onRecoverPasswordPartnerButtonClick(partner.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-unlock-alt"
    }), _vm._v("\n                  Recuperar Senha\n              ")])])]) : _vm._e()
  }), 0)])])]), _vm._v(" "), _c('notifier', {
    ref: "notifier"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "delete-partner-modal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Excluir Parceiro")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("\n            Ao clicar em \"Ok\" o parceiro será excluído do sistema.\n            Esta ação é irreversível! Deseja continuar?\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "delete-partner-modal-confirm",
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Ok")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "recover-password-modal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Recuperar Senha")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("Ao clicar em \"Ok\" um link para criação de uma nova senha será enviado por email ao parceiro. Deseja continuar?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "recover-password-modal-confirm",
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Ok")])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('ul', {
    staticClass: "sidebar-menu"
  }, [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu",
    style: (_vm.reportsMenuStyle)
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'QuizReports'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v("Questionários")])]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu",
    style: (_vm.reportsMenuStyle)
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'SegmentedChartsReports'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-line-chart"
  }), _vm._v(" "), _c('span', [_vm._v("Gráficos")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'SegmentedTextualReports'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v(" "), _c('span', [_vm._v("Textuais")])])])], 1)])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "header"
  }, [_c('strong', [_vm._v("Menu")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" "), _c('span', [_vm._v("Relatórios")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-center"
  }), _vm._v(" "), _c('span', [_vm._v("Segmentados")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
}]}

/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.parkOffersResidency) ? _c('ItemsQuestion', {
    ref: "child",
    attrs: {
      "question": _vm.question,
      "answer": _vm.answer,
      "isDisabled": _vm.isDisabled
    },
    on: {
      "answerUpdated": _vm.onAnswerUpdated
    }
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homepage__wrapper"
  }, [_c('PortalHeader'), _vm._v(" "), _c('main', {
    staticClass: "m-main"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._t("default", function() {
    return [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-5"
    }, [_c('div', {
      staticClass: "m-block m-block--big-height"
    }, [_c('p', {
      staticClass: "m-block__title"
    }, [_c('i', {
      staticClass: "m-block__icon fa fa-newspaper-o"
    }), _vm._v("\n                " + _vm._s(_vm.$t("content.news")) + "\n              ")]), _vm._v(" "), _c('news')], 1)]), _vm._v(" "), _c('div', {
      staticClass: "col-md-7"
    }, [_c('div', {
      staticClass: "m-block m-block--big-height"
    }, [_c('p', {
      staticClass: "m-block__title"
    }, [_c('i', {
      staticClass: "m-block__icon fa fa-map"
    }), _vm._v("\n                " + _vm._s(_vm.$t("content.map")) + "\n              ")]), _vm._v(" "), _c('PortalMap')], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-9"
    }, [_c('div', {
      staticClass: "m-block"
    }, [_c('div', {
      staticClass: "m-info"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6 col-sm-3 text-center m-info__title"
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('content.parksInOperationStage')))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6 col-sm-3 m-info__group"
    }, [_c('span', {
      staticClass: "m-info__text--big center-block"
    }, [_c('i', {
      staticClass: "fa fa-3x font-white fa-rocket m-info__icon"
    }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.indicators.parksInOperationStage))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6 col-sm-3 text-center"
    }, [_c('p', {
      staticClass: "m-info__text--small"
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('portal.revenues')))])]), _vm._v(" "), _c('p', {
      staticClass: "m-info__text center-block"
    }, [_c('strong', [_vm._v("R$ " + _vm._s(Number(_vm.indicators.revenuesEstimate).toLocaleString('pt-BR')))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6 col-sm-3 text-center"
    }, [_c('p', {
      staticClass: "m-info__text--small"
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('portal.taxes')))])]), _vm._v(" "), _c('p', {
      staticClass: "m-info__text center-block"
    }, [_c('strong', [_vm._v("R$ " + _vm._s(Number(_vm.indicators.taxesEstimate).toLocaleString('pt-BR')))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6 col-sm-3 text-center"
    }, [_c('p', {
      staticClass: "m-info__text--small"
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('portal.jobs')))])]), _vm._v(" "), _c('p', {
      staticClass: "m-info__text center-block"
    }, [_c('strong', [_vm._v(_vm._s(Number(_vm.indicators.jobsEstimate).toLocaleString('pt-BR')))])])])])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('div', {
      staticClass: "m-block"
    }, [_c('div', {
      staticClass: "m-info"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12 text-center m-info__title"
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('commons.companies')))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12 m-info__group"
    }, [_c('span', {
      staticClass: "m-info__text--big center-block"
    }, [_c('i', {
      staticClass: "fa fa-3x font-white fa-fighter-jet m-info__icon no-padding"
    }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.indicators.companies))])])])])])])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-9"
    }, [_c('div', {
      staticClass: "m-block"
    }, [_c('div', {
      staticClass: "m-info"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6 col-sm-3 text-center m-info__title"
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('content.parksInImplantationStage')))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6 col-sm-3 m-info__group"
    }, [_c('span', {
      staticClass: "m-info__text--big center-block"
    }, [_c('i', {
      staticClass: "fa fa-3x font-white fa-cogs m-info__icon"
    }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.indicators.parksInImplantationStage))])])])])])])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-9"
    }, [_c('div', {
      staticClass: "m-block"
    }, [_c('div', {
      staticClass: "m-info"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6 col-sm-3 text-center m-info__title"
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('content.parksInPlanningStage')))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6 col-sm-3 m-info__group"
    }, [_c('span', {
      staticClass: "m-info__text--big center-block"
    }, [_c('i', {
      staticClass: "fa fa-3x font-white fa-calendar-check-o m-info__icon"
    }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.indicators.parksInPlanningStage))])])])])])])])])]
  })], 2)]), _vm._v(" "), _c('PortalFooter')], 1)
},staticRenderFns: []}

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default", function() {
    return [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.content)
      }
    })]
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.pageTitle))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    class: [{
      'low-opacity': this.activeContent !== 'pt'
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "src": this.$config.imgDir + '/flag-brazil-32.png'
    },
    on: {
      "click": _vm.showPtContent
    }
  }), _vm._v(" "), _c('img', {
    class: [{
      'low-opacity': this.activeContent !== 'en'
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "src": this.$config.imgDir + '/flag-usa-32.png'
    },
    on: {
      "click": _vm.showEnContent
    }
  })]), _vm._v(" "), _c('div', [(this.activeContent === 'pt') ? _c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Texto em Portugês")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body pad"
  }, [_c('vue-html5-editor', {
    attrs: {
      "content": _vm.pageContent.portugueseBody,
      "height": 300
    },
    on: {
      "change": _vm.updatePortugueseData
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (this.activeContent === 'en') ? _c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Texto em Inglês")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body pad"
  }, [_c('vue-html5-editor', {
    attrs: {
      "content": _vm.pageContent.englishBody,
      "height": 300
    },
    on: {
      "change": _vm.updateEnglishData
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('notifier', {
    ref: "notifier"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Salvar")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'form-group': true,
      'has-error': this.m_error !== null
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.field.label))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.m_fieldAnswer.value),
      expression: "m_fieldAnswer.value"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.disabledAttribute
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.m_fieldAnswer, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    },
    domProps: {
      "value": null
    }
  }), _vm._v(" "), _vm._l((_vm.getYearsRange()), function(year) {
    return _c('option', [_vm._v(_vm._s(year))])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Título")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.news.title),
      expression: "news.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "title",
      "placeholder": "Entre com o título"
    },
    domProps: {
      "value": (_vm.news.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.news, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.title) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('DatePicker', {
    attrs: {
      "placeholder": "Selecione a data",
      "bootstrapStyling": true,
      "language": _vm.datepickerLanguage
    },
    model: {
      value: (_vm.news.dateTime),
      callback: function($$v) {
        _vm.$set(_vm.news, "dateTime", $$v)
      },
      expression: "news.dateTime"
    }
  }), _vm._v(" "), (_vm.errors.dateTime) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.dateTime))]) : _vm._e()], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body pad"
  }, [_c('vue-html5-editor', {
    attrs: {
      "content": _vm.news.content,
      "height": 300
    },
    on: {
      "change": _vm.updateContent
    }
  }), _vm._v(" "), (_vm.errors.content) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.content))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v("  Salvar\n      ")]), _vm._v(" "), _c('go-back-button')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Conteúdo")])])
}]}

/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "wrapper"
    }
  }, [_c('app-header'), _vm._v(" "), (_vm.userHasResearcherRole()) ? _c('researcher-sidebar') : _vm._e(), _vm._v(" "), (_vm.userHasAdminRole()) ? _c('admin-sidebar') : _vm._e(), _vm._v(" "), (_vm.userHasParkRole()) ? _c('park-sidebar') : _vm._e(), _vm._v(" "), (_vm.userHasPartnerRole()) ? _c('partner-sidebar') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 737 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Editar Empresa " + _vm._s(this.company.name))])]), _vm._v(" "), _c('CompanyForm', {
    attrs: {
      "company": _vm.company,
      "errors": _vm.errors,
      "onSubmit": _vm.onSubmit
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 739 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "error-page"
  }, [_c('h2', {
    staticClass: "headline text-red"
  }, [_vm._v("401")]), _vm._v(" "), _c('div', {
    staticClass: "error-content"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n          Clique "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Homepage'
      },
      "exact": ""
    }
  }, [_c('a', [_c('span', [_vm._v("aqui")])])]), _vm._v(" para continuar da página inicial\n        ")], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('i', {
    staticClass: "fa fa-warning text-red"
  }), _vm._v(" Não autorizado.")])
}]}

/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'form-group': true,
      'has-error': this.m_error !== null
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.field.label))]), _vm._v(" "), (!_vm.field.allowsMultipleChoice) ? _c('select', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.disabledAttribute
    },
    domProps: {
      "value": _vm.getAnswerValueForSelect()
    },
    on: {
      "change": _vm.onChange
    }
  }, _vm._l((_vm.field.options), function(o) {
    return _c('option', [_vm._v(_vm._s(o))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.field.allowsMultipleChoice) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.field.options), function(o) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [_c('label', {
      staticClass: "checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.m_fieldAnswer.value),
        expression: "m_fieldAnswer.value"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": _vm.disabledAttribute
      },
      domProps: {
        "value": o,
        "checked": Array.isArray(_vm.m_fieldAnswer.value) ? _vm._i(_vm.m_fieldAnswer.value, o) > -1 : (_vm.m_fieldAnswer.value)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.m_fieldAnswer.value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = o,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.m_fieldAnswer, "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.m_fieldAnswer, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.m_fieldAnswer, "value", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(o)
      }
    })])])
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 742 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('homepage', [_c('div', {
    staticClass: "m-block"
  }, [_c('h2', [_vm._v(_vm._s(_vm.news.title))]), _vm._v(" "), _c('div', {
    staticClass: "blog-single-head-date"
  }, [_c('p'), _c('div', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" Publicado em " + _vm._s(_vm.formatDate(_vm.news.dateTime)))]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.news.content)
    }
  })]), _vm._v(" "), _vm._t("default")], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 743 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('homepage', [_c('div', {
    staticClass: "m-block"
  }, [_c('h2', [_vm._v(_vm._s(_vm.pageTitle))]), _vm._v(" "), (this.$i18n.locale === 'pt') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(this.content.portugueseBody)
    }
  }) : _vm._e(), _vm._v(" "), (this.$i18n.locale === 'en') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(this.content.englishBody)
    }
  }) : _vm._e()]), _vm._v(" "), _vm._t("default")], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 744 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view'), _vm._v(" "), _c('vue-progress-bar'), _vm._v(" "), _c('notifications', {
    attrs: {
      "classes": "vue-notification notification"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 745 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-table font-dark"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Exportação de dados - Empresas")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row main-row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "inner-box"
  }, [_c('ParksFilter', {
    attrs: {
      "parks": _vm.parks,
      "disabled": _vm.waitingDownload
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "inner-box"
  }, [_c('h4', [_vm._v("Filtrar Empresas "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.alterLinked
    }
  }, [_vm._v(_vm._s(_vm.defaultLinked))]), _vm._v(" no ano de")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "center-inside-col"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedYear),
      expression: "selectedYear"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.waitingDownload
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.availableYears), function(year) {
    return _c('option', {
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  }), 0)])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "disabled": _vm.waitingDownload || _vm.selectedParksIds.length === 0
    },
    on: {
      "click": _vm.handleDownloadClick
    }
  }, [_vm._v("\n              Baixar arquivo em formato Excel  \n              "), (_vm.waitingDownload) ? _c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }) : _vm._e()])])])])])])
},staticRenderFns: []}

/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.parkOffersAcceleration) ? _c('ItemsQuestion', {
    ref: "child",
    attrs: {
      "question": _vm.question,
      "answer": _vm.answer,
      "isDisabled": _vm.isDisabled
    },
    on: {
      "answerUpdated": _vm.onAnswerUpdated
    }
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 748 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Editar Parceiro")])]), _vm._v(" "), _c('PartnerForm', {
    attrs: {
      "partner": _vm.partner,
      "errors": _vm.errors,
      "onSubmit": _vm.onSubmit
    }
  })], 1)])]), _vm._v(" "), _c('notifier', {
    ref: "notifier"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 749 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Responder Questionário")]), _vm._v(" "), (this.questionsByAxis) ? _c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('tabs', {
    staticClass: "nav-tabs-custom",
    attrs: {
      "value": this.activeAxis
    },
    on: {
      "active": _vm.setActiveAxis
    }
  }, _vm._l((Object.keys(this.questionsByAxis)), function(axis, index) {
    return _c('tab', {
      key: index,
      attrs: {
        "header": _vm.axisHeader(axis)
      }
    }, _vm._l((_vm.questionsByAxis[axis]), function(q) {
      return (_vm.quiz && q.isVisible) ? _c(_vm.getQuestionComponent(q), {
        key: q.uuid,
        ref: "questions",
        refInFor: true,
        tag: "component",
        attrs: {
          "question": q,
          "answer": _vm.getQuestionAnswer(q),
          "quizAnswers": _vm.quiz.answers
        },
        on: {
          "answerUpdated": _vm.onAnswerUpdated
        }
      }) : _vm._e()
    }), 1)
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success pull-right",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#send-for-approval-modal",
      "disabled": !_vm.isQuizAllowedToBeSent
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v("  Enviar\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-primary pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v("  Salvar\n              ")]), _vm._v(" "), _c('go-back-button')], 1)]) : _vm._e()])])])]), _vm._v(" "), _c('notifier', {
    ref: "notifier"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "send-for-approval-modal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Enviar Questionário")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("Ao clicar em \"Ok\" o questionário será enviado e não será mais possível alterar as respostas. Deseja continuar?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sendQuiz()
      }
    }
  }, [_vm._v("Ok")])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 750 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.question.statement))]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "value": _vm.getAnswerAsDateObject(),
      "placeholder": "Selecione a data",
      "bootstrapStyling": true,
      "language": _vm.datepickerLanguage,
      "required": _vm.question.required,
      "disabled": _vm.disabledAttribute,
      "disabled-dates": _vm.disabledDates
    },
    on: {
      "selected": _vm.onDateSelected
    }
  }), _vm._v(" "), (_vm.m_error) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.m_error))]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('CmsTemplate', {
    attrs: {
      "pageName": 'about',
      "pageTitle": _vm.$t('commons.about')
    }
  })
},staticRenderFns: []}

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "login-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.$config.imgDir + '/logo.png'
    }
  })]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "login-box-body",
    staticStyle: {
      "border-top": "4px solid #3c8dbc"
    }
  }, [_c('p', {
    staticClass: "login-box-msg"
  }, [_vm._v("Criar Senha")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group has-feedback"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password",
      "required": "",
      "placeholder": "Senha"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": _vm.validateForm,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-lock form-control-feedback"
  }), _vm._v(" "), _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.passwordError))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatPassword),
      expression: "repeatPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "repeatPassword",
      "id": "repeat-password",
      "required": "",
      "placeholder": "Repita a Senha"
    },
    domProps: {
      "value": (_vm.repeatPassword)
    },
    on: {
      "keyup": _vm.validateForm,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repeatPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-lock form-control-feedback"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary pull-right",
    attrs: {
      "type": "submit",
      "disabled": !_vm.isValid()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-in"
  }), _vm._v("  Salvar\n            ")])])])]), _vm._v(" "), _c('br')])])])
},staticRenderFns: []}

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [(this.park.currentStage === 'Operação') ? _c('p', [_c('button', {
    staticClass: "btn btn-sm btn-success",
    on: {
      "click": _vm.createCompany
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("  Novo")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Empresas do " + _vm._s(this.park.initials))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('DataTables', {
    attrs: {
      "tableId": "parks-table",
      "url": this.getApiUrl(),
      "columns": this.columns,
      "columnDefs": this.columnDefs
    }
  })], 1)]), _vm._v(" "), _c('go-back-button'), _vm._v(" "), _c('notifier', {
    ref: "notifier"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "delete-company-modal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Excluir Empresa")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("Ao clicar em \"Ok\" a empresa será excluída do sistema. Esta ação é irreversível! Deseja continuar?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "delete-company-modal-confirm",
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Ok")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "unlink-company-modal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Desligar Empresa")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v("Informe a data do desligamento para prosseguir:")]), _vm._v(" "), _c('DatePicker', {
    attrs: {
      "placeholder": "Selecione a data",
      "bootstrapStyling": true,
      "language": _vm.datepickerLanguage
    },
    model: {
      value: (_vm.unlinkCompanyDate),
      callback: function($$v) {
        _vm.unlinkCompanyDate = $$v
      },
      expression: "unlinkCompanyDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "unlink-company-modal-confirm",
      "type": "button",
      "data-dismiss": "modal",
      "disabled": !_vm.unlinkCompanyDate
    }
  }, [_vm._v("\n            Desligar\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "relink-company-modal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Religar Empresa")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v("Informe a data do religamento para prosseguir:")]), _vm._v(" "), _c('DatePicker', {
    attrs: {
      "placeholder": "Selecione a data",
      "bootstrapStyling": true,
      "language": _vm.datepickerLanguage
    },
    model: {
      value: (_vm.relinkCompanyDate),
      callback: function($$v) {
        _vm.relinkCompanyDate = $$v
      },
      expression: "relinkCompanyDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "relink-company-modal-confirm",
      "type": "button",
      "data-dismiss": "modal",
      "disabled": !_vm.relinkCompanyDate
    }
  }, [_vm._v("\n            Religar\n          ")])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Adicionar Notícia")])]), _vm._v(" "), _c('NewsForm', {
    attrs: {
      "news": _vm.news,
      "errors": _vm.errors,
      "onSubmit": _vm.onSubmit
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 755 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-table font-dark"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Exportação de dados - Questionários")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row main-row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "inner-box"
  }, [_c('ParksFilter', {
    attrs: {
      "parks": _vm.parks,
      "disabled": _vm.isDownloading
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "inner-box"
  }, [_c('h4', [_vm._v("Ano do Questionário")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "center-inside-col"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedYear),
      expression: "selectedYear"
    }],
    staticClass: "form-control year-select",
    attrs: {
      "disabled": _vm.isDownloading
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.availableYears.length === 0) ? _c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                      Carregando anos…\n                    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.availableYears), function(year) {
    return _c('option', {
      key: year,
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  })], 2)])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "disabled": _vm.isDownloading || _vm.selectedParksIds.length === 0
    },
    on: {
      "click": function($event) {
        return _vm.handleDownloadClick('original')
      }
    }
  }, [_vm._v("\n              Baixar Excel (formato original)\n              "), (_vm.waitingDownload === 'original') ? _c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-primary readable-export-btn",
    attrs: {
      "disabled": _vm.isDownloading || _vm.selectedParksIds.length === 0,
      "title": "Abas por eixo e coleções em formato longo (1 linha por item)"
    },
    on: {
      "click": function($event) {
        return _vm.handleDownloadClick('readable')
      }
    }
  }, [_vm._v("\n              Baixar Excel legível\n              "), (_vm.waitingDownload === 'readable') ? _c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "export-hint"
  }, [_vm._v("\n              A versão legível organiza as respostas por eixo e coloca coleções\n              (equipe, investimentos, âncoras etc.) em tabelas com uma linha por item.\n            ")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 756 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "box box-primary center-block relatorio-estatistico"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-dashboard font-dark"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Relatório Estatístico Nacional")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row filter-row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "filter-label"
  }, [_vm._v("\n            Ano de referência\n            "), _c('span', {
    staticClass: "filter-hint",
    attrs: {
      "tabindex": "0"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "filter-hint__bubble"
  }, [_vm._v(_vm._s(_vm.yearHint))])])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.year),
      expression: "year",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isBusy
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.year = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.availableYears), function(y) {
    return _c('option', {
      key: y,
      domProps: {
        "value": y
      }
    }, [_vm._v(_vm._s(y))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "filter-label"
  }, [_vm._v("\n            Ano comparativo\n            "), _c('span', {
    staticClass: "filter-hint",
    attrs: {
      "tabindex": "0"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "filter-hint__bubble"
  }, [_vm._v(_vm._s(_vm.compareYearHint))])])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.compareYear),
      expression: "compareYear"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isBusy
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.compareYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Nenhum")]), _vm._v(" "), _vm._l((_vm.compareYearOptions), function(y) {
    return _c('option', {
      key: 'c-' + y,
      domProps: {
        "value": y
      }
    }, [_vm._v(_vm._s(y))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 filter-actions"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.isBusy
    },
    on: {
      "click": _vm.loadRelatorio
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    class: {
      'fa-spin': _vm.loading
    }
  }), _vm._v("\n            Gerar relatório\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isBusy || !_vm.relatorio
    },
    on: {
      "click": _vm.downloadExcel
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    class: {
      'fa-spin': _vm.downloading === 'excel'
    }
  }), _vm._v("\n            Excel\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.isBusy || !_vm.relatorio
    },
    on: {
      "click": _vm.downloadPdf
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o",
    class: {
      'fa-spin': _vm.downloading === 'pdf'
    }
  }), _vm._v("\n            PDF\n          ")])])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("\n        Gerando relatório estatístico… isso pode levar vários minutos.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.downloading) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("\n        " + _vm._s(_vm.exportStatusMessage) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.infoMessage) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v(_vm._s(_vm.infoMessage))]) : _vm._e(), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), (_vm.relatorio) ? _c('div', {
    staticClass: "relatorio-summary"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "info-box bg-aqua"
  }, [_c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Ano")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.relatorio.year))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "info-box bg-green"
  }, [_c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Indicadores")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.relatorio.indicators.length))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "info-box bg-yellow"
  }, [_c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    staticClass: "fa fa-folder-open"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Seções")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.relatorio.sections.length))])])])]), _vm._v(" "), (_vm.summaryKpis.totalParques !== null) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "info-box bg-red"
  }, [_c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    staticClass: "fa fa-tree"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Parques em operação")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.summaryKpis.totalParques))])])])]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "text-muted generated-at"
  }, [_vm._v("\n          Gerado em " + _vm._s(_vm.formatGeneratedAt(_vm.relatorio.generatedAt)) + "\n          "), (_vm.relatorio.compareYear) ? _c('span', [_vm._v(" · Comparativo com " + _vm._s(_vm.relatorio.compareYear))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.relatorio) ? _c('div', {
    staticClass: "section-nav"
  }, _vm._l((_vm.relatorio.sections), function(section) {
    return _c('button', {
      key: section.id,
      staticClass: "btn btn-default btn-sm section-nav-btn",
      class: {
        active: _vm.activeSectionId === section.id
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.scrollToSection(section.id)
        }
      }
    }, [_vm._v("\n          " + _vm._s(section.label) + "\n        ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.relatorio) ? _c('div', _vm._l((_vm.relatorio.sections), function(section) {
    return _c('div', {
      key: section.id,
      staticClass: "report-section panel panel-default",
      attrs: {
        "id": 'section-' + section.id
      }
    }, [_c('div', {
      staticClass: "panel-heading",
      on: {
        "click": function($event) {
          return _vm.toggleSection(section.id)
        }
      }
    }, [_c('h3', {
      staticClass: "panel-title"
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.isSectionExpanded(section.id) ? 'fa-chevron-down' : 'fa-chevron-right'
    }), _vm._v("\n              " + _vm._s(section.label) + "\n              "), _c('span', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(section.indicators.length))])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isSectionExpanded(section.id)),
        expression: "isSectionExpanded(section.id)"
      }],
      staticClass: "panel-body"
    }, _vm._l((section.indicators), function(indicator) {
      return _c('IndicatorResult', {
        key: indicator.id,
        attrs: {
          "indicator": indicator,
          "chart-visible": _vm.isSectionExpanded(section.id)
        }
      })
    }), 1)])
  }), 0) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ItemsQuestion', {
    key: _vm.childKey,
    ref: "child",
    attrs: {
      "question": _vm.questionWithFilteredItemRows,
      "answer": _vm.answer,
      "isDisabled": _vm.isDisabled
    },
    on: {
      "answerUpdated": _vm.onAnswerUpdated
    }
  })
},staticRenderFns: []}

/***/ }),
/* 758 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "error-page"
  }, [_c('h2', {
    staticClass: "headline text-red"
  }, [_vm._v("500")]), _vm._v(" "), _c('div', {
    staticClass: "error-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("\n          Enquanto isto, você pode retornar à "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Homepage'
      },
      "exact": ""
    }
  }, [_c('a', [_c('span', [_vm._v("página inicial")])])]), _vm._v(" e continuar\n          a navegação.\n        ")], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('i', {
    staticClass: "fa fa-warning text-red"
  }), _vm._v(" Oops! Algo deu errado.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Por favor, entre em contato conosco com uma descrição dos passos realizados por você que o levaram até este erro.\n          "), _c('br'), _vm._v("\n          Trabalharemos para resolver o problema o mais rápido possível.\n        ")])
}]}

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'form-group': true,
      'has-error': this.m_error !== null
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.field.label))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.m_fieldAnswer.value),
      expression: "m_fieldAnswer.value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Entre com o e-mail",
      "disabled": _vm.disabledAttribute
    },
    domProps: {
      "value": (_vm.m_fieldAnswer.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.m_fieldAnswer, "value", $event.target.value)
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 760 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_vm._v("\n  Welcome Park!\n")])
},staticRenderFns: []}

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Adicionar Parceiro")])]), _vm._v(" "), _c('PartnerForm', {
    attrs: {
      "partner": _vm.partner,
      "errors": _vm.errors,
      "onSubmit": _vm.onSubmit
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.parkOffersCoworking) ? _c('ItemsQuestion', {
    ref: "child",
    attrs: {
      "question": _vm.question,
      "answer": _vm.answer,
      "isDisabled": _vm.isDisabled
    },
    on: {
      "answerUpdated": _vm.onAnswerUpdated
    }
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.metadata && _vm.metadata.filterScopeLabel) ? _c('div', {
    staticClass: "report-metadata"
  }, [_c('span', {
    staticClass: "label label-info"
  }, [_vm._v(_vm._s(_vm.metadata.filterScopeLabel))])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 764 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o font-dark"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Envio de e-mails")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row main-row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "inner-box"
  }, [_c('h4', [_vm._v("\n                Destinatários  \n                "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectAllParks()
      }
    }
  }, [_vm._v("Selecionar todos")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearSelectedParks()
      }
    }
  }, [_vm._v("Limpar")])]), _vm._v(" "), _c('div', {
    staticClass: "scrollable-content"
  }, _vm._l((_vm.parks), function(park) {
    return _c('div', {
      key: park.id,
      staticClass: "checkbox"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (park.isSelected),
        expression: "park.isSelected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(park.isSelected) ? _vm._i(park.isSelected, null) > -1 : (park.isSelected)
      },
      on: {
        "change": function($event) {
          var $$a = park.isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(park, "isSelected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(park, "isSelected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(park, "isSelected", $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(park.name) + "\n                  ")])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-8"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "inner-box"
  }, [(_vm.errors.recipients) ? _c('p', {
    staticClass: "text-red"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }, [_vm._v(" ")]), _vm._v("\n                  " + _vm._s(_vm.errors.recipients) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "subject"
    }
  }, [_vm._v("Assunto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subject),
      expression: "subject"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "subject",
      "placeholder": "Entre com o assunto"
    },
    domProps: {
      "value": (_vm.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subject = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.subject) ? _c('p', {
    staticClass: "text-red"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }, [_vm._v(" ")]), _vm._v("\n                    " + _vm._s(_vm.errors.subject) + "\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Corpo do e-mail")]), _vm._v(" "), _c('vue-html5-editor', {
    attrs: {
      "content": _vm.body,
      "height": 300
    },
    on: {
      "change": _vm.updateContent
    }
  }), _vm._v(" "), (_vm.errors.body) ? _c('p', {
    staticClass: "text-red"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }, [_vm._v(" ")]), _vm._v("\n                    " + _vm._s(_vm.errors.body) + "\n                  ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "submit",
      "disabled": _vm.isSending
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSend.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-send-o"
  }), _vm._v("  Enviar\n                  ")])])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-chart-container",
    class: _vm.containerClass
  }, [_c('ReportFilterBadge', {
    attrs: {
      "metadata": _vm.data.metadata
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "report-chart-canvas",
    style: (_vm.canvasStyle)
  }, [_c(_vm.chartComponent, {
    tag: "component",
    attrs: {
      "data": _vm.data
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),
/* 767 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DateQuestion', {
    ref: "child",
    attrs: {
      "question": _vm.question,
      "answer": _vm.answer,
      "isDisabled": _vm.isDisabled,
      "disableFutureDates": true
    },
    on: {
      "answerUpdated": _vm.onAnswerUpdated
    }
  })
},staticRenderFns: []}

/***/ }),
/* 768 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "m-header"
  }, [_c('div', {
    staticClass: "m-header__translate"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row text-right"
  }, [_c('img', {
    class: [{
      'low-opacity': this.$i18n.locale !== 'pt'
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "src": this.$config.imgDir + '/flag-brazil-32.png'
    },
    on: {
      "click": function($event) {
        return _vm.setLocale('pt')
      }
    }
  }), _vm._v(" "), _c('img', {
    class: [{
      'low-opacity': this.$i18n.locale !== 'en'
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "src": this.$config.imgDir + '/flag-usa-32.png'
    },
    on: {
      "click": function($event) {
        return _vm.setLocale('en')
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "m-header__logo"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "text-center m-info__title"
  }, [_c('img', {
    attrs: {
      "src": _vm.$config.logo
    }
  })])])])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-inverse m-navbar"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse collapse m-navbar__collapse",
    attrs: {
      "id": "navbar"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Homepage'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('span', [_vm._v(_vm._s(_vm.$t("navbar.home")))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ParksPage'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('span', [_vm._v(_vm._s(_vm.$t("navbar.parks")))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'CompaniesPage'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('span', [_vm._v(_vm._s(_vm.$t("navbar.companies")))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'AboutPage'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('span', [_vm._v(_vm._s(_vm.$t("navbar.about")))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ContactPage'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('span', [_vm._v(_vm._s(_vm.$t("navbar.contact")))])])])], 1), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('button', {
    staticClass: "btn navbar-btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("navbar.login")))])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar",
      "aria-expanded": "false",
      "aria-controls": "navbar"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])])
}]}

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-wrench font-dark"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Manutenção do Sistema")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "maintenance-section"
  }, [_c('h4', [_vm._v("Consistência de estágios dos parques")]), _vm._v(" "), _c('p', {
    staticClass: "help-text"
  }, [_vm._v("\n          Compara o estágio cadastrado do parque com o estágio calculado a partir das\n          datas das Informações Gerais. A sincronização atualiza o cadastro com base nessas datas.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "btn-row"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.parkStagesLoading
    },
    on: {
      "click": _vm.runAudit
    }
  }, [_vm._v("\n            Auditar (somente leitura)  \n            "), (_vm.parkStagesLoading && _vm.parkStagesAction === 'audit') ? _c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "disabled": _vm.parkStagesLoading
    },
    on: {
      "click": _vm.runSync
    }
  }, [_vm._v("\n            Sincronizar estágios  \n            "), (_vm.parkStagesLoading && _vm.parkStagesAction === 'sync') ? _c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }) : _vm._e()])]), _vm._v(" "), (_vm.parkStagesError) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.parkStagesError))]) : _vm._e(), _vm._v(" "), (_vm.parkStagesResult) ? _c('div', {
    staticClass: "result-box"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.parkStagesResult.fixApplied ? 'Sincronização executada.' : 'Auditoria executada.'))]), _vm._v("\n            Total de inconsistências: "), _c('strong', [_vm._v(_vm._s(_vm.parkStagesResult.total))]), _vm._v(" "), (_vm.parkStagesResult.fixApplied) ? _c('span', [_vm._v(" — Corrigidas: "), _c('strong', [_vm._v(_vm._s(_vm.parkStagesResult.fixed))])]) : _vm._e()]), _vm._v(" "), (_vm.parkStagesResult.inconsistencies.length) ? _c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Parque")]), _vm._v(" "), _c('th', [_vm._v("Problemas")]), _vm._v(" "), (_vm.parkStagesResult.fixApplied) ? _c('th', [_vm._v("Corrigido")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.parkStagesResult.inconsistencies), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_c('ul', {
      staticClass: "issues-list"
    }, _vm._l((item.issues), function(issue, index) {
      return _c('li', {
        key: index
      }, [_vm._v(_vm._s(issue))])
    }), 0)]), _vm._v(" "), (_vm.parkStagesResult.fixApplied) ? _c('td', [_c('span', {
      class: item.fixed ? 'label label-success' : 'label label-default'
    }, [_vm._v("\n                    " + _vm._s(item.fixed ? 'Sim' : 'Não') + "\n                  ")])]) : _vm._e()])
  }), 0)]) : _c('p', {
    staticClass: "text-success"
  }, [_vm._v("Nenhuma inconsistência encontrada.")])]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "maintenance-section"
  }, [_c('h4', [_vm._v("Natureza jurídica da entidade gestora")]), _vm._v(" "), _c('p', {
    staticClass: "help-text"
  }, [_vm._v("\n          Atualiza as opções dos campos de natureza jurídica (administrativa e financeira)\n          no banco de dados, incluindo a opção "), _c('strong', [_vm._v("Empresa Pública")]), _vm._v(".\n          Equivalente ao comando "), _c('code', [_vm._v("inovadata:update-management-entity-legal-nature-options")]), _vm._v(".\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "btn-row"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "disabled": _vm.legalNatureLoading
    },
    on: {
      "click": _vm.runLegalNatureUpdate
    }
  }, [_vm._v("\n            Atualizar opções no banco  \n            "), (_vm.legalNatureLoading) ? _c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }) : _vm._e()])]), _vm._v(" "), (_vm.legalNatureError) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.legalNatureError))]) : _vm._e(), _vm._v(" "), (_vm.legalNatureResult) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n          " + _vm._s(_vm.legalNatureResult.message) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "maintenance-section"
  }, [_c('h4', [_vm._v("Áreas de terreno e edificações (por parque)")]), _vm._v(" "), _c('p', {
    staticClass: "help-text"
  }, [_vm._v("\n          Recria as respostas de áreas de terreno e edificações no questionário do parque\n          a partir das Informações Gerais, quando estiverem inconsistentes.\n          Equivalente ao comando "), _c('code', [_vm._v("inovadata:fix-park-land-areas {parkId}")]), _vm._v(".\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-inline btn-row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "parkIdInput"
    }
  }, [_vm._v("ID do parque")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.parkId),
      expression: "parkId",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control park-id-input",
    attrs: {
      "id": "parkIdInput",
      "type": "number",
      "min": "1",
      "placeholder": "Ex.: 73"
    },
    domProps: {
      "value": (_vm.parkId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.parkId = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "disabled": _vm.landAreasLoading || !_vm.parkId
    },
    on: {
      "click": _vm.runLandAreasFix
    }
  }, [_vm._v("\n            Corrigir áreas do parque  \n            "), (_vm.landAreasLoading) ? _c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }) : _vm._e()])]), _vm._v(" "), (_vm.landAreasError) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.landAreasError))]) : _vm._e(), _vm._v(" "), (_vm.landAreasResult) ? _c('div', {
    class: _vm.landAreasResult.status === 'ok' ? 'alert alert-success' : 'alert alert-warning'
  }, [_vm._v("\n          " + _vm._s(_vm.landAreasResult.message) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "maintenance-section"
  }, [_c('h4', [_vm._v("Outliers financeiros (correção de respostas)")]), _vm._v(" "), _c('p', {
    staticClass: "help-text"
  }, [_vm._v("\n          Compara e corrige valores monetários do Park Quiz com base na planilha de ajustes\n          empacotada na API. Isso "), _c('strong', [_vm._v("atualiza o banco")]), _vm._v(" ("), _c('code', [_vm._v("abstract_field_answer")]), _vm._v(").\n          Não altera o "), _c('code', [_vm._v("KnownFinancialOutlierRegistry")]), _vm._v(", que apenas exclui outliers\n          conhecidos (Biopark, BIOTIC, Órion) no relatório estatístico.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox btn-row"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.financialIncludeUnanswered),
      expression: "financialIncludeUnanswered"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.financialIncludeUnanswered) ? _vm._i(_vm.financialIncludeUnanswered, null) > -1 : (_vm.financialIncludeUnanswered)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.financialIncludeUnanswered,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.financialIncludeUnanswered = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.financialIncludeUnanswered = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.financialIncludeUnanswered = $$c
        }
      }
    }
  }), _vm._v("\n            Incluir quizzes "), _c('code', [_vm._v("unanswered")]), _vm._v(" (ex.: Itaipu 2020)\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "btn-row"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.financialLoading
    },
    on: {
      "click": _vm.runFinancialAudit
    }
  }, [_vm._v("\n            Auditar (somente leitura)  \n            "), (_vm.financialLoading && _vm.financialAction === 'audit') ? _c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "disabled": _vm.financialLoading
    },
    on: {
      "click": _vm.runFinancialFix
    }
  }, [_vm._v("\n            Corrigir outliers  \n            "), (_vm.financialLoading && _vm.financialAction === 'fix') ? _c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }) : _vm._e()])]), _vm._v(" "), (_vm.financialError) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.financialError))]) : _vm._e(), _vm._v(" "), (_vm.financialResult) ? _c('div', {
    staticClass: "result-box"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.financialResult.fixApplied ? 'Correção executada.' : 'Auditoria executada.'))]), _vm._v("\n            Total: "), _c('strong', [_vm._v(_vm._s(_vm.financialResult.total))]), _vm._v(" "), (!_vm.financialResult.fixApplied) ? _c('span', [_vm._v("\n              — A atualizar: "), _c('strong', [_vm._v(_vm._s(_vm.financialResult.wouldUpdate))])]) : _c('span', [_vm._v("\n              — Atualizados: "), _c('strong', [_vm._v(_vm._s(_vm.financialResult.updated))])]), _vm._v("\n            — Sem alteração: "), _c('strong', [_vm._v(_vm._s(_vm.financialResult.unchanged))]), _vm._v("\n            — Não encontrados: "), _c('strong', [_vm._v(_vm._s(_vm.financialResult.answerNotFound))]), _vm._v(" "), (_vm.financialResult.parkNotFound) ? _c('span', [_vm._v("\n              — Parque não encontrado: "), _c('strong', [_vm._v(_vm._s(_vm.financialResult.parkNotFound))])]) : _vm._e(), _vm._v(" "), (_vm.financialResult.ambiguous) ? _c('span', [_vm._v("\n              — Ambíguos: "), _c('strong', [_vm._v(_vm._s(_vm.financialResult.ambiguous))])]) : _vm._e()]), _vm._v(" "), (_vm.financialVisibleRows.length) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-condensed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Parque")]), _vm._v(" "), _c('th', [_vm._v("Ano")]), _vm._v(" "), _c('th', [_vm._v("Campo")]), _vm._v(" "), _c('th', [_vm._v("Atual")]), _vm._v(" "), _c('th', [_vm._v("Esperado")]), _vm._v(" "), _c('th', [_vm._v("Delta")]), _vm._v(" "), _c('th', [_vm._v("Quiz")]), _vm._v(" "), _c('th', [_vm._v("Detalhe")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.financialVisibleRows), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('span', {
      staticClass: "label",
      class: _vm.financialStatusClass(row.status)
    }, [_vm._v(_vm._s(row.status))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.parkLabel || row.parkNameContains))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.year))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.fieldLabel))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatMoney(row.currentValue)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatMoney(row.expectedValue)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatMoney(row.delta)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.quizStatus || '—'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.detail))])])
  }), 0)]), _vm._v(" "), (_vm.financialHiddenUnchanged > 0) ? _c('p', {
    staticClass: "help-text"
  }, [_vm._v("\n              " + _vm._s(_vm.financialHiddenUnchanged) + " linha(s) "), _c('code', [_vm._v("unchanged")]), _vm._v("/"), _c('code', [_vm._v("skipped_pending")]), _vm._v(" ocultas.\n            ")]) : _vm._e()]) : _c('p', {
    staticClass: "text-success"
  }, [_vm._v("Nenhuma linha com delta ou problema a reportar.")])]) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indicator-result box box-default"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h4', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.indicator.title))]), _vm._v(" "), (_vm.showFinancialToggle) ? _c('div', {
    staticClass: "box-tools pull-right financial-view-toggle"
  }, [_c('label', {
    staticClass: "sr-only"
  }, [_vm._v("Visualização financeira")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.financialView),
      expression: "financialView"
    }],
    staticClass: "form-control input-sm",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.financialView = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "nominal"
    }
  }, [_vm._v("Nominal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "deflated"
    }
  }, [_vm._v("Deflacionado (IPCA)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "withoutKnownParkOutliers"
    }
  }, [_vm._v("Sem outliers conhecidos")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.showLineChart && _vm.lineChartData && _vm.chartVisible) ? _c('div', {
    staticClass: "chart-wrapper"
  }, [_c('ReportChartContainer', {
    key: 'line-' + _vm.chartRenderKey + '-' + _vm.financialView,
    attrs: {
      "data": _vm.lineChartData,
      "chart-component": _vm.LineChart
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.snapshotChartData && _vm.chartVisible) ? _c('div', {
    staticClass: "chart-wrapper snapshot-chart"
  }, [_c('ReportChartContainer', {
    key: 'snapshot-' + _vm.chartRenderKey,
    attrs: {
      "data": _vm.snapshotChartData,
      "chart-component": _vm.snapshotChartComponent
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.distributionChartData && _vm.chartVisible) ? _c('div', {
    staticClass: "chart-wrapper distribution-chart"
  }, [_c('ReportChartContainer', {
    key: 'distribution-' + _vm.chartRenderKey + '-' + _vm.financialView,
    attrs: {
      "data": _vm.distributionChartData,
      "chart-component": _vm.distributionChartComponent
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.indicator.type === 'table' || _vm.indicator.type === 'ranking') && _vm.tableData) ? _c('div', {
    staticClass: "table-wrapper"
  }, [_c('TableReport', {
    attrs: {
      "data": _vm.tableData
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.nestedTables), function(nestedTable, index) {
    return _c('div', {
      key: 'nested-' + index,
      staticClass: "table-wrapper nested-table"
    }, [_c('TableReport', {
      attrs: {
        "data": nestedTable
      }
    })], 1)
  }), _vm._v(" "), (_vm.indicator.type === 'series' && _vm.seriesDetailTable) ? _c('div', {
    staticClass: "table-wrapper table-scroll"
  }, [_c('TableReport', {
    attrs: {
      "data": _vm.seriesDetailTable
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.comparisonTable) ? _c('div', {
    staticClass: "table-wrapper table-scroll"
  }, [_c('TableReport', {
    attrs: {
      "data": _vm.comparisonTable
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.comparisonNestedTables), function(comparisonNestedTable, index) {
    return _c('div', {
      key: 'comparison-' + index,
      staticClass: "table-wrapper table-scroll nested-table"
    }, [_c('TableReport', {
      attrs: {
        "data": comparisonNestedTable
      }
    })], 1)
  }), _vm._v(" "), (_vm.concentrationText) ? _c('p', {
    staticClass: "concentration-summary text-muted"
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" " + _vm._s(_vm.concentrationText) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.indicator.type === 'kpi') ? _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v("\n      " + _vm._s(_vm.kpiValue) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.adjustmentNote) ? _c('p', {
    staticClass: "text-muted adjustment-note"
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" " + _vm._s(_vm.adjustmentNote) + "\n    ")]) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(this.data.title) ? _c('h4', [_vm._v(_vm._s(this.data.title))]) : _vm._e(), _vm._v(" "), _c('ReportFilterBadge', {
    attrs: {
      "metadata": this.data.metadata
    }
  }), _vm._v(" "), _c('ul', _vm._l((this.data.report), function(item) {
    return _c('li', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.label)
      }
    }), _vm._v(" "), (item.children) ? _c('ListReport', {
      attrs: {
        "data": _vm.formatDataForRecursiveChildComponent(item.children)
      }
    }) : _vm._e()], 1)
  }), 0)], 1)
},staticRenderFns: []}

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.question.statement))]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.disabledAttribute
    },
    domProps: {
      "value": _vm.getBooleanAnswerValue()
    },
    on: {
      "change": _vm.onBooleanAnswerChange
    }
  }, [_c('option', {
    domProps: {
      "value": 'true'
    }
  }, [_vm._v("Sim")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'false'
    }
  }, [_vm._v("Não")])]), _vm._v(" "), (_vm.m_error) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.m_error))]) : _vm._e(), _vm._v(" "), (_vm.getBooleanAnswerValue()) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-solid box-primary"
  }, [_c('div', {
    staticClass: "box-body"
  }, _vm._l((_vm.question.fieldsWhenTrue), function(field) {
    return _c(_vm.getFieldComponent(field), {
      key: field.uuid,
      ref: "fields",
      refInFor: true,
      tag: "component",
      attrs: {
        "field": field,
        "fieldAnswer": _vm.getFieldAnswer(field),
        "isDisabled": _vm.disabledAttribute
      },
      on: {
        "fieldUpdated": _vm.onFieldUpdated
      }
    })
  }), 1)])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 773 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.someProgramIsOffered) ? _c('CollectionQuestion', {
    key: _vm.childKey,
    ref: "child",
    attrs: {
      "question": _vm.questionWithFilteredProgramOptions,
      "answer": _vm.answer,
      "isDisabled": _vm.isDisabled
    },
    on: {
      "answerUpdated": _vm.onAnswerUpdated
    }
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 774 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('homepage', [_c('div', {
    staticClass: "m-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t('contact.contact_us')))])]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('contact.our_email')) + ":")]), _vm._v(" ntg@ufv.br"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('contact.our_phones')) + ":")]), _vm._v(" (31) 3899 4097 ou (31) 3899 4086"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('contact.our_address')) + ":")]), _c('br'), _vm._v("\n        Universidade Federal de Viçosa (UFV)"), _c('br'), _vm._v("\n        Departamento de Engenharia de Produção e Mecânica (DEP)"), _c('br'), _vm._v("\n        Avenida Prof. Peter Henry Rolfs, s/n – Campus Universitário"), _c('br'), _vm._v("\n        CEP: 36570-900 – Viçosa – MG\n        "), _c('br'), _c('br'), _vm._v(" "), (_vm.formStatus === _vm.FORM_STATUS_SUBMIT_SUCCESS) ? _c('div', {
    staticClass: "alert alert-success text-center",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('contact.form.alerts.success')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.formStatus === _vm.FORM_STATUS_SUBMIT_ERROR) ? _c('div', {
    staticClass: "alert alert-danger text-center",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('contact.form.alerts.error')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    class: [{
      'has-error': _vm.formData.name.error
    }, 'form-group']
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('contact.form.name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.name.value),
      expression: "formData.name.value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "aria-describedby": "helpBlockName"
    },
    domProps: {
      "value": (_vm.formData.name.value)
    },
    on: {
      "change": function($event) {
        return _vm.validateRequiredField('name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.name, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formData.name.error) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlockName"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t(("contact.form.validation." + (_vm.formData.name.error)))) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: [{
      'has-error': _vm.formData.email.error
    }, 'form-group']
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.$t('contact.form.email')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.email.value),
      expression: "formData.email.value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email",
      "aria-describedby": "helpBlockEmail"
    },
    domProps: {
      "value": (_vm.formData.email.value)
    },
    on: {
      "change": function($event) {
        return _vm.validateEmailField('email')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.email, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formData.email.error) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlockEmail"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t(("contact.form.validation." + (_vm.formData.email.error)))) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: [{
      'has-error': _vm.formData.subject.error
    }, 'form-group']
  }, [_c('label', {
    attrs: {
      "for": "subject"
    }
  }, [_vm._v(_vm._s(_vm.$t('contact.form.subject')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.subject.value),
      expression: "formData.subject.value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "subject",
      "aria-describedby": "helpBlockSubject"
    },
    domProps: {
      "value": (_vm.formData.subject.value)
    },
    on: {
      "change": function($event) {
        return _vm.validateRequiredField('subject')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.subject, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formData.subject.error) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlockSubject"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t(("contact.form.validation." + (_vm.formData.subject.error)))) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: [{
      'has-error': _vm.formData.message.error
    }, 'form-group']
  }, [_c('label', {
    attrs: {
      "for": "message"
    }
  }, [_vm._v(_vm._s(_vm.$t('contact.form.message')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.message.value),
      expression: "formData.message.value"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "message",
      "rows": "3",
      "aria-describedby": "helpBlockMessage"
    },
    domProps: {
      "value": (_vm.formData.message.value)
    },
    on: {
      "change": function($event) {
        return _vm.validateRequiredField('message')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.message, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formData.message.error) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlockMessage"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t(("contact.form.validation." + (_vm.formData.message.error)))) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('vue-recaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": _vm.recaptcha_site_key
    },
    on: {
      "verify": _vm.onCaptchaVerified,
      "expired": _vm.onCaptchaExpired
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "submit",
      "disabled": _vm.formStatus === _vm.FORM_STATUS_SUBMITTING
    }
  }, [_vm._v(_vm._s(_vm.$t('contact.form.submit')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('gmap-map', {
    staticClass: "map",
    attrs: {
      "center": {
        lat: -20.760829,
        lng: -42.866235
      },
      "zoom": 14
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": {
        lat: -20.760829,
        lng: -42.865235
      },
      "clickable": false,
      "draggable": false
    }
  })], 1)], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-sm btn-info center-block pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goBack()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v("  Voltar\n")])
},staticRenderFns: []}

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_vm._v("\n  Welcome Researcher!\n")])
},staticRenderFns: []}

/***/ }),
/* 777 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "evolution-report"
  }, [(_vm.title) ? _c('h4', {
    staticClass: "report-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('ReportFilterBadge', {
    attrs: {
      "metadata": _vm.metadata
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "years-grid",
    style: (_vm.gridStyle)
  }, _vm._l((_vm.entries), function(entry) {
    return _c('div', {
      key: entry.year,
      staticClass: "year-block"
    }, [_c('h5', {
      staticClass: "year-title"
    }, [_vm._v(_vm._s(entry.year))]), _vm._v(" "), _c('div', {
      staticClass: "year-body"
    }, [_c(_vm.reportComponent, {
      tag: "component",
      attrs: {
        "data": _vm.entryData(entry)
      }
    })], 1)])
  }), 0)], 1)
},staticRenderFns: []}

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Cms', {
    attrs: {
      "pageTitle": 'Conteúdo da Página de Empresas',
      "pageName": 'companies'
    }
  })
},staticRenderFns: []}

/***/ }),
/* 779 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'form-group': true,
      'has-error': this.m_error !== null
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.field.label))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.m_fieldAnswer.value),
      expression: "m_fieldAnswer.value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Preencha o campo",
      "disabled": _vm.disabledAttribute
    },
    domProps: {
      "value": (_vm.m_fieldAnswer.value)
    },
    on: {
      "keypress": function($event) {
        return _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.m_fieldAnswer, "value", $event.target.value)
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(this.data.title) ? _c('h4', [_vm._v(_vm._s(this.data.title))]) : _vm._e(), _vm._v(" "), _c('ReportFilterBadge', {
    attrs: {
      "metadata": this.data.metadata
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_c('tbody', [_c('tr', _vm._l((this.headers), function(header, index) {
    return _c('th', {
      key: index
    }, [_vm._v(_vm._s(header))])
  }), 0), _vm._v(" "), _vm._l((this.rowsByGroup), function(rows, group) {
    return _vm._l((rows), function(row, rowIndex) {
      return _c('tr', {
        key: group + '-' + rowIndex
      }, [(rowIndex === 0 && group !== '__ungrouped__') ? _c('td', {
        attrs: {
          "rowspan": rows.length
        }
      }, [_vm._v(_vm._s(group))]) : _vm._e(), _vm._v(" "), _vm._l((row), function(cell, cellIndex) {
        return _c('td', {
          key: cellIndex
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatterByDataType[cell.dataType](cell.value))
          }
        })])
      })], 2)
    })
  }), _vm._v(" "), (Object.keys(this.rowsByGroup).length === 0) ? [_c('tr', [_c('td', {
    attrs: {
      "colspan": this.headers.length
    }
  }, [_vm._v("Não há informações para este relatório no ano selecionado.")])])] : _vm._e()], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 781 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Adicionar Parque Tecnológico")])]), _vm._v(" "), _c('ParkForm', {
    attrs: {
      "park": _vm.park,
      "errors": _vm.errors,
      "onSubmit": _vm.onSubmit
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 782 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.parkOffersIncubation) ? _c('ItemsQuestion', {
    ref: "child",
    attrs: {
      "question": _vm.question,
      "answer": _vm.answer,
      "isDisabled": _vm.isDisabled
    },
    on: {
      "answerUpdated": _vm.onAnswerUpdated
    }
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 783 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "m-footer"
  }, [_c('div', {
    staticClass: "m-footer__sponsors"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-4 text-center"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('portal.contributors')) + "\n          "), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "m-footer__sponsor",
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "src": _vm.$config.imgDir + '/logo-mctic.png',
      "alt": "Ministério da Ciência, Tecnologia, Inovações e Comunicações"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-4 text-center"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('portal.project')) + "\n          "), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "m-footer__sponsor",
    attrs: {
      "src": _vm.$config.imgDir + '/Logo-NTG.png',
      "alt": "Núcleo de Tecnologias de Gestão – NTG"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "m-footer__sponsor",
    attrs: {
      "src": _vm.$config.imgDir + '/logo-com-inscricao.png',
      "alt": "Universidade Federal de Viçosa - UFV"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-4 text-center"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('portal.development')) + "\n          "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "vertical-align": "middle",
      "display": "inline-block",
      "float": "none"
    }
  }, [_c('img', {
    staticClass: "m-footer__sponsor",
    staticStyle: {
      "height": "22px"
    },
    attrs: {
      "src": _vm.$config.imgDir + '/jungle.png',
      "alt": "Jungle"
    }
  })])])])])])])
},staticRenderFns: []}

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Cms', {
    attrs: {
      "pageTitle": 'Conteúdo da Página Institucional',
      "pageName": 'about'
    }
  })
},staticRenderFns: []}

/***/ })
],[363]);


// WEBPACK FOOTER //
// static/js/app.b29d6b2ec66ac6ec5b9c.js